var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types/ids.ts
function asId(raw) {
  return raw;
}

// src/types/enums.ts
var DeviceKinds = ["server", "router", "switch", "firewall", "loadbalancer", "ups"];
var DeviceStates = [
  "offline",
  // bewusst ausgeschaltet
  "booting",
  // fährt hoch (n Ticks)
  "online",
  // regulärer Betrieb
  "degraded",
  // läuft, aber mit Fehlern (Überhitzung, Paketverlust)
  "failed",
  // Defekt, benötigt Reparatur
  "maintenance"
  // Wartungsfenster, kein Kundentraffic
];
var OperatingSystems = ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"];
var ServerRoles = ["shared-hosting", "vps-host", "dedicated", "storage", "mail", "dns", "backup", "gpu-host", "unassigned"];
var MigrationPhases = [
  "queued",
  // wartet auf eine freie Übertragungsspur
  "disk",
  // Plattendaten werden kopiert
  "memory",
  // Arbeitsspeicher wird im laufenden Betrieb nachgezogen
  "cutover",
  // Umschaltung; die letzte Differenz geht mit angehaltener Instanz
  "done",
  "failed"
];
var BalanceAlgorithms = ["round-robin", "least-connections", "source-hash"];
var LinkKinds = [
  "fiber-owned",
  // selbst gebaute Glasfaser
  "fiber-leased",
  // gemietete Dark Fiber / Wellenlänge
  "transit",
  // gekaufter IP-Transit
  "peering-private",
  // PNI
  "peering-ix",
  // Peering über einen IXP
  "internal"
  // Rack-/DC-interne Verkabelung
];
var LinkStates = ["up", "down", "degraded", "planned"];
var PeerRelations = ["customer", "peer", "transit", "ibgp"];
var BgpSessionStates = ["idle", "connect", "active", "opensent", "openconfirm", "established"];
var BgpOrigins = ["igp", "egp", "incomplete"];
var AddressFamilies = ["ipv4", "ipv6"];
var ProductKinds = [
  "shared-hosting",
  "vps",
  "dedicated",
  "colocation",
  "storage",
  "domain",
  "ssl",
  "backup",
  "mail",
  "transit-sale",
  "game-server",
  "container",
  "gpu-compute"
];
var CustomerSegments = ["private", "smb", "enterprise", "reseller"];
var ContractStates = ["active", "suspended", "cancelled", "pending"];
var InvoiceStates = ["draft", "open", "paid", "overdue", "cancelled"];
var TicketStates = ["open", "in-progress", "waiting-customer", "resolved", "closed"];
var TicketPriorities = ["low", "normal", "high", "urgent"];
var TicketCategories = ["technical", "billing", "abuse", "sales", "outage"];
var Severities = ["info", "warning", "error", "critical"];
var LogCategories = [
  "system",
  "network",
  "bgp",
  "billing",
  "customer",
  "hardware",
  "security",
  "event",
  "research",
  "ai"
];
var StaffRoles = ["technician", "network-engineer", "support", "sales", "security"];
var Difficulties = ["easy", "normal", "hard"];
var UserRoles = ["admin", "technician", "support", "customer"];

// src/constants.ts
var SIM = {
  /** Ein Tick entspricht einer Spielstunde. */
  MINUTES_PER_TICK: 60,
  TICKS_PER_DAY: 24,
  TICKS_PER_MONTH: 24 * 30,
  TICKS_PER_YEAR: 24 * 360,
  /** Startzeitpunkt der Spielwelt. */
  EPOCH: "2025-01-01T00:00:00.000Z",
  /** Voreingestellte Ticks pro realer Sekunde. */
  DEFAULT_SPEED: 1,
  MAX_SPEED: 32,
  /** Länge der Monitoring-Ringpuffer. */
  METRIC_WINDOW: 240,
  /** Größe des Fensters für die 95.-Perzentil-Abrechnung (Ticks). */
  BILLING_WINDOW: 24 * 30,
  /** Maximale Anzahl behaltener Log-Einträge im Weltzustand. */
  MAX_LOGS: 2e3,
  /** Muss mindestens einen vollen Abrechnungsmonat abdecken, sonst fehlen der
   *  Monatsauswertung Buchungen. */
  MAX_LEDGER_ENTRIES: 2e4,
  /** Boot-/Reparaturzeiten in Ticks. */
  BOOT_TICKS: 1,
  REPAIR_TICKS_BASE: 4,
  OS_INSTALL_TICKS: 2,
  /** Zahlungsziel für Rechnungen. */
  INVOICE_DUE_TICKS: 24 * 14,
  /** Schwellenwerte für Warnungen. */
  LINK_CONGESTION_WARN: 0.75,
  LINK_CONGESTION_CRITICAL: 0.92,
  TEMP_WARN_C: 45,
  TEMP_CRITICAL_C: 65,
  DISK_WARN: 0.85
};
var UPGRADE = {
  /** Grundzeit eines Wartungsfensters: ausbauen, öffnen, prüfen, schließen, hochfahren. */
  MAINTENANCE_BASE_TICKS: 1,
  /** Ohne Techniker vor Ort dauert alles deutlich länger (externer Dienstleister). */
  NO_TECHNICIAN_FACTOR: 3,
  /** Aufschlag auf den Listenpreis bei Expresslieferung. */
  EXPRESS_SURCHARGE: 0.45,
  /** Um welchen Faktor sich die Lieferzeit bei Express verkürzt. */
  EXPRESS_SPEEDUP: 4,
  /** Restwert beim Verkauf gebrauchter Bauteile, als Anteil des Listenpreises. */
  PART_RESALE_SHARE: 0.55,
  /** Zufriedenheitsverlust je Kunde, dessen Dienst für ein Wartungsfenster abgeschaltet wurde. */
  MAINTENANCE_SATISFACTION_COST: 3
};
var MIGRATION = {
  /**
   * Anteil der Anbindung, den Migrationsverkehr belegen darf.
   *
   * Der Rest bleibt für Kunden reserviert. Wer den Wert in Gedanken auf 1
   * setzt, hat einen Umzug gebaut, der die Kunden vom Netz drängt – das macht
   * im Betrieb niemand zweimal.
   */
  LINK_SHARE: 0.5,
  /** Anbindung eines Servers ohne erkennbaren Uplink, in Mbit/s. */
  FALLBACK_MBPS: 1e3,
  /**
   * Wie viel Arbeitsspeicher eine voll ausgelastete Instanz je Stunde neu
   * beschreibt, als Vielfaches ihrer Größe.
   *
   * Das ist die Größe, gegen die eine Live-Migration anrennt: Was übertragen
   * ist und danach wieder beschrieben wird, muss noch einmal hinüber. Bei
   * fetter Leitung fällt es nicht auf; bei dünner konvergiert es nie.
   */
  DIRTY_RATE_PER_HOUR: 6,
  /**
   * Restmenge, ab der umgeschaltet wird, als Anteil dessen, was in einem Tick
   * über die Leitung geht. 2 % einer Stunde sind gut 70 Sekunden – so kurz,
   * dass es als "unterbrechungsfrei" durchgeht.
   */
  SWITCHOVER_SHARE: 0.02,
  /**
   * Nach so vielen erfolglosen Speicherdurchgängen wird das Umschalten
   * erzwungen. Ohne diese Grenze liefe eine schreibfreudige Instanz auf einer
   * dünnen Leitung bis zum Ende der Partie in der Migration.
   */
  MAX_PASSES: 6,
  /** Gleichzeitige Übertragungen je Server; der Rest wartet in der Schlange. */
  MAX_CONCURRENT_PER_SERVER: 4,
  /** Zufriedenheitsverlust bei einer erzwungenen, spürbaren Umschaltpause. */
  FORCED_SWITCHOVER_SATISFACTION: 4,
  /** So lange bleibt ein abgeschlossener Auftrag in der Übersicht stehen. */
  KEEP_FINISHED_TICKS: 48
};
var LOADBALANCING = {
  /** Verbindungen je Mbit/s Verkehr – grobe Umrechnung für die Kapazitätsprüfung. */
  CONNECTIONS_PER_MBPS: 45,
  /** TLS-Handshakes je Sekunde und Mbit/s, wenn der Balancer TLS beendet. */
  HANDSHAKES_PER_MBPS: 1.2,
  /** Ab dieser Auslastung staut sich der Balancer merklich. */
  CONGESTION_THRESHOLD: 0.85,
  /**
   * Wahrscheinlichkeit je Tick und Pool, dass eine fehlende Sitzungsbindung zu
   * einer Beschwerde führt. Der abgemeldete Kunde ist kein Sonderfall, sondern
   * das erwartbare Ergebnis – nur nicht bei jedem Klick.
   */
  SESSION_LOSS_TICKET_CHANCE: 0.06
};
var COLOCATION = {
  /** Wählbare Mindestlaufzeiten in Monaten; 0 bedeutet monatlich kündbar. */
  TERMS: [0, 12, 24, 36, 60],
  /** Preisnachlass je Jahr Bindung. */
  DISCOUNT_PER_TERM_YEAR: 0.035,
  /** Aufschlag für einen Vertrag ohne Bindung – Flexibilität kostet. */
  MONTHLY_SURCHARGE: 0.12,
  /** Höchstens so viele Monate lassen sich vorauszahlen. */
  MAX_PREPAID_MONTHS: 12,
  /** Nachlass je vorausbezahltem Monat. */
  DISCOUNT_PER_PREPAID_MONTH: 6e-3,
  /**
   * Nachlass für Menge, je zugesagtem Kilowatt über der Grundzusage.
   *
   * Deckelt bei `MAX_VOLUME_DISCOUNT`: Auch der größte Kunde bekommt den
   * Standort nicht geschenkt.
   */
  DISCOUNT_PER_KW_OVER_BASE: 18e-4,
  MAX_VOLUME_DISCOUNT: 0.12,
  /** Untergrenze jedes Angebots als Anteil des Listenpreises. */
  PRICE_FLOOR_SHARE: 0.62,
  /** So viele Nachverhandlungen lässt ein Anbieter zu. */
  MAX_ROUNDS: 3,
  /** Anteil der Lücke zur Forderung, den ein Anbieter je Runde nachgibt. */
  CONCESSION_SHARE: 0.45,
  /** Ein Angebot verfällt nach dieser Zeit (Ticks). */
  OFFER_VALID_TICKS: 24 * 7,
  /**
   * Nach einem geplatzten Gespräch bleibt der Standort so lange gesperrt.
   *
   * Ohne diese Sperre wäre eine Absage folgenlos – man klickt neu und würfelt
   * wieder. Vier Tage sind kurz genug, dass niemand die Partie deswegen
   * unterbricht, und lang genug, dass zu hartes Verhandeln wehtut.
   */
  COOLDOWN_TICKS: 24 * 4,
  /** Kündigungsfrist in Monaten, nach Laufzeitstufe. */
  NOTICE_MONTHS: { none: 1, short: 2, long: 3 },
  /** Anteil der Restmiete, der beim vorzeitigen Ausstieg fällig wird, je Laufzeit. */
  EXIT_PENALTY_SHARE: { none: 0, short: 0.35, long: 0.5 },
  /**
   * Anteil des Zeitwerts, den zurückgelassene Hardware bei der Zwangsräumung
   * noch einbringt.
   *
   * Der Standort räumt selbst, verlangt dafür Geld und verwertet den Rest.
   * Deutlich weniger als ein geordneter Verkauf – genau das ist der Anreiz,
   * rechtzeitig umzuziehen.
   */
  EVICTION_SALVAGE_SHARE: 0.25,
  /** Pauschale der Räumung je zurückgelassenem Gerät. */
  EVICTION_FEE_PER_DEVICE: 180,
  /** Rufschaden, wenn Kundendienste in einer Räumung untergehen. */
  EVICTION_REPUTATION_COST: 12
};
var DELIVERY = {
  /** Einbauen eines gelieferten Geräts in ein Rack: Einbau, Verkabelung, Hochfahren. */
  INSTALL_TICKS: 3
};
var RELOCATION = {
  /** Grundpauschale je Transport (Anfahrt, Papierkram). */
  BASE_FEE: 240,
  /** Speditionskosten je Kilometer und Höheneinheit. */
  PER_KM_PER_UNIT: 0.28,
  /** Zuschlag je Höheneinheit für Verpackung und Handling an beiden Enden. */
  HANDLING_PER_UNIT: 45,
  /** Ausbauen und verpacken. */
  PACK_TICKS: 2,
  /** Reisegeschwindigkeit der Spedition in km je Tick (Stunde). */
  KM_PER_TICK: 70,
  /** Einbauen, verkabeln, hochfahren. */
  INSTALL_TICKS: 3,
  /** Grundrisiko eines Transportschadens. */
  DAMAGE_RISK_BASE: 0.02,
  /** Zusätzliches Risiko je 1000 km. */
  DAMAGE_RISK_PER_1000KM: 0.015,
  /** Zustandsverlust, den jeder Transport kostet – Rütteln schadet. */
  HEALTH_LOSS: 0.03,
  /**
   * Zustandsverlust eines Umbaus im selben Standort.
   *
   * Deutlich weniger als eine Fahrt, aber nicht null: Auch zwei Racks weiter
   * wird ausgebaut, getragen und wieder verschraubt. Wer ein Gerät ständig
   * umsetzt, merkt es irgendwann am Zustand.
   */
  MOVE_HEALTH_LOSS: 5e-3,
  /** Zustandsverlust bei einem Transportschaden. */
  DAMAGE_HEALTH_LOSS: 0.45,
  /** So lange bleibt ein abgeschlossener Transport in der Übersicht stehen. */
  KEEP_FINISHED_TICKS: 48
};
var PHYSICS = {
  /** Wärmeabgabe: 1 W elektrische Leistung ≈ 1 W Wärme. */
  WATT_TO_HEAT: 1,
  /** Wieviel °C ein Gerät pro kW Wärmeüberschuss im Rack ansteigt. */
  TEMP_RISE_PER_KW_OVER: 6,
  /** Abkühlungsrate pro Tick in Richtung Zieltemperatur. */
  TEMP_SMOOTHING: 0.35,
  /** Grundtemperatur eines gekühlten Racks. */
  BASE_RACK_TEMP_C: 22,
  /** Zusätzlicher Gesundheitsverlust pro Tick oberhalb der kritischen Temperatur. */
  HEALTH_LOSS_PER_TICK_HOT: 4e-3,
  /** Normale Alterung pro Tick. */
  HEALTH_LOSS_PER_TICK: 4e-5,
  /** Lichtgeschwindigkeit in Glasfaser: ~200.000 km/s -> 5 µs pro km, plus Aufschlag. */
  MS_PER_KM_FIBER: 5e-3,
  /** Latenzaufschlag je Router-Hop in ms. */
  MS_PER_HOP: 0.15
};
var ECONOMY = {
  /** Mehrwertsteuersatz. */
  TAX_PERCENT: 19,
  /** Zinssatz p. a. auf Schulden. */
  DEBT_INTEREST_RATE: 0.09,
  /** Jährlicher RIR-Mitgliedsbeitrag. */
  RIR_MEMBERSHIP_YEARLY: 1400,
  /** Einmalige Gebühr für eine eigene ASN. */
  ASN_SETUP_FEE: 500,
  /** Monatliche Kosten je IPv4-/24 (Knappheitsprämie). */
  IPV4_24_MONTHLY: 90,
  /** Kaufpreis je IPv4-Adresse auf dem Transfermarkt. */
  IPV4_ADDRESS_PRICE: 42,
  /**
   * Anteil des Kaufpreises, den ein Verkauf einbringt. Die Differenz ist die
   * Maklermarge – knapp genug, dass Adressen als Wertanlage taugen, aber teuer
   * genug, dass ständiges Hin und Her sich nicht lohnt.
   */
  IPV4_TRANSFER_SHARE: 0.88,
  /** Monatliche Kosten für ein IPv6-/32. */
  IPV6_32_MONTHLY: 15,
  /** Vertragsstrafe je Prozentpunkt SLA-Unterschreitung, als Anteil der Monatsgebühr. */
  SLA_PENALTY_PER_POINT: 0.1,
  /** Obergrenze der Gutschrift als Anteil der Monatsgebühr – wie in echten SLAs. */
  SLA_MAX_CREDIT_SHARE: 0.3,
  /** Traffic-Überverbrauch je GB. */
  OVERAGE_PER_GB: 0.08,
  /** Gehaltsbandbreiten je Skill-Punkt (Arbeitgeberbrutto). */
  SALARY_PER_SKILL: 300,
  SALARY_BASE: 1500
};
var COMMUNITIES = {
  BLACKHOLE: "65535:666",
  NO_EXPORT: "65535:65281",
  NO_ADVERTISE: "65535:65282",
  /** Herstellerneutrale Steuer-Communities des eigenen Netzes. */
  PREPEND_1: "{asn}:1001",
  PREPEND_2: "{asn}:1002",
  PREPEND_3: "{asn}:1003",
  NO_EXPORT_PEERS: "{asn}:2000",
  NO_EXPORT_TRANSIT: "{asn}:2001"
};
var ADMIN_DISTANCE = {
  CONNECTED: 0,
  STATIC: 1,
  OSPF: 110,
  EBGP: 20,
  IBGP: 200
};
var DIFFICULTY = {
  easy: {
    startingCash: 15e4,
    costMultiplier: 0.85,
    demandMultiplier: 1.35,
    eventFrequency: 0.6,
    creditLimit: 1e5,
    satisfactionDecay: 0.6
  },
  normal: {
    startingCash: 8e4,
    costMultiplier: 1,
    demandMultiplier: 1,
    eventFrequency: 1,
    creditLimit: 5e4,
    satisfactionDecay: 1
  },
  hard: {
    startingCash: 45e3,
    costMultiplier: 1.2,
    demandMultiplier: 0.75,
    eventFrequency: 1.5,
    creditLimit: 15e3,
    satisfactionDecay: 1.4
  }
};
var WORLD_VERSION = 16;

// src/utils/rng.ts
var Rng = class {
  state;
  constructor(seed) {
    this.state = seed >>> 0 || 2654435769;
  }
  /** Aktueller Zustand – zum Persistieren im Weltzustand. */
  getState() {
    return this.state >>> 0;
  }
  setState(state) {
    this.state = state >>> 0 || 2654435769;
  }
  /** Gleichverteilt in [0, 1). */
  next() {
    this.state = this.state + 1831565813 >>> 0;
    let t = this.state;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  }
  /** Gleichverteilt in [min, max). */
  float(min, max) {
    return min + this.next() * (max - min);
  }
  /** Ganzzahl in [min, max] (beide inklusive). */
  int(min, max) {
    return Math.floor(this.float(min, max + 1));
  }
  /** Trifft mit Wahrscheinlichkeit p (0..1) zu. */
  chance(p) {
    return this.next() < p;
  }
  /** Zufälliges Element; wirft bei leerem Array nicht, sondern liefert undefined. */
  pick(items) {
    if (items.length === 0) return void 0;
    return items[this.int(0, items.length - 1)];
  }
  /** Gewichtete Auswahl. Gewichte müssen >= 0 sein. */
  pickWeighted(items, weight) {
    const total = items.reduce((sum3, item2) => sum3 + Math.max(0, weight(item2)), 0);
    if (total <= 0) return void 0;
    let roll = this.next() * total;
    for (const item2 of items) {
      roll -= Math.max(0, weight(item2));
      if (roll <= 0) return item2;
    }
    return items[items.length - 1];
  }
  /** Normalverteilung (Box-Muller), praktisch für Lastschwankungen. */
  normal(mean = 0, stdDev = 1) {
    const u1 = Math.max(this.next(), Number.EPSILON);
    const u2 = this.next();
    return mean + stdDev * Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  }
  /** In-place-Shuffle (Fisher-Yates). */
  shuffle(items) {
    for (let i = items.length - 1; i > 0; i--) {
      const j = this.int(0, i);
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  }
};

// src/utils/ip.ts
var ip_exports = {};
__export(ip_exports, {
  addressCount: () => addressCount,
  addressToBigInt: () => addressToBigInt,
  aggregate: () => aggregate,
  bigIntToAddress: () => bigIntToAddress,
  bigIntToIpv4: () => bigIntToIpv4,
  bigIntToIpv6: () => bigIntToIpv6,
  broadcastAddress: () => broadcastAddress,
  containsAddress: () => containsAddress,
  containsPrefix: () => containsPrefix,
  detectFamily: () => detectFamily,
  formatPrefix: () => formatPrefix,
  gatewayAddress: () => gatewayAddress,
  ipv4ToBigInt: () => ipv4ToBigInt,
  ipv6ToBigInt: () => ipv6ToBigInt,
  isAnnounceable: () => isAnnounceable,
  isPrivate: () => isPrivate,
  longestPrefixMatch: () => longestPrefixMatch,
  nthAddress: () => nthAddress,
  parsePrefix: () => parsePrefix,
  prefixesOverlap: () => prefixesOverlap,
  reversePointerName: () => reversePointerName,
  reverseZoneName: () => reverseZoneName,
  subnets: () => subnets,
  toCidr: () => toCidr,
  usableHosts: () => usableHosts
});
var V4_BITS = 32;
var V6_BITS = 128;
function detectFamily(address) {
  return address.includes(":") ? "ipv6" : "ipv4";
}
function ipv4ToBigInt(address) {
  const parts = address.trim().split(".");
  if (parts.length !== 4) throw new Error(`Ung\xFCltige IPv4-Adresse: ${address}`);
  let value = 0n;
  for (const part of parts) {
    const octet = Number(part);
    if (!Number.isInteger(octet) || octet < 0 || octet > 255) {
      throw new Error(`Ung\xFCltiges Oktett in ${address}`);
    }
    value = value << 8n | BigInt(octet);
  }
  return value;
}
function bigIntToIpv4(value) {
  const v = value & 0xffffffffn;
  return [24n, 16n, 8n, 0n].map((shift) => Number(v >> shift & 0xffn)).join(".");
}
function ipv6ToBigInt(address) {
  let addr = address.trim().toLowerCase();
  const v4Match = addr.match(/(\d+\.\d+\.\d+\.\d+)$/);
  if (v4Match) {
    const v4 = ipv4ToBigInt(v4Match[1]);
    const high = (v4 >> 16n & 0xffffn).toString(16);
    const low = (v4 & 0xffffn).toString(16);
    addr = addr.slice(0, v4Match.index) + `${high}:${low}`;
  }
  const doubleColon = addr.indexOf("::");
  let head;
  let tail;
  if (doubleColon >= 0) {
    head = addr.slice(0, doubleColon).split(":").filter(Boolean);
    tail = addr.slice(doubleColon + 2).split(":").filter(Boolean);
  } else {
    head = addr.split(":");
    tail = [];
  }
  if (head.length + tail.length > 8) throw new Error(`Ung\xFCltige IPv6-Adresse: ${address}`);
  const groups = [
    ...head,
    ...Array(8 - head.length - tail.length).fill("0"),
    ...tail
  ];
  let value = 0n;
  for (const group of groups) {
    if (!/^[0-9a-f]{1,4}$/.test(group)) throw new Error(`Ung\xFCltige IPv6-Gruppe "${group}" in ${address}`);
    value = value << 16n | BigInt(parseInt(group, 16));
  }
  return value;
}
function bigIntToIpv6(value) {
  const groups = [];
  for (let i = 7n; i >= 0n; i--) {
    groups.push(Number(value >> i * 16n & 0xffffn).toString(16));
  }
  let bestStart = -1;
  let bestLen = 0;
  let curStart = -1;
  let curLen = 0;
  groups.forEach((g, i) => {
    if (g === "0") {
      if (curStart < 0) curStart = i;
      curLen++;
      if (curLen > bestLen) {
        bestLen = curLen;
        bestStart = curStart;
      }
    } else {
      curStart = -1;
      curLen = 0;
    }
  });
  if (bestLen < 2) return groups.join(":");
  const head = groups.slice(0, bestStart).join(":");
  const tail = groups.slice(bestStart + bestLen).join(":");
  return `${head}::${tail}`;
}
function addressToBigInt(address, family) {
  const fam = family ?? detectFamily(address);
  return fam === "ipv4" ? ipv4ToBigInt(address) : ipv6ToBigInt(address);
}
function bigIntToAddress(value, family) {
  return family === "ipv4" ? bigIntToIpv4(value) : bigIntToIpv6(value);
}
function parsePrefix(cidr) {
  const [addr, lenRaw] = cidr.trim().split("/");
  if (!addr) throw new Error(`Ung\xFCltiges Prefix: ${cidr}`);
  const family = detectFamily(addr);
  const bits = family === "ipv4" ? V4_BITS : V6_BITS;
  const length = lenRaw === void 0 ? bits : Number(lenRaw);
  if (!Number.isInteger(length) || length < 0 || length > bits) {
    throw new Error(`Ung\xFCltige Prefixl\xE4nge in ${cidr}`);
  }
  const value = addressToBigInt(addr, family);
  return { family, network: maskAddress(value, length, bits), length, bits };
}
function formatPrefix(prefix) {
  return `${bigIntToAddress(prefix.network, prefix.family)}/${prefix.length}`;
}
function toCidr(network, length) {
  return formatPrefix(parsePrefix(`${network}/${length}`));
}
function maskAddress(value, length, bits) {
  if (length === 0) return 0n;
  const hostBits = BigInt(bits - length);
  return value >> hostBits << hostBits;
}
function addressCount(length, family) {
  const bits = family === "ipv4" ? V4_BITS : V6_BITS;
  return 1n << BigInt(bits - length);
}
function usableHosts(length, family) {
  if (family === "ipv6") {
    const count2 = addressCount(length, "ipv6");
    return count2 > BigInt(Number.MAX_SAFE_INTEGER) ? Number.MAX_SAFE_INTEGER : Number(count2);
  }
  if (length >= 31) return length === 32 ? 1 : 2;
  return Number(addressCount(length, "ipv4")) - 2;
}
function broadcastAddress(prefix) {
  return prefix.network + addressCount(prefix.length, prefix.family) - 1n;
}
function containsPrefix(outer, inner) {
  if (outer.family !== inner.family) return false;
  if (inner.length < outer.length) return false;
  return maskAddress(inner.network, outer.length, outer.bits) === outer.network;
}
function containsAddress(prefix, address) {
  const family = detectFamily(address);
  if (family !== prefix.family) return false;
  const value = addressToBigInt(address, family);
  return maskAddress(value, prefix.length, prefix.bits) === prefix.network;
}
function prefixesOverlap(a, b) {
  return containsPrefix(a, b) || containsPrefix(b, a);
}
function subnets(cidr, newLength, limit = 256) {
  const parent = parsePrefix(cidr);
  if (newLength < parent.length) throw new Error("Neue Prefixl\xE4nge muss gr\xF6\xDFer als die des Elternnetzes sein");
  if (newLength > parent.bits) throw new Error("Prefixl\xE4nge \xFCberschreitet die Adressbreite");
  const step = addressCount(newLength, parent.family);
  const total = 1n << BigInt(newLength - parent.length);
  const count2 = total > BigInt(limit) ? BigInt(limit) : total;
  const out = [];
  for (let i = 0n; i < count2; i++) {
    out.push(`${bigIntToAddress(parent.network + i * step, parent.family)}/${newLength}`);
  }
  return out;
}
function nthAddress(cidr, index) {
  const prefix = parsePrefix(cidr);
  const offset = typeof index === "number" ? BigInt(index) : index;
  const size = addressCount(prefix.length, prefix.family);
  if (offset < 0n || offset >= size) throw new Error(`Index ${offset} liegt au\xDFerhalb von ${cidr}`);
  return bigIntToAddress(prefix.network + offset, prefix.family);
}
function gatewayAddress(cidr) {
  const prefix = parsePrefix(cidr);
  return bigIntToAddress(prefix.network + 1n, prefix.family);
}
function longestPrefixMatch(candidates, address) {
  const family = detectFamily(address);
  const value = addressToBigInt(address, family);
  let bestIndex = -1;
  let bestLength = -1;
  candidates.forEach((cidr, index) => {
    let prefix;
    try {
      prefix = parsePrefix(cidr);
    } catch {
      return;
    }
    if (prefix.family !== family) return;
    if (maskAddress(value, prefix.length, prefix.bits) !== prefix.network) return;
    if (prefix.length > bestLength) {
      bestLength = prefix.length;
      bestIndex = index;
    }
  });
  return bestIndex;
}
function aggregate(cidrs) {
  const parsed = cidrs.map((c) => {
    try {
      return parsePrefix(c);
    } catch {
      return null;
    }
  }).filter((p) => p !== null).sort((a, b) => a.network === b.network ? a.length - b.length : a.network < b.network ? -1 : 1);
  const result = [];
  for (const prefix of parsed) {
    if (result.some((r) => r.family === prefix.family && containsPrefix(r, prefix))) continue;
    let current = prefix;
    let merged = true;
    while (merged && current.length > 0) {
      merged = false;
      const size = addressCount(current.length, current.family);
      const isLower = current.network / size % 2n === 0n;
      const buddyNetwork = isLower ? current.network + size : current.network - size;
      const buddyIndex = result.findIndex(
        (r) => r.family === current.family && r.length === current.length && r.network === buddyNetwork
      );
      if (buddyIndex >= 0) {
        result.splice(buddyIndex, 1);
        current = {
          family: current.family,
          bits: current.bits,
          length: current.length - 1,
          network: maskAddress(isLower ? current.network : buddyNetwork, current.length - 1, current.bits)
        };
        merged = true;
      }
    }
    result.push(current);
  }
  return result.map(formatPrefix).sort();
}
function reverseZoneName(cidr) {
  const prefix = parsePrefix(cidr);
  if (prefix.family === "ipv4") {
    const octets = bigIntToIpv4(prefix.network).split(".");
    const keep = Math.floor(prefix.length / 8);
    return `${octets.slice(0, keep).reverse().join(".")}.in-addr.arpa`;
  }
  const hex = prefix.network.toString(16).padStart(32, "0");
  const nibbles = Math.floor(prefix.length / 4);
  return `${hex.slice(0, nibbles).split("").reverse().join(".")}.ip6.arpa`;
}
function reversePointerName(address) {
  const family = detectFamily(address);
  if (family === "ipv4") {
    return `${address.split(".").reverse().join(".")}.in-addr.arpa`;
  }
  const hex = ipv6ToBigInt(address).toString(16).padStart(32, "0");
  return `${hex.split("").reverse().join(".")}.ip6.arpa`;
}
function isPrivate(address) {
  const family = detectFamily(address);
  const ranges = family === "ipv4" ? ["10.0.0.0/8", "172.16.0.0/12", "192.168.0.0/16", "127.0.0.0/8", "169.254.0.0/16", "100.64.0.0/10"] : ["fc00::/7", "fe80::/10", "::1/128"];
  return ranges.some((r) => containsAddress(parsePrefix(r), address));
}
function isAnnounceable(cidr) {
  let prefix;
  try {
    prefix = parsePrefix(cidr);
  } catch (e) {
    return { ok: false, reason: e.message };
  }
  if (prefix.family === "ipv4") {
    if (prefix.length > 24) return { ok: false, reason: "IPv4-Prefixe l\xE4nger als /24 werden global gefiltert" };
    if (isPrivate(bigIntToIpv4(prefix.network))) return { ok: false, reason: "Privater Adressbereich (Bogon)" };
  } else {
    if (prefix.length > 48) return { ok: false, reason: "IPv6-Prefixe l\xE4nger als /48 werden global gefiltert" };
    if (isPrivate(bigIntToIpv6(prefix.network))) return { ok: false, reason: "Nicht global g\xFCltiger Bereich" };
  }
  return { ok: true };
}

// src/utils/misc.ts
function makeId(rng, prefix) {
  const alphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
  let out = "";
  for (let i = 0; i < 10; i++) out += alphabet[rng.int(0, alphabet.length - 1)];
  return `${prefix}_${out}`;
}
function clamp(value, min, max) {
  return value < min ? min : value > max ? max : value;
}
function lerp(a, b, t) {
  return a + (b - a) * clamp(t, 0, 1);
}
function smooth(current, target, factor) {
  return current + (target - current) * clamp(factor, 0, 1);
}
function sum(values2) {
  return values2.reduce((a, b) => a + b, 0);
}
function average(values2) {
  return values2.length === 0 ? 0 : sum(values2) / values2.length;
}
function percentile(values2, p) {
  if (values2.length === 0) return 0;
  const sorted = [...values2].sort((a, b) => a - b);
  const index = clamp(p, 0, 1) * (sorted.length - 1);
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  if (lower === upper) return sorted[lower];
  return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower);
}
function money(value) {
  return Math.round(value * 100) / 100;
}
function values(store) {
  return Object.values(store);
}
function pushWindow(buffer, value, window) {
  buffer.push(value);
  if (buffer.length > window) buffer.splice(0, buffer.length - window);
  return buffer;
}
function groupBy(items, key) {
  const out = {};
  for (const item2 of items) {
    const k = key(item2);
    (out[k] ??= []).push(item2);
  }
  return out;
}
function deepClone(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}
function formatMbps(mbps) {
  if (mbps >= 1e6) return `${(mbps / 1e6).toFixed(2)} Tbit/s`;
  if (mbps >= 1e3) return `${(mbps / 1e3).toFixed(2)} Gbit/s`;
  return `${mbps.toFixed(1)} Mbit/s`;
}
function formatBytes(gb) {
  if (gb >= 1048576) return `${(gb / 1048576).toFixed(2)} PB`;
  if (gb >= 1024) return `${(gb / 1024).toFixed(2)} TB`;
  return `${gb.toFixed(0)} GB`;
}

// src/domain/catalog/parts.ts
var DimmStandards = ["ddr4", "ddr5"];
var CpuSockets = ["gen3", "gen4", "gen5"];
var DriveFormFactors = ["sata-2.5", "sata-3.5", "nvme-u2"];
var PartKinds = ["cpu", "ram", "drive", "nic", "gpu"];
var CPU_PARTS = [
  {
    key: "cpu-g3-2c",
    name: "Dual-Core 3.6 GHz",
    kind: "cpu",
    vendorTier: "budget",
    price: 110,
    cores: 2,
    ghz: 3.6,
    ipc: 0.78,
    socket: "gen3",
    idleWatt: 8,
    maxWatt: 38,
    leadTimeTicks: 24,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Der billigste Prozessor im Katalog. F\xFCr Nameserver und Mailrelays reicht er, f\xFCr Kunden nicht."
  },
  {
    key: "cpu-g3-4c",
    name: "Quad-Core 3.4 GHz",
    kind: "cpu",
    vendorTier: "budget",
    price: 240,
    cores: 4,
    ghz: 3.4,
    ipc: 0.8,
    socket: "gen3",
    idleWatt: 12,
    maxWatt: 65,
    leadTimeTicks: 24,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Einstiegsprozessor mit hoher Taktrate und wenigen Kernen."
  },
  {
    key: "cpu-g3-8c",
    name: "8-Core 3.0 GHz",
    kind: "cpu",
    vendorTier: "budget",
    price: 520,
    cores: 8,
    ghz: 3,
    ipc: 0.85,
    socket: "gen3",
    idleWatt: 15,
    maxWatt: 88,
    leadTimeTicks: 24,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Verdoppelt die Kernzahl der Einstiegsplattform ohne Sockelwechsel."
  },
  {
    key: "cpu-g4-8c",
    name: "8-Core 3.8 GHz",
    kind: "cpu",
    vendorTier: "standard",
    price: 780,
    cores: 8,
    ghz: 3.8,
    ipc: 1,
    socket: "gen4",
    idleWatt: 20,
    maxWatt: 135,
    leadTimeTicks: 36,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Wenige, aber sehr schnelle Kerne. Die richtige Wahl f\xFCr Shared Hosting und Datenbanken, wo eine einzelne Anfrage z\xFCgig fertig werden muss \u2013 und die falsche f\xFCr VPS-Dichte."
  },
  {
    key: "cpu-g4-12c",
    name: "12-Core 2.4 GHz",
    kind: "cpu",
    vendorTier: "standard",
    price: 680,
    cores: 12,
    ghz: 2.4,
    ipc: 0.95,
    socket: "gen4",
    idleWatt: 22,
    maxWatt: 120,
    leadTimeTicks: 36,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Sparsamer Allrounder f\xFCr Storage- und Backup-Knoten."
  },
  {
    key: "cpu-g4-16c",
    name: "16-Core 2.9 GHz",
    kind: "cpu",
    vendorTier: "standard",
    price: 950,
    cores: 16,
    ghz: 2.9,
    ipc: 1,
    socket: "gen4",
    idleWatt: 25,
    maxWatt: 150,
    leadTimeTicks: 36,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Referenzprozessor der Mittelklasse \u2013 gutes Verh\xE4ltnis von Kernen zu Takt."
  },
  {
    key: "cpu-g4-16le",
    name: "16-Core 1.9 GHz (sparsam)",
    kind: "cpu",
    vendorTier: "standard",
    price: 890,
    cores: 16,
    ghz: 1.9,
    ipc: 0.95,
    socket: "gen4",
    idleWatt: 16,
    maxWatt: 95,
    leadTimeTicks: 36,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    /*
     * Die Stromspar-Variante ist im Katalog wichtiger, als sie aussieht.
     * Ein Server läuft Jahre; bei 0,45 €/kWh kosten 55 W Unterschied rund
     * 220 € im Jahr – mehr, als der Aufpreis ausmacht. Wer rechnet, findet
     * das. Wer nur auf die Kernzahl schaut, nicht.
     */
    description: "Gleiche Kernzahl wie das Referenzmodell bei zwei Dritteln des Verbrauchs, daf\xFCr deutlich niedrigerem Takt. Rechnet sich \xFCber die Stromrechnung, nicht \xFCber den Kaufpreis."
  },
  {
    key: "cpu-g4-24c",
    name: "24-Core 2.7 GHz",
    kind: "cpu",
    vendorTier: "standard",
    price: 2100,
    cores: 24,
    ghz: 2.7,
    ipc: 1.05,
    socket: "gen4",
    idleWatt: 32,
    maxWatt: 205,
    leadTimeTicks: 48,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: null,
    description: "Maximalausbau der Gen4-Plattform; hebt bestehende Hosts sp\xFCrbar an."
  },
  {
    key: "cpu-g5-16c",
    name: "16-Core 4.0 GHz",
    kind: "cpu",
    vendorTier: "enterprise",
    price: 2900,
    cores: 16,
    ghz: 4,
    ipc: 1.35,
    socket: "gen5",
    idleWatt: 38,
    maxWatt: 240,
    leadTimeTicks: 72,
    installTicks: 3,
    lifespanTicks: 24 * 360 * 10,
    /*
     * Hängt an der NVMe-Forschung und nicht an der Dual-Socket-Verdichtung –
     * und das schließt eine Lücke: Wer bisher nur die NVMe-Plattform
     * erforschte, bekam ein Gen5-Gehäuse, für das es keinen einzigen kaufbaren
     * Prozessor gab. Ein Gehäuse, das man nicht bestücken kann, ist kein
     * Fortschritt, sondern ein Rätsel.
     */
    requiresResearch: "res-nvme",
    description: "Der schnellste Kern im Katalog. Wenige davon, daf\xFCr jeder einzelne unschlagbar \u2013 f\xFCr dedizierte Server, deren Kunden Rechenzeit und nicht Kernzahl kaufen."
  },
  {
    key: "cpu-g5-32c",
    name: "32-Core 3.1 GHz",
    kind: "cpu",
    vendorTier: "enterprise",
    price: 3400,
    cores: 32,
    ghz: 3.1,
    ipc: 1.25,
    socket: "gen5",
    idleWatt: 45,
    maxWatt: 280,
    leadTimeTicks: 72,
    installTicks: 3,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: "res-dense-compute",
    description: "Kernstarke Server-CPU f\xFCr hohe VPS-Dichte."
  },
  {
    key: "cpu-g5-48c",
    name: "48-Core 3.6 GHz",
    kind: "cpu",
    vendorTier: "enterprise",
    price: 6800,
    cores: 48,
    ghz: 3.6,
    ipc: 1.4,
    socket: "gen5",
    idleWatt: 55,
    maxWatt: 330,
    leadTimeTicks: 72,
    installTicks: 3,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: "res-dense-compute",
    description: "Spitzenmodell: viele Kerne bei hohem Takt, entsprechend teuer."
  },
  {
    key: "cpu-g5-64c",
    name: "64-Core 3.2 GHz",
    kind: "cpu",
    vendorTier: "enterprise",
    price: 9800,
    cores: 64,
    ghz: 3.2,
    ipc: 1.4,
    socket: "gen5",
    idleWatt: 65,
    maxWatt: 420,
    leadTimeTicks: 96,
    installTicks: 3,
    lifespanTicks: 24 * 360 * 10,
    requiresResearch: "res-dense-compute",
    /*
     * Die Obergrenze ist absichtlich unwirtschaftlich je Kern: Sie kauft
     * Höheneinheiten und Rackplätze zurück, nicht Rechenleistung je Euro. In
     * einem vollen Rechenzentrum ist genau das die knappe Ware.
     */
    description: "Zwei davon in einem Geh\xE4use ergeben 128 Kerne auf zwei H\xF6heneinheiten. Je Kern ist das teuer bezahlt \u2013 man kauft hier Platz und Strombudget, nicht Rechenleistung."
  }
];
var RAM_PARTS = [
  {
    key: "ram-ddr4-8",
    name: "8 GB DDR4 RDIMM",
    kind: "ram",
    vendorTier: "budget",
    price: 34,
    capacityGb: 8,
    standard: "ddr4",
    idleWatt: 1,
    maxWatt: 2,
    leadTimeTicks: 12,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Nur f\xFCr Kleinstknoten sinnvoll \u2013 in einem Geh\xE4use mit vier Pl\xE4tzen sind das magere 32 GB."
  },
  {
    key: "ram-ddr4-16",
    name: "16 GB DDR4 RDIMM",
    kind: "ram",
    vendorTier: "budget",
    price: 58,
    capacityGb: 16,
    standard: "ddr4",
    idleWatt: 1.5,
    maxWatt: 3,
    leadTimeTicks: 12,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Kleinstes sinnvolles Modul \u2013 f\xFCllt Steckpl\xE4tze, die sp\xE4ter fehlen."
  },
  {
    key: "ram-ddr4-32",
    name: "32 GB DDR4 RDIMM",
    kind: "ram",
    vendorTier: "standard",
    price: 108,
    capacityGb: 32,
    standard: "ddr4",
    idleWatt: 2,
    maxWatt: 4,
    leadTimeTicks: 12,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Der Standardriegel f\xFCr DDR4-Plattformen."
  },
  {
    key: "ram-ddr4-64",
    name: "64 GB DDR4 RDIMM",
    kind: "ram",
    vendorTier: "standard",
    price: 285,
    capacityGb: 64,
    standard: "ddr4",
    idleWatt: 3,
    maxWatt: 6,
    leadTimeTicks: 18,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Verdoppelt die Kapazit\xE4t je Steckplatz \u2013 spart Slots f\xFCr sp\xE4ter."
  },
  {
    key: "ram-ddr4-128",
    name: "128 GB DDR4 RDIMM",
    kind: "ram",
    vendorTier: "enterprise",
    price: 1150,
    capacityGb: 128,
    standard: "ddr4",
    idleWatt: 5.5,
    maxWatt: 10,
    leadTimeTicks: 36,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Der Weg, eine DDR4-Plattform ohne Sockelwechsel voll zu bekommen. Je Gigabyte doppelt so teuer wie ein 64er \u2013 man bezahlt die freien Steckpl\xE4tze, die dabei \xFCbrig bleiben."
  },
  {
    key: "ram-ddr5-16",
    name: "16 GB DDR5 RDIMM",
    kind: "ram",
    vendorTier: "budget",
    price: 95,
    capacityGb: 16,
    standard: "ddr5",
    idleWatt: 1.8,
    maxWatt: 4,
    leadTimeTicks: 18,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "G\xFCnstigster DDR5-Riegel; sinnvoll, um viele Steckpl\xE4tze zun\xE4chst nur zu belegen."
  },
  {
    key: "ram-ddr5-32",
    name: "32 GB DDR5 RDIMM",
    kind: "ram",
    vendorTier: "standard",
    price: 165,
    capacityGb: 32,
    standard: "ddr5",
    idleWatt: 2.5,
    maxWatt: 5,
    leadTimeTicks: 18,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Einstieg in die DDR5-Plattformen."
  },
  {
    key: "ram-ddr5-64",
    name: "64 GB DDR5 RDIMM",
    kind: "ram",
    vendorTier: "enterprise",
    price: 340,
    capacityGb: 64,
    standard: "ddr5",
    idleWatt: 3.5,
    maxWatt: 7,
    leadTimeTicks: 18,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Arbeitspferd f\xFCr dichte VPS-Hosts."
  },
  {
    key: "ram-ddr5-128",
    name: "128 GB DDR5 RDIMM",
    kind: "ram",
    vendorTier: "enterprise",
    price: 980,
    capacityGb: 128,
    standard: "ddr5",
    idleWatt: 6,
    maxWatt: 11,
    leadTimeTicks: 36,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: "res-dense-compute",
    description: "H\xF6chste Kapazit\xE4t je Steckplatz; der Preis je GB ist deutlich schlechter."
  },
  {
    key: "ram-ddr5-256",
    name: "256 GB DDR5 RDIMM",
    kind: "ram",
    vendorTier: "enterprise",
    price: 2600,
    capacityGb: 256,
    standard: "ddr5",
    idleWatt: 9,
    maxWatt: 16,
    leadTimeTicks: 48,
    installTicks: 0.25,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: "res-dense-compute",
    description: "Das Ende der Fahnenstange. Erst damit reizt ein Geh\xE4use mit zw\xF6lf Pl\xE4tzen seinen Speichercontroller wirklich aus \u2013 zu einem Preis, der jede \xDCberbuchung wieder attraktiv macht."
  }
];
var DRIVE_PARTS = [
  {
    key: "drv-ssd-256",
    name: "SATA-SSD 256 GB",
    kind: "drive",
    vendorTier: "budget",
    price: 32,
    capacityGb: 256,
    media: "ssd",
    formFactor: "sata-2.5",
    idleWatt: 1,
    maxWatt: 3.5,
    leadTimeTicks: 8,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "Reines Systemlaufwerk. Zwei davon im Spiegel kosten weniger als ein Abend Ausfall."
  },
  {
    key: "drv-ssd-512",
    name: "SATA-SSD 512 GB",
    kind: "drive",
    vendorTier: "budget",
    price: 52,
    capacityGb: 512,
    media: "ssd",
    formFactor: "sata-2.5",
    idleWatt: 1.2,
    maxWatt: 4,
    leadTimeTicks: 8,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "Systemlaufwerk und Einstieg f\xFCr kleine Shared-Hosting-Knoten."
  },
  {
    key: "drv-ssd-1024",
    name: "SATA-SSD 1 TB",
    kind: "drive",
    vendorTier: "budget",
    price: 95,
    capacityGb: 1024,
    media: "ssd",
    formFactor: "sata-2.5",
    idleWatt: 1.5,
    maxWatt: 5,
    leadTimeTicks: 8,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "G\xFCnstige Kapazit\xE4t, aber deutlich weniger IOPS als NVMe."
  },
  {
    key: "drv-ssd-2048",
    name: "SATA-SSD 2 TB",
    kind: "drive",
    vendorTier: "budget",
    price: 175,
    capacityGb: 2048,
    media: "ssd",
    formFactor: "sata-2.5",
    idleWatt: 1.6,
    maxWatt: 5.5,
    leadTimeTicks: 8,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "Kapazit\xE4t f\xFCr Geh\xE4use, die keine NVMe-Einsch\xFCbe haben \u2013 langsamer, aber halb so teuer je Terabyte."
  },
  {
    key: "drv-ssd-4096",
    name: "SATA-SSD 4 TB",
    kind: "drive",
    vendorTier: "standard",
    price: 340,
    capacityGb: 4096,
    media: "ssd",
    formFactor: "sata-2.5",
    idleWatt: 1.8,
    maxWatt: 6,
    leadTimeTicks: 12,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "Die gr\xF6\xDFte SATA-SSD im Katalog. F\xFCr Shared Hosting die g\xFCnstigste Art, Einsch\xFCbe zu sparen."
  },
  {
    key: "drv-nvme-1024",
    name: "NVMe-SSD 1 TB (U.2)",
    kind: "drive",
    vendorTier: "standard",
    price: 165,
    capacityGb: 1024,
    media: "ssd",
    formFactor: "nvme-u2",
    idleWatt: 5,
    maxWatt: 12,
    leadTimeTicks: 12,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 6,
    requiresResearch: null,
    description: "Kleinste NVMe: volle IOPS bei wenig Kapazit\xE4t \u2013 f\xFCr schnelle Systemplatten und Datenbanken."
  },
  {
    key: "drv-nvme-2048",
    name: "NVMe-SSD 2 TB (U.2)",
    kind: "drive",
    vendorTier: "standard",
    price: 280,
    capacityGb: 2048,
    media: "ssd",
    formFactor: "nvme-u2",
    idleWatt: 6,
    maxWatt: 14,
    leadTimeTicks: 12,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 6,
    requiresResearch: null,
    description: "Der Standard f\xFCr VPS-Hosts: hohe IOPS bei vertretbarem Preis."
  },
  {
    key: "drv-nvme-4096",
    name: "NVMe-SSD 4 TB (U.2)",
    kind: "drive",
    vendorTier: "standard",
    price: 520,
    capacityGb: 4096,
    media: "ssd",
    formFactor: "nvme-u2",
    idleWatt: 7,
    maxWatt: 16,
    leadTimeTicks: 12,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 6,
    requiresResearch: null,
    description: "Doppelte Kapazit\xE4t je Einschub \u2013 wichtig, wenn die Bays knapp werden."
  },
  {
    key: "drv-nvme-8192",
    name: "NVMe-SSD 8 TB (U.2)",
    kind: "drive",
    vendorTier: "enterprise",
    price: 1180,
    capacityGb: 8192,
    media: "ssd",
    formFactor: "nvme-u2",
    idleWatt: 8,
    maxWatt: 18,
    leadTimeTicks: 24,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 6,
    requiresResearch: "res-nvme",
    description: "Maximale Dichte f\xFCr Premium-Produkte."
  },
  {
    key: "drv-nvme-16384",
    name: "NVMe-SSD 16 TB (U.2)",
    kind: "drive",
    vendorTier: "enterprise",
    price: 2500,
    capacityGb: 16384,
    media: "ssd",
    formFactor: "nvme-u2",
    idleWatt: 9,
    maxWatt: 20,
    leadTimeTicks: 36,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 6,
    requiresResearch: "res-nvme",
    description: "64 TB Flash auf vier Einsch\xFCben. Der Preis je Terabyte ist der schlechteste im Katalog \u2013 gekauft wird hier der Einschub, nicht der Speicher."
  },
  {
    key: "drv-hdd-6000",
    name: "SATA-HDD 6 TB",
    kind: "drive",
    vendorTier: "budget",
    price: 118,
    capacityGb: 6e3,
    media: "hdd",
    formFactor: "sata-3.5",
    idleWatt: 5,
    maxWatt: 9,
    leadTimeTicks: 12,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 4,
    requiresResearch: null,
    description: "Klassische Kapazit\xE4tsplatte f\xFCr Backup und kaltes Storage."
  },
  {
    key: "drv-hdd-12000",
    name: "SATA-HDD 12 TB",
    kind: "drive",
    vendorTier: "budget",
    price: 210,
    capacityGb: 12e3,
    media: "hdd",
    formFactor: "sata-3.5",
    idleWatt: 5.5,
    maxWatt: 10,
    leadTimeTicks: 12,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 4,
    requiresResearch: null,
    description: "Der Mittelweg beim kalten Speicher: doppelte Kapazit\xE4t der 6-TB-Platte, k\xFCrzerer Wiederaufbau als bei 20 TB."
  },
  {
    key: "drv-hdd-20000",
    name: "SATA-HDD 20 TB",
    kind: "drive",
    vendorTier: "standard",
    price: 330,
    capacityGb: 2e4,
    media: "hdd",
    formFactor: "sata-3.5",
    idleWatt: 6,
    maxWatt: 11,
    leadTimeTicks: 18,
    installTicks: 0.2,
    lifespanTicks: 24 * 360 * 4,
    requiresResearch: null,
    description: "Beste Kapazit\xE4t je Einschub; ein Wiederaufbau nach Ausfall dauert lange."
  }
];
var NIC_PARTS = [
  {
    key: "nic-1g",
    name: "2\xD7 1 GbE",
    kind: "nic",
    vendorTier: "budget",
    price: 95,
    speedMbps: 1e3,
    ports: 2,
    idleWatt: 2,
    maxWatt: 6,
    leadTimeTicks: 8,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Reicht f\xFCr Shared Hosting, nicht f\xFCr Storage oder viele VPS."
  },
  {
    key: "nic-1g-quad",
    name: "4\xD7 1 GbE",
    kind: "nic",
    vendorTier: "budget",
    price: 150,
    speedMbps: 1e3,
    ports: 4,
    idleWatt: 3,
    maxWatt: 9,
    leadTimeTicks: 8,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Vier Gigabit-Ports statt zwei \u2013 die billigste Art, 4 Gbit/s an einen Server zu bekommen."
  },
  {
    key: "nic-10g",
    name: "2\xD7 10 GbE",
    kind: "nic",
    vendorTier: "standard",
    price: 330,
    speedMbps: 1e4,
    ports: 2,
    idleWatt: 6,
    maxWatt: 14,
    leadTimeTicks: 12,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Der \xFCbliche Serveranschluss; passt zu 10G-Top-of-Rack-Switches."
  },
  {
    key: "nic-10g-quad",
    name: "4\xD7 10 GbE",
    kind: "nic",
    vendorTier: "standard",
    price: 620,
    speedMbps: 1e4,
    ports: 4,
    idleWatt: 9,
    maxWatt: 22,
    leadTimeTicks: 12,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "40 Gbit/s aus vier gew\xF6hnlichen Ports \u2013 g\xFCnstiger als eine 25G-Karte und passt an vorhandene Switches."
  },
  {
    key: "nic-25g",
    name: "2\xD7 25 GbE",
    kind: "nic",
    vendorTier: "enterprise",
    price: 790,
    speedMbps: 25e3,
    ports: 2,
    idleWatt: 9,
    maxWatt: 20,
    leadTimeTicks: 18,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "F\xFCr dichte Hosts, deren Uplink sonst zum Engpass wird."
  },
  {
    key: "nic-40g",
    name: "2\xD7 40 GbE",
    kind: "nic",
    vendorTier: "enterprise",
    price: 1300,
    speedMbps: 4e4,
    ports: 2,
    idleWatt: 11,
    maxWatt: 26,
    leadTimeTicks: 24,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: null,
    description: "Die Stufe zwischen 25G und 100G \u2013 f\xFCr Storage-Knoten, die viele Umz\xFCge tragen m\xFCssen."
  },
  {
    key: "nic-100g",
    name: "2\xD7 100 GbE",
    kind: "nic",
    vendorTier: "enterprise",
    price: 2400,
    speedMbps: 1e5,
    ports: 2,
    idleWatt: 14,
    maxWatt: 32,
    leadTimeTicks: 36,
    installTicks: 0.5,
    lifespanTicks: 24 * 360 * 12,
    requiresResearch: "res-100g",
    description: "Backbone-Anbindung f\xFCr Storage-Cluster und Premium-Compute."
  }
];
var GPU_PARTS = [
  {
    key: "gpu-t1",
    name: "Inferenzbeschleuniger T1",
    kind: "gpu",
    vendorTier: "standard",
    price: 8900,
    computeUnits: 1,
    idleWatt: 40,
    maxWatt: 300,
    leadTimeTicks: 72,
    installTicks: 2,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: "res-ai-compute",
    description: "Solide Leistung f\xFCr Inferenz und kleinere Modelle \u2013 der Einstieg ins GPU-Gesch\xE4ft."
  },
  {
    key: "gpu-t2",
    name: "Trainingsbeschleuniger T2",
    kind: "gpu",
    vendorTier: "enterprise",
    price: 24500,
    computeUnits: 3,
    idleWatt: 65,
    maxWatt: 700,
    leadTimeTicks: 120,
    installTicks: 3,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: "res-ai-compute",
    description: "F\xFCr Training gro\xDFer Modelle ausgelegt \u2013 hoher Verbrauch, entsprechend teure K\xFChlung."
  }
];
var PART_MODELS = [...CPU_PARTS, ...RAM_PARTS, ...DRIVE_PARTS, ...NIC_PARTS, ...GPU_PARTS];
var PART_INDEX = new Map(PART_MODELS.map((p) => [p.key, p]));
function findPart(key) {
  return PART_INDEX.get(key);
}
function findPartOfKind(key, kind) {
  const part = PART_INDEX.get(key);
  return part?.kind === kind ? part : void 0;
}
function availableParts(kind, completedResearch2) {
  return PART_MODELS.filter(
    (p) => p.kind === kind && (p.requiresResearch === null || completedResearch2.includes(p.requiresResearch))
  );
}
function deriveServerSpecs(platform, bom) {
  let cores = 0;
  let ramGb = 0;
  let ssdGb = 0;
  let hddGb = 0;
  let nicMbps = 0;
  let gpuCount = 0;
  let idleWatt = platform.baseIdleWatt;
  let maxWatt = platform.baseMaxWatt;
  const cpus = [];
  for (const entry of bom) {
    const part = findPart(entry.modelKey);
    if (!part || entry.quantity <= 0) continue;
    idleWatt += part.idleWatt * entry.quantity;
    maxWatt += part.maxWatt * entry.quantity;
    switch (part.kind) {
      case "cpu":
        cores += part.cores * entry.quantity;
        cpus.push({ part, quantity: entry.quantity });
        break;
      case "ram":
        ramGb += part.capacityGb * entry.quantity;
        break;
      case "drive":
        if (part.media === "ssd") ssdGb += part.capacityGb * entry.quantity;
        else hddGb += part.capacityGb * entry.quantity;
        break;
      case "nic":
        nicMbps += part.speedMbps * part.ports * entry.quantity;
        break;
      case "gpu":
        gpuCount += part.computeUnits * entry.quantity;
        break;
    }
  }
  const slowest = cpus.reduce(
    (worst, c) => worst === null || c.part.ghz * c.part.ipc < worst.ghz * worst.ipc ? c.part : worst,
    null
  );
  return {
    cpuModel: describeCpus(cpus),
    cpuCores: cores,
    cpuGhz: slowest?.ghz ?? 0,
    cpuIpc: slowest?.ipc ?? 1,
    // Der Speichercontroller begrenzt unabhängig von der Zahl der Steckplätze.
    ramGb: Math.min(ramGb, platform.maxRamGb),
    ssdGb,
    hddGb,
    nicMbps,
    gpuCount,
    idleWatt: Math.round(idleWatt * 10) / 10,
    maxWatt: Math.round(maxWatt * 10) / 10
  };
}
function describeCpus(cpus) {
  if (cpus.length === 0) return "kein Prozessor";
  return cpus.map(({ part, quantity }) => quantity > 1 ? `${quantity}\xD7 ${part.name}` : part.name).join(" + ");
}
var PART_KIND_LABEL = {
  cpu: "Prozessor",
  ram: "Arbeitsspeicher",
  drive: "Laufwerk",
  nic: "Netzwerkkarte",
  gpu: "GPU-Karte"
};
var SLOT_LABEL = {
  cpu: "Sockel",
  ram: "DIMM-Steckplatz",
  drive: "Einschub",
  nic: "Erweiterungsslot",
  gpu: "GPU-Steckplatz"
};

// src/domain/catalog/hardware.ts
function assemble(definition) {
  return { ...definition, ...deriveServerSpecs(definition.platform, definition.factoryParts) };
}
var SERVER_MODELS = [
  /*
   * Die schmale Klasse.
   *
   * DNS, Mail und kleine Dienste brauchen keine Rechenleistung, sondern
   * Verfügbarkeit und wenig Strom. Ein Nameserver, der auf einem 16-Kern-Knoten
   * läuft, ist verschwendetes Kapital – und genau deshalb gibt es hier Geräte,
   * die kaum etwas kosten und kaum etwas können.
   */
  assemble({
    key: "srv-micro",
    name: "PicoNode 1U",
    vendorTier: "budget",
    price: 420,
    maintenancePerMonth: 5,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen3",
      dimmSlots: 2,
      dimmStandard: "ddr4",
      maxRamGb: 32,
      driveBays: 2,
      driveFormFactors: ["sata-2.5"],
      nicSlots: 1,
      baseIdleWatt: 8,
      baseMaxWatt: 14
    },
    factoryParts: [
      { modelKey: "cpu-g3-4c", quantity: 1 },
      { modelKey: "ram-ddr4-16", quantity: 1 },
      { modelKey: "drv-ssd-512", quantity: 1 },
      { modelKey: "nic-1g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "freebsd"],
    requiresResearch: null,
    description: "Sparsamer Kleinstserver f\xFCr Nameserver, Mailrelays und \xDCberwachung. Zwei Steckpl\xE4tze, zwei Einsch\xFCbe \u2013 mehr als seine eine Aufgabe tr\xE4gt er nicht."
  }),
  assemble({
    key: "srv-dns-redundant",
    name: "AnycastNode 1U",
    vendorTier: "standard",
    price: 1450,
    maintenancePerMonth: 14,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen3",
      dimmSlots: 4,
      dimmStandard: "ddr4",
      maxRamGb: 128,
      driveBays: 4,
      driveFormFactors: ["sata-2.5", "nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 18,
      baseMaxWatt: 34
    },
    factoryParts: [
      { modelKey: "cpu-g3-8c", quantity: 1 },
      { modelKey: "ram-ddr4-16", quantity: 2 },
      { modelKey: "drv-ssd-512", quantity: 2 },
      { modelKey: "nic-10g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "freebsd"],
    requiresResearch: null,
    description: "Auf viele kleine Anfragen ausgelegt: zwei Systemplatten, 10G-Anbindung. Der \xFCbliche Knoten f\xFCr autoritatives DNS an mehreren Standorten."
  }),
  assemble({
    key: "srv-mail-2u",
    name: "MailStore 2U",
    vendorTier: "standard",
    price: 2650,
    maintenancePerMonth: 24,
    heightUnits: 2,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 12,
      driveFormFactors: ["sata-2.5", "sata-3.5"],
      nicSlots: 2,
      baseIdleWatt: 32,
      baseMaxWatt: 88
    },
    factoryParts: [
      { modelKey: "cpu-g4-12c", quantity: 1 },
      { modelKey: "ram-ddr4-32", quantity: 2 },
      { modelKey: "drv-ssd-1024", quantity: 4 },
      { modelKey: "nic-10g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky"],
    requiresResearch: null,
    description: "Viele Einsch\xFCbe bei m\xE4\xDFiger Rechenleistung \u2013 das Profil eines Postfachservers. W\xE4chst mit dem Postfachvolumen, nicht mit der Kundenzahl."
  }),
  assemble({
    key: "srv-backup-4u",
    name: "ColdVault 4U",
    vendorTier: "budget",
    price: 3900,
    maintenancePerMonth: 30,
    heightUnits: 4,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen3",
      dimmSlots: 4,
      dimmStandard: "ddr4",
      maxRamGb: 128,
      driveBays: 24,
      driveFormFactors: ["sata-3.5"],
      nicSlots: 2,
      baseIdleWatt: 42,
      baseMaxWatt: 170
    },
    factoryParts: [
      { modelKey: "cpu-g3-8c", quantity: 1 },
      { modelKey: "ram-ddr4-16", quantity: 2 },
      { modelKey: "drv-hdd-6000", quantity: 12 },
      { modelKey: "nic-1g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 8,
    supportedOs: ["linux-debian", "linux-ubuntu"],
    requiresResearch: null,
    description: "Reine Kapazit\xE4t f\xFCr Sicherungen: schwache CPU, langsame Anbindung, viele Platten. Die H\xE4lfte der Einsch\xFCbe ist ab Werk frei."
  }),
  assemble({
    key: "srv-eco-1",
    name: "EcoNode 1U",
    vendorTier: "budget",
    price: 1450,
    maintenancePerMonth: 12,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen3",
      dimmSlots: 4,
      dimmStandard: "ddr4",
      maxRamGb: 128,
      driveBays: 4,
      driveFormFactors: ["sata-2.5"],
      nicSlots: 1,
      baseIdleWatt: 27,
      baseMaxWatt: 49
    },
    factoryParts: [
      { modelKey: "cpu-g3-4c", quantity: 1 },
      { modelKey: "ram-ddr4-16", quantity: 2 },
      { modelKey: "drv-ssd-1024", quantity: 2 },
      { modelKey: "nic-1g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "freebsd"],
    requiresResearch: null,
    description: "G\xFCnstiger Einstiegsserver mit 2 TB im Spiegel. Nur vier DIMM-Steckpl\xE4tze und vier Einsch\xFCbe \u2013 der Ausbauspielraum ist schnell ersch\xF6pft."
  }),
  assemble({
    key: "srv-std-2",
    name: "CoreLine 1U",
    vendorTier: "standard",
    price: 3400,
    maintenancePerMonth: 28,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 8,
      driveFormFactors: ["nvme-u2", "sata-2.5"],
      nicSlots: 2,
      baseIdleWatt: 45,
      baseMaxWatt: 126
    },
    factoryParts: [
      { modelKey: "cpu-g4-16c", quantity: 1 },
      { modelKey: "ram-ddr4-32", quantity: 4 },
      { modelKey: "drv-nvme-2048", quantity: 1 },
      { modelKey: "nic-10g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: null,
    description: "Arbeitspferd f\xFCr VPS-Hosting. Halb best\xFCckt ausgeliefert \u2013 vier freie DIMM-Steckpl\xE4tze und sieben Einsch\xFCbe lassen viel Luft nach oben."
  }),
  assemble({
    key: "srv-storage-4u",
    name: "BulkStore 4U",
    vendorTier: "standard",
    price: 6800,
    maintenancePerMonth: 55,
    heightUnits: 4,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 26,
      driveFormFactors: ["sata-3.5", "sata-2.5"],
      nicSlots: 2,
      baseIdleWatt: 55,
      baseMaxWatt: 289
    },
    factoryParts: [
      { modelKey: "cpu-g4-12c", quantity: 1 },
      { modelKey: "ram-ddr4-32", quantity: 3 },
      { modelKey: "drv-ssd-1024", quantity: 1 },
      { modelKey: "drv-hdd-6000", quantity: 20 },
      { modelKey: "nic-10g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "freebsd"],
    requiresResearch: null,
    description: "Storage-Chassis mit 26 Einsch\xFCben \u2013 Grundlage f\xFCr Backup- und Storage-Produkte. F\xFCnf Einsch\xFCbe bleiben ab Werk frei."
  }),
  /*
   * Der Hochtakt-Knoten für Shared Hosting.
   *
   * Er hat weniger Kerne als der gleich teure Allrounder und ist trotzdem die
   * bessere Wahl, wenn hundert kleine Webseiten daraufliegen: Dort wartet
   * niemand auf Kerne, sondern auf das Ende der einzelnen Anfrage.
   */
  assemble({
    key: "srv-shared-1u",
    name: "SwiftHost 1U",
    vendorTier: "standard",
    price: 3200,
    maintenancePerMonth: 26,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 8,
      driveFormFactors: ["sata-2.5", "nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 42,
      baseMaxWatt: 118
    },
    factoryParts: [
      { modelKey: "cpu-g4-8c", quantity: 1 },
      { modelKey: "ram-ddr4-32", quantity: 4 },
      { modelKey: "drv-ssd-2048", quantity: 2 },
      { modelKey: "nic-10g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: null,
    description: "Acht sehr schnelle Kerne statt vieler langsamer, dazu 4 TB SATA-Flash. F\xFCr Shared Hosting die bessere Maschine als ein Kernmonster \u2013 und die schlechtere f\xFCr VPS."
  }),
  assemble({
    key: "srv-dual-2u",
    name: "TwinCore 2U",
    vendorTier: "standard",
    price: 8400,
    maintenancePerMonth: 78,
    heightUnits: 2,
    platform: {
      cpuSockets: 2,
      cpuSocket: "gen4",
      dimmSlots: 16,
      dimmStandard: "ddr4",
      maxRamGb: 1024,
      driveBays: 12,
      driveFormFactors: ["nvme-u2", "sata-2.5"],
      nicSlots: 2,
      baseIdleWatt: 60,
      baseMaxWatt: 115
    },
    factoryParts: [
      { modelKey: "cpu-g4-16c", quantity: 2 },
      { modelKey: "ram-ddr4-32", quantity: 8 },
      { modelKey: "drv-nvme-2048", quantity: 4 },
      { modelKey: "nic-10g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: "res-dense-compute",
    description: "32 Kerne aus zwei Sockeln, 256 GB RAM, acht freie Einsch\xFCbe. Der Arbeitsknoten f\xFCr VPS-Dichte, bevor sich die Gen5-Plattform lohnt."
  }),
  assemble({
    key: "srv-ent-2u",
    name: "DenseCompute 2U",
    vendorTier: "enterprise",
    price: 11500,
    maintenancePerMonth: 95,
    heightUnits: 2,
    platform: {
      cpuSockets: 2,
      cpuSocket: "gen5",
      dimmSlots: 16,
      dimmStandard: "ddr5",
      maxRamGb: 2048,
      driveBays: 8,
      driveFormFactors: ["nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 67,
      baseMaxWatt: 88
    },
    factoryParts: [
      { modelKey: "cpu-g5-32c", quantity: 2 },
      { modelKey: "ram-ddr5-32", quantity: 16 },
      { modelKey: "drv-nvme-4096", quantity: 2 },
      { modelKey: "nic-25g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: "res-dense-compute",
    description: "Dual-Socket-Plattform f\xFCr hohe VPS-Dichte. Alle 16 DIMM-Steckpl\xE4tze sind belegt: Mehr Speicher hei\xDFt hier, die vorhandenen Module gegen gr\xF6\xDFere zu tauschen."
  }),
  assemble({
    key: "srv-nvme-1u",
    name: "FlashNode NVMe 1U",
    vendorTier: "enterprise",
    price: 15900,
    maintenancePerMonth: 130,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen5",
      dimmSlots: 12,
      dimmStandard: "ddr5",
      maxRamGb: 3072,
      driveBays: 10,
      driveFormFactors: ["nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 97,
      baseMaxWatt: 382
    },
    factoryParts: [
      { modelKey: "cpu-g5-48c", quantity: 1 },
      { modelKey: "ram-ddr5-64", quantity: 12 },
      { modelKey: "drv-nvme-8192", quantity: 4 },
      { modelKey: "nic-100g", quantity: 1 }
    ],
    lifespanTicks: 24 * 360 * 8,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server"],
    requiresResearch: "res-nvme",
    description: "NVMe-Plattform mit sehr hohem IOPS-Budget f\xFCr Premium-Produkte."
  }),
  assemble({
    key: "srv-gpu-1u",
    name: "AccelNode GPU 1U",
    vendorTier: "enterprise",
    price: 68e3,
    // Die eigentliche Rechnung ist der Strom, nicht der Einkauf – siehe
    // Leistungsaufnahme der GPU-Karten.
    maintenancePerMonth: 420,
    heightUnits: 2,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen5",
      dimmSlots: 8,
      dimmStandard: "ddr5",
      maxRamGb: 2048,
      driveBays: 4,
      driveFormFactors: ["nvme-u2"],
      nicSlots: 2,
      gpuSlots: 4,
      baseIdleWatt: 110,
      baseMaxWatt: 460
    },
    factoryParts: [
      { modelKey: "cpu-g5-48c", quantity: 1 },
      { modelKey: "ram-ddr5-64", quantity: 8 },
      { modelKey: "drv-nvme-8192", quantity: 2 },
      { modelKey: "nic-100g", quantity: 1 },
      { modelKey: "gpu-t2", quantity: 2 }
    ],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky"],
    requiresResearch: "res-ai-compute",
    description: "Zwei Trainingsbeschleuniger ab Werk, zwei weitere Steckpl\xE4tze frei f\xFCr den Ausbau."
  })
];
var SERVER_CHASSIS = [
  assemble({
    key: "chs-eco-1u",
    name: "Barebone EcoNode 1U",
    vendorTier: "budget",
    price: 890,
    maintenancePerMonth: 12,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen3",
      dimmSlots: 4,
      dimmStandard: "ddr4",
      maxRamGb: 128,
      driveBays: 4,
      driveFormFactors: ["sata-2.5"],
      nicSlots: 1,
      baseIdleWatt: 27,
      baseMaxWatt: 49
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "freebsd"],
    requiresResearch: null,
    description: "Einfaches 1-HE-Geh\xE4use: ein Sockel der dritten Generation, vier DIMM, vier SATA-Einsch\xFCbe, ein Erweiterungsslot."
  }),
  assemble({
    key: "chs-mail-2u",
    name: "Barebone MailStore 2U",
    vendorTier: "standard",
    price: 1650,
    maintenancePerMonth: 24,
    heightUnits: 2,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 12,
      driveFormFactors: ["sata-2.5", "sata-3.5"],
      nicSlots: 2,
      baseIdleWatt: 32,
      baseMaxWatt: 88
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky"],
    requiresResearch: null,
    description: "Zw\xF6lf Einsch\xFCbe bei gen\xFCgsamer Plattform \u2013 das Geh\xE4use f\xFCr alles, was Platz braucht und keine Rechenleistung."
  }),
  assemble({
    key: "chs-core-1u",
    name: "Barebone CoreLine 1U",
    vendorTier: "standard",
    price: 2150,
    maintenancePerMonth: 28,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 8,
      driveFormFactors: ["nvme-u2", "sata-2.5"],
      nicSlots: 2,
      baseIdleWatt: 45,
      baseMaxWatt: 126
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 6,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: null,
    description: "Das \xFCbliche Arbeitspferd als leeres Geh\xE4use: acht DIMM, acht Einsch\xFCbe wahlweise NVMe oder SATA."
  }),
  assemble({
    key: "chs-store-4u",
    name: "Barebone BulkStore 4U",
    vendorTier: "standard",
    price: 4200,
    maintenancePerMonth: 55,
    heightUnits: 4,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen4",
      dimmSlots: 8,
      dimmStandard: "ddr4",
      maxRamGb: 512,
      driveBays: 26,
      driveFormFactors: ["sata-3.5", "sata-2.5"],
      nicSlots: 2,
      baseIdleWatt: 55,
      baseMaxWatt: 289
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "freebsd"],
    requiresResearch: null,
    description: "26 Einsch\xFCbe f\xFCr 3,5-Zoll-Platten. Wer Kapazit\xE4t verkauft, baut sie hier zusammen."
  }),
  /*
   * Der Einstieg in zwei Sockel.
   *
   * Dual-Socket bleibt an die Forschung „Dual-Socket-Verdichtung“ gebunden –
   * sie heißt so, weil sie genau das freischaltet. Was sich ändert: Danach gibt
   * es nicht mehr *ein* Gehäuse, sondern eine Klasse. Dieses hier ist die
   * bezahlbare Variante auf der bekannten Gen4-Plattform: gewöhnliche
   * DDR4-Riegel, gewöhnliche Prozessoren, zwölf Einschübe – und trotzdem die
   * doppelte Kernzahl je Höheneinheit.
   */
  assemble({
    key: "chs-dual-2u",
    name: "Barebone TwinCore 2U",
    vendorTier: "standard",
    price: 5200,
    maintenancePerMonth: 70,
    heightUnits: 2,
    platform: {
      cpuSockets: 2,
      cpuSocket: "gen4",
      dimmSlots: 16,
      dimmStandard: "ddr4",
      maxRamGb: 1024,
      driveBays: 12,
      driveFormFactors: ["nvme-u2", "sata-2.5"],
      nicSlots: 2,
      baseIdleWatt: 60,
      baseMaxWatt: 115
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: "res-dense-compute",
    description: "Zwei Gen4-Sockel und sechzehn DIMM-Steckpl\xE4tze auf zwei H\xF6heneinheiten. Der bezahlbare Weg zu hoher Dichte \u2013 mit vertrauter Best\xFCckung."
  }),
  assemble({
    key: "chs-dual-1u",
    name: "Barebone TwinCore 1U",
    vendorTier: "enterprise",
    price: 5900,
    maintenancePerMonth: 82,
    heightUnits: 1,
    platform: {
      cpuSockets: 2,
      cpuSocket: "gen4",
      dimmSlots: 12,
      dimmStandard: "ddr4",
      maxRamGb: 768,
      driveBays: 4,
      driveFormFactors: ["nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 55,
      baseMaxWatt: 105
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server"],
    requiresResearch: "res-dense-compute",
    /*
     * Teurer als das 2U-Gehäuse bei weniger Ausbau: Man bezahlt die
     * Höheneinheit. In einem vollen Rack ist das die richtige Rechnung, in
     * einem halbleeren nicht.
     */
    description: "Zwei Sockel auf einer H\xF6heneinheit, daf\xFCr nur vier Einsch\xFCbe und zw\xF6lf DIMM-Pl\xE4tze. Lohnt sich, wenn Rackplatz knapper ist als Geld."
  }),
  assemble({
    key: "chs-dense-2u",
    name: "Barebone DenseCompute 2U",
    vendorTier: "enterprise",
    price: 7200,
    maintenancePerMonth: 95,
    heightUnits: 2,
    platform: {
      cpuSockets: 2,
      cpuSocket: "gen5",
      dimmSlots: 16,
      dimmStandard: "ddr5",
      maxRamGb: 2048,
      driveBays: 8,
      driveFormFactors: ["nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 67,
      baseMaxWatt: 88
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 7,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server", "freebsd"],
    requiresResearch: "res-dense-compute",
    description: "Zwei Sockel, sechzehn DIMM-Steckpl\xE4tze. Das Geh\xE4use f\xFCr hohe VPS-Dichte \u2013 wenn die K\xFChlung mitspielt."
  }),
  assemble({
    key: "chs-flash-1u",
    name: "Barebone FlashNode 1U",
    vendorTier: "enterprise",
    price: 9900,
    maintenancePerMonth: 130,
    heightUnits: 1,
    platform: {
      cpuSockets: 1,
      cpuSocket: "gen5",
      dimmSlots: 12,
      dimmStandard: "ddr5",
      maxRamGb: 3072,
      driveBays: 10,
      driveFormFactors: ["nvme-u2"],
      nicSlots: 2,
      baseIdleWatt: 97,
      baseMaxWatt: 382
    },
    factoryParts: [],
    lifespanTicks: 24 * 360 * 8,
    supportedOs: ["linux-debian", "linux-ubuntu", "linux-rocky", "windows-server"],
    requiresResearch: "res-nvme",
    description: "Reine NVMe-Plattform mit zw\xF6lf DDR5-Steckpl\xE4tzen. Teuer im Einkauf, unschlagbar bei IOPS je H\xF6heneinheit."
  })
];
var ROUTER_MODELS = [
  {
    key: "rtr-edge-s",
    name: "EdgeRoute S",
    vendorTier: "budget",
    price: 2800,
    maintenancePerMonth: 30,
    heightUnits: 1,
    portCount: 8,
    portSpeedMbps: 1e3,
    forwardingCapacityMbps: 8e3,
    fibCapacity: 4e4,
    maxBgpSessions: 4,
    idleWatt: 60,
    maxWatt: 110,
    lifespanTicks: 24 * 360 * 8,
    requiresResearch: null,
    description: "Einstiegsrouter. Die kleine FIB reicht nicht f\xFCr eine volle Internet-Tabelle."
  },
  {
    key: "rtr-core-m",
    name: "CoreRoute M",
    vendorTier: "standard",
    price: 14e3,
    maintenancePerMonth: 140,
    heightUnits: 1,
    portCount: 24,
    portSpeedMbps: 1e4,
    forwardingCapacityMbps: 24e4,
    fibCapacity: 12e5,
    maxBgpSessions: 32,
    idleWatt: 180,
    maxWatt: 340,
    lifespanTicks: 24 * 360 * 8,
    requiresResearch: null,
    description: "Kann die volle DFZ-Tabelle halten \u2013 Voraussetzung f\xFCr echten Transit."
  },
  {
    key: "rtr-core-l",
    name: "CoreRoute L 100G",
    vendorTier: "enterprise",
    price: 62e3,
    maintenancePerMonth: 620,
    heightUnits: 2,
    portCount: 32,
    portSpeedMbps: 1e5,
    forwardingCapacityMbps: 32e5,
    fibCapacity: 4e6,
    maxBgpSessions: 128,
    idleWatt: 480,
    maxWatt: 1100,
    lifespanTicks: 24 * 360 * 9,
    requiresResearch: "res-100g",
    description: "Backbone-Plattform mit 100G-Ports und gro\xDFer Session-Kapazit\xE4t."
  },
  {
    key: "rtr-core-xl",
    name: "CoreRoute XL 400G",
    vendorTier: "enterprise",
    price: 185e3,
    maintenancePerMonth: 1800,
    heightUnits: 4,
    portCount: 36,
    portSpeedMbps: 4e5,
    forwardingCapacityMbps: 144e5,
    fibCapacity: 8e6,
    maxBgpSessions: 512,
    idleWatt: 900,
    maxWatt: 2400,
    lifespanTicks: 24 * 360 * 9,
    requiresResearch: "res-400g",
    description: "F\xFCr Betreiber mit mehreren Terabit Kapazit\xE4t und vielen Peerings."
  }
];
var SWITCH_MODELS = [
  {
    key: "sw-access-1g",
    name: "AccessSwitch 48\xD71G",
    vendorTier: "budget",
    price: 1600,
    maintenancePerMonth: 16,
    heightUnits: 1,
    portCount: 48,
    portSpeedMbps: 1e3,
    uplinkCount: 4,
    uplinkSpeedMbps: 1e4,
    switchingCapacityMbps: 88e3,
    macTableSize: 16e3,
    layer3: false,
    idleWatt: 55,
    maxWatt: 95,
    lifespanTicks: 24 * 360 * 9,
    requiresResearch: null,
    description: "Klassischer Top-of-Rack-Switch f\xFCr Serveranbindung mit 1G."
  },
  {
    key: "sw-tor-10g",
    name: "ToR 48\xD710G + 6\xD740G",
    vendorTier: "standard",
    price: 7400,
    maintenancePerMonth: 72,
    heightUnits: 1,
    portCount: 48,
    portSpeedMbps: 1e4,
    uplinkCount: 6,
    uplinkSpeedMbps: 4e4,
    switchingCapacityMbps: 72e4,
    macTableSize: 128e3,
    layer3: true,
    idleWatt: 130,
    maxWatt: 240,
    lifespanTicks: 24 * 360 * 9,
    requiresResearch: null,
    description: "Layer-3-f\xE4higer ToR-Switch, erlaubt Routing zwischen VLANs im Rack."
  },
  {
    key: "sw-spine-100g",
    name: "Spine 32\xD7100G",
    vendorTier: "enterprise",
    price: 34e3,
    maintenancePerMonth: 330,
    heightUnits: 1,
    portCount: 32,
    portSpeedMbps: 1e5,
    uplinkCount: 0,
    uplinkSpeedMbps: 0,
    switchingCapacityMbps: 32e5,
    macTableSize: 288e3,
    layer3: true,
    idleWatt: 320,
    maxWatt: 620,
    lifespanTicks: 24 * 360 * 9,
    requiresResearch: "res-100g",
    description: "Spine-Ebene f\xFCr eine Leaf-Spine-Fabric \xFCber mehrere Racks."
  }
];
var FIREWALL_MODELS = [
  {
    key: "fw-small",
    name: "GuardWall 1G",
    vendorTier: "budget",
    price: 2200,
    maintenancePerMonth: 45,
    heightUnits: 1,
    throughputMbps: 1e3,
    sessionCapacity: 25e4,
    scrubbingGbps: 0.5,
    idleWatt: 40,
    maxWatt: 85,
    lifespanTicks: 24 * 360 * 7,
    requiresResearch: null,
    description: "Stateful Firewall f\xFCr kleine Netze mit minimaler DDoS-Abwehr."
  },
  {
    key: "fw-scrub-10g",
    name: "ScrubShield 10G",
    vendorTier: "standard",
    price: 18e3,
    maintenancePerMonth: 260,
    heightUnits: 2,
    throughputMbps: 1e4,
    sessionCapacity: 4e6,
    scrubbingGbps: 10,
    idleWatt: 160,
    maxWatt: 380,
    lifespanTicks: 24 * 360 * 7,
    requiresResearch: null,
    description: "Scrubbing-Appliance, filtert Volumenangriffe bis 10 Gbit/s."
  },
  {
    key: "fw-scrub-100g",
    name: "ScrubShield 100G",
    vendorTier: "enterprise",
    price: 96e3,
    maintenancePerMonth: 1250,
    heightUnits: 3,
    throughputMbps: 1e5,
    sessionCapacity: 4e7,
    scrubbingGbps: 120,
    idleWatt: 620,
    maxWatt: 1400,
    lifespanTicks: 24 * 360 * 7,
    requiresResearch: "res-ddos-scrubbing",
    description: "Tr\xE4gerklasse-Mitigation; h\xE4lt auch gro\xDFen Angriffen stand."
  }
];
var LOADBALANCER_MODELS = [
  {
    key: "lb-soft-1g",
    name: "BalanceNode 1G",
    vendorTier: "budget",
    price: 1900,
    maintenancePerMonth: 22,
    heightUnits: 1,
    throughputMbps: 1e3,
    connectionCapacity: 12e4,
    tlsHandshakesPerSecond: 1500,
    idleWatt: 45,
    maxWatt: 95,
    lifespanTicks: 24 * 360 * 7,
    requiresResearch: null,
    description: "Software-Lastverteiler auf Standardhardware. F\xFCr die ersten Pools v\xF6llig ausreichend, solange TLS auf den Backends bleibt \u2013 die Handshakes bringen ihn schnell an die Grenze."
  },
  {
    key: "lb-adc-10g",
    name: "TrafficDirector 10G",
    vendorTier: "standard",
    price: 16500,
    maintenancePerMonth: 210,
    heightUnits: 1,
    throughputMbps: 1e4,
    connectionCapacity: 2e6,
    tlsHandshakesPerSecond: 28e3,
    idleWatt: 150,
    maxWatt: 330,
    lifespanTicks: 24 * 360 * 7,
    requiresResearch: null,
    description: "Anwendungs-Loadbalancer mit eigener Kryptobeschleunigung. Beendet TLS ohne einzubrechen und tr\xE4gt damit auch Pools, deren Backends nichts mehr davon wissen wollen."
  },
  {
    key: "lb-adc-100g",
    name: "TrafficDirector 100G",
    vendorTier: "enterprise",
    price: 88e3,
    maintenancePerMonth: 1100,
    heightUnits: 2,
    throughputMbps: 1e5,
    connectionCapacity: 24e6,
    tlsHandshakesPerSecond: 24e4,
    idleWatt: 520,
    maxWatt: 1180,
    lifespanTicks: 24 * 360 * 8,
    requiresResearch: "res-100g",
    description: "Tr\xE4gerklasse-Verteiler f\xFCr Plattformen mit vielen tausend gleichzeitigen Sitzungen."
  }
];
var UPS_MODELS = [
  {
    key: "ups-3kw",
    name: "PowerHold 3kW",
    vendorTier: "budget",
    price: 1900,
    maintenancePerMonth: 20,
    heightUnits: 2,
    capacityKwh: 3,
    outputKw: 3,
    idleWatt: 25,
    maxWatt: 60,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "\xDCberbr\xFCckt kurze Netzausf\xE4lle f\xFCr ein einzelnes Rack."
  },
  {
    key: "ups-10kw",
    name: "PowerHold 10kW",
    vendorTier: "standard",
    price: 7200,
    maintenancePerMonth: 68,
    heightUnits: 4,
    capacityKwh: 12,
    outputKw: 10,
    idleWatt: 60,
    maxWatt: 140,
    lifespanTicks: 24 * 360 * 5,
    requiresResearch: null,
    description: "Rack-USV mit ausreichender Laufzeit, bis der Generator anspringt."
  },
  {
    key: "ups-40kw",
    name: "PowerHold 40kW",
    vendorTier: "enterprise",
    price: 26e3,
    maintenancePerMonth: 240,
    heightUnits: 0,
    capacityKwh: 60,
    outputKw: 40,
    idleWatt: 140,
    maxWatt: 320,
    lifespanTicks: 24 * 360 * 6,
    requiresResearch: null,
    central: true,
    description: "Zentrale USV f\xFCr den ganzen Standort \u2013 steht als Zuleitung neben den Racks, nicht in einem von ihnen."
  }
];
var RACK_MODELS = [
  {
    key: "rack-half",
    name: "Halbes Rack (21 HE)",
    units: 21,
    powerBudgetKw: 3,
    monthlyCost: 320,
    setupCost: 250,
    description: "G\xFCnstiger Einstieg; reicht f\xFCr die ersten Server und einen Switch."
  },
  {
    key: "rack-full",
    name: "Volles Rack (42 HE)",
    units: 42,
    powerBudgetKw: 6,
    monthlyCost: 580,
    setupCost: 400,
    description: "Standard-Rack mit 6 kW Anschlussleistung."
  },
  {
    key: "rack-hd",
    name: "High-Density-Rack (47 HE)",
    units: 47,
    powerBudgetKw: 15,
    monthlyCost: 1450,
    setupCost: 900,
    description: "F\xFCr dichte Compute-Nodes; ben\xF6tigt entsprechende K\xFChlung im Standort."
  }
];
var INDEX = new Map(
  [...SERVER_MODELS, ...SERVER_CHASSIS, ...ROUTER_MODELS, ...SWITCH_MODELS, ...FIREWALL_MODELS, ...LOADBALANCER_MODELS, ...UPS_MODELS].map((m) => [
    m.key,
    m
  ])
);
function findModel(key) {
  return INDEX.get(key);
}
function findServerModel(key) {
  return SERVER_MODELS.find((m) => m.key === key) ?? SERVER_CHASSIS.find((m) => m.key === key);
}
function findChassis(key) {
  return SERVER_CHASSIS.find((m) => m.key === key);
}
function findRouterModel(key) {
  return ROUTER_MODELS.find((m) => m.key === key);
}
function findSwitchModel(key) {
  return SWITCH_MODELS.find((m) => m.key === key);
}
function findFirewallModel(key) {
  return FIREWALL_MODELS.find((m) => m.key === key);
}
function findLoadBalancerModel(key) {
  return LOADBALANCER_MODELS.find((m) => m.key === key);
}
function findUpsModel(key) {
  return UPS_MODELS.find((m) => m.key === key);
}
function findRackModel(key) {
  return RACK_MODELS.find((m) => m.key === key);
}
function availableModels(models, completedResearch2) {
  return models.filter((m) => m.requiresResearch === null || completedResearch2.includes(m.requiresResearch));
}

// src/domain/catalog/products.ts
var PRODUCT_TEMPLATES = [
  {
    key: "shared-starter",
    kind: "shared-hosting",
    name: "Webhosting Starter",
    description: "10 GB SSD, 5 Domains, Mailpostf\xE4cher \u2013 Einstiegspaket f\xFCr Privatkunden.",
    referencePrice: 9.9,
    setupPrice: 0,
    resources: { cpuCores: 0.05, ramGb: 0.25, ssdGb: 10, hddGb: 0, trafficMbps: 0.4, includedTrafficGb: 200, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.5,
    demandWeight: 40,
    requiresResearch: null
  },
  {
    key: "shared-business",
    kind: "shared-hosting",
    name: "Webhosting Business",
    description: "100 GB SSD, unbegrenzte Domains, t\xE4gliche Backups.",
    referencePrice: 24.9,
    setupPrice: 0,
    resources: { cpuCores: 0.2, ramGb: 1, ssdGb: 100, hddGb: 0, trafficMbps: 1.5, includedTrafficGb: 1e3, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.9,
    demandWeight: 22,
    requiresResearch: null
  },
  {
    key: "vps-s",
    kind: "vps",
    name: "VPS S",
    description: "2 vCPU, 4 GB RAM, 80 GB NVMe.",
    referencePrice: 15.9,
    setupPrice: 0,
    resources: { cpuCores: 2, ramGb: 4, ssdGb: 80, hddGb: 0, trafficMbps: 3, includedTrafficGb: 4e3, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.9,
    demandWeight: 30,
    requiresResearch: null
  },
  {
    key: "vps-m",
    kind: "vps",
    name: "VPS M",
    description: "4 vCPU, 16 GB RAM, 200 GB NVMe.",
    referencePrice: 29.9,
    setupPrice: 0,
    resources: { cpuCores: 4, ramGb: 16, ssdGb: 200, hddGb: 0, trafficMbps: 8, includedTrafficGb: 1e4, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.9,
    demandWeight: 18,
    requiresResearch: null
  },
  {
    key: "vps-l",
    kind: "vps",
    name: "VPS L",
    description: "8 vCPU, 32 GB RAM, 400 GB NVMe, dedizierte Kerne.",
    referencePrice: 69,
    setupPrice: 0,
    resources: { cpuCores: 8, ramGb: 32, ssdGb: 400, hddGb: 0, trafficMbps: 20, includedTrafficGb: 2e4, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.95,
    demandWeight: 9,
    requiresResearch: null
  },
  {
    key: "dedi-entry",
    kind: "dedicated",
    name: "Dedicated Entry",
    description: "Eigener Server mit 16 Kernen und 128 GB RAM.",
    referencePrice: 139,
    setupPrice: 99,
    resources: { cpuCores: 16, ramGb: 128, ssdGb: 2e3, hddGb: 0, trafficMbps: 60, includedTrafficGb: 6e4, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.9,
    demandWeight: 8,
    requiresResearch: null
  },
  {
    key: "dedi-power",
    kind: "dedicated",
    name: "Dedicated Power",
    description: "Dual-Socket-Server mit 64 Kernen f\xFCr rechenintensive Workloads.",
    referencePrice: 439,
    setupPrice: 199,
    resources: { cpuCores: 64, ramGb: 512, ssdGb: 8e3, hddGb: 0, trafficMbps: 200, includedTrafficGb: 15e4, ipv4Count: 4, ipv6Count: 1 },
    slaUptimePercent: 99.95,
    demandWeight: 3,
    requiresResearch: "res-dense-compute"
  },
  {
    key: "colo-1he",
    kind: "colocation",
    name: "Colocation 1 HE",
    description: "Eine H\xF6heneinheit inklusive 300 W und 1 Gbit/s Anbindung.",
    referencePrice: 79,
    setupPrice: 150,
    resources: { cpuCores: 0, ramGb: 0, ssdGb: 0, hddGb: 0, trafficMbps: 30, includedTrafficGb: 3e4, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.95,
    demandWeight: 6,
    requiresResearch: null
  },
  {
    key: "colo-rack",
    kind: "colocation",
    name: "Colocation Rack",
    description: "Volles Rack mit 6 kW und redundanter Anbindung.",
    referencePrice: 1390,
    setupPrice: 900,
    resources: { cpuCores: 0, ramGb: 0, ssdGb: 0, hddGb: 0, trafficMbps: 400, includedTrafficGb: 4e5, ipv4Count: 16, ipv6Count: 1 },
    slaUptimePercent: 99.98,
    demandWeight: 2,
    requiresResearch: null
  },
  {
    key: "storage-box",
    kind: "storage",
    name: "Storage Box 2 TB",
    description: "Netzwerkspeicher \xFCber SFTP/S3 f\xFCr Backups und Archive.",
    referencePrice: 11.9,
    setupPrice: 0,
    resources: { cpuCores: 0.05, ramGb: 0.2, ssdGb: 0, hddGb: 2e3, trafficMbps: 2, includedTrafficGb: 5e3, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.5,
    demandWeight: 12,
    requiresResearch: null
  },
  {
    key: "backup-managed",
    kind: "backup",
    name: "Managed Backup",
    description: "T\xE4gliche Sicherung mit 30 Tagen Aufbewahrung.",
    referencePrice: 7.9,
    setupPrice: 0,
    resources: { cpuCores: 0.02, ramGb: 0.1, ssdGb: 0, hddGb: 500, trafficMbps: 0.8, includedTrafficGb: 2e3, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.5,
    demandWeight: 10,
    requiresResearch: null
  },
  {
    key: "mail-pro",
    kind: "mail",
    name: "Mailserver Pro",
    description: "25 Postf\xE4cher, Spam- und Virenfilter, eigenes Reverse-DNS.",
    referencePrice: 13.9,
    setupPrice: 0,
    resources: { cpuCores: 0.1, ramGb: 0.5, ssdGb: 50, hddGb: 0, trafficMbps: 0.5, includedTrafficGb: 500, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.9,
    demandWeight: 8,
    requiresResearch: null
  },
  {
    key: "ssl-dv",
    kind: "ssl",
    name: "SSL-Zertifikat DV",
    description: "Domainvalidiertes Zertifikat, j\xE4hrliche Verl\xE4ngerung.",
    referencePrice: 2.5,
    setupPrice: 0,
    resources: { cpuCores: 0, ramGb: 0, ssdGb: 0, hddGb: 0, trafficMbps: 0, includedTrafficGb: 0, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.9,
    demandWeight: 14,
    requiresResearch: null
  },
  {
    key: "domain-de",
    kind: "domain",
    name: "Domain .de",
    description: "Registrierung inklusive DNS-Verwaltung.",
    referencePrice: 0.99,
    setupPrice: 0,
    resources: { cpuCores: 0, ramGb: 0, ssdGb: 0, hddGb: 0, trafficMbps: 0.01, includedTrafficGb: 0, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.99,
    demandWeight: 25,
    requiresResearch: null
  },
  // --- Managed WordPress / One-Click-Apps ------------------------------
  // Reine Katalogvarianten von Shared Hosting: dieselbe Rolle, mehr SSD für
  // Plugins/Uploads, engere SLA – wer CMS-Betrieb verkauft, verspricht mehr.
  {
    key: "wp-starter",
    kind: "shared-hosting",
    name: "Managed WordPress Starter",
    description: "Vorinstalliertes WordPress, automatische Updates, t\xE4gliches Backup.",
    referencePrice: 12.9,
    setupPrice: 0,
    resources: { cpuCores: 0.15, ramGb: 0.5, ssdGb: 20, hddGb: 0, trafficMbps: 0.8, includedTrafficGb: 300, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.7,
    demandWeight: 16,
    requiresResearch: null
  },
  {
    key: "wp-business",
    kind: "shared-hosting",
    name: "Managed WordPress Business",
    description: "Staging-Umgebung, CDN-Anbindung, Ein-Klick-Plugins f\xFCr Shop- und Mitgliederseiten.",
    referencePrice: 34.9,
    setupPrice: 0,
    resources: { cpuCores: 0.5, ramGb: 2, ssdGb: 80, hddGb: 0, trafficMbps: 2.5, includedTrafficGb: 2e3, ipv4Count: 0, ipv6Count: 0 },
    slaUptimePercent: 99.9,
    demandWeight: 9,
    requiresResearch: null
  },
  // --- Game-Server-Hosting -----------------------------------------------
  // Läuft auf derselben Rolle wie VPS, aber mit knapperer Überbuchung
  // (`OVERCOMMIT['game-server']`) – Spiele brauchen gleichmäßige statt
  // spitzenlastige CPU-Leistung.
  {
    key: "game-s",
    kind: "game-server",
    name: "Game Server S",
    description: "4 vCPU (dediziert), 8 GB RAM, f\xFCr Community-Server bis 32 Spieler.",
    referencePrice: 19.9,
    setupPrice: 0,
    resources: { cpuCores: 4, ramGb: 8, ssdGb: 40, hddGb: 0, trafficMbps: 15, includedTrafficGb: 8e3, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.9,
    demandWeight: 14,
    requiresResearch: null
  },
  {
    key: "game-m",
    kind: "game-server",
    name: "Game Server M",
    description: "8 vCPU (dediziert), 16 GB RAM, f\xFCr gro\xDFe Communities und Modding-Server.",
    referencePrice: 44.9,
    setupPrice: 0,
    resources: { cpuCores: 8, ramGb: 16, ssdGb: 100, hddGb: 0, trafficMbps: 40, includedTrafficGb: 2e4, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.9,
    demandWeight: 6,
    requiresResearch: null
  },
  // --- Managed Kubernetes / Container --------------------------------
  // Zahlt die Technikwelle `container-hosting` (trends.ts) mit ein: Der
  // Wechsel von geteiltem Webspace zu eigener Laufzeitumgebung geht hier
  // in ein echtes Produkt über, nicht nur in mehr VPS-Nachfrage.
  {
    key: "k8s-node-s",
    kind: "container",
    name: "Kubernetes Node S",
    description: "Verwalteter Container-Knoten, 2 vCPU/4 GB, Orchestrierung inklusive.",
    referencePrice: 22.9,
    setupPrice: 0,
    resources: { cpuCores: 2, ramGb: 4, ssdGb: 40, hddGb: 0, trafficMbps: 5, includedTrafficGb: 5e3, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.9,
    demandWeight: 11,
    requiresResearch: null
  },
  {
    key: "k8s-node-m",
    kind: "container",
    name: "Kubernetes Node M",
    description: "Verwalteter Container-Knoten, 4 vCPU/16 GB, f\xFCr Produktions-Cluster.",
    referencePrice: 54.9,
    setupPrice: 0,
    resources: { cpuCores: 4, ramGb: 16, ssdGb: 120, hddGb: 0, trafficMbps: 12, includedTrafficGb: 15e3, ipv4Count: 1, ipv6Count: 1 },
    slaUptimePercent: 99.95,
    demandWeight: 5,
    requiresResearch: null
  },
  // --- GPU-Compute (KI-Workloads) -----------------------------------
  // Braucht `res-ai-compute` (research.ts) – GPU-Hosts sind Premium-Hardware,
  // die erst erforscht werden muss, wie schon bei `res-nvme`/`res-dense-compute`.
  {
    key: "gpu-s",
    kind: "gpu-compute",
    name: "GPU Cloud S",
    description: "1x GPU-Beschleuniger, 16 vCPU, 64 GB RAM \u2013 Inferenz und kleinere Trainingsl\xE4ufe.",
    referencePrice: 249,
    setupPrice: 0,
    resources: { cpuCores: 16, ramGb: 64, ssdGb: 500, hddGb: 0, trafficMbps: 20, includedTrafficGb: 1e4, ipv4Count: 1, ipv6Count: 1, gpuCount: 1 },
    slaUptimePercent: 99.5,
    demandWeight: 4,
    requiresResearch: "res-ai-compute"
  },
  {
    key: "gpu-m",
    kind: "gpu-compute",
    name: "GPU Cloud M",
    description: "4x GPU-Beschleuniger im Verbund, 64 vCPU, 256 GB RAM \u2013 f\xFCr Training gro\xDFer Modelle.",
    referencePrice: 899,
    setupPrice: 0,
    resources: { cpuCores: 64, ramGb: 256, ssdGb: 2e3, hddGb: 0, trafficMbps: 50, includedTrafficGb: 3e4, ipv4Count: 1, ipv6Count: 1, gpuCount: 4 },
    slaUptimePercent: 99.5,
    demandWeight: 1,
    requiresResearch: "res-ai-compute"
  }
];
var TLD_COSTS = {
  de: 5.5,
  com: 9.2,
  net: 11.4,
  org: 10.8,
  eu: 6.1,
  io: 32,
  dev: 13.5
};
function findProductTemplate(key) {
  return PRODUCT_TEMPLATES.find((p) => p.key === key);
}

// src/domain/catalog/locations.ts
var KM_PER_UNIT = 4;
var LOCATIONS = [
  {
    key: "loc-fra",
    city: "Frankfurt",
    country: "DE",
    position: { x: 470, y: 430 },
    rackCapacity: 60,
    powerCapacityKw: 900,
    coolingCapacityKw: 800,
    pue: 1.35,
    powerPricePerKwh: 0.45,
    ambientTempC: 20,
    monthlyRent: 4200,
    setupCost: 25e3,
    marketPotential: 1,
    carriers: ["NordFiber", "TransEuro", "MetroLink", "GlobalReach"],
    startingLocation: true,
    description: "Wichtigster Internetknoten der Region. Teuer, aber beste Anbindung."
  },
  {
    key: "loc-ber",
    city: "Berlin",
    country: "DE",
    position: { x: 560, y: 350 },
    rackCapacity: 40,
    powerCapacityKw: 500,
    coolingCapacityKw: 450,
    pue: 1.4,
    powerPricePerKwh: 0.42,
    ambientTempC: 19,
    monthlyRent: 2600,
    setupCost: 16e3,
    marketPotential: 0.75,
    carriers: ["NordFiber", "MetroLink"],
    startingLocation: true,
    description: "G\xFCnstigerer Standort mit solidem Kundenpotenzial."
  },
  {
    key: "loc-ams",
    city: "Amsterdam",
    country: "NL",
    position: { x: 420, y: 330 },
    rackCapacity: 55,
    powerCapacityKw: 800,
    coolingCapacityKw: 720,
    pue: 1.3,
    powerPricePerKwh: 0.38,
    ambientTempC: 18,
    monthlyRent: 3900,
    setupCost: 23e3,
    marketPotential: 0.92,
    carriers: ["TransEuro", "GlobalReach", "SeaCable"],
    startingLocation: true,
    description: "Sehr gute Peering-Dichte und g\xFCnstige Transitpreise."
  },
  {
    key: "loc-par",
    city: "Paris",
    country: "FR",
    position: { x: 350, y: 470 },
    rackCapacity: 48,
    powerCapacityKw: 700,
    coolingCapacityKw: 640,
    pue: 1.38,
    powerPricePerKwh: 0.31,
    ambientTempC: 20,
    monthlyRent: 3400,
    setupCost: 21e3,
    marketPotential: 0.85,
    carriers: ["TransEuro", "MetroLink"],
    startingLocation: false,
    description: "Gro\xDFer Markt, aber st\xE4rkerer Wettbewerb bei Shared Hosting."
  },
  {
    key: "loc-lon",
    city: "London",
    country: "GB",
    position: { x: 300, y: 340 },
    rackCapacity: 52,
    powerCapacityKw: 760,
    coolingCapacityKw: 700,
    pue: 1.36,
    powerPricePerKwh: 0.48,
    ambientTempC: 18,
    monthlyRent: 4600,
    setupCost: 27e3,
    marketPotential: 0.95,
    carriers: ["GlobalReach", "SeaCable", "TransEuro"],
    startingLocation: false,
    description: "Hohe Kosten, daf\xFCr Zugang zu transatlantischen Kapazit\xE4ten."
  },
  {
    key: "loc-vie",
    city: "Wien",
    country: "AT",
    position: { x: 620, y: 500 },
    rackCapacity: 30,
    powerCapacityKw: 380,
    coolingCapacityKw: 340,
    pue: 1.42,
    powerPricePerKwh: 0.4,
    ambientTempC: 20,
    monthlyRent: 2100,
    setupCost: 13e3,
    marketPotential: 0.55,
    carriers: ["MetroLink", "AlpenNet"],
    startingLocation: false,
    description: "Regionaler Standort mit wenig Konkurrenz."
  },
  {
    key: "loc-sto",
    city: "Stockholm",
    country: "SE",
    position: { x: 600, y: 160 },
    rackCapacity: 35,
    powerCapacityKw: 450,
    coolingCapacityKw: 500,
    pue: 1.15,
    powerPricePerKwh: 0.22,
    ambientTempC: 13,
    monthlyRent: 2400,
    setupCost: 15e3,
    marketPotential: 0.5,
    carriers: ["NordFiber", "SeaCable"],
    startingLocation: false,
    description: "Billiger Strom und Freik\xFChlung \u2013 niedrigste Betriebskosten."
  },
  {
    key: "loc-mil",
    city: "Mailand",
    country: "IT",
    position: { x: 470, y: 610 },
    rackCapacity: 34,
    powerCapacityKw: 420,
    coolingCapacityKw: 360,
    pue: 1.48,
    powerPricePerKwh: 0.44,
    ambientTempC: 23,
    monthlyRent: 2500,
    setupCost: 15500,
    marketPotential: 0.62,
    carriers: ["MetroLink", "AlpenNet"],
    startingLocation: false,
    description: "Warmes Klima erh\xF6ht die K\xFChlkosten sp\xFCrbar."
  },
  {
    key: "loc-mad",
    city: "Madrid",
    country: "ES",
    position: { x: 230, y: 650 },
    rackCapacity: 32,
    powerCapacityKw: 400,
    coolingCapacityKw: 340,
    pue: 1.5,
    powerPricePerKwh: 0.35,
    ambientTempC: 25,
    monthlyRent: 2200,
    setupCost: 14e3,
    marketPotential: 0.58,
    carriers: ["TransEuro", "SeaCable"],
    startingLocation: false,
    description: "Wachsender Markt, aber weite Wege zu den zentralen Knoten."
  },
  {
    key: "loc-war",
    city: "Warschau",
    country: "PL",
    position: { x: 690, y: 330 },
    rackCapacity: 28,
    powerCapacityKw: 340,
    coolingCapacityKw: 310,
    pue: 1.44,
    powerPricePerKwh: 0.33,
    ambientTempC: 19,
    monthlyRent: 1700,
    setupCost: 11e3,
    marketPotential: 0.52,
    carriers: ["NordFiber", "MetroLink"],
    startingLocation: false,
    description: "Sehr g\xFCnstige Betriebskosten bei brauchbarem Kundenpotenzial."
  },
  // ---------------------------------------------------------------------------
  // Deutschland
  //
  // Der Heimatmarkt ist bewusst breit: Er erlaubt einen Start abseits von
  // Frankfurt, wo Miete und Strom am höchsten sind. Das Kundenpotenzial fällt
  // dafür deutlich ab – wer billig anfängt, wächst langsamer.
  // ---------------------------------------------------------------------------
  {
    key: "loc-muc",
    city: "M\xFCnchen",
    country: "DE",
    position: { x: 522, y: 485 },
    rackCapacity: 42,
    powerCapacityKw: 560,
    coolingCapacityKw: 500,
    pue: 1.38,
    powerPricePerKwh: 0.43,
    ambientTempC: 20,
    monthlyRent: 3100,
    setupCost: 18e3,
    marketPotential: 0.7,
    carriers: ["MetroLink", "GlobalReach", "AlpenNet"],
    startingLocation: true,
    description: "Zahlungskr\xE4ftige Kundschaft, aber die teuersten Mieten au\xDFerhalb Frankfurts."
  },
  {
    key: "loc-ham",
    city: "Hamburg",
    country: "DE",
    position: { x: 493, y: 335 },
    rackCapacity: 38,
    powerCapacityKw: 480,
    coolingCapacityKw: 430,
    pue: 1.34,
    powerPricePerKwh: 0.41,
    ambientTempC: 18,
    monthlyRent: 2500,
    setupCost: 15e3,
    marketPotential: 0.62,
    carriers: ["NordFiber", "SeaCable"],
    startingLocation: true,
    description: "Seekabel-Anlandungen in der N\xE4he, k\xFChles Klima, solider Mittelstand."
  },
  {
    key: "loc-dus",
    city: "D\xFCsseldorf",
    country: "DE",
    position: { x: 436, y: 399 },
    rackCapacity: 40,
    powerCapacityKw: 520,
    coolingCapacityKw: 470,
    pue: 1.36,
    powerPricePerKwh: 0.42,
    ambientTempC: 20,
    monthlyRent: 2800,
    setupCost: 16500,
    marketPotential: 0.6,
    carriers: ["MetroLink", "GlobalReach"],
    startingLocation: true,
    description: "Dichtes Ballungsgebiet mit kurzen Wegen nach Frankfurt und Amsterdam."
  },
  {
    key: "loc-cgn",
    city: "K\xF6ln",
    country: "DE",
    position: { x: 439, y: 407 },
    rackCapacity: 34,
    powerCapacityKw: 430,
    coolingCapacityKw: 390,
    pue: 1.38,
    powerPricePerKwh: 0.42,
    ambientTempC: 20,
    monthlyRent: 2300,
    setupCost: 14e3,
    marketPotential: 0.55,
    carriers: ["MetroLink", "TransEuro"],
    startingLocation: true,
    description: "Medienstandort mit stetiger Nachfrage nach Auslieferungskapazit\xE4t."
  },
  {
    key: "loc-str",
    city: "Stuttgart",
    country: "DE",
    position: { x: 479, y: 467 },
    rackCapacity: 30,
    powerCapacityKw: 380,
    coolingCapacityKw: 340,
    pue: 1.39,
    powerPricePerKwh: 0.43,
    ambientTempC: 20,
    monthlyRent: 2100,
    setupCost: 13e3,
    marketPotential: 0.5,
    carriers: ["MetroLink", "AlpenNet"],
    startingLocation: true,
    description: "Industrienahe Kundschaft mit hohen Anspr\xFCchen an Verf\xFCgbarkeit."
  },
  {
    key: "loc-nue",
    city: "N\xFCrnberg",
    country: "DE",
    position: { x: 513, y: 448 },
    rackCapacity: 28,
    powerCapacityKw: 360,
    coolingCapacityKw: 320,
    pue: 1.37,
    powerPricePerKwh: 0.42,
    ambientTempC: 19,
    monthlyRent: 1900,
    setupCost: 12e3,
    marketPotential: 0.42,
    carriers: ["MetroLink", "NordFiber"],
    startingLocation: true,
    description: "Gut angebunden, g\xFCnstig, seit jeher beliebt bei Massenhostern."
  },
  {
    key: "loc-han",
    city: "Hannover",
    country: "DE",
    position: { x: 489, y: 367 },
    rackCapacity: 26,
    powerCapacityKw: 320,
    coolingCapacityKw: 290,
    pue: 1.38,
    powerPricePerKwh: 0.4,
    ambientTempC: 19,
    monthlyRent: 1700,
    setupCost: 11e3,
    marketPotential: 0.4,
    carriers: ["NordFiber", "MetroLink"],
    startingLocation: true,
    description: "Unauff\xE4llig, zentral gelegen und billig \u2013 ein solider Zweitstandort."
  },
  {
    key: "loc-lej",
    city: "Leipzig",
    country: "DE",
    position: { x: 536, y: 396 },
    rackCapacity: 30,
    powerCapacityKw: 400,
    coolingCapacityKw: 360,
    pue: 1.36,
    powerPricePerKwh: 0.39,
    ambientTempC: 19,
    monthlyRent: 1800,
    setupCost: 11500,
    marketPotential: 0.38,
    carriers: ["NordFiber", "MetroLink"],
    startingLocation: true,
    description: "Viel Windstrom in der Region und entsprechend g\xFCnstige Arbeitspreise."
  },
  {
    key: "loc-fsn",
    city: "Falkenstein",
    country: "DE",
    position: { x: 536, y: 420 },
    rackCapacity: 34,
    powerCapacityKw: 460,
    coolingCapacityKw: 420,
    pue: 1.28,
    powerPricePerKwh: 0.37,
    ambientTempC: 18,
    monthlyRent: 1500,
    setupCost: 9500,
    marketPotential: 0.2,
    carriers: ["NordFiber", "MetroLink"],
    startingLocation: true,
    description: "L\xE4ndlich, spottbillig, k\xFChl \u2013 aber vor Ort gibt es praktisch keine Kundschaft."
  },
  {
    key: "loc-fkb",
    city: "Karlsruhe",
    country: "DE",
    position: { x: 465, y: 461 },
    rackCapacity: 24,
    powerCapacityKw: 300,
    coolingCapacityKw: 270,
    pue: 1.37,
    powerPricePerKwh: 0.42,
    ambientTempC: 20,
    monthlyRent: 1600,
    setupCost: 1e4,
    marketPotential: 0.35,
    carriers: ["MetroLink", "TransEuro"],
    startingLocation: true,
    description: "Forschungsnahe Region, kurze Wege nach Frankfurt und Stra\xDFburg."
  },
  {
    key: "loc-scn",
    city: "Saarbr\xFCcken",
    country: "DE",
    position: { x: 440, y: 454 },
    rackCapacity: 20,
    powerCapacityKw: 250,
    coolingCapacityKw: 225,
    pue: 1.4,
    powerPricePerKwh: 0.4,
    ambientTempC: 20,
    monthlyRent: 1200,
    setupCost: 8e3,
    marketPotential: 0.28,
    carriers: ["MetroLink", "TransEuro"],
    startingLocation: true,
    description: "Kleiner Markt an der franz\xF6sischen Grenze, daf\xFCr der g\xFCnstigste Einstieg."
  },
  // ---------------------------------------------------------------------------
  // Nahes Ausland
  //
  // Die Spanne ist hier am größten: Norwegen und Finnland liefern Strom zum
  // Bruchteil der deutschen Preise, Irland und die Schweiz verlangen dafür
  // Mieten weit über dem Durchschnitt.
  // ---------------------------------------------------------------------------
  {
    key: "loc-eyg",
    city: "Eygelshoven",
    country: "NL",
    position: { x: 423, y: 408 },
    rackCapacity: 26,
    powerCapacityKw: 340,
    coolingCapacityKw: 310,
    pue: 1.3,
    powerPricePerKwh: 0.36,
    ambientTempC: 18,
    monthlyRent: 1500,
    setupCost: 9500,
    marketPotential: 0.25,
    carriers: ["SeaCable", "TransEuro"],
    startingLocation: true,
    description: "Ehemaliges Zechengel\xE4nde im Dreil\xE4ndereck: billige Fl\xE4che, kurze Wege nach Amsterdam."
  },
  {
    key: "loc-zrh",
    city: "Z\xFCrich",
    country: "CH",
    position: { x: 468, y: 506 },
    rackCapacity: 30,
    powerCapacityKw: 380,
    coolingCapacityKw: 340,
    pue: 1.32,
    powerPricePerKwh: 0.29,
    ambientTempC: 18,
    monthlyRent: 3400,
    setupCost: 2e4,
    marketPotential: 0.6,
    carriers: ["AlpenNet", "GlobalReach", "MetroLink"],
    startingLocation: false,
    description: "Wasserkraft macht den Strom g\xFCnstig, die Miete frisst den Vorteil wieder auf."
  },
  {
    key: "loc-prg",
    city: "Prag",
    country: "CZ",
    position: { x: 573, y: 431 },
    rackCapacity: 26,
    powerCapacityKw: 330,
    coolingCapacityKw: 300,
    pue: 1.42,
    powerPricePerKwh: 0.34,
    ambientTempC: 19,
    monthlyRent: 1500,
    setupCost: 9500,
    marketPotential: 0.44,
    carriers: ["MetroLink", "TransEuro"],
    startingLocation: false,
    description: "G\xFCnstige Betriebskosten in Reichweite der mitteleurop\xE4ischen Knoten."
  },
  {
    key: "loc-cph",
    city: "Kopenhagen",
    country: "DK",
    position: { x: 539, y: 275 },
    rackCapacity: 24,
    powerCapacityKw: 300,
    coolingCapacityKw: 330,
    pue: 1.25,
    powerPricePerKwh: 0.37,
    ambientTempC: 15,
    monthlyRent: 2200,
    setupCost: 13e3,
    marketPotential: 0.45,
    carriers: ["NordFiber", "SeaCable"],
    startingLocation: false,
    description: "Viel Freik\xFChlung und ein Netz, das nach Skandinavien hin gut ausgebaut ist."
  },
  {
    key: "loc-bru",
    city: "Br\xFCssel",
    country: "BE",
    position: { x: 393, y: 409 },
    rackCapacity: 28,
    powerCapacityKw: 350,
    coolingCapacityKw: 315,
    pue: 1.36,
    powerPricePerKwh: 0.39,
    ambientTempC: 19,
    monthlyRent: 2400,
    setupCost: 14500,
    marketPotential: 0.5,
    carriers: ["TransEuro", "SeaCable"],
    startingLocation: false,
    description: "Beh\xF6rden und Verb\xE4nde als Kundschaft \u2013 anspruchsvoll, aber zahlungskr\xE4ftig."
  },
  {
    key: "loc-lux",
    city: "Luxemburg",
    country: "LU",
    position: { x: 425, y: 444 },
    rackCapacity: 22,
    powerCapacityKw: 280,
    coolingCapacityKw: 250,
    pue: 1.31,
    powerPricePerKwh: 0.38,
    ambientTempC: 19,
    monthlyRent: 2600,
    setupCost: 15500,
    marketPotential: 0.3,
    carriers: ["TransEuro", "MetroLink"],
    startingLocation: true,
    description: "Kleiner Markt, aber Finanzkunden mit hohen Anforderungen und Budgets."
  },
  {
    key: "loc-sxb",
    city: "Stra\xDFburg",
    country: "FR",
    position: { x: 453, y: 473 },
    rackCapacity: 20,
    powerCapacityKw: 250,
    coolingCapacityKw: 225,
    pue: 1.36,
    powerPricePerKwh: 0.31,
    ambientTempC: 19,
    monthlyRent: 1400,
    setupCost: 9e3,
    marketPotential: 0.3,
    carriers: ["TransEuro", "MetroLink"],
    startingLocation: true,
    description: "Franz\xF6sischer Atomstrom zum Grenzpreis, eine Stunde von Karlsruhe entfernt."
  },
  {
    key: "loc-rbx",
    city: "Roubaix",
    country: "FR",
    position: { x: 372, y: 414 },
    rackCapacity: 32,
    powerCapacityKw: 420,
    coolingCapacityKw: 380,
    pue: 1.3,
    powerPricePerKwh: 0.3,
    ambientTempC: 17,
    monthlyRent: 1600,
    setupCost: 10500,
    marketPotential: 0.35,
    carriers: ["TransEuro", "SeaCable"],
    startingLocation: false,
    description: "Klassischer Massenhosting-Standort: viel Fl\xE4che, wenig Miete, kurzer Weg nach Paris."
  },
  {
    key: "loc-grv",
    city: "Gravelines",
    country: "FR",
    position: { x: 353, y: 406 },
    rackCapacity: 36,
    powerCapacityKw: 520,
    coolingCapacityKw: 480,
    pue: 1.22,
    powerPricePerKwh: 0.29,
    ambientTempC: 15,
    monthlyRent: 1500,
    setupCost: 1e4,
    marketPotential: 0.22,
    carriers: ["TransEuro", "SeaCable"],
    startingLocation: false,
    description: "Kernkraftwerk vor der T\xFCr, Meerwasserk\xFChlung, kaum lokale Nachfrage."
  },
  {
    key: "loc-osl",
    city: "Oslo",
    country: "NO",
    position: { x: 507, y: 158 },
    rackCapacity: 28,
    powerCapacityKw: 380,
    coolingCapacityKw: 420,
    pue: 1.18,
    powerPricePerKwh: 0.16,
    ambientTempC: 12,
    monthlyRent: 2e3,
    setupCost: 13e3,
    marketPotential: 0.35,
    carriers: ["NordFiber", "SeaCable"],
    startingLocation: false,
    description: "Wasserkraft und K\xE4lte ergeben die niedrigsten Energiekosten Europas."
  },
  {
    key: "loc-hel",
    city: "Helsinki",
    country: "FI",
    position: { x: 760, y: 151 },
    rackCapacity: 26,
    powerCapacityKw: 350,
    coolingCapacityKw: 390,
    pue: 1.16,
    powerPricePerKwh: 0.2,
    ambientTempC: 11,
    monthlyRent: 1800,
    setupCost: 12e3,
    marketPotential: 0.33,
    carriers: ["NordFiber", "SeaCable"],
    startingLocation: false,
    description: "Abw\xE4rme l\xE4sst sich ins Fernw\xE4rmenetz verkaufen \u2013 daf\xFCr ist der Weg zur\xFCck weit."
  },
  {
    key: "loc-dub",
    city: "Dublin",
    country: "IE",
    position: { x: 204, y: 340 },
    rackCapacity: 30,
    powerCapacityKw: 380,
    coolingCapacityKw: 340,
    pue: 1.3,
    powerPricePerKwh: 0.46,
    ambientTempC: 15,
    monthlyRent: 2800,
    setupCost: 17e3,
    marketPotential: 0.5,
    carriers: ["SeaCable", "AtlanticBridge", "GlobalReach"],
    startingLocation: false,
    description: "Br\xFCckenkopf zwischen Europa und Nordamerika \u2013 mit den Strompreisen, die dazugeh\xF6ren."
  },
  // ---------------------------------------------------------------------------
  // Nordamerika
  //
  // Der Sprung über den Atlantik kostet Latenz: Selbst Ashburn liegt 92 ms von
  // Frankfurt entfernt. Wer dort baut, braucht eigene Transitverträge vor Ort –
  // europäische Kundschaft über eine solche Strecke zu bedienen, geht schief.
  //
  // Strom ist durchweg günstiger als in Europa, Kühlung dafür oft teurer: In
  // Phoenix und Miami frisst die Außentemperatur einen Teil des Vorteils wieder
  // auf.
  // ---------------------------------------------------------------------------
  {
    key: "loc-iad",
    city: "Ashburn",
    country: "US",
    position: { x: -1151, y: 737 },
    rackCapacity: 70,
    powerCapacityKw: 1100,
    coolingCapacityKw: 990,
    pue: 1.32,
    powerPricePerKwh: 0.19,
    ambientTempC: 23,
    monthlyRent: 4600,
    setupCost: 3e4,
    marketPotential: 0.9,
    carriers: ["AmeriCore", "GlobalReach", "AtlanticBridge"],
    startingLocation: false,
    description: "Die dichteste Rechenzentrumslandschaft der Welt. Billiger Strom, harte Konkurrenz."
  },
  {
    key: "loc-nyc",
    city: "New York",
    country: "US",
    position: { x: -1075, y: 691 },
    rackCapacity: 45,
    powerCapacityKw: 620,
    coolingCapacityKw: 560,
    pue: 1.42,
    powerPricePerKwh: 0.27,
    ambientTempC: 22,
    monthlyRent: 5200,
    setupCost: 34e3,
    marketPotential: 0.95,
    carriers: ["AmeriCore", "AtlanticBridge", "GlobalReach"],
    startingLocation: false,
    description: "Gr\xF6\xDFter Einzelmarkt und teuerste Fl\xE4che \u2013 Platz ist auf der Insel knapp."
  },
  {
    key: "loc-ord",
    city: "Chicago",
    country: "US",
    position: { x: -1373, y: 658 },
    rackCapacity: 48,
    powerCapacityKw: 680,
    coolingCapacityKw: 610,
    pue: 1.36,
    powerPricePerKwh: 0.2,
    ambientTempC: 20,
    monthlyRent: 3200,
    setupCost: 21e3,
    marketPotential: 0.8,
    carriers: ["AmeriCore", "PacificWave"],
    startingLocation: false,
    description: "Knotenpunkt des Mittleren Westens mit ausgeglichenen Kosten."
  },
  {
    key: "loc-dfw",
    city: "Dallas",
    country: "US",
    position: { x: -1573, y: 911 },
    rackCapacity: 46,
    powerCapacityKw: 660,
    coolingCapacityKw: 620,
    pue: 1.48,
    powerPricePerKwh: 0.16,
    ambientTempC: 26,
    monthlyRent: 2600,
    setupCost: 18e3,
    marketPotential: 0.7,
    carriers: ["AmeriCore", "PacificWave"],
    startingLocation: false,
    description: "Sehr billiger Strom aus einem eigenen Netz \u2013 das im Winter schon ausgefallen ist."
  },
  {
    key: "loc-atl",
    city: "Atlanta",
    country: "US",
    position: { x: -1302, y: 884 },
    rackCapacity: 38,
    powerCapacityKw: 520,
    coolingCapacityKw: 480,
    pue: 1.45,
    powerPricePerKwh: 0.18,
    ambientTempC: 24,
    monthlyRent: 2400,
    setupCost: 16e3,
    marketPotential: 0.6,
    carriers: ["AmeriCore", "AtlanticBridge"],
    startingLocation: false,
    description: "G\xFCnstiger S\xFCden mit guter Anbindung, aber schw\xFCler Sommer."
  },
  {
    key: "loc-lax",
    city: "Los Angeles",
    country: "US",
    position: { x: -2042, y: 876 },
    rackCapacity: 42,
    powerCapacityKw: 580,
    coolingCapacityKw: 540,
    pue: 1.4,
    powerPricePerKwh: 0.31,
    ambientTempC: 22,
    monthlyRent: 4400,
    setupCost: 28e3,
    marketPotential: 0.85,
    carriers: ["PacificWave", "AmeriCore", "GlobalReach"],
    startingLocation: false,
    description: "Tor zum Pazifik. Der teuerste Strom des Landes, aber ein riesiger Markt."
  },
  {
    key: "loc-sea",
    city: "Seattle",
    country: "US",
    position: { x: -2132, y: 499 },
    rackCapacity: 34,
    powerCapacityKw: 470,
    coolingCapacityKw: 420,
    pue: 1.2,
    powerPricePerKwh: 0.14,
    ambientTempC: 15,
    monthlyRent: 2700,
    setupCost: 18e3,
    marketPotential: 0.6,
    carriers: ["PacificWave", "AmeriCore"],
    startingLocation: false,
    description: "Wasserkraft und mildes Klima: der g\xFCnstigste Betrieb in ganz Nordamerika."
  },
  {
    key: "loc-mia",
    city: "Miami",
    country: "US",
    position: { x: -1210, y: 1106 },
    rackCapacity: 32,
    powerCapacityKw: 440,
    coolingCapacityKw: 420,
    pue: 1.52,
    powerPricePerKwh: 0.21,
    ambientTempC: 28,
    monthlyRent: 2900,
    setupCost: 19e3,
    marketPotential: 0.55,
    carriers: ["AmeriCore", "AtlanticBridge"],
    startingLocation: false,
    description: "Umschlagplatz nach Lateinamerika. Dauerhaft warm und in der Wirbelsturmzone."
  },
  {
    key: "loc-phx",
    city: "Phoenix",
    country: "US",
    position: { x: -1907, y: 892 },
    rackCapacity: 40,
    powerCapacityKw: 600,
    coolingCapacityKw: 580,
    pue: 1.55,
    powerPricePerKwh: 0.17,
    ambientTempC: 30,
    monthlyRent: 2300,
    setupCost: 16e3,
    marketPotential: 0.45,
    carriers: ["PacificWave", "AmeriCore"],
    startingLocation: false,
    description: "Billiger Strom in der W\xFCste \u2013 von dem die K\xFChlung einen guten Teil zur\xFCckholt."
  }
];
var IXP_TEMPLATES = [
  { key: "ix-fra", name: "FRA-IX", city: "Frankfurt", position: { x: 470, y: 430 }, portFeePerGbps: 65, setupFee: 1500, memberCount: 1050, trafficCoverage: 0.42, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-ams", name: "AMS-IX", city: "Amsterdam", position: { x: 420, y: 330 }, portFeePerGbps: 58, setupFee: 1400, memberCount: 890, trafficCoverage: 0.38, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-lon", name: "LON-IX", city: "London", position: { x: 300, y: 340 }, portFeePerGbps: 72, setupFee: 1800, memberCount: 820, trafficCoverage: 0.34, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-par", name: "PAR-IX", city: "Paris", position: { x: 350, y: 470 }, portFeePerGbps: 61, setupFee: 1300, memberCount: 540, trafficCoverage: 0.24, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-ber", name: "BER-IX", city: "Berlin", position: { x: 560, y: 350 }, portFeePerGbps: 40, setupFee: 700, memberCount: 210, trafficCoverage: 0.11, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-vie", name: "VIE-IX", city: "Wien", position: { x: 620, y: 500 }, portFeePerGbps: 44, setupFee: 800, memberCount: 180, trafficCoverage: 0.09, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-sto", name: "STO-IX", city: "Stockholm", position: { x: 600, y: 160 }, portFeePerGbps: 38, setupFee: 650, memberCount: 160, trafficCoverage: 0.08, routeServer: { available: false, requiresRpki: false } },
  { key: "ix-mil", name: "MIL-IX", city: "Mailand", position: { x: 470, y: 610 }, portFeePerGbps: 42, setupFee: 750, memberCount: 190, trafficCoverage: 0.1, routeServer: { available: false, requiresRpki: false } },
  // Deutschland und nahes Ausland. Regionale Knoten sind billig, decken aber
  // wenig Verkehr ab – sie lohnen sich erst, wenn man ohnehin vor Ort steht.
  { key: "ix-dus", name: "DUS-IX", city: "D\xFCsseldorf", position: { x: 436, y: 399 }, portFeePerGbps: 43, setupFee: 780, memberCount: 230, trafficCoverage: 0.12, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-muc", name: "MUC-IX", city: "M\xFCnchen", position: { x: 522, y: 485 }, portFeePerGbps: 45, setupFee: 820, memberCount: 200, trafficCoverage: 0.1, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-ham", name: "HAM-IX", city: "Hamburg", position: { x: 493, y: 335 }, portFeePerGbps: 41, setupFee: 720, memberCount: 170, trafficCoverage: 0.09, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-lej", name: "LEJ-IX", city: "Leipzig", position: { x: 536, y: 396 }, portFeePerGbps: 34, setupFee: 520, memberCount: 90, trafficCoverage: 0.05, routeServer: { available: false, requiresRpki: false } },
  { key: "ix-prg", name: "PRG-IX", city: "Prag", position: { x: 573, y: 431 }, portFeePerGbps: 36, setupFee: 600, memberCount: 140, trafficCoverage: 0.07, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-cph", name: "CPH-IX", city: "Kopenhagen", position: { x: 539, y: 275 }, portFeePerGbps: 39, setupFee: 660, memberCount: 130, trafficCoverage: 0.07, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-bru", name: "BRU-IX", city: "Br\xFCssel", position: { x: 393, y: 409 }, portFeePerGbps: 43, setupFee: 740, memberCount: 150, trafficCoverage: 0.08, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-zrh", name: "ZRH-IX", city: "Z\xFCrich", position: { x: 468, y: 506 }, portFeePerGbps: 48, setupFee: 900, memberCount: 160, trafficCoverage: 0.08, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-dub", name: "DUB-IX", city: "Dublin", position: { x: 204, y: 340 }, portFeePerGbps: 46, setupFee: 820, memberCount: 120, trafficCoverage: 0.06, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-osl", name: "OSL-IX", city: "Oslo", position: { x: 507, y: 158 }, portFeePerGbps: 33, setupFee: 500, memberCount: 85, trafficCoverage: 0.04, routeServer: { available: false, requiresRpki: false } },
  { key: "ix-hel", name: "HEL-IX", city: "Helsinki", position: { x: 760, y: 151 }, portFeePerGbps: 32, setupFee: 480, memberCount: 80, trafficCoverage: 0.04, routeServer: { available: false, requiresRpki: false } },
  // Nordamerika. Die Deckung zählt getrennt: Ein US-Knoten bringt keinen
  // europäischen Verkehr ans Netz und umgekehrt.
  { key: "ix-iad", name: "IAD-IX", city: "Ashburn", position: { x: -1151, y: 737 }, portFeePerGbps: 52, setupFee: 1300, memberCount: 760, trafficCoverage: 0.36, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-nyc", name: "NYC-IX", city: "New York", position: { x: -1075, y: 691 }, portFeePerGbps: 60, setupFee: 1500, memberCount: 620, trafficCoverage: 0.29, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-ord", name: "CHI-IX", city: "Chicago", position: { x: -1373, y: 658 }, portFeePerGbps: 47, setupFee: 1e3, memberCount: 380, trafficCoverage: 0.19, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-lax", name: "LAX-IX", city: "Los Angeles", position: { x: -2042, y: 876 }, portFeePerGbps: 55, setupFee: 1200, memberCount: 420, trafficCoverage: 0.21, routeServer: { available: true, requiresRpki: true } },
  { key: "ix-sea", name: "SEA-IX", city: "Seattle", position: { x: -2132, y: 499 }, portFeePerGbps: 44, setupFee: 900, memberCount: 260, trafficCoverage: 0.13, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-dfw", name: "DFW-IX", city: "Dallas", position: { x: -1573, y: 911 }, portFeePerGbps: 45, setupFee: 950, memberCount: 290, trafficCoverage: 0.15, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-atl", name: "ATL-IX", city: "Atlanta", position: { x: -1302, y: 884 }, portFeePerGbps: 42, setupFee: 850, memberCount: 210, trafficCoverage: 0.11, routeServer: { available: true, requiresRpki: false } },
  { key: "ix-mia", name: "MIA-IX", city: "Miami", position: { x: -1210, y: 1106 }, portFeePerGbps: 46, setupFee: 950, memberCount: 240, trafficCoverage: 0.12, routeServer: { available: true, requiresRpki: false } }
];
var PROVIDER_TEMPLATES = [
  { asn: 64500, name: "GlobalReach Networks", kind: "tier1", transitPricePerMbps: 0.42, reach: 1, peeringWillingness: 0.02, ixpKeys: ["ix-fra", "ix-ams", "ix-lon", "ix-iad", "ix-nyc"], cities: ["Frankfurt", "Amsterdam", "London", "D\xFCsseldorf", "M\xFCnchen", "Z\xFCrich", "Dublin", "Ashburn", "New York", "Los Angeles"], peeringPolicy: "restrictive", maxRatio: 1.5, requiresRpki: true, minTrafficMbps: 1e5, atRouteServer: false },
  { asn: 64501, name: "TransEuro Carrier", kind: "tier1", transitPricePerMbps: 0.38, reach: 0.99, peeringWillingness: 0.03, ixpKeys: ["ix-fra", "ix-ams", "ix-par", "ix-bru"], cities: ["Frankfurt", "Amsterdam", "Paris", "Madrid", "Br\xFCssel", "Roubaix", "Gravelines", "Stra\xDFburg", "Luxemburg", "Eygelshoven", "Prag", "K\xF6ln", "Karlsruhe", "Saarbr\xFCcken"], peeringPolicy: "restrictive", maxRatio: 1.5, requiresRpki: true, minTrafficMbps: 1e5, atRouteServer: false },
  { asn: 64502, name: "NordFiber", kind: "tier2", transitPricePerMbps: 0.24, reach: 0.94, peeringWillingness: 0.35, ixpKeys: ["ix-fra", "ix-ber", "ix-sto", "ix-ham", "ix-cph", "ix-osl", "ix-hel"], cities: ["Frankfurt", "Berlin", "Stockholm", "Warschau", "Hamburg", "Hannover", "Leipzig", "Falkenstein", "N\xFCrnberg", "Kopenhagen", "Oslo", "Helsinki"], peeringPolicy: "selective", maxRatio: 2.5, requiresRpki: true, minTrafficMbps: 2e3, atRouteServer: true },
  { asn: 64503, name: "MetroLink", kind: "tier2", transitPricePerMbps: 0.21, reach: 0.9, peeringWillingness: 0.45, ixpKeys: ["ix-fra", "ix-ber", "ix-vie", "ix-mil", "ix-dus", "ix-muc", "ix-lej", "ix-prg"], cities: ["Frankfurt", "Berlin", "Wien", "Mailand", "Warschau", "M\xFCnchen", "N\xFCrnberg", "Stuttgart", "Karlsruhe", "Saarbr\xFCcken", "K\xF6ln", "D\xFCsseldorf", "Prag", "Z\xFCrich", "Luxemburg", "Stra\xDFburg", "Falkenstein", "Leipzig", "Hannover"], peeringPolicy: "selective", maxRatio: 2.5, requiresRpki: true, minTrafficMbps: 2e3, atRouteServer: true },
  { asn: 64504, name: "SeaCable Transit", kind: "tier2", transitPricePerMbps: 0.27, reach: 0.92, peeringWillingness: 0.3, ixpKeys: ["ix-ams", "ix-lon", "ix-ham", "ix-cph", "ix-dub"], cities: ["Amsterdam", "London", "Stockholm", "Madrid", "Dublin", "Roubaix", "Gravelines", "Br\xFCssel", "Eygelshoven", "Kopenhagen", "Hamburg", "Oslo", "Helsinki"], peeringPolicy: "selective", maxRatio: 2.5, requiresRpki: true, minTrafficMbps: 2e3, atRouteServer: true },
  { asn: 64505, name: "AlpenNet", kind: "tier2", transitPricePerMbps: 0.26, reach: 0.88, peeringWillingness: 0.4, ixpKeys: ["ix-vie", "ix-mil", "ix-muc", "ix-zrh"], cities: ["Wien", "Mailand", "Z\xFCrich", "M\xFCnchen", "Stuttgart"], peeringPolicy: "selective", maxRatio: 2.5, requiresRpki: false, minTrafficMbps: 1500, atRouteServer: true },
  // Nordamerika. Ohne diese drei wären die US-Standorte zwar baubar, aber ohne
  // Transitanbieter vor Ort nicht ans Netz zu bringen.
  { asn: 64506, name: "AmeriCore Backbone", kind: "tier1", transitPricePerMbps: 0.3, reach: 0.99, peeringWillingness: 0.03, ixpKeys: ["ix-iad", "ix-nyc", "ix-ord", "ix-lax", "ix-dfw", "ix-atl"], cities: ["Ashburn", "New York", "Chicago", "Dallas", "Atlanta", "Los Angeles", "Seattle", "Miami", "Phoenix", "Frankfurt", "London"], peeringPolicy: "restrictive", maxRatio: 1.5, requiresRpki: true, minTrafficMbps: 1e5, atRouteServer: false },
  { asn: 64507, name: "PacificWave Transit", kind: "tier2", transitPricePerMbps: 0.19, reach: 0.9, peeringWillingness: 0.4, ixpKeys: ["ix-lax", "ix-sea", "ix-ord", "ix-dfw"], cities: ["Los Angeles", "Seattle", "Phoenix", "Dallas", "Chicago"], peeringPolicy: "selective", maxRatio: 2.5, requiresRpki: true, minTrafficMbps: 2e3, atRouteServer: true },
  { asn: 64508, name: "AtlanticBridge", kind: "tier2", transitPricePerMbps: 0.26, reach: 0.93, peeringWillingness: 0.32, ixpKeys: ["ix-ams", "ix-lon", "ix-dub", "ix-nyc", "ix-iad", "ix-mia"], cities: ["Amsterdam", "London", "Frankfurt", "Dublin", "New York", "Ashburn", "Miami", "Atlanta"], peeringPolicy: "selective", maxRatio: 2.5, requiresRpki: true, minTrafficMbps: 2e3, atRouteServer: true },
  { asn: 64510, name: "StreamCast Media", kind: "content", transitPricePerMbps: 0, reach: 0.22, peeringWillingness: 0.9, ixpKeys: ["ix-fra", "ix-ams", "ix-lon", "ix-par", "ix-iad", "ix-nyc", "ix-lax"], cities: ["Frankfurt", "Amsterdam", "London", "Paris", "Ashburn", "New York", "Los Angeles"], peeringPolicy: "open", maxRatio: 12, requiresRpki: true, minTrafficMbps: 100, atRouteServer: true },
  { asn: 64511, name: "CloudEdge CDN", kind: "content", transitPricePerMbps: 0, reach: 0.18, peeringWillingness: 0.95, ixpKeys: ["ix-fra", "ix-ams", "ix-ber", "ix-vie", "ix-mil", "ix-sto", "ix-dus", "ix-muc", "ix-ham", "ix-prg", "ix-zrh", "ix-iad", "ix-ord", "ix-dfw", "ix-sea"], cities: ["Frankfurt", "Amsterdam", "Berlin", "Wien", "D\xFCsseldorf", "M\xFCnchen", "Hamburg", "Ashburn", "Chicago", "Seattle"], peeringPolicy: "open", maxRatio: 12, requiresRpki: true, minTrafficMbps: 100, atRouteServer: true },
  { asn: 64512, name: "SocialNet Inc", kind: "content", transitPricePerMbps: 0, reach: 0.14, peeringWillingness: 0.85, ixpKeys: ["ix-fra", "ix-ams", "ix-lon", "ix-iad", "ix-ord"], cities: ["Frankfurt", "Amsterdam", "London", "Ashburn", "Chicago"], peeringPolicy: "open", maxRatio: 12, requiresRpki: true, minTrafficMbps: 100, atRouteServer: true },
  { asn: 64520, name: "Telekomm Access", kind: "eyeball", transitPricePerMbps: 0, reach: 0.16, peeringWillingness: 0.12, ixpKeys: ["ix-fra", "ix-ber", "ix-dus", "ix-ham"], cities: ["Frankfurt", "Berlin", "D\xFCsseldorf", "Hamburg", "K\xF6ln"], peeringPolicy: "selective", maxRatio: 8, requiresRpki: false, minTrafficMbps: 500, atRouteServer: true },
  { asn: 64521, name: "KabelNet Consumer", kind: "eyeball", transitPricePerMbps: 0, reach: 0.11, peeringWillingness: 0.25, ixpKeys: ["ix-fra", "ix-ams", "ix-dus", "ix-lej"], cities: ["Frankfurt", "Amsterdam", "D\xFCsseldorf", "Leipzig", "Eygelshoven"], peeringPolicy: "selective", maxRatio: 8, requiresRpki: false, minTrafficMbps: 500, atRouteServer: true },
  { asn: 64522, name: "MobilOne", kind: "eyeball", transitPricePerMbps: 0, reach: 0.09, peeringWillingness: 0.4, ixpKeys: ["ix-fra", "ix-vie", "ix-mil", "ix-muc"], cities: ["Frankfurt", "Wien", "Mailand", "M\xFCnchen", "Stuttgart"], peeringPolicy: "selective", maxRatio: 8, requiresRpki: false, minTrafficMbps: 500, atRouteServer: true },
  { asn: 64523, name: "AmeriBell Access", kind: "eyeball", transitPricePerMbps: 0, reach: 0.15, peeringWillingness: 0.18, ixpKeys: ["ix-iad", "ix-nyc", "ix-ord", "ix-atl", "ix-dfw"], cities: ["Ashburn", "New York", "Chicago", "Atlanta", "Dallas", "Miami"], peeringPolicy: "selective", maxRatio: 8, requiresRpki: false, minTrafficMbps: 500, atRouteServer: true }
];
function distanceKm(a, b) {
  return Math.hypot(a.x - b.x, a.y - b.y) * KM_PER_UNIT;
}
function fiberLatencyMs(a, b) {
  return Math.max(0.1, distanceKm(a, b) * 1.4 * PHYSICS.MS_PER_KM_FIBER);
}
function findLocation(key) {
  return LOCATIONS.find((l) => l.key === key);
}

// src/domain/catalog/bank.ts
var LOAN_PRODUCTS = [
  {
    key: "loan-betriebsmittel",
    name: "Betriebsmittelkredit",
    description: "Kurzfristige Liquidit\xE4t ohne Sicherheiten \u2013 teurer als die Kreditlinie, aber mit fester Tilgung statt Daueranspruch.",
    baseRate: 0.12,
    minAmount: 5e3,
    maxAmount: 8e4,
    termTicks: SIM.TICKS_PER_YEAR,
    requiresResearch: null,
    minReputation: 0
  },
  {
    key: "loan-investition",
    name: "Investitionskredit",
    description: "Zweckgebundene Mittelfristfinanzierung f\xFCr Ausbau und Hardware, nach gepr\xFCfter Bonit\xE4t.",
    baseRate: 0.085,
    minAmount: 2e4,
    maxAmount: 3e5,
    termTicks: SIM.TICKS_PER_YEAR * 3,
    requiresResearch: "res-bonitaetspruefung",
    minReputation: 25
  },
  {
    key: "loan-hausbank",
    name: "Hausbankdarlehen",
    description: "Langfristige Gro\xDFfinanzierung zu Konditionen, die es nur mit gewachsener Bankbeziehung gibt.",
    baseRate: 0.05,
    minAmount: 1e5,
    maxAmount: 12e5,
    termTicks: SIM.TICKS_PER_YEAR * 6,
    requiresResearch: "res-hausbankstatus",
    minReputation: 55
  }
];
function findLoanProduct(key) {
  return LOAN_PRODUCTS.find((p) => p.key === key);
}

// src/domain/network/topology.ts
function isLinkUsable(link) {
  return (link.state === "up" || link.state === "degraded") && link.buildTicksRemaining <= 0;
}
function isLinkPortEnabled(world, link) {
  for (const endpoint of [link.a, link.b]) {
    if (endpoint.kind !== "internal" || endpoint.routerId === null || endpoint.portIndex === null) continue;
    const port = world.routers[endpoint.routerId]?.ports[endpoint.portIndex];
    if (port && port.enabled === false) return false;
  }
  return true;
}
function isLinkLive(world, link) {
  return isLinkUsable(link) && isLinkPortEnabled(world, link);
}
function buildTopology(world) {
  const routers = Object.keys(world.routers);
  const edges = [];
  const adjacency = {};
  for (const id of routers) adjacency[id] = [];
  for (const link of values(world.links)) {
    if (!isLinkLive(world, link)) continue;
    if (link.a.kind !== "internal" || link.b.kind !== "internal") continue;
    const from = link.a.routerId;
    const to = link.b.routerId;
    if (!from || !to || !world.routers[from] || !world.routers[to]) continue;
    const penalty = link.state === "degraded" ? 3 : 1;
    const cost = Math.max(1, link.latencyMs * 10) * penalty;
    const forward = { linkId: link.id, from, to, cost, capacityMbps: link.capacityMbps };
    const backward = { linkId: link.id, from: to, to: from, cost, capacityMbps: link.capacityMbps };
    edges.push(forward, backward);
    adjacency[from].push(forward);
    adjacency[to].push(backward);
  }
  return { routers, edges, adjacency };
}
function shortestPaths(topology, source) {
  const dist = {};
  const prev = {};
  const visited = /* @__PURE__ */ new Set();
  for (const r of topology.routers) {
    dist[r] = Infinity;
    prev[r] = null;
  }
  if (!(source in dist)) return {};
  dist[source] = 0;
  while (visited.size < topology.routers.length) {
    let current = null;
    let best = Infinity;
    for (const r of topology.routers) {
      if (visited.has(r)) continue;
      if (dist[r] < best) {
        best = dist[r];
        current = r;
      }
    }
    if (current === null || best === Infinity) break;
    visited.add(current);
    for (const edge of topology.adjacency[current] ?? []) {
      const next = dist[current] + edge.cost;
      if (next < dist[edge.to]) {
        dist[edge.to] = next;
        prev[edge.to] = edge;
      }
    }
  }
  const result = {};
  for (const target of topology.routers) {
    if (dist[target] === Infinity) continue;
    const hops = [];
    const links = [];
    let cursor = target;
    while (cursor && cursor !== source) {
      const edge = prev[cursor];
      if (!edge) break;
      hops.unshift(cursor);
      links.unshift(edge.linkId);
      cursor = edge.from;
    }
    hops.unshift(source);
    result[target] = { cost: dist[target], hops, links };
  }
  return result;
}
function allShortestPaths(topology) {
  const out = {};
  for (const router of topology.routers) {
    out[router] = shortestPaths(topology, router);
  }
  return out;
}
function connectedComponents(topology) {
  const seen = /* @__PURE__ */ new Set();
  const components = [];
  for (const start of topology.routers) {
    if (seen.has(start)) continue;
    const stack = [start];
    const component = [];
    seen.add(start);
    while (stack.length) {
      const node = stack.pop();
      component.push(node);
      for (const edge of topology.adjacency[node] ?? []) {
        if (!seen.has(edge.to)) {
          seen.add(edge.to);
          stack.push(edge.to);
        }
      }
    }
    components.push(component);
  }
  return components;
}

// src/domain/network/cabling.ts
var ok = (message) => ({ ok: true, message });
var fail = (message) => ({ ok: false, message });
function connectToSwitch(world, input) {
  const sw = world.switches[input.switchId];
  if (!sw) return fail("Switch nicht gefunden.");
  const port = sw.ports[input.portIndex];
  if (!port) return fail(`Port ${input.portIndex} gibt es an ${sw.name} nicht.`);
  const device = patchableDevice(world, input.kind, input.deviceId);
  if (!device) return fail("Ger\xE4t nicht gefunden.");
  if (input.kind === "switch" && input.deviceId === sw.id) {
    return fail(`${sw.name} l\xE4sst sich nicht an sich selbst stecken.`);
  }
  if (device.datacenterId !== sw.datacenterId) {
    return fail(
      `${device.name} steht in ${world.datacenters[device.datacenterId]?.city ?? "?"}, ${sw.name} in ${world.datacenters[sw.datacenterId]?.city ?? "?"}. Ein Patchkabel reicht daf\xFCr nicht.`
    );
  }
  if (port.connectedDevice) {
    const other = describeConnected(world, port.connectedDevice);
    return fail(`Port ${input.portIndex} ist mit ${other} belegt. Erst abziehen.`);
  }
  if (port.linkId) return fail(`Port ${input.portIndex} tr\xE4gt eine WAN-Strecke.`);
  if (input.kind === "server") {
    const server = world.servers[input.deviceId];
    if (server.uplink) releaseSwitchPort(world, server.uplink.switchId, server.uplink.portIndex);
    server.uplink = { switchId: sw.id, portIndex: port.index };
  }
  port.connectedDevice = { kind: input.kind, id: input.deviceId };
  port.description = device.name;
  const note = speedMismatchNote(world, input.kind, input.deviceId, port);
  return ok(`${device.name} an ${sw.name} Port ${port.index} gesteckt (VLAN ${port.vlanId}).${note}`);
}
function disconnectFromSwitch(world, input) {
  const device = patchableDevice(world, input.kind, input.deviceId);
  if (!device) return fail("Ger\xE4t nicht gefunden.");
  if (input.kind === "server") {
    const server = world.servers[input.deviceId];
    if (!server.uplink) return fail(`${server.name} h\xE4ngt an keinem Switch.`);
    const active = server.contractIds.length + server.vpsIds.length;
    releaseSwitchPort(world, server.uplink.switchId, server.uplink.portIndex);
    server.uplink = null;
    return ok(
      `${server.name} vom Switch abgezogen.` + (active > 0 ? ` Achtung: ${active} Kundendienste laufen darauf und sind ab sofort nicht erreichbar.` : "")
    );
  }
  let found = false;
  for (const sw of values(world.switches)) {
    for (const port of sw.ports) {
      if (port.connectedDevice?.kind === input.kind && port.connectedDevice.id === input.deviceId) {
        port.connectedDevice = null;
        port.description = "";
        found = true;
      }
    }
  }
  return found ? ok(`${device.name} vom Switch abgezogen.`) : fail(`${device.name} h\xE4ngt an keinem Switch.`);
}
function repatchDevice(world, input) {
  const target = world.switches[input.switchId]?.ports[input.portIndex];
  if (!target) return fail("Zielport existiert nicht.");
  if (target.connectedDevice) return fail(`Zielport ${input.portIndex} ist bereits belegt.`);
  if (target.linkId) return fail(`Zielport ${input.portIndex} tr\xE4gt eine WAN-Strecke.`);
  disconnectFromSwitch(world, { kind: input.kind, deviceId: input.deviceId });
  return connectToSwitch(world, input);
}
function releaseSwitchPort(world, switchId, portIndex) {
  const port = world.switches[switchId]?.ports[portIndex];
  if (!port) return;
  port.connectedDevice = null;
  port.description = "";
}
function patchableDevice(world, kind, id) {
  switch (kind) {
    case "server":
      return world.servers[id];
    case "router":
      return world.routers[id];
    case "switch":
      return world.switches[id];
    case "firewall":
      return world.firewalls[id];
    case "loadbalancer":
      return world.loadBalancers[id];
  }
}
function describeConnected(world, connected) {
  const device = connected.kind === "switch" ? world.switches[connected.id] : patchableDevice(world, connected.kind, connected.id);
  return device?.name ?? `${connected.kind} ${connected.id}`;
}
function serverNicMbps(server) {
  let mbps = 0;
  for (const part of server.parts) {
    const model = findPartOfKind(part.modelKey, "nic");
    if (model) mbps += model.speedMbps * model.ports;
  }
  return mbps > 0 ? mbps : findServerModel(server.model)?.nicMbps ?? 0;
}
function speedMismatchNote(world, kind, deviceId, port) {
  if (kind !== "server") return "";
  const server = world.servers[deviceId];
  const nicMbps = serverNicMbps(server);
  if (nicMbps > 0 && port.speedMbps < nicMbps) {
    return ` Hinweis: Die Netzwerkkarte kann ${formatSpeed(nicMbps)}, der Port nur ${formatSpeed(port.speedMbps)}.`;
  }
  return "";
}
function formatSpeed(mbps) {
  return mbps >= 1e3 ? `${mbps / 1e3} Gbit/s` : `${mbps} Mbit/s`;
}
function switchHasUplink(world, switchId, seen = /* @__PURE__ */ new Set()) {
  if (seen.has(switchId)) return false;
  seen.add(switchId);
  const sw = world.switches[switchId];
  if (!sw) return false;
  for (const port of sw.ports) {
    if (port.enabled === false || !port.connectedDevice) continue;
    const { kind, id } = port.connectedDevice;
    if (kind === "router") {
      const router = world.routers[id];
      if (router && (router.state === "online" || router.state === "degraded")) return true;
      continue;
    }
    if (kind === "switch") {
      if (switchHasUplink(world, id, seen)) return true;
      continue;
    }
    if (kind === "firewall" || kind === "loadbalancer") {
      const device = kind === "firewall" ? world.firewalls[id] : world.loadBalancers[id];
      if (!device || device.state !== "online" && device.state !== "degraded") continue;
      for (const other of values(world.switches)) {
        if (other.id === sw.id) continue;
        const angeschlossen = other.ports.some(
          (p) => p.enabled !== false && p.connectedDevice?.kind === kind && p.connectedDevice.id === id
        );
        if (angeschlossen && switchHasUplink(world, other.id, seen)) return true;
      }
    }
  }
  return false;
}
function switchesWithoutUplink(world, datacenterId) {
  return values(world.switches).filter((sw) => !datacenterId || sw.datacenterId === datacenterId).filter((sw) => sw.state === "online" || sw.state === "degraded").filter((sw) => !switchHasUplink(world, sw.id));
}
function isServerConnected(world, serverId) {
  const server = world.servers[serverId];
  if (!server?.uplink) return false;
  const sw = world.switches[server.uplink.switchId];
  if (!sw) return false;
  if (sw.state !== "online" && sw.state !== "degraded") return false;
  if (sw.ports[server.uplink.portIndex]?.enabled === false) return false;
  return switchHasUplink(world, sw.id);
}
function freeSwitchPorts(sw) {
  return sw.ports.filter((p) => p.connectedDevice === null && p.linkId === null);
}
function switchesWithFreePorts(world, datacenterId) {
  return values(world.switches).filter((s) => s.datacenterId === datacenterId).map((sw) => ({ sw, free: freeSwitchPorts(sw).length })).filter((entry) => entry.free > 0);
}
function moveLinkToPort(world, input) {
  const link = world.links[input.linkId];
  if (!link) return fail("Strecke nicht gefunden.");
  const target = world.routers[input.targetRouterId];
  if (!target) return fail("Zielrouter nicht gefunden.");
  const targetPort = target.ports[input.targetPortIndex];
  if (!targetPort) return fail(`Port ${input.targetPortIndex} gibt es an ${target.name} nicht.`);
  if (targetPort.linkId) return fail(`Port ${input.targetPortIndex} an ${target.name} ist bereits belegt.`);
  const side = link.a.kind === "internal" ? "a" : "b";
  const endpoint = link[side];
  if (endpoint.kind !== "internal" || !endpoint.routerId) {
    return fail("Diese Strecke hat kein eigenes Ende, das sich umstecken lie\xDFe.");
  }
  if (link.a.kind === "internal" && link.b.kind === "internal") {
    return fail("Interne Strecken zwischen zwei eigenen Routern lassen sich nicht einseitig umstecken \u2013 neu bauen.");
  }
  const source = world.routers[endpoint.routerId];
  if (source?.id === target.id && endpoint.portIndex === input.targetPortIndex) {
    return fail("Die Strecke liegt bereits auf diesem Port.");
  }
  if (targetPort.speedMbps < link.capacityMbps) {
    return fail(
      `${target.name} Port ${input.targetPortIndex} liefert nur ${formatSpeed(targetPort.speedMbps)}, die Strecke hat ${formatSpeed(link.capacityMbps)}.`
    );
  }
  if (target.datacenterId !== source?.datacenterId) {
    return fail(
      `Die \xDCbergabe liegt in ${world.datacenters[source?.datacenterId ?? ""]?.city ?? "?"}; ${target.name} steht in ${world.datacenters[target.datacenterId]?.city ?? "?"}. Der Carrier m\xFCsste die Leitung erst dorthin f\xFChren.`
    );
  }
  if (source && endpoint.portIndex !== null) {
    const oldPort = source.ports[endpoint.portIndex];
    if (oldPort) {
      oldPort.linkId = null;
      oldPort.description = "";
    }
  }
  targetPort.linkId = link.id;
  targetPort.description = link.name;
  link[side] = {
    kind: "internal",
    routerId: target.id,
    portIndex: targetPort.index,
    label: `${target.name} Port ${targetPort.index}`,
    datacenterId: target.datacenterId
  };
  let movedSessions = 0;
  if (source && source.id !== target.id) {
    const moving = source.bgp.neighbors.filter((n) => n.linkId === link.id);
    source.bgp.neighbors = source.bgp.neighbors.filter((n) => n.linkId !== link.id);
    for (const neighbor of moving) {
      target.bgp.neighbors.push(neighbor);
      delete world.sessions[`ses_${source.id}_${neighbor.id}`];
      movedSessions += 1;
    }
  }
  link.state = "down";
  link.buildTicksRemaining = 1;
  const ixp = link.ixpId ? world.ixps[link.ixpId] : null;
  if (ixp && ixp.routerId === source?.id) ixp.routerId = target.id;
  return ok(
    `${link.name} auf ${target.name} Port ${targetPort.index} umgesteckt.` + (movedSessions > 0 ? ` ${movedSessions} BGP-Sitzung(en) umgezogen, Neuaufbau l\xE4uft.` : "") + " Die Strecke ist f\xFCr kurze Zeit unterbrochen."
  );
}
function advanceLinkBuilds(world) {
  const finished = [];
  for (const link of values(world.links)) {
    if (link.buildTicksRemaining <= 0) continue;
    link.buildTicksRemaining -= 1;
    if (link.buildTicksRemaining > 0) continue;
    if (link.state === "planned" || link.state === "down") link.state = "up";
    finished.push({ linkId: link.id, text: `${link.name} ist aufgeschaltet und tr\xE4gt Verkehr.` });
  }
  return finished;
}

// src/domain/world/economy.ts
var IndexKeys = ["konjunktur", "strom", "hardware", "ipv4", "transit", "glasfaser", "miete"];
var INDEX_LABEL = {
  konjunktur: "Konjunktur",
  strom: "Energiepreise",
  hardware: "Hardwarepreise",
  ipv4: "IPv4-Transfermarkt",
  transit: "Transitpreise",
  glasfaser: "Glasfaser und Mietleitungen",
  miete: "Rackfl\xE4che und Standortmiete"
};
var BOUNDS = {
  konjunktur: [0.6, 1.4],
  strom: [0.55, 2.3],
  hardware: [0.6, 1.85],
  ipv4: [0.7, 2.6],
  transit: [0.45, 1.5],
  glasfaser: [0.6, 1.5],
  miete: [0.75, 1.7]
};
var ADJUST_PER_DAY = 0.012;
var NOISE = 25e-4;
var RegimeKeys = ["normal", "boom", "rezession", "energiekrise", "chipknappheit"];
var REGIMES = {
  normal: {
    key: "normal",
    label: "Ruhige Lage",
    description: "Die M\xE4rkte bewegen sich ohne besondere Ausschl\xE4ge.",
    targets: {},
    duration: [18, 48],
    next: { boom: 3, rezession: 3, energiekrise: 2, chipknappheit: 2 }
  },
  boom: {
    key: "boom",
    label: "Aufschwung",
    description: "Die Nachfrage zieht breit an. Wer Kapazit\xE4t hat, verkauft sie.",
    targets: { konjunktur: 1.28, hardware: 1.22, miete: 1.3, glasfaser: 1.12, ipv4: 1.35 },
    duration: [12, 30],
    next: { normal: 5, rezession: 4 }
  },
  rezession: {
    key: "rezession",
    label: "Rezession",
    description: "Die Nachfrage bricht ein, Zahlungsziele werden gedehnt. Hardware wird billig.",
    targets: { konjunktur: 0.7, hardware: 0.78, miete: 0.85, ipv4: 0.82, transit: 0.85 },
    duration: [10, 22],
    next: { normal: 6, boom: 2, energiekrise: 1 }
  },
  energiekrise: {
    key: "energiekrise",
    label: "Energiekrise",
    description: "Gro\xDFhandelspreise f\xFCr Strom vervielfachen sich. Effizienz entscheidet.",
    targets: { strom: 2.1, konjunktur: 0.88, miete: 1.15 },
    duration: [6, 18],
    next: { normal: 7, rezession: 3 }
  },
  chipknappheit: {
    key: "chipknappheit",
    label: "Chipknappheit",
    description: "Lieferketten stocken. Hardware wird teuer und knapp.",
    targets: { hardware: 1.7, konjunktur: 0.95 },
    duration: [6, 18],
    next: { normal: 7, boom: 2, rezession: 1 }
  }
};
var MAX_HISTORY = 240;
function emptyEconomy() {
  const indices = {};
  const history = {};
  for (const key of IndexKeys) {
    indices[key] = { value: 1, target: 1 };
    history[key] = [];
  }
  return {
    regime: { key: "normal", startedAtTick: 0, endsAtTick: SIM.TICKS_PER_MONTH * 24 },
    indices,
    history
  };
}
function pickNextRegime(current, rng) {
  const options = Object.entries(REGIMES[current].next);
  const total = options.reduce((sum3, [, weight]) => sum3 + weight, 0);
  let roll = rng.float(0, 1) * total;
  for (const [key, weight] of options) {
    roll -= weight;
    if (roll <= 0) return key;
  }
  return "normal";
}
function applyTargets(state, key) {
  const regime = REGIMES[key];
  for (const index of IndexKeys) {
    state.indices[index].target = regime.targets[index] ?? 1;
  }
}
function updateEconomy(world, rng) {
  const state = world.economy;
  const report = {};
  if (world.meta.tick >= state.regime.endsAtTick) {
    const from = state.regime.key;
    const to = pickNextRegime(from, rng);
    const [minMonths, maxMonths] = REGIMES[to].duration;
    const months = minMonths + Math.floor(rng.float(0, 1) * (maxMonths - minMonths + 1));
    state.regime = {
      key: to,
      startedAtTick: world.meta.tick,
      endsAtTick: world.meta.tick + months * SIM.TICKS_PER_MONTH
    };
    applyTargets(state, to);
    report.regimeChanged = { from, to };
  }
  for (const key of IndexKeys) {
    const index = state.indices[key];
    const [min, max] = BOUNDS[key];
    const drift = (index.target - index.value) * ADJUST_PER_DAY;
    const noise = rng.normal(0, NOISE);
    index.value = clamp(index.value + drift + noise, min, max);
  }
  if (world.meta.tick % SIM.TICKS_PER_MONTH < SIM.TICKS_PER_DAY) {
    for (const key of IndexKeys) {
      const series = state.history[key];
      series.push(Math.round(state.indices[key].value * 1e3) / 1e3);
      if (series.length > MAX_HISTORY) series.splice(0, series.length - MAX_HISTORY);
    }
    report.monthClosed = true;
  }
  return report;
}
function worldPrice(world, key, base) {
  return Math.round(base * world.economy.indices[key].value);
}
function worldRate(world, key, base) {
  return base * world.economy.indices[key].value;
}
function surcharge(world, key) {
  return world.economy.indices[key].value - 1;
}
function currentRegime(world) {
  return REGIMES[world.economy.regime.key];
}

// src/domain/network/ipam.ts
function prefixesOfFamily(world, family) {
  return values(world.prefixes).filter((p) => p.family === family);
}
function childPrefixes(world, parentId) {
  return values(world.prefixes).filter((p) => p.parentId === parentId);
}
function cidrOf(prefix) {
  return `${prefix.network}/${prefix.length}`;
}
function prefixUtilization(world, prefix) {
  const total = usableHosts(prefix.length, prefix.family);
  const parsed = parsePrefix(cidrOf(prefix));
  let used = 0;
  for (const child of childPrefixes(world, prefix.id)) {
    used += usableHosts(child.length, child.family);
  }
  for (const contract of values(world.contracts)) {
    const list = prefix.family === "ipv4" ? contract.ipv4 : contract.ipv6;
    for (const address of list) {
      if (containsAddress(parsed, address)) used += 1;
    }
  }
  return { used, total, percent: total === 0 ? 0 : Math.min(100, used / total * 100) };
}
function createPrefix(world, rng, input) {
  const parsed = parsePrefix(input.cidr);
  const prefix = {
    id: asId(makeId(rng, "pfx")),
    family: parsed.family,
    network: formatPrefix(parsed).split("/")[0],
    length: parsed.length,
    source: input.source,
    parentId: input.parentId ?? null,
    usage: input.usage,
    assignedTo: null,
    announced: false,
    monthlyCost: input.monthlyCost ?? defaultPrefixCost(world, parsed.family, parsed.length),
    rdnsDelegated: false,
    acquiredAtTick: world.meta.tick
  };
  world.prefixes[prefix.id] = prefix;
  return prefix;
}
function defaultPrefixCost(world, family, length) {
  if (family === "ipv6") return length <= 32 ? ECONOMY.IPV6_32_MONTHLY : 0;
  const twentyFours = Math.max(1, 2 ** Math.max(0, 24 - length));
  return Math.round(worldRate(world, "ipv4", ECONOMY.IPV4_24_MONTHLY) * twentyFours);
}
function ipv4BlockPrice(world, length) {
  return Math.round(Number(addressCount(length, "ipv4")) * worldRate(world, "ipv4", ECONOMY.IPV4_ADDRESS_PRICE));
}
function transferMarketValue(world, family, length) {
  if (family === "ipv6") return 0;
  return Math.round(Number(addressCount(length, "ipv4")) * worldRate(world, "ipv4", ECONOMY.IPV4_ADDRESS_PRICE) * ECONOMY.IPV4_TRANSFER_SHARE);
}
function assignedAddressCount(world, prefix) {
  const parsed = parsePrefix(cidrOf(prefix));
  let used = 0;
  for (const contract of values(world.contracts)) {
    if (contract.state === "cancelled") continue;
    const list = prefix.family === "ipv4" ? contract.ipv4 : contract.ipv6;
    for (const address of list) {
      if (containsAddress(parsed, address)) used += 1;
    }
  }
  return used;
}
function canSellPrefix(world, prefixId) {
  const prefix = world.prefixes[prefixId];
  if (!prefix) return { ok: false, reason: "Prefix nicht gefunden.", proceeds: 0, monthlySaving: 0 };
  const reject = (reason) => ({ ok: false, reason, proceeds: 0, monthlySaving: 0 });
  if (prefix.source === "rfc1918") return reject("Private Adressen lassen sich nicht handeln.");
  if (prefix.source === "upstream") return reject("Geliehene Adressen des Upstreams geh\xF6ren nicht dir.");
  if (prefix.parentId) return reject("Nur ganze Bl\xF6cke sind handelbar, keine einzelnen Subnetze. Erst das Elternnetz freir\xE4umen.");
  if (prefix.announced) return reject("Der Block wird noch per BGP angek\xFCndigt \u2013 erst zur\xFCckziehen.");
  if (prefix.assignedTo) return reject("Der Block ist noch zugewiesen.");
  const children = childPrefixes(world, prefixId);
  const busy = children.filter((c) => c.assignedTo !== null || c.announced || assignedAddressCount(world, c) > 0);
  if (busy.length > 0) {
    return reject(`${busy.length} Subnetz(e) daraus sind noch in Gebrauch (${busy.map((c) => cidrOf(c)).slice(0, 3).join(", ")}).`);
  }
  const assigned = assignedAddressCount(world, prefix);
  if (assigned > 0) return reject(`${assigned} Adressen daraus sind noch an Kunden vergeben.`);
  return {
    ok: true,
    proceeds: transferMarketValue(world, prefix.family, prefix.length),
    monthlySaving: prefix.monthlyCost
  };
}
function sellPrefix(world, prefixId, credit) {
  const check = canSellPrefix(world, prefixId);
  if (!check.ok) return { ok: false, message: check.reason };
  const prefix = world.prefixes[prefixId];
  const cidr = cidrOf(prefix);
  for (const child of childPrefixes(world, prefixId)) delete world.prefixes[child.id];
  delete world.prefixes[prefixId];
  if (check.proceeds > 0) credit(check.proceeds, `Verkauf ${cidr} auf dem Transfermarkt`);
  return {
    ok: true,
    message: check.proceeds > 0 ? `${cidr} verkauft (${check.proceeds.toLocaleString("de-DE")} \u20AC). Spart ${check.monthlySaving.toLocaleString("de-DE")} \u20AC/Monat.` : `${cidr} zur\xFCckgegeben. Spart ${check.monthlySaving.toLocaleString("de-DE")} \u20AC/Monat.`
  };
}
function mergeSubnets(world, prefixId) {
  const prefix = world.prefixes[prefixId];
  if (!prefix) return { ok: false, message: "Prefix nicht gefunden.", removed: 0 };
  const children = childPrefixes(world, prefixId);
  if (children.length === 0) return { ok: false, message: "Dieser Block ist nicht unterteilt.", removed: 0 };
  const busy = children.filter((c) => c.assignedTo !== null || c.announced || assignedAddressCount(world, c) > 0);
  if (busy.length > 0) {
    return {
      ok: false,
      message: `${busy.length} Subnetz(e) sind noch in Gebrauch: ${busy.map((c) => cidrOf(c)).slice(0, 3).join(", ")}. Erst die Kunden daraus umziehen oder die Ank\xFCndigung zur\xFCckziehen.`,
      removed: 0
    };
  }
  for (const child of children) delete world.prefixes[child.id];
  return {
    ok: true,
    message: `${children.length} leere Subnetze aus ${cidrOf(prefix)} entfernt. Der Block ist wieder am St\xFCck verf\xFCgbar.`,
    removed: children.length
  };
}
function withdrawPrefixEverywhere(world, prefixId) {
  const prefix = world.prefixes[prefixId];
  if (!prefix) return { ok: false, message: "Prefix nicht gefunden.", affectedAddresses: 0 };
  const cidr = cidrOf(prefix);
  let removed = 0;
  for (const router of values(world.routers)) {
    const index = router.bgp.originatedPrefixes.indexOf(cidr);
    if (index >= 0) {
      router.bgp.originatedPrefixes.splice(index, 1);
      removed += 1;
    }
  }
  prefix.announced = false;
  for (const child of childPrefixes(world, prefixId)) child.announced = false;
  const affected = assignedAddressCount(world, prefix);
  if (removed === 0) return { ok: false, message: `${cidr} wurde ohnehin nicht angek\xFCndigt.`, affectedAddresses: affected };
  return {
    ok: true,
    message: `${cidr} wird nicht mehr angek\xFCndigt.` + (affected > 0 ? ` Achtung: ${affected} vergebene Adressen sind damit von au\xDFen unerreichbar.` : ""),
    affectedAddresses: affected
  };
}
function sellablePrefixes(world) {
  return values(world.prefixes).map((prefix) => ({ prefix, check: canSellPrefix(world, prefix.id) })).filter((entry) => entry.check.ok).map((entry) => ({ prefix: entry.prefix, proceeds: entry.check.proceeds, monthlySaving: entry.check.monthlySaving })).sort((a, b) => b.proceeds - a.proceeds);
}
function splitPrefix(world, rng, parentId, newLength) {
  const parent = world.prefixes[parentId];
  if (!parent) throw new Error("Elternnetz nicht gefunden");
  if (newLength <= parent.length) throw new Error("Subnetz muss kleiner als das Elternnetz sein");
  const existing = childPrefixes(world, parentId).map((c) => parsePrefix(cidrOf(c)));
  const created = [];
  for (const cidr of subnets(cidrOf(parent), newLength, 512)) {
    const candidate = parsePrefix(cidr);
    if (existing.some((e) => containsPrefix(e, candidate) || containsPrefix(candidate, e))) continue;
    created.push(
      createPrefix(world, rng, {
        cidr,
        source: parent.source,
        usage: "unassigned",
        parentId,
        monthlyCost: 0
        // Kosten trägt das Elternnetz
      })
    );
  }
  return created;
}
function findFreePrefix(world, family, minHosts) {
  return values(world.prefixes).filter((p) => p.family === family && p.usage === "unassigned" && p.assignedTo === null).filter((p) => usableHosts(p.length, p.family) >= minHosts).sort((a, b) => b.length - a.length)[0];
}
function usedAddresses(world, family) {
  const used = /* @__PURE__ */ new Set();
  for (const contract of values(world.contracts)) {
    for (const a of family === "ipv4" ? contract.ipv4 : contract.ipv6) used.add(a);
  }
  for (const server of values(world.servers)) {
    if (family === "ipv4" && server.managementIp) used.add(server.managementIp);
  }
  for (const router of values(world.routers)) {
    for (const port of router.ports) {
      const address = family === "ipv4" ? port.ipv4 : port.ipv6;
      if (address) used.add(address);
    }
  }
  for (const vps of values(world.vpsInstances)) {
    const address = family === "ipv4" ? vps.ipv4 : vps.ipv6;
    if (address) used.add(address);
  }
  return used;
}
function allocateAddresses(world, family, count2, purpose = "customer") {
  if (count2 <= 0) return { ok: true, addresses: [] };
  const used = usedAddresses(world, family);
  const pools = values(world.prefixes).filter((p) => p.family === family).filter((p) => purpose === "customer" ? p.usage === "customer" : p.usage === "infrastructure").sort((a, b) => b.length - a.length);
  const addresses = [];
  for (const pool of pools) {
    const total = addressCount(pool.length, family);
    const start = 1n;
    const end = family === "ipv4" ? total - 1n : total;
    for (let i = start; i < end && addresses.length < count2; i++) {
      const address = nthAddress(cidrOf(pool), i);
      if (used.has(address)) continue;
      used.add(address);
      addresses.push(address);
    }
    if (addresses.length >= count2) return { ok: true, addresses, prefixId: pool.id };
  }
  return {
    ok: false,
    addresses,
    error: family === "ipv4" ? `Nicht gen\xFCgend freie IPv4-Adressen (${addresses.length} von ${count2}). Weiteren Block kaufen oder NAT einsetzen.` : `Nicht gen\xFCgend freie IPv6-Adressen (${addresses.length} von ${count2}).`
  };
}
function releaseAddresses(world, customerId) {
  for (const contract of values(world.contracts)) {
    if (contract.customerId !== customerId) continue;
    contract.ipv4 = [];
    contract.ipv6 = [];
  }
}
function canAnnounce(world, prefixId) {
  const prefix = world.prefixes[prefixId];
  if (!prefix) return { ok: false, reason: "Prefix nicht gefunden" };
  if (world.company.asn === 0) return { ok: false, reason: "Ohne eigene ASN ist keine Ank\xFCndigung m\xF6glich" };
  if (prefix.source === "upstream") {
    return { ok: false, reason: "Vom Upstream geliehene Adressen k\xFCndigt der Upstream selbst an" };
  }
  if (prefix.source === "rfc1918" || prefix.source === "internal") {
    return { ok: false, reason: "Private Adressen sind global nicht routbar" };
  }
  return isAnnounceable(cidrOf(prefix));
}
function ipamSummary(world, family) {
  const prefixes = prefixesOfFamily(world, family).filter((p) => p.parentId === null);
  const used = usedAddresses(world, family);
  let total = 0;
  for (const p of prefixes) {
    const hosts = usableHosts(p.length, p.family);
    total += Number.isFinite(hosts) ? hosts : 0;
  }
  return {
    family,
    prefixCount: prefixesOfFamily(world, family).length,
    totalAddresses: total,
    usedAddresses: used.size,
    announcedPrefixes: prefixesOfFamily(world, family).filter((p) => p.announced).length,
    monthlyCost: prefixesOfFamily(world, family).reduce((s, p) => s + p.monthlyCost, 0)
  };
}

// src/domain/network/diagnostics.ts
function diagnose(world) {
  const findings = [];
  const explainedDatacenters = /* @__PURE__ */ new Set();
  const explainedSwitches = /* @__PURE__ */ new Set();
  const explainedRouters = /* @__PURE__ */ new Set();
  checkPower(world, findings, explainedDatacenters);
  checkEviction(world, findings);
  checkDevices(world, findings, explainedDatacenters, explainedSwitches, explainedRouters);
  checkCabling(world, findings, explainedDatacenters, explainedSwitches);
  checkSwitchUplinks(world, findings);
  checkLinks(world, findings, explainedRouters);
  checkBgp(world, findings, explainedRouters);
  checkAnnouncements(world, findings);
  checkCapacity(world, findings);
  checkRedundancy(world, findings);
  checkLoadBalancing(world, findings);
  const rank = { critical: 0, error: 1, warning: 2, info: 3 };
  return findings.sort((a, b) => rank[a.severity] - rank[b.severity]);
}
function checkPower(world, out, explained) {
  for (const dc of values(world.datacenters)) {
    if (dc.utilityPower) continue;
    const ups = values(world.upsUnits).filter((u) => u.datacenterId === dc.id);
    const charge = ups.reduce((sum3, u) => sum3 + u.charge, 0) / Math.max(1, ups.length) * 100;
    explained.add(dc.id);
    out.push({
      id: `power-out-${dc.id}`,
      severity: "critical",
      layer: "strom",
      title: `${dc.name}: kein Netzstrom`,
      cause: dc.generator.installed ? `Der Netzanschluss ist ausgefallen. Der Generator l\xE4uft mit ${dc.generator.fuelPercent.toFixed(0)} % Tankf\xFCllung.` : "Der Netzanschluss ist ausgefallen, und es gibt keinen Generator.",
      impact: ups.length > 0 ? `Alles am Standort l\xE4uft auf USV (${charge.toFixed(0)} % Restladung).` : "Ohne USV ist am Standort sofort alles dunkel.",
      remedies: dc.generator.installed ? [{ label: "Warten, bis der Netzstrom zur\xFCckkehrt", command: null, note: "Der Generator \xFCberbr\xFCckt, solange Diesel da ist." }] : [
        {
          label: "Notstromgenerator installieren",
          command: { type: "dc/installGenerator", datacenterId: dc.id },
          note: "Hilft erst beim n\xE4chsten Ausfall, nicht bei diesem."
        }
      ],
      ref: { kind: "datacenter", id: dc.id }
    });
  }
}
function checkEviction(world, out) {
  for (const dc of values(world.datacenters)) {
    const notice = dc.contract?.notice;
    if (!notice) continue;
    const left = notice.effectiveAtTick - world.meta.tick;
    if (left <= 0) continue;
    const servers = values(world.servers).filter((s) => s.datacenterId === dc.id);
    const devices = servers.length + values(world.routers).filter((d) => d.datacenterId === dc.id).length + values(world.switches).filter((d) => d.datacenterId === dc.id).length + values(world.firewalls).filter((d) => d.datacenterId === dc.id).length + values(world.loadBalancers).filter((d) => d.datacenterId === dc.id).length + values(world.upsUnits).filter((d) => d.datacenterId === dc.id).length;
    if (devices === 0) continue;
    const contracts = servers.reduce(
      (sum3, server) => sum3 + server.contractIds.filter((id) => world.contracts[id] && world.contracts[id].state !== "cancelled").length + server.vpsIds.filter((id) => world.vpsInstances[id]).length,
      0
    );
    const days = Math.round(left / 24);
    out.push({
      id: `eviction-${dc.id}`,
      severity: left < 24 * 7 ? "error" : left < 24 * 30 ? "warning" : "info",
      layer: "kapazitaet",
      title: `${dc.name}: R\xE4umung in ${days} ${days === 1 ? "Tag" : "Tagen"}`,
      cause: `Der Standortvertrag mit ${dc.contract.providerName} ist gek\xFCndigt und endet in ${days} ${days === 1 ? "Tag" : "Tagen"}.`,
      impact: `Dort stehen noch ${devices} Ger\xE4te` + (contracts > 0 ? ` mit ${contracts} Kundendiensten` : "") + ". Was am Stichtag nicht weg ist, verwertet der Anbieter zum Schrottpreis.",
      remedies: [
        {
          label: "Dienste an einen anderen Standort verlegen",
          command: null,
          note: "Erst die Server r\xE4umen, dann die leeren Ger\xE4te fahren lassen."
        },
        {
          label: "K\xFCndigung zur\xFCcknehmen",
          command: { type: "coloc/withdrawNotice", datacenterId: dc.id },
          note: notice.penaltyPaid > 0 ? "Die gezahlte Ausstiegssumme erstattet der Anbieter nicht." : void 0
        }
      ],
      ref: { kind: "datacenter", id: dc.id }
    });
  }
}
function checkDevices(world, out, explainedDcs, explainedSwitches, explainedRouters) {
  const kinds = [
    { store: world.routers, kind: "router" },
    { store: world.switches, kind: "switch" },
    { store: world.firewalls, kind: "firewall" },
    { store: world.servers, kind: "server" }
  ];
  for (const { store, kind } of kinds) {
    for (const device of Object.values(store)) {
      if (explainedDcs.has(device.datacenterId)) continue;
      if (kind === "server" && isUncommissioned(world, device.id)) {
        out.push(commissioningFinding(world, device.id));
        continue;
      }
      if (device.state === "online" || device.state === "booting" || device.state === "maintenance") continue;
      if (kind === "switch") explainedSwitches.add(device.id);
      if (kind === "router") explainedRouters.add(device.id);
      const impact = describeDeviceImpact(world, kind, device.id);
      if (device.state === "failed") {
        out.push({
          id: `device-failed-${device.id}`,
          severity: kind === "server" ? "error" : "critical",
          layer: "geraet",
          title: `${device.name} ist defekt`,
          cause: `Hardwaredefekt (Zustand ${(device.health * 100).toFixed(0)} %). Das Ger\xE4t bootet nicht mehr.`,
          impact,
          remedies: [
            {
              label: "Reparatur beauftragen",
              command: { type: "hw/repair", kind, id: device.id },
              note: "Kostet Ersatzteile; Techniker vor Ort beschleunigen die Sache."
            },
            { label: "Ger\xE4t ersetzen und abgeben", command: null, note: "Neues Ger\xE4t kaufen, dann das alte verkaufen." }
          ],
          ref: { kind, id: device.id }
        });
      } else if (device.state === "offline") {
        if (device.standby && !carriesLoad(world, kind, device.id)) continue;
        out.push({
          id: `device-off-${device.id}`,
          severity: device.standby ? "warning" : kind === "server" ? "warning" : "error",
          layer: "geraet",
          title: device.standby ? `${device.name} ist Reserve \u2013 tr\xE4gt aber Dienste` : `${device.name} ist ausgeschaltet`,
          cause: device.standby ? "Das Ger\xE4t wurde als Reserve abgeschaltet, hat aber noch Kunden zugeordnet." : "Das Ger\xE4t wurde administrativ abgeschaltet \u2013 ein Defekt liegt nicht vor.",
          impact,
          remedies: [{ label: "Einschalten", command: { type: "hw/power", kind, id: device.id, on: true } }],
          ref: { kind, id: device.id }
        });
      } else if (device.state === "degraded") {
        out.push({
          id: `device-degraded-${device.id}`,
          severity: "warning",
          layer: "geraet",
          title: `${device.name} l\xE4uft eingeschr\xE4nkt`,
          cause: `Der Zustand liegt bei ${(device.health * 100).toFixed(0)} % \u2013 Fehler h\xE4ufen sich, Pakete gehen verloren.`,
          impact,
          remedies: [
            { label: "Wartung durchf\xFChren", command: { type: "hw/repair", kind, id: device.id } },
            { label: "Neu starten", command: { type: "hw/reboot", kind, id: device.id } }
          ],
          ref: { kind, id: device.id }
        });
      }
    }
  }
}
function isUncommissioned(world, serverId) {
  const server = world.servers[serverId];
  if (!server) return false;
  if (server.contractIds.length > 0 || server.vpsIds.length > 0) return false;
  return server.os === null || server.uplink === null || server.role === "unassigned";
}
function commissioningFinding(world, serverId) {
  const server = world.servers[serverId];
  const open = [];
  const remedies = [];
  if (server.role === "unassigned") {
    open.push("Rolle festlegen");
    remedies.push({
      label: "Als VPS-Host einrichten",
      command: { type: "server/setRole", serverId: server.id, role: "vps-host" },
      note: "Die Rolle bestimmt, welche Produkte darauf laufen d\xFCrfen."
    });
  }
  if (server.os === null) {
    open.push("Betriebssystem installieren");
    remedies.push({
      label: "Debian installieren",
      command: { type: "server/installOs", serverId: server.id, os: "linux-debian" }
    });
  }
  if (server.uplink === null) {
    open.push("an einen Switch stecken");
    const target = pickFreePort(world, server.datacenterId);
    remedies.push(
      target ? {
        label: `An ${target.switchName} Port ${target.portIndex} stecken`,
        command: {
          type: "cable/connect",
          kind: "server",
          deviceId: server.id,
          switchId: target.switchId,
          portIndex: target.portIndex
        }
      } : { label: "Switch mit freiem Port beschaffen", command: null, note: "Am Standort ist kein Port frei." }
    );
  }
  if (server.state === "offline" && open.length === 0) {
    open.push("einschalten");
  }
  if (server.state === "offline") {
    remedies.push({ label: "Einschalten", command: { type: "hw/power", kind: "server", id: server.id, on: true } });
  }
  return {
    id: `server-commissioning-${server.id}`,
    severity: "info",
    layer: "geraet",
    title: `${server.name} ist noch nicht in Betrieb`,
    cause: `Offen: ${open.join(", ")}.`,
    impact: "Der Server kostet bereits Miete und Wartung, nimmt aber keine Kunden auf.",
    remedies,
    ref: { kind: "server", id: server.id }
  };
}
function carriesLoad(world, kind, id) {
  if (kind === "server") {
    const server = world.servers[id];
    if (!server) return false;
    return server.contractIds.some((cid) => world.contracts[cid] && world.contracts[cid].state !== "cancelled") || server.vpsIds.some((vid) => !!world.vpsInstances[vid]);
  }
  if (kind === "switch") return values(world.servers).some((s) => s.uplink?.switchId === id);
  if (kind === "router") return values(world.links).some((l) => l.a.routerId === id || l.b.routerId === id);
  return true;
}
function describeDeviceImpact(world, kind, id) {
  if (kind === "server") {
    const server = world.servers[id];
    const contracts = server ? server.contractIds.length + server.vpsIds.length : 0;
    return contracts > 0 ? `${contracts} Kundendienste darauf sind nicht erreichbar.` : "Keine Kunden betroffen.";
  }
  if (kind === "switch") {
    const behind = values(world.servers).filter((s) => s.uplink?.switchId === id);
    const contracts = behind.reduce((sum3, s) => sum3 + s.contractIds.length + s.vpsIds.length, 0);
    return behind.length > 0 ? `${behind.length} Server dahinter sind vom Netz getrennt (${contracts} Kundendienste).` : "Kein Server h\xE4ngt daran.";
  }
  if (kind === "router") {
    const links = values(world.links).filter((l) => l.a.routerId === id || l.b.routerId === id);
    return links.length > 0 ? `${links.length} Strecken laufen dar\xFCber \u2013 Transit und Peering fallen aus.` : "Keine Strecken betroffen.";
  }
  return "Auswirkung nicht bestimmt.";
}
function checkCabling(world, out, explainedDcs, explainedSwitches) {
  for (const server of values(world.servers)) {
    if (explainedDcs.has(server.datacenterId)) continue;
    if (server.state !== "online" && server.state !== "degraded") continue;
    const load = server.contractIds.length + server.vpsIds.length;
    if (!server.uplink) {
      const target = pickFreePort(world, server.datacenterId);
      out.push({
        id: `uplink-missing-${server.id}`,
        severity: load > 0 ? "error" : "warning",
        layer: "verkabelung",
        title: `${server.name} h\xE4ngt an keinem Switch`,
        cause: "Der Server l\xE4uft, ist aber nicht verkabelt \u2013 ohne Uplink erreicht ihn niemand.",
        impact: load > 0 ? `${load} Kundendienste darauf sind nicht erreichbar.` : "Der Server nimmt keine Neukunden auf, solange er nicht angeschlossen ist.",
        remedies: target ? [
          {
            label: `An ${target.switchName} Port ${target.portIndex} stecken`,
            command: {
              type: "cable/connect",
              kind: "server",
              deviceId: server.id,
              switchId: target.switchId,
              portIndex: target.portIndex
            }
          }
        ] : [{ label: "Switch mit freien Ports beschaffen", command: null, note: "Am Standort ist kein freier Port verf\xFCgbar." }],
        ref: { kind: "server", id: server.id }
      });
      continue;
    }
    const sw = world.switches[server.uplink.switchId];
    if (!sw) {
      out.push({
        id: `uplink-orphan-${server.id}`,
        severity: "error",
        layer: "verkabelung",
        title: `${server.name} zeigt auf einen Switch, den es nicht gibt`,
        cause: "Der Switch wurde entfernt, ohne den Server umzustecken.",
        impact: load > 0 ? `${load} Kundendienste sind nicht erreichbar.` : "Server ist vom Netz.",
        remedies: [{ label: "Neu verkabeln", command: { type: "cable/disconnect", kind: "server", deviceId: server.id } }],
        ref: { kind: "server", id: server.id }
      });
      continue;
    }
    if (explainedSwitches.has(sw.id)) continue;
    const port = sw.ports[server.uplink.portIndex];
    if (port && port.enabled === false) {
      out.push({
        id: `port-disabled-${server.id}`,
        severity: load > 0 ? "error" : "warning",
        layer: "verkabelung",
        title: `${sw.name} Port ${port.index} ist abgeschaltet`,
        cause: `Der Port, an dem ${server.name} h\xE4ngt, wurde administrativ deaktiviert.`,
        impact: load > 0 ? `${load} Kundendienste dahinter sind nicht erreichbar.` : "Der Server ist vom Netz getrennt.",
        remedies: [
          {
            label: "Port aktivieren",
            command: { type: "switch/setPortEnabled", switchId: sw.id, portIndex: port.index, enabled: true }
          }
        ],
        ref: { kind: "switch", id: sw.id }
      });
    }
  }
}
function checkSwitchUplinks(world, out) {
  for (const sw of switchesWithoutUplink(world)) {
    const dahinter = values(world.servers).filter((s) => s.uplink?.switchId === sw.id);
    const dienste = dahinter.reduce(
      (sum3, s) => sum3 + s.contractIds.filter((id) => world.contracts[id]?.state === "active").length + s.vpsIds.length,
      0
    );
    const router = values(world.routers).find(
      (r) => r.datacenterId === sw.datacenterId && (r.state === "online" || r.state === "degraded")
    );
    const port = freeSwitchPorts(sw).find((p) => p.mode === "trunk") ?? freeSwitchPorts(sw)[0];
    out.push({
      id: `switch-no-uplink-${sw.id}`,
      severity: dienste > 0 ? "error" : "warning",
      layer: "verkabelung",
      title: `${sw.name} hat keinen Uplink`,
      cause: "Der Switch h\xE4ngt an keinem Router. Was an ihm steckt, erreicht sich gegenseitig \u2013 und sonst nichts. Ein Switch verteilt, er verbindet nicht nach drau\xDFen.",
      impact: dienste > 0 ? `${dienste} Kundendienste auf ${dahinter.length} Servern sind nicht erreichbar.` : `${dahinter.length} Server h\xE4ngen daran und w\xE4ren es, sobald sie Kunden bekommen.`,
      remedies: router && port ? [
        {
          label: `An ${router.name} stecken`,
          command: { type: "cable/connect", kind: "router", deviceId: router.id, switchId: sw.id, portIndex: port.index }
        }
      ] : router ? [{ label: "Kein freier Port \u2013 erst einen r\xE4umen", command: null }] : [{ label: "Erst einen Router an diesem Standort aufstellen", command: null }],
      ref: { kind: "switch", id: sw.id }
    });
  }
}
function pickFreePort(world, datacenterId) {
  for (const sw of values(world.switches)) {
    if (sw.datacenterId !== datacenterId) continue;
    if (sw.state !== "online" && sw.state !== "degraded") continue;
    const free2 = freeSwitchPorts(sw)[0];
    if (free2) return { switchId: sw.id, switchName: sw.name, portIndex: free2.index };
  }
  return null;
}
function checkLinks(world, out, explainedRouters) {
  for (const link of values(world.links)) {
    const ownRouter = link.a.routerId ?? link.b.routerId;
    if (ownRouter && explainedRouters.has(ownRouter)) continue;
    if (link.buildTicksRemaining > 0) {
      out.push({
        id: `link-building-${link.id}`,
        severity: "info",
        layer: "strecke",
        title: `${link.name} wird noch gebaut`,
        cause: `Der Carrier schaltet die Strecke in ${link.buildTicksRemaining} h auf.`,
        impact: "Bis dahin tr\xE4gt sie keinen Verkehr.",
        remedies: [{ label: "Abwarten", command: null }],
        ref: { kind: "link", id: link.id }
      });
      continue;
    }
    if (link.state === "down") {
      out.push({
        id: `link-down-${link.id}`,
        severity: link.kind === "transit" ? "critical" : "error",
        layer: "strecke",
        title: `${link.name} ist ausgefallen`,
        cause: link.kind === "transit" || link.kind === "peering-ix" || link.kind === "peering-private" ? "Die \xDCbergabe zum Gegen\xFCber ist unterbrochen \u2013 Faserschaden oder St\xF6rung beim Carrier." : "Die Strecke ist unterbrochen.",
        impact: describeLinkImpact(world, link.id),
        remedies: [
          {
            label: "Auf einen anderen Router-Port umstecken",
            command: null,
            note: "Hilft, wenn der Port defekt ist \u2013 nicht bei einem Schaden an der Leitung."
          },
          { label: "Strecke k\xFCndigen und neu bestellen", command: { type: "link/cancel", linkId: link.id } }
        ],
        ref: { kind: "link", id: link.id }
      });
    } else if (link.state === "degraded") {
      out.push({
        id: `link-degraded-${link.id}`,
        severity: "warning",
        layer: "strecke",
        title: `${link.name} \xFCbertr\xE4gt fehlerhaft`,
        cause: `Die Strecke hat ${link.baseLossPercent.toFixed(1)} % Grundverlust \u2013 das Routing weicht ihr bereits aus.`,
        impact: "H\xF6here Latenz und Paketverlust f\xFCr den Verkehr, der noch dar\xFCber l\xE4uft.",
        remedies: [{ label: "Beim Carrier reklamieren und Ersatz bestellen", command: null }],
        ref: { kind: "link", id: link.id }
      });
    }
    const load = Math.max(link.utilizationMbps.aToB, link.utilizationMbps.bToA) / Math.max(1, link.capacityMbps);
    if (isLinkUsable(link) && load > SIM.LINK_CONGESTION_CRITICAL) {
      out.push({
        id: `link-congested-${link.id}`,
        severity: "error",
        layer: "kapazitaet",
        title: `${link.name} ist \xFCberlastet`,
        cause: `Die Strecke l\xE4uft bei ${(load * 100).toFixed(0)} % von ${link.capacityMbps} Mbit/s. Ab hier fallen Pakete weg.`,
        impact: "Alle Kunden, deren Verkehr hier\xFCber l\xE4uft, sehen Verluste und hohe Latenz.",
        remedies: [
          {
            label: "Kapazit\xE4t verdoppeln",
            command: { type: "link/upgrade", linkId: link.id, capacityMbps: link.capacityMbps * 2 },
            note: "H\xF6here monatliche Kosten."
          },
          { label: "Zweite Strecke aufbauen und Last verteilen", command: null }
        ],
        ref: { kind: "link", id: link.id }
      });
    }
  }
}
function describeLinkImpact(world, linkId) {
  const usable = values(world.links).filter((l) => l.id !== linkId && isLinkUsable(l) && (l.kind === "transit" || l.kind.startsWith("peering")));
  return usable.length === 0 ? "Es bleibt keine weitere Anbindung \u2013 das Netz ist von au\xDFen nicht erreichbar." : `${usable.length} weitere Anbindung(en) tragen den Verkehr, bei entsprechend h\xF6herer Auslastung.`;
}
function checkBgp(world, out, explainedRouters) {
  for (const router of values(world.routers)) {
    if (explainedRouters.has(router.id)) continue;
    for (const neighbor of router.bgp.neighbors) {
      const session = world.sessions[`ses_${router.id}_${neighbor.id}`];
      if (session?.state === "established") continue;
      const link = neighbor.linkId ? world.links[neighbor.linkId] : null;
      if (link && !isLinkUsable(link)) continue;
      if (!neighbor.enabled) {
        out.push({
          id: `bgp-shutdown-${neighbor.id}`,
          severity: "error",
          layer: "bgp",
          title: `BGP-Sitzung zu AS${neighbor.remoteAsn} ist abgeschaltet`,
          cause: session?.lastError === "Route Leak" ? "Die Sitzung wurde nach einem Route Leak automatisch stillgelegt." : "Die Sitzung steht auf Shutdown \u2013 administrativ deaktiviert.",
          impact: `${neighbor.description}: \xDCber diesen Nachbarn kommen und gehen derzeit keine Routen.`,
          remedies: [
            {
              label: "Sitzung wieder aktivieren",
              command: { type: "bgp/updateNeighbor", routerId: router.id, peerId: neighbor.id, patch: { enabled: true } },
              note: "Vorher die Exportregeln pr\xFCfen, sonst wiederholt sich das Problem."
            }
          ],
          ref: { kind: "router", id: router.id }
        });
        continue;
      }
      if (session?.lastError?.includes("max-prefix")) {
        out.push({
          id: `bgp-maxprefix-${neighbor.id}`,
          severity: "error",
          layer: "bgp",
          title: `Max-Prefix-Grenze zu AS${neighbor.remoteAsn} \xFCberschritten`,
          cause: `Der Nachbar sendet mehr Prefixe als die eingestellte Grenze von ${neighbor.maxPrefix.toLocaleString("de-DE")}. Die Sitzung wurde deshalb beendet.`,
          impact: `${neighbor.description}: keine Routen \xFCber diesen Nachbarn.`,
          remedies: [
            {
              label: "Grenze auf 1,5 Mio. anheben",
              command: {
                type: "bgp/updateNeighbor",
                routerId: router.id,
                peerId: neighbor.id,
                patch: { maxPrefix: 15e5 }
              }
            },
            {
              label: "Stattdessen nur die Default-Route beziehen",
              command: {
                type: "bgp/updateNeighbor",
                routerId: router.id,
                peerId: neighbor.id,
                patch: { defaultOriginate: true }
              },
              note: "Schont FIB und Speicher, kostet aber die Wahl des besten Pfades."
            },
            { label: "Sitzung zur\xFCcksetzen", command: { type: "bgp/clearSession", routerId: router.id, peerId: neighbor.id } }
          ],
          ref: { kind: "router", id: router.id }
        });
        continue;
      }
      if (!neighbor.linkId && neighbor.relation !== "ibgp") {
        out.push({
          id: `bgp-nolink-${neighbor.id}`,
          severity: "warning",
          layer: "bgp",
          title: `AS${neighbor.remoteAsn} hat keine Strecke zugeordnet`,
          cause: "Der Nachbar ist konfiguriert, aber es gibt keine physische Verbindung dorthin.",
          impact: "Die Sitzung kommt nie zustande.",
          remedies: [
            { label: "Nachbarn entfernen", command: { type: "bgp/removeNeighbor", routerId: router.id, peerId: neighbor.id } }
          ],
          ref: { kind: "router", id: router.id }
        });
        continue;
      }
      if (session && session.state !== "idle") {
        out.push({
          id: `bgp-converging-${neighbor.id}`,
          severity: "info",
          layer: "bgp",
          title: `Sitzung zu AS${neighbor.remoteAsn} baut sich auf`,
          cause: `Zustand "${session.state}" \u2013 der Aufbau l\xE4uft.`,
          impact: 'Routen fehlen noch, bis der Zustand "established" erreicht ist.',
          remedies: [{ label: "Abwarten", command: null }],
          ref: { kind: "router", id: router.id }
        });
      }
    }
  }
}
function checkAnnouncements(world, out) {
  const announcedAnywhere = /* @__PURE__ */ new Set();
  for (const router of values(world.routers)) {
    for (const prefix of router.bgp.originatedPrefixes) announcedAnywhere.add(prefix);
  }
  const ownPrefixes = values(world.prefixes).filter(
    (p) => (p.source === "rir" || p.source === "purchased") && p.parentId === null
  );
  if (ownPrefixes.length > 0 && announcedAnywhere.size === 0) {
    const router = values(world.routers).find((r) => r.state === "online");
    const candidate = ownPrefixes[0];
    out.push({
      id: "no-announcement",
      severity: "critical",
      layer: "ankuendigung",
      title: "Kein eigenes Netz wird angek\xFCndigt",
      cause: world.company.asn === 0 ? "Ohne eigene AS-Nummer l\xE4sst sich nichts ank\xFCndigen." : "Es sind eigene Adressbl\xF6cke vorhanden, aber keiner davon wird per BGP bekannt gegeben.",
      impact: "Kein Netz der Welt wei\xDF, wie es zu deinen Kunden findet. Alles wirkt offline.",
      remedies: router && world.company.asn !== 0 ? [
        {
          label: `${cidrOf(candidate)} ank\xFCndigen`,
          command: { type: "bgp/announce", routerId: router.id, prefix: cidrOf(candidate) }
        }
      ] : [{ label: "Eigene AS-Nummer beantragen", command: null }]
    });
  }
  for (const prefix of ownPrefixes) {
    if (announcedAnywhere.has(cidrOf(prefix))) continue;
    if (prefix.usage === "unassigned") continue;
    out.push({
      id: `prefix-silent-${prefix.id}`,
      severity: "warning",
      layer: "ankuendigung",
      title: `${cidrOf(prefix)} wird nicht angek\xFCndigt`,
      cause: "Der Block ist f\xFCr Kunden vorgesehen, wird aber nicht per BGP bekannt gegeben.",
      impact: "Adressen daraus sind aus dem Internet nicht erreichbar.",
      remedies: (() => {
        const router = values(world.routers).find((r) => r.state === "online");
        return router ? [
          { label: "Jetzt ank\xFCndigen", command: { type: "bgp/announce", routerId: router.id, prefix: cidrOf(prefix) } },
          {
            label: "Block abgeben",
            command: { type: "ipam/sellBlock", prefixId: prefix.id },
            note: `Spart ${prefix.monthlyCost.toLocaleString("de-DE")} \u20AC/Monat.`
          }
        ] : [];
      })(),
      ref: { kind: "prefix", id: prefix.id }
    });
  }
}
function checkLoadBalancing(world, out) {
  for (const balancer of values(world.loadBalancers)) {
    for (const pool of balancer.pools) {
      if (pool.contractIds.length === 0) continue;
      const serving = pool.members.filter((m) => {
        const server = world.servers[m.serverId];
        return m.healthy && !m.drain && server && (server.state === "online" || server.state === "degraded");
      });
      if (serving.length === 0) {
        out.push({
          id: `pool-empty-${pool.id}`,
          severity: "critical",
          layer: "geraet",
          title: `Pool \u201E${pool.name}\u201C liefert nichts aus`,
          cause: pool.members.length === 0 ? "Der Pool hat kein einziges Mitglied." : "Alle Mitglieder sind ausgefallen, im Abzug oder nicht erreichbar.",
          impact: `${pool.contractIds.length} Vertr\xE4ge sind offline.`,
          remedies: [
            { label: "Server in den Pool aufnehmen", command: null, note: "Unter Netz \u2192 Loadbalancer." },
            ...pool.members.filter((m) => m.drain).slice(0, 1).map((m) => ({
              label: `${world.servers[m.serverId]?.name ?? "Mitglied"} aus dem Abzug holen`,
              command: { type: "lb/setDrain", poolId: pool.id, serverId: m.serverId, drain: false },
              note: "Es nimmt danach sofort wieder Sitzungen an."
            }))
          ],
          ref: { kind: "loadbalancer", id: balancer.id }
        });
        continue;
      }
      if (serving.length === 1) {
        out.push({
          id: `pool-single-member-${pool.id}`,
          severity: "warning",
          layer: "geraet",
          title: `Pool \u201E${pool.name}\u201C h\xE4ngt an einem einzigen Knoten`,
          cause: `Nur ${world.servers[serving[0].serverId]?.name ?? "ein Server"} liefert aus. Ein Pool mit einem Mitglied ist ein Umweg, keine Redundanz.`,
          impact: `${pool.contractIds.length} Vertr\xE4ge fallen aus, sobald dieser Knoten stirbt \u2013 dann sogar samt Balancer im Pfad.`,
          remedies: [
            {
              label: "Zweiten Server aufnehmen",
              command: null,
              note: "Er muss die gesamte Pool-Last allein tragen k\xF6nnen \u2013 genau das ist der Zweck."
            }
          ],
          ref: { kind: "loadbalancer", id: balancer.id }
        });
      }
      const stateful = pool.contractIds.some((id) => {
        const contract = world.contracts[id];
        const kind = contract ? world.products[contract.productId]?.kind : void 0;
        return kind === "shared-hosting" || kind === "mail";
      });
      if (stateful && !pool.sessionPersistence && serving.length > 1) {
        out.push({
          id: `pool-no-persistence-${pool.id}`,
          severity: "warning",
          layer: "geraet",
          title: `\u201E${pool.name}\u201C verteilt Sitzungen auseinander`,
          cause: "Der Pool tr\xE4gt zustandsbehaftete Anwendungen, verteilt aber ohne Sitzungsbindung. Derselbe Besucher landet bei jeder Anfrage auf einem anderen Knoten.",
          impact: "Kunden werden mitten im Arbeiten abgemeldet und beschweren sich \u2013 das ist kein Ausfall, sieht f\xFCr sie aber wie einer aus.",
          remedies: [
            {
              label: "Sitzungsbindung einschalten",
              command: { type: "lb/updatePool", poolId: pool.id, patch: { sessionPersistence: true } },
              note: "Kostet etwas Gleichverteilung und behebt das Problem sofort."
            }
          ],
          ref: { kind: "loadbalancer", id: balancer.id }
        });
      }
    }
    const carrying = balancer.pools.reduce((sum3, pool) => sum3 + pool.contractIds.length, 0);
    if (carrying > 0 && !balancer.peerId) {
      out.push({
        id: `lb-single-${balancer.id}`,
        severity: "warning",
        layer: "geraet",
        title: `${balancer.name} steht allein im Pfad`,
        cause: "Hinter dem Balancer sind die Server redundant \u2013 vor ihm ist es niemand. Sein Ausfall nimmt alles mit, was er tr\xE4gt.",
        impact: `${carrying} Vertr\xE4ge h\xE4ngen an diesem einen Ger\xE4t.`,
        remedies: [
          {
            label: "Zweiten Balancer kaufen und koppeln",
            command: null,
            note: "Die Reserve \xFCbernimmt die virtuelle Adresse von selbst; die Kunden merken nichts."
          }
        ],
        ref: { kind: "loadbalancer", id: balancer.id }
      });
    }
    if (balancer.load > 0.9 && carrying > 0) {
      out.push({
        id: `lb-overload-${balancer.id}`,
        severity: "error",
        layer: "kapazitaet",
        title: `${balancer.name} ist am Anschlag`,
        cause: `Die Auslastung liegt bei ${Math.round(balancer.load * 100)} %. \xDCber der Grenze weist er Verbindungen ab.`,
        impact: "Besucher sehen Fehlerseiten, obwohl alle Server laufen \u2013 der schwerste Fehler zum Suchen.",
        remedies: [
          {
            label: "TLS zur\xFCck auf die Backends legen",
            command: null,
            note: "Nimmt die Handshakes vom Balancer. Kostet Rechenleistung auf den Servern, kauft aber Zeit."
          },
          { label: "Gr\xF6\xDFeres Ger\xE4t beschaffen", command: null, note: "Unter Netz \u2192 Loadbalancer." }
        ],
        ref: { kind: "loadbalancer", id: balancer.id }
      });
    }
  }
}
function checkRedundancy(world, out) {
  for (const dc of values(world.datacenters)) {
    if ((dc.powerFeeds?.count ?? 1) > 1) continue;
    const devices = [
      ...values(world.servers),
      ...values(world.routers),
      ...values(world.switches)
    ].filter((d) => d.datacenterId === dc.id).length;
    if (devices === 0) continue;
    const setup = Math.round(dc.powerCapacityKw * 55);
    const monthly = Math.round(dc.powerCapacityKw * 1.8);
    out.push({
      id: `single-power-feed-${dc.id}`,
      severity: dc.generator.installed ? "info" : "warning",
      layer: "strom",
      title: `${dc.name} h\xE4ngt an einer einzigen Zuleitung`,
      cause: dc.generator.installed ? "Es gibt einen Generator, aber nur eine Netzeinspeisung. F\xE4llt sie aus, l\xE4uft alles auf Diesel \u2013 bis der Tank leer ist." : "Eine Zuleitung, kein Generator. Ein Netzausfall nimmt den ganzen Standort mit, sobald die USV leer ist.",
      impact: `${devices} Ger\xE4te am Standort h\xE4ngen an diesem einen Strang.`,
      remedies: [
        {
          label: "Zweite Netzeinspeisung schalten",
          command: { type: "dc/addPowerFeed", datacenterId: dc.id },
          note: `${setup.toLocaleString("de-DE")} \u20AC einmalig, ${monthly.toLocaleString("de-DE")} \u20AC/Monat. F\xE4ngt den Ausfall einer Zuleitung ab.`
        },
        ...dc.generator.installed ? [] : [
          {
            label: "Notstromgenerator installieren",
            command: { type: "dc/installGenerator", datacenterId: dc.id },
            note: "\xDCberbr\xFCckt Stunden, nicht Tage \u2013 die zweite Zuleitung ist der bessere Schutz."
          }
        ]
      ],
      ref: { kind: "datacenter", id: dc.id }
    });
  }
  const external = values(world.links).filter(
    (l) => l.kind === "transit" || l.kind === "peering-ix" || l.kind === "peering-private"
  );
  const transits = external.filter((l) => l.kind === "transit");
  const tragende = transits.filter((l) => !l.standby);
  if (transits.length === 1 && external.length <= 1) {
    const link = transits[0];
    out.push({
      id: "single-transit",
      severity: "warning",
      layer: "strecke",
      title: "Nur ein Upstream",
      cause: `Die gesamte Anbindung h\xE4ngt an ${link.name}. F\xE4llt die Strecke oder der Anbieter aus, ist das Netz weg.`,
      impact: "Bei einem Ausfall sind alle Kunden gleichzeitig offline \u2013 ohne dass du etwas tun kannst.",
      remedies: [
        {
          label: "Reserve-Transit bei einem zweiten Anbieter buchen",
          command: null,
          note: "Unter Netz \u2192 Leitungen. Als Reserve gef\xFChrt kostet er nur den Commit und \xFCbernimmt bei Ausfall von selbst."
        },
        {
          label: "An einem Internetknoten peeren",
          command: null,
          note: "Senkt zus\xE4tzlich die Transitkosten."
        }
      ],
      ref: { kind: "link", id: link.id }
    });
  }
  if (transits.length > 0 && tragende.length === 0) {
    out.push({
      id: "only-standby-transit",
      severity: "error",
      layer: "strecke",
      title: "Alle Transitstrecken sind als Reserve gef\xFChrt",
      cause: "Keine Strecke tr\xE4gt im Regelbetrieb \u2013 Reserve bedeutet, dass sie gemieden wird.",
      impact: "Der Verkehr nimmt notgedrungen trotzdem diesen Weg, aber die Kostenrechnung stimmt nicht mehr.",
      remedies: transits.slice(0, 2).map((link) => ({
        label: `${link.name} in den Regelbetrieb nehmen`,
        command: { type: "link/setStandby", linkId: link.id, standby: false }
      }))
    });
  }
}
function checkCapacity(world, out) {
  const external = values(world.links).filter(
    (l) => l.kind === "transit" || l.kind === "peering-ix" || l.kind === "peering-private"
  );
  if (external.length === 0) {
    out.push({
      id: "no-upstream",
      severity: "critical",
      layer: "strecke",
      title: "Keine Anbindung ans Internet",
      cause: "Es besteht weder ein Transitvertrag noch ein Peering.",
      impact: "Nichts ist von au\xDFen erreichbar, es kommen keine Kunden.",
      remedies: [{ label: "Transit bestellen", command: null, note: "Unter Netz \u2192 Strecken einen Anbieter w\xE4hlen." }]
    });
  } else if (external.filter((l) => isLinkUsable(l)).length === 0) {
    out.push({
      id: "all-upstreams-down",
      severity: "critical",
      layer: "strecke",
      title: "Alle Anbindungen sind gest\xF6rt",
      cause: `${external.length} externe Strecke(n) vorhanden, aber keine davon ist nutzbar.`,
      impact: "Das Netz ist vollst\xE4ndig vom Internet getrennt.",
      remedies: [{ label: "St\xF6rungen an den Strecken beheben", command: null }]
    });
  }
  for (const router of values(world.routers)) {
    const fullTablePeers = router.bgp.neighbors.filter(
      (n) => n.enabled && n.relation === "transit" && !n.defaultOriginate
    );
    if (fullTablePeers.length === 0) continue;
    if (router.fibCapacity >= 9e5) continue;
    out.push({
      id: `fib-too-small-${router.id}`,
      severity: "error",
      layer: "kapazitaet",
      title: `${router.name} kann keine volle Routingtabelle halten`,
      cause: `Das Modell fasst ${router.fibCapacity.toLocaleString("de-DE")} Eintr\xE4ge, eine volle Tabelle hat rund 985.000.`,
      impact: "Pakete zu Zielen, die nicht mehr in die Tabelle passen, werden verworfen.",
      remedies: [
        ...fullTablePeers.map((n) => ({
          label: `Von AS${n.remoteAsn} nur die Default-Route beziehen`,
          command: { type: "bgp/updateNeighbor", routerId: router.id, peerId: n.id, patch: { defaultOriginate: true } },
          note: "Sofort wirksam und kostenlos; daf\xFCr entf\xE4llt die Wahl des besten Pfades."
        })),
        { label: "Gr\xF6\xDFeren Router einsetzen", command: null, note: "CoreRoute M oder gr\xF6\xDFer h\xE4lt die volle Tabelle." }
      ],
      ref: { kind: "router", id: router.id }
    });
  }
  for (const server of values(world.servers)) {
    const total = server.ssdGb + server.hddGb;
    if (total === 0) continue;
    const free2 = freeDiskShare(world, server.id);
    if (free2 > 1 - SIM.DISK_WARN) continue;
    out.push({
      id: `disk-full-${server.id}`,
      severity: free2 <= 0.02 ? "error" : "warning",
      layer: "kapazitaet",
      title: `${server.name}: Speicher fast voll`,
      cause: `Nur noch ${(free2 * 100).toFixed(1)} % frei von ${total.toLocaleString("de-DE")} GB.`,
      impact: "Neue Kunden passen nicht mehr darauf; bestehende laufen in Schreibfehler.",
      remedies: [
        { label: "Laufwerke nachr\xFCsten", command: null, note: "Bauteil bestellen, dann Wartungsfenster planen." },
        { label: "Kunden auf einen anderen Knoten verlegen", command: null }
      ],
      ref: { kind: "server", id: server.id }
    });
  }
}
function freeDiskShare(world, serverId) {
  const server = world.servers[serverId];
  if (!server) return 1;
  let used = 0;
  for (const vpsId of server.vpsIds) used += world.vpsInstances[vpsId]?.diskGb ?? 0;
  for (const contractId of server.contractIds) {
    const product = world.products[world.contracts[contractId]?.productId ?? ""];
    if (product) used += product.resources.ssdGb + product.resources.hddGb;
  }
  const total = server.ssdGb + server.hddGb;
  return total > 0 ? Math.max(0, 1 - used / total) : 1;
}
function primaryIssue(world) {
  const findings = diagnose(world);
  return findings.find((f) => f.severity === "critical" || f.severity === "error") ?? null;
}

// src/domain/network/peering.ts
var ok2 = (message, createdId) => ({ ok: true, message, createdId });
var fail2 = (message) => ({ ok: false, message });
var POLICY_LABEL = {
  open: "offen",
  selective: "selektiv",
  restrictive: "restriktiv"
};
function emptyHygiene() {
  return {
    rpkiSigned: false,
    rpkiValidating: false,
    irrRegistered: false,
    irrFiltering: false,
    manrsCompliant: false,
    irrUpdatedAtTick: null
  };
}
function recomputeManrs(hygiene) {
  hygiene.manrsCompliant = hygiene.rpkiSigned && hygiene.rpkiValidating && hygiene.irrRegistered && hygiene.irrFiltering;
}
var HYGIENE_COSTS = {
  rpkiSigned: { setup: 1200, monthly: 40 },
  rpkiValidating: { setup: 2400, monthly: 90 },
  irrRegistered: { setup: 600, monthly: 25 },
  irrFiltering: { setup: 1800, monthly: 70 }
};
var HYGIENE_LABEL = {
  rpkiSigned: "Eigene Prefixe per ROA signieren",
  rpkiValidating: "Eingehende Routen gegen RPKI pr\xFCfen",
  irrRegistered: "IRR-Objekte pflegen (route, as-set)",
  irrFiltering: "Eingehend nach IRR-Prefixlisten filtern"
};
var HYGIENE_DESCRIPTION = {
  rpkiSigned: "Ohne Signatur k\xF6nnen Fremde deine Netze ank\xFCndigen, ohne dass es jemand merkt. Viele Knoten und alle seri\xF6sen Netze setzen es voraus.",
  rpkiValidating: "Verhindert, dass du selbst auf einen fremden Hijack hereinf\xE4llst und den Verkehr deiner Kunden ins Leere leitest.",
  irrRegistered: "Ohne IRR-Objekte bauen andere keine Filterlisten f\xFCr dich \u2013 und lassen deine Routen deshalb fallen.",
  irrFiltering: "Verhindert, dass du fremde Fehler weitertr\xE4gst. Ein durchgereichter Route Leak kostet Ruf und Peerings."
};
function enableHygiene(world, measure) {
  const hygiene = world.company.hygiene;
  if (hygiene[measure]) return fail2("Diese Ma\xDFnahme l\xE4uft bereits.");
  if (measure === "rpkiSigned" && world.company.asn === 0) {
    return fail2("Ohne eigene AS-Nummer gibt es nichts zu signieren.");
  }
  hygiene[measure] = true;
  if (measure === "irrRegistered") hygiene.irrUpdatedAtTick = world.meta.tick;
  recomputeManrs(hygiene);
  return ok2(
    `${HYGIENE_LABEL[measure]}: aktiv.` + (hygiene.manrsCompliant ? " Damit ist das Netz MANRS-konform \u2013 das \xF6ffnet T\xFCren beim Peering." : "")
  );
}
function assessPeering(world, provider, via) {
  const hygiene = world.company.hygiene;
  const ownTraffic = world.derived.traffic.totalMbps;
  const requirements = [];
  const rpkiOk = !provider.requiresRpki || hygiene.rpkiSigned && hygiene.irrRegistered;
  requirements.push({
    label: "Signierte Routen und IRR-Objekte",
    met: rpkiOk,
    detail: provider.requiresRpki ? "Der Partner filtert nach RPKI und IRR. Ohne beides landen deine Routen im Papierkorb." : "Der Partner verlangt es nicht, erwartet es aber mittelfristig."
  });
  const trafficOk = ownTraffic >= provider.minTrafficMbps;
  requirements.push({
    label: `Mindestens ${provider.minTrafficMbps} Mbit/s Verkehr`,
    met: trafficOk,
    detail: `Dein Netz \xFCbertr\xE4gt derzeit ${ownTraffic.toFixed(0)} Mbit/s. Unterhalb der Schwelle lohnt der Aufwand f\xFCr den Partner nicht.`
  });
  const estimatedRatio = estimateRatio(world, provider);
  const ratioOk = estimatedRatio <= provider.maxRatio;
  requirements.push({
    label: `Verkehrsverh\xE4ltnis h\xF6chstens ${provider.maxRatio.toFixed(1)} : 1`,
    met: ratioOk,
    detail: `Erwartet werden etwa ${estimatedRatio.toFixed(1)} : 1 (ausgehend zu eingehend). ` + (provider.kind === "eyeball" ? "Zugangsnetze nehmen gern Verkehr entgegen \u2013 hier ist das kein Hindernis." : "Netze mit \xE4hnlichem Profil sehen darin wenig Gegenwert.")
  });
  const policyOk = provider.peeringPolicy !== "restrictive";
  requirements.push({
    label: "Peering-Politik des Partners",
    met: policyOk,
    detail: provider.peeringPolicy === "restrictive" ? "Das Netz peert grunds\xE4tzlich nicht mit kleineren Netzen \u2013 es verkauft lieber Transit." : `Politik: ${POLICY_LABEL[provider.peeringPolicy]}.`
  });
  const reputationBonus = (world.company.reputation - 50) / 200;
  const manrsBonus = hygiene.manrsCompliant ? 0.15 : 0;
  if (via.kind === "route-server") {
    const accepted2 = rpkiOk && provider.peeringPolicy === "open";
    return {
      accepted: accepted2,
      decisionTicks: 0,
      reason: accepted2 ? "\xDCber den Route-Server l\xE4uft das automatisch." : provider.peeringPolicy === "open" ? "Der Route-Server verlangt g\xFCltige Signaturen." : "Das Netz h\xE4ngt nicht am Route-Server, sondern verhandelt einzeln.",
      monthlyCost: 0,
      requirements: requirements.slice(0, 1)
    };
  }
  if (!policyOk) {
    return {
      accepted: false,
      decisionTicks: SIM.TICKS_PER_DAY * 3,
      reason: `${provider.name} peert grunds\xE4tzlich nicht mit Netzen dieser Gr\xF6\xDFe. Transit bleibt der einzige Weg dorthin.`,
      monthlyCost: 0,
      requirements
    };
  }
  const hardFailures = requirements.filter((r) => !r.met && r.label !== "Peering-Politik des Partners");
  const paidOption = provider.kind === "eyeball" && hardFailures.length <= 1;
  if (provider.peeringPolicy === "open") {
    const accepted2 = rpkiOk;
    return {
      accepted: accepted2,
      decisionTicks: SIM.TICKS_PER_DAY * (1 + Math.round(Math.random() * 0)) + 12,
      reason: accepted2 ? `${provider.name} peert offen und stimmt zu.` : "Auch ein offenes Netz erwartet signierte Routen.",
      monthlyCost: 0,
      requirements
    };
  }
  const score = (rpkiOk ? 0.35 : 0) + (trafficOk ? 0.3 : 0) + (ratioOk ? 0.25 : 0) + reputationBonus + manrsBonus + provider.peeringWillingness * 0.2;
  const accepted = score >= 0.75;
  return {
    accepted,
    decisionTicks: SIM.TICKS_PER_DAY * (3 + Math.floor(provider.reach * 10)),
    reason: accepted ? `${provider.name} stimmt zu.` : paidOption ? `${provider.name} lehnt kostenloses Peering ab, bietet aber bezahltes Peering an.` : `${provider.name} lehnt ab: ${hardFailures.map((r) => r.label).join(", ") || "zu wenig Gegenwert"}.`,
    monthlyCost: !accepted && paidOption ? Math.round(120 + provider.reach * 900) : 0,
    requirements
  };
}
function estimateRatio(world, provider) {
  const base = 4.5;
  switch (provider.kind) {
    case "eyeball":
      return base;
    case "content":
      return base * 0.35;
    case "tier1":
    case "tier2":
      return base * 0.8;
    default:
      return base;
  }
}
function requestPeering(world, rng, input) {
  const provider = world.market.providers.find((p) => p.asn === input.peerAsn);
  if (!provider) return fail2("Netz unbekannt.");
  const existing = values(world.peerings).find(
    (p) => p.peerAsn === input.peerAsn && (p.state === "active" || p.state === "requested")
  );
  if (existing) {
    return fail2(
      existing.state === "active" ? `Mit ${provider.name} besteht bereits ein Peering.` : `Die Anfrage an ${provider.name} l\xE4uft noch.`
    );
  }
  if (input.via.kind === "ix" || input.via.kind === "route-server") {
    const ixp = world.ixps[input.via.ixpId];
    if (!ixp?.joined) return fail2("An diesem Knoten besteht keine Mitgliedschaft.");
    if (!provider.ixpIds.includes(ixp.id)) return fail2(`${provider.name} ist an ${ixp.name} nicht pr\xE4sent.`);
    if (input.via.kind === "route-server" && !ixp.routeServer.connected) {
      return fail2(`Die Sitzung zum Route-Server von ${ixp.name} steht noch nicht.`);
    }
  } else {
    const link = world.links[input.via.linkId];
    if (!link) return fail2("Direktverbindung nicht gefunden.");
  }
  const assessment = assessPeering(world, provider, input.via);
  const id = makeId(rng, "peer-rel");
  world.peerings[id] = {
    id,
    peerAsn: provider.asn,
    via: input.via,
    state: assessment.decisionTicks === 0 ? assessment.accepted ? "active" : "rejected" : "requested",
    requestedAtTick: world.meta.tick,
    decidesAtTick: assessment.decisionTicks === 0 ? null : world.meta.tick + assessment.decisionTicks,
    establishedAtTick: assessment.decisionTicks === 0 && assessment.accepted ? world.meta.tick : null,
    note: assessment.reason,
    ratio: 0,
    monthlyCost: assessment.monthlyCost,
    trafficMbps: 0
  };
  if (assessment.decisionTicks === 0) {
    if (assessment.accepted) {
      attachSession(world, rng, world.peerings[id], provider);
      return ok2(assessment.reason, id);
    }
    return fail2(assessment.reason);
  }
  return ok2(
    `Anfrage an ${provider.name} gestellt. Antwort in etwa ${Math.round(assessment.decisionTicks / SIM.TICKS_PER_DAY)} Tagen.`,
    id
  );
}
function attachSession(world, rng, relation, provider) {
  const linkId = resolveLink(world, relation);
  if (!linkId) return;
  const link = world.links[linkId];
  const routerId = link?.a.routerId ?? link?.b.routerId;
  const router = routerId ? world.routers[routerId] : null;
  if (!router) return;
  if (router.bgp.neighbors.some((n) => n.remoteAsn === provider.asn && n.linkId === linkId)) return;
  router.bgp.neighbors.push({
    id: asId(makeId(rng, "peer")),
    address: `192.0.2.${provider.asn % 200 + 10}`,
    remoteAsn: provider.asn,
    description: `${provider.name} (${describeVia(world, relation.via)})`,
    relation: "peer",
    linkId,
    enabled: true,
    routeMapIn: null,
    routeMapOut: null,
    maxPrefix: 25e4,
    defaultOriginate: false,
    prependOut: 0,
    localPrefIn: 200,
    medOut: null
  });
}
function resolveLink(world, relation) {
  if (relation.via.kind === "pni") return relation.via.linkId;
  const ixpId = relation.via.ixpId;
  return values(world.links).find((l) => l.ixpId === ixpId)?.id ?? null;
}
function describeVia(world, via) {
  switch (via.kind) {
    case "ix":
      return world.ixps[via.ixpId]?.name ?? "IXP";
    case "route-server":
      return `${world.ixps[via.ixpId]?.name ?? "IXP"} Route-Server`;
    case "pni":
      return "PNI";
  }
}
function advancePeerings(world, rng) {
  const report = { decided: [], terminated: [] };
  for (const relation of values(world.peerings)) {
    const provider = world.market.providers.find((p) => p.asn === relation.peerAsn);
    if (!provider) continue;
    if (relation.state === "requested") {
      if (relation.decidesAtTick === null || world.meta.tick < relation.decidesAtTick) continue;
      const assessment = assessPeering(world, provider, relation.via);
      relation.note = assessment.reason;
      relation.monthlyCost = assessment.monthlyCost;
      if (assessment.accepted) {
        relation.state = "active";
        relation.establishedAtTick = world.meta.tick;
        attachSession(world, rng, relation, provider);
      } else {
        relation.state = "rejected";
      }
      report.decided.push({ name: provider.name, accepted: assessment.accepted, note: assessment.reason });
      continue;
    }
    if (relation.state !== "active") continue;
    const linkId = resolveLink(world, relation);
    const link = linkId ? world.links[linkId] : null;
    if (link) {
      const share = provider.reach / Math.max(0.05, sumReachOnLink(world, link.id));
      const total = link.utilizationMbps.aToB + link.utilizationMbps.bToA;
      relation.trafficMbps = total * share;
      const outbound = link.utilizationMbps.aToB * share;
      const inbound = link.utilizationMbps.bToA * share;
      relation.ratio = inbound > 0.01 ? outbound / inbound : outbound > 0 ? 99 : 0;
    }
    if (world.meta.tick % (SIM.TICKS_PER_DAY * 7) !== 0) continue;
    if (relation.establishedAtTick !== null && world.meta.tick - relation.establishedAtTick < SIM.TICKS_PER_MONTH) {
      continue;
    }
    const reason = terminationReason(world, provider, relation);
    if (!reason) continue;
    if (!rng.chance(0.35)) continue;
    relation.state = "terminated";
    relation.note = reason;
    detachSession(world, relation, provider);
    report.terminated.push({ name: provider.name, reason });
  }
  return report;
}
function sumReachOnLink(world, linkId) {
  let sum3 = 0;
  for (const relation of values(world.peerings)) {
    if (relation.state !== "active") continue;
    if (resolveLink(world, relation) !== linkId) continue;
    const provider = world.market.providers.find((p) => p.asn === relation.peerAsn);
    if (provider) sum3 += provider.reach;
  }
  return sum3;
}
function terminationReason(world, provider, relation) {
  if (relation.via.kind === "route-server") {
    return provider.requiresRpki && !world.company.hygiene.rpkiSigned ? "Der Knoten hat die Sitzung wegen fehlender RPKI-Signaturen gefiltert." : null;
  }
  if (provider.peeringPolicy === "open") return null;
  if (provider.requiresRpki && !world.company.hygiene.rpkiSigned) {
    return `${provider.name} verlangt inzwischen signierte Routen und hat das Peering beendet.`;
  }
  if (relation.ratio > provider.maxRatio * 1.6 && relation.trafficMbps > 50) {
    return `Das Verkehrsverh\xE4ltnis liegt bei ${relation.ratio.toFixed(1)} : 1 statt der vereinbarten ${provider.maxRatio.toFixed(1)} : 1. ${provider.name} hat gek\xFCndigt.`;
  }
  if (relation.trafficMbps < provider.minTrafficMbps * 0.2 && relation.trafficMbps >= 0) {
    return `\xDCber das Peering l\xE4uft kaum Verkehr (${relation.trafficMbps.toFixed(0)} Mbit/s). ${provider.name} hat es aufgel\xF6st.`;
  }
  if (world.company.reputation < 25) {
    return `${provider.name} hat das Peering wegen des schlechten Rufs beendet.`;
  }
  return null;
}
function detachSession(world, relation, provider) {
  const linkId = resolveLink(world, relation);
  for (const router of values(world.routers)) {
    const before = router.bgp.neighbors.length;
    router.bgp.neighbors = router.bgp.neighbors.filter(
      (n) => !(n.remoteAsn === provider.asn && n.relation === "peer" && (linkId === null || n.linkId === linkId))
    );
    if (router.bgp.neighbors.length !== before) {
      for (const session of values(world.sessions)) {
        if (session.routerId === router.id && session.remoteAsn === provider.asn) {
          delete world.sessions[session.id];
        }
      }
    }
  }
}
function terminatePeering(world, relationId) {
  const relation = world.peerings[relationId];
  if (!relation) return fail2("Peering nicht gefunden.");
  if (relation.state !== "active") return fail2("Dieses Peering ist nicht aktiv.");
  const provider = world.market.providers.find((p) => p.asn === relation.peerAsn);
  relation.state = "terminated";
  relation.note = "Von eigener Seite gek\xFCndigt.";
  if (provider) detachSession(world, relation, provider);
  return ok2(`Peering mit ${provider?.name ?? `AS${relation.peerAsn}`} beendet.`);
}
function connectRouteServer(world, rng, ixpId) {
  const ixp = world.ixps[ixpId];
  if (!ixp) return fail2("Knoten nicht gefunden.");
  if (!ixp.joined) return fail2("An diesem Knoten besteht keine Mitgliedschaft.");
  if (!ixp.routeServer.available) return fail2(`${ixp.name} betreibt keinen Route-Server.`);
  if (ixp.routeServer.connected) return fail2("Die Sitzung steht bereits.");
  if (ixp.routeServer.requiresRpki && !world.company.hygiene.rpkiSigned) {
    return fail2(
      `${ixp.name} l\xE4sst an den Route-Server nur Netze mit signierten Routen. Zuerst die eigenen Prefixe per ROA signieren.`
    );
  }
  ixp.routeServer.connected = true;
  const openMembers = world.market.providers.filter(
    (p) => p.ixpIds.includes(ixp.id) && p.atRouteServer && p.peeringPolicy === "open"
  );
  let established = 0;
  for (const provider of openMembers) {
    const existing = values(world.peerings).find((p) => p.peerAsn === provider.asn && p.state === "active");
    if (existing) continue;
    const id = makeId(rng, "peer-rel");
    world.peerings[id] = {
      id,
      peerAsn: provider.asn,
      via: { kind: "route-server", ixpId: ixp.id },
      state: "active",
      requestedAtTick: world.meta.tick,
      decidesAtTick: null,
      establishedAtTick: world.meta.tick,
      note: "\xDCber den Route-Server.",
      ratio: 0,
      monthlyCost: 0,
      trafficMbps: 0
    };
    attachSession(world, rng, world.peerings[id], provider);
    established += 1;
  }
  return ok2(
    `Sitzung zum Route-Server von ${ixp.name} steht. ${established} Netze sind damit sofort direkt erreichbar` + (established > 0 ? " \u2013 ohne einzelne Verhandlung." : ".")
  );
}
function peeringOverview(world) {
  const relations = values(world.peerings);
  const active = relations.filter((r) => r.state === "active");
  const traffic = world.derived.traffic;
  const peeringShare = traffic.totalMbps > 0 ? traffic.peeringMbps / traffic.totalMbps : 0;
  const transitPrice = values(world.links).filter((l) => l.kind === "transit" && isLinkUsable(l)).reduce((sum3, l) => sum3 + l.pricePerMbps, 0) / Math.max(1, values(world.links).filter((l) => l.kind === "transit" && isLinkUsable(l)).length);
  const monthlySavings = Math.round(traffic.peeringMbps * (transitPrice || 0.25));
  const paidPeeringCost = active.reduce((sum3, r) => sum3 + r.monthlyCost, 0);
  const candidates = [];
  for (const ixp of values(world.ixps)) {
    if (!ixp.joined) continue;
    for (const provider of world.market.providers) {
      if (!provider.ixpIds.includes(ixp.id)) continue;
      if (relations.some((r) => r.peerAsn === provider.asn && (r.state === "active" || r.state === "requested"))) continue;
      const via = provider.atRouteServer && ixp.routeServer.connected && provider.peeringPolicy === "open" ? { kind: "route-server", ixpId: ixp.id } : { kind: "ix", ixpId: ixp.id };
      candidates.push({ provider, via, assessment: assessPeering(world, provider, via) });
    }
  }
  candidates.sort((a, b) => b.provider.reach - a.provider.reach);
  return {
    active: active.length,
    requested: relations.filter((r) => r.state === "requested").length,
    peeringShare,
    monthlySavings,
    paidPeeringCost,
    candidates
  };
}
function paidPeeringMonthlyCost(world) {
  return values(world.peerings).filter((r) => r.state === "active").reduce((sum3, r) => sum3 + r.monthlyCost, 0);
}
function ixpPortLoad(world, ixpId) {
  const ixp = world.ixps[ixpId];
  const link = values(world.links).find((l) => l.ixpId === ixpId);
  const capacityMbps = ixp?.portCapacityMbps ?? 0;
  const usedMbps = link ? Math.max(link.utilizationMbps.aToB, link.utilizationMbps.bToA) : 0;
  return { usedMbps, capacityMbps, share: capacityMbps > 0 ? clamp(usedMbps / capacityMbps, 0, 2) : 0 };
}

// src/domain/network/services.ts
function createVlan(world, rng, input) {
  if (input.tag < 1 || input.tag > 4094) throw new Error("VLAN-Tag muss zwischen 1 und 4094 liegen");
  const duplicate = values(world.vlans).find((v) => v.tag === input.tag && v.datacenterId === input.datacenterId);
  if (duplicate) throw new Error(`VLAN ${input.tag} existiert am Standort bereits`);
  const vlan = {
    id: asId(makeId(rng, "vlan")),
    tag: input.tag,
    name: input.name,
    datacenterId: input.datacenterId,
    prefixIds: [],
    dhcp: null,
    description: input.description ?? ""
  };
  world.vlans[vlan.id] = vlan;
  return vlan;
}
function assignPrefixToVlan(world, vlanId, prefixId) {
  const vlan = world.vlans[vlanId];
  const prefix = world.prefixes[prefixId];
  if (!vlan) throw new Error("VLAN nicht gefunden");
  if (!prefix) throw new Error("Prefix nicht gefunden");
  if (!vlan.prefixIds.includes(prefixId)) vlan.prefixIds.push(prefixId);
  prefix.assignedTo = { kind: "vlan", id: vlanId };
  if (prefix.usage === "unassigned") prefix.usage = "infrastructure";
}
function validateSwitchVlans(world, switchId) {
  const sw = world.switches[switchId];
  if (!sw) return ["Switch nicht gefunden"];
  const problems = [];
  const trunkVlans = /* @__PURE__ */ new Set();
  for (const port of sw.ports) {
    if (port.mode === "trunk" && port.enabled) {
      for (const v of port.allowedVlans) trunkVlans.add(v);
      trunkVlans.add(port.vlanId);
    }
  }
  for (const port of sw.ports) {
    if (port.mode !== "access" || !port.enabled || !port.connectedDevice) continue;
    if (!trunkVlans.has(port.vlanId)) {
      problems.push(`Port ${port.index}: VLAN ${port.vlanId} wird auf keinem Uplink getrunkt \u2013 das Ger\xE4t ist isoliert.`);
    }
  }
  return problems;
}
function createVrf(world, rng, input) {
  const vrf = {
    id: asId(makeId(rng, "vrf")),
    name: input.name,
    rd: input.rd,
    importTargets: [input.rd],
    exportTargets: [input.rd],
    description: input.description ?? ""
  };
  world.vrfs[vrf.id] = vrf;
  return vrf;
}
function createDhcpPool(world, vlanId, prefixId, leaseSeconds = 86400) {
  const vlan = world.vlans[vlanId];
  const prefix = world.prefixes[prefixId];
  if (!vlan) throw new Error("VLAN nicht gefunden");
  if (!prefix) throw new Error("Prefix nicht gefunden");
  const cidr = cidrOf(prefix);
  const parsed = parsePrefix(cidr);
  const size = 1n << BigInt(parsed.bits - parsed.length);
  const pool = {
    rangeStart: nthAddress(cidr, size / 2n),
    rangeEnd: nthAddress(cidr, size - 2n),
    gateway: gatewayAddress(cidr),
    dnsServers: ["9.9.9.9", "1.1.1.1"],
    leaseTimeSeconds: leaseSeconds,
    leases: {}
  };
  vlan.dhcp = pool;
  return pool;
}
function requestLease(pool, clientId) {
  if (pool.leases[clientId]) return pool.leases[clientId];
  const start = addressToBigInt(pool.rangeStart);
  const end = addressToBigInt(pool.rangeEnd);
  const taken = new Set(Object.values(pool.leases));
  const family = pool.rangeStart.includes(":") ? "ipv6" : "ipv4";
  for (let value = start; value <= end; value++) {
    const address = family === "ipv4" ? [24n, 16n, 8n, 0n].map((s) => Number(value >> s & 0xffn)).join(".") : value.toString(16);
    if (taken.has(address)) continue;
    pool.leases[clientId] = address;
    return address;
  }
  return null;
}
function releaseLease(pool, clientId) {
  delete pool.leases[clientId];
}
function createZone(world, name, serverIds) {
  const zone = {
    name,
    serverIds,
    records: [
      { name: "@", type: "NS", value: `ns1.${name}`, ttl: 86400 },
      { name: "@", type: "NS", value: `ns2.${name}`, ttl: 86400 }
    ],
    reverseForPrefixId: null
  };
  world.dnsZones[name] = zone;
  return zone;
}
function createReverseZone(world, prefixId, serverIds) {
  const prefix = world.prefixes[prefixId];
  if (!prefix) throw new Error("Prefix nicht gefunden");
  const name = reverseZoneName(cidrOf(prefix));
  const zone = {
    name,
    serverIds,
    records: [],
    reverseForPrefixId: prefixId
  };
  world.dnsZones[name] = zone;
  prefix.rdnsDelegated = true;
  return zone;
}
function setReverseRecord(world, address, hostname) {
  const zone = values(world.dnsZones).find((z) => {
    if (!z.reverseForPrefixId) return false;
    const prefix = world.prefixes[z.reverseForPrefixId];
    if (!prefix) return false;
    return containsAddress(parsePrefix(cidrOf(prefix)), address);
  });
  if (!zone) return false;
  const name = reversePointerName(address);
  const existing = zone.records.find((r) => r.type === "PTR" && r.name === name);
  if (existing) existing.value = hostname;
  else zone.records.push({ name, type: "PTR", value: hostname, ttl: 3600 });
  return true;
}
function addRecord(world, zoneName, record) {
  const zone = world.dnsZones[zoneName];
  if (!zone) throw new Error(`Zone ${zoneName} nicht gefunden`);
  zone.records.push(record);
}
function zoneResolvable(world, zoneName) {
  const zone = world.dnsZones[zoneName];
  if (!zone) return false;
  return zone.serverIds.some((id) => {
    const server = world.servers[id];
    return server && (server.state === "online" || server.state === "degraded");
  });
}
function translate(rules, sourceAddress) {
  for (const rule of rules) {
    if (!containsAddress(parsePrefix(rule.insidePrefix), sourceAddress)) continue;
    return { address: rule.outsideAddress, matched: rule };
  }
  return { address: sourceAddress, matched: null };
}
function natOversubscription(rules, customerCount) {
  const addresses = new Set(rules.map((r) => r.outsideAddress)).size;
  return addresses === 0 ? Infinity : customerCount / addresses;
}
function evaluateAcl(acl, packet) {
  const entries = [...acl.entries].sort((a, b) => a.seq - b.seq);
  for (const entry of entries) {
    if (entry.protocol !== "ip" && entry.protocol !== packet.protocol) continue;
    if (entry.source !== "any" && !containsAddress(parsePrefix(entry.source), packet.source)) continue;
    if (entry.destination !== "any" && !containsAddress(parsePrefix(entry.destination), packet.destination)) continue;
    if (entry.port !== void 0 && packet.port !== void 0) {
      const match = Array.isArray(entry.port) ? packet.port >= entry.port[0] && packet.port <= entry.port[1] : packet.port === entry.port;
      if (!match) continue;
    }
    return { action: entry.action, entry };
  }
  return { action: "deny", entry: null };
}
function mitigationCapacityGbps(world, datacenterId) {
  let capacity = 0;
  for (const firewall of values(world.firewalls)) {
    if (firewall.datacenterId !== datacenterId) continue;
    if (firewall.state !== "online" && firewall.state !== "degraded") continue;
    capacity += firewall.state === "degraded" ? firewall.scrubbingGbps * 0.5 : firewall.scrubbingGbps;
  }
  return capacity;
}
function defaultFirewallRules() {
  return [
    { seq: 10, action: "allow", source: "any", destination: "any", protocol: "tcp", port: 80, description: "HTTP", enabled: true },
    { seq: 20, action: "allow", source: "any", destination: "any", protocol: "tcp", port: 443, description: "HTTPS", enabled: true },
    { seq: 30, action: "allow", source: "any", destination: "any", protocol: "icmp", description: "ICMP (Ping, PMTUD)", enabled: true },
    { seq: 40, action: "rate-limit", source: "any", destination: "any", protocol: "udp", limitMbps: 500, description: "UDP-Flood begrenzen", enabled: true },
    { seq: 100, action: "deny", source: "any", destination: "any", protocol: "any", description: "Alles \xDCbrige verwerfen", enabled: true }
  ];
}
function defaultEdgeAcl(ownPrefixes) {
  const entries = [
    { seq: 10, action: "deny", protocol: "ip", source: "10.0.0.0/8", destination: "any", log: true },
    { seq: 20, action: "deny", protocol: "ip", source: "172.16.0.0/12", destination: "any", log: true },
    { seq: 30, action: "deny", protocol: "ip", source: "192.168.0.0/16", destination: "any", log: true },
    { seq: 40, action: "deny", protocol: "ip", source: "127.0.0.0/8", destination: "any", log: true }
  ];
  ownPrefixes.forEach((prefix, i) => {
    entries.push({ seq: 100 + i * 10, action: "deny", protocol: "ip", source: prefix, destination: "any", log: true });
  });
  entries.push({ seq: 1e3, action: "permit", protocol: "ip", source: "any", destination: "any", log: false });
  return { name: "EDGE-IN", entries, appliedTo: [] };
}
function nextRouterId(world) {
  const used = new Set(values(world.routers).map((r) => r.bgp.routerId));
  for (let i = 1; i < 255; i++) {
    const candidate = `10.255.255.${i}`;
    if (!used.has(candidate)) return candidate;
  }
  return "10.255.254.1";
}
function hasExternalConnectivity(world, routerId) {
  const router = world.routers[routerId];
  if (!router) return false;
  return router.bgp.neighbors.some((n) => {
    if (n.relation === "ibgp" || !n.enabled || !n.linkId) return false;
    const link = world.links[n.linkId];
    return !!link && link.state === "up";
  });
}

// src/domain/network/traffic.ts
function diurnalFactor(tick2) {
  const hour = (tick2 % SIM.TICKS_PER_DAY + SIM.TICKS_PER_DAY) % SIM.TICKS_PER_DAY;
  const phase = (hour - 5 + 24) % 24 / 24;
  return 0.45 + 0.55 * Math.sin(Math.PI * Math.min(1, phase * 1.15)) ** 1.4;
}
function trafficByDatacenter(world, rng) {
  const factor = diurnalFactor(world.meta.tick);
  const out = {};
  for (const id of Object.keys(world.datacenters)) out[id] = 0;
  for (const contract of values(world.contracts)) {
    if (contract.state !== "active") continue;
    const product = world.products[contract.productId];
    if (!product) continue;
    const datacenterId = contractDatacenterId(world, contract);
    if (!datacenterId || !(datacenterId in out)) continue;
    const jitter = clamp(1 + rng.normal(0, 0.18), 0.4, 2.2);
    out[datacenterId] += product.resources.trafficMbps * factor * jitter;
  }
  return out;
}
function contractDatacenterId(world, contract) {
  if (contract.poolId) {
    const balancer = values(world.loadBalancers).find((lb) => lb.pools.some((p) => p.id === contract.poolId));
    return balancer?.datacenterId ?? null;
  }
  if (contract.serverId) return world.servers[contract.serverId]?.datacenterId ?? null;
  if (contract.vpsId) {
    const vps = world.vpsInstances[contract.vpsId];
    return vps ? world.servers[vps.hostServerId]?.datacenterId ?? null : null;
  }
  if (contract.rackId) return world.racks[contract.rackId]?.datacenterId ?? null;
  return null;
}
function ingressLinks(world, datacenterId) {
  const external = values(world.links).filter((l) => linkClass(l) !== "internal" && isLinkUsable(l));
  const local = external.filter((l) => l.a.datacenterId === datacenterId);
  return local.length > 0 ? local : external;
}
function edgeRouterOf(world, datacenterId) {
  const candidates = values(world.routers).filter((r) => r.datacenterId === datacenterId).filter((r) => r.state === "online" || r.state === "degraded");
  if (candidates.length === 0) return null;
  const withExternal = candidates.find((r) => r.bgp.neighbors.some((n) => n.relation !== "ibgp" && n.enabled));
  return (withExternal ?? candidates[0]).id;
}
function tracePath(world, tables, distances, origin, destination) {
  const table = tables[origin];
  if (!table) return { links: [], egress: null, hops: 0 };
  const prefixes = table.entries.map((e) => e.prefix);
  const index = longestPrefixMatch(prefixes, destination.prefix.split("/")[0]);
  if (index < 0) return { links: [], egress: null, hops: 0 };
  const entry = table.entries[index];
  if (entry.best.relation === "ibgp") {
    const target = values(world.routers).find((r) => r.bgp.routerId === entry.best.nextHop);
    if (!target) return { links: [], egress: null, hops: 0 };
    const path = distances[origin]?.[target.id];
    if (!path) return { links: [], egress: null, hops: 0 };
    const targetTable = tables[target.id];
    const targetPrefixes = targetTable?.entries.map((e) => e.prefix) ?? [];
    const targetIndex = longestPrefixMatch(targetPrefixes, destination.prefix.split("/")[0]);
    const egress = targetIndex >= 0 ? targetTable.entries[targetIndex].egressLinkId : null;
    return {
      links: [...path.links, ...egress ? [egress] : []],
      egress,
      hops: path.links.length + 1
    };
  }
  return { links: entry.egressLinkId ? [entry.egressLinkId] : [], egress: entry.egressLinkId, hops: 1 };
}
function linkClass(link) {
  if (link.kind === "transit") return "transit";
  if (link.kind === "peering-ix" || link.kind === "peering-private") return "peering";
  return "internal";
}
function simulateTraffic(world, tables, rng, extraInboundMbps = {}) {
  const topology = buildTopology(world);
  const distances = allShortestPaths(topology);
  const perDc = trafficByDatacenter(world, rng);
  const destinations = world.market.destinations;
  const linkLoad = {};
  for (const link of values(world.links)) linkLoad[link.id] = { aToB: 0, bToA: 0 };
  let total = 0;
  let transit = 0;
  let peering = 0;
  let internal = 0;
  let unroutable = 0;
  let latencyWeighted = 0;
  for (const [datacenterId, mbps] of Object.entries(perDc)) {
    if (mbps <= 0) continue;
    total += mbps;
    const dc = world.datacenters[datacenterId];
    const origin = edgeRouterOf(world, datacenterId);
    if (!origin) {
      unroutable += mbps;
      continue;
    }
    for (const destination of destinations) {
      const share = mbps * destination.trafficShare;
      if (share <= 0) continue;
      const path = tracePath(world, tables, distances, origin, destination);
      if (!path.egress) {
        unroutable += share;
        continue;
      }
      let pathLatency = 0;
      for (const linkId of path.links) {
        const link = world.links[linkId];
        if (!link || !isLinkUsable(link)) continue;
        const load = linkLoad[linkId] ?? { aToB: 0, bToA: 0 };
        load.aToB += share * 0.12;
        load.bToA += share * 0.88;
        linkLoad[linkId] = load;
        pathLatency += link.latencyMs;
        internal += linkClass(link) === "internal" ? share : 0;
      }
      const egressLink = world.links[path.egress];
      if (egressLink) {
        const cls = linkClass(egressLink);
        if (cls === "transit") transit += share;
        else if (cls === "peering") peering += share;
      }
      const exitCity = egressLink?.a.datacenterId ? world.datacenters[egressLink.a.datacenterId] : dc;
      if (exitCity) pathLatency += fiberLatencyMs(exitCity.position, destination.position);
      pathLatency += path.hops * PHYSICS.MS_PER_HOP;
      if (egressLink && linkClass(egressLink) === "transit") pathLatency += 4;
      latencyWeighted += pathLatency * share;
    }
  }
  for (const [datacenterId, mbps] of Object.entries(extraInboundMbps)) {
    if (mbps <= 0) continue;
    const links = ingressLinks(world, datacenterId);
    const capacity = links.reduce((sum3, l) => sum3 + l.capacityMbps, 0);
    for (const link of links) {
      const load = linkLoad[link.id] ?? { aToB: 0, bToA: 0 };
      load.bToA += capacity > 0 ? mbps * link.capacityMbps / capacity : mbps / links.length;
      linkLoad[link.id] = load;
    }
  }
  const congested = [];
  let lossAccumulator = 0;
  let lossWeight = 0;
  for (const link of values(world.links)) {
    const load = linkLoad[link.id] ?? { aToB: 0, bToA: 0 };
    link.utilizationMbps = load;
    const peak = Math.max(load.aToB, load.bToA);
    const utilization = link.capacityMbps > 0 ? peak / link.capacityMbps : 0;
    if (utilization >= SIM.LINK_CONGESTION_CRITICAL) congested.push(link.id);
    let loss = link.baseLossPercent;
    if (utilization > 0.9) loss += (utilization - 0.9) * 120;
    if (link.state === "degraded") loss += 2.5;
    if (peak > 0) {
      lossAccumulator += clamp(loss, 0, 100) * peak;
      lossWeight += peak;
    }
    if (link.kind === "transit") {
      pushWindow(link.samples95th, peak, SIM.BILLING_WINDOW);
    }
  }
  const routed = Math.max(0, total - unroutable);
  return {
    linkLoad,
    totalMbps: total,
    transitMbps: transit,
    peeringMbps: peering,
    internalMbps: internal,
    unroutableMbps: unroutable,
    avgLatencyMs: routed > 0 ? latencyWeighted / routed : 0,
    packetLossPercent: lossWeight > 0 ? lossAccumulator / lossWeight : unroutable > 0 ? 100 : 0,
    congestedLinks: congested
  };
}
function billable95th(link) {
  if (link.samples95th.length === 0) return 0;
  return percentile(link.samples95th, 0.95);
}
function probeDestination(world, tables, destination) {
  const topology = buildTopology(world);
  const distances = allShortestPaths(topology);
  const datacenterIds = Object.keys(world.datacenters);
  let best = null;
  for (const dcId of datacenterIds) {
    const origin = edgeRouterOf(world, dcId);
    if (!origin) continue;
    const path = tracePath(world, tables, distances, origin, destination);
    if (!path.egress) continue;
    let latency = path.hops * PHYSICS.MS_PER_HOP;
    let loss = 0;
    for (const linkId of path.links) {
      const link = world.links[linkId];
      if (!link) continue;
      latency += link.latencyMs;
      const peak = Math.max(link.utilizationMbps.aToB, link.utilizationMbps.bToA);
      const utilization = link.capacityMbps > 0 ? peak / link.capacityMbps : 0;
      loss += link.baseLossPercent + (utilization > 0.9 ? (utilization - 0.9) * 120 : 0);
    }
    const dc = world.datacenters[dcId];
    latency += fiberLatencyMs(dc.position, destination.position);
    latency *= 2;
    if (!best || latency < best.latencyMs) best = { latencyMs: latency, lossPercent: clamp(loss, 0, 100) };
  }
  if (!best) return { reachable: false, latencyMs: 0, lossPercent: 100 };
  return { reachable: best.lossPercent < 100, ...best };
}

// src/domain/world/regions.ts
var BOUNDS2 = {
  demand: [0.55, 1.9],
  power: [0.6, 1.8],
  rent: [0.7, 1.9]
};
var REGION_TRENDS = [
  {
    key: "fra-verdichtung",
    headline: "Frankfurt: Rechenzentrumsfl\xE4chen werden knapp",
    body: "Der gr\xF6\xDFte europ\xE4ische Knoten w\xE4chst weiter, aber die Fl\xE4che nicht mit. Mieten und Anschlusskosten ziehen deutlich an.",
    scope: { locations: ["loc-fra"] },
    effects: { demand: 1.25, rent: 1.55 },
    window: [1, 8],
    duration: [24, 48]
  },
  {
    key: "ams-baustopp",
    headline: "Amsterdam verh\xE4ngt Baustopp f\xFCr Rechenzentren",
    body: "Die Kommune stoppt Neubauten wegen Strom- und Fl\xE4chenbedarf. Bestandsfl\xE4chen werden schlagartig wertvoller.",
    scope: { locations: ["loc-ams"] },
    effects: { rent: 1.6, demand: 0.85 },
    window: [2, 9],
    duration: [24, 40]
  },
  {
    key: "nord-windkraft",
    headline: "Norddeutschland baut Windkraft massiv aus",
    body: "\xDCberschussstrom senkt die Beschaffungskosten im Norden sp\xFCrbar. Betreiber pr\xFCfen Verlagerungen.",
    scope: { locations: ["loc-ham", "loc-han", "loc-cph"] },
    effects: { power: 0.68, demand: 1.15 },
    window: [1, 8],
    duration: [24, 48]
  },
  {
    key: "sued-netzentgelte",
    headline: "Netzentgelte im S\xFCden ziehen an",
    body: "Der fehlende Netzausbau treibt die Entgelte in Bayern und Baden-W\xFCrttemberg. Standortkosten steigen.",
    scope: { locations: ["loc-muc", "loc-nue", "loc-str", "loc-fkb"] },
    effects: { power: 1.4 },
    window: [2, 10],
    duration: [18, 36]
  },
  {
    key: "ber-startups",
    headline: "Berlin zieht Gr\xFCnderinnen und Gr\xFCnder an",
    body: "Die Stadt wird zum Zentrum der jungen Softwarebranche. Nachfrage nach kleinen, schnell verf\xFCgbaren Servern steigt.",
    scope: { locations: ["loc-ber"] },
    effects: { demand: 1.45, rent: 1.2 },
    window: [1, 7],
    duration: [24, 40]
  },
  {
    key: "nordics-kuehlung",
    headline: "Skandinavien wirbt mit freier K\xFChlung",
    body: "Oslo, Stockholm und Helsinki bewerben niedrige Energiekosten und ganzj\xE4hrige Au\xDFenluftk\xFChlung.",
    scope: { locations: ["loc-osl", "loc-sto", "loc-hel"] },
    effects: { power: 0.62, demand: 1.3 },
    window: [2, 10],
    duration: [30, 48]
  },
  {
    key: "mrs-seekabel",
    headline: "Neue Seekabel landen in S\xFCdeuropa an",
    body: "Mehrere Systeme nach Asien und Afrika gehen in Betrieb. Mailand und Madrid gewinnen als Knoten.",
    scope: { locations: ["loc-mil", "loc-mad"] },
    effects: { demand: 1.4, rent: 1.15 },
    window: [3, 11],
    duration: [24, 40]
  },
  {
    key: "osteuropa-aufholjagd",
    headline: "Osteuropa holt bei Infrastruktur auf",
    body: "Warschau und Prag melden starken Zulauf. Niedrige Kosten treffen auf wachsende Nachfrage.",
    scope: { locations: ["loc-war", "loc-prg"] },
    effects: { demand: 1.5, rent: 1.25, power: 1.1 },
    window: [2, 10],
    duration: [24, 44]
  },
  {
    key: "uk-abwanderung",
    headline: "London verliert an Bedeutung f\xFCr kontinentale Kunden",
    body: "Rechtliche Unsicherheit bei Daten\xFCbermittlungen l\xE4sst Kunden auf das Festland ausweichen.",
    scope: { countries: ["GB", "IE"] },
    effects: { demand: 0.72, rent: 0.85 },
    window: [2, 9],
    duration: [24, 40]
  },
  {
    key: "us-strompreis",
    headline: "US-Energiemarkt unter Druck",
    body: "Netzausbau und Nachfrage geraten aus dem Takt. In mehreren Bundesstaaten steigen die Gewerbestrompreise.",
    scope: { countries: ["US"] },
    effects: { power: 1.45, demand: 1.1 },
    window: [3, 12],
    duration: [18, 36]
  },
  {
    key: "phx-wasser",
    headline: "Wasserknappheit trifft Rechenzentren im S\xFCdwesten",
    body: "Verdunstungsk\xFChlung ger\xE4t unter politischen Druck. Phoenix verliert seinen Kostenvorteil.",
    scope: { locations: ["loc-phx", "loc-lax"] },
    effects: { power: 1.35, demand: 0.85 },
    window: [4, 13],
    duration: [18, 36]
  },
  {
    key: "regionale-foerderung",
    headline: "F\xF6rderprogramm f\xFCr strukturschwache Regionen",
    body: "Ansiedlungen abseits der gro\xDFen Knoten werden bezuschusst. Mieten fallen, Nachfrage zieht langsam nach.",
    scope: { locations: ["loc-lej", "loc-fsn", "loc-scn", "loc-eyg", "loc-grv"] },
    effects: { rent: 0.72, demand: 1.2 },
    window: [2, 10],
    duration: [24, 44]
  }
];
function emptyRegions() {
  const factors = {};
  for (const location of LOCATIONS) {
    factors[location.key] = { demand: 1, power: 1, rent: 1 };
  }
  return { factors, active: [], seen: [] };
}
var ADJUST_PER_MONTH = 0.09;
function findRegionTrend(key) {
  return REGION_TRENDS.find((trend) => trend.key === key);
}
function affects(trend, locationKey) {
  if (trend.scope.locations?.includes(locationKey)) return true;
  if (!trend.scope.countries) return false;
  const location = LOCATIONS.find((l) => l.key === locationKey);
  return location ? trend.scope.countries.includes(location.country) : false;
}
function updateRegions(world, rng) {
  const state = world.regions;
  const report = { started: [], ended: [] };
  const year = Math.floor(world.meta.tick / SIM.TICKS_PER_YEAR) + 1;
  for (const active of [...state.active]) {
    if (world.meta.tick < active.endsAtTick) continue;
    state.active = state.active.filter((a) => a.key !== active.key);
    const trend = findRegionTrend(active.key);
    if (trend) report.ended.push(trend);
  }
  if (state.active.length < 3) {
    const candidates = REGION_TRENDS.filter(
      (trend) => !state.seen.includes(trend.key) && year >= trend.window[0] && year <= trend.window[1]
    );
    if (candidates.length > 0 && rng.chance(1 / 18)) {
      const trend = candidates[Math.floor(rng.float(0, 1) * candidates.length)];
      const [minMonths, maxMonths] = trend.duration;
      const months = minMonths + Math.floor(rng.float(0, 1) * (maxMonths - minMonths + 1));
      state.active.push({
        key: trend.key,
        startedAtTick: world.meta.tick,
        endsAtTick: world.meta.tick + months * SIM.TICKS_PER_MONTH
      });
      state.seen.push(trend.key);
      report.started.push(trend);
    }
  }
  for (const location of LOCATIONS) {
    const factors = state.factors[location.key];
    if (!factors) continue;
    const target = { demand: 1, power: 1, rent: 1 };
    for (const active of state.active) {
      const trend = findRegionTrend(active.key);
      if (!trend || !affects(trend, location.key)) continue;
      target.demand *= trend.effects.demand ?? 1;
      target.power *= trend.effects.power ?? 1;
      target.rent *= trend.effects.rent ?? 1;
    }
    factors.demand = clamp(factors.demand + (target.demand - factors.demand) * ADJUST_PER_MONTH, ...BOUNDS2.demand);
    factors.power = clamp(factors.power + (target.power - factors.power) * ADJUST_PER_MONTH, ...BOUNDS2.power);
    factors.rent = clamp(factors.rent + (target.rent - factors.rent) * ADJUST_PER_MONTH, ...BOUNDS2.rent);
  }
  return report;
}
function regionFactorsOfCity(world, city) {
  const location = LOCATIONS.find((l) => l.city === city);
  return (location && world.regions.factors[location.key]) ?? { demand: 1, power: 1, rent: 1 };
}
function regionFactors(world, locationKey) {
  return world.regions.factors[locationKey] ?? { demand: 1, power: 1, rent: 1 };
}

// src/domain/minigames/state.ts
var MINIGAME = {
  /**
   * Länger bleibt ein Ereignis nie eingefroren, auch wenn die Uhr fehlt oder
   * jemand während des Spiels vorspult: zwei Spieltage.
   */
  MAX_FROZEN_TICKS: 48,
  /** Spielraum für Netzlaufzeit beim Abgeben. */
  GRACE_MS: 8e3
};
var MINIGAME_LABEL = {
  cabling: "Notstrom anklemmen",
  "tower-defense": "Abwehrlinie halten",
  escape: "Aus der Zelle ausbrechen"
};
function createMinigame(rng, kind, params = {}) {
  return {
    kind,
    seed: rng.int(1, 2 ** 31 - 2),
    state: "ready",
    params,
    startedAtMs: null,
    deadlineMs: null,
    startedAtTick: null,
    solved: [],
    mistakes: 0,
    resultNote: null
  };
}
function isFrozen(world, event) {
  const game = event.minigame;
  if (!game || game.state !== "running" || event.resolved) return false;
  if (game.startedAtTick !== null && world.meta.tick - game.startedAtTick >= MINIGAME.MAX_FROZEN_TICKS) return false;
  const now = world.meta.clockMs;
  if (game.deadlineMs !== null && now !== void 0 && now > game.deadlineMs + MINIGAME.GRACE_MS) return false;
  return true;
}
function powerFrozen(world, datacenterId) {
  return values(world.events).some(
    (e) => e.type === "power-outage" && e.targets.some((t) => t.kind === "datacenter" && t.id === datacenterId) && isFrozen(world, e)
  );
}
function expireMinigames(world) {
  const expired = [];
  for (const event of values(world.events)) {
    const game = event.minigame;
    if (!game || game.state !== "running" || event.resolved) continue;
    if (isFrozen(world, event)) continue;
    game.state = "lost";
    game.resultNote = "Die Zeit ist abgelaufen \u2013 das Ereignis l\xE4uft normal weiter.";
    expired.push(event);
  }
  return expired;
}

// src/domain/dc/facility.ts
function devicePowerWatt(device, load, powerModifier = 1) {
  if (device.state === "offline" || device.state === "failed") return 0;
  const effective = clamp(load, 0, 1);
  return (device.idleWatt + (device.maxWatt - device.idleWatt) * effective) * powerModifier;
}
function serverLoad(world, serverId) {
  const server = world.servers[serverId];
  if (!server) return 0;
  if (server.state !== "online" && server.state !== "degraded") return 0;
  let cores = 0;
  let ram = 0;
  for (const vpsId of server.vpsIds) {
    const vps = world.vpsInstances[vpsId];
    if (!vps || vps.state === "offline") continue;
    cores += vps.vcpu * vps.cpuLoad;
    ram += vps.ramGb;
  }
  for (const contractId of server.contractIds) {
    const contract = world.contracts[contractId];
    if (!contract || contract.state !== "active") continue;
    const product = world.products[contract.productId];
    if (!product) continue;
    cores += product.resources.cpuCores * 0.55;
    ram += product.resources.ramGb;
  }
  const cpuLoad = server.cpuCores > 0 ? cores / server.cpuCores : 0;
  const ramLoad = server.ramGb > 0 ? ram / server.ramGb : 0;
  return clamp(Math.max(cpuLoad, ramLoad * 0.7), 0.05, 1);
}
function rackUsage(world, rackId) {
  const rack = world.racks[rackId];
  if (!rack) return { used: 0, total: 0 };
  let used = 0;
  const count2 = (device) => {
    if (device.rackId === rackId) used += device.heightUnits;
  };
  values(world.servers).forEach(count2);
  values(world.routers).forEach(count2);
  values(world.switches).forEach(count2);
  values(world.firewalls).forEach(count2);
  values(world.loadBalancers).forEach(count2);
  values(world.upsUnits).forEach(count2);
  return { used, total: rack.units };
}
function rackPowerKw(world, rackId, powerModifier = 1) {
  let watt = 0;
  for (const server of values(world.servers)) {
    if (server.rackId !== rackId) continue;
    watt += devicePowerWatt(server, serverLoad(world, server.id), powerModifier);
  }
  for (const router of values(world.routers)) {
    if (router.rackId !== rackId) continue;
    watt += devicePowerWatt(router, router.cpuLoad, powerModifier);
  }
  for (const sw of values(world.switches)) {
    if (sw.rackId !== rackId) continue;
    watt += devicePowerWatt(sw, 0.5, powerModifier);
  }
  for (const fw of values(world.firewalls)) {
    if (fw.rackId !== rackId) continue;
    const load = fw.sessionCapacity > 0 ? fw.currentSessions / fw.sessionCapacity : 0;
    watt += devicePowerWatt(fw, load, powerModifier);
  }
  for (const lb of values(world.loadBalancers)) {
    if (lb.rackId !== rackId) continue;
    watt += devicePowerWatt(lb, Math.min(1, lb.load), powerModifier);
  }
  for (const ups of values(world.upsUnits)) {
    if (ups.rackId !== rackId) continue;
    watt += devicePowerWatt(ups, 0.3, powerModifier);
  }
  return watt / 1e3;
}
function updateFacility(world, datacenterId, modifiers) {
  const dc = world.datacenters[datacenterId];
  const racks = values(world.racks).filter((r) => r.datacenterId === datacenterId);
  let itLoadKw = 0;
  const perRack = /* @__PURE__ */ new Map();
  for (const rack of racks) {
    const kw = rackPowerKw(world, rack.id, modifiers.power);
    perRack.set(rack.id, kw);
    itLoadKw += kw;
  }
  for (const ups of values(world.upsUnits)) {
    if (ups.datacenterId !== datacenterId || ups.rackId !== null) continue;
    itLoadKw += devicePowerWatt(ups, 0.3, modifiers.power) / 1e3;
  }
  const totalKw = itLoadKw * dc.pue;
  const heatKw = itLoadKw * PHYSICS.WATT_TO_HEAT;
  const effectiveCooling = dc.coolingCapacityKw * modifiers.cooling * ambientPenalty(dc);
  const coolingDeficitKw = Math.max(0, heatKw - effectiveCooling);
  let onBackup = false;
  if (!dc.utilityPower) {
    onBackup = true;
    if (!powerFrozen(world, datacenterId)) drainBackup(world, datacenterId, totalKw);
  } else {
    rechargeUps(world, datacenterId);
    if (dc.generator.installed && dc.generator.fuelPercent < 100) {
      dc.generator.fuelPercent = Math.min(100, dc.generator.fuelPercent + 1.5);
    }
  }
  updateTemperatures(world, datacenterId, perRack, coolingDeficitKw, racks.length);
  const hoursPerTick = SIM.MINUTES_PER_TICK / 60;
  const pricePerKwh = effectivePowerPrice(world, dc);
  const costPerTick = dc.utilityPower ? totalKw * hoursPerTick * pricePerKwh : totalKw * hoursPerTick * pricePerKwh * 3.2;
  const itCostPerTick = dc.pue > 0 ? costPerTick / dc.pue : costPerTick;
  const coolingCostPerTick = costPerTick - itCostPerTick;
  return {
    datacenterId,
    itLoadKw,
    totalKw,
    capacityKw: dc.powerCapacityKw,
    heatKw,
    coolingCapacityKw: effectiveCooling,
    coolingDeficitKw,
    costPerTick,
    itCostPerTick,
    coolingCostPerTick,
    onBackup
  };
}
function ambientPenalty(dc) {
  if (dc.ambientTempC <= 20) return 1.05;
  return clamp(1 - (dc.ambientTempC - 20) * 0.012, 0.7, 1.05);
}
function updateTemperatures(world, datacenterId, perRack, coolingDeficitKw, rackCount) {
  const dc = world.datacenters[datacenterId];
  const deficitPerRack = rackCount > 0 ? coolingDeficitKw / rackCount : 0;
  const applyTo = (device) => {
    if (device.datacenterId !== datacenterId) return;
    const rack = device.rackId ? world.racks[device.rackId] : void 0;
    const rackKw = device.rackId ? perRack.get(device.rackId) ?? 0 : 0;
    const density = rack && rack.powerBudgetKw > 0 ? rackKw / rack.powerBudgetKw : 0;
    if (device.rackId && !rack) return;
    let target = PHYSICS.BASE_RACK_TEMP_C + density * 14 + deficitPerRack * PHYSICS.TEMP_RISE_PER_KW_OVER;
    if (!dc.utilityPower && !hasBackupPower(world, datacenterId)) target += 25;
    if (device.state === "offline" || device.state === "failed") target = dc.ambientTempC;
    device.temperatureC = smooth(device.temperatureC, target, PHYSICS.TEMP_SMOOTHING);
    let loss = PHYSICS.HEALTH_LOSS_PER_TICK;
    if (device.temperatureC > SIM.TEMP_WARN_C) {
      loss += PHYSICS.HEALTH_LOSS_PER_TICK_HOT * ((device.temperatureC - SIM.TEMP_WARN_C) / 10);
    }
    device.health = clamp(device.health - loss, 0, 1);
    if (device.temperatureC > SIM.TEMP_CRITICAL_C && device.state === "online") {
      device.state = "degraded";
    } else if (device.temperatureC < SIM.TEMP_WARN_C && device.state === "degraded" && device.health > 0.35) {
      device.state = "online";
    }
  };
  values(world.servers).forEach(applyTo);
  values(world.routers).forEach(applyTo);
  values(world.switches).forEach(applyTo);
  values(world.firewalls).forEach(applyTo);
  values(world.loadBalancers).forEach(applyTo);
  values(world.upsUnits).forEach(applyTo);
}
function hasBackupPower(world, datacenterId) {
  const dc = world.datacenters[datacenterId];
  if (dc.generator.installed && dc.generator.fuelPercent > 0) return true;
  return values(world.upsUnits).some((u) => u.datacenterId === datacenterId && u.charge > 0.02);
}
function drainBackup(world, datacenterId, demandKw) {
  const dc = world.datacenters[datacenterId];
  const hoursPerTick = SIM.MINUTES_PER_TICK / 60;
  if (dc.generator.installed && dc.generator.fuelPercent > 0) {
    const burn = demandKw / Math.max(1, dc.powerCapacityKw) * (100 / Math.max(1, dc.generator.runtimeHours)) * hoursPerTick;
    dc.generator.fuelPercent = Math.max(0, dc.generator.fuelPercent - burn);
    rechargeUps(world, datacenterId);
    return;
  }
  let remaining = demandKw * hoursPerTick;
  for (const ups of values(world.upsUnits)) {
    if (ups.datacenterId !== datacenterId || ups.charge <= 0) continue;
    const available = ups.capacityKwh * ups.charge;
    const draw = Math.min(available, remaining);
    ups.charge = clamp((available - draw) / Math.max(1e-3, ups.capacityKwh), 0, 1);
    remaining -= draw;
    if (remaining <= 0) break;
  }
  if (remaining > 0) {
    powerDownDatacenter(world, datacenterId);
  }
}
function rechargeUps(world, datacenterId) {
  for (const ups of values(world.upsUnits)) {
    if (ups.datacenterId !== datacenterId) continue;
    if (ups.state === "failed" || ups.state === "offline") continue;
    ups.charge = clamp(ups.charge + 0.08, 0, 1);
  }
}
function powerDownDatacenter(world, datacenterId) {
  const stop = (device) => {
    if (device.datacenterId !== datacenterId) return;
    if (device.state === "failed") return;
    device.state = "offline";
    device.pendingTicks = 0;
  };
  values(world.servers).forEach(stop);
  values(world.routers).forEach(stop);
  values(world.switches).forEach(stop);
  values(world.firewalls).forEach(stop);
  values(world.loadBalancers).forEach(stop);
}
function powerUpDatacenter(world, datacenterId) {
  const start = (device) => {
    if (device.datacenterId !== datacenterId) return;
    if (device.state !== "offline") return;
    if (device.standby) return;
    device.state = "booting";
    device.pendingTicks = SIM.BOOT_TICKS;
  };
  values(world.routers).forEach(start);
  values(world.switches).forEach(start);
  values(world.firewalls).forEach(start);
  values(world.loadBalancers).forEach(start);
  values(world.servers).forEach(start);
}
function freeRackSlots(world, datacenterId) {
  const used = values(world.racks).filter((r) => r.datacenterId === datacenterId).length;
  return Math.max(0, world.datacenters[datacenterId].rackCapacity - used);
}
function canInstall(world, rackId, heightUnits, maxWatt) {
  const rack = world.racks[rackId];
  if (!rack) return { ok: false, reason: "Rack nicht gefunden" };
  const usage2 = rackUsage(world, rackId);
  if (usage2.used + heightUnits > rack.units) {
    return { ok: false, reason: `Nicht genug H\xF6heneinheiten frei (${rack.units - usage2.used} HE verf\xFCgbar)` };
  }
  const currentKw = rackPowerKw(world, rackId);
  if (currentKw + maxWatt / 1e3 > rack.powerBudgetKw) {
    return { ok: false, reason: `Strombudget des Racks \xFCberschritten (${rack.powerBudgetKw} kW)` };
  }
  return { ok: true };
}
function occupiedRanges(world, rackId, excludeId) {
  const ranges = [];
  const add = (device) => {
    if (device.rackId !== rackId || device.id === excludeId) return;
    ranges.push({ start: device.rackUnit, end: device.rackUnit + device.heightUnits });
  };
  values(world.servers).forEach(add);
  values(world.routers).forEach(add);
  values(world.switches).forEach(add);
  values(world.firewalls).forEach(add);
  values(world.loadBalancers).forEach(add);
  values(world.upsUnits).forEach(add);
  return ranges.sort((a, b) => a.start - b.start);
}
function nextRackSlot(world, rackId, heightUnits, excludeId) {
  let cursor = 0;
  for (const range of occupiedRanges(world, rackId, excludeId)) {
    if (range.start - cursor >= heightUnits) break;
    cursor = Math.max(cursor, range.end);
  }
  return cursor;
}
function effectivePowerPrice(world, dc) {
  const region = regionFactorsOfCity(world, dc.city);
  return worldRate(world, "strom", dc.powerPricePerKwh) * region.power;
}

// src/domain/compute/provisioning.ts
function poolLoadOnServer(world, serverId) {
  const load = { cpu: 0, ram: 0, ssd: 0, hdd: 0, gpu: 0 };
  for (const balancer of values(world.loadBalancers)) {
    for (const pool of balancer.pools) {
      if (!pool.members.some((m) => m.serverId === serverId)) continue;
      for (const contractId of pool.contractIds) {
        const contract = world.contracts[contractId];
        if (!contract || contract.state === "cancelled") continue;
        const product = world.products[contract.productId];
        if (!product) continue;
        load.cpu += product.resources.cpuCores;
        load.ram += product.resources.ramGb;
        load.ssd += product.resources.ssdGb;
        load.hdd += product.resources.hddGb;
        load.gpu += product.resources.gpuCount ?? 0;
      }
    }
  }
  return load;
}
function serverCapacity(world, serverId, performanceModifier = 1) {
  const server = world.servers[serverId];
  if (!server) {
    return { cpuCores: 0, cpuCoresUsed: 0, ramGb: 0, ramGbUsed: 0, ssdGb: 0, ssdGbUsed: 0, hddGb: 0, hddGbUsed: 0, gpuCount: 0, gpuCountUsed: 0 };
  }
  const pooled = poolLoadOnServer(world, serverId);
  let cpu = pooled.cpu;
  let ram = pooled.ram;
  let ssd = pooled.ssd;
  let hdd = pooled.hdd;
  let gpu = pooled.gpu;
  for (const vpsId of server.vpsIds) {
    const vps = world.vpsInstances[vpsId];
    if (!vps) continue;
    cpu += vps.vcpu;
    ram += vps.ramGb;
    ssd += vps.diskGb;
  }
  for (const contractId of server.contractIds) {
    const contract = world.contracts[contractId];
    if (!contract || contract.state === "cancelled") continue;
    const product = world.products[contract.productId];
    if (!product) continue;
    cpu += product.resources.cpuCores;
    ram += product.resources.ramGb;
    ssd += product.resources.ssdGb;
    hdd += product.resources.hddGb;
    gpu += product.resources.gpuCount ?? 0;
  }
  return {
    // Forschung erhöht die effektive Rechenleistung, nicht die physische Kernzahl.
    cpuCores: server.cpuCores * performanceModifier,
    cpuCoresUsed: cpu,
    ramGb: server.ramGb,
    ramGbUsed: ram,
    ssdGb: server.ssdGb,
    ssdGbUsed: ssd,
    hddGb: server.hddGb,
    hddGbUsed: hdd,
    gpuCount: server.gpuCount ?? 0,
    gpuCountUsed: gpu
  };
}
var OVERCOMMIT = {
  "shared-hosting": { cpu: 20, ram: 8, disk: 4 },
  mail: { cpu: 12, ram: 5, disk: 3 },
  storage: { cpu: 8, ram: 4, disk: 1.3 },
  backup: { cpu: 8, ram: 4, disk: 1.5 },
  vps: { cpu: 3, ram: 1, disk: 1.15 },
  dedicated: { cpu: 1, ram: 1, disk: 1 },
  // Container teilen sich Ressourcen effizienter als klassische VPS-Kunden.
  container: { cpu: 4, ram: 1.15, disk: 1.2 },
  // Spiele brauchen gleichmäßige statt spitzenlastige CPU-Leistung – knapper
  // als normaler VPS-Overcommit, sonst ruckelt es bei gleichzeitiger Last.
  "game-server": { cpu: 1.5, ram: 1, disk: 1.2 },
  // GPUs werden nicht überbucht: reale Knappheit ist der Witz des Produkts.
  "gpu-compute": { cpu: 1, ram: 1, disk: 1, gpu: 1 }
};
function overcommitFor(kind) {
  return OVERCOMMIT[kind] ?? { cpu: 2, ram: 1, disk: 1 };
}
function overcommitOfRole(role) {
  return overcommitFor(role === "vps-host" ? "vps" : role === "gpu-host" ? "gpu-compute" : role);
}
function fits(capacity, product) {
  const r = product.resources;
  const o = overcommitFor(product.kind);
  return capacity.cpuCoresUsed + r.cpuCores <= capacity.cpuCores * o.cpu && capacity.ramGbUsed + r.ramGb <= capacity.ramGb * o.ram && capacity.ssdGbUsed + r.ssdGb <= capacity.ssdGb * o.disk && capacity.hddGbUsed + r.hddGb <= capacity.hddGb * o.disk && capacity.gpuCountUsed + (r.gpuCount ?? 0) <= capacity.gpuCount * (o.gpu ?? 1);
}
function requiredRole(product) {
  switch (product.kind) {
    case "shared-hosting":
      return "shared-hosting";
    case "vps":
      return "vps-host";
    case "dedicated":
      return "dedicated";
    case "storage":
      return "storage";
    case "backup":
      return "backup";
    case "mail":
      return "mail";
    // Container und Game-Server teilen sich den VPS-Pool – wirtschaftlich
    // andere Produkte, technisch dieselbe Art von Host.
    case "container":
    case "game-server":
      return "vps-host";
    case "gpu-compute":
      return "gpu-host";
    default:
      return null;
  }
}
function findHost(world, product, performanceModifier = 1) {
  const role = requiredRole(product);
  if (role === null) return null;
  const candidates = values(world.servers).filter((s) => s.role === role).filter((s) => s.os !== null).filter((s) => s.state === "online" || s.state === "booting").filter((s) => isServerConnected(world, s.id)).filter((s) => s.retirement === null).filter((s) => {
    if (role !== "dedicated") return true;
    return s.contractIds.length === 0 && s.vpsIds.length === 0;
  }).filter((s) => fits(serverCapacity(world, s.id, performanceModifier), product));
  if (candidates.length === 0) return null;
  return candidates.sort((a, b) => {
    const ca = serverCapacity(world, a.id, performanceModifier);
    const cb = serverCapacity(world, b.id, performanceModifier);
    return ca.ramGbUsed / Math.max(1, ca.ramGb) - cb.ramGbUsed / Math.max(1, cb.ramGb);
  })[0];
}
function hostFailureReason(world, product, performanceModifier = 1) {
  const role = requiredRole(product);
  if (role === null) return "Produkt braucht keinen Host";
  const mitRolle = values(world.servers).filter((s) => s.role === role);
  if (mitRolle.length === 0) {
    return `kein Server mit der Rolle \u201E${role}\u201C vorhanden`;
  }
  const einsatzbereit = mitRolle.filter(
    (s) => s.os !== null && (s.state === "online" || s.state === "booting") && isServerConnected(world, s.id) && s.retirement === null
  );
  if (einsatzbereit.length === 0) {
    const ohneOs = mitRolle.filter((s) => s.os === null).length;
    const offline = mitRolle.filter((s) => s.state !== "online" && s.state !== "booting").length;
    const ohneNetz = mitRolle.filter((s) => !isServerConnected(world, s.id)).length;
    const abgabe = mitRolle.filter((s) => s.retirement !== null).length;
    const teile = [
      ohneOs > 0 ? `${ohneOs} ohne Betriebssystem` : "",
      offline > 0 ? `${offline} nicht online` : "",
      ohneNetz > 0 ? `${ohneNetz} ohne Netzanbindung` : "",
      abgabe > 0 ? `${abgabe} zur Abgabe vorgesehen` : ""
    ].filter(Boolean);
    return `alle ${mitRolle.length} Server der Rolle \u201E${role}\u201C sind nicht einsatzbereit (${teile.join(", ")})`;
  }
  if (role === "dedicated") {
    const frei = einsatzbereit.filter((s) => s.contractIds.length === 0 && s.vpsIds.length === 0);
    if (frei.length === 0) {
      return `alle ${einsatzbereit.length} dedizierten Server sind exklusiv vergeben \u2013 ein dedizierter Server geh\xF6rt einem Kunden allein`;
    }
    const passend = frei.filter((s) => fits(serverCapacity(world, s.id, performanceModifier), product));
    if (passend.length === 0) {
      const r2 = product.resources;
      const groesster = frei.map((s) => serverCapacity(world, s.id, performanceModifier)).sort((a, b) => b.cpuCores - a.cpuCores)[0];
      return `kein freier dedizierter Server ist gro\xDF genug: ${product.name} braucht ${r2.cpuCores} Kerne, ${r2.ramGb} GB RAM, ${r2.ssdGb} GB SSD \u2013 der gr\xF6\xDFte freie hat ${groesster?.cpuCores ?? 0} Kerne, ${groesster?.ramGb ?? 0} GB RAM, ${groesster?.ssdGb ?? 0} GB SSD`;
    }
    return "kein passender dedizierter Server frei";
  }
  const r = product.resources;
  return `alle ${einsatzbereit.length} Server der Rolle \u201E${role}\u201C sind voll \u2013 ${product.name} braucht ${r.cpuCores} Kerne, ${r.ramGb} GB RAM, ${r.ssdGb} GB SSD` + (r.gpuCount ? `, ${r.gpuCount} GPU` : "");
}
function installOs(world, serverId, os) {
  const server = world.servers[serverId];
  if (!server) return { ok: false, error: "Server nicht gefunden" };
  const model = findServerModel(server.model);
  if (model && !model.supportedOs.includes(os)) {
    return { ok: false, error: `${model.name} unterst\xFCtzt ${os} nicht` };
  }
  if (server.contractIds.length > 0 || server.vpsIds.length > 0) {
    return { ok: false, error: "Server ist belegt \u2013 Neuinstallation w\xFCrde Kundendaten l\xF6schen" };
  }
  server.os = os;
  server.state = "booting";
  server.pendingTicks = SIM.OS_INSTALL_TICKS;
  return { ok: true };
}
function rebootDevice(device) {
  if (device.state === "failed") return { ok: false, error: "Defektes Ger\xE4t muss zuerst repariert werden" };
  device.state = "booting";
  device.pendingTicks = SIM.BOOT_TICKS;
  return { ok: true };
}
function startRepair(world, device) {
  const technicians = values(world.staff).filter(
    (s) => s.role === "technician" && (s.datacenterId === null || s.datacenterId === device.datacenterId)
  );
  const skill = technicians.length > 0 ? Math.max(...technicians.map((t) => t.skill)) : 1;
  const ticks = Math.max(1, Math.round(SIM.REPAIR_TICKS_BASE * (2 - device.health) / (0.5 + skill / 10)));
  device.state = "maintenance";
  device.pendingTicks = ticks;
  return { ok: true, ticks };
}
function createVps(world, rng, input) {
  const host = world.servers[input.hostServerId];
  if (!host) return { ok: false, error: "Host nicht gefunden" };
  if (host.role !== "vps-host") return { ok: false, error: "Server ist kein VPS-Host" };
  if (host.os === null) return { ok: false, error: "Host hat kein Betriebssystem" };
  const capacity = serverCapacity(world, host.id);
  if (capacity.ramGbUsed + input.ramGb > capacity.ramGb) return { ok: false, error: "Nicht gen\xFCgend RAM auf dem Host" };
  if (capacity.ssdGbUsed + input.diskGb > capacity.ssdGb) return { ok: false, error: "Nicht gen\xFCgend Speicher auf dem Host" };
  const vps = {
    id: asId(makeId(rng, "vps")),
    hostServerId: host.id,
    contractId: input.contractId,
    name: input.name,
    vcpu: input.vcpu,
    ramGb: input.ramGb,
    diskGb: input.diskGb,
    os: input.os,
    state: "booting",
    ipv4: null,
    ipv6: null,
    cpuLoad: 0.1,
    createdAtTick: world.meta.tick
  };
  world.vpsInstances[vps.id] = vps;
  host.vpsIds.push(vps.id);
  return { ok: true, vps };
}
function destroyVps(world, vpsId) {
  const vps = world.vpsInstances[vpsId];
  if (!vps) return false;
  const host = world.servers[vps.hostServerId];
  if (host) host.vpsIds = host.vpsIds.filter((id) => id !== vpsId);
  delete world.vpsInstances[vpsId];
  return true;
}
function advancePendingOperations(world) {
  const finished = [];
  const advance = (device) => {
    if (device.pendingTicks <= 0) return;
    device.pendingTicks -= 1;
    if (device.pendingTicks > 0) return;
    if (device.state === "booting") {
      device.state = device.health < 0.35 ? "degraded" : "online";
      finished.push(`${device.name} ist wieder online.`);
    } else if (device.state === "maintenance") {
      device.health = clamp(device.health + 0.55, 0, 1);
      device.state = "online";
      finished.push(`${device.name}: Reparatur abgeschlossen.`);
    }
  };
  values(world.servers).filter((s) => s.maintenance === null).forEach(advance);
  values(world.routers).forEach(advance);
  values(world.switches).forEach(advance);
  values(world.firewalls).forEach(advance);
  values(world.loadBalancers).forEach(advance);
  values(world.upsUnits).forEach(advance);
  for (const vps of values(world.vpsInstances)) {
    const host = world.servers[vps.hostServerId];
    if (!host) continue;
    if (host.state === "offline" || host.state === "failed" || host.state === "maintenance") vps.state = "offline";
    else if (vps.state === "booting") vps.state = "online";
    else if (host.state === "degraded" && vps.state === "online") vps.state = "degraded";
    else if (host.state === "online" && vps.state === "degraded") vps.state = "online";
  }
  return finished;
}
function autoRepair(world) {
  const technicians = values(world.staff).filter((s) => s.role === "technician" || s.role === "network-engineer");
  if (technicians.length === 0) return { started: [], costs: 0 };
  const inProgress = [
    ...values(world.routers),
    ...values(world.switches),
    ...values(world.servers),
    ...values(world.firewalls),
    ...values(world.loadBalancers)
  ].filter((d) => d.state === "maintenance").length;
  let free2 = technicians.length - inProgress;
  if (free2 <= 0) return { started: [], costs: 0 };
  const queue = [
    ...values(world.routers),
    ...values(world.switches),
    ...values(world.loadBalancers),
    ...values(world.firewalls),
    ...values(world.servers)
  ].filter((d) => d.state === "failed");
  const started = [];
  let costs = 0;
  for (const device of queue) {
    if (free2 <= 0) break;
    const result = startRepair(world, device);
    started.push(`${device.name}: Techniker begonnen (${result.ticks} h).`);
    costs += Math.round(device.purchasePrice * 0.08);
    free2 -= 1;
  }
  return { started, costs };
}
function updateVpsLoad(world, rng) {
  for (const vps of values(world.vpsInstances)) {
    if (vps.state !== "online" && vps.state !== "degraded") {
      vps.cpuLoad = 0;
      continue;
    }
    const base = vps.contractId ? 0.35 : 0.08;
    vps.cpuLoad = clamp(vps.cpuLoad * 0.7 + (base + rng.normal(0, 0.15)) * 0.3, 0.01, 1);
  }
}
function totalCapacity(world, performanceModifier = 1) {
  let cpuCoresTotal = 0;
  let ramGbTotal = 0;
  let diskGbTotal = 0;
  let cpuCoresUsed = 0;
  let ramGbUsed = 0;
  let diskGbUsed = 0;
  for (const server of values(world.servers)) {
    cpuCoresTotal += server.cpuCores * performanceModifier;
    ramGbTotal += server.ramGb;
    diskGbTotal += server.ssdGb + server.hddGb;
    const pooled = poolLoadOnServer(world, server.id);
    cpuCoresUsed += pooled.cpu;
    ramGbUsed += pooled.ram;
    diskGbUsed += pooled.ssd + pooled.hdd;
  }
  for (const vps of values(world.vpsInstances)) {
    if (!world.servers[vps.hostServerId]) continue;
    cpuCoresUsed += vps.vcpu;
    ramGbUsed += vps.ramGb;
    diskGbUsed += vps.diskGb;
  }
  for (const contract of values(world.contracts)) {
    if (contract.state === "cancelled") continue;
    if (!contract.serverId || contract.vpsId) continue;
    const product = world.products[contract.productId];
    if (!product) continue;
    cpuCoresUsed += product.resources.cpuCores;
    ramGbUsed += product.resources.ramGb;
    diskGbUsed += product.resources.ssdGb + product.resources.hddGb;
  }
  return { cpuCoresTotal, cpuCoresUsed, ramGbTotal, ramGbUsed, diskGbTotal, diskGbUsed };
}
function usage(used, installed, factor) {
  const limit = installed * factor;
  return { used, installed, limit, ratio: limit > 0 ? clamp(used / limit, 0, 1) : 0 };
}
function serverUtilization(world, serverId, performanceModifier = 1) {
  const server = world.servers[serverId];
  if (!server) return null;
  const capacity = serverCapacity(world, serverId, performanceModifier);
  const o = overcommitOfRole(server.role);
  const cpu = usage(capacity.cpuCoresUsed, capacity.cpuCores, o.cpu);
  const ram = usage(capacity.ramGbUsed, capacity.ramGb, o.ram);
  const ssd = usage(capacity.ssdGbUsed, capacity.ssdGb, o.disk);
  const hdd = usage(capacity.hddGbUsed, capacity.hddGb, o.disk);
  const candidates = [
    ["cpu", cpu],
    ["ram", ram],
    ["ssd", ssd],
    ["hdd", hdd]
  ];
  const tightest = candidates.filter(([, r]) => r.installed > 0).sort((a, b) => b[1].ratio - a[1].ratio)[0];
  const load = serverLoad(world, serverId);
  const belegt = server.contractIds.filter((id) => world.contracts[id]?.state !== "cancelled").length > 0 || server.vpsIds.length > 0;
  const exclusive = server.role === "dedicated" && belegt;
  return {
    serverId,
    cpu,
    ram,
    ssd,
    hdd,
    /*
     * `fill` beantwortet die Frage "kann hier noch etwas verkauft werden?"
     * (siehe Kommentar an `ServerUtilization`). Bei einem exklusiv vergebenen
     * Server lautet die Antwort nein – unabhängig davon, wie viel Blech der
     * Kunde tatsächlich nutzt. Die vier Ressourcenzeilen darüber zeigen
     * weiterhin die echte Belegung, damit die Fehlbestückung sichtbar bleibt.
     */
    fill: exclusive ? 1 : tightest ? tightest[1].ratio : 0,
    bottleneck: tightest ? tightest[0] : "cpu",
    load,
    watt: devicePowerWatt(server, load),
    vpsCount: server.vpsIds.filter((id) => !!world.vpsInstances[id]).length,
    contractCount: server.contractIds.filter((id) => world.contracts[id]?.state !== "cancelled").length,
    exclusive
  };
}
function serverUtilizations(world, performanceModifier = 1) {
  const list = [];
  for (const server of values(world.servers)) {
    const utilization = serverUtilization(world, server.id, performanceModifier);
    if (utilization) list.push(utilization);
  }
  return list;
}
function serverLoadRows(world, performanceModifier = 1) {
  const round = (value) => Number(value.toFixed(3));
  return serverUtilizations(world, performanceModifier).map((u) => ({
    id: u.serverId,
    fill: round(u.fill),
    bottleneck: u.bottleneck,
    cpu: round(u.cpu.ratio),
    ram: round(u.ram.ratio),
    ssd: round(u.ssd.ratio),
    hdd: round(u.hdd.ratio),
    load: round(u.load),
    watt: Math.round(u.watt),
    services: u.vpsCount + u.contractCount
  }));
}

// src/domain/network/loadbalancing.ts
var ok3 = (message, createdId) => ({ ok: true, message, createdId });
var fail3 = (message) => ({ ok: false, message });
function findPool(world, poolId) {
  for (const balancer of values(world.loadBalancers)) {
    const pool = balancer.pools.find((p) => p.id === poolId);
    if (pool) return { balancer, pool };
  }
  return void 0;
}
function poolsAt(world, datacenterId) {
  const out = [];
  for (const balancer of values(world.loadBalancers)) {
    if (balancer.datacenterId !== datacenterId) continue;
    for (const pool of balancer.pools) out.push({ balancer, pool });
  }
  return out;
}
function poolsOfServer(world, serverId) {
  const out = [];
  for (const balancer of values(world.loadBalancers)) {
    for (const pool of balancer.pools) {
      const member = pool.members.find((m) => m.serverId === serverId);
      if (member) out.push({ balancer, pool, member });
    }
  }
  return out;
}
function balancerPathUp(world, balancer) {
  const usable = (lb) => !!lb && (lb.state === "online" || lb.state === "degraded") && lbConnected(world, lb);
  if (usable(balancer)) return true;
  return balancer.peerId ? usable(world.loadBalancers[balancer.peerId]) : false;
}
function lbConnected(world, balancer) {
  for (const sw of values(world.switches)) {
    if (sw.state !== "online" && sw.state !== "degraded") continue;
    for (const port of sw.ports) {
      if (port.connectedDevice?.kind === "loadbalancer" && port.connectedDevice.id === balancer.id) {
        return port.enabled !== false;
      }
    }
  }
  return false;
}
function servingMembers(world, pool) {
  return pool.members.filter((member) => {
    if (!member.healthy || member.drain) return false;
    const server = world.servers[member.serverId];
    return !!server && (server.state === "online" || server.state === "degraded") && isServerConnected(world, member.serverId);
  });
}
function createPool(world, rng, input) {
  const balancer = world.loadBalancers[input.loadBalancerId];
  if (!balancer) return fail3("Loadbalancer nicht gefunden.");
  if (!input.name.trim()) return fail3("Der Pool braucht einen Namen.");
  const pool = {
    id: asId(makeId(rng, "pool")),
    name: input.name.trim(),
    vip: input.vip ?? null,
    algorithm: input.algorithm ?? "least-connections",
    tlsTermination: false,
    /*
     * Sitzungsbindung ist voreingestellt an.
     *
     * Die Voreinstellung, die im Zweifel niemanden ausloggt, ist die richtige:
     * Wer sie abschaltet, tut es, weil seine Anwendung zustandslos ist – und
     * weiß dann auch, was er tut.
     */
    sessionPersistence: true,
    healthCheckSeconds: 5,
    unhealthyThreshold: 3,
    members: [],
    contractIds: [],
    availability: 1,
    trafficMbps: 0
  };
  balancer.pools.push(pool);
  return ok3(`Pool \u201E${pool.name}\u201C auf ${balancer.name} angelegt.`, pool.id);
}
function deletePool(world, poolId) {
  const found = findPool(world, poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  if (found.pool.contractIds.length > 0) {
    return fail3(
      `Auf \u201E${found.pool.name}\u201C liegen noch ${found.pool.contractIds.length} Vertr\xE4ge. Sie m\xFCssen zuerst auf einen Server zur\xFCckgelegt werden \u2013 sonst w\xE4ren sie nirgends.`
    );
  }
  found.balancer.pools = found.balancer.pools.filter((p) => p.id !== poolId);
  return ok3(`Pool \u201E${found.pool.name}\u201C entfernt.`);
}
function updatePool(world, poolId, patch) {
  const found = findPool(world, poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  const { pool } = found;
  if (patch.healthCheckSeconds !== void 0 && (patch.healthCheckSeconds < 1 || patch.healthCheckSeconds > 300)) {
    return fail3("Ein Pr\xFCfintervall unter einer Sekunde belastet nur die Backends, \xFCber f\xFCnf Minuten ist es keine Pr\xFCfung mehr.");
  }
  if (patch.unhealthyThreshold !== void 0 && (patch.unhealthyThreshold < 1 || patch.unhealthyThreshold > 10)) {
    return fail3("Zwischen einer und zehn fehlgeschlagenen Proben \u2013 alles andere ist entweder nerv\xF6s oder blind.");
  }
  Object.assign(pool, patch);
  return ok3(`Pool \u201E${pool.name}\u201C angepasst.`);
}
function addPoolMember(world, input, performanceModifier = 1) {
  const found = findPool(world, input.poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  const { balancer, pool } = found;
  const server = world.servers[input.serverId];
  if (!server) return fail3("Server nicht gefunden.");
  if (pool.members.some((m) => m.serverId === server.id)) return fail3(`${server.name} ist bereits Mitglied von \u201E${pool.name}\u201C.`);
  if (server.datacenterId !== balancer.datacenterId) {
    return fail3(
      `${server.name} steht in ${world.datacenters[server.datacenterId]?.city ?? "?"}, ${balancer.name} in ${world.datacenters[balancer.datacenterId]?.city ?? "?"}. Ein Pool \xFCber Standorte hinweg braucht Anycast, nicht einen Balancer.`
    );
  }
  if (server.os === null) return fail3(`${server.name} hat kein Betriebssystem.`);
  if (server.retirement) return fail3(`${server.name} ist zur Abgabe vorgemerkt.`);
  if (!isServerConnected(world, server.id)) return fail3(`${server.name} h\xE4ngt an keinem Switch \u2013 erst verkabeln.`);
  const capacity = serverCapacity(world, server.id, performanceModifier);
  for (const contractId of pool.contractIds) {
    const contract = world.contracts[contractId];
    const product = contract ? world.products[contract.productId] : void 0;
    if (!product) continue;
    const role = requiredRole(product);
    if (role !== null && server.role !== role) {
      return fail3(`${server.name} hat die Rolle \u201E${server.role}\u201C, der Pool liefert ${product.name} aus (braucht \u201E${role}\u201C).`);
    }
    if (!fits(capacity, product)) {
      return fail3(`${server.name} k\xF6nnte die Last des Pools nicht allein tragen \u2013 als Reserve w\xE4re er wertlos.`);
    }
    capacity.cpuCoresUsed += product.resources.cpuCores;
    capacity.ramGbUsed += product.resources.ramGb;
    capacity.ssdGbUsed += product.resources.ssdGb;
    capacity.hddGbUsed += product.resources.hddGb;
  }
  pool.members.push({
    serverId: server.id,
    weight: Math.max(1, Math.round(input.weight ?? 1)),
    healthy: true,
    failedChecks: 0,
    drain: false
  });
  return ok3(
    `${server.name} in \u201E${pool.name}\u201C aufgenommen (${pool.members.length} ${pool.members.length === 1 ? "Mitglied" : "Mitglieder"}).` + (pool.members.length === 1 ? " Ein Pool mit einem Mitglied ist noch keine Redundanz." : "")
  );
}
function removePoolMember(world, input) {
  const found = findPool(world, input.poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  const { pool } = found;
  const member = pool.members.find((m) => m.serverId === input.serverId);
  if (!member) return fail3("Dieser Server ist kein Mitglied des Pools.");
  if (pool.contractIds.length > 0 && servingMembers(world, pool).length <= 1 && !member.drain) {
    return fail3(
      `${world.servers[input.serverId]?.name ?? "Dieser Knoten"} ist das letzte ausliefernde Mitglied. Ihn jetzt herauszunehmen nimmt den Pool vom Netz.`
    );
  }
  pool.members = pool.members.filter((m) => m.serverId !== input.serverId);
  return ok3(`${world.servers[input.serverId]?.name ?? "Server"} aus \u201E${pool.name}\u201C entfernt.`);
}
function setMemberDrain(world, input) {
  const found = findPool(world, input.poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  const { pool } = found;
  const member = pool.members.find((m) => m.serverId === input.serverId);
  if (!member) return fail3("Dieser Server ist kein Mitglied des Pools.");
  if (input.drain && pool.contractIds.length > 0) {
    const remaining = servingMembers(world, pool).filter((m) => m.serverId !== input.serverId).length;
    if (remaining === 0) {
      return fail3("Danach bliebe kein ausliefernder Knoten \xFCbrig \u2013 der Pool w\xE4re offline. Erst ein zweites Mitglied aufnehmen.");
    }
  }
  member.drain = input.drain;
  const name = world.servers[input.serverId]?.name ?? "Server";
  return ok3(
    input.drain ? `${name} bekommt keine neuen Sitzungen mehr. Sobald die laufenden durch sind, l\xE4sst er sich gefahrlos anfassen.` : `${name} nimmt wieder Sitzungen an.`
  );
}
function setMemberWeight(world, input) {
  const found = findPool(world, input.poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  const member = found.pool.members.find((m) => m.serverId === input.serverId);
  if (!member) return fail3("Dieser Server ist kein Mitglied des Pools.");
  if (input.weight < 1 || input.weight > 100) return fail3("Das Gewicht liegt zwischen 1 und 100.");
  member.weight = Math.round(input.weight);
  return ok3(`Gewicht von ${world.servers[input.serverId]?.name ?? "Server"} auf ${member.weight} gesetzt.`);
}
function attachContractToPool(world, input, performanceModifier = 1) {
  const found = findPool(world, input.poolId);
  if (!found) return fail3("Pool nicht gefunden.");
  const { pool } = found;
  const contract = world.contracts[input.contractId];
  if (!contract) return fail3("Vertrag nicht gefunden.");
  if (contract.state === "cancelled") return fail3("Der Vertrag ist gek\xFCndigt.");
  if (contract.poolId === pool.id) return fail3("Der Vertrag liegt bereits auf diesem Pool.");
  if (contract.vpsId) return fail3("Eine VPS ist eine einzelne Maschine \u2013 sie l\xE4sst sich nicht auf einen Pool legen.");
  if (contract.rackId) return fail3("Colocation liefert der Kunde selbst aus; ein Pool \xE4ndert daran nichts.");
  const product = world.products[contract.productId];
  if (!product) return fail3("Produkt nicht gefunden.");
  if (pool.members.length === 0) return fail3(`\u201E${pool.name}\u201C hat noch kein Mitglied \u2013 dort l\xE4ge der Vertrag im Nichts.`);
  const role = requiredRole(product);
  for (const member of pool.members) {
    const server = world.servers[member.serverId];
    if (!server) continue;
    if (role !== null && server.role !== role) {
      return fail3(`${server.name} hat die Rolle \u201E${server.role}\u201C, ${product.name} braucht \u201E${role}\u201C.`);
    }
    if (server.id === contract.serverId) continue;
    if (!fits(serverCapacity(world, server.id, performanceModifier), product)) {
      return fail3(`Auf ${server.name} ist kein Platz f\xFCr eine weitere Kopie von ${product.name}.`);
    }
  }
  if (contract.serverId) {
    const previous = world.servers[contract.serverId];
    if (previous) previous.contractIds = previous.contractIds.filter((id) => id !== contract.id);
  }
  if (contract.poolId) detachFromPoolList(world, contract.poolId, contract.id);
  contract.serverId = null;
  contract.poolId = pool.id;
  pool.contractIds.push(contract.id);
  const customer = world.customers[contract.customerId];
  return ok3(
    `${product.name} von ${customer?.company ?? customer?.name ?? "Kunde"} liegt jetzt auf \u201E${pool.name}\u201C (${pool.members.length} ${pool.members.length === 1 ? "Mitglied" : "Mitglieder"}). Der Ausfall eines einzelnen Knotens trifft ihn ab sofort nicht mehr.`
  );
}
function detachContractFromPool(world, input, performanceModifier = 1) {
  const contract = world.contracts[input.contractId];
  if (!contract) return fail3("Vertrag nicht gefunden.");
  if (!contract.poolId) return fail3("Der Vertrag liegt auf keinem Pool.");
  const target = world.servers[input.targetServerId];
  if (!target) return fail3("Zielserver nicht gefunden.");
  const product = world.products[contract.productId];
  if (!product) return fail3("Produkt nicht gefunden.");
  const role = requiredRole(product);
  if (role !== null && target.role !== role) return fail3(`${target.name} hat die Rolle \u201E${target.role}\u201C, gebraucht wird \u201E${role}\u201C.`);
  if (target.os === null) return fail3(`${target.name} hat kein Betriebssystem.`);
  const alreadyMember = poolsOfServer(world, target.id).some((entry) => entry.pool.id === contract.poolId);
  if (!alreadyMember && !fits(serverCapacity(world, target.id, performanceModifier), product)) {
    return fail3(`Auf ${target.name} ist kein Platz mehr f\xFCr ${product.name}.`);
  }
  detachFromPoolList(world, contract.poolId, contract.id);
  contract.poolId = null;
  contract.serverId = target.id;
  if (!target.contractIds.includes(contract.id)) target.contractIds.push(contract.id);
  return ok3(`${product.name} liegt wieder allein auf ${target.name} \u2013 ab jetzt trifft ihn dessen Ausfall wieder voll.`);
}
function detachFromPoolList(world, poolId, contractId) {
  const found = findPool(world, poolId);
  if (!found) return;
  found.pool.contractIds = found.pool.contractIds.filter((id) => id !== contractId);
}
function dropContractFromPools(world, contractId) {
  for (const balancer of values(world.loadBalancers)) {
    for (const pool of balancer.pools) {
      pool.contractIds = pool.contractIds.filter((id) => id !== contractId);
    }
  }
}
function dropServerFromPools(world, serverId) {
  for (const balancer of values(world.loadBalancers)) {
    for (const pool of balancer.pools) {
      pool.members = pool.members.filter((m) => m.serverId !== serverId);
    }
  }
}
function pairLoadBalancers(world, a, b) {
  const first = world.loadBalancers[a];
  const second = world.loadBalancers[b];
  if (!first || !second) return fail3("Loadbalancer nicht gefunden.");
  if (first.id === second.id) return fail3("Ein Ger\xE4t kann nicht sein eigener Partner sein.");
  if (first.datacenterId !== second.datacenterId) {
    return fail3("Ein Paar teilt sich eine virtuelle Adresse \u2013 das geht nur im selben Standortnetz.");
  }
  if (first.peerId && first.peerId !== second.id) return fail3(`${first.name} ist bereits gekoppelt.`);
  if (second.peerId && second.peerId !== first.id) return fail3(`${second.name} ist bereits gekoppelt.`);
  if (second.pools.length > 0) {
    return fail3(`${second.name} tr\xE4gt eigene Pools. Die Reserve muss leer sein, sonst laufen zwei Konfigurationen auseinander.`);
  }
  first.peerId = second.id;
  second.peerId = first.id;
  first.haRole = "active";
  second.haRole = "standby";
  return ok3(`${first.name} und ${second.name} bilden ein Paar. ${second.name} \xFCbernimmt, sobald ${first.name} ausf\xE4llt.`);
}
function unpairLoadBalancer(world, id) {
  const balancer = world.loadBalancers[id];
  if (!balancer) return fail3("Loadbalancer nicht gefunden.");
  if (!balancer.peerId) return fail3(`${balancer.name} ist nicht gekoppelt.`);
  const peer = world.loadBalancers[balancer.peerId];
  if (peer) {
    peer.peerId = null;
    peer.haRole = "active";
  }
  balancer.peerId = null;
  balancer.haRole = "active";
  return ok3(`Kopplung von ${balancer.name} aufgehoben. Beide Ger\xE4te stehen jetzt allein.`);
}
function updateLoadBalancers(world, rng) {
  const result = { messages: [] };
  const factor = diurnalFactor(world.meta.tick);
  for (const balancer of values(world.loadBalancers)) {
    if (balancer.peerId) {
      const peer = world.loadBalancers[balancer.peerId];
      const selfUp = balancer.state === "online" || balancer.state === "degraded";
      if (!selfUp && balancer.haRole === "active" && peer && (peer.state === "online" || peer.state === "degraded")) {
        balancer.haRole = "standby";
        peer.haRole = "active";
        result.messages.push({
          text: `${peer.name} hat die virtuelle Adresse von ${balancer.name} \xFCbernommen. Die Kunden haben davon nichts gemerkt.`,
          severity: "warning",
          ref: { kind: "loadbalancer", id: peer.id }
        });
      }
    }
    const pathUp = balancerPathUp(world, balancer);
    let trafficMbps = 0;
    for (const pool of balancer.pools) {
      const lostShare = runHealthChecks(world, pool, result);
      const serving = servingMembers(world, pool);
      const poolTraffic = poolTrafficMbps(world, pool, factor);
      pool.trafficMbps = Number(poolTraffic.toFixed(2));
      trafficMbps += poolTraffic;
      if (!pathUp) {
        pool.availability = 0;
        continue;
      }
      if (pool.contractIds.length === 0) {
        pool.availability = 1;
        continue;
      }
      if (serving.length === 0) {
        pool.availability = 0;
        result.messages.push({
          text: `Pool \u201E${pool.name}\u201C hat kein ausliefendes Mitglied mehr \u2013 alles darauf ist offline.`,
          severity: "error",
          ref: { kind: "loadbalancer", id: balancer.id }
        });
        continue;
      }
      pool.availability = clamp(1 - lostShare, 0, 1);
      if (!pool.sessionPersistence && serving.length > 1 && statefulPool(world, pool)) {
        if (rng.chance(LOADBALANCING.SESSION_LOSS_TICKET_CHANCE)) {
          const affected = rng.pick(pool.contractIds);
          const contract = affected ? world.contracts[affected] : void 0;
          const customer = contract ? world.customers[contract.customerId] : void 0;
          if (customer) customer.satisfaction = clamp(customer.satisfaction - 2, 0, 100);
          result.messages.push({
            text: `Beschwerde aus \u201E${pool.name}\u201C: ${customer?.company ?? customer?.name ?? "Ein Kunde"} wird beim Klicken abgemeldet. Ohne Sitzungsbindung landet derselbe Besucher bei jeder Anfrage auf einem anderen Knoten.`,
            severity: "warning",
            ref: { kind: "loadbalancer", id: balancer.id }
          });
        }
      }
    }
    const throughputLoad = balancer.throughputMbps > 0 ? trafficMbps / balancer.throughputMbps : 0;
    const connections = trafficMbps * LOADBALANCING.CONNECTIONS_PER_MBPS;
    const connectionLoad = balancer.connectionCapacity > 0 ? connections / balancer.connectionCapacity : 0;
    const handshakes = balancer.pools.some((p) => p.tlsTermination) ? trafficMbps * LOADBALANCING.HANDSHAKES_PER_MBPS : 0;
    const tlsLoad = balancer.tlsHandshakesPerSecond > 0 ? handshakes / balancer.tlsHandshakesPerSecond : 0;
    balancer.load = clamp(Math.max(throughputLoad, connectionLoad, tlsLoad), 0, 2);
    if (balancer.load > LOADBALANCING.CONGESTION_THRESHOLD && pathUp) {
      const overload = (balancer.load - LOADBALANCING.CONGESTION_THRESHOLD) / (1 - LOADBALANCING.CONGESTION_THRESHOLD);
      const lossShare = clamp(overload * 0.6, 0, 0.9);
      for (const pool of balancer.pools) {
        if (pool.contractIds.length === 0) continue;
        pool.availability = clamp(pool.availability * (1 - lossShare), 0, 1);
      }
      if (world.meta.tick % 4 === 0) {
        result.messages.push({
          text: `${balancer.name} ist \xFCberlastet (${Math.round(balancer.load * 100)} %${tlsLoad >= throughputLoad && tlsLoad >= connectionLoad ? ", Grenze sind die TLS-Handshakes" : ""}). Verbindungen werden abgewiesen.`,
          severity: "error",
          ref: { kind: "loadbalancer", id: balancer.id }
        });
      }
    }
  }
  return result;
}
function runHealthChecks(world, pool, result) {
  const totalWeight = pool.members.reduce((sum3, m) => sum3 + (m.drain || !m.healthy ? 0 : m.weight), 0);
  let lostShare = 0;
  for (const member of pool.members) {
    const server = world.servers[member.serverId];
    const up = !!server && (server.state === "online" || server.state === "degraded") && isServerConnected(world, member.serverId);
    if (up) {
      if (!member.healthy) {
        member.healthy = true;
        member.failedChecks = 0;
        result.messages.push({
          text: `${server.name} ist wieder in der Rotation von \u201E${pool.name}\u201C.`,
          severity: "info",
          ref: { kind: "server", id: member.serverId }
        });
      } else {
        member.failedChecks = 0;
      }
      continue;
    }
    if (!member.healthy) continue;
    member.healthy = false;
    member.failedChecks = pool.unhealthyThreshold;
    const gapSeconds = pool.healthCheckSeconds * pool.unhealthyThreshold;
    const share = totalWeight > 0 && !member.drain ? member.weight / totalWeight : 0;
    lostShare += gapSeconds / (SIM.MINUTES_PER_TICK * 60) * share;
    result.messages.push({
      text: `${server?.name ?? "Ein Mitglied"} aus \u201E${pool.name}\u201C gefallen. Der Balancer hat ${gapSeconds} Sekunden gebraucht, um es zu merken; danach trugen die \xDCbrigen weiter.`,
      severity: "warning",
      ref: { kind: "server", id: member.serverId }
    });
  }
  return lostShare;
}
function poolTrafficMbps(world, pool, factor = 1) {
  let mbps = 0;
  for (const contractId of pool.contractIds) {
    const contract = world.contracts[contractId];
    if (!contract || contract.state !== "active") continue;
    const product = world.products[contract.productId];
    if (product) mbps += product.resources.trafficMbps * factor;
  }
  return mbps;
}
function statefulPool(world, pool) {
  return pool.contractIds.some((id) => {
    const contract = world.contracts[id];
    const kind = contract ? world.products[contract.productId]?.kind : void 0;
    return kind === "shared-hosting" || kind === "mail";
  });
}
function poolAvailabilityOf(world, poolId) {
  return findPool(world, poolId)?.pool.availability ?? 0;
}
function poolDatacenterId(world, poolId) {
  return findPool(world, poolId)?.balancer.datacenterId ?? null;
}
var ALGORITHM_LABEL = {
  "round-robin": "Reihum",
  "least-connections": "Wenigste Verbindungen",
  "source-hash": "Nach Quelladresse"
};
function poolCandidates(world, poolId) {
  const found = findPool(world, poolId);
  if (!found) return [];
  const { balancer, pool } = found;
  return values(world.servers).filter((s) => s.datacenterId === balancer.datacenterId).filter((s) => s.os !== null && !s.retirement).filter((s) => !pool.members.some((m) => m.serverId === s.id)).filter((s) => s.state === "online" || s.state === "degraded");
}

// src/domain/compute/migration.ts
var ok4 = (message, migrationId) => ({ ok: true, message, migrationId });
var fail4 = (message) => ({ ok: false, message });
var RUNNING = ["queued", "disk", "memory", "cutover"];
function serverUplinkMbps(world, server) {
  const nic = serverNicMbps(server);
  const port = server.uplink ? world.switches[server.uplink.switchId]?.ports[server.uplink.portIndex]?.speedMbps ?? 0 : 0;
  if (nic > 0 && port > 0) return Math.min(nic, port);
  return nic || port || MIGRATION.FALLBACK_MBPS;
}
function interDcFreeMbps(world, a, b) {
  let free2 = 0;
  for (const link of values(world.links)) {
    if (link.kind !== "fiber-owned" && link.kind !== "fiber-leased" && link.kind !== "internal") continue;
    if (link.state !== "up") continue;
    const ends = [link.a.datacenterId, link.b.datacenterId];
    if (!ends.includes(a) || !ends.includes(b)) continue;
    const peak = Math.max(link.utilizationMbps.aToB, link.utilizationMbps.bToA);
    free2 += Math.max(0, link.capacityMbps - peak);
  }
  return free2;
}
function transferPath(world, source, target) {
  const local = Math.min(serverUplinkMbps(world, source), serverUplinkMbps(world, target));
  if (source.datacenterId === target.datacenterId) {
    return { capacityMbps: local, bottleneck: "Serveranbindung", crossSite: false };
  }
  const wan = interDcFreeMbps(world, source.datacenterId, target.datacenterId);
  return {
    capacityMbps: Math.min(local, wan),
    bottleneck: wan < local ? "Backbone zwischen den Standorten" : "Serveranbindung",
    crossSite: true
  };
}
function plannedRateMbps(world, source, target) {
  return transferPath(world, source, target).capacityMbps * MIGRATION.LINK_SHARE;
}
function activeTransfers(world, serverId) {
  return values(world.migrations).filter(
    (job) => (job.phase === "disk" || job.phase === "memory" || job.phase === "cutover") && (job.sourceServerId === serverId || job.targetServerId === serverId)
  );
}
function migrationRateMbps(world, job) {
  const source = world.servers[job.sourceServerId];
  const target = world.servers[job.targetServerId];
  if (!source || !target) return 0;
  const path = transferPath(world, source, target);
  const sharing = Math.max(1, activeTransfers(world, job.sourceServerId).length, activeTransfers(world, job.targetServerId).length);
  return path.capacityMbps * MIGRATION.LINK_SHARE / sharing;
}
function gbPerTick(mbps) {
  return mbps * 3600 / 8 / 1e3;
}
function estimateMigration(world, input) {
  const empty = {
    ok: false,
    diskGb: 0,
    ramGb: 0,
    rateMbps: 0,
    ticks: 0,
    freezeSeconds: 0,
    convergenceRisk: false,
    bottleneck: "",
    crossSite: false,
    seamless: false
  };
  const reject = (error) => ({ ...empty, error });
  const target = world.servers[input.targetServerId];
  if (!target) return reject("Zielserver nicht gefunden.");
  let source;
  let diskGb = 0;
  let ramGb = 0;
  let cpuLoad = 0.3;
  let seamless = false;
  if (input.kind === "vps") {
    const vps = world.vpsInstances[input.id];
    if (!vps) return reject("Instanz nicht gefunden.");
    source = world.servers[vps.hostServerId];
    diskGb = vps.diskGb;
    ramGb = vps.ramGb;
    cpuLoad = vps.cpuLoad;
  } else {
    const contract = world.contracts[input.id];
    if (!contract) return reject("Vertrag nicht gefunden.");
    const product = world.products[contract.productId];
    if (!product) return reject("Produkt des Vertrags ist unbekannt.");
    source = contract.serverId ? world.servers[contract.serverId] : void 0;
    diskGb = product.resources.ssdGb + product.resources.hddGb;
    seamless = contract.poolId !== null;
  }
  if (!source) return reject("Der Dienst liegt auf keinem Server.");
  const path = transferPath(world, source, target);
  if (path.capacityMbps <= 0) {
    return reject(
      source.datacenterId === target.datacenterId ? "Zwischen den beiden Knoten besteht keine nutzbare Verbindung." : "Zwischen den Standorten gibt es keine freie eigene Strecke \u2013 \xFCber fremden Transit wird nicht migriert."
    );
  }
  const sharing = Math.max(1, activeTransfers(world, source.id).length, activeTransfers(world, target.id).length);
  const rate = path.capacityMbps * MIGRATION.LINK_SHARE / sharing;
  const perTick = gbPerTick(rate);
  const dirtyPerTick = ramGb * clamp(cpuLoad, 0.05, 1) * MIGRATION.DIRTY_RATE_PER_HOUR;
  const convergenceRisk = ramGb > 0 && dirtyPerTick >= perTick * 0.8;
  const diskTicks = perTick > 0 ? diskGb / perTick : Infinity;
  const memoryTicks = ramGb > 0 && perTick > 0 ? convergenceRisk ? MIGRATION.MAX_PASSES : ramGb / perTick : 0;
  const ticks = Math.max(1, Math.ceil(diskTicks + memoryTicks));
  const freezeSeconds = seamless ? 0 : input.kind === "contract" ? cutoverSecondsForContract(diskGb) : convergenceRisk ? dirtyPerTick / Math.max(1e-3, perTick) * 3600 * MIGRATION.SWITCHOVER_SHARE * 10 : Math.min(ramGb, perTick * MIGRATION.SWITCHOVER_SHARE) / Math.max(1e-3, perTick) * 3600;
  return {
    ok: true,
    diskGb,
    ramGb,
    rateMbps: rate,
    ticks,
    freezeSeconds: Math.round(freezeSeconds),
    convergenceRisk,
    bottleneck: path.bottleneck,
    crossSite: path.crossSite,
    seamless
  };
}
function cutoverSecondsForContract(diskGb) {
  return clamp(120 + diskGb * 1.5, 120, 1800);
}
function migrationOf(world, kind, id) {
  return values(world.migrations).find((job) => job.subject.kind === kind && job.subject.id === id && RUNNING.includes(job.phase));
}
function runningMigrations(world) {
  return values(world.migrations).filter((job) => RUNNING.includes(job.phase));
}
function createJob(world, rng, base) {
  const job = {
    ...base,
    id: asId(makeId(rng, "mig")),
    phase: "queued",
    startedAtTick: world.meta.tick,
    diskGbSent: 0,
    ramGbOutstanding: base.ramGbTotal,
    passes: 0,
    rateMbps: 0,
    freezeSeconds: 0,
    note: ""
  };
  world.migrations[job.id] = job;
  return job;
}
function startVpsMigration(world, rng, input, performanceModifier = 1) {
  const vps = world.vpsInstances[input.vpsId];
  if (!vps) return fail4("Instanz nicht gefunden.");
  if (migrationOf(world, "vps", vps.id)) return fail4(`${vps.name} zieht bereits um.`);
  const source = world.servers[vps.hostServerId];
  const target = world.servers[input.targetServerId];
  if (!target) return fail4("Zielserver nicht gefunden.");
  if (target.id === vps.hostServerId) return fail4("Quelle und Ziel sind derselbe Server.");
  if (target.role !== "vps-host") return fail4(`${target.name} ist kein VPS-Host.`);
  if (target.os === null) return fail4(`${target.name} hat kein Betriebssystem.`);
  if (target.state !== "online" && target.state !== "degraded") return fail4(`${target.name} ist nicht betriebsbereit.`);
  if (target.retirement) return fail4(`${target.name} ist zur Abgabe vorgemerkt und nimmt nichts mehr auf.`);
  if (!isServerConnected(world, target.id)) return fail4(`${target.name} h\xE4ngt an keinem Switch \u2013 erst verkabeln.`);
  if (source && source.state !== "online" && source.state !== "degraded") {
    return fail4(`${source.name} ist nicht betriebsbereit \u2013 eine Live-Migration braucht einen laufenden Quellhost.`);
  }
  const capacity = serverCapacity(world, target.id, performanceModifier);
  if (capacity.ramGbUsed + vps.ramGb > capacity.ramGb) {
    return fail4(
      `${target.name} hat nicht genug freien Arbeitsspeicher (${Math.round(capacity.ramGb - capacity.ramGbUsed)} GB frei, ${vps.ramGb} GB n\xF6tig).`
    );
  }
  if (capacity.ssdGbUsed + vps.diskGb > capacity.ssdGb) {
    return fail4(
      `${target.name} hat nicht genug freien Speicher (${Math.round(capacity.ssdGb - capacity.ssdGbUsed)} GB frei, ${vps.diskGb} GB n\xF6tig).`
    );
  }
  const estimate = estimateMigration(world, { kind: "vps", id: vps.id, targetServerId: target.id });
  if (!estimate.ok) return fail4(estimate.error);
  const job = createJob(world, rng, {
    subject: { kind: "vps", id: vps.id },
    sourceServerId: vps.hostServerId,
    targetServerId: target.id,
    diskGbTotal: vps.diskGb,
    ramGbTotal: vps.ramGb,
    reason: input.reason ?? "manual"
  });
  if (!target.vpsIds.includes(vps.id)) target.vpsIds.push(vps.id);
  return ok4(
    `Umzug von ${vps.name} nach ${target.name} eingereiht: ${Math.round(vps.diskGb)} GB Platte, ${vps.ramGb} GB Arbeitsspeicher \xFCber ${formatRate(estimate.rateMbps)} \u2013 etwa ${estimate.ticks} h.` + (estimate.convergenceRisk ? " Achtung: Die Instanz beschreibt ihren Speicher schneller, als die Leitung ihn \xFCbertr\xE4gt. Das Umschalten wird eine sp\xFCrbare Pause kosten." : ""),
    job.id
  );
}
function startContractMigration(world, rng, input, performanceModifier = 1) {
  const contract = world.contracts[input.contractId];
  if (!contract) return fail4("Vertrag nicht gefunden.");
  if (contract.state === "cancelled") return fail4("Der Vertrag ist gek\xFCndigt.");
  if (contract.vpsId) return fail4("Dieser Vertrag h\xE4ngt an einer VPS \u2013 daf\xFCr die Live-Migration der Instanz nutzen.");
  if (!contract.serverId) {
    return fail4(
      contract.poolId ? "Dieser Vertrag liegt auf einem Backend-Pool. Dort wird nicht der Vertrag verlegt, sondern das Pool-Mitglied getauscht." : "Dieser Vertrag liegt auf keinem Server."
    );
  }
  if (contract.serverId === input.targetServerId) return fail4("Quelle und Ziel sind derselbe Server.");
  if (migrationOf(world, "contract", contract.id)) return fail4("F\xFCr diesen Vertrag l\xE4uft bereits ein Umzug.");
  const product = world.products[contract.productId];
  if (!product) return fail4("Produkt nicht gefunden.");
  const target = world.servers[input.targetServerId];
  if (!target) return fail4("Zielserver nicht gefunden.");
  const role = requiredRole(product);
  if (role !== null && target.role !== role) {
    return fail4(`${target.name} hat die Rolle "${target.role}", gebraucht wird "${role}".`);
  }
  if (target.os === null) return fail4(`${target.name} hat kein Betriebssystem.`);
  if (target.state !== "online" && target.state !== "degraded") return fail4(`${target.name} ist nicht betriebsbereit (${target.state}).`);
  if (target.retirement) return fail4(`${target.name} ist zur Abgabe vorgemerkt und nimmt nichts mehr auf.`);
  if (!isServerConnected(world, target.id)) return fail4(`${target.name} h\xE4ngt an keinem Switch \u2013 erst verkabeln.`);
  if (!fits(serverCapacity(world, target.id, performanceModifier), product)) {
    return fail4(`Auf ${target.name} ist kein Platz mehr f\xFCr ${product.name}.`);
  }
  const estimate = estimateMigration(world, { kind: "contract", id: contract.id, targetServerId: target.id });
  if (!estimate.ok) return fail4(estimate.error);
  const job = createJob(world, rng, {
    subject: { kind: "contract", id: contract.id },
    sourceServerId: contract.serverId,
    targetServerId: target.id,
    diskGbTotal: estimate.diskGb,
    ramGbTotal: 0,
    reason: input.reason ?? "manual"
  });
  if (!target.contractIds.includes(contract.id)) target.contractIds.push(contract.id);
  const customer = world.customers[contract.customerId];
  return ok4(
    `Umzug von ${product.name} (${customer?.company ?? customer?.name ?? "Kunde"}) nach ${target.name} eingereiht: ${Math.round(estimate.diskGb)} GB \xFCber ${formatRate(estimate.rateMbps)}, etwa ${estimate.ticks} h.` + (estimate.seamless ? " Der Vertrag liegt in einem Pool \u2013 das Umschalten bleibt unbemerkt." : ` Beim Umschalten f\xE4llt der Dienst rund ${Math.round(estimate.freezeSeconds / 60)} Minuten aus.`),
    job.id
  );
}
function cancelMigration(world, migrationId) {
  const job = world.migrations[migrationId];
  if (!job) return fail4("Umzug nicht gefunden.");
  if (!RUNNING.includes(job.phase)) return fail4("Dieser Umzug ist bereits abgeschlossen.");
  releaseReservation(world, job);
  job.phase = "failed";
  job.note = "Vom Betreiber abgebrochen.";
  return ok4("Umzug abgebrochen. Die \xFCbertragenen Daten auf dem Ziel sind verworfen.");
}
function releaseReservation(world, job) {
  const target = world.servers[job.targetServerId];
  if (!target) return;
  if (job.subject.kind === "vps") {
    target.vpsIds = target.vpsIds.filter((id) => id !== job.subject.id);
  } else {
    target.contractIds = target.contractIds.filter((id) => id !== job.subject.id);
  }
}
function dropMigrationsFor(world, kind, id) {
  for (const job of values(world.migrations)) {
    if (job.subject.kind !== kind || job.subject.id !== id) continue;
    if (RUNNING.includes(job.phase)) {
      releaseReservation(world, job);
      job.phase = "failed";
      job.note = "Der Dienst existiert nicht mehr.";
    }
  }
}
function advanceMigrations(world) {
  const result = { messages: [], disruptedContracts: [], drainedServerIds: [] };
  const touchedSources = /* @__PURE__ */ new Set();
  for (const job of values(world.migrations)) {
    if (!RUNNING.includes(job.phase)) continue;
    const source = world.servers[job.sourceServerId];
    const target = world.servers[job.targetServerId];
    const subjectGone = job.subject.kind === "vps" ? !world.vpsInstances[job.subject.id] : !world.contracts[job.subject.id];
    if (subjectGone || !target) {
      if (target) releaseReservation(world, job);
      job.phase = "failed";
      job.note = "Quelle oder Ziel sind verschwunden.";
      continue;
    }
    if (target.state === "failed" || target.state === "offline" || target.state === "maintenance") {
      releaseReservation(world, job);
      job.phase = "failed";
      job.note = `${target.name} ist nicht mehr verf\xFCgbar.`;
      result.messages.push({ text: `Umzug abgebrochen: ${target.name} ist nicht mehr verf\xFCgbar.`, severity: "warning" });
      continue;
    }
    if (source && (source.state === "failed" || source.state === "offline")) {
      releaseReservation(world, job);
      job.phase = "failed";
      job.note = `${source.name} ist ausgefallen \u2013 ohne laufende Quelle keine \xDCbertragung.`;
      result.messages.push({
        text: `Umzug abgebrochen: ${source.name} ist ausgefallen. Was dort lag, ist jetzt offline statt umgezogen.`,
        severity: "error"
      });
      continue;
    }
    if (job.phase === "queued") {
      const busySource = activeTransfers(world, job.sourceServerId).length;
      const busyTarget = activeTransfers(world, job.targetServerId).length;
      if (Math.max(busySource, busyTarget) >= MIGRATION.MAX_CONCURRENT_PER_SERVER) {
        job.note = `Wartet auf eine freie \xDCbertragungsspur (${MIGRATION.MAX_CONCURRENT_PER_SERVER} gleichzeitig).`;
        continue;
      }
      job.phase = job.diskGbTotal > job.diskGbSent ? "disk" : job.ramGbTotal > 0 ? "memory" : "cutover";
      job.note = "";
    }
    const rate = migrationRateMbps(world, job);
    job.rateMbps = Math.round(rate);
    let budget = gbPerTick(rate);
    if (budget <= 0) {
      job.note = "Keine \xDCbertragungskapazit\xE4t verf\xFCgbar.";
      continue;
    }
    if (job.phase === "disk") {
      const send = Math.min(budget, job.diskGbTotal - job.diskGbSent);
      job.diskGbSent += send;
      budget -= send;
      if (job.diskGbSent >= job.diskGbTotal - 1e-6) {
        job.phase = job.ramGbTotal > 0 ? "memory" : "cutover";
        job.ramGbOutstanding = job.ramGbTotal;
      }
    }
    let forced = false;
    const cpuLoad = job.subject.kind === "vps" ? clamp(world.vpsInstances[job.subject.id]?.cpuLoad ?? 0.3, 0.05, 1) : 0;
    const fullTick = gbPerTick(rate);
    while (job.phase === "memory" && budget > 0) {
      const send = Math.min(budget, job.ramGbOutstanding);
      job.ramGbOutstanding -= send;
      budget -= send;
      job.passes += 1;
      const hours = fullTick > 0 ? send / fullTick : 0;
      job.ramGbOutstanding += job.ramGbTotal * cpuLoad * MIGRATION.DIRTY_RATE_PER_HOUR * hours;
      if (job.ramGbOutstanding <= fullTick * MIGRATION.SWITCHOVER_SHARE) {
        job.phase = "cutover";
        break;
      }
      if (job.passes >= MIGRATION.MAX_PASSES) {
        job.phase = "cutover";
        forced = true;
        break;
      }
      if (send <= 0) break;
    }
    if (job.phase === "memory") {
      job.note = forced ? "" : `Speicherabgleich, Durchgang ${job.passes}.`;
      continue;
    }
    if (job.phase === "cutover") {
      completeMigration(world, job, { forced, ratePerTick: fullTick, result });
      touchedSources.add(job.sourceServerId);
    }
  }
  for (const serverId of touchedSources) {
    const server = world.servers[serverId];
    if (!server) continue;
    if (server.vpsIds.length === 0 && server.contractIds.length === 0) result.drainedServerIds.push(serverId);
  }
  return result;
}
function completeMigration(world, job, context) {
  const target = world.servers[job.targetServerId];
  const source = world.servers[job.sourceServerId];
  if (context.forced) {
    job.note = "Umschaltung erzwungen \u2013 der Speicherabgleich kam gegen die Schreiblast der Instanz nicht an.";
  }
  if (job.subject.kind === "vps") {
    const vps = world.vpsInstances[job.subject.id];
    if (source) source.vpsIds = source.vpsIds.filter((id) => id !== vps.id);
    vps.hostServerId = target.id;
    job.freezeSeconds = Math.round(job.ramGbOutstanding / Math.max(1e-3, context.ratePerTick) * 3600);
    applyCutoverCost(world, vps.contractId, job, context);
    context.result.messages.push({
      text: `${vps.name} l\xE4uft jetzt auf ${target.name}` + (job.freezeSeconds >= 60 ? ` \u2013 das Umschalten kostete ${Math.round(job.freezeSeconds / 60)} Minuten Ausfall, weil der Speicherabgleich nicht konvergierte.` : ` (Umschaltpause ${job.freezeSeconds} s).`),
      severity: job.freezeSeconds >= 60 ? "warning" : "info"
    });
  } else {
    const contract = world.contracts[job.subject.id];
    if (source) source.contractIds = source.contractIds.filter((id) => id !== contract.id);
    contract.serverId = target.id;
    job.freezeSeconds = contract.poolId ? 0 : cutoverSecondsForContract(job.diskGbTotal);
    applyCutoverCost(world, contract.id, job, context);
    const customer = world.customers[contract.customerId];
    const product = world.products[contract.productId];
    context.result.messages.push({
      text: `${product?.name ?? "Vertrag"} von ${customer?.company ?? customer?.name ?? "Kunde"} liegt jetzt auf ${target.name}` + (job.freezeSeconds > 0 ? ` (${Math.round(job.freezeSeconds / 60)} Minuten Umschaltpause).` : " \u2013 ohne Unterbrechung, der Pool trug weiter."),
      severity: "info"
    });
  }
  job.phase = "done";
}
function applyCutoverCost(world, contractId, job, context) {
  if (!contractId) return;
  const contract = world.contracts[contractId];
  if (!contract) return;
  if (job.freezeSeconds <= 0) return;
  contract.downtimeTicks += job.freezeSeconds / 3600;
  if (job.freezeSeconds >= 60) {
    const customer = world.customers[contract.customerId];
    if (customer) {
      customer.satisfaction = clamp(customer.satisfaction - MIGRATION.FORCED_SWITCHOVER_SATISFACTION, 0, 100);
    }
    context.result.disruptedContracts.push(contract.id);
  }
}
function planEvacuation(world, serverId, options = {}) {
  const performanceModifier = options.performanceModifier ?? 1;
  const empty = { serverId, steps: [], blocked: [], totalTicks: 0, disruptive: 0, complete: false };
  const server = world.servers[serverId];
  if (!server) return { ...empty, error: "Server nicht gefunden." };
  const candidates = values(world.servers).filter((s) => s.id !== server.id).filter((s) => s.role === server.role && s.os !== null && !s.retirement).filter((s) => s.state === "online" || s.state === "degraded").filter((s) => isServerConnected(world, s.id)).filter((s) => options.targetServerId ? s.id === options.targetServerId : true);
  if (candidates.length === 0) {
    return {
      ...empty,
      error: options.targetServerId ? "Der gew\xE4hlte Zielserver ist nicht aufnahmebereit." : `Es gibt keinen zweiten betriebsbereiten Server mit der Rolle \u201E${server.role}\u201C, der die Last aufnehmen k\xF6nnte.`
    };
  }
  const budget = /* @__PURE__ */ new Map();
  for (const candidate of candidates) budget.set(candidate.id, { ...serverCapacity(world, candidate.id, performanceModifier) });
  const steps = [];
  const blocked = [];
  const workloads = collectWorkloads(world, server);
  for (const workload of workloads) {
    let placed = false;
    const ranked = [...candidates].sort((a, b) => {
      const ca = budget.get(a.id);
      const cb = budget.get(b.id);
      return ca.ramGbUsed / Math.max(1, ca.ramGb) - cb.ramGbUsed / Math.max(1, cb.ramGb);
    });
    for (const candidate of ranked) {
      const capacity = budget.get(candidate.id);
      if (!accepts(world, candidate, capacity, workload)) continue;
      const estimate = workload.kind === "vps" ? estimateMigration(world, { kind: "vps", id: workload.id, targetServerId: candidate.id }) : estimateMigration(world, { kind: "contract", id: workload.id, targetServerId: candidate.id });
      if (!estimate.ok) continue;
      book(capacity, workload);
      steps.push({
        kind: workload.kind,
        id: workload.id,
        label: workload.label,
        targetServerId: candidate.id,
        targetName: candidate.name,
        diskGb: estimate.diskGb,
        ramGb: estimate.ramGb,
        ticks: estimate.ticks,
        freezeSeconds: estimate.freezeSeconds,
        seamless: estimate.seamless
      });
      placed = true;
      break;
    }
    if (!placed) {
      blocked.push({
        label: workload.label,
        reason: candidates.length === 1 ? `Auf ${candidates[0].name} ist kein Platz mehr.` : "Kein Knoten mit passender Rolle hat noch genug freie Kapazit\xE4t."
      });
    }
  }
  const totalTicks = steps.reduce((sum3, step) => sum3 + step.ticks, 0);
  return {
    serverId,
    steps,
    blocked,
    totalTicks: Math.ceil(totalTicks),
    disruptive: steps.filter((s) => !s.seamless && s.freezeSeconds >= 60).length,
    complete: blocked.length === 0 && steps.length > 0
  };
}
function evacuateServer(world, rng, input) {
  const performanceModifier = input.performanceModifier ?? 1;
  const plan = planEvacuation(world, input.serverId, { targetServerId: input.targetServerId, performanceModifier });
  if (plan.error) return { ok: false, message: plan.error, started: 0, failed: [] };
  if (plan.steps.length === 0) {
    return { ok: false, message: "Auf diesem Server liegt nichts, was sich verlegen lie\xDFe.", started: 0, failed: [] };
  }
  const failed = [];
  let started = 0;
  for (const step of plan.steps) {
    const result = step.kind === "vps" ? startVpsMigration(world, rng, { vpsId: step.id, targetServerId: step.targetServerId, reason: "evacuation" }, performanceModifier) : startContractMigration(
      world,
      rng,
      { contractId: step.id, targetServerId: step.targetServerId, reason: "evacuation" },
      performanceModifier
    );
    if (result.ok) started += 1;
    else failed.push({ label: step.label, reason: result.message });
  }
  const server = world.servers[input.serverId];
  if (input.retireAfterwards && plan.complete && failed.length === 0 && !server.retirement) {
    server.retirement = { harvestParts: true, requestedAtTick: world.meta.tick, reason: "consolidation" };
  }
  const parts = [
    `${started} ${started === 1 ? "Dienst wird" : "Dienste werden"} von ${server.name} verlegt`,
    `voraussichtlich ${plan.totalTicks} h`,
    plan.blocked.length > 0 ? `${plan.blocked.length} bleiben mangels Platz stehen` : null,
    failed.length > 0 ? `${failed.length} abgelehnt` : null,
    input.retireAfterwards && plan.complete && failed.length === 0 ? "danach wird der Server abgegeben" : null
  ].filter((part) => part !== null);
  return { ok: started > 0, message: `${parts.join(", ")}.`, started, failed };
}
function collectWorkloads(world, server) {
  const workloads = [];
  for (const vpsId of server.vpsIds) {
    const vps = world.vpsInstances[vpsId];
    if (!vps) continue;
    if (vps.hostServerId !== server.id) continue;
    if (migrationOf(world, "vps", vps.id)) continue;
    workloads.push({ kind: "vps", id: vps.id, label: vps.name, ramGb: vps.ramGb });
  }
  for (const contractId of server.contractIds) {
    const contract = world.contracts[contractId];
    if (!contract || contract.state === "cancelled") continue;
    if (contract.serverId !== server.id) continue;
    if (migrationOf(world, "contract", contract.id)) continue;
    const product = world.products[contract.productId];
    const customer = world.customers[contract.customerId];
    workloads.push({
      kind: "contract",
      id: contractId,
      label: `${product?.name ?? "Vertrag"} \u2013 ${customer?.company ?? customer?.name ?? "Kunde"}`,
      ramGb: product?.resources.ramGb ?? 0
    });
  }
  return workloads.sort((a, b) => b.ramGb - a.ramGb);
}
function accepts(world, target, capacity, workload) {
  if (workload.kind === "vps") {
    const vps = world.vpsInstances[workload.id];
    if (!vps || target.role !== "vps-host") return false;
    return capacity.ramGbUsed + vps.ramGb <= capacity.ramGb && capacity.ssdGbUsed + vps.diskGb <= capacity.ssdGb;
  }
  const contract = world.contracts[workload.id];
  const product = contract ? world.products[contract.productId] : void 0;
  if (!product) return false;
  const role = requiredRole(product);
  if (role !== null && target.role !== role) return false;
  return fits(capacity, product);
}
function book(capacity, workload) {
  capacity.ramGbUsed += workload.ramGb;
}
function formatRate(mbps) {
  return mbps >= 1e3 ? `${(mbps / 1e3).toFixed(1)} Gbit/s` : `${Math.round(mbps)} Mbit/s`;
}
function pruneMigrations(world) {
  let removed = 0;
  for (const job of values(world.migrations)) {
    if (RUNNING.includes(job.phase)) continue;
    if (world.meta.tick - job.startedAtTick < MIGRATION.KEEP_FINISHED_TICKS) continue;
    delete world.migrations[job.id];
    removed += 1;
  }
  return removed;
}

// src/domain/business/contracts.ts
function provisionContract(world, rng, input) {
  const product = world.products[input.productId];
  if (!product) return { ok: false, error: "Produkt nicht gefunden" };
  if (!product.active) return { ok: false, error: "Produkt wird nicht verkauft" };
  const role = requiredRole(product);
  let serverId = null;
  let vpsId = null;
  let rackId = null;
  if (role !== null) {
    const host = findHost(world, product, input.performanceModifier ?? 1);
    if (!host) {
      return { ok: false, error: hostFailureReason(world, product, input.performanceModifier ?? 1) };
    }
    serverId = host.id;
  } else if (product.kind === "colocation") {
    const rack = values(world.racks).find((r) => {
      const used = values(world.servers).filter((s) => s.rackId === r.id).reduce((sum3, s) => sum3 + s.heightUnits, 0);
      return r.units - used >= (product.name.includes("Rack") ? 42 : 1);
    });
    if (!rack) return { ok: false, error: "Keine freien Rackpl\xE4tze f\xFCr Colocation" };
    rackId = rack.id;
  }
  const v4 = allocateAddresses(world, "ipv4", product.resources.ipv4Count);
  if (!v4.ok) return { ok: false, error: v4.error };
  const v6 = allocateAddresses(world, "ipv6", product.resources.ipv6Count);
  if (!v6.ok) return { ok: false, error: v6.error };
  const contract = {
    id: asId(makeId(rng, "ctr")),
    customerId: input.customer.id,
    productId: product.id,
    state: "active",
    serverId,
    vpsId: null,
    rackId,
    poolId: null,
    monthlyPrice: product.monthlyPrice,
    startedAtTick: world.meta.tick,
    endsAtTick: null,
    ipv4: v4.addresses,
    ipv6: v6.addresses,
    uptimeTicks: 0,
    downtimeTicks: 0,
    trafficGb: 0
  };
  if (product.kind === "vps" && serverId) {
    const created = createVps(world, rng, {
      hostServerId: serverId,
      contractId: contract.id,
      name: `vps-${contract.id.slice(-6)}`,
      vcpu: product.resources.cpuCores,
      ramGb: product.resources.ramGb,
      diskGb: product.resources.ssdGb,
      os: "linux-debian"
    });
    if (!created.ok || !created.vps) return { ok: false, error: created.error };
    created.vps.ipv4 = contract.ipv4[0] ?? null;
    created.vps.ipv6 = contract.ipv6[0] ?? null;
    vpsId = created.vps.id;
    contract.vpsId = vpsId;
  } else if (serverId) {
    world.servers[serverId].contractIds.push(contract.id);
  }
  world.contracts[contract.id] = contract;
  if (!world.customers[input.customer.id]) world.customers[input.customer.id] = input.customer;
  world.customers[input.customer.id].contractIds.push(contract.id);
  return { ok: true, contract };
}
function contractAvailability(world, contract, reachability) {
  if (reachability < 0.5) return 0;
  if (contract.poolId) {
    return poolAvailabilityOf(world, contract.poolId);
  }
  if (contract.vpsId) {
    const vps = world.vpsInstances[contract.vpsId];
    if (!vps || vps.state !== "online" && vps.state !== "degraded") return 0;
    return isServerConnected(world, vps.hostServerId) ? 1 : 0;
  }
  if (contract.serverId) {
    const server = world.servers[contract.serverId];
    if (!server || server.state !== "online" && server.state !== "degraded") return 0;
    return isServerConnected(world, server.id) ? 1 : 0;
  }
  if (contract.rackId) {
    const rack = world.racks[contract.rackId];
    if (!rack) return 0;
    const dc = world.datacenters[rack.datacenterId];
    return dc && dc.utilityPower ? 1 : 0;
  }
  return 1;
}
function isContractUp(world, contract, reachability) {
  return contractAvailability(world, contract, reachability) > 0.5;
}
function updateContractMetrics(world, reachability, trafficFactor) {
  const impact = attackImpact(world);
  const attacked = impact.blackholes.length > 0 || impact.targets.size > 0 || impact.sites.size > 0;
  for (const contract of values(world.contracts)) {
    if (contract.state !== "active") continue;
    let availability = contractAvailability(world, contract, reachability);
    if (attacked && availability > 0) availability *= attackAvailabilityFactor(world, contract, impact);
    contract.uptimeTicks += availability;
    contract.downtimeTicks += 1 - availability;
    const product = world.products[contract.productId];
    if (product) {
      contract.trafficGb += product.resources.trafficMbps * trafficFactor * 3600 / 8 / 1024;
    }
  }
}
function contractUptimePercent(contract) {
  const total = contract.uptimeTicks + contract.downtimeTicks;
  if (total === 0) return 100;
  return contract.uptimeTicks / total * 100;
}
function migrationTargets(world, contractId, performanceModifier = 1) {
  const contract = world.contracts[contractId];
  const product = contract ? world.products[contract.productId] : void 0;
  if (!contract || !product) return [];
  const role = requiredRole(product);
  return values(world.servers).filter((s) => s.id !== contract.serverId).filter((s) => role === null || s.role === role).filter((s) => s.os !== null && (s.state === "online" || s.state === "degraded")).filter((s) => isServerConnected(world, s.id)).filter((s) => fits(serverCapacity(world, s.id, performanceModifier), product)).map((s) => s.id);
}
function terminateContract(world, contractId) {
  const contract = world.contracts[contractId];
  if (!contract) return false;
  contract.state = "cancelled";
  contract.endsAtTick = world.meta.tick;
  contract.ipv4 = [];
  contract.ipv6 = [];
  dropMigrationsFor(world, "contract", contractId);
  if (contract.vpsId) dropMigrationsFor(world, "vps", contract.vpsId);
  if (contract.vpsId) {
    const vps = world.vpsInstances[contract.vpsId];
    if (vps) {
      const host = world.servers[vps.hostServerId];
      if (host) host.vpsIds = host.vpsIds.filter((id) => id !== contract.vpsId);
      delete world.vpsInstances[contract.vpsId];
    }
  }
  if (contract.serverId) {
    const server = world.servers[contract.serverId];
    if (server) server.contractIds = server.contractIds.filter((id) => id !== contractId);
  }
  if (contract.poolId) {
    dropContractFromPools(world, contractId);
    contract.poolId = null;
  }
  return true;
}
function suspendContract(world, contractId) {
  const contract = world.contracts[contractId];
  if (!contract || contract.state !== "active") return false;
  contract.state = "suspended";
  if (contract.vpsId) {
    const vps = world.vpsInstances[contract.vpsId];
    if (vps) vps.state = "offline";
  }
  return true;
}
function resumeContract(world, contractId) {
  const contract = world.contracts[contractId];
  if (!contract || contract.state !== "suspended") return false;
  contract.state = "active";
  if (contract.vpsId) {
    const vps = world.vpsInstances[contract.vpsId];
    if (vps) vps.state = "booting";
  }
  return true;
}
function removeCustomer(world, customerId) {
  const customer = world.customers[customerId];
  if (!customer) return;
  for (const contractId of [...customer.contractIds]) {
    terminateContract(world, contractId);
  }
  for (const ticketId of [...customer.ticketIds]) {
    const ticket = world.tickets[ticketId];
    if (!ticket) continue;
    if (ticket.state === "open" || ticket.state === "in-progress") {
      ticket.state = "closed";
      ticket.resolvedAtTick = world.meta.tick;
      ticket.messages.push({ tick: world.meta.tick, author: "system", body: "Kunde hat gek\xFCndigt, Vorgang geschlossen." });
    }
  }
  delete world.customers[customerId];
}
function freeSlots(world, productId, performanceModifier = 1) {
  const product = world.products[productId];
  if (!product) return 0;
  const role = requiredRole(product);
  if (role === null) return Number.MAX_SAFE_INTEGER;
  const o = OVERCOMMIT[product.kind] ?? { cpu: 2, ram: 1, disk: 1 };
  let slots = 0;
  for (const server of values(world.servers)) {
    if (server.role !== role || server.os === null) continue;
    if (server.state !== "online" && server.state !== "booting") continue;
    const capacity = serverCapacity(world, server.id, performanceModifier);
    const byRam = product.resources.ramGb > 0 ? Math.floor((capacity.ramGb * o.ram - capacity.ramGbUsed) / product.resources.ramGb) : Infinity;
    const bySsd = product.resources.ssdGb > 0 ? Math.floor((capacity.ssdGb * o.disk - capacity.ssdGbUsed) / product.resources.ssdGb) : Infinity;
    const byHdd = product.resources.hddGb > 0 ? Math.floor((capacity.hddGb * o.disk - capacity.hddGbUsed) / product.resources.hddGb) : Infinity;
    const value = Math.min(byRam, bySsd, byHdd);
    if (Number.isFinite(value)) slots += Math.max(0, value);
  }
  return slots;
}

// src/domain/compute/upgrades.ts
var ok5 = (message, createdId) => ({ ok: true, message, createdId });
var fail5 = (message) => ({ ok: false, message });
function platformOf(server) {
  return findServerModel(server.model)?.platform ?? null;
}
function slotUsage(server) {
  const platform = platformOf(server);
  const totals = {
    cpu: platform?.cpuSockets ?? 0,
    ram: platform?.dimmSlots ?? 0,
    drive: platform?.driveBays ?? 0,
    nic: platform?.nicSlots ?? 0,
    gpu: platform?.gpuSlots ?? 0
  };
  const result = {};
  for (const kind of Object.keys(totals)) {
    const occupied = server.parts.filter((p) => p.kind === kind).sort((a, b) => a.slot - b.slot);
    result[kind] = {
      kind,
      total: totals[kind],
      used: occupied.length,
      free: Math.max(0, totals[kind] - occupied.length),
      occupied
    };
  }
  return result;
}
function nextFreeSlot(server, kind, alsoTaken = []) {
  const group = slotUsage(server)[kind];
  const taken = /* @__PURE__ */ new Set([...group.occupied.map((p) => p.slot), ...alsoTaken]);
  for (let slot = 0; slot < group.total; slot++) {
    if (!taken.has(slot)) return slot;
  }
  return -1;
}
function isCompatible(platform, part) {
  switch (part.kind) {
    case "ram":
      return part.standard === platform.dimmStandard ? { ok: true } : { ok: false, reason: `${part.name} ist ${part.standard.toUpperCase()}, die Plattform erwartet ${platform.dimmStandard.toUpperCase()}.` };
    case "cpu":
      return part.socket === platform.cpuSocket ? { ok: true } : { ok: false, reason: `${part.name} passt auf Sockel ${part.socket}, die Plattform hat ${platform.cpuSocket}.` };
    case "drive":
      return platform.driveFormFactors.includes(part.formFactor) ? { ok: true } : {
        ok: false,
        reason: `${part.name} braucht einen ${part.formFactor}-Einschub; das Geh\xE4use hat ${platform.driveFormFactors.join(", ")}.`
      };
    case "nic":
      return { ok: true };
    case "gpu":
      return (platform.gpuSlots ?? 0) > 0 ? { ok: true } : { ok: false, reason: `${part.name} braucht einen GPU-Steckplatz; dieses Geh\xE4use hat keinen.` };
  }
}
function recomputeServerSpecs(server) {
  const platform = platformOf(server);
  if (!platform) return;
  const bom = [];
  const counts = /* @__PURE__ */ new Map();
  for (const part of server.parts) counts.set(part.modelKey, (counts.get(part.modelKey) ?? 0) + 1);
  for (const [modelKey, quantity] of counts) bom.push({ modelKey, quantity });
  const specs = deriveServerSpecs(platform, bom);
  server.cpuModel = specs.cpuModel;
  server.cpuCores = specs.cpuCores;
  server.cpuGhz = specs.cpuGhz;
  server.cpuIpc = specs.cpuIpc;
  server.ramGb = specs.ramGb;
  server.ssdGb = specs.ssdGb;
  server.hddGb = specs.hddGb;
  server.gpuCount = specs.gpuCount;
  server.idleWatt = specs.idleWatt;
  server.maxWatt = specs.maxWatt;
}
function factoryParts(modelKey, tick2) {
  const model = findServerModel(modelKey);
  if (!model) return [];
  const parts = [];
  const nextSlot = { cpu: 0, ram: 0, drive: 0, nic: 0, gpu: 0 };
  for (const entry of model.factoryParts) {
    const part = findPart(entry.modelKey);
    if (!part) continue;
    for (let i = 0; i < entry.quantity; i++) {
      parts.push({ kind: part.kind, modelKey: part.key, slot: nextSlot[part.kind]++, installedAtTick: tick2, health: 1 });
    }
  }
  return parts;
}
function stockOf(world, datacenterId, modelKey) {
  return world.inventory[datacenterId]?.[modelKey] ?? 0;
}
function stockAt(world, datacenterId) {
  const shelf = world.inventory[datacenterId] ?? {};
  return Object.entries(shelf).filter(([, quantity]) => quantity > 0).map(([modelKey, quantity]) => ({ modelKey, quantity }));
}
function addStock(world, datacenterId, modelKey, delta) {
  const shelf = world.inventory[datacenterId] ??= {};
  shelf[modelKey] = Math.max(0, (shelf[modelKey] ?? 0) + delta);
  if (shelf[modelKey] === 0) delete shelf[modelKey];
}
function quoteOrder(world, modelKey, quantity, express) {
  const part = findPart(modelKey);
  if (!part) return { ok: false, error: "Bauteil unbekannt." };
  if (!Number.isInteger(quantity) || quantity < 1) return { ok: false, error: "St\xFCckzahl muss mindestens 1 sein." };
  const unitPrice = worldPrice(world, "hardware", part.price * (express ? 1 + UPGRADE.EXPRESS_SURCHARGE : 1));
  const leadTimeTicks = Math.max(1, Math.round(part.leadTimeTicks / (express ? UPGRADE.EXPRESS_SPEEDUP : 1)));
  return { ok: true, unitPrice, total: unitPrice * quantity, leadTimeTicks };
}
function orderParts(world, rng, input, pay) {
  const datacenter = world.datacenters[input.datacenterId];
  if (!datacenter) return fail5("Standort nicht gefunden.");
  const express = input.express ?? false;
  const quote = quoteOrder(world, input.modelKey, input.quantity, express);
  if (!quote.ok) return fail5(quote.error);
  const part = findPart(input.modelKey);
  if (part.requiresResearch && !world.research[part.requiresResearch]?.completed) {
    return fail5(`${part.name} ist noch nicht verf\xFCgbar \u2013 die zugeh\xF6rige Forschung fehlt.`);
  }
  if (!pay(quote.total, `${input.quantity}\xD7 ${part.name}${express ? " (Express)" : ""}`)) {
    return fail5(`Nicht gen\xFCgend Kapital (${quote.total} \u20AC ben\xF6tigt).`);
  }
  const id = asId(makeId(rng, "ord"));
  world.partOrders[id] = {
    id,
    modelKey: part.key,
    kind: part.kind,
    quantity: input.quantity,
    unitPrice: quote.unitPrice,
    express,
    orderedAtTick: world.meta.tick,
    arrivesAtTick: world.meta.tick + quote.leadTimeTicks,
    datacenterId: input.datacenterId,
    state: "ordered"
  };
  return ok5(
    `${input.quantity}\xD7 ${part.name} bestellt (${quote.total.toLocaleString("de-DE")} \u20AC). Lieferung nach ${datacenter.name} in ${quote.leadTimeTicks} h.`,
    id
  );
}
function cancelPartOrder(world, orderId, refund) {
  const order = world.partOrders[orderId];
  if (!order) return fail5("Bestellung nicht gefunden.");
  if (order.state !== "ordered") return fail5("Die Bestellung ist bereits ausgeliefert.");
  order.state = "cancelled";
  const total = order.unitPrice * order.quantity;
  refund(total, `Stornierung ${order.quantity}\xD7 ${findPart(order.modelKey)?.name ?? order.modelKey}`);
  return ok5(`Bestellung storniert, ${total.toLocaleString("de-DE")} \u20AC erstattet.`);
}
function advancePartOrders(world) {
  const messages = [];
  for (const order of values(world.partOrders)) {
    if (order.state !== "ordered") continue;
    if (world.meta.tick < order.arrivesAtTick) continue;
    order.state = "delivered";
    addStock(world, order.datacenterId, order.modelKey, order.quantity);
    const part = findPart(order.modelKey);
    messages.push(
      `Wareneingang ${world.datacenters[order.datacenterId]?.name ?? order.datacenterId}: ${order.quantity}\xD7 ${part?.name ?? order.modelKey}.`
    );
  }
  return messages;
}
function sellParts(world, input, credit) {
  const part = findPart(input.modelKey);
  if (!part) return fail5("Bauteil unbekannt.");
  const available = stockOf(world, input.datacenterId, input.modelKey);
  if (available < input.quantity) return fail5(`Nur ${available}\xD7 ${part.name} auf Lager.`);
  const total = worldPrice(world, "hardware", part.price * UPGRADE.PART_RESALE_SHARE) * input.quantity;
  addStock(world, input.datacenterId, input.modelKey, -input.quantity);
  credit(total, `Verkauf ${input.quantity}\xD7 ${part.name}`);
  return ok5(`${input.quantity}\xD7 ${part.name} verkauft (${total.toLocaleString("de-DE")} \u20AC).`);
}
function previewUpgrade(world, input) {
  const empty = { cpuCores: 0, ramGb: 0, ssdGb: 0, hddGb: 0, maxWatt: 0 };
  const reject = (error) => ({
    ok: false,
    error,
    ticks: 0,
    before: empty,
    after: empty,
    affectedContractIds: [],
    summary: ""
  });
  const server = world.servers[input.serverId];
  if (!server) return reject("Server nicht gefunden.");
  const platform = platformOf(server);
  if (!platform) return reject("Zu diesem Server ist kein Modell im Katalog hinterlegt.");
  if (server.maintenance) return reject("An diesem Server l\xE4uft bereits ein Wartungsfenster.");
  if (server.state === "failed") return reject("Der Server ist defekt \u2013 zuerst reparieren.");
  if (server.state === "booting") return reject("Der Server f\xE4hrt gerade hoch.");
  if (input.install.length === 0 && input.remove.length === 0) return reject("Es wurde keine Arbeit geplant.");
  const before = {
    cpuCores: server.cpuCores,
    ramGb: server.ramGb,
    ssdGb: server.ssdGb,
    hddGb: server.hddGb,
    maxWatt: server.maxWatt
  };
  const removedKeys = [];
  for (const entry of input.remove) {
    const part = server.parts.find((p) => p.kind === entry.kind && p.slot === entry.slot);
    if (!part) return reject(`${SLOT_LABEL[entry.kind]} ${entry.slot} ist nicht belegt.`);
    if (removedKeys.some((r) => r.kind === entry.kind && r.slot === entry.slot)) {
      return reject(`${SLOT_LABEL[entry.kind]} ${entry.slot} wurde doppelt zum Ausbau vorgemerkt.`);
    }
    removedKeys.push({ kind: entry.kind, slot: entry.slot, modelKey: part.modelKey });
  }
  const claimed = /* @__PURE__ */ new Map();
  const takenSlots = { cpu: [], ram: [], drive: [], nic: [], gpu: [] };
  const freedSlots = new Set(removedKeys.map((r) => `${r.kind}:${r.slot}`));
  const resolvedInstall = [];
  for (const entry of input.install) {
    const part = findPart(entry.modelKey);
    if (!part) return reject(`Bauteil "${entry.modelKey}" ist unbekannt.`);
    const compatible = isCompatible(platform, part);
    if (!compatible.ok) return reject(compatible.reason);
    const need = (claimed.get(part.key) ?? 0) + 1;
    if (stockOf(world, server.datacenterId, part.key) < need) {
      return reject(
        `Nicht gen\xFCgend ${part.name} im Lager ${world.datacenters[server.datacenterId]?.name ?? ""} (${stockOf(world, server.datacenterId, part.key)} vorhanden, ${need} ben\xF6tigt).`
      );
    }
    claimed.set(part.key, need);
    let slot = entry.slot ?? -1;
    if (slot >= 0) {
      const group = slotUsage(server)[part.kind];
      if (slot >= group.total) return reject(`${SLOT_LABEL[part.kind]} ${slot} gibt es an diesem Geh\xE4use nicht.`);
      const occupiedNow = group.occupied.some((p) => p.slot === slot) && !freedSlots.has(`${part.kind}:${slot}`);
      if (occupiedNow || takenSlots[part.kind].includes(slot)) {
        return reject(`${SLOT_LABEL[part.kind]} ${slot} ist belegt \u2013 erst r\xE4umen oder einen anderen w\xE4hlen.`);
      }
    } else {
      const freedFree = [...freedSlots].filter((k) => k.startsWith(`${part.kind}:`)).map((k) => Number(k.split(":")[1])).filter((s) => !takenSlots[part.kind].includes(s)).sort((a, b) => a - b);
      slot = freedFree.length > 0 ? freedFree[0] : nextFreeSlot(server, part.kind, takenSlots[part.kind]);
      if (slot < 0) {
        const group = slotUsage(server)[part.kind];
        return reject(
          `Alle ${group.total} ${SLOT_LABEL[part.kind]}${group.total === 1 ? "" : "e"} sind belegt. F\xFCr mehr ${PART_KIND_LABEL[part.kind]} m\xFCssen vorhandene Bauteile gegen gr\xF6\xDFere getauscht werden.`
        );
      }
    }
    takenSlots[part.kind].push(slot);
    resolvedInstall.push({ kind: part.kind, modelKey: part.key, slot });
  }
  const resultingParts = server.parts.filter((p) => !freedSlots.has(`${p.kind}:${p.slot}`)).concat(resolvedInstall.map((i) => ({ ...i, installedAtTick: world.meta.tick, health: 1 })));
  const counts = /* @__PURE__ */ new Map();
  for (const part of resultingParts) counts.set(part.modelKey, (counts.get(part.modelKey) ?? 0) + 1);
  const specs = deriveServerSpecs(platform, [...counts].map(([modelKey, quantity]) => ({ modelKey, quantity })));
  if (specs.cpuCores === 0) return reject("Ohne Prozessor l\xE4uft der Server nicht \u2013 mindestens einer muss bleiben.");
  if (specs.ramGb === 0) return reject("Ohne Arbeitsspeicher l\xE4uft der Server nicht.");
  const rawRamGb = [...counts].reduce((sum3, [key, quantity]) => {
    const part = findPart(key);
    return part?.kind === "ram" ? sum3 + part.capacityGb * quantity : sum3;
  }, 0);
  if (rawRamGb > platform.maxRamGb) {
    return reject(
      `Die Plattform adressiert h\xF6chstens ${platform.maxRamGb} GB; geplant sind ${rawRamGb} GB. Die \xFCberz\xE4hligen Module bringen nichts.`
    );
  }
  const rack = world.racks[server.rackId];
  if (rack) {
    const usedKw = rackPowerKw(world, rack.id);
    const deltaKw = (specs.maxWatt - server.maxWatt) / 1e3;
    if (usedKw + deltaKw > rack.powerBudgetKw) {
      return reject(
        `Das Rack ${rack.name} hat ${rack.powerBudgetKw} kW Budget; nach dem Ausbau w\xE4ren es ${(usedKw + deltaKw).toFixed(2)} kW. Zuerst Leistung schaffen oder Ger\xE4te umverteilen.`
      );
    }
  }
  const affectedContractIds = affectedContracts(world, server);
  if (affectedContractIds.length > 0 && !input.acceptDowntime) {
    const vpsCount = server.vpsIds.filter((id) => world.vpsInstances[id]).length;
    return reject(
      `Auf ${server.name} laufen ${affectedContractIds.length} aktive Vertr\xE4ge` + (vpsCount > 0 ? ` (${vpsCount} VPS)` : "") + ". Erst auf einen anderen Host migrieren \u2013 oder die Ausfallzeit ausdr\xFCcklich in Kauf nehmen."
    );
  }
  const ticks = maintenanceTicks(world, server, resolvedInstall, removedKeys);
  const summary = describeWork(resolvedInstall, removedKeys);
  return {
    ok: true,
    ticks,
    before,
    after: {
      cpuCores: specs.cpuCores,
      ramGb: specs.ramGb,
      ssdGb: specs.ssdGb,
      hddGb: specs.hddGb,
      maxWatt: specs.maxWatt
    },
    affectedContractIds,
    summary
  };
}
function affectedContracts(world, server) {
  const direct = server.contractIds.filter((id) => world.contracts[id]?.state === "active");
  const viaVps = server.vpsIds.map((id) => world.vpsInstances[id]?.contractId).filter((id) => !!id && world.contracts[id]?.state === "active");
  return [...direct, ...viaVps];
}
function maintenanceTicks(world, server, install, remove) {
  const work = [...install, ...remove].reduce((sum3, entry) => sum3 + (findPart(entry.modelKey)?.installTicks ?? 0.25), 0);
  const technicians = values(world.staff).filter(
    (s) => s.role === "technician" && (s.datacenterId === null || s.datacenterId === server.datacenterId)
  );
  if (technicians.length === 0) {
    return Math.max(1, Math.ceil((UPGRADE.MAINTENANCE_BASE_TICKS + work) * UPGRADE.NO_TECHNICIAN_FACTOR));
  }
  const skill = Math.max(...technicians.map((t) => t.skill));
  return Math.max(1, Math.ceil((UPGRADE.MAINTENANCE_BASE_TICKS + work) / (0.6 + skill / 12)));
}
function describeWork(install, remove) {
  const label = (entries) => {
    const counts = /* @__PURE__ */ new Map();
    for (const entry of entries) counts.set(entry.modelKey, (counts.get(entry.modelKey) ?? 0) + 1);
    return [...counts].map(([key, n]) => `${n}\xD7 ${findPart(key)?.name ?? key}`).join(", ");
  };
  const parts = [];
  if (remove.length > 0) parts.push(`Ausbau: ${label(remove)}`);
  if (install.length > 0) parts.push(`Einbau: ${label(install)}`);
  return parts.join(" \xB7 ");
}
function planUpgrade(world, input) {
  const preview = previewUpgrade(world, input);
  if (!preview.ok) return fail5(preview.error);
  const server = world.servers[input.serverId];
  const platform = platformOf(server);
  const removeEntries = input.remove.map((entry) => ({ kind: entry.kind, slot: entry.slot }));
  const freedSlots = new Set(removeEntries.map((r) => `${r.kind}:${r.slot}`));
  const takenSlots = { cpu: [], ram: [], drive: [], nic: [], gpu: [] };
  const installEntries = [];
  for (const entry of input.install) {
    const part = findPart(entry.modelKey);
    let slot = entry.slot ?? -1;
    if (slot < 0) {
      const freedFree = [...freedSlots].filter((k) => k.startsWith(`${part.kind}:`)).map((k) => Number(k.split(":")[1])).filter((s) => !takenSlots[part.kind].includes(s)).sort((a, b) => a - b);
      slot = freedFree.length > 0 ? freedFree[0] : nextFreeSlot(server, part.kind, takenSlots[part.kind]);
    }
    takenSlots[part.kind].push(slot);
    installEntries.push({ kind: part.kind, modelKey: part.key, slot });
    addStock(world, server.datacenterId, part.key, -1);
  }
  const job = {
    install: installEntries,
    remove: removeEntries,
    startedAtTick: world.meta.tick,
    totalTicks: preview.ticks,
    summary: preview.summary,
    affectedContractIds: preview.affectedContractIds
  };
  server.maintenance = job;
  server.state = "maintenance";
  server.pendingTicks = preview.ticks;
  for (const vpsId of server.vpsIds) {
    const vps = world.vpsInstances[vpsId];
    if (vps) vps.state = "offline";
  }
  const gain = [];
  if (preview.after.cpuCores !== preview.before.cpuCores) gain.push(`${preview.before.cpuCores} \u2192 ${preview.after.cpuCores} Kerne`);
  if (preview.after.ramGb !== preview.before.ramGb) gain.push(`${preview.before.ramGb} \u2192 ${preview.after.ramGb} GB RAM`);
  if (preview.after.ssdGb !== preview.before.ssdGb) gain.push(`${preview.before.ssdGb} \u2192 ${preview.after.ssdGb} GB SSD`);
  if (preview.after.hddGb !== preview.before.hddGb) gain.push(`${preview.before.hddGb} \u2192 ${preview.after.hddGb} GB HDD`);
  void platform;
  return ok5(
    `Wartungsfenster an ${server.name} gestartet (${preview.ticks} h). ${preview.summary}.` + (gain.length > 0 ? ` Danach: ${gain.join(", ")}.` : "") + (preview.affectedContractIds.length > 0 ? ` ${preview.affectedContractIds.length} Vertr\xE4ge sind w\xE4hrenddessen offline.` : "")
  );
}
function cancelUpgrade(world, serverId) {
  const server = world.servers[serverId];
  if (!server) return fail5("Server nicht gefunden.");
  if (!server.maintenance) return fail5("An diesem Server l\xE4uft kein Wartungsfenster.");
  for (const entry of server.maintenance.install) addStock(world, server.datacenterId, entry.modelKey, 1);
  server.maintenance = null;
  server.state = "booting";
  server.pendingTicks = SIM.BOOT_TICKS;
  return ok5(`Wartungsfenster an ${server.name} abgebrochen, Bauteile zur\xFCck ins Lager.`);
}
function advanceMaintenance(world) {
  const messages = [];
  const satisfactionHits = [];
  for (const server of values(world.servers)) {
    const job = server.maintenance;
    if (!job) continue;
    server.pendingTicks -= 1;
    if (server.pendingTicks > 0) continue;
    for (const entry of job.remove) {
      const index = server.parts.findIndex((p) => p.kind === entry.kind && p.slot === entry.slot);
      if (index < 0) continue;
      addStock(world, server.datacenterId, server.parts[index].modelKey, 1);
      server.parts.splice(index, 1);
    }
    for (const entry of job.install) {
      server.parts.push({
        kind: entry.kind,
        modelKey: entry.modelKey,
        slot: entry.slot,
        installedAtTick: world.meta.tick,
        health: 1
      });
    }
    recomputeServerSpecs(server);
    server.maintenance = null;
    server.state = "booting";
    server.pendingTicks = SIM.BOOT_TICKS;
    satisfactionHits.push(...job.affectedContractIds);
    messages.push(
      `${server.name}: Wartungsfenster abgeschlossen. ${job.summary}. Jetzt ${server.cpuCores} Kerne, ${server.ramGb} GB RAM, ${server.ssdGb + server.hddGb} GB Speicher.`
    );
  }
  return { messages, satisfactionHits };
}
function resizeVps(world, input, capacityOf) {
  const vps = world.vpsInstances[input.vpsId];
  if (!vps) return fail5("VPS nicht gefunden.");
  if (migrationOf(world, "vps", vps.id)) return fail5("W\xE4hrend eines Umzugs l\xE4sst sich die Gr\xF6\xDFe nicht \xE4ndern.");
  if (input.vcpu < 1 || input.ramGb < 1 || input.diskGb < 1) return fail5("Ung\xFCltige Ausstattung.");
  if (input.diskGb < vps.diskGb) return fail5("Die Platte l\xE4sst sich nicht verkleinern \u2013 die Daten liegen darauf.");
  const host = world.servers[vps.hostServerId];
  if (!host) return fail5("Host nicht gefunden.");
  const capacity = capacityOf(host.id);
  const deltaRam = input.ramGb - vps.ramGb;
  const deltaDisk = input.diskGb - vps.diskGb;
  if (capacity.ramGbUsed + deltaRam > capacity.ramGb) {
    return fail5(`${host.name} hat nicht genug freien Arbeitsspeicher. Erst aufr\xFCsten oder die Instanz migrieren.`);
  }
  if (capacity.ssdGbUsed + deltaDisk > capacity.ssdGb) {
    return fail5(`${host.name} hat nicht genug freien Speicher. Erst aufr\xFCsten oder die Instanz migrieren.`);
  }
  const grew = input.vcpu > vps.vcpu || deltaRam > 0;
  vps.vcpu = input.vcpu;
  vps.ramGb = input.ramGb;
  vps.diskGb = input.diskGb;
  if (grew) {
    vps.state = "booting";
  }
  return ok5(
    `${vps.name} auf ${input.vcpu} vCPU, ${input.ramGb} GB RAM, ${input.diskGb} GB Speicher ge\xE4ndert` + (grew ? " \u2013 die Instanz startet daf\xFCr neu." : ".")
  );
}
function residualValue(world, device) {
  const age = world.meta.tick - device.purchasedAtTick;
  const residual = Math.max(0.1, 1 - age / (SIM.TICKS_PER_YEAR * 6)) * device.health;
  return Math.round(device.purchasePrice * residual * 0.6);
}
function quoteDecommission(world, kind, id) {
  const reject = (error) => ({
    ok: false,
    error,
    proceeds: 0,
    partsProceeds: 0,
    harvestable: [],
    sideEffects: []
  });
  const device = deviceOf(world, kind, id);
  if (!device) return reject("Ger\xE4t nicht gefunden.");
  if (device.state === "maintenance") return reject("An diesem Ger\xE4t l\xE4uft gerade eine Wartung.");
  const sideEffects = [];
  if (kind === "server") {
    const server = world.servers[id];
    const active = affectedContracts(world, server);
    if (active.length > 0) {
      const vpsCount = server.vpsIds.filter((vid) => world.vpsInstances[vid]).length;
      return reject(
        `Auf ${server.name} liegen noch ${active.length} aktive Vertr\xE4ge` + (vpsCount > 0 ? ` (${vpsCount} VPS)` : "") + ". Erst migrieren oder k\xFCndigen, dann l\xE4sst sich der Server abgeben."
      );
    }
    if (activeTransfers(world, server.id).length > 0) {
      return reject("Auf diesen Server l\xE4uft gerade eine \xDCbertragung.");
    }
    if (server.uplink) sideEffects.push(`Switch-Port ${server.uplink.portIndex} wird frei.`);
  }
  if (kind === "router") {
    const router = world.routers[id];
    const attached = values(world.links).filter((l) => l.a.routerId === id || l.b.routerId === id);
    if (attached.length > 0) {
      return reject(
        `${router?.name ?? "Der Router"} tr\xE4gt noch ${attached.length} Verbindungen (${attached.map((l) => l.name).slice(0, 3).join(", ")}). Diese zuerst auf einen anderen Router umstecken \u2013 oder k\xFCndigen, wenn sie ganz weg sollen.`
      );
    }
  }
  if (kind === "switch") {
    const attached = values(world.servers).filter((s) => s.uplink?.switchId === id);
    if (attached.length > 0) {
      return reject(
        `${attached.length} Server h\xE4ngen an diesem Switch (${attached.map((s) => s.name).slice(0, 3).join(", ")}). Erst umstecken.`
      );
    }
  }
  if (kind === "loadbalancer") {
    const balancer = world.loadBalancers[id];
    const carrying = balancer?.pools.reduce((sum3, pool) => sum3 + pool.contractIds.length, 0) ?? 0;
    if (carrying > 0) {
      return reject(
        `\xDCber ${balancer?.name ?? "dieses Ger\xE4t"} laufen noch ${carrying} Vertr\xE4ge. Sie m\xFCssten zuerst auf einen anderen Balancer oder zur\xFCck auf einen Server \u2013 sonst w\xE4ren sie nirgends erreichbar.`
      );
    }
    if (balancer?.peerId) sideEffects.push("Die Kopplung zum Partnerger\xE4t wird aufgehoben; der bleibt allein zur\xFCck.");
  }
  if (kind === "ups") {
    const ups = world.upsUnits[id];
    sideEffects.push(
      ups?.rackId ? "Die Notstromversorgung des Racks sinkt entsprechend." : "Die Notstromversorgung des Standorts sinkt entsprechend."
    );
  }
  const proceeds = residualValue(world, device);
  let partsProceeds = 0;
  const harvestable = [];
  if (kind === "server") {
    const server = world.servers[id];
    const counts = /* @__PURE__ */ new Map();
    for (const part of server.parts) counts.set(part.modelKey, (counts.get(part.modelKey) ?? 0) + 1);
    for (const [modelKey, quantity] of counts) {
      harvestable.push({ modelKey, quantity });
      const model = findPart(modelKey);
      if (model) partsProceeds += Math.round(model.price * UPGRADE.PART_RESALE_SHARE) * quantity;
    }
  }
  return { ok: true, proceeds, partsProceeds, harvestable, sideEffects };
}
function decommissionDevice(world, kind, id, options, credit) {
  const quote = quoteDecommission(world, kind, id);
  if (!quote.ok) return fail5(quote.error);
  const device = deviceOf(world, kind, id);
  const name = device.name;
  const harvest = options.harvestParts ?? false;
  if (kind === "server") {
    const server = world.servers[id];
    if (server.uplink) {
      const sw = world.switches[server.uplink.switchId];
      const port = sw?.ports?.[server.uplink.portIndex];
      if (port) {
        port.description = "";
        port.connectedDevice = null;
      }
    }
    server.managementIp = null;
    if (harvest) {
      for (const entry of quote.harvestable) addStock(world, server.datacenterId, entry.modelKey, entry.quantity);
    }
    dropServerFromPools(world, server.id);
    delete world.servers[server.id];
  } else if (kind === "switch") {
    delete world.switches[id];
  } else if (kind === "router") {
    delete world.routers[id];
  } else if (kind === "firewall") {
    delete world.firewalls[id];
  } else if (kind === "loadbalancer") {
    for (const sw of values(world.switches)) {
      for (const port of sw.ports) {
        if (port.connectedDevice?.kind === "loadbalancer" && port.connectedDevice.id === id) {
          port.connectedDevice = null;
          port.description = "";
        }
      }
    }
    const peerId = world.loadBalancers[id]?.peerId;
    if (peerId && world.loadBalancers[peerId]) {
      world.loadBalancers[peerId].peerId = null;
      world.loadBalancers[peerId].haRole = "active";
    }
    delete world.loadBalancers[id];
  } else if (kind === "ups") {
    const ups = world.upsUnits[id];
    if (ups?.rackId) {
      const rack = world.racks[ups.rackId];
      if (rack) rack.upsIds = rack.upsIds.filter((upsId) => upsId !== id);
    }
    delete world.upsUnits[id];
  }
  const total = quote.proceeds + (harvest ? 0 : quote.partsProceeds);
  credit(total, `Verkauf ${name}`);
  const partsNote = kind === "server" && quote.harvestable.length > 0 ? harvest ? ` Die Bauteile liegen jetzt im Ersatzteillager (${quote.harvestable.reduce((s, h) => s + h.quantity, 0)} St\xFCck).` : ` Die verbauten Bauteile gingen mit (${quote.partsProceeds.toLocaleString("de-DE")} \u20AC davon).` : "";
  return ok5(`${name} verkauft (${total.toLocaleString("de-DE")} \u20AC Erl\xF6s).${partsNote}`);
}
function deviceOf(world, kind, id) {
  const stores = {
    server: world.servers,
    router: world.routers,
    switch: world.switches,
    firewall: world.firewalls,
    loadbalancer: world.loadBalancers,
    ups: world.upsUnits
  };
  return stores[kind]?.[id];
}
function replacementCandidates(world) {
  const candidates = [];
  for (const server of values(world.servers)) {
    const model = findServerModel(server.model);
    if (!model) continue;
    const age = world.meta.tick - server.purchasedAtTick;
    const lifeShare = age / model.lifespanTicks;
    const proceeds = residualValue(world, server);
    if (server.health < 0.35) {
      candidates.push({ serverId: server.id, name: server.name, reason: `Zustand bei ${(server.health * 100).toFixed(0)} %`, proceeds });
    } else if (lifeShare > 0.8) {
      candidates.push({
        serverId: server.id,
        name: server.name,
        reason: `${(lifeShare * 100).toFixed(0)} % der Lebensdauer erreicht`,
        proceeds
      });
    }
  }
  return candidates.sort((a, b) => b.proceeds - a.proceeds);
}
function agePartsAndReport(world, rng) {
  const warnings = [];
  for (const server of values(world.servers)) {
    if (server.parts.length === 0) continue;
    if (server.state === "offline") continue;
    let weakest = 1;
    for (const part of server.parts) {
      const model = findPart(part.modelKey);
      const lifespan = model?.lifespanTicks ?? SIM.TICKS_PER_YEAR * 6;
      const heat = server.temperatureC > SIM.TEMP_WARN_C ? 1 + (server.temperatureC - SIM.TEMP_WARN_C) / 25 : 1;
      part.health = clamp(part.health - 1 / lifespan * heat, 0, 1);
      weakest = Math.min(weakest, part.health);
      if (part.health < 0.12 && rng.chance(4e-3)) {
        warnings.push({
          serverId: server.id,
          text: `${server.name}: ${model?.name ?? part.modelKey} in ${SLOT_LABEL[part.kind]} ${part.slot} meldet Fehler und sollte getauscht werden.`
        });
      }
    }
    server.health = Math.min(server.health, weakest);
  }
  return { warnings };
}
function describeParts(server) {
  return server.parts.slice().sort((a, b) => a.kind.localeCompare(b.kind) || a.slot - b.slot).map((part) => ({ part, model: findPart(part.modelKey) }));
}
function partsValue(server) {
  return server.parts.reduce((sum3, part) => sum3 + (findPart(part.modelKey)?.price ?? 0), 0);
}

// src/domain/economy/finance.ts
function post(world, entry) {
  if (Math.abs(entry.amount) < 5e-3) return;
  const record = { ...entry, tick: world.meta.tick, amount: money(entry.amount) };
  world.ledger.push(record);
  if (world.ledger.length > SIM.MAX_LEDGER_ENTRIES) {
    world.ledger.splice(0, world.ledger.length - SIM.MAX_LEDGER_ENTRIES);
  }
  world.company.cash = money(world.company.cash + record.amount);
  if (record.amount > 0) world.company.lifetimeRevenue = money(world.company.lifetimeRevenue + record.amount);
  else world.company.lifetimeCost = money(world.company.lifetimeCost - record.amount);
}
function chargeOperatingCosts(world, powerCostPerTick, coolingCostPerTick, modifiers) {
  const settings = DIFFICULTY[world.meta.difficulty];
  const perTick = (monthly) => monthly / SIM.TICKS_PER_MONTH * settings.costMultiplier;
  const breakdown = {
    power: 0,
    cooling: 0,
    rack: 0,
    hardware: 0,
    staff: 0,
    transit: 0,
    ip: 0,
    fiber: 0,
    ixp: 0,
    research: 0,
    total: 0
  };
  breakdown.power = powerCostPerTick * settings.costMultiplier;
  breakdown.cooling = coolingCostPerTick * settings.costMultiplier;
  for (const rack of values(world.racks)) breakdown.rack += perTick(rack.monthlyCost);
  for (const dc of values(world.datacenters)) {
    breakdown.rack += perTick(worldRate(world, "miete", dc.monthlyRent) * regionFactorsOfCity(world, dc.city).rent);
  }
  const maintenance = (model) => findModel(model)?.maintenancePerMonth ?? 0;
  for (const s of values(world.servers)) breakdown.hardware += perTick(maintenance(s.model));
  for (const r of values(world.routers)) breakdown.hardware += perTick(maintenance(r.model));
  for (const s of values(world.switches)) breakdown.hardware += perTick(maintenance(s.model));
  for (const f of values(world.firewalls)) breakdown.hardware += perTick(maintenance(f.model));
  for (const l of values(world.loadBalancers)) breakdown.hardware += perTick(maintenance(l.model));
  for (const u of values(world.upsUnits)) breakdown.hardware += perTick(maintenance(u.model));
  for (const staff of values(world.staff)) breakdown.staff += perTick(staff.monthlySalary) * modifiers.staff;
  for (const link of values(world.links)) {
    if (link.buildTicksRemaining > 0) continue;
    if (link.kind === "transit") {
      const billable = Math.max(link.committedMbps, billable95th(link));
      breakdown.transit += perTick(worldRate(world, "transit", link.monthlyCost + Math.max(0, billable - link.committedMbps) * link.pricePerMbps));
    } else if (link.kind === "peering-ix") {
      breakdown.ixp += perTick(link.monthlyCost);
    } else {
      breakdown.fiber += perTick(link.monthlyCost);
    }
  }
  for (const ixp of values(world.ixps)) {
    if (!ixp.joined) continue;
    breakdown.ixp += perTick(ixp.portCapacityMbps / 1e3 * ixp.portFeePerGbps);
  }
  breakdown.ixp += perTick(paidPeeringMonthlyCost(world));
  for (const [measure, costs] of Object.entries(HYGIENE_COSTS)) {
    if (world.company.hygiene[measure]) breakdown.ixp += perTick(costs.monthly);
  }
  for (const dc of values(world.datacenters)) {
    breakdown.power += perTick(dc.powerFeeds?.monthlyCost ?? 0);
  }
  for (const prefix of values(world.prefixes)) breakdown.ip += perTick(prefix.monthlyCost);
  if (world.company.rirMember) breakdown.ip += perTick(ECONOMY.RIR_MEMBERSHIP_YEARLY / 12);
  if (world.activeResearchId) {
    const node = world.research[world.activeResearchId];
    if (node && !node.completed && node.durationTicks > 0) {
      breakdown.research += node.cost / node.durationTicks;
    }
  }
  breakdown.total = breakdown.power + breakdown.cooling + breakdown.rack + breakdown.hardware + breakdown.staff + breakdown.transit + breakdown.ip + breakdown.fiber + breakdown.ixp + breakdown.research;
  const postIf = (amount, category, description) => {
    if (amount > 1e-4) post(world, { category, amount: -amount, description });
  };
  postIf(breakdown.power, "cost-power", "Stromkosten");
  postIf(breakdown.cooling, "cost-cooling", "K\xFChlung");
  postIf(breakdown.rack, "cost-rack", "Racks und Standortmiete");
  postIf(breakdown.hardware, "cost-hardware", "Hardwarewartung");
  postIf(breakdown.staff, "cost-staff", "Personalkosten");
  postIf(breakdown.transit, "cost-transit", "IP-Transit");
  postIf(breakdown.ip, "cost-ip", "IP-Adressen und RIR");
  postIf(breakdown.fiber, "cost-fiber", "Glasfaser und Standleitungen");
  postIf(breakdown.ixp, "cost-ixp", "IXP-Ports");
  postIf(breakdown.research, "cost-research", "Forschung und Entwicklung");
  return breakdown;
}
function chargeInterest(world, loanRateMultiplier = 1) {
  if (world.company.debt <= 0) return;
  const interest = world.company.debt * ECONOMY.DEBT_INTEREST_RATE * loanRateMultiplier / SIM.TICKS_PER_YEAR;
  post(world, { category: "cost-other", amount: -interest, description: "Kreditzinsen" });
}
function isBillingTick(tick2) {
  return tick2 > 0 && tick2 % SIM.TICKS_PER_MONTH === 0;
}
function issueMonthlyInvoices(world, rng) {
  const created = [];
  for (const customer of values(world.customers)) {
    const contracts = customer.contractIds.map((id) => world.contracts[id]).filter((c) => !!c && (c.state === "active" || c.state === "suspended"));
    if (contracts.length === 0) continue;
    const items = [];
    for (const contract of contracts) {
      const product = world.products[contract.productId];
      if (!product) continue;
      items.push({
        description: `${product.name} (${contract.id.slice(-6)})`,
        quantity: 1,
        unitPrice: contract.monthlyPrice,
        taxPercent: ECONOMY.TAX_PERCENT,
        contractId: contract.id
      });
      const included = product.resources.includedTrafficGb;
      const overage = Math.max(0, contract.trafficGb - included);
      if (overage > 1) {
        items.push({
          description: `Zus\xE4tzlicher Traffic (${Math.round(overage)} GB)`,
          quantity: Math.round(overage),
          unitPrice: ECONOMY.OVERAGE_PER_GB,
          taxPercent: ECONOMY.TAX_PERCENT,
          contractId: contract.id
        });
      }
      const uptime = contractUptimePercent(contract);
      if (uptime < product.slaUptimePercent) {
        const shortfall = product.slaUptimePercent - uptime;
        const credit = -Math.min(
          contract.monthlyPrice * ECONOMY.SLA_MAX_CREDIT_SHARE,
          contract.monthlyPrice * shortfall * ECONOMY.SLA_PENALTY_PER_POINT
        );
        items.push({
          description: `SLA-Gutschrift (${uptime.toFixed(2)} % statt ${product.slaUptimePercent} %)`,
          quantity: 1,
          unitPrice: money(credit),
          taxPercent: ECONOMY.TAX_PERCENT,
          contractId: contract.id
        });
        customer.satisfaction = clamp(customer.satisfaction - shortfall * 2.5, 0, 100);
      }
      contract.trafficGb = 0;
      contract.uptimeTicks = 0;
      contract.downtimeTicks = 0;
    }
    if (items.length === 0) continue;
    const net = money(items.reduce((s, i) => s + i.quantity * i.unitPrice, 0));
    const tax = money(items.reduce((s, i) => s + i.quantity * i.unitPrice * (i.taxPercent / 100), 0));
    const invoice = {
      id: asId(makeId(rng, "inv")),
      number: `RE-${String(Math.floor(world.meta.tick / SIM.TICKS_PER_MONTH)).padStart(4, "0")}-${makeId(rng, "").slice(1, 6).toUpperCase()}`,
      customerId: customer.id,
      state: "open",
      items,
      issuedAtTick: world.meta.tick,
      dueAtTick: world.meta.tick + SIM.INVOICE_DUE_TICKS,
      paidAtTick: null,
      net,
      tax,
      gross: money(net + tax)
    };
    world.invoices[invoice.id] = invoice;
    customer.invoiceIds.push(invoice.id);
    created.push(invoice);
  }
  return created;
}
function processPayments(world, rng) {
  let paid = 0;
  const overdue = [];
  for (const invoice of values(world.invoices)) {
    if (invoice.state !== "open" && invoice.state !== "overdue") continue;
    const customer = world.customers[invoice.customerId];
    if (!customer) continue;
    const chancePerTick = customer.reliability / (SIM.INVOICE_DUE_TICKS * 0.6);
    if (rng.chance(chancePerTick)) {
      invoice.state = "paid";
      invoice.paidAtTick = world.meta.tick;
      post(world, {
        category: revenueCategoryOf(world, invoice),
        amount: invoice.gross,
        description: `Zahlungseingang ${invoice.number}`,
        ref: invoice.id
      });
      if (invoice.tax > 0) {
        post(world, {
          category: "cost-tax",
          amount: -invoice.tax,
          description: `Umsatzsteuer ans Finanzamt (${invoice.number})`,
          ref: invoice.id
        });
      }
      paid += invoice.gross;
      continue;
    }
    if (world.meta.tick > invoice.dueAtTick && invoice.state === "open") {
      invoice.state = "overdue";
      customer.balance = money(customer.balance - invoice.gross);
      overdue.push(invoice.id);
    }
    if (invoice.state === "overdue" && world.meta.tick > invoice.dueAtTick + SIM.TICKS_PER_MONTH) {
      for (const contractId of customer.contractIds) {
        const contract = world.contracts[contractId];
        if (contract?.state === "active") contract.state = "suspended";
      }
    }
  }
  return { paid, overdue };
}
function revenueCategoryOf(world, invoice) {
  const first = invoice.items.find((i) => i.contractId);
  if (!first?.contractId) return "revenue-other";
  const contract = world.contracts[first.contractId];
  const product = contract ? world.products[contract.productId] : void 0;
  switch (product?.kind) {
    case "domain":
      return "revenue-domain";
    case "colocation":
      return "revenue-colocation";
    case "transit-sale":
      return "revenue-transit";
    default:
      return "revenue-hosting";
  }
}
function summarizeFinance(world) {
  const from = Math.max(0, world.meta.tick - SIM.TICKS_PER_MONTH);
  const window = world.ledger.filter((e) => e.tick >= from);
  const elapsed = Math.max(1, world.meta.tick - from);
  const scale = SIM.TICKS_PER_MONTH / elapsed;
  const revenueBreakdown = {};
  const costBreakdown = {};
  let revenue = 0;
  let cost = 0;
  for (const entry of window) {
    if (entry.amount >= 0) {
      revenue += entry.amount;
      revenueBreakdown[entry.category] = money((revenueBreakdown[entry.category] ?? 0) + entry.amount * scale);
    } else {
      cost += -entry.amount;
      costBreakdown[entry.category] = money((costBreakdown[entry.category] ?? 0) + -entry.amount * scale);
    }
  }
  const monthlyRevenue = money(revenue * scale);
  const monthlyCost = money(cost * scale);
  const monthlyProfit = money(monthlyRevenue - monthlyCost);
  const runwayMonths = monthlyProfit >= 0 ? Infinity : Math.max(0, world.company.cash / -monthlyProfit);
  return { monthlyRevenue, monthlyCost, monthlyProfit, revenueBreakdown, costBreakdown, runwayMonths };
}
function canAfford(world, amount) {
  return world.company.cash + (world.company.creditLimit - world.company.debt) >= amount;
}
function spend(world, amount, category, description) {
  if (!canAfford(world, amount)) return false;
  if (world.company.cash < amount) {
    const needed = amount - world.company.cash;
    world.company.debt = money(world.company.debt + needed);
    world.company.cash = money(world.company.cash + needed);
  }
  post(world, { category, amount: -amount, description });
  return true;
}
function rackSetupCost(modelKey) {
  return findRackModel(modelKey)?.setupCost ?? 0;
}
function activeBillableLinks(world) {
  return values(world.links).filter((l) => isLinkUsable(l) && l.monthlyCost > 0).length;
}
function repayDebt(world, amount) {
  const repay = Math.min(amount, world.company.debt, world.company.cash);
  if (repay <= 0) return false;
  world.company.debt = money(world.company.debt - repay);
  post(world, { category: "cost-other", amount: -repay, description: "Kredittilgung" });
  return true;
}
function companyValue(world) {
  let assets = 0;
  for (const server of values(world.servers)) assets += residualValue(world, server);
  for (const router of values(world.routers)) assets += residualValue(world, router);
  for (const sw of values(world.switches)) assets += residualValue(world, sw);
  for (const firewall of values(world.firewalls)) assets += residualValue(world, firewall);
  for (const balancer of values(world.loadBalancers)) assets += residualValue(world, balancer);
  for (const ups of values(world.upsUnits)) assets += residualValue(world, ups);
  let addresses = 0;
  for (const prefix of values(world.prefixes)) {
    if (prefix.source !== "rir" && prefix.source !== "purchased") continue;
    if (prefix.parentId) continue;
    addresses += transferMarketValue(world, prefix.family, prefix.length);
  }
  const quality = (0.4 + world.derived.customers.avgSatisfaction / 100 * 0.6) * (0.6 + world.company.reputation / 100 * 0.4);
  const customerBase = Math.round(world.derived.finance.monthlyRevenue * 12 * quality);
  const total = assets + addresses + customerBase + world.company.cash - world.company.debt;
  return {
    assets: Math.round(assets),
    addresses: Math.round(addresses),
    customerBase,
    cash: Math.round(world.company.cash),
    debt: Math.round(world.company.debt),
    total: Math.round(total)
  };
}

// src/domain/network/bgp/decision.ts
var ORIGIN_RANK = { igp: 0, egp: 1, incomplete: 2 };
function routerIdValue(id) {
  const parts = id.split(".").map(Number);
  if (parts.length !== 4 || parts.some((p) => !Number.isFinite(p))) return Number.MAX_SAFE_INTEGER;
  return (parts[0] << 24 >>> 0) + (parts[1] << 16) + (parts[2] << 8) + parts[3];
}
function isExternal(route) {
  return route.relation !== "ibgp" && route.relation !== "local";
}
function comparePaths(a, b, reasonOut) {
  const decide = (delta, reason) => {
    if (delta === 0) return null;
    if (reasonOut) reasonOut.reason = reason;
    return delta;
  };
  let r = decide(b.localPref - a.localPref, `h\xF6here Local Preference (${Math.max(a.localPref, b.localPref)})`);
  if (r !== null) return r;
  const aLocal = a.relation === "local" ? 0 : 1;
  const bLocal = b.relation === "local" ? 0 : 1;
  r = decide(aLocal - bLocal, "lokal originiert");
  if (r !== null) return r;
  r = decide(a.asPath.length - b.asPath.length, `k\xFCrzerer AS-Path (${Math.min(a.asPath.length, b.asPath.length)} Hops)`);
  if (r !== null) return r;
  r = decide(ORIGIN_RANK[a.origin] - ORIGIN_RANK[b.origin], "niedrigerer Origin-Code");
  if (r !== null) return r;
  const aNeighborAs = a.asPath[0];
  const bNeighborAs = b.asPath[0];
  if (aNeighborAs !== void 0 && aNeighborAs === bNeighborAs) {
    r = decide(a.med - b.med, `niedrigerer MED (${Math.min(a.med, b.med)})`);
    if (r !== null) return r;
  }
  const aExternal = isExternal(a) ? 0 : 1;
  const bExternal = isExternal(b) ? 0 : 1;
  r = decide(aExternal - bExternal, "\xFCber eBGP gelernt");
  if (r !== null) return r;
  r = decide(a.igpCost - b.igpCost, `geringere IGP-Metrik zum Next Hop (${Math.min(a.igpCost, b.igpCost)})`);
  if (r !== null) return r;
  if (isExternal(a) && isExternal(b)) {
    r = decide(a.learnedAtTick - b.learnedAtTick, "\xE4ltere und damit stabilere Session");
    if (r !== null) return r;
  }
  r = decide(
    routerIdValue(a.peerRouterId) - routerIdValue(b.peerRouterId),
    `niedrigere Router-ID (${a.peerRouterId < b.peerRouterId ? a.peerRouterId : b.peerRouterId})`
  );
  if (r !== null) return r;
  if (reasonOut) reasonOut.reason = "gleichwertige Pfade, erste Route behalten";
  return 0;
}
function selectBestPath(candidates) {
  const usable = candidates.filter((c) => !c.suppressed);
  if (usable.length === 0) return null;
  const sorted = [...usable].sort((a, b) => comparePaths(a, b));
  const best = sorted[0];
  let reason = "einziger verf\xFCgbarer Pfad";
  if (sorted.length > 1) {
    const out = { reason: "" };
    comparePaths(best, sorted[1], out);
    reason = out.reason || "gleichwertige Pfade";
  }
  return { best, alternatives: sorted.slice(1), reason };
}
function hasAsLoop(route, localAsn) {
  return route.asPath.includes(localAsn);
}

// src/domain/network/bgp/policy.ts
function matchPrefixList(list, prefix) {
  let candidate;
  try {
    candidate = parsePrefix(prefix);
  } catch {
    return false;
  }
  const entries = [...list.entries].sort((a, b) => a.seq - b.seq);
  for (const entry of entries) {
    let base;
    try {
      base = parsePrefix(entry.prefix);
    } catch {
      continue;
    }
    if (base.family !== candidate.family) continue;
    if (!containsPrefix(base, candidate)) continue;
    const min = entry.ge ?? base.length;
    const max = entry.le ?? (entry.ge !== void 0 ? candidate.bits : base.length);
    if (candidate.length < min || candidate.length > max) continue;
    return entry.action === "permit";
  }
  return false;
}
function matchAsPath(pattern, asPath) {
  const subject = asPath.join(" ");
  const translated = pattern.replace(/_/g, "(?:^|\\s|$)");
  try {
    return new RegExp(translated).test(subject);
  } catch {
    return false;
  }
}
function matchCommunity(pattern, communities) {
  if (pattern.includes("*")) {
    const rx = new RegExp(`^${pattern.replace(/\*/g, "\\d+")}$`);
    return communities.some((c) => rx.test(c));
  }
  return communities.includes(pattern);
}
function resolveCommunity(template, asn) {
  return template.replace("{asn}", String(asn));
}
function clauseMatches(clause, route, ctx) {
  const m = clause.match;
  if (!m || Object.keys(m).length === 0) return true;
  if (m.prefixList) {
    const list = ctx.prefixLists.find((l) => l.name === m.prefixList);
    if (!list || !matchPrefixList(list, route.prefix)) return false;
  }
  if (m.asPathRegex && !matchAsPath(m.asPathRegex, route.asPath)) return false;
  if (m.community && !matchCommunity(m.community, route.communities)) return false;
  if (m.relation && route.relation !== m.relation) return false;
  return true;
}
function applySet(clause, route, localAsn) {
  const set = clause.set ?? {};
  const next = {
    ...route,
    communities: [...route.communities],
    asPath: [...route.asPath]
  };
  if (set.localPref !== void 0) next.localPref = set.localPref;
  if (set.med !== void 0) next.med = set.med;
  if (set.origin !== void 0) next.origin = set.origin;
  if (set.prependSelf) {
    next.asPath = [...Array(set.prependSelf).fill(localAsn), ...next.asPath];
  }
  if (set.addCommunity?.length) {
    for (const c of set.addCommunity) {
      const resolved = resolveCommunity(c, localAsn);
      if (!next.communities.includes(resolved)) next.communities.push(resolved);
    }
  }
  if (set.removeCommunity?.length) {
    next.communities = next.communities.filter(
      (c) => !set.removeCommunity.some((p) => matchCommunity(resolveCommunity(p, localAsn), [c]))
    );
  }
  return next;
}
function applyRouteMap(map, route, ctx) {
  if (!map) return { accepted: true, route, matchedSeq: null };
  const clauses = [...map.clauses].sort((a, b) => a.seq - b.seq);
  for (const clause of clauses) {
    if (!clauseMatches(clause, route, ctx)) continue;
    if (clause.action === "deny") {
      return { accepted: false, route, matchedSeq: clause.seq };
    }
    return { accepted: true, route: applySet(clause, route, ctx.localAsn), matchedSeq: clause.seq };
  }
  return { accepted: false, route, matchedSeq: null };
}
function isValleyFreeExport(routeRelation, toRelation) {
  if (toRelation === "customer") return true;
  if (toRelation === "ibgp") return true;
  return routeRelation === "local" || routeRelation === "customer";
}
function detectRouteLeak(route, toRelation) {
  return !isValleyFreeExport(route.relation, toRelation);
}
function isBlockedByCommunity(route, toRelation, localAsn) {
  if (route.communities.includes("65535:65282")) return "NO_ADVERTISE";
  if (route.communities.includes("65535:65281") && toRelation !== "ibgp") return "NO_EXPORT";
  if (route.communities.includes(`${localAsn}:2000`) && toRelation === "peer") return "Kein Export an Peers";
  if (route.communities.includes(`${localAsn}:2001`) && toRelation === "transit") return "Kein Export an Upstreams";
  return null;
}
function prependsFromCommunity(route, localAsn) {
  if (route.communities.includes(`${localAsn}:1003`)) return 3;
  if (route.communities.includes(`${localAsn}:1002`)) return 2;
  if (route.communities.includes(`${localAsn}:1001`)) return 1;
  return 0;
}

// src/domain/network/bgp/engine.ts
var FULL_TABLE_SIZE = 985e3;
var STATE_SEQUENCE = ["idle", "connect", "active", "opensent", "openconfirm", "established"];
function sessionViable(world, router, neighbor) {
  if (!neighbor.enabled) return { ok: false, reason: "administrativ abgeschaltet" };
  if (router.state !== "online" && router.state !== "degraded") return { ok: false, reason: `Router ist ${router.state}` };
  if (neighbor.relation === "ibgp") {
    return { ok: true };
  }
  if (!neighbor.linkId) return { ok: false, reason: "kein Link zugeordnet" };
  const link = world.links[neighbor.linkId];
  if (!link) return { ok: false, reason: "Link existiert nicht" };
  if (!isLinkUsable(link)) return { ok: false, reason: `Link ist ${link.state}` };
  if (!isLinkPortEnabled(world, link)) return { ok: false, reason: "Router-Port ist administrativ abgeschaltet" };
  return { ok: true };
}
function stepSessions(world) {
  const messages = [];
  const seen = /* @__PURE__ */ new Set();
  for (const router of values(world.routers)) {
    for (const neighbor of router.bgp.neighbors) {
      const sessionId = asId(`ses_${router.id}_${neighbor.id}`);
      seen.add(sessionId);
      let session = world.sessions[sessionId];
      if (!session) {
        session = {
          id: sessionId,
          routerId: router.id,
          peerId: neighbor.id,
          state: "idle",
          remoteAsn: neighbor.remoteAsn,
          ticksInState: 0,
          prefixesReceived: 0,
          prefixesSent: 0,
          flaps: 0,
          lastError: null,
          uptimeTicks: 0
        };
        world.sessions[sessionId] = session;
      }
      session.remoteAsn = neighbor.remoteAsn;
      const viable = sessionViable(world, router, neighbor);
      if (!viable.ok) {
        if (session.state === "established") {
          session.flaps += 1;
          messages.push({
            severity: "error",
            text: `BGP-Session zu AS${neighbor.remoteAsn} (${neighbor.description}) ausgefallen: ${viable.reason}`
          });
        }
        if (session.state !== "idle") {
          session.state = "idle";
          session.ticksInState = 0;
          session.uptimeTicks = 0;
          session.prefixesReceived = 0;
          session.prefixesSent = 0;
        }
        session.lastError = viable.reason ?? null;
        continue;
      }
      const overloaded = router.bgp.neighbors.filter((n) => n.enabled).length > router.maxBgpSessions;
      if (overloaded && session.state !== "established") {
        session.lastError = `Router unterst\xFCtzt nur ${router.maxBgpSessions} Sessions`;
        session.state = "active";
        session.ticksInState += 1;
        continue;
      }
      session.lastError = null;
      if (session.state === "established") {
        session.ticksInState += 1;
        session.uptimeTicks += 1;
      } else {
        const index = STATE_SEQUENCE.indexOf(session.state);
        session.state = STATE_SEQUENCE[Math.min(index + 1, STATE_SEQUENCE.length - 1)];
        session.ticksInState = 0;
        if (session.state === "established") {
          messages.push({
            severity: "info",
            text: `BGP-Session zu AS${neighbor.remoteAsn} (${neighbor.description}) ist aktiv.`
          });
        }
      }
    }
  }
  for (const id of Object.keys(world.sessions)) {
    if (!seen.has(id)) delete world.sessions[id];
  }
  return { messages };
}
function hash(input) {
  let h = 2166136261;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0) / 4294967296;
}
function buildAsPath(provider, destination, providers) {
  if (destination.ownerAsn === provider.asn) return [provider.asn];
  const roll = hash(`${provider.asn}:${destination.prefix}`);
  const path = [provider.asn];
  if (provider.kind !== "tier1") {
    const tier1 = providers.filter((p) => p.kind === "tier1");
    if (tier1.length > 0) {
      path.push(tier1[Math.floor(roll * tier1.length) % tier1.length].asn);
    }
  }
  if (roll > 0.72) {
    const mid = providers.filter((p) => p.kind === "tier2" && p.asn !== provider.asn);
    if (mid.length > 0) path.push(mid[Math.floor(roll * 100) % mid.length].asn);
  }
  if (!path.includes(destination.ownerAsn)) path.push(destination.ownerAsn);
  return path;
}
function peerAnnouncements(provider, destinations) {
  const own = destinations.filter((d) => d.ownerAsn === provider.asn);
  if (provider.kind === "content" || provider.kind === "eyeball") return own;
  const cone = destinations.filter((d) => d.ownerAsn !== provider.asn && hash(`${provider.asn}~${d.prefix}`) < 0.25);
  return [...own, ...cone];
}
function generateExternalRoutes(world, router, neighbor, tick2) {
  const provider = world.market.providers.find((p) => p.asn === neighbor.remoteAsn);
  if (!provider) return { routes: [], virtualPrefixCount: 0 };
  const destinations = world.market.destinations;
  const defaultOnly = neighbor.relation === "transit" && neighbor.defaultOriginate;
  const relevant = defaultOnly ? [] : neighbor.relation === "transit" ? destinations : neighbor.relation === "peer" ? peerAnnouncements(provider, destinations) : [];
  const dc = router.datacenterId ? world.datacenters[router.datacenterId] : void 0;
  const routes = [];
  for (const destination of relevant) {
    const asPath = buildAsPath(provider, destination, world.market.providers);
    const med = dc ? Math.round(distanceKm(dc.position, destination.position) / 10) : 0;
    routes.push({
      prefix: destination.prefix,
      nextHop: neighbor.address,
      asPath,
      origin: "igp",
      med,
      localPref: neighbor.localPrefIn,
      communities: [],
      learnedFrom: neighbor.id,
      relation: neighbor.relation,
      igpCost: 0,
      peerRouterId: `10.255.${neighbor.remoteAsn % 250}.${(neighbor.remoteAsn >> 8) % 250}`,
      learnedAtTick: tick2
    });
  }
  if (neighbor.defaultOriginate) {
    routes.push({
      prefix: "0.0.0.0/0",
      nextHop: neighbor.address,
      asPath: [provider.asn],
      origin: "igp",
      med: 0,
      localPref: neighbor.localPrefIn,
      communities: [],
      learnedFrom: neighbor.id,
      relation: neighbor.relation,
      igpCost: 0,
      peerRouterId: `10.255.${neighbor.remoteAsn % 250}.0`,
      learnedAtTick: tick2
    });
  }
  const virtualPrefixCount = neighbor.defaultOriginate && neighbor.relation === "transit" ? 1 : neighbor.relation === "transit" ? Math.round(FULL_TABLE_SIZE * provider.reach) : Math.round(FULL_TABLE_SIZE * provider.reach * 0.12);
  return { routes, virtualPrefixCount };
}
function originatedRoutes(world, router, tick2) {
  return router.bgp.originatedPrefixes.map((prefix) => ({
    prefix,
    nextHop: "0.0.0.0",
    asPath: [],
    origin: "igp",
    med: 0,
    localPref: 100,
    communities: [],
    learnedFrom: null,
    relation: "local",
    igpCost: 0,
    peerRouterId: router.bgp.routerId,
    learnedAtTick: tick2
  }));
}
function computeAdvertisedRoutes(router, neighbor, locRib) {
  const routes = [];
  const leaked = [];
  const localAsn = router.bgp.localAsn;
  const outMap = router.bgp.routeMaps.find((m) => m.name === neighbor.routeMapOut);
  for (const entry of locRib) {
    const route = entry.best;
    if (route.relation === "ibgp" && neighbor.relation === "ibgp") continue;
    const blocked = isBlockedByCommunity(route, neighbor.relation, localAsn);
    if (blocked) continue;
    const policy = applyRouteMap(outMap, route, {
      prefixLists: router.bgp.prefixLists,
      localAsn,
      relation: route.relation
    });
    if (outMap && !policy.accepted) continue;
    if (!outMap && !isValleyFreeExport(route.relation, neighbor.relation)) continue;
    if (outMap && detectRouteLeak(route, neighbor.relation)) {
      leaked.push(route);
    }
    const shaped = policy.route;
    const prepends = neighbor.prependOut + prependsFromCommunity(shaped, localAsn);
    const asPath = neighbor.relation === "ibgp" ? [...shaped.asPath] : [...Array(prepends + 1).fill(localAsn), ...shaped.asPath];
    routes.push({
      ...shaped,
      asPath,
      // Next-Hop-Self: nach außen und im iBGP zeigt der Next Hop auf uns.
      nextHop: neighbor.relation === "ibgp" ? router.bgp.routerId : neighbor.address,
      med: neighbor.medOut ?? shaped.med,
      relation: shaped.relation,
      peerRouterId: router.bgp.routerId
    });
  }
  return { routes, leaked };
}
function runBgp(world, maxIterations = 5) {
  const tick2 = world.meta.tick;
  const topology = buildTopology(world);
  const distances = allShortestPaths(topology);
  const routers = values(world.routers);
  const ribs = /* @__PURE__ */ new Map();
  for (const router of routers) ribs.set(router.id, { loc: /* @__PURE__ */ new Map(), candidates: /* @__PURE__ */ new Map() });
  const messages = [];
  const leaks = [];
  const fibUsage = {};
  const ribUsage = {};
  let iterations = 0;
  for (let iteration = 0; iteration < maxIterations; iteration++) {
    iterations = iteration + 1;
    let changed = false;
    for (const router of routers) {
      const rib = ribs.get(router.id);
      const candidates = /* @__PURE__ */ new Map();
      let ribPrefixes = router.bgp.originatedPrefixes.length;
      let uncovered = 1;
      let defaultOnlySessions = 0;
      const add = (route) => {
        const list = candidates.get(route.prefix) ?? [];
        list.push(route);
        candidates.set(route.prefix, list);
      };
      for (const route of originatedRoutes(world, router, tick2)) add(route);
      for (const neighbor of router.bgp.neighbors) {
        const session = world.sessions[asId(`ses_${router.id}_${neighbor.id}`)];
        if (!session || session.state !== "established") continue;
        if (neighbor.relation === "ibgp") continue;
        const { routes, virtualPrefixCount } = generateExternalRoutes(world, router, neighbor, tick2);
        if (virtualPrefixCount > neighbor.maxPrefix) {
          if (iteration === 0) {
            messages.push({
              severity: "error",
              text: `Max-Prefix-Grenze \xFCberschritten: AS${neighbor.remoteAsn} sendet ${virtualPrefixCount.toLocaleString("de-DE")} Prefixe, erlaubt sind ${neighbor.maxPrefix.toLocaleString("de-DE")}. Session wird beendet.`
            });
            session.state = "idle";
            session.flaps += 1;
            session.lastError = "max-prefix \xFCberschritten";
          }
          continue;
        }
        session.prefixesReceived = virtualPrefixCount;
        ribPrefixes += virtualPrefixCount;
        if (neighbor.defaultOriginate && neighbor.relation === "transit") {
          defaultOnlySessions += 1;
        } else {
          const provider = world.market.providers.find((p) => p.asn === neighbor.remoteAsn);
          const share = provider ? provider.reach * (neighbor.relation === "transit" ? 1 : 0.12) : 0;
          uncovered *= 1 - Math.min(1, share);
        }
        const inMap = router.bgp.routeMaps.find((m) => m.name === neighbor.routeMapIn);
        for (const raw of routes) {
          if (hasAsLoop(raw, router.bgp.localAsn)) continue;
          const policy = applyRouteMap(inMap, raw, {
            prefixLists: router.bgp.prefixLists,
            localAsn: router.bgp.localAsn,
            relation: raw.relation
          });
          if (inMap && !policy.accepted) continue;
          add(policy.route);
        }
      }
      for (const other of routers) {
        if (other.id === router.id) continue;
        const neighbor = router.bgp.neighbors.find((n) => n.relation === "ibgp" && n.description.includes(other.name));
        const session = neighbor ? world.sessions[asId(`ses_${router.id}_${neighbor.id}`)] : void 0;
        if (neighbor && (!session || session.state !== "established")) continue;
        const path = distances[router.id]?.[other.id];
        if (!path) continue;
        const otherRib = ribs.get(other.id);
        if (!otherRib) continue;
        for (const entry of otherRib.loc.values()) {
          if (entry.best.relation === "ibgp") continue;
          if (hasAsLoop(entry.best, router.bgp.localAsn)) continue;
          add({
            ...entry.best,
            relation: "ibgp",
            nextHop: other.bgp.routerId,
            igpCost: path.cost,
            localPref: entry.best.localPref,
            peerRouterId: other.bgp.routerId
          });
        }
      }
      const nextLoc = /* @__PURE__ */ new Map();
      for (const [prefix, list] of candidates) {
        const selection = selectBestPath(list);
        if (!selection) continue;
        nextLoc.set(prefix, {
          prefix,
          best: selection.best,
          alternatives: selection.alternatives,
          reason: selection.reason,
          egressLinkId: resolveEgressLink(world, router, selection.best, distances)
        });
      }
      if (!ribsEqual(rib.loc, nextLoc)) changed = true;
      rib.loc = nextLoc;
      rib.candidates = candidates;
      fibUsage[router.id] = Math.round(FULL_TABLE_SIZE * (1 - uncovered)) + defaultOnlySessions + router.bgp.originatedPrefixes.length;
      ribUsage[router.id] = ribPrefixes;
    }
    if (!changed) break;
  }
  for (const router of routers) {
    const rib = ribs.get(router.id);
    const locList = [...rib.loc.values()];
    for (const neighbor of router.bgp.neighbors) {
      const session = world.sessions[asId(`ses_${router.id}_${neighbor.id}`)];
      if (!session || session.state !== "established") continue;
      const { routes, leaked } = computeAdvertisedRoutes(router, neighbor, locList);
      session.prefixesSent = routes.length;
      if (leaked.length > 0 && neighbor.relation !== "customer" && neighbor.relation !== "ibgp") {
        leaks.push({
          routerId: router.id,
          peerId: neighbor.id,
          toAsn: neighbor.remoteAsn,
          prefixCount: leaked.length,
          sampleAsPath: leaked[0].asPath
        });
      }
    }
  }
  const fibOverflow = [];
  for (const router of routers) {
    const usage2 = fibUsage[router.id] ?? 0;
    if (usage2 > router.fibCapacity) {
      fibOverflow.push(router.id);
      messages.push({
        severity: "error",
        text: `${router.name}: Weiterleitungstabelle \xFCberl\xE4uft (${usage2.toLocaleString("de-DE")} von ${router.fibCapacity.toLocaleString("de-DE")} Eintr\xE4gen). Pakete werden verworfen. Abhilfe: gr\xF6\xDFeres Modell einsetzen, oder bei den Upstreams "nur Default-Route" statt der vollen Tabelle beziehen.`
      });
    }
    const rib = ribUsage[router.id] ?? 0;
    const ribBudget = router.fibCapacity * 3;
    if (rib > ribBudget) {
      messages.push({
        severity: "warning",
        text: `${router.name}: ${rib.toLocaleString("de-DE")} empfangene Prefixe \xFCber alle Sitzungen (Speicher reicht f\xFCr etwa ${ribBudget.toLocaleString("de-DE")}). Die Konvergenz wird langsamer. Ein Filter auf den eingehenden Sitzungen oder weniger Full-Table-Upstreams schaffen Luft.`
      });
    }
  }
  const routingTables = {};
  for (const router of routers) {
    const rib = ribs.get(router.id);
    const entries = [...rib.loc.values()].sort((a, b) => a.prefix.localeCompare(b.prefix));
    let totalPaths = 0;
    for (const list of rib.candidates.values()) totalPaths += list.length;
    routingTables[router.id] = { routerId: router.id, entries, totalPaths };
  }
  return {
    routingTables,
    fibUsage,
    ribUsage,
    fibOverflow,
    leaks,
    messages,
    reachability: computeReachability(world, routingTables, fibOverflow),
    iterations
  };
}
function resolveEgressLink(world, router, route, distances) {
  if (route.relation === "local") return null;
  if (route.relation === "ibgp") {
    const target = values(world.routers).find((r) => r.bgp.routerId === route.nextHop);
    if (!target) return null;
    const path = distances[router.id]?.[target.id];
    const first = path?.links[0];
    return first ? first : null;
  }
  const neighbor = router.bgp.neighbors.find((n) => n.id === route.learnedFrom);
  return neighbor?.linkId ?? null;
}
function ribsEqual(a, b) {
  if (a.size !== b.size) return false;
  for (const [prefix, entry] of a) {
    const other = b.get(prefix);
    if (!other) return false;
    if (other.best.nextHop !== entry.best.nextHop) return false;
    if (other.best.asPath.join(",") !== entry.best.asPath.join(",")) return false;
    if (other.best.localPref !== entry.best.localPref) return false;
  }
  return true;
}
function computeReachability(world, tables, overflow) {
  const destinations = world.market.destinations;
  if (destinations.length === 0) return 0;
  const reachable = /* @__PURE__ */ new Set();
  let hasDefault = false;
  for (const [routerId, table] of Object.entries(tables)) {
    const penalty = overflow.includes(routerId);
    for (const entry of table.entries) {
      if (entry.prefix === "0.0.0.0/0" || entry.prefix === "::/0") {
        if (!penalty) hasDefault = true;
        continue;
      }
      if (!penalty) reachable.add(entry.prefix);
    }
  }
  if (hasDefault) return overflow.length > 0 ? 0.85 : 1;
  let share = 0;
  for (const destination of destinations) {
    if (reachable.has(destination.prefix)) share += destination.trafficShare;
  }
  const overflowFactor = overflow.length > 0 ? 0.6 : 1;
  return Math.min(1, share * overflowFactor);
}
function withdrawPrefix(router, prefix) {
  const index = router.bgp.originatedPrefixes.indexOf(prefix);
  if (index < 0) return false;
  router.bgp.originatedPrefixes.splice(index, 1);
  return true;
}
function announcePrefix(router, prefix) {
  if (router.bgp.originatedPrefixes.includes(prefix)) return false;
  router.bgp.originatedPrefixes.push(prefix);
  return true;
}
function setBlackhole(router, prefix, enable) {
  const name = "BLACKHOLE-OUT";
  let map = router.bgp.routeMaps.find((m) => m.name === name);
  if (!map) {
    map = { name, clauses: [] };
    router.bgp.routeMaps.push(map);
  }
  const existing = map.clauses.findIndex((c) => c.match.prefixList === `BH-${prefix}`);
  if (!enable) {
    if (existing >= 0) map.clauses.splice(existing, 1);
    router.bgp.prefixLists = router.bgp.prefixLists.filter((l) => l.name !== `BH-${prefix}`);
    if (isHostRoute(prefix)) router.bgp.originatedPrefixes = router.bgp.originatedPrefixes.filter((p) => p !== prefix);
    return;
  }
  if (existing >= 0) return;
  router.bgp.prefixLists.push({ name: `BH-${prefix}`, entries: [{ seq: 10, action: "permit", prefix }] });
  map.clauses.push({
    seq: (map.clauses.length + 1) * 10,
    action: "permit",
    match: { prefixList: `BH-${prefix}` },
    set: { addCommunity: ["65535:666"], localPref: 50 }
  });
  if (!router.bgp.originatedPrefixes.includes(prefix)) router.bgp.originatedPrefixes.push(prefix);
}
function sessionsOfRouter(world, routerId) {
  return values(world.sessions).filter((s) => s.routerId === routerId);
}
function relationLabel(relation) {
  switch (relation) {
    case "customer":
      return "Kunde";
    case "peer":
      return "Peer";
    case "transit":
      return "Upstream";
    case "ibgp":
      return "iBGP";
  }
}
function isHostRoute(prefix) {
  return prefix.includes(":") ? prefix.endsWith("/128") : prefix.endsWith("/32");
}

// src/domain/network/ddos.ts
var DDOS = {
  /** Einmalige Gebühr für die Umleitung zu einem Scrubbing-Dienstleister. */
  SCRUB_SETUP_FEE: 1500,
  /** Preis je Gbit/s Angriffsvolumen und Tick beim externen Scrubbing. */
  SCRUB_PRICE_PER_GBPS: 25,
  /** Kleinste Blackhole-Prefixe, die Upstreams annehmen (längere = spezifischer). */
  MIN_BLACKHOLE_LENGTH_V4: 24,
  MIN_BLACKHOLE_LENGTH_V6: 48,
  /** Darunter merkt ein Server von einem Angriff praktisch nichts. */
  NOTICEABLE_GBPS: 0.05
};
var REFLECTOR_PORTS = [
  { port: 53, service: "DNS" },
  { port: 123, service: "NTP" },
  { port: 389, service: "CLDAP" },
  { port: 1900, service: "SSDP" },
  { port: 11211, service: "memcached" }
];
var VECTOR_LABEL = {
  "udp-amplification": "UDP-Amplification",
  "syn-flood": "SYN-Flood",
  "http-flood": "HTTP-Flood (Layer 7)"
};
function emptyHardening() {
  return { synCookies: false, udpDropPorts: [], httpRateLimit: false };
}
function hardeningOf(server) {
  return server.hardening ?? emptyHardening();
}
function activeAttacks(world) {
  return values(world.events).filter((e) => !e.resolved && !!e.ddos);
}
function attackOnServer(world, serverId) {
  return activeAttacks(world).find((e) => e.ddos.serverId === serverId);
}
function siteMitigationGbps(world, datacenterId, vector, bonusGbps) {
  if (vector === "http-flood") return 0;
  let capacity = 0;
  for (const firewall of values(world.firewalls)) {
    if (firewall.datacenterId !== datacenterId) continue;
    if (firewall.state !== "online" && firewall.state !== "degraded") continue;
    if (vector === "udp-amplification") {
      const handlesUdp = firewall.rules.some(
        (r) => r.enabled && r.protocol === "udp" && (r.action === "rate-limit" || r.action === "deny")
      );
      if (!handlesUdp) continue;
    }
    capacity += firewall.state === "degraded" ? firewall.scrubbingGbps * 0.5 : firewall.scrubbingGbps;
  }
  return capacity + bonusGbps;
}
function hasEstablishedTransit(world, router) {
  return router.bgp.neighbors.some((n) => {
    if (!n.enabled || n.relation !== "transit") return false;
    return values(world.sessions).some((s) => s.routerId === router.id && s.peerId === n.id && s.state === "established");
  });
}
function canSignalBlackhole(world, router) {
  if (router.state !== "online" && router.state !== "degraded") return false;
  return router.bgp.blackholeEnabled && hasEstablishedTransit(world, router);
}
function acceptable(prefix) {
  const min = prefix.family === "ipv4" ? DDOS.MIN_BLACKHOLE_LENGTH_V4 : DDOS.MIN_BLACKHOLE_LENGTH_V6;
  return prefix.length >= min;
}
function blackholePrefixesOf(router) {
  const map = router.bgp.routeMaps.find((m) => m.name === "BLACKHOLE-OUT");
  if (!map) return [];
  const names = new Set(map.clauses.map((c) => c.match.prefixList).filter((n) => !!n));
  return router.bgp.prefixLists.filter((l) => names.has(l.name)).flatMap((l) => l.entries.map((e) => e.prefix));
}
function effectiveBlackholes(world) {
  const out = [];
  for (const router of values(world.routers)) {
    const prefixes = blackholePrefixesOf(router);
    if (prefixes.length === 0 || !canSignalBlackhole(world, router)) continue;
    for (const cidr of prefixes) {
      try {
        const prefix = parsePrefix(cidr);
        if (acceptable(prefix)) out.push({ prefix, routerId: router.id });
      } catch {
      }
    }
  }
  return out;
}
function isBlackholed(blackholes, address) {
  return blackholes.some((b) => containsAddress(b.prefix, address));
}
function blackholeProblem(world, router, cidr) {
  let prefix;
  try {
    prefix = parsePrefix(cidr);
  } catch {
    return "Ung\xFCltiges Prefix.";
  }
  if (!acceptable(prefix)) {
    return `Upstreams nehmen Blackholes erst ab /${prefix.family === "ipv4" ? DDOS.MIN_BLACKHOLE_LENGTH_V4 : DDOS.MIN_BLACKHOLE_LENGTH_V6} an.`;
  }
  if (router.state !== "online" && router.state !== "degraded") return `${router.name} ist nicht in Betrieb.`;
  if (!router.bgp.blackholeEnabled) return `Auf ${router.name} ist die Blackhole-Community abgeschaltet.`;
  if (!hasEstablishedTransit(world, router)) return `${router.name} hat keine aufgebaute Transit-Session.`;
  return null;
}
function blackholeRouters(world, datacenterId) {
  const usable = values(world.routers).filter((r) => canSignalBlackhole(world, r));
  const local = usable.filter((r) => r.datacenterId === datacenterId);
  return local.length > 0 ? local : usable;
}
function hostRoute(address) {
  return detectFamily(address) === "ipv4" ? `${address}/32` : `${address}/128`;
}
function liftOwnBlackholes(world, attack) {
  for (const routerId of attack.blackholeRouterIds) {
    const router = world.routers[routerId];
    if (router) setBlackhole(router, hostRoute(attack.targetIp), false);
  }
  attack.blackholeRouterIds = [];
}
function currentVolume(world, event, attack) {
  const elapsed = world.meta.tick - event.startedAtTick;
  if (elapsed <= 0) return attack.peakGbps * 0.6;
  if (event.ticksRemaining <= 1) return attack.peakGbps * 0.5;
  return attack.peakGbps;
}
function prepareAttacks(world, bonusGbps) {
  const inbound = {};
  const attacks = activeAttacks(world);
  if (attacks.length === 0) return inbound;
  const blackholes = effectiveBlackholes(world);
  for (const event of attacks) {
    const attack = event.ddos;
    const volume = currentVolume(world, event, attack);
    attack.currentGbps = round2(volume);
    if (isFrozen(world, event)) {
      attack.filteredGbps = attack.currentGbps;
      attack.residualGbps = 0;
      continue;
    }
    if (isBlackholed(blackholes, attack.targetIp)) {
      attack.filteredGbps = attack.currentGbps;
      attack.residualGbps = 0;
      continue;
    }
    if (attack.externalScrub) {
      post(world, {
        category: "cost-other",
        amount: -volume * attack.scrubPricePerGbps,
        description: `Externes Scrubbing f\xFCr ${attack.targetIp}`
      });
      attack.filteredGbps = attack.currentGbps;
      attack.residualGbps = 0;
      continue;
    }
    const filtered = Math.min(volume, siteMitigationGbps(world, attack.datacenterId, attack.vector, bonusGbps));
    attack.filteredGbps = round2(filtered);
    attack.residualGbps = round2(volume - filtered);
    inbound[attack.datacenterId] = (inbound[attack.datacenterId] ?? 0) + attack.residualGbps * 1e3;
  }
  return inbound;
}
function settleAttacks(world) {
  const attacks = activeAttacks(world);
  if (attacks.length === 0) return;
  const blackholes = effectiveBlackholes(world);
  for (const event of attacks) {
    const attack = event.ddos;
    attack.uplinkSaturation = round2(uplinkSaturation(world, attack.datacenterId));
    if (isFrozen(world, event)) {
      attack.targetState = "ok";
      attack.targetNote = "Die Abwehrlinie h\xE4lt den Angriff auf, solange du sie verteidigst.";
      continue;
    }
    if (isBlackholed(blackholes, attack.targetIp)) {
      attack.targetState = "blackholed";
      attack.targetNote = "Die Upstreams verwerfen allen Verkehr an diese Adresse \u2013 auch den der Besucher.";
      continue;
    }
    const delivered = attack.residualGbps * (attack.uplinkSaturation > 1 ? 1 / attack.uplinkSaturation : 1);
    const server = attack.serverId ? world.servers[attack.serverId] : void 0;
    const nicGbps = server ? serverNicMbps(server) / 1e3 : 10;
    const hardening = server ? hardeningOf(server) : emptyHardening();
    const verdict = judgeTarget(attack, delivered, nicGbps, hardening);
    attack.targetState = verdict.state;
    attack.targetNote = verdict.note;
    if (attack.targetState === "ok" && attack.uplinkSaturation > 1) {
      attack.targetState = "degraded";
      attack.targetNote = "Der Server h\xE4lt, aber die Zuleitungen des Standorts sind voll \u2013 Besucher sehen Paketverlust.";
    }
  }
}
function judgeTarget(attack, deliveredGbps2, nicGbps, hardening) {
  if (attack.externalScrub) {
    return { state: "ok", note: "Der Verkehr l\xE4uft \xFCber den Scrubbing-Dienstleister und kommt sauber an." };
  }
  if (attack.vector === "http-flood") {
    if (attack.residualGbps <= 0) return { state: "ok", note: "Der Angriff wird vollst\xE4ndig gefiltert." };
    return hardening.httpRateLimit ? { state: "ok", note: "Die Anfragebegrenzung verwirft die Flut, echte Besucher kommen durch." } : { state: "down", note: "Der Webserver ist mit Anfragen ausgelastet und antwortet nicht mehr." };
  }
  if (deliveredGbps2 < DDOS.NOTICEABLE_GBPS) {
    return { state: "ok", note: "Der Angriff wird am Netzrand gefiltert und erreicht den Server nicht." };
  }
  if (deliveredGbps2 >= nicGbps * 0.95) {
    return {
      state: "down",
      note: `Die Netzwerkkarte ist voll (${decimal(deliveredGbps2)} von ${decimal(nicGbps)} Gbit/s). Dagegen hilft nur Filterung vor dem Server.`
    };
  }
  if (attack.vector === "syn-flood") {
    return hardening.synCookies ? { state: "ok", note: "SYN-Cookies halten den Verbindungs-Backlog frei." } : { state: "down", note: "Der SYN-Backlog ist voll, neue Verbindungen werden nicht mehr angenommen." };
  }
  const dropped = attack.reflectorPort !== null && hardening.udpDropPorts.includes(attack.reflectorPort);
  return dropped ? { state: "ok", note: "Der Paketfilter verwirft die reflektierten Pakete fr\xFCh." } : { state: "degraded", note: "Die Pakete kommen bis in den Kernel durch; die Dienste antworten z\xE4h." };
}
function uplinkSaturation(world, datacenterId) {
  let worst = 0;
  for (const link of ingressLinks(world, datacenterId)) {
    if (link.capacityMbps <= 0) continue;
    const peak = Math.max(link.utilizationMbps.aToB, link.utilizationMbps.bToA);
    worst = Math.max(worst, peak / link.capacityMbps);
  }
  return worst;
}
function attackImpact(world) {
  const impact = { blackholes: effectiveBlackholes(world), targets: /* @__PURE__ */ new Map(), sites: /* @__PURE__ */ new Map() };
  for (const event of activeAttacks(world)) {
    const attack = event.ddos;
    const factor = attack.targetState === "down" || attack.targetState === "blackholed" ? 0 : attack.targetState === "degraded" ? 0.6 : 1;
    impact.targets.set(attack.contractId, Math.min(impact.targets.get(attack.contractId) ?? 1, factor));
    if (attack.uplinkSaturation > 1) {
      const site = Math.max(0.15, 1 / attack.uplinkSaturation);
      impact.sites.set(attack.datacenterId, Math.min(impact.sites.get(attack.datacenterId) ?? 1, site));
    }
  }
  return impact;
}
function attackAvailabilityFactor(world, contract, impact) {
  const primary = contract.ipv4[0] ?? contract.ipv6[0];
  if (primary && impact.blackholes.length > 0 && isBlackholed(impact.blackholes, primary)) return 0;
  let factor = impact.targets.get(contract.id) ?? 1;
  if (impact.sites.size > 0) {
    const site = contractDatacenterId(world, contract);
    if (site) factor *= impact.sites.get(site) ?? 1;
  }
  return factor;
}
function decimal(value) {
  return value.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}
function round2(value) {
  return Math.round(value * 100) / 100;
}

// src/domain/compute/console.ts
var CONSOLE_MAX_LINE = 400;
var HELP = [
  "Verf\xFCgbare Befehle (Auswahl, wie auf einem echten Linux-Server):",
  "",
  "  \xDCberblick     hostname, uname -a, uptime, date, free -h, df -h, top",
  "  Netz          ip a, ip r, ping <ziel>, iftop | nload",
  "  Verbindungen  ss -s, ss -tan [state syn-recv], netstat -an",
  "  Mitschnitt    tcpdump [-c N]",
  "  Protokolle    dmesg, journalctl -k, tail /var/log/nginx/access.log",
  "  Dienste       systemctl status nginx, systemctl restart nginx",
  "  Abwehr        sysctl net.ipv4.tcp_syncookies[=1]",
  "                iptables -L | -A \u2026 | -D \u2026 | -F",
  "  Sonstiges     clear, reboot, exit",
  "",
  "Pipes gehen auch: \u2026 | grep <muster>, | wc -l, | head -n 5, | tail -n 5"
];
function runConsole(world, serverId, line) {
  const server = world.servers[serverId];
  if (!server) return { output: ["Server nicht gefunden."] };
  const input = line.trim().slice(0, CONSOLE_MAX_LINE);
  if (input === "") return { output: [] };
  const [head, ...pipes] = input.split("|").map((part) => part.trim());
  const args = tokenize(head);
  if (args[0] === "sudo") args.shift();
  const command = args[0] ?? "";
  if (command === "clear") return { output: [], clear: true };
  if (command === "exit" || command === "logout") return { output: ["logout"], close: true };
  if (command === "help" || command === "?") return { output: HELP };
  const unreachable = reachabilityProblem(server);
  if (unreachable) return { output: [unreachable] };
  if (server.os === "windows-server") {
    return { output: ["Windows-Server werden per Remotedesktop verwaltet. Diese Konsole spricht nur Unix-Werkzeuge."] };
  }
  const ctx = {
    world,
    server,
    attack: attackOnServer(world, server.id),
    rng: new Rng(hash2(`${server.id}:${world.meta.tick}:${input}`))
  };
  const result = dispatch(ctx, command, args.slice(1));
  return { ...result, output: applyPipes(result.output, pipes, command) };
}
function reachabilityProblem(server) {
  if (server.state === "booting") return "Der Server f\xE4hrt gerade hoch \u2013 die Konsole zeigt noch den Bootvorgang.";
  if (server.state !== "online" && server.state !== "degraded") {
    return `Keine Verbindung zum BMC: ${server.name} ist ${server.state === "offline" ? "ausgeschaltet" : "au\xDFer Betrieb"}.`;
  }
  if (server.os === null) return "Kein Betriebssystem installiert \u2013 der Server h\xE4ngt im PXE-Boot.";
  return null;
}
function dispatch(ctx, command, args) {
  switch (command) {
    case "hostname":
      return { output: [ctx.server.name] };
    case "whoami":
      return { output: ["root"] };
    case "uname":
      return { output: [args.includes("-a") ? unameLong(ctx.server) : ctx.server.os === "freebsd" ? "FreeBSD" : "Linux"] };
    case "date":
      return { output: [formatDate(ctx.world.meta.date)] };
    case "uptime":
      return { output: [uptimeLine(ctx)] };
    case "free":
      return { output: free(ctx) };
    case "df":
      return { output: df(ctx.server) };
    case "top":
    case "htop":
      return { output: top(ctx) };
    case "ip":
      return ip(ctx, args);
    case "ifconfig":
      return ip(ctx, ["a"]);
    case "ping":
      return { output: ping(ctx, args) };
    case "iftop":
    case "nload":
    case "bmon":
    case "vnstat":
      return { output: bandwidth(ctx) };
    case "ss":
    case "netstat":
      return { output: sockets(ctx, args) };
    case "tcpdump":
      return { output: tcpdump(ctx, args) };
    case "dmesg":
      return { output: kernelLog(ctx) };
    case "journalctl":
      return { output: args.includes("-k") || args.includes("--dmesg") ? kernelLog(ctx) : serviceLog(ctx) };
    case "tail":
    case "cat":
    case "less":
    case "more":
    case "head":
      return { output: readFile(ctx, args) };
    case "systemctl":
    case "service":
      return { output: systemctl(ctx, command === "service" ? [args[1] ?? "", args[0] ?? ""] : args) };
    case "sysctl":
      return sysctl(ctx, args);
    case "iptables":
      return iptables(ctx, args);
    case "nft":
      return { output: ["Diese Maschine nutzt iptables-nft \u2013 bitte die iptables-Befehle verwenden."] };
    case "reboot":
    case "shutdown":
      if (command === "shutdown" && !args.includes("-r")) {
        return { output: ["Ausschalten bitte \xFCber die Schaltfl\xE4che im Serverfenster \u2013 dort wird nach betroffenen Kunden gefragt."] };
      }
      return {
        output: ["Broadcast message from root: The system will reboot now!"],
        delegate: { type: "hw/reboot", kind: "server", id: ctx.server.id }
      };
    default:
      return { output: [`bash: ${command}: Befehl nicht gefunden. \u201Ehelp\u201C zeigt, was diese Konsole kann.`] };
  }
}
function deliveredGbps(ctx) {
  const attack = ctx.attack?.ddos;
  if (!attack || attack.targetState === "blackholed" || attack.externalScrub) return 0;
  const throughUplink = attack.uplinkSaturation > 1 ? 1 / attack.uplinkSaturation : 1;
  return Math.min(attack.residualGbps * throughUplink, serverNicMbps(ctx.server) / 1e3);
}
function felt(ctx) {
  const attack = ctx.attack?.ddos;
  if (!attack) return null;
  if (attack.vector === "http-flood") return attack.residualGbps > 0 && !attack.externalScrub && attack.targetState !== "blackholed" ? attack : null;
  return deliveredGbps(ctx) >= 0.05 ? attack : null;
}
function struggling(ctx) {
  const attack = felt(ctx);
  return !!attack && (attack.targetState === "down" || attack.targetState === "degraded");
}
function contractsOn(ctx) {
  const ids = [
    ...ctx.server.contractIds,
    ...ctx.server.vpsIds.map((id) => ctx.world.vpsInstances[id]?.contractId).filter((id) => !!id)
  ];
  return ids.map((id) => ctx.world.contracts[id]).filter((c) => c && c.state === "active");
}
function customerMbps(ctx) {
  const factor = diurnalFactor(ctx.world.meta.tick);
  return contractsOn(ctx).reduce((sum3, c) => sum3 + (ctx.world.products[c.productId]?.resources.trafficMbps ?? 0) * factor, 0);
}
function serverAddresses(ctx) {
  const out = [];
  for (const contract of contractsOn(ctx)) out.push(...contract.ipv4);
  return [...new Set(out)];
}
function loadAverage(ctx) {
  const base = 0.15 + contractsOn(ctx).length * 0.12;
  const cores = Math.max(1, ctx.server.cpuCores);
  return struggling(ctx) ? cores * 1.6 : Math.min(base, cores * 0.7);
}
function unameLong(server) {
  switch (server.os) {
    case "linux-ubuntu":
      return `Linux ${server.name} 6.8.0-45-generic #45-Ubuntu SMP PREEMPT_DYNAMIC x86_64 x86_64 x86_64 GNU/Linux`;
    case "linux-rocky":
      return `Linux ${server.name} 5.14.0-427.el9.x86_64 #1 SMP PREEMPT_DYNAMIC x86_64 x86_64 x86_64 GNU/Linux`;
    case "freebsd":
      return `FreeBSD ${server.name} 14.1-RELEASE FreeBSD 14.1-RELEASE GENERIC amd64`;
    default:
      return `Linux ${server.name} 6.1.0-26-amd64 #1 SMP PREEMPT_DYNAMIC Debian 6.1.112-1 x86_64 GNU/Linux`;
  }
}
function formatDate(iso) {
  const d = new Date(iso);
  return d.toUTCString().replace("GMT", "UTC");
}
function clock(iso) {
  return new Date(iso).toISOString().slice(11, 19);
}
function uptimeLine(ctx) {
  const hours = Math.max(1, ctx.world.meta.tick - ctx.server.purchasedAtTick);
  const days = Math.floor(hours / 24);
  const load = loadAverage(ctx);
  const l1 = load.toFixed(2);
  const l5 = (load * 0.85).toFixed(2);
  const l15 = (load * 0.6).toFixed(2);
  const up = days > 0 ? `${days} days, ${String(hours % 24).padStart(2, " ")}:00` : `${hours}:00`;
  return ` ${clock(ctx.world.meta.date)} up ${up},  1 user,  load average: ${l1}, ${l5}, ${l15}`;
}
function free(ctx) {
  const total = ctx.server.ramGb;
  const used = Math.min(total * 0.92, 1.2 + contractsOn(ctx).length * 0.7 + ctx.server.vpsIds.length * 1.5);
  const cache = Math.max(0, (total - used) * 0.55);
  const fmt = (gb) => `${gb.toFixed(1)}Gi`.padStart(10);
  return [
    "               total        used        free      shared  buff/cache   available",
    `Mem:     ${fmt(total)}  ${fmt(used)}  ${fmt(total - used - cache)}      0.1Gi  ${fmt(cache)}  ${fmt(total - used)}`,
    "Swap:          2.0Gi       0.0Gi       2.0Gi"
  ];
}
function df(server) {
  const rows = ["Filesystem      Size  Used Avail Use% Mounted on"];
  const line = (dev, gb, use, mount) => `${dev.padEnd(15)} ${`${Math.round(gb)}G`.padStart(4)} ${`${Math.round(gb * use)}G`.padStart(5)} ${`${Math.round(gb * (1 - use))}G`.padStart(5)} ${`${Math.round(use * 100)}%`.padStart(4)} ${mount}`;
  if (server.ssdGb > 0) rows.push(line("/dev/nvme0n1p2", server.ssdGb, 0.38, "/"));
  if (server.hddGb > 0) rows.push(line("/dev/md0", server.hddGb, 0.52, "/data"));
  rows.push("tmpfs           3.2G  1.1M  3.2G   1% /run");
  return rows;
}
function top(ctx) {
  const attack = felt(ctx);
  const load = loadAverage(ctx);
  const cores = Math.max(1, ctx.server.cpuCores);
  const busy = Math.min(99.9, load / cores * 100);
  const si = attack && attack.vector !== "http-flood" && attack.targetState !== "ok" ? Math.min(80, busy * 0.8) : 0.3;
  const us = Math.max(0, busy - si);
  const processes = [];
  if (attack?.vector === "http-flood" && attack.targetState === "down") {
    for (let i = 0; i < Math.min(6, cores); i++) processes.push(["nginx: worker process", 96 + ctx.rng.float(0, 3.9)]);
    processes.push(["php-fpm: pool www", 88]);
  } else if (attack && attack.vector !== "http-flood" && attack.targetState !== "ok") {
    for (let i = 0; i < Math.min(4, cores); i++) processes.push([`ksoftirqd/${i}`, 70 + ctx.rng.float(0, 29)]);
  }
  processes.push(["nginx: worker process", 2.1], ["php-fpm: pool www", 1.4], ["mariadbd", 0.9], ["systemd-journald", 0.1], ["sshd", 0]);
  return [
    `top - ${clock(ctx.world.meta.date)} up, load average: ${load.toFixed(2)}, ${(load * 0.85).toFixed(2)}, ${(load * 0.6).toFixed(2)}`,
    `%Cpu(s): ${us.toFixed(1)} us,  0.8 sy,  0.0 ni, ${(100 - busy).toFixed(1)} id,  0.1 wa,  0.0 hi, ${si.toFixed(1)} si,  0.0 st`,
    `MiB Mem : ${(ctx.server.ramGb * 1024).toFixed(1)} total`,
    "",
    "    PID USER      %CPU COMMAND",
    ...processes.slice(0, 10).map(([name, cpu], i) => `${String(800 + i * 37).padStart(7)} ${name.startsWith("ksoftirqd") ? "root    " : "www-data"}  ${cpu.toFixed(1).padStart(5)} ${name}`)
  ];
}
function ip(ctx, args) {
  const sub = args[0] ?? "a";
  const addresses = serverAddresses(ctx);
  const mgmt = ctx.server.managementIp;
  if (sub === "r" || sub === "route") {
    const first = mgmt ?? addresses[0];
    const gateway = first ? first.replace(/\.\d+$/, ".1") : null;
    return {
      output: gateway ? [`default via ${gateway} dev eth0 proto static`, `${first.replace(/\.\d+$/, ".0")}/24 dev eth0 proto kernel scope link src ${first}`] : ["Keine Routen \u2013 der Server hat keine Adresse."]
    };
  }
  if (sub !== "a" && sub !== "addr" && sub !== "address") return { output: [`Unbekannter Unterbefehl \u201Eip ${sub}\u201C. Versuche ip a oder ip r.`] };
  const mbps = serverNicMbps(ctx.server);
  const connected = isServerConnected(ctx.world, ctx.server.id);
  const lines = [
    "1: lo: <LOOPBACK,UP,LOWER_UP> mtu 65536 qdisc noqueue state UNKNOWN",
    "    inet 127.0.0.1/8 scope host lo",
    `2: eth0: <BROADCAST,MULTICAST${connected ? ",UP,LOWER_UP" : ",NO-CARRIER"}> mtu 1500 qdisc mq state ${connected ? "UP" : "DOWN"} (${mbps >= 1e3 ? `${mbps / 1e3}G` : `${mbps}M`})`
  ];
  if (mgmt) lines.push(`    inet ${mgmt}/24 scope global eth0  # Verwaltung`);
  for (const address of addresses) lines.push(`    inet ${address}/32 scope global eth0`);
  return { output: lines };
}
function ping(ctx, args) {
  const target = args.filter((a) => !a.startsWith("-") && !/^\d+$/.test(a)).pop();
  if (!target) return ["ping: usage error: Ziel fehlt, z. B. ping 1.1.1.1"];
  const countArg = args.indexOf("-c");
  const count2 = Math.min(10, Math.max(1, countArg >= 0 ? Number(args[countArg + 1]) || 4 : 4));
  if (!isServerConnected(ctx.world, ctx.server.id)) return ["ping: connect: Network is unreachable"];
  const local = target === "127.0.0.1" || target === "localhost" || serverAddresses(ctx).includes(target);
  const quality = ctx.world.derived.quality;
  const reachability = ctx.world.derived.internetReachability ?? 1;
  const attack = ctx.attack?.ddos;
  const extraLoss = attack && attack.uplinkSaturation > 1 ? (1 - 1 / attack.uplinkSaturation) * 100 : 0;
  const loss = local ? 0 : reachability < 0.5 ? 100 : Math.min(100, quality.packetLossPercent + extraLoss);
  const baseRtt = local ? 0.03 : Math.max(1, quality.avgLatencyMs * 2 * 0.6);
  const lines = [`PING ${target} (${target}) 56(84) bytes of data.`];
  let received = 0;
  const rtts = [];
  for (let i = 1; i <= count2; i++) {
    if (ctx.rng.next() * 100 < loss) continue;
    const rtt = baseRtt * (1 + ctx.rng.float(-0.08, 0.25)) + (attack && attack.uplinkSaturation > 0.9 && !local ? ctx.rng.float(20, 120) : 0);
    rtts.push(rtt);
    received += 1;
    lines.push(`64 bytes from ${target}: icmp_seq=${i} ttl=${local ? 64 : 56} time=${rtt.toFixed(rtt < 1 ? 3 : 1)} ms`);
  }
  lines.push("", `--- ${target} ping statistics ---`);
  lines.push(`${count2} packets transmitted, ${received} received, ${Math.round((count2 - received) / count2 * 100)}% packet loss`);
  if (rtts.length > 0) {
    const avg = rtts.reduce((s, r) => s + r, 0) / rtts.length;
    lines.push(`rtt min/avg/max = ${Math.min(...rtts).toFixed(3)}/${avg.toFixed(3)}/${Math.max(...rtts).toFixed(3)} ms`);
  }
  return lines;
}
function bandwidth(ctx) {
  const nic = serverNicMbps(ctx.server);
  const normal = customerMbps(ctx);
  const attack = felt(ctx);
  const attackMbps = attack ? deliveredGbps(ctx) * 1e3 : 0;
  const rx = Math.min(nic, normal * 0.12 + attackMbps);
  const tx = Math.min(nic, normal * 0.88 * (struggling(ctx) ? 0.2 : 1));
  const fmt = (mbps) => mbps >= 1e3 ? `${(mbps / 1e3).toFixed(2)} Gbit/s` : `${mbps.toFixed(1)} Mbit/s`;
  const bar = (mbps) => "#".repeat(Math.max(0, Math.min(40, Math.round(mbps / Math.max(1, nic) * 40)))).padEnd(40, ".");
  const lines = [
    `Device eth0 (${fmt(nic)} Leitung)`,
    "",
    `  Incoming:  [${bar(rx)}]  ${fmt(rx)}`,
    `  Outgoing:  [${bar(tx)}]  ${fmt(tx)}`,
    ""
  ];
  if (attack && attack.vector === "http-flood") {
    lines.push(`  Pakete eingehend: ~${Math.round(attack.peakRps * 6).toLocaleString("de-DE")} pps, \xFCberwiegend TCP/443`);
  } else if (attack) {
    const pps = attack.vector === "syn-flood" ? attackMbps * 1e6 / (60 * 8) : attackMbps * 1e6 / (1200 * 8);
    lines.push(`  Pakete eingehend: ~${Math.round(pps).toLocaleString("de-DE")} pps (${attack.vector === "syn-flood" ? "sehr kleine Pakete" : "gro\xDFe UDP-Pakete"})`);
  } else {
    lines.push("  Verkehr im \xFCblichen Rahmen.");
  }
  return lines;
}
function sockets(ctx, args) {
  const attack = felt(ctx);
  const hardening = ctx.server.hardening ?? emptyHardening();
  const established = Math.round(customerMbps(ctx) * 3 + 12);
  const synFlood = attack?.vector === "syn-flood";
  const httpFlood = attack?.vector === "http-flood";
  const synRecv = synFlood ? hardening.synCookies ? 120 + ctx.rng.int(0, 200) : 4096 : ctx.rng.int(0, 3);
  const estab = httpFlood ? established + Math.round(attack.peakRps / 20) : established;
  if (args.includes("-s")) {
    return [
      `Total: ${estab + synRecv + 40}`,
      `TCP:   ${estab + synRecv + 25} (estab ${estab}, closed 18, orphaned ${httpFlood ? 900 : 0}, timewait ${httpFlood ? estab * 3 : 30})`,
      "",
      "Transport Total     IP        IPv6",
      `TCP       ${String(estab + synRecv + 25).padEnd(9)} ${String(estab + synRecv).padEnd(9)} 25`,
      "UDP       4         3         1",
      "",
      `SYN_RECV  ${synRecv}${synFlood && !hardening.synCookies ? "   \u2190 Backlog voll" : ""}`
    ];
  }
  const onlySynRecv = args.join(" ").includes("syn-recv") || args.join(" ").includes("SYN_RECV");
  const addresses = serverAddresses(ctx);
  const local = addresses[0] ?? ctx.server.managementIp ?? "0.0.0.0";
  const lines = ["State      Recv-Q Send-Q   Local Address:Port      Peer Address:Port"];
  if (!onlySynRecv) {
    lines.push(`LISTEN     0      ${synFlood && !hardening.synCookies ? 511 : 0}      0.0.0.0:443             0.0.0.0:*`);
    lines.push("LISTEN     0      0        0.0.0.0:80              0.0.0.0:*");
    lines.push("LISTEN     0      0        0.0.0.0:22              0.0.0.0:*");
  }
  const synLines = Math.min(synRecv, 40);
  for (let i = 0; i < synLines; i++) {
    lines.push(`SYN-RECV   0      0     ${`${local}:443`.padEnd(22)} ${randomIp(ctx.rng)}:${ctx.rng.int(1024, 65535)}`);
  }
  if (!onlySynRecv) {
    const estLines = Math.min(estab, httpFlood ? 30 : 8);
    const flooders = Array.from({ length: 12 }, () => randomIp(ctx.rng));
    for (let i = 0; i < estLines; i++) {
      const peer = httpFlood ? flooders[i % flooders.length] : randomIp(ctx.rng);
      lines.push(`ESTAB      0      0     ${`${local}:443`.padEnd(22)} ${peer}:${ctx.rng.int(1024, 65535)}`);
    }
  }
  if (synRecv > synLines) lines.push(`\u2026 ${synRecv - synLines} weitere SYN-RECV`);
  return lines;
}
function tcpdump(ctx, args) {
  const countArg = args.indexOf("-c");
  const count2 = Math.min(40, Math.max(1, countArg >= 0 ? Number(args[countArg + 1]) || 12 : 12));
  const attack = felt(ctx);
  const target = serverAddresses(ctx)[0] ?? ctx.server.managementIp ?? "0.0.0.0";
  const attackTarget = ctx.attack?.ddos.targetIp ?? target;
  const base = new Date(ctx.world.meta.date).getTime();
  const share = attack ? attack.vector === "http-flood" ? 0.8 : 0.95 : 0;
  const reflector = REFLECTOR_PORTS.find((r) => r.port === attack?.reflectorPort);
  const lines = [
    "tcpdump: verbose output suppressed, use -v[v]... for full protocol decode",
    "listening on eth0, link-type EN10MB (Ethernet), snapshot length 262144 bytes"
  ];
  let elapsedUs = ctx.rng.int(0, 3e4);
  for (let i = 0; i < count2; i++) {
    elapsedUs += attack ? ctx.rng.int(2, 80) : ctx.rng.int(5e3, 6e4);
    const time2 = new Date(base + Math.floor(elapsedUs / 1e3)).toISOString().slice(11, 23) + String(elapsedUs % 1e3).padStart(3, "0");
    if (attack && ctx.rng.next() < share) {
      if (attack.vector === "udp-amplification") {
        const port = attack.reflectorPort ?? 123;
        lines.push(`${time2} IP ${randomIp(ctx.rng)}.${port} > ${attackTarget}.${ctx.rng.int(1024, 65535)}: ${amplificationPayload(port, ctx.rng)}`);
      } else if (attack.vector === "syn-flood") {
        lines.push(`${time2} IP ${randomIp(ctx.rng)}.${ctx.rng.int(1024, 65535)} > ${attackTarget}.443: Flags [S], seq ${ctx.rng.int(1e8, 4e9)}, win 64240, length 0`);
      } else {
        lines.push(`${time2} IP ${randomIp(ctx.rng, 40)}.${ctx.rng.int(1024, 65535)} > ${attackTarget}.443: Flags [P.], seq 1:518, ack 1, win 502, length 517`);
      }
    } else {
      const flags = ctx.rng.pick(["[P.]", "[.]", "[P.]", "[S.]", "[F.]"]);
      const length = flags === "[P.]" ? ctx.rng.int(80, 1448) : 0;
      lines.push(`${time2} IP ${target}.443 > ${randomIp(ctx.rng)}.${ctx.rng.int(1024, 65535)}: Flags ${flags}, ack ${ctx.rng.int(1, 9e5)}, win 501, length ${length}`);
    }
  }
  const dropped = attack && attack.targetState !== "ok" ? ctx.rng.int(2e4, 4e5) : 0;
  lines.push(`${count2} packets captured`, `${count2 + dropped + ctx.rng.int(0, 40)} packets received by filter`, `${dropped} packets dropped by kernel`);
  if (reflector && attack) lines.push("", `Auff\xE4llig: alle Pakete stammen von Quellport ${reflector.port} (${reflector.service}).`);
  return lines;
}
function amplificationPayload(port, rng) {
  switch (port) {
    case 53:
      return `${rng.int(1e3, 65e3)} 32/0/1 ANY (${rng.int(3e3, 4e3)})`;
    case 123:
      return "NTPv2, Reserved, length 468";
    case 389:
      return `UDP, length ${rng.int(2800, 3100)}`;
    case 1900:
      return `UDP, length ${rng.int(280, 340)}`;
    default:
      return "UDP, length 1400";
  }
}
function kernelLog(ctx) {
  const hardening = ctx.server.hardening ?? emptyHardening();
  const attack = felt(ctx);
  const uptimeSec = Math.max(60, (ctx.world.meta.tick - ctx.server.purchasedAtTick) * 3600);
  const stamp = (offset) => `[${(uptimeSec + offset).toFixed(6).padStart(14)}]`;
  const lines = [
    `${stamp(-86e3)} EXT4-fs (nvme0n1p2): mounted filesystem with ordered data mode.`,
    `${stamp(-85990)} eth0: Link is Up - ${serverNicMbps(ctx.server) >= 1e3 ? `${serverNicMbps(ctx.server) / 1e3}Gbps` : `${serverNicMbps(ctx.server)}Mbps`}/Full`
  ];
  if (!attack) return lines;
  if (attack.vector === "syn-flood") {
    lines.push(
      `${stamp(-30)} TCP: request_sock_TCP: Possible SYN flooding on port 0.0.0.0:443. ${hardening.synCookies ? "Sending cookies." : "Dropping request."}  Check SNMP counters.`
    );
  } else if (attack.vector === "udp-amplification") {
    lines.push(`${stamp(-40)} nf_conntrack: nf_conntrack: table full, dropping packet`);
    lines.push(`${stamp(-12)} net_ratelimit: ${ctx.rng.int(800, 9e3)} callbacks suppressed`);
  } else {
    lines.push(`${stamp(-25)} TCP: too many orphaned sockets`);
  }
  if (attack.vector !== "http-flood" && deliveredGbps(ctx) >= serverNicMbps(ctx.server) / 1e3 * 0.95) {
    lines.push(`${stamp(-3)} eth0: rx queue overrun, ${ctx.rng.int(1e5, 9e5)} packets dropped`);
  }
  return lines;
}
function serviceLog(ctx) {
  const attack = felt(ctx);
  const time2 = clock(ctx.world.meta.date);
  const lines = [`${time2} ${ctx.server.name} systemd[1]: Started nginx.service - A high performance web server.`];
  if (attack?.vector === "http-flood" && attack.targetState === "down") {
    lines.push(`${time2} ${ctx.server.name} nginx[812]: [alert] 1024 worker_connections are not enough`);
    lines.push(`${time2} ${ctx.server.name} php-fpm[901]: [WARNING] [pool www] server reached pm.max_children setting (50)`);
  }
  return lines;
}
var ACCESS_LOG = /\/var\/log\/(nginx|apache2|httpd)\/access\.log/;
function readFile(ctx, args) {
  const path = args.filter((a) => !a.startsWith("-") && !/^\d+$/.test(a)).pop();
  if (!path) return ["Dateiname fehlt, z. B. tail /var/log/nginx/access.log"];
  if (path === "/proc/sys/net/ipv4/tcp_syncookies") return [(ctx.server.hardening?.synCookies ? 1 : 0).toString()];
  if (path === "/proc/loadavg") return [`${loadAverage(ctx).toFixed(2)} ${(loadAverage(ctx) * 0.85).toFixed(2)} ${(loadAverage(ctx) * 0.6).toFixed(2)} 3/412 31337`];
  if (path === "/var/log/kern.log") return kernelLog(ctx);
  if (!ACCESS_LOG.test(path)) return [`${path}: Datei nicht gefunden oder in der Simulation nicht vorhanden.`];
  const attack = felt(ctx);
  const nArg = args.indexOf("-n");
  const count2 = Math.min(40, Math.max(1, nArg >= 0 ? Number(args[nArg + 1]) || 10 : 10));
  const date = new Date(ctx.world.meta.date);
  const stamp = `${String(date.getUTCDate()).padStart(2, "0")}/${date.toLocaleString("en-US", { month: "short", timeZone: "UTC" })}/${date.getUTCFullYear()}:${clock(ctx.world.meta.date)} +0000`;
  const pages = ["/", "/index.php", "/kontakt", "/wp-content/themes/main/style.css", "/blog/", "/shop/warenkorb", "/favicon.ico"];
  const agents = [
    "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0 Safari/537.36",
    "Mozilla/5.0 (iPhone; CPU iPhone OS 17_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.6 Mobile/15E148 Safari/604.1",
    "Mozilla/5.0 (X11; Linux x86_64; rv:131.0) Gecko/20100101 Firefox/131.0",
    "Mozilla/5.0 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)"
  ];
  const flooders = Array.from({ length: 6 }, () => randomIp(ctx.rng, 40));
  const lines = [];
  for (let i = 0; i < count2; i++) {
    if (attack?.vector === "http-flood" && ctx.rng.next() < 0.85) {
      const status = attack.targetState === "down" ? ctx.rng.pick([499, 502, 504]) : 429;
      lines.push(
        `${ctx.rng.pick(flooders)} - - [${stamp}] "GET /?${ctx.rng.int(1e6, 9e6).toString(36)}=${ctx.rng.int(1e6, 9e6).toString(36)} HTTP/1.1" ${status} 0 "-" "Mozilla/5.0 (Windows NT 6.1; WOW64; Trident/7.0; rv:11.0) like Gecko"`
      );
    } else {
      lines.push(`${randomIp(ctx.rng)} - - [${stamp}] "GET ${ctx.rng.pick(pages)} HTTP/2.0" 200 ${ctx.rng.int(300, 48e3)} "-" "${ctx.rng.pick(agents)}"`);
    }
  }
  return lines;
}
function systemctl(ctx, args) {
  const [action, unit = ""] = args;
  const service = unit.replace(/\.service$/, "");
  const known = ["nginx", "php-fpm", "php8.2-fpm", "mariadb", "mysql", "sshd", "ssh"];
  if (!action) return ["systemctl: Aktion fehlt, z. B. systemctl status nginx"];
  if (!known.includes(service)) return [`Unit ${unit || "(leer)"}.service could not be found.`];
  const attack = felt(ctx);
  const flooded = attack?.vector === "http-flood" && attack.targetState === "down" && (service === "nginx" || service.startsWith("php"));
  if (action === "restart" || action === "reload") {
    return flooded ? ["", `${service} neu gestartet \u2013 nach wenigen Sekunden ist er wieder voll ausgelastet. Die Ursache sitzt davor.`] : [];
  }
  if (action !== "status") return [`systemctl ${action}: in der Simulation nicht vorgesehen.`];
  return [
    `\u25CF ${service}.service`,
    `     Loaded: loaded (/lib/systemd/system/${service}.service; enabled)`,
    `     Active: active (running) since ${formatDate(ctx.world.meta.date)}`,
    ...flooded ? [`${clock(ctx.world.meta.date)} ${ctx.server.name} ${service}: [alert] worker_connections are not enough, ${ctx.rng.int(5e3, 4e4)} requests queued`] : []
  ];
}
function hardeningFor(server) {
  server.hardening ??= emptyHardening();
  return server.hardening;
}
function sysctl(ctx, args) {
  const expr = args.filter((a) => a !== "-w" && a !== "-q").join("");
  if (args.includes("-a")) {
    return {
      output: [
        "net.core.somaxconn = 4096",
        "net.ipv4.tcp_max_syn_backlog = 512",
        `net.ipv4.tcp_syncookies = ${ctx.server.hardening?.synCookies ? 1 : 0}`,
        "net.ipv4.tcp_synack_retries = 5"
      ]
    };
  }
  const [key, value] = expr.split("=");
  if (key !== "net.ipv4.tcp_syncookies") {
    return { output: [key ? `sysctl: cannot stat /proc/sys/${key.replace(/\./g, "/")}: In der Simulation nicht vorhanden` : "sysctl: Schl\xFCssel fehlt, z. B. sysctl net.ipv4.tcp_syncookies"] };
  }
  if (value === void 0) return { output: [`net.ipv4.tcp_syncookies = ${ctx.server.hardening?.synCookies ? 1 : 0}`] };
  if (value !== "0" && value !== "1" && value !== "2") return { output: [`sysctl: setting key "net.ipv4.tcp_syncookies": Invalid argument`] };
  const enable = value !== "0";
  const hardening = hardeningFor(ctx.server);
  const changed = hardening.synCookies !== enable;
  hardening.synCookies = enable;
  return {
    output: [`net.ipv4.tcp_syncookies = ${value}`],
    change: changed ? `${ctx.server.name}: SYN-Cookies ${enable ? "aktiviert" : "abgeschaltet"}.` : void 0
  };
}
function parseRule(args) {
  const after = (flag) => {
    const i = args.indexOf(flag);
    return i >= 0 ? args[i + 1] ?? null : null;
  };
  const port = (value) => value && /^\d+$/.test(value) ? Number(value) : null;
  return {
    protocol: after("-p") ?? after("--protocol"),
    sport: port(after("--sport") ?? after("--source-port")),
    dport: port(after("--dport") ?? after("--destination-port")) ?? (after("--dports") ? 443 : null),
    source: after("-s") ?? after("--source"),
    target: (after("-j") ?? after("--jump"))?.toUpperCase() ?? null,
    limited: ["connlimit", "hashlimit", "limit"].some((m) => args.includes(m))
  };
}
function iptables(ctx, args) {
  const hardening = ctx.server.hardening ?? emptyHardening();
  if (args.length === 0 || args.includes("-L") || args.includes("--list") || args.includes("-S")) {
    return { output: listRules(hardening) };
  }
  if (args.includes("-F") || args.includes("--flush")) {
    const had = hardening.udpDropPorts.length > 0 || hardening.httpRateLimit;
    const target = hardeningFor(ctx.server);
    target.udpDropPorts = [];
    target.httpRateLimit = false;
    return { output: [], change: had ? `${ctx.server.name}: Paketfilter geleert.` : void 0 };
  }
  const append = args.includes("-A") || args.includes("-I") || args.includes("--append") || args.includes("--insert");
  const remove = args.includes("-D") || args.includes("--delete");
  if (!append && !remove) return { output: ["iptables: Aktion fehlt. Beispiele stehen unter \u201Ehelp\u201C."] };
  if (!args.includes("INPUT")) return { output: ["Diese Konsole verwaltet nur die Kette INPUT."] };
  const rule = parseRule(args);
  const dropping = rule.target === "DROP" || rule.target === "REJECT";
  if (rule.protocol === "udp" && rule.sport !== null && dropping) {
    const target = hardeningFor(ctx.server);
    const has = target.udpDropPorts.includes(rule.sport);
    if (append && !has) target.udpDropPorts.push(rule.sport);
    if (remove && has) target.udpDropPorts = target.udpDropPorts.filter((p) => p !== rule.sport);
    if (remove && !has) return { output: ["iptables: Bad rule (does a matching rule exist in that chain?)."] };
    return { output: [], change: append === has ? void 0 : `${ctx.server.name}: UDP-Quellport ${rule.sport} ${append ? "wird verworfen" : "wieder erlaubt"}.` };
  }
  if (rule.protocol === "udp" && dropping) {
    return {
      output: [
        "Abgelehnt: Ohne --sport verwirft die Regel jeden UDP-Verkehr \u2013 auch DNS-Antworten und NTP f\xFCr den Server selbst.",
        "Gib den Quellport der Reflektoren an, z. B.: iptables -A INPUT -p udp --sport 123 -j DROP"
      ]
    };
  }
  if (rule.protocol === "tcp" && (rule.dport === 80 || rule.dport === 443) && dropping) {
    if (!rule.limited) {
      return {
        output: [
          `Abgelehnt: Diese Regel sperrt alle Besucher auf Port ${rule.dport} aus \u2013 auch die echten.`,
          `Begrenze stattdessen je Quelle, z. B.: iptables -A INPUT -p tcp --dport ${rule.dport} -m connlimit --connlimit-above 50 -j REJECT`
        ]
      };
    }
    const target = hardeningFor(ctx.server);
    const changed = target.httpRateLimit !== append;
    target.httpRateLimit = append;
    return { output: [], change: changed ? `${ctx.server.name}: HTTP-Verbindungsbegrenzung ${append ? "aktiv" : "entfernt"}.` : void 0 };
  }
  if (rule.source && dropping) {
    return {
      output: [
        `Regel f\xFCr ${rule.source} gesetzt.`,
        "Hinweis: Ein verteilter Angriff kommt von Tausenden Adressen \u2013 einzelne Quellen zu sperren hilft dagegen kaum. Die Regel wird nicht gespeichert."
      ]
    };
  }
  return {
    output: [
      "Diese Regel kennt die Simulation nicht. Wirksame Beispiele:",
      "  iptables -A INPUT -p udp --sport 123 -j DROP",
      "  iptables -A INPUT -p tcp --dport 443 -m connlimit --connlimit-above 50 -j REJECT"
    ]
  };
}
function listRules(hardening) {
  const lines = ["Chain INPUT (policy ACCEPT)", "target     prot opt source               destination"];
  for (const port of hardening.udpDropPorts) {
    lines.push(`DROP       udp  --  0.0.0.0/0            0.0.0.0/0            udp spt:${port}`);
  }
  if (hardening.httpRateLimit) {
    lines.push("REJECT     tcp  --  0.0.0.0/0            0.0.0.0/0            multiport dports 80,443 #conn src/32 > 50 reject-with tcp-reset");
  }
  lines.push("", "Chain FORWARD (policy ACCEPT)", "target     prot opt source               destination", "", "Chain OUTPUT (policy ACCEPT)", "target     prot opt source               destination");
  return lines;
}
function tokenize(input) {
  return (input.match(/"[^"]*"|'[^']*'|\S+/g) ?? []).map((t) => t.replace(/^["']|["']$/g, ""));
}
function applyPipes(lines, pipes, command) {
  let out = lines;
  for (const pipe of pipes) {
    const [name, ...rest] = tokenize(pipe);
    if (name === "grep" || name === "egrep") {
      const invert = rest.includes("-v");
      const ignoreCase = rest.includes("-i");
      const countOnly = rest.includes("-c");
      const pattern = rest.filter((a) => !a.startsWith("-")).join(" ");
      const needle = ignoreCase ? pattern.toLowerCase() : pattern;
      const matched = out.filter((l) => (ignoreCase ? l.toLowerCase() : l).includes(needle) !== invert);
      out = countOnly ? [String(matched.length)] : matched;
    } else if (name === "wc" && rest.includes("-l")) {
      out = [String(out.length)];
    } else if (name === "head" || name === "tail") {
      const nArg = rest.indexOf("-n");
      const n = nArg >= 0 ? Number(rest[nArg + 1]) || 10 : Number(rest.find((a) => /^-\d+$/.test(a))?.slice(1)) || 10;
      out = name === "head" ? out.slice(0, n) : out.slice(-n);
    } else if (name === "less" || name === "more" || name === "cat") {
    } else {
      return [`${command}: Pipe nach \u201E${name ?? ""}\u201C wird in dieser Konsole nicht unterst\xFCtzt.`];
    }
  }
  return out;
}
function randomIp(rng, pool) {
  const firstOctets = [5, 23, 31, 37, 45, 62, 77, 81, 89, 91, 103, 109, 117, 141, 154, 176, 185, 188, 193, 195, 212, 217];
  if (pool) {
    const n = rng.int(0, pool - 1);
    return `${firstOctets[n % firstOctets.length]}.${n * 37 % 250}.${n * 91 % 250}.${n * 13 % 250 + 2}`;
  }
  return `${rng.pick(firstOctets)}.${rng.int(0, 255)}.${rng.int(0, 255)}.${rng.int(1, 254)}`;
}
function hash2(text) {
  let h = 2166136261;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

// src/domain/dc/colocation.ts
var PROVIDERS = [
  "Kernwerk Colocation",
  "Nordlicht Datacenter",
  "Meridian Facilities",
  "Steinbruch Rechenzentren",
  "Atlas Colocation",
  "Hafenkante Datacenter",
  "Grundlast Immobilien",
  "Fernblick Facilities"
];
function providerFor(locationKey) {
  let hash3 = 0;
  for (let i = 0; i < locationKey.length; i++) hash3 = hash3 * 31 + locationKey.charCodeAt(i) >>> 0;
  return PROVIDERS[hash3 % PROVIDERS.length];
}
function baseCommittedKw(location) {
  return Math.max(45, Math.floor(location.powerCapacityKw / 8));
}
function maxCommittedKw(location) {
  return Math.max(baseCommittedKw(location) * 2, Math.floor(location.powerCapacityKw / 2));
}
function listRent(location, committedKw) {
  const baseKw = baseCommittedKw(location);
  const baseRent = Math.round(location.monthlyRent * 0.3);
  return Math.round(baseRent / baseKw * committedKw);
}
function footprintFor(location, committedKw) {
  const baseKw = baseCommittedKw(location);
  const scale = committedKw / baseKw;
  return {
    rackCapacity: Math.max(6, Math.round(Math.max(6, Math.floor(location.rackCapacity / 4)) * scale)),
    powerCapacityKw: committedKw,
    coolingCapacityKw: Math.max(40, Math.round(Math.max(40, Math.floor(location.coolingCapacityKw / 8)) * scale))
  };
}
function termClass(termMonths) {
  if (termMonths <= 0) return "none";
  return termMonths <= 12 ? "short" : "long";
}
function quoteColocation(world, location, request) {
  const committedKw = clamp(Math.round(request.committedKw), baseCommittedKw(location), maxCommittedKw(location));
  const termMonths = COLOCATION.TERMS.includes(request.termMonths) ? request.termMonths : 12;
  const prepaidMonths = clamp(Math.round(request.prepaidMonths), 0, COLOCATION.MAX_PREPAID_MONTHS);
  const list = listRent(location, committedKw);
  const breakdown = [];
  if (termMonths <= 0) {
    breakdown.push({ label: "Ohne Bindung", share: -COLOCATION.MONTHLY_SURCHARGE });
  } else {
    breakdown.push({ label: `${termMonths} Monate Bindung`, share: termMonths / 12 * COLOCATION.DISCOUNT_PER_TERM_YEAR });
  }
  if (prepaidMonths > 0) {
    breakdown.push({ label: `${prepaidMonths} Monate im Voraus`, share: prepaidMonths * COLOCATION.DISCOUNT_PER_PREPAID_MONTH });
  }
  const overBase = Math.max(0, committedKw - baseCommittedKw(location));
  if (overBase > 0) {
    breakdown.push({
      label: `${committedKw} kW Zusage`,
      share: Math.min(COLOCATION.MAX_VOLUME_DISCOUNT, overBase * COLOCATION.DISCOUNT_PER_KW_OVER_BASE)
    });
  }
  if (world.company.reputation > 55) {
    breakdown.push({ label: "Ruf am Markt", share: (world.company.reputation - 55) / 45 * 0.05 });
  }
  const discount = breakdown.reduce((sum3, entry) => sum3 + entry.share, 0);
  const floorRent = Math.round(list * COLOCATION.PRICE_FLOOR_SHARE);
  const monthlyRent = Math.max(floorRent, Math.round(list * (1 - discount)));
  const setupCost = Math.round(
    location.setupCost * (committedKw / baseCommittedKw(location)) * (1 - Math.min(0.4, termMonths / 12 * 0.1))
  );
  const klass = termClass(termMonths);
  return {
    termMonths,
    committedKw,
    prepaidMonths,
    monthlyRent,
    noticeMonths: COLOCATION.NOTICE_MONTHS[klass],
    exitPenaltyShare: COLOCATION.EXIT_PENALTY_SHARE[klass],
    setupCost,
    listRent: list,
    discount,
    breakdown,
    floorRent,
    upfront: setupCost + monthlyRent * prepaidMonths
  };
}
var ok6 = (message, extra = {}) => ({ ok: true, message, ...extra });
var fail6 = (message) => ({ ok: false, message });
function startNegotiation(world, rng, input) {
  const location = findLocation(input.locationKey);
  if (!location) return fail6("Standort unbekannt.");
  const datacenterId = input.datacenterId ?? null;
  if (datacenterId && !world.datacenters[datacenterId]) return fail6("Standort nicht gefunden.");
  if (!datacenterId && values(world.datacenters).some((dc) => dc.city === location.city)) {
    return fail6(`In ${location.city} besteht bereits ein Vertrag. F\xFCr bessere Konditionen den bestehenden neu verhandeln.`);
  }
  const running = values(world.negotiations).find((n) => n.state === "open" && n.locationKey === input.locationKey);
  if (running) return fail6(`Mit ${running.providerName} l\xE4uft bereits ein Gespr\xE4ch \xFCber ${location.city}.`);
  const blocked = values(world.negotiations).find(
    (n) => n.locationKey === input.locationKey && n.state === "failed" && world.meta.tick - n.startedAtTick < COLOCATION.COOLDOWN_TICKS
  );
  if (blocked) {
    const days = Math.ceil((blocked.startedAtTick + COLOCATION.COOLDOWN_TICKS - world.meta.tick) / SIM.TICKS_PER_DAY);
    return fail6(`${blocked.providerName} will \xFCber ${location.city} vorerst nicht mehr reden \u2013 in etwa ${days} Tagen wieder versuchen.`);
  }
  const quote = quoteColocation(world, location, input);
  const id = asId(makeId(rng, "neg"));
  const negotiation = {
    id,
    locationKey: location.key,
    city: location.city,
    providerName: providerFor(location.key),
    datacenterId,
    round: 1,
    maxRounds: COLOCATION.MAX_ROUNDS,
    offer: {
      termMonths: quote.termMonths,
      committedKw: quote.committedKw,
      prepaidMonths: quote.prepaidMonths,
      monthlyRent: quote.monthlyRent,
      noticeMonths: quote.noticeMonths,
      exitPenaltyShare: quote.exitPenaltyShare,
      setupCost: quote.setupCost
    },
    listRent: quote.listRent,
    demandedRent: null,
    patience: 1,
    state: "open",
    note: `${quote.committedKw} kW, ` + (quote.termMonths > 0 ? `${quote.termMonths} Monate Laufzeit` : "monatlich k\xFCndbar") + `. Angebot ${quote.monthlyRent.toLocaleString("de-DE")} \u20AC im Monat.`,
    startedAtTick: world.meta.tick,
    expiresAtTick: world.meta.tick + COLOCATION.OFFER_VALID_TICKS
  };
  world.negotiations[id] = negotiation;
  return ok6(`${negotiation.providerName} legt ein Angebot f\xFCr ${location.city} vor: ${quote.monthlyRent.toLocaleString("de-DE")} \u20AC/Monat.`, {
    negotiationId: id
  });
}
function counterNegotiation(world, rng, input) {
  const negotiation = world.negotiations[input.negotiationId];
  if (!negotiation) return fail6("Gespr\xE4ch nicht gefunden.");
  if (negotiation.state !== "open") return fail6("Dieses Gespr\xE4ch ist abgeschlossen.");
  if (negotiation.round >= negotiation.maxRounds) {
    return fail6(`${negotiation.providerName} verhandelt nicht weiter \u2013 annehmen oder abbrechen.`);
  }
  const location = findLocation(negotiation.locationKey);
  if (!location) return fail6("Standort unbekannt.");
  negotiation.round += 1;
  if (input.terms && (input.terms.termMonths !== void 0 || input.terms.committedKw !== void 0 || input.terms.prepaidMonths !== void 0)) {
    const quote = quoteColocation(world, location, {
      termMonths: input.terms.termMonths ?? negotiation.offer.termMonths,
      committedKw: input.terms.committedKw ?? negotiation.offer.committedKw,
      prepaidMonths: input.terms.prepaidMonths ?? negotiation.offer.prepaidMonths
    });
    negotiation.offer = {
      termMonths: quote.termMonths,
      committedKw: quote.committedKw,
      prepaidMonths: quote.prepaidMonths,
      monthlyRent: quote.monthlyRent,
      noticeMonths: quote.noticeMonths,
      exitPenaltyShare: quote.exitPenaltyShare,
      setupCost: quote.setupCost
    };
    negotiation.listRent = quote.listRent;
    negotiation.patience = Math.max(0.15, negotiation.patience - 0.15);
    negotiation.note = `Neue Grundlage: ${quote.committedKw} kW, ${quote.termMonths > 0 ? `${quote.termMonths} Monate` : "monatlich"}. ${quote.monthlyRent.toLocaleString("de-DE")} \u20AC/Monat.`;
    return ok6(negotiation.note, { negotiationId: negotiation.id });
  }
  const floor = Math.round(negotiation.listRent * COLOCATION.PRICE_FLOOR_SHARE);
  const current = negotiation.offer.monthlyRent;
  const demanded = Math.round(input.demandedRent ?? current * 0.9);
  negotiation.demandedRent = demanded;
  if (demanded >= current) {
    negotiation.patience = Math.max(0, negotiation.patience - 0.2);
    negotiation.note = "Das war kein Gegenangebot. Der Preis bleibt.";
    return ok6(negotiation.note, { negotiationId: negotiation.id });
  }
  if (demanded < floor * 0.85) {
    negotiation.state = "failed";
    negotiation.patience = 0;
    negotiation.note = `${negotiation.providerName} bricht ab: \u201EZu diesem Preis vermieten wir keine Fl\xE4che.\u201C`;
    return fail6(negotiation.note);
  }
  const target = Math.max(floor, demanded);
  const gap = current - target;
  const jitter = 0.8 + rng.next() * 0.4;
  const concession = gap * COLOCATION.CONCESSION_SHARE * negotiation.patience * jitter;
  const newRent = Math.max(floor, Math.round(current - concession));
  const greed = (current - demanded) / Math.max(1, current);
  negotiation.patience = clamp(negotiation.patience - (0.18 + greed * 1.2), 0, 1);
  negotiation.offer.monthlyRent = newRent;
  if (negotiation.patience <= 0) {
    negotiation.state = "failed";
    negotiation.note = `${negotiation.providerName} bleibt bei ${newRent.toLocaleString("de-DE")} \u20AC und beendet das Gespr\xE4ch.`;
    return fail6(negotiation.note);
  }
  const atFloor = newRent <= floor;
  negotiation.note = atFloor ? `${newRent.toLocaleString("de-DE")} \u20AC/Monat \u2013 \u201Emehr geht nicht, das ist unser Selbstkostenpreis.\u201C` : `${newRent.toLocaleString("de-DE")} \u20AC/Monat, Runde ${negotiation.round} von ${negotiation.maxRounds}.`;
  return ok6(negotiation.note, { negotiationId: negotiation.id });
}
function abortNegotiation(world, negotiationId) {
  const negotiation = world.negotiations[negotiationId];
  if (!negotiation) return fail6("Gespr\xE4ch nicht gefunden.");
  if (negotiation.state !== "open") return fail6("Dieses Gespr\xE4ch ist bereits abgeschlossen.");
  negotiation.state = "failed";
  negotiation.note = "Vom Betreiber abgebrochen.";
  return ok6(`Gespr\xE4ch \xFCber ${negotiation.city} abgebrochen.`);
}
function acceptNegotiation(world, rng, negotiationId, spend2) {
  const negotiation = world.negotiations[negotiationId];
  if (!negotiation) return fail6("Gespr\xE4ch nicht gefunden.");
  if (negotiation.state !== "open") return fail6("Dieses Angebot steht nicht mehr.");
  if (world.meta.tick > negotiation.expiresAtTick) {
    negotiation.state = "expired";
    return fail6("Das Angebot ist abgelaufen.");
  }
  const location = findLocation(negotiation.locationKey);
  if (!location) return fail6("Standort unbekannt.");
  const offer = negotiation.offer;
  const upfront = offer.setupCost + offer.monthlyRent * offer.prepaidMonths;
  const contract = {
    providerName: negotiation.providerName,
    termMonths: offer.termMonths,
    committedKw: offer.committedKw,
    prepaidMonths: offer.prepaidMonths,
    monthlyRent: offer.monthlyRent,
    noticeMonths: offer.noticeMonths,
    exitPenaltyShare: offer.exitPenaltyShare,
    signedAtTick: world.meta.tick,
    termEndsAtTick: world.meta.tick + offer.termMonths * SIM.TICKS_PER_MONTH,
    listRent: negotiation.listRent,
    notice: null
  };
  if (negotiation.datacenterId) {
    const dc = world.datacenters[negotiation.datacenterId];
    if (!dc) return fail6("Standort nicht gefunden.");
    const footprint2 = footprintFor(location, offer.committedKw);
    const racksInUse = values(world.racks).filter((rack) => rack.datacenterId === dc.id).length;
    if (footprint2.rackCapacity < racksInUse) {
      return fail6(
        `${offer.committedKw} kW reichen nur f\xFCr ${footprint2.rackCapacity} Rackpl\xE4tze, belegt sind ${racksInUse}. Erst Racks zur\xFCckgeben, dann kleiner mieten.`
      );
    }
    const installedKw = [...values(world.servers), ...values(world.routers), ...values(world.switches), ...values(world.firewalls), ...values(world.loadBalancers)].filter((device) => device.datacenterId === dc.id).reduce((sum3, device) => sum3 + device.maxWatt, 0) / 1e3;
    if (footprint2.powerCapacityKw < installedKw) {
      return fail6(
        `Die Ger\xE4te am Standort ziehen bis zu ${Math.ceil(installedKw)} kW \u2013 eine Zusage \xFCber ${offer.committedKw} kW deckt das nicht.`
      );
    }
    if (upfront > 0 && !spend2(upfront, `Neuer Standortvertrag ${dc.city}`)) {
      return fail6(`Nicht gen\xFCgend Kapital (${upfront.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
    }
    const expansionKw = Math.max(0, dc.powerCapacityKw - dc.contract.committedKw);
    dc.monthlyRent = Math.max(0, dc.monthlyRent - dc.contract.monthlyRent + contract.monthlyRent);
    dc.powerCapacityKw = footprint2.powerCapacityKw + expansionKw;
    dc.rackCapacity = footprint2.rackCapacity;
    dc.contract = contract;
    negotiation.state = "accepted";
    return ok6(
      `Neuer Vertrag f\xFCr ${dc.city}: ${offer.monthlyRent.toLocaleString("de-DE")} \u20AC/Monat, ` + (offer.termMonths > 0 ? `${offer.termMonths} Monate Laufzeit` : "monatlich k\xFCndbar") + `. Gegen\xFCber der Liste ${Math.round((1 - offer.monthlyRent / negotiation.listRent) * 100)} % gespart.`,
      { datacenterId: dc.id }
    );
  }
  if (values(world.datacenters).some((dc) => dc.city === location.city)) {
    return fail6(`In ${location.city} existiert bereits ein Standort.`);
  }
  if (!spend2(upfront, `Standortvertrag ${location.city}`)) {
    return fail6(`Nicht gen\xFCgend Kapital (${upfront.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
  }
  const footprint = footprintFor(location, offer.committedKw);
  const id = asId(makeId(rng, "dc"));
  world.datacenters[id] = {
    id,
    name: `${world.company.name} ${location.city}`,
    city: location.city,
    country: location.country,
    position: location.position,
    rackCapacity: footprint.rackCapacity,
    powerCapacityKw: footprint.powerCapacityKw,
    coolingCapacityKw: footprint.coolingCapacityKw,
    pue: location.pue,
    powerPricePerKwh: location.powerPricePerKwh,
    monthlyRent: contract.monthlyRent,
    generator: { installed: false, runtimeHours: 0, fuelPercent: 0 },
    powerFeeds: { count: 1, monthlyCost: 0 },
    carriers: location.carriers,
    ambientTempC: location.ambientTempC,
    utilityPower: true,
    builtAtTick: world.meta.tick,
    contract
  };
  negotiation.state = "accepted";
  return ok6(
    `Standort ${location.city} unter Vertrag: ${offer.committedKw} kW f\xFCr ${offer.monthlyRent.toLocaleString("de-DE")} \u20AC/Monat` + (offer.termMonths > 0 ? ` \xFCber ${offer.termMonths} Monate.` : ", monatlich k\xFCndbar."),
    { datacenterId: id }
  );
}
function quoteNotice(world, datacenterId, mode) {
  const empty = {
    ok: false,
    effectiveAtTick: 0,
    ticksUntil: 0,
    penalty: 0,
    mode,
    early: mode !== "term",
    termBuyout: 0,
    noticeBuyout: 0,
    devices: 0,
    racks: 0,
    contracts: 0
  };
  const dc = world.datacenters[datacenterId];
  if (!dc) return { ...empty, error: "Standort nicht gefunden." };
  if (dc.contract.notice) return { ...empty, error: "Dieser Standort ist bereits gek\xFCndigt." };
  const noticeEnd = world.meta.tick + dc.contract.noticeMonths * SIM.TICKS_PER_MONTH;
  const effectiveAtTick = mode === "immediate" ? world.meta.tick : mode === "early" ? noticeEnd : Math.max(noticeEnd, dc.contract.termEndsAtTick);
  const remainingTicks = Math.max(0, dc.contract.termEndsAtTick - effectiveAtTick);
  const remainingMonths = remainingTicks / SIM.TICKS_PER_MONTH;
  const termBuyout = mode === "term" ? 0 : money(remainingMonths * dc.contract.monthlyRent * dc.contract.exitPenaltyShare);
  const noticeBuyout = mode === "immediate" ? money(dc.contract.noticeMonths * dc.contract.monthlyRent) : 0;
  const penalty = termBuyout + noticeBuyout;
  const inventory = describeSite(world, datacenterId);
  return {
    ok: true,
    effectiveAtTick,
    ticksUntil: effectiveAtTick - world.meta.tick,
    penalty,
    mode,
    early: mode !== "term",
    termBuyout,
    noticeBuyout,
    devices: inventory.devices,
    racks: inventory.racks,
    contracts: inventory.contracts
  };
}
function describeSite(world, datacenterId) {
  const devices = values(world.servers).filter((d) => d.datacenterId === datacenterId).length + values(world.routers).filter((d) => d.datacenterId === datacenterId).length + values(world.switches).filter((d) => d.datacenterId === datacenterId).length + values(world.firewalls).filter((d) => d.datacenterId === datacenterId).length + values(world.loadBalancers).filter((d) => d.datacenterId === datacenterId).length + values(world.upsUnits).filter((d) => d.datacenterId === datacenterId).length;
  let contracts = 0;
  for (const server of values(world.servers)) {
    if (server.datacenterId !== datacenterId) continue;
    contracts += server.contractIds.filter((id) => world.contracts[id]?.state !== "cancelled").length;
    contracts += server.vpsIds.filter((id) => world.vpsInstances[id]).length;
  }
  return { devices, racks: values(world.racks).filter((r) => r.datacenterId === datacenterId).length, contracts };
}
function giveNotice(world, datacenterId, mode, spend2) {
  const quote = quoteNotice(world, datacenterId, mode);
  if (!quote.ok) return fail6(quote.error);
  const dc = world.datacenters[datacenterId];
  if (quote.penalty > 0 && !spend2(quote.penalty, `Vorzeitiger Ausstieg ${dc.city}`)) {
    return fail6(`Nicht gen\xFCgend Kapital f\xFCr die Ausstiegszahlung (${quote.penalty.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
  }
  dc.contract.notice = {
    givenAtTick: world.meta.tick,
    effectiveAtTick: quote.effectiveAtTick,
    early: quote.early,
    penaltyPaid: quote.penalty
  };
  if (mode === "immediate") {
    return ok6(
      `${dc.name} zum sofortigen Ausstieg gek\xFCndigt (${quote.penalty.toLocaleString("de-DE")} \u20AC: ${quote.termBuyout.toLocaleString("de-DE")} \u20AC Restlaufzeit, ${quote.noticeBuyout.toLocaleString("de-DE")} \u20AC Frist).` + (quote.devices > 0 ? ` ${quote.devices} Ger\xE4te stehen noch dort \u2013 sie gehen mit dem Standort an ${dc.contract.providerName}.` : "")
    );
  }
  const days = Math.round(quote.ticksUntil / SIM.TICKS_PER_DAY);
  return ok6(
    `${dc.name} gek\xFCndigt zum ${days}. Tag von heute an` + (quote.penalty > 0 ? ` (${quote.penalty.toLocaleString("de-DE")} \u20AC Ausstiegszahlung).` : ".") + (quote.devices > 0 ? ` ${quote.devices} Ger\xE4te m\xFCssen bis dahin umgezogen oder abgegeben sein \u2013 was stehen bleibt, r\xE4umt ${dc.contract.providerName} auf eigene Rechnung.` : "")
  );
}
function withdrawNotice(world, datacenterId) {
  const dc = world.datacenters[datacenterId];
  if (!dc) return fail6("Standort nicht gefunden.");
  if (!dc.contract.notice) return fail6("Dieser Standort ist nicht gek\xFCndigt.");
  const paid = dc.contract.notice.penaltyPaid;
  dc.contract.notice = null;
  return ok6(
    `K\xFCndigung f\xFCr ${dc.name} zur\xFCckgenommen.` + (paid > 0 ? ` Die Ausstiegszahlung von ${paid.toLocaleString("de-DE")} \u20AC erstattet ${dc.contract.providerName} nicht.` : "")
  );
}
function closeDatacenter(world, datacenterId, credit) {
  const dc = world.datacenters[datacenterId];
  const report = { city: dc?.city ?? "", devicesSalvaged: 0, proceeds: 0, fees: 0, contractsLost: 0 };
  if (!dc) return report;
  for (const server of values(world.servers)) {
    if (server.datacenterId !== datacenterId) continue;
    for (const contractId of [...server.contractIds]) {
      if (world.contracts[contractId] && world.contracts[contractId].state !== "cancelled") {
        terminateContract(world, contractId);
        report.contractsLost += 1;
      }
    }
    for (const vpsId of [...server.vpsIds]) {
      const vps = world.vpsInstances[vpsId];
      if (!vps) continue;
      if (vps.contractId && world.contracts[vps.contractId]?.state !== "cancelled") {
        terminateContract(world, vps.contractId);
        report.contractsLost += 1;
      }
      dropMigrationsFor(world, "vps", vpsId);
      delete world.vpsInstances[vpsId];
    }
  }
  for (const link of values(world.links)) {
    if (link.a.datacenterId !== datacenterId && link.b.datacenterId !== datacenterId) continue;
    for (const router of values(world.routers)) {
      for (const port of router.ports) {
        if (port.linkId === link.id) {
          port.linkId = null;
          port.description = "";
        }
      }
      router.bgp.neighbors = router.bgp.neighbors.filter((n) => n.linkId !== link.id);
    }
    delete world.links[link.id];
  }
  const salvage = (device) => Math.round(residualValue(world, device) * COLOCATION.EVICTION_SALVAGE_SHARE);
  const stores = [world.servers, world.routers, world.switches, world.firewalls, world.loadBalancers, world.upsUnits];
  for (const store of stores) {
    for (const device of Object.values(store)) {
      if (device.datacenterId !== datacenterId) continue;
      report.proceeds += salvage(device);
      report.fees += COLOCATION.EVICTION_FEE_PER_DEVICE;
      report.devicesSalvaged += 1;
      delete store[device.id];
    }
  }
  for (const server of values(world.servers)) {
    if (server.uplink && !world.switches[server.uplink.switchId]) server.uplink = null;
  }
  for (const contract of values(world.contracts)) {
    if (contract.serverId && !world.servers[contract.serverId]) contract.serverId = null;
  }
  for (const balancer of values(world.loadBalancers)) {
    for (const pool of balancer.pools) {
      pool.members = pool.members.filter((member) => world.servers[member.serverId]);
    }
  }
  for (const rack of values(world.racks)) {
    if (rack.datacenterId === datacenterId) delete world.racks[rack.id];
  }
  delete world.inventory[datacenterId];
  delete world.datacenters[datacenterId];
  const net = report.proceeds - report.fees;
  if (net !== 0) {
    credit(net, `R\xE4umung ${report.city}: ${report.devicesSalvaged} Ger\xE4te verwertet`);
  }
  return report;
}
function advanceColocation(world, credit) {
  const result = { messages: [], closed: [] };
  const now = world.meta.tick;
  for (const dc of values(world.datacenters)) {
    const contract = dc.contract;
    if (!contract) continue;
    if (contract.notice) {
      const left = contract.notice.effectiveAtTick - now;
      if (left === SIM.TICKS_PER_DAY * 7 || left === SIM.TICKS_PER_DAY) {
        const site = describeSite(world, dc.id);
        if (site.devices > 0) {
          result.messages.push({
            text: `${dc.name} wird in ${Math.round(left / SIM.TICKS_PER_DAY)} ${left === SIM.TICKS_PER_DAY ? "Tag" : "Tagen"} ger\xE4umt. Dort stehen noch ${site.devices} Ger\xE4te` + (site.contracts > 0 ? ` mit ${site.contracts} Kundendiensten` : "") + ".",
            severity: "warning",
            datacenterId: dc.id
          });
        }
      }
      if (left <= 0) {
        const site = describeSite(world, dc.id);
        const closure = closeDatacenter(world, dc.id, credit);
        result.closed.push(closure);
        if (site.devices > 0) {
          world.company.reputation = clamp(
            world.company.reputation - (closure.contractsLost > 0 ? COLOCATION.EVICTION_REPUTATION_COST : 3),
            0,
            100
          );
          result.messages.push({
            text: `${closure.city}: Der Vertrag ist ausgelaufen, ${closure.devicesSalvaged} zur\xFCckgelassene Ger\xE4te wurden verwertet (${Math.round(closure.proceeds - closure.fees).toLocaleString("de-DE")} \u20AC netto)` + (closure.contractsLost > 0 ? `, ${closure.contractsLost} Kundenvertr\xE4ge sind damit beendet.` : "."),
            severity: closure.contractsLost > 0 ? "error" : "warning"
          });
        } else {
          result.messages.push({ text: `${closure.city}: Standort ordnungsgem\xE4\xDF \xFCbergeben, der Vertrag ist beendet.`, severity: "info" });
        }
        continue;
      }
    }
    if (contract.termMonths > 0 && now >= contract.termEndsAtTick) {
      const before = contract.monthlyRent;
      const after = contract.listRent;
      dc.monthlyRent = Math.max(0, dc.monthlyRent - before + after);
      contract.monthlyRent = after;
      contract.termMonths = 0;
      contract.noticeMonths = COLOCATION.NOTICE_MONTHS.none;
      contract.exitPenaltyShare = COLOCATION.EXIT_PENALTY_SHARE.none;
      contract.termEndsAtTick = now;
      result.messages.push({
        text: `${dc.name}: Die Mindestlaufzeit ist abgelaufen. Der Vertrag l\xE4uft monatlich weiter, die Miete steigt von ${before.toLocaleString("de-DE")} \u20AC auf ${after.toLocaleString("de-DE")} \u20AC. Neu verhandeln oder mit einem Monat Frist k\xFCndigen.`,
        severity: "warning",
        datacenterId: dc.id
      });
    }
  }
  for (const negotiation of values(world.negotiations)) {
    if (negotiation.state !== "open") continue;
    if (now <= negotiation.expiresAtTick) continue;
    negotiation.state = "expired";
    result.messages.push({
      text: `Das Angebot von ${negotiation.providerName} f\xFCr ${negotiation.city} ist abgelaufen.`,
      severity: "info"
    });
  }
  return result;
}
function pruneNegotiations(world) {
  let removed = 0;
  for (const negotiation of values(world.negotiations)) {
    if (negotiation.state === "open") continue;
    if (world.meta.tick - negotiation.startedAtTick < COLOCATION.OFFER_VALID_TICKS) continue;
    delete world.negotiations[negotiation.id];
    removed += 1;
  }
  return removed;
}
function isUnderNotice(dc) {
  return dc.contract?.notice != null;
}

// src/domain/dc/relocation.ts
var RUNNING2 = ["packing", "transit", "install"];
var ok7 = (message, transportId) => ({ ok: true, message, transportId });
var fail7 = (message) => ({ ok: false, message });
function storeOf(world, kind) {
  switch (kind) {
    case "server":
      return world.servers;
    case "router":
      return world.routers;
    case "switch":
      return world.switches;
    case "firewall":
      return world.firewalls;
    case "loadbalancer":
      return world.loadBalancers;
    case "ups":
      return world.upsUnits;
  }
}
function deviceOf2(world, kind, id) {
  return storeOf(world, kind)[id];
}
function siteDistanceKm(world, from, to) {
  const a = world.datacenters[from];
  const b = world.datacenters[to];
  if (!a || !b) return 0;
  return distanceKm(a.position, b.position);
}
function estimateTransport(world, input) {
  const empty = {
    ok: false,
    distanceKm: 0,
    cost: 0,
    ticks: 0,
    packTicks: RELOCATION.PACK_TICKS,
    transitTicks: 0,
    installTicks: RELOCATION.INSTALL_TICKS,
    damageRisk: 0,
    residualValue: 0
  };
  const device = deviceOf2(world, input.kind, input.id);
  if (!device) return { ...empty, error: "Ger\xE4t nicht gefunden." };
  const rack = world.racks[input.targetRackId];
  if (!rack) return { ...empty, error: "Zielrack nicht gefunden." };
  const km = siteDistanceKm(world, device.datacenterId, rack.datacenterId);
  const transitTicks = Math.max(1, Math.ceil(km / RELOCATION.KM_PER_TICK));
  const cost = Math.round(
    RELOCATION.BASE_FEE + km * RELOCATION.PER_KM_PER_UNIT * device.heightUnits + RELOCATION.HANDLING_PER_UNIT * device.heightUnits
  );
  const damageRisk = clamp(
    (RELOCATION.DAMAGE_RISK_BASE + km / 1e3 * RELOCATION.DAMAGE_RISK_PER_1000KM) * (2 - device.health),
    0,
    0.35
  );
  return {
    ok: true,
    distanceKm: Math.round(km),
    cost,
    ticks: RELOCATION.PACK_TICKS + transitTicks + RELOCATION.INSTALL_TICKS,
    packTicks: RELOCATION.PACK_TICKS,
    transitTicks,
    installTicks: RELOCATION.INSTALL_TICKS,
    damageRisk,
    // Der Zeitwert kommt aus derselben Funktion wie beim Verkauf: Die Frage
    // „fahren oder verkaufen?“ darf nicht von zwei Formeln beantwortet werden.
    residualValue: residualValue(world, device)
  };
}
function checkTransportable(world, kind, id) {
  const device = deviceOf2(world, kind, id);
  if (!device) return { ok: false, reason: "Ger\xE4t nicht gefunden." };
  if (device.rackId === null) {
    return { ok: false, reason: `${device.name} ist eine zentrale Anlage ohne festen Rackplatz \u2013 sie zieht bei einem Standortwechsel nicht mit um.` };
  }
  if (device.state === "maintenance") return { ok: false, reason: `An ${device.name} l\xE4uft gerade eine Wartung.` };
  if (transportOf(world, kind, id)) return { ok: false, reason: `${device.name} ist bereits f\xFCr einen Transport eingeplant.` };
  if (kind === "server") {
    const server = world.servers[id];
    const contracts = server.contractIds.filter((cid) => world.contracts[cid] && world.contracts[cid].state !== "cancelled");
    const instances = server.vpsIds.filter((vid) => world.vpsInstances[vid]);
    if (contracts.length + instances.length > 0) {
      return {
        ok: false,
        reason: `Auf ${server.name} liegen noch ${contracts.length + instances.length} Dienste. Erst r\xE4umen \u2013 ein Server im Lastwagen liefert nichts aus.`
      };
    }
    if (activeTransfers(world, server.id).length > 0) {
      return { ok: false, reason: `Auf ${server.name} l\xE4uft noch eine \xDCbertragung.` };
    }
  }
  if (kind === "switch") {
    const attached = values(world.servers).filter((s) => s.uplink?.switchId === id);
    if (attached.length > 0) {
      return {
        ok: false,
        reason: `${attached.length} Server h\xE4ngen noch an ${device.name} (${attached.map((s) => s.name).slice(0, 3).join(", ")}). Erst umstecken.`
      };
    }
  }
  if (kind === "router") {
    const attached = values(world.links).filter((l) => l.a.routerId === id || l.b.routerId === id);
    if (attached.length > 0) {
      return {
        ok: false,
        reason: `${device.name} tr\xE4gt noch ${attached.length} Strecken (${attached.map((l) => l.name).slice(0, 3).join(", ")}). Eine Leitung zieht nicht mit um \u2013 sie endet an einem Ort.`
      };
    }
  }
  if (kind === "loadbalancer") {
    const balancer = world.loadBalancers[id];
    const carrying = balancer?.pools.reduce((sum3, pool) => sum3 + pool.contractIds.length, 0) ?? 0;
    if (carrying > 0) {
      return { ok: false, reason: `\xDCber ${device.name} laufen noch ${carrying} Vertr\xE4ge. Sie w\xE4ren w\xE4hrend der Fahrt nirgends erreichbar.` };
    }
  }
  return { ok: true };
}
function transportOf(world, kind, id) {
  return values(world.transports).find((job) => job.deviceKind === kind && job.deviceId === id && RUNNING2.includes(job.phase));
}
function runningTransports(world) {
  return values(world.transports).filter((job) => RUNNING2.includes(job.phase));
}
function startTransport(world, rng, input, spend2) {
  const device = deviceOf2(world, input.kind, input.id);
  if (!device) return fail7("Ger\xE4t nicht gefunden.");
  const rack = world.racks[input.targetRackId];
  if (!rack) return fail7("Zielrack nicht gefunden.");
  if (rack.datacenterId === device.datacenterId) {
    return fail7("Ziel und Quelle liegen im selben Standort \u2013 daf\xFCr gen\xFCgt ein Umbau im Rack, kein Transport.");
  }
  const check = checkTransportable(world, input.kind, input.id);
  if (!check.ok) return fail7(check.reason);
  const maxWatt = "maxWatt" in device ? device.maxWatt : 0;
  const space = canInstall(world, input.targetRackId, device.heightUnits, maxWatt);
  if (!space.ok) return fail7(`Im Zielrack ist kein Platz: ${space.reason}`);
  const target = world.datacenters[rack.datacenterId];
  if (target?.contract?.notice) {
    return fail7(`${target.name} ist selbst gek\xFCndigt \u2013 dorthin lohnt sich kein Transport.`);
  }
  const estimate = estimateTransport(world, input);
  if (!estimate.ok) return fail7(estimate.error);
  if (!spend2(estimate.cost, `Transport ${device.name} nach ${target?.city ?? "Zielstandort"}`)) {
    return fail7(`Nicht gen\xFCgend Kapital (${estimate.cost.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
  }
  const id = asId(makeId(rng, "trp"));
  const job = {
    id,
    deviceKind: input.kind,
    deviceId: input.id,
    deviceName: device.name,
    fromDatacenterId: device.datacenterId,
    toDatacenterId: rack.datacenterId,
    // `checkTransportable` hat oben schon geprüft, dass es kein zentrales
    // Gerät ohne Rack ist – der Wert ist an dieser Stelle nie null.
    fromRackId: device.rackId,
    targetRackId: input.targetRackId,
    phase: "packing",
    ticksRemaining: RELOCATION.PACK_TICKS,
    startedAtTick: world.meta.tick,
    cost: estimate.cost,
    distanceKm: estimate.distanceKm,
    damageRisk: estimate.damageRisk,
    note: "Wird ausgebaut und verpackt."
  };
  world.transports[id] = job;
  device.state = "offline";
  device.pendingTicks = 0;
  detach(world, input.kind, input.id);
  moveIntoRack(world, input.kind, device, input.targetRackId, rack.datacenterId);
  return ok7(
    `${device.name} geht auf Transport nach ${target?.city ?? "dem Zielstandort"}: ${estimate.distanceKm} km, ${estimate.cost.toLocaleString("de-DE")} \u20AC, etwa ${estimate.ticks} h au\xDFer Betrieb.`,
    id
  );
}
function checkMovable(world, kind, id, targetRackId) {
  const device = deviceOf2(world, kind, id);
  if (!device) return { ok: false, reason: "Ger\xE4t nicht gefunden." };
  if (device.rackId === null) {
    return { ok: false, reason: `${device.name} ist eine zentrale Anlage ohne festen Rackplatz \u2013 sie l\xE4sst sich nicht in ein Rack umbauen.` };
  }
  const rack = world.racks[targetRackId];
  if (!rack) return { ok: false, reason: "Zielrack nicht gefunden." };
  if (rack.id === device.rackId) return { ok: false, reason: `${device.name} steht bereits in ${rack.name}.` };
  if (rack.datacenterId !== device.datacenterId) {
    const target = world.datacenters[rack.datacenterId];
    return {
      ok: false,
      reason: `${rack.name} steht in ${target?.city ?? "einem anderen Standort"} \u2013 dorthin geht es nur per Transport, nicht per Umbau.`
    };
  }
  if (device.state === "maintenance") return { ok: false, reason: `An ${device.name} l\xE4uft gerade eine Wartung.` };
  if (transportOf(world, kind, id)) return { ok: false, reason: `${device.name} ist bereits f\xFCr einen Transport eingeplant.` };
  const maxWatt = "maxWatt" in device ? device.maxWatt : 0;
  const space = canInstall(world, targetRackId, device.heightUnits, maxWatt);
  if (!space.ok) return { ok: false, reason: `In ${rack.name} ist kein Platz: ${space.reason}` };
  if (kind === "server") {
    if (activeTransfers(world, id).length > 0) {
      return { ok: false, reason: `Auf ${device.name} l\xE4uft noch eine \xDCbertragung.` };
    }
    const server = world.servers[id];
    const busy = server.contractIds.filter((cid) => world.contracts[cid] && world.contracts[cid].state !== "cancelled").length + server.vpsIds.filter((vid) => !!world.vpsInstances[vid]).length;
    if (busy > 0) {
      return {
        ok: false,
        needsForce: true,
        reason: `Auf ${server.name} liegen noch ${busy} Dienste. W\xE4hrend des Umbaus sind sie offline \u2013 erst r\xE4umen, oder den Ausfall ausdr\xFCcklich in Kauf nehmen.`
      };
    }
  }
  return { ok: true };
}
function moveDeviceWithinSite(world, input) {
  const check = checkMovable(world, input.kind, input.id, input.targetRackId);
  if (!check.ok && !(check.needsForce && input.force)) return fail7(check.reason);
  const device = deviceOf2(world, input.kind, input.id);
  const rack = world.racks[input.targetRackId];
  const from = world.racks[device.rackId]?.name ?? "dem alten Rack";
  moveIntoRack(world, input.kind, device, input.targetRackId, rack.datacenterId);
  device.state = "booting";
  device.pendingTicks = RELOCATION.INSTALL_TICKS + SIM.BOOT_TICKS;
  device.health = clamp(device.health - RELOCATION.MOVE_HEALTH_LOSS, 0, 1);
  return ok7(
    `${device.name} steht jetzt in ${rack.name} statt in ${from}. Etwa ${device.pendingTicks} h au\xDFer Betrieb; die Verkabelung bleibt, das Kabel reicht im selben Raum.`
  );
}
function devicesInRack(world, rackId) {
  const kinds = ["server", "router", "switch", "firewall", "loadbalancer", "ups"];
  return kinds.flatMap((kind) => values(storeOf(world, kind)).map((device) => ({ kind, device }))).filter((entry) => entry.device.rackId === rackId).sort((a, b) => a.device.rackUnit - b.device.rackUnit);
}
function reorderDeviceInRack(world, kind, id, direction) {
  const device = deviceOf2(world, kind, id);
  if (!device) return fail7("Ger\xE4t nicht gefunden.");
  if (device.rackId === null) {
    return fail7(`${device.name} ist eine zentrale Anlage ohne festen Rackplatz \u2013 sie l\xE4sst sich nicht verschieben.`);
  }
  const stack = devicesInRack(world, device.rackId);
  const index = stack.findIndex((entry) => entry.device.id === id);
  const neighbor = stack[direction === "up" ? index + 1 : index - 1];
  if (!neighbor) {
    return fail7(
      direction === "up" ? `${device.name} steht bereits ganz oben im Rack.` : `${device.name} steht bereits ganz unten im Rack.`
    );
  }
  const lower = device.rackUnit <= neighbor.device.rackUnit ? device : neighbor.device;
  const upper = lower === device ? neighbor.device : device;
  const base = lower.rackUnit;
  upper.rackUnit = base;
  lower.rackUnit = base + upper.heightUnits;
  return ok7(`${device.name} und ${neighbor.device.name} haben die Pl\xE4tze getauscht.`);
}
function detach(world, kind, id) {
  if (kind === "server") {
    const server = world.servers[id];
    if (server?.uplink) {
      const sw2 = world.switches[server.uplink.switchId];
      const port = sw2?.ports?.[server.uplink.portIndex];
      if (port) {
        port.connectedDevice = null;
        port.description = "";
      }
      server.uplink = null;
    }
    return;
  }
  const sw = kind === "switch" ? world.switches[id] : void 0;
  if (sw) {
    for (const port of sw.ports) {
      port.connectedDevice = null;
      port.linkId = null;
    }
  }
}
function moveIntoRack(world, kind, device, rackId, datacenterId) {
  const previous = device.rackId ? world.racks[device.rackId] : void 0;
  if (kind === "ups" && previous) previous.upsIds = previous.upsIds.filter((id) => id !== device.id);
  device.rackId = rackId;
  device.datacenterId = datacenterId;
  device.rackUnit = nextRackSlot(world, rackId, device.heightUnits, device.id);
  const target = world.racks[rackId];
  if (kind === "ups" && target && !target.upsIds.includes(device.id)) target.upsIds.push(device.id);
}
function cancelTransport(world, transportId) {
  const job = world.transports[transportId];
  if (!job) return fail7("Transport nicht gefunden.");
  if (!RUNNING2.includes(job.phase)) return fail7("Dieser Transport ist bereits abgeschlossen.");
  if (job.phase !== "packing") {
    return fail7("Das Ger\xE4t ist bereits unterwegs. Ein Lastwagen dreht nicht um \u2013 abwarten und dr\xFCben wieder einbauen.");
  }
  const device = deviceOf2(world, job.deviceKind, job.deviceId);
  if (device) {
    if (world.racks[job.fromRackId]) {
      moveIntoRack(world, job.deviceKind, device, job.fromRackId, job.fromDatacenterId);
    }
    device.state = "booting";
    device.pendingTicks = SIM.BOOT_TICKS;
  }
  job.phase = "failed";
  job.note = "Vom Betreiber abgebrochen; die Speditionskosten bleiben.";
  return ok7(`Transport von ${job.deviceName} abgebrochen. Das Ger\xE4t bleibt am alten Standort, die Speditionskosten sind weg.`);
}
function advanceTransports(world, rng) {
  const result = { messages: [], clearedSites: [] };
  const touchedSources = /* @__PURE__ */ new Set();
  for (const job of values(world.transports)) {
    if (!RUNNING2.includes(job.phase)) continue;
    const device = deviceOf2(world, job.deviceKind, job.deviceId);
    if (!device) {
      job.phase = "failed";
      job.note = "Das Ger\xE4t existiert nicht mehr.";
      continue;
    }
    const rack = world.racks[job.targetRackId];
    if (!rack || !world.datacenters[job.toDatacenterId]) {
      job.phase = "failed";
      job.note = "Der Zielort existiert nicht mehr.";
      result.messages.push({
        text: `Transport von ${job.deviceName} gescheitert: Das Zielrack gibt es nicht mehr. Das Ger\xE4t steht auf dem Hof.`,
        severity: "error"
      });
      continue;
    }
    job.ticksRemaining -= 1;
    if (job.ticksRemaining > 0) continue;
    switch (job.phase) {
      case "packing": {
        job.phase = "transit";
        job.ticksRemaining = Math.max(1, Math.ceil(job.distanceKm / RELOCATION.KM_PER_TICK));
        job.note = `Unterwegs, ${job.distanceKm} km.`;
        touchedSources.add(job.fromDatacenterId);
        break;
      }
      case "transit": {
        job.phase = "install";
        job.ticksRemaining = RELOCATION.INSTALL_TICKS;
        job.note = "Angekommen, wird eingebaut.";
        break;
      }
      case "install": {
        completeTransport(world, rng, job, device, result);
        break;
      }
    }
  }
  for (const datacenterId of touchedSources) {
    if (!world.datacenters[datacenterId]) continue;
    const remaining = runningTransports(world).filter((j) => j.fromDatacenterId === datacenterId).length;
    const stillThere = values(world.servers).some((d) => d.datacenterId === datacenterId) || values(world.routers).some((d) => d.datacenterId === datacenterId) || values(world.switches).some((d) => d.datacenterId === datacenterId) || values(world.firewalls).some((d) => d.datacenterId === datacenterId) || values(world.loadBalancers).some((d) => d.datacenterId === datacenterId) || values(world.upsUnits).some((d) => d.datacenterId === datacenterId);
    if (!stillThere && remaining === 0) result.clearedSites.push(datacenterId);
  }
  return result;
}
function completeTransport(world, rng, job, device, result) {
  device.health = clamp(device.health - RELOCATION.HEALTH_LOSS, 0, 1);
  if (rng.next() < job.damageRisk) {
    device.health = clamp(device.health - RELOCATION.DAMAGE_HEALTH_LOSS, 0, 1);
    device.state = "failed";
    device.pendingTicks = 0;
    job.phase = "done";
    job.note = "Transportschaden \u2013 das Ger\xE4t kam defekt an.";
    result.messages.push({
      text: `${device.name} hat den Transport nicht \xFCberstanden und ist defekt angekommen. Reparatur n\xF6tig.`,
      severity: "error"
    });
    return;
  }
  device.state = "booting";
  device.pendingTicks = SIM.BOOT_TICKS;
  device.temperatureC = world.datacenters[job.toDatacenterId]?.ambientTempC ?? 24;
  job.phase = "done";
  job.note = "Eingebaut und hochgefahren.";
  result.messages.push({
    text: `${device.name} steht jetzt in ${world.datacenters[job.toDatacenterId]?.city ?? "dem neuen Standort"} ` + (job.deviceKind === "server" ? "\u2013 Uplink neu stecken, dann nimmt er wieder Kunden auf." : "\u2013 Verkabelung pr\xFCfen."),
    severity: "info"
  });
}
function planSiteRelocation(world, fromDatacenterId, toDatacenterId) {
  const empty = { steps: [], blocked: [], totalCost: 0, totalTicks: 0, notWorthIt: 0 };
  const from = world.datacenters[fromDatacenterId];
  const to = world.datacenters[toDatacenterId];
  if (!from || !to) return { ...empty, error: "Standort nicht gefunden." };
  if (from.id === to.id) return { ...empty, error: "Quelle und Ziel sind derselbe Standort." };
  const targetRacks = values(world.racks).filter((r) => r.datacenterId === toDatacenterId);
  if (targetRacks.length === 0) {
    return { ...empty, error: `In ${to.city} ist noch kein Rack angemietet \u2013 dorthin l\xE4sst sich nichts liefern.` };
  }
  const freeUnits = /* @__PURE__ */ new Map();
  for (const rack of targetRacks) {
    const used = allDevices(world).filter((entry) => entry.device.rackId === rack.id).reduce((sum3, entry) => sum3 + entry.device.heightUnits, 0);
    freeUnits.set(rack.id, rack.units - used);
  }
  const steps = [];
  const blocked = [];
  const candidates = allDevices(world).filter((entry) => entry.device.datacenterId === fromDatacenterId).sort((a, b) => b.device.heightUnits - a.device.heightUnits);
  for (const { kind, device } of candidates) {
    const check = checkTransportable(world, kind, device.id);
    if (!check.ok) {
      blocked.push({ name: device.name, reason: check.reason });
      continue;
    }
    const rack = targetRacks.find((r) => (freeUnits.get(r.id) ?? 0) >= device.heightUnits);
    if (!rack) {
      blocked.push({ name: device.name, reason: `In ${to.city} ist kein Rackplatz mehr frei (${device.heightUnits} HE n\xF6tig).` });
      continue;
    }
    const estimate = estimateTransport(world, { kind, id: device.id, targetRackId: rack.id });
    if (!estimate.ok) {
      blocked.push({ name: device.name, reason: estimate.error });
      continue;
    }
    freeUnits.set(rack.id, (freeUnits.get(rack.id) ?? 0) - device.heightUnits);
    steps.push({
      kind,
      id: device.id,
      name: device.name,
      targetRackId: rack.id,
      targetRackName: rack.name,
      cost: estimate.cost,
      ticks: estimate.ticks,
      residualValue: estimate.residualValue
    });
  }
  return {
    steps,
    blocked,
    totalCost: steps.reduce((sum3, step) => sum3 + step.cost, 0),
    totalTicks: steps.reduce((max, step) => Math.max(max, step.ticks), 0),
    notWorthIt: steps.filter((step) => step.cost > step.residualValue).length
  };
}
function relocateSite(world, rng, input, spend2) {
  const plan = planSiteRelocation(world, input.fromDatacenterId, input.toDatacenterId);
  if (plan.error) return { ok: false, message: plan.error, started: 0, failed: [] };
  if (plan.steps.length === 0) {
    return {
      ok: false,
      message: plan.blocked.length > 0 ? `Kein Ger\xE4t ist transportbereit: ${plan.blocked[0].reason}` : "An diesem Standort steht nichts, was sich fahren lie\xDFe.",
      started: 0,
      failed: plan.blocked
    };
  }
  const failed = [...plan.blocked];
  let started = 0;
  for (const step of plan.steps) {
    const result = startTransport(world, rng, { kind: step.kind, id: step.id, targetRackId: step.targetRackId }, spend2);
    if (result.ok) started += 1;
    else failed.push({ name: step.name, reason: result.message });
  }
  const to = world.datacenters[input.toDatacenterId];
  return {
    ok: started > 0,
    message: `${started} ${started === 1 ? "Ger\xE4t geht" : "Ger\xE4te gehen"} nach ${to?.city ?? "dem neuen Standort"}, voraussichtlich ${plan.totalTicks} h` + (failed.length > 0 ? `; ${failed.length} bleiben stehen.` : "."),
    started,
    failed
  };
}
function allDevices(world) {
  const kinds = ["server", "router", "switch", "firewall", "loadbalancer", "ups"];
  return kinds.flatMap((kind) => Object.values(storeOf(world, kind)).map((device) => ({ kind, device })));
}
function pruneTransports(world) {
  let removed = 0;
  for (const job of values(world.transports)) {
    if (RUNNING2.includes(job.phase)) continue;
    if (world.meta.tick - job.startedAtTick < RELOCATION.KEEP_FINISHED_TICKS) continue;
    delete world.transports[job.id];
    removed += 1;
  }
  return removed;
}

// src/domain/compute/configurator.ts
function configureServer(input) {
  const chassis = findChassis(input.chassisKey);
  const problems = [];
  const warnings = [];
  if (!chassis) {
    return {
      ok: false,
      problems: ["Geh\xE4use unbekannt."],
      warnings: [],
      chassisKey: input.chassisKey,
      chassisName: "",
      heightUnits: 0,
      supportedOs: [],
      chassisPrice: 0,
      partsPrice: 0,
      totalPrice: 0,
      maintenancePerMonth: 0,
      slots: [],
      specs: deriveServerSpecs(emptyPlatform(), []),
      lines: []
    };
  }
  const platform = chassis.platform;
  const lines = [];
  const used = { cpu: 0, ram: 0, drive: 0, nic: 0, gpu: 0 };
  for (const line of input.parts) {
    if (line.quantity <= 0) continue;
    const part = findPart(line.modelKey);
    if (!part) {
      problems.push(`Bauteil \u201E${line.modelKey}\u201C ist unbekannt.`);
      continue;
    }
    const fit = isCompatible(platform, part);
    if (!fit.ok) {
      problems.push(fit.reason);
      continue;
    }
    used[part.kind] += line.quantity;
    lines.push({ part, quantity: line.quantity, price: part.price * line.quantity });
  }
  const slots = [
    { kind: "cpu", used: used.cpu, total: platform.cpuSockets, label: SLOT_LABEL.cpu },
    { kind: "ram", used: used.ram, total: platform.dimmSlots, label: SLOT_LABEL.ram },
    { kind: "drive", used: used.drive, total: platform.driveBays, label: SLOT_LABEL.drive },
    { kind: "nic", used: used.nic, total: platform.nicSlots, label: SLOT_LABEL.nic }
  ];
  if (platform.gpuSlots) {
    slots.push({ kind: "gpu", used: used.gpu, total: platform.gpuSlots, label: SLOT_LABEL.gpu });
  }
  for (const slot of slots) {
    if (slot.used > slot.total) {
      problems.push(`${PART_KIND_LABEL[slot.kind]}: ${slot.used} St\xFCck auf ${slot.total} ${slot.label}.`);
    }
  }
  const bom = lines.map((line) => ({ modelKey: line.part.key, quantity: line.quantity }));
  const specs = deriveServerSpecs(platform, bom);
  if (used.cpu === 0) problems.push("Ohne Prozessor startet der Server nicht.");
  if (specs.ramGb === 0) problems.push("Ohne Arbeitsspeicher startet der Server nicht.");
  if (specs.ssdGb + specs.hddGb === 0) problems.push("Ohne Laufwerk l\xE4sst sich kein Betriebssystem installieren.");
  if (used.nic === 0) problems.push("Ohne Netzwerkkarte h\xE4ngt der Server an keinem Switch.");
  if (used.cpu > 1) {
    const distinct = new Set(lines.filter((l) => l.part.kind === "cpu").map((l) => l.part.key));
    if (distinct.size > 1) {
      warnings.push("Unterschiedliche Prozessoren in einem System: Das Tempo richtet sich nach dem langsamsten.");
    }
  }
  if (used.cpu > 0 && used.cpu < platform.cpuSockets) {
    warnings.push(`Nur ${used.cpu} von ${platform.cpuSockets} Sockeln best\xFCckt \u2013 die DIMM-Steckpl\xE4tze des leeren Sockels bleiben ungenutzt.`);
  }
  const rawRam = bom.map((entry) => ({ part: findPart(entry.modelKey), quantity: entry.quantity })).filter((entry) => entry.part?.kind === "ram").reduce((sum3, entry) => sum3 + entry.part.capacityGb * entry.quantity, 0);
  if (rawRam > platform.maxRamGb) {
    warnings.push(`Der Speichercontroller adressiert h\xF6chstens ${platform.maxRamGb} GB \u2013 ${rawRam - platform.maxRamGb} GB bleiben ungenutzt.`);
  }
  if (used.drive === 1) {
    warnings.push("Nur ein Laufwerk: F\xE4llt es aus, ist alles darauf weg. Zwei im Spiegel sind der \xFCbliche Anfang.");
  }
  const partsPrice = lines.reduce((sum3, line) => sum3 + line.price, 0);
  return {
    ok: problems.length === 0,
    problems,
    warnings,
    chassisKey: chassis.key,
    chassisName: chassis.name,
    heightUnits: chassis.heightUnits,
    supportedOs: chassis.supportedOs,
    chassisPrice: chassis.price,
    partsPrice,
    totalPrice: chassis.price + partsPrice,
    maintenancePerMonth: chassis.maintenancePerMonth,
    slots,
    specs,
    lines
  };
}
function suggestConfiguration(chassisKey, availableParts2) {
  const chassis = findChassis(chassisKey);
  if (!chassis) return [];
  const platform = chassis.platform;
  const cheapestOf = (kind) => availableParts2.filter((part) => part.kind === kind && isCompatible(platform, part).ok).sort((a, b) => a.price - b.price)[0];
  const lines = [];
  const cpu = cheapestOf("cpu");
  if (cpu) lines.push({ modelKey: cpu.key, quantity: platform.cpuSockets });
  const ram = cheapestOf("ram");
  if (ram) lines.push({ modelKey: ram.key, quantity: Math.max(2, Math.floor(platform.dimmSlots / 2)) });
  const drive = cheapestOf("drive");
  if (drive) lines.push({ modelKey: drive.key, quantity: Math.min(2, platform.driveBays) });
  const nic = cheapestOf("nic");
  if (nic) lines.push({ modelKey: nic.key, quantity: 1 });
  return lines;
}
function emptyPlatform() {
  return {
    cpuSockets: 0,
    cpuSocket: "gen3",
    dimmSlots: 0,
    dimmStandard: "ddr4",
    maxRamGb: 0,
    driveBays: 0,
    driveFormFactors: [],
    nicSlots: 0,
    baseIdleWatt: 0,
    baseMaxWatt: 0
  };
}

// src/domain/compute/consolidation.ts
function planConsolidation(world, input) {
  const performanceModifier = input.performanceModifier ?? 1;
  const target = world.servers[input.targetServerId];
  const empty = {
    targetServerId: input.targetServerId,
    moves: [],
    blocked: [],
    drained: [],
    partial: [],
    durationTicks: 0,
    transferGb: 0,
    rateMbps: 0,
    interruptedContracts: 0,
    targetLoadBefore: 0,
    targetLoadAfter: 0,
    proceeds: 0,
    partsProceeds: 0,
    freedWatt: 0,
    monthlySaving: 0,
    freedRackUnits: 0
  };
  const reject = (error) => ({ ...empty, error });
  if (!target) return reject("Zielserver nicht gefunden.");
  if (target.role === "dedicated") {
    return reject("Dedizierte Server geh\xF6ren einem Kunden exklusiv und lassen sich nicht als Sammelziel nutzen.");
  }
  if (target.os === null) return reject(`${target.name} hat kein Betriebssystem \u2013 dorthin l\xE4sst sich nichts verlegen.`);
  if (target.state !== "online" && target.state !== "degraded") {
    return reject(`${target.name} ist nicht betriebsbereit (${target.state}).`);
  }
  if (!isServerConnected(world, target.id)) return reject(`${target.name} h\xE4ngt an keinem Switch \u2013 erst verkabeln.`);
  if (target.maintenance) return reject(`An ${target.name} l\xE4uft gerade ein Wartungsfenster.`);
  if (target.retirement) return reject(`${target.name} ist selbst zur Abgabe vorgemerkt.`);
  const sources = input.sourceServerIds.filter((id) => id !== target.id).map((id) => world.servers[id]).filter((s) => !!s);
  if (sources.length === 0) return reject("Keine Quellserver ausgew\xE4hlt.");
  const capacity = { ...serverCapacity(world, target.id, performanceModifier) };
  const targetLoadBefore = capacity.ramGbUsed / Math.max(1, capacity.ramGb);
  const moves = [];
  const blocked = [];
  const leftBehind = /* @__PURE__ */ new Set();
  for (const workload of collectWorkloads2(world, sources)) {
    const check = accept(world, target, capacity, workload);
    if (check.ok) {
      moves.push(check.move);
    } else {
      blocked.push({ sourceServerId: workload.sourceServerId, label: workload.label, reason: check.reason });
      leftBehind.add(workload.sourceServerId);
    }
  }
  const drained = sources.filter((s) => !leftBehind.has(s.id)).map((s) => s.id);
  const partial = sources.filter((s) => leftBehind.has(s.id)).map((s) => s.id);
  let proceeds = 0;
  let partsProceeds = 0;
  let freedWatt = 0;
  let monthlySaving = 0;
  let freedRackUnits = 0;
  const hoursPerMonth = SIM.TICKS_PER_MONTH * SIM.MINUTES_PER_TICK / 60;
  for (const id of drained) {
    const server = world.servers[id];
    proceeds += residualValue(world, server);
    partsProceeds += quoteDecommission(world, "server", server.id).partsProceeds;
    freedRackUnits += server.heightUnits;
    const dc = world.datacenters[server.datacenterId];
    const pue = dc?.pue ?? 1.5;
    const watt = server.idleWatt * pue;
    freedWatt += watt;
    if (dc) monthlySaving += watt / 1e3 * hoursPerMonth * effectivePowerPrice(world, dc);
  }
  const capacityAfter = capacity.ramGbUsed / Math.max(1, capacity.ramGb);
  const firstSource = sources[0];
  const rate = firstSource ? plannedRateMbps(world, firstSource, target) : 0;
  return {
    targetServerId: target.id,
    moves,
    blocked,
    drained,
    partial,
    durationTicks: Math.ceil(moves.reduce((sum3, m) => sum3 + m.ticks, 0)),
    transferGb: Math.round(moves.reduce((sum3, m) => sum3 + m.transferGb, 0)),
    rateMbps: Math.round(rate),
    interruptedContracts: moves.filter((m) => m.interrupts).length,
    targetLoadBefore,
    targetLoadAfter: capacityAfter,
    proceeds: Math.round(proceeds),
    partsProceeds: Math.round(partsProceeds),
    freedWatt: Math.round(freedWatt),
    monthlySaving: Math.round(monthlySaving),
    freedRackUnits
  };
}
function collectWorkloads2(world, sources) {
  const workloads = [];
  for (const source of sources) {
    for (const vpsId of source.vpsIds) {
      const vps = world.vpsInstances[vpsId];
      if (!vps) continue;
      if (migrationOf(world, "vps", vps.id)) continue;
      if (vps.hostServerId !== source.id) continue;
      workloads.push({ kind: "vps", id: vps.id, sourceServerId: source.id, label: vps.name, ramGb: vps.ramGb });
    }
    for (const contractId of source.contractIds) {
      const contract = world.contracts[contractId];
      if (!contract || contract.state === "cancelled") continue;
      if (contract.serverId !== source.id) continue;
      if (migrationOf(world, "contract", contract.id)) continue;
      const product = world.products[contract.productId];
      const customer = world.customers[contract.customerId];
      workloads.push({
        kind: "contract",
        id: contractId,
        sourceServerId: source.id,
        label: `${product?.name ?? "Vertrag"} \u2013 ${customer?.company ?? customer?.name ?? "Kunde"}`,
        ramGb: product?.resources.ramGb ?? 0
      });
    }
  }
  return workloads.sort((a, b) => b.ramGb - a.ramGb);
}
function accept(world, target, capacity, workload) {
  const frei = (gesamt, belegt) => Math.max(0, Math.round(gesamt - belegt));
  if (workload.kind === "vps") {
    const vps = world.vpsInstances[workload.id];
    if (target.role !== "vps-host") {
      return { ok: false, reason: `${target.name} ist kein VPS-Host (Rolle "${target.role}").` };
    }
    if (capacity.ramGbUsed + vps.ramGb > capacity.ramGb) {
      return { ok: false, reason: `Arbeitsspeicher reicht nicht (${frei(capacity.ramGb, capacity.ramGbUsed)} GB frei, ${vps.ramGb} GB n\xF6tig).` };
    }
    if (capacity.ssdGbUsed + vps.diskGb > capacity.ssdGb) {
      return { ok: false, reason: `Speicher reicht nicht (${frei(capacity.ssdGb, capacity.ssdGbUsed)} GB frei, ${vps.diskGb} GB n\xF6tig).` };
    }
    capacity.cpuCoresUsed += vps.vcpu;
    capacity.ramGbUsed += vps.ramGb;
    capacity.ssdGbUsed += vps.diskGb;
    const estimate2 = estimateMigration(world, { kind: "vps", id: vps.id, targetServerId: target.id });
    if (!estimate2.ok) return { ok: false, reason: estimate2.error };
    return {
      ok: true,
      move: {
        kind: "vps",
        id: vps.id,
        sourceServerId: workload.sourceServerId,
        label: workload.label,
        ramGb: vps.ramGb,
        transferGb: estimate2.diskGb + estimate2.ramGb,
        ticks: estimate2.ticks,
        // Eine saubere Live-Migration bleibt unbemerkt; erst eine erzwungene
        // Umschaltung wird zur Störung.
        interrupts: estimate2.freezeSeconds >= 60
      }
    };
  }
  const contract = world.contracts[workload.id];
  const product = world.products[contract.productId];
  if (!product) return { ok: false, reason: "Produkt des Vertrags ist unbekannt." };
  const role = requiredRole(product);
  if (role !== null && target.role !== role) {
    return { ok: false, reason: `${target.name} hat die Rolle "${target.role}", gebraucht wird "${role}".` };
  }
  if (!fits(capacity, product)) {
    return {
      ok: false,
      reason: `Auf ${target.name} ist kein Platz mehr (${frei(capacity.ramGb, capacity.ramGbUsed)} GB RAM, ${frei(capacity.ssdGb, capacity.ssdGbUsed)} GB SSD frei).`
    };
  }
  capacity.cpuCoresUsed += product.resources.cpuCores;
  capacity.ramGbUsed += product.resources.ramGb;
  capacity.ssdGbUsed += product.resources.ssdGb;
  capacity.hddGbUsed += product.resources.hddGb;
  const estimate = estimateMigration(world, { kind: "contract", id: contract.id, targetServerId: target.id });
  if (!estimate.ok) return { ok: false, reason: estimate.error };
  return {
    ok: true,
    move: {
      kind: "contract",
      id: contract.id,
      sourceServerId: workload.sourceServerId,
      label: workload.label,
      ramGb: product.resources.ramGb,
      transferGb: estimate.diskGb,
      ticks: estimate.ticks,
      // Ein Konto wird kopiert und umgeschaltet – das merkt der Kunde, sofern
      // er nicht hinter einem Loadbalancer liegt.
      interrupts: !estimate.seamless
    }
  };
}
function consolidate(world, rng, input) {
  const plan = planConsolidation(world, input);
  if (plan.error) return { ok: false, message: plan.error, moved: 0, failed: [], retired: [], durationTicks: 0 };
  if (plan.moves.length === 0 && plan.blocked.length > 0) {
    return {
      ok: false,
      message: `Nichts l\xE4sst sich verlegen: ${plan.blocked[0].reason}`,
      moved: 0,
      failed: [],
      retired: [],
      durationTicks: 0
    };
  }
  const performanceModifier = input.performanceModifier ?? 1;
  const failed = [];
  let moved = 0;
  for (const move of plan.moves) {
    const result = move.kind === "vps" ? startVpsMigration(
      world,
      rng,
      { vpsId: move.id, targetServerId: plan.targetServerId, reason: "consolidation" },
      performanceModifier
    ) : startContractMigration(
      world,
      rng,
      { contractId: move.id, targetServerId: plan.targetServerId, reason: "consolidation" },
      performanceModifier
    );
    if (result.ok) moved += 1;
    else failed.push({ label: move.label, reason: result.message });
  }
  const retired = [];
  if (input.retireDrained !== false) {
    for (const id of plan.drained) {
      const server = world.servers[id];
      if (!server || server.retirement) continue;
      server.retirement = {
        harvestParts: input.harvestParts ?? true,
        requestedAtTick: world.meta.tick,
        reason: "consolidation"
      };
      retired.push(id);
    }
  }
  const target = world.servers[plan.targetServerId];
  const parts = [
    `${moved} ${moved === 1 ? "Dienst wird" : "Dienste werden"} auf ${target.name} verlegt`,
    plan.durationTicks > 1 ? `${plan.transferGb} GB \xFCber ${plan.rateMbps} Mbit/s, etwa ${plan.durationTicks} h` : null,
    retired.length > 0 ? `${retired.length} Server danach zur Abgabe vorgemerkt` : null,
    plan.blocked.length > 0 ? `${plan.blocked.length} Dienste bleiben stehen (kein Platz)` : null,
    failed.length > 0 ? `${failed.length} abgelehnt` : null
  ].filter((p) => p !== null);
  return {
    ok: moved > 0,
    message: `${parts.join(", ")}.`,
    moved,
    failed,
    retired,
    durationTicks: plan.durationTicks
  };
}
function retireServer(world, serverId, options = {}) {
  const server = world.servers[serverId];
  if (!server) return { ok: false, message: "Server nicht gefunden." };
  if (server.retirement) return { ok: false, message: `${server.name} ist bereits zur Abgabe vorgemerkt.` };
  server.retirement = {
    harvestParts: options.harvestParts ?? true,
    requestedAtTick: world.meta.tick,
    reason: options.reason ?? "manual"
  };
  const belegt = server.contractIds.length + server.vpsIds.length;
  return {
    ok: true,
    message: belegt === 0 ? `${server.name} wird abgegeben, sobald der n\xE4chste Tick durch ist.` : `${server.name} nimmt keine neuen Kunden mehr an und wird verkauft, sobald die letzten ${belegt} Dienste herunter sind.`
  };
}
function cancelRetirement(world, serverId) {
  const server = world.servers[serverId];
  if (!server) return { ok: false, message: "Server nicht gefunden." };
  if (!server.retirement) return { ok: false, message: `${server.name} ist gar nicht zur Abgabe vorgemerkt.` };
  server.retirement = null;
  return { ok: true, message: `${server.name} bleibt im Bestand und nimmt wieder Kunden an.` };
}
function retirementBlockers(world, server) {
  const blockers = [];
  const vps = server.vpsIds.filter((id) => world.vpsInstances[id]).length;
  const contracts = server.contractIds.filter((id) => world.contracts[id]?.state !== "cancelled").length;
  if (vps > 0) blockers.push(`${vps} ${vps === 1 ? "Instanz l\xE4uft" : "Instanzen laufen"} noch`);
  if (contracts > 0) blockers.push(`${contracts} ${contracts === 1 ? "Vertrag liegt" : "Vertr\xE4ge liegen"} noch darauf`);
  if (activeTransfers(world, server.id).length > 0) blockers.push("eine \xDCbertragung l\xE4uft noch");
  if (server.maintenance) blockers.push("ein Wartungsfenster l\xE4uft");
  return blockers;
}
function advanceRetirements(world, credit) {
  const messages = [];
  const soldServerIds = [];
  for (const server of values(world.servers)) {
    if (!server.retirement) continue;
    if (retirementBlockers(world, server).length > 0) continue;
    const harvest = server.retirement.harvestParts;
    const result = decommissionDevice(world, "server", server.id, { harvestParts: harvest }, credit);
    if (result.ok) {
      soldServerIds.push(server.id);
      messages.push(result.message);
    }
  }
  return { messages, soldServerIds };
}
function consolidationSuggestions(world, performanceModifier = 1) {
  const suggestions = [];
  const groups = /* @__PURE__ */ new Map();
  for (const server of values(world.servers)) {
    if (server.role === "dedicated" || server.role === "unassigned") continue;
    if (server.retirement) continue;
    if (server.os === null) continue;
    const key = `${server.datacenterId}|${server.role}`;
    const group = groups.get(key);
    if (group) group.push(server);
    else groups.set(key, [server]);
  }
  for (const group of groups.values()) {
    if (group.length < 2) continue;
    const sorted = [...group].sort((a, b) => b.ramGb - a.ramGb);
    const target = sorted[0];
    if (target.state !== "online" && target.state !== "degraded") continue;
    const candidates = sorted.slice(1).filter((s) => {
      if (s.state !== "online" && s.state !== "degraded") return false;
      if (s.maintenance) return false;
      const cap = serverCapacity(world, s.id, performanceModifier);
      const auslastung = cap.ramGbUsed / Math.max(1, cap.ramGb);
      return auslastung < 0.5 || s.health < 0.5;
    });
    if (candidates.length === 0) continue;
    const ranked = candidates.sort((a, b) => a.health - b.health).slice(0, 6);
    for (let count2 = ranked.length; count2 >= 1; count2--) {
      const sourceServerIds = ranked.slice(0, count2).map((s) => s.id);
      const plan = planConsolidation(world, { targetServerId: target.id, sourceServerIds, performanceModifier });
      if (plan.error || plan.drained.length !== sourceServerIds.length) continue;
      if (plan.moves.length === 0) continue;
      suggestions.push({ targetServerId: target.id, sourceServerIds, plan });
      break;
    }
  }
  return suggestions.sort((a, b) => b.plan.monthlySaving + b.plan.proceeds - (a.plan.monthlySaving + a.plan.proceeds));
}

// src/domain/world/competitors.ts
var CompetitorArchetypes = ["massenhoster", "premium", "regional", "reseller", "colo"];
var ARCHETYPE_LABEL = {
  massenhoster: "Massenhoster",
  premium: "Premiumanbieter",
  regional: "Regionalanbieter",
  reseller: "Reseller",
  colo: "Colocation"
};
var CompetitorStrategies = ["expansion", "konsolidierung", "preiskampf", "rueckzug"];
var STRATEGY_LABEL = {
  expansion: "Expansion",
  konsolidierung: "Konsolidierung",
  preiskampf: "Preiskampf",
  rueckzug: "R\xFCckzug"
};
var COMPETITOR_TEMPLATES = [
  {
    id: "cmp-alpenweb",
    name: "Alpenweb",
    archetype: "massenhoster",
    regions: ["loc-muc", "loc-fra", "loc-vie"],
    share: { "shared-hosting": 0.14, domain: 0.16, ssl: 0.11, vps: 0.06, mail: 0.08 },
    priceLevel: 0.88
  },
  {
    id: "cmp-nordlink",
    name: "Nordlink Systems",
    archetype: "premium",
    regions: ["loc-ham", "loc-cph", "loc-sto"],
    share: { dedicated: 0.13, vps: 0.09, colocation: 0.07, backup: 0.09 },
    priceLevel: 1.28
  },
  {
    id: "cmp-rheinstrom",
    name: "Rheinstrom Hosting",
    archetype: "regional",
    regions: ["loc-dus", "loc-cgn"],
    share: { "shared-hosting": 0.05, vps: 0.04, mail: 0.05, domain: 0.04 },
    priceLevel: 1.02
  },
  {
    id: "cmp-datenhalle",
    name: "Datenhalle AG",
    archetype: "colo",
    regions: ["loc-fra", "loc-fsn"],
    share: { colocation: 0.29, "transit-sale": 0.18, dedicated: 0.06 },
    priceLevel: 1.05
  },
  {
    id: "cmp-cloudmeer",
    name: "Cloudmeer",
    archetype: "massenhoster",
    regions: ["loc-ams", "loc-bru"],
    share: { vps: 0.16, storage: 0.13, backup: 0.11, "shared-hosting": 0.07 },
    priceLevel: 0.83
  },
  {
    id: "cmp-serverwerk",
    name: "Serverwerk",
    archetype: "premium",
    regions: ["loc-ber", "loc-lej"],
    share: { dedicated: 0.09, vps: 0.07, storage: 0.06 },
    priceLevel: 1.19
  },
  {
    id: "cmp-hansanet",
    name: "HansaNet",
    archetype: "regional",
    regions: ["loc-ham", "loc-han"],
    share: { colocation: 0.06, "transit-sale": 0.09, dedicated: 0.05 },
    priceLevel: 1.08
  },
  {
    id: "cmp-webfabrik",
    name: "Webfabrik",
    archetype: "reseller",
    regions: ["loc-fra"],
    share: { "shared-hosting": 0.08, domain: 0.11, ssl: 0.14 },
    priceLevel: 0.94
  },
  {
    id: "cmp-atlantik",
    name: "Atlantik Digital",
    archetype: "massenhoster",
    regions: ["loc-par", "loc-rbx", "loc-grv"],
    share: { "shared-hosting": 0.11, vps: 0.12, domain: 0.09, storage: 0.08 },
    priceLevel: 0.79
  },
  {
    id: "cmp-alpenkern",
    name: "Alpenkern",
    archetype: "colo",
    regions: ["loc-zrh", "loc-muc"],
    share: { colocation: 0.14, dedicated: 0.05, "transit-sale": 0.07 },
    priceLevel: 1.34
  },
  {
    id: "cmp-vistanet",
    name: "Vistanet",
    archetype: "premium",
    regions: ["loc-lon", "loc-dub"],
    share: { dedicated: 0.08, mail: 0.12, backup: 0.09, colocation: 0.05 },
    priceLevel: 1.22
  },
  {
    id: "cmp-ostlicht",
    name: "Ostlicht Hosting",
    archetype: "regional",
    regions: ["loc-war", "loc-prg"],
    share: { "shared-hosting": 0.06, vps: 0.06, domain: 0.05 },
    priceLevel: 0.86
  },
  {
    id: "cmp-mediterran",
    name: "Mediterran Data",
    archetype: "regional",
    regions: ["loc-mil", "loc-mad"],
    share: { colocation: 0.05, "shared-hosting": 0.05, vps: 0.05 },
    priceLevel: 0.97
  },
  {
    id: "cmp-basispunkt",
    name: "Basispunkt IT",
    archetype: "reseller",
    regions: ["loc-nue", "loc-str"],
    share: { "shared-hosting": 0.04, ssl: 0.08, domain: 0.06, mail: 0.05 },
    priceLevel: 1.11
  }
];
var STRATEGY_TABLE = {
  // Der Massenhoster kämpft über den Preis – auch dann noch, wenn es ihn umbringt.
  massenhoster: { stark: "expansion", mittel: "preiskampf", schwach: "preiskampf" },
  // Premium verteidigt die Marge statt den Anteil; das hält ihn länger am Leben.
  premium: { stark: "expansion", mittel: "konsolidierung", schwach: "rueckzug" },
  regional: { stark: "expansion", mittel: "konsolidierung", schwach: "rueckzug" },
  reseller: { stark: "preiskampf", mittel: "preiskampf", schwach: "rueckzug" },
  colo: { stark: "expansion", mittel: "konsolidierung", schwach: "konsolidierung" }
};
var STRATEGY_EFFECT = {
  expansion: { share: 0.012, price: 4e-3, healthCost: -0.012 },
  konsolidierung: { share: -2e-3, price: 0.012, healthCost: 0.02 },
  preiskampf: { share: 0.02, price: -0.028, healthCost: -0.045 },
  rueckzug: { share: -0.035, price: 0.02, healthCost: 0.035 }
};
function emptyCompetitors() {
  return {
    firms: COMPETITOR_TEMPLATES.map((template) => ({
      ...template,
      share: { ...template.share },
      health: 0.6,
      strategy: "konsolidierung",
      state: "aktiv"
    })),
    priceLevel: {},
    occupied: {}
  };
}
function bandOf(health) {
  if (health >= 0.66) return "stark";
  if (health >= 0.33) return "mittel";
  return "schwach";
}
function updateCompetitors(world, rng) {
  const state = world.competitors;
  const events = [];
  const konjunktur = world.economy.indices.konjunktur.value;
  const active = state.firms.filter((f) => f.state === "aktiv");
  for (const firm of active) {
    const focus = Object.keys(firm.share);
    const trend = focus.length ? focus.reduce((sum3, kind) => sum3 + (world.market.trends.demand[kind] ?? 1), 0) / focus.length : 1;
    const exposure = firm.archetype === "colo" ? 0.5 : firm.archetype === "premium" ? 0.75 : 1.15;
    const pressure = (konjunktur - 1) * exposure + (trend - 1) * 0.8;
    firm.health = clamp(firm.health + pressure * 0.06 + rng.normal(0, 0.012), 0, 1);
    const next = STRATEGY_TABLE[firm.archetype][bandOf(firm.health)];
    if (next !== firm.strategy) {
      firm.strategy = next;
      if (next === "preiskampf" || next === "rueckzug") {
        events.push({
          kind: "strategie",
          firm: firm.name,
          text: next === "preiskampf" ? `${firm.name} senkt die Preise auf breiter Front.` : `${firm.name} zieht sich aus Teilen des Marktes zur\xFCck.`
        });
      }
    }
    const effect = STRATEGY_EFFECT[firm.strategy];
    firm.priceLevel = clamp(firm.priceLevel + effect.price, 0.6, 1.8);
    firm.health = clamp(firm.health + effect.healthCost, 0, 1);
    for (const kind of focus) {
      const current = firm.share[kind] ?? 0;
      firm.share[kind] = clamp(current * (1 + effect.share), 0, 0.45);
    }
    if (firm.strategy === "expansion" && rng.chance(0.04)) {
      events.push({ kind: "expansion", firm: firm.name, text: `${firm.name} er\xF6ffnet einen weiteren Standort.` });
    }
  }
  for (const firm of active) {
    if (firm.health > 0.08) continue;
    const freed = Object.values(firm.share).reduce((sum3, value) => sum3 + (value ?? 0), 0);
    const buyer = state.firms.filter((f) => f.state === "aktiv" && f.id !== firm.id && f.health > 0.5).sort((a, b) => b.health - a.health)[0];
    if (buyer && rng.chance(0.55)) {
      firm.state = "uebernommen";
      firm.leftAtTick = world.meta.tick;
      for (const [kind, value] of Object.entries(firm.share)) {
        buyer.share[kind] = clamp((buyer.share[kind] ?? 0) + value * 0.75, 0, 0.45);
      }
      events.push({
        kind: "fusion",
        firm: firm.name,
        other: buyer.name,
        text: `${buyer.name} \xFCbernimmt ${firm.name}.`,
        // Ein Viertel der Kunden bleibt bei einer Übernahme nicht.
        freedShare: freed * 0.25
      });
    } else {
      firm.state = "insolvent";
      firm.leftAtTick = world.meta.tick;
      events.push({
        kind: "insolvenz",
        firm: firm.name,
        text: `${firm.name} meldet Insolvenz an.`,
        freedShare: freed
      });
    }
    firm.share = {};
  }
  recomputeAggregates(world);
  return events;
}
var MAX_OCCUPIED = 0.85;
function recomputeAggregates(world) {
  const state = world.competitors;
  const priceLevel = {};
  const occupied = {};
  const weighted = {};
  const active = state.firms.filter((firm) => firm.state === "aktiv");
  for (const firm of active) {
    for (const [kind, share] of Object.entries(firm.share)) {
      occupied[kind] = (occupied[kind] ?? 0) + share;
    }
  }
  for (const kind of Object.keys(occupied)) {
    const total = occupied[kind] ?? 0;
    if (total <= MAX_OCCUPIED) continue;
    const factor = MAX_OCCUPIED / total;
    for (const firm of active) {
      const share = firm.share[kind];
      if (share !== void 0) firm.share[kind] = share * factor;
    }
    occupied[kind] = MAX_OCCUPIED;
  }
  for (const firm of active) {
    for (const [kind, share] of Object.entries(firm.share)) {
      weighted[kind] = (weighted[kind] ?? 0) + share * firm.priceLevel;
    }
  }
  for (const kind of Object.keys(occupied)) {
    const total = occupied[kind] ?? 0;
    priceLevel[kind] = total > 0 ? (weighted[kind] ?? 0) / total : 1;
  }
  state.priceLevel = priceLevel;
  state.occupied = occupied;
}
function freeShareOf(world, kind) {
  const occupied = world.competitors.occupied[kind] ?? 0;
  return clamp(1 - occupied, 0.25, 1);
}
function competitorPriceLevel(world, kind) {
  return world.competitors.priceLevel[kind] ?? 1;
}
function playerShare(world, kind) {
  const occupied = world.competitors.occupied[kind] ?? 0;
  const contracts = Object.values(world.contracts).filter(
    (c) => c.state === "active" && world.products[c.productId]?.kind === kind
  ).length;
  if (contracts === 0) return 0;
  const estimated = contracts / 1e5;
  return clamp(estimated, 0, 1 - occupied);
}
function isCompetitorTick(tick2) {
  return tick2 > 0 && tick2 % SIM.TICKS_PER_MONTH === 0;
}
var REFERENCE_FREE_SHARE = (() => {
  const occupied = {};
  for (const template of COMPETITOR_TEMPLATES) {
    for (const [kind, share] of Object.entries(template.share)) {
      occupied[kind] = (occupied[kind] ?? 0) + share;
    }
  }
  const kinds = Object.keys(occupied);
  const sum3 = kinds.reduce((total, kind) => total + clamp(1 - (occupied[kind] ?? 0), 0.25, 1), 0);
  return kinds.length > 0 ? sum3 / kinds.length : 1;
})();
function marketPressure(world) {
  const kinds = Object.keys(world.competitors.occupied);
  if (kinds.length === 0) return 1;
  const average2 = kinds.reduce((sum3, kind) => sum3 + freeShareOf(world, kind), 0) / kinds.length;
  return clamp(average2 / REFERENCE_FREE_SHARE, 0.67, 1.2);
}

// src/domain/business/market.ts
var FIRST_NAMES = [
  "Anna",
  "Bernd",
  "Clara",
  "David",
  "Elif",
  "Felix",
  "Greta",
  "Hakan",
  "Ines",
  "Jonas",
  "Katrin",
  "Lars",
  "Mira",
  "Nils",
  "Olga",
  "Pawel",
  "Quentin",
  "Rosa",
  "Sven",
  "Tanja"
];
var LAST_NAMES = [
  "Schneider",
  "Weber",
  "Hoffmann",
  "Kr\xFCger",
  "Baumann",
  "Yilmaz",
  "Novak",
  "Dubois",
  "Rossi",
  "Jansen",
  "Andersson",
  "Kowalski",
  "Fischer",
  "Lehmann",
  "Vogel",
  "Brandt",
  "Sommer",
  "Winter",
  "Kraus",
  "Hansen"
];
var COMPANY_WORDS = [
  ["Nord", "S\xFCd", "Alpen", "Rhein", "Elbe", "Metro", "Delta", "Vertex", "Prisma", "Orbit"],
  ["Digital", "Media", "Software", "Commerce", "Systems", "Labs", "Studio", "Consulting", "Logistik", "Technik"],
  ["GmbH", "AG", "UG", "e.K.", "& Partner"]
];
function computeAttractiveness(product, reputation, competitorLevel = 1) {
  const template = findProductTemplate(productKeyOf(product));
  const reference = (template?.referencePrice ?? product.monthlyPrice) * competitorLevel;
  if (product.monthlyPrice <= 0) return 0;
  const priceRatio = reference / product.monthlyPrice;
  const priceScore = Math.pow(priceRatio, 1.6);
  const reputationScore = 0.35 + reputation / 100 * 1.05;
  const slaScore = 0.85 + (product.slaUptimePercent - 99) * 0.12;
  return clamp(priceScore * reputationScore * slaScore, 0, 12);
}
function productKeyOf(product) {
  const match = findProductTemplate(product.name.toLowerCase().replace(/\s+/g, "-"));
  if (match) return match.key;
  const byName = findProductTemplate(product.id);
  return byName?.key ?? product.id;
}
function refreshAttractiveness(world) {
  for (const product of values(world.products)) {
    product.attractiveness = computeAttractiveness(product, world.company.reputation, competitorPriceLevel(world, product.kind));
  }
}
function marketReach(world) {
  const cities = new Set(values(world.datacenters).map((d) => d.city));
  let reach = 0;
  for (const city of cities) {
    const location = LOCATIONS.find((l) => l.city === city);
    reach += (location?.marketPotential ?? 0.3) * regionFactorsOfCity(world, city).demand;
  }
  return reach;
}
function generateLeads(world, rng) {
  const settings = DIFFICULTY[world.meta.difficulty];
  refreshAttractiveness(world);
  const activeProducts = values(world.products).filter((p) => p.active && p.attractiveness > 0);
  if (activeProducts.length === 0) return [];
  const base = 1.4 * marketReach(world) * world.market.demandIndex * settings.demandMultiplier * world.economy.indices.konjunktur.value * marketPressure(world);
  const expected = base * (0.4 + world.company.reputation / 100);
  const count2 = Math.floor(expected) + (rng.chance(expected % 1) ? 1 : 0);
  const leads = [];
  for (let i = 0; i < count2; i++) {
    const product = rng.pickWeighted(activeProducts, (p) => {
      const template = findProductTemplate(productKeyOf(p));
      return (template?.demandWeight ?? 5) * p.attractiveness * world.market.trends.demand[p.kind] * freeShareOf(world, p.kind);
    });
    if (!product) continue;
    leads.push({ customer: createCustomer(world, rng, product), productId: product.id });
  }
  return leads;
}
function createCustomer(world, rng, product) {
  const segment = segmentForProduct(product, rng);
  const first = rng.pick(FIRST_NAMES) ?? "Alex";
  const last2 = rng.pick(LAST_NAMES) ?? "Muster";
  const isCompany = segment !== "private";
  const company = isCompany ? `${rng.pick(COMPANY_WORDS[0])}${rng.pick(COMPANY_WORDS[1])} ${rng.pick(COMPANY_WORDS[2])}` : null;
  return {
    id: asId(makeId(rng, "cus")),
    name: `${first} ${last2}`,
    company,
    segment,
    email: `${first.toLowerCase()}.${last2.toLowerCase().replace(/[^a-z]/g, "")}@example.${rng.pick(["de", "com", "net"])}`,
    satisfaction: rng.int(68, 88),
    balance: 0,
    contractIds: [],
    invoiceIds: [],
    ticketIds: [],
    domainIds: [],
    joinedAtTick: world.meta.tick,
    churnRisk: 0,
    reliability: clamp(rng.normal(segment === "enterprise" ? 0.93 : 0.85, 0.09), 0.4, 1),
    abandonedTickets: 0,
    notes: ""
  };
}
function segmentForProduct(product, rng) {
  switch (product.kind) {
    case "colocation":
      return rng.chance(0.6) ? "enterprise" : "smb";
    case "dedicated":
      return rng.chance(0.45) ? "enterprise" : rng.chance(0.6) ? "smb" : "reseller";
    case "vps":
      return rng.chance(0.35) ? "smb" : rng.chance(0.7) ? "private" : "reseller";
    // GPU-Compute ist Investitionsgut: Privatkunden trainieren keine Modelle.
    case "gpu-compute":
      return rng.chance(0.55) ? "enterprise" : "smb";
    case "container":
      return rng.chance(0.5) ? "smb" : rng.chance(0.6) ? "reseller" : "enterprise";
    // Game-Server werden meist von Communities/Privatpersonen gemietet.
    case "game-server":
      return rng.chance(0.75) ? "private" : "smb";
    default:
      return rng.chance(0.65) ? "private" : "smb";
  }
}
var ChurnReasons = ["ausfall", "support", "preis", "zahlung"];
var CHURN_REASON_LABEL = {
  ausfall: "Ausf\xE4lle",
  support: "Support",
  preis: "Preis",
  zahlung: "Zahlungsprobleme"
};
function emptyChurnReasons() {
  return { ausfall: 0, support: 0, preis: 0, zahlung: 0 };
}
function dominantReason(world, customer) {
  let downtime = 0;
  for (const id of customer.contractIds) {
    const contract = world.contracts[id];
    if (contract) downtime += contract.downtimeTicks;
  }
  if (downtime >= 4) return "ausfall";
  const stale = customer.ticketIds.some((id) => {
    const ticket = world.tickets[id];
    if (!ticket) return false;
    const open = ticket.state === "open" || ticket.state === "in-progress";
    return open && ticket.firstResponseTick === null && world.meta.tick - ticket.openedAtTick > 24;
  });
  if (stale || customer.abandonedTickets > 0) return "support";
  if (customer.balance < -50) return "zahlung";
  return "preis";
}
function updateChurn(world, rng) {
  const settings = DIFFICULTY[world.meta.difficulty];
  const churned = [];
  const churnPerTick = 8e-4;
  for (const customer of values(world.customers)) {
    const active = customer.contractIds.filter((id) => world.contracts[id]?.state === "active");
    if (active.length === 0) continue;
    const pressure = (60 - customer.satisfaction) / 100;
    customer.churnRisk = clamp(customer.churnRisk + pressure * 0.03 * settings.satisfactionDecay, 0, 1);
    if (customer.balance < -50) customer.churnRisk = clamp(customer.churnRisk + 4e-3, 0, 1);
    if (customer.churnRisk > 0.05 && rng.chance(customer.churnRisk * churnPerTick)) {
      churned.push(customer.id);
      const reason = dominantReason(world, customer);
      customer.churnReason = reason;
      world.derived.customers.churnReasons[reason] += 1;
    }
  }
  return churned;
}
function updateDemandIndex(world, rng) {
  const cyclePosition = world.meta.tick % (SIM.TICKS_PER_YEAR * 2) / (SIM.TICKS_PER_YEAR * 2);
  const cycle = 1 + 0.28 * Math.sin(cyclePosition * Math.PI * 2);
  const noise = rng.normal(0, 0.01);
  world.market.demandIndex = clamp(world.market.demandIndex * 0.98 + (cycle + noise) * 0.02, 0.45, 1.9);
}
function updateReputation(world) {
  const customers = values(world.customers).filter((c) => c.contractIds.some((id) => world.contracts[id]?.state === "active"));
  if (customers.length === 0) return;
  const avgSatisfaction = customers.reduce((s, c) => s + c.satisfaction, 0) / customers.length;
  world.company.reputation = clamp(world.company.reputation * 0.995 + avgSatisfaction * 5e-3, 0, 100);
}
function availableLocations(world) {
  const occupied = new Set(values(world.datacenters).map((d) => d.city));
  return LOCATIONS.filter((l) => !occupied.has(l.city)).map((l) => l.key);
}
function locationSetupCost(key) {
  return findLocation(key)?.setupCost ?? 0;
}

// src/domain/business/support-model.ts
function shiftCoverage(model, hourOfDay2) {
  const businessHours = hourOfDay2 >= 8 && hourOfDay2 < 18;
  const evening = hourOfDay2 >= 18 && hourOfDay2 < 22;
  switch (model) {
    case "day":
      return businessHours ? 1 : evening ? 0.15 : 0;
    case "oncall":
      return businessHours ? 1 : evening ? 0.5 : 0.25;
    case "shift":
      return businessHours ? 1 : evening ? 0.95 : 0.8;
  }
}
var SHIFT_SALARY_FACTOR = {
  day: 1,
  oncall: 1.25,
  shift: 1.7
};
var SHIFT_LABEL = {
  day: "B\xFCrozeiten",
  oncall: "Rufbereitschaft",
  shift: "Schichtbetrieb"
};
function hourOfDay(tick2) {
  return (tick2 % SIM.TICKS_PER_DAY + SIM.TICKS_PER_DAY) % SIM.TICKS_PER_DAY;
}
function fitFor(staff, category) {
  if (staff.specialties.includes(category)) return 1;
  const related = {
    technical: ["outage"],
    outage: ["technical"],
    billing: ["sales"],
    sales: ["billing"],
    abuse: ["technical"]
  };
  return related[category].some((c) => staff.specialties.includes(c)) ? 0.7 : 0.45;
}
function canHandle(staff, ticket) {
  return staff.level >= ticket.level;
}
function supportCapacity(world, speedModifier = 1) {
  const hour = hourOfDay(world.meta.tick);
  const agents = values(world.staff).filter((s) => s.role === "support");
  const byLevel = { 1: 0, 2: 0, 3: 0 };
  let available = 0;
  for (const agent of agents) {
    const coverage = shiftCoverage(agent.shift, hour);
    if (coverage <= 0) continue;
    available += coverage;
    byLevel[agent.level] += 3.2 * (0.6 + agent.skill / 10) * coverage * speedModifier;
  }
  return {
    byLevel,
    total: byLevel[1] + byLevel[2] + byLevel[3],
    coverage: agents.length > 0 ? available / agents.length : 0,
    hour
  };
}
var ABUSE_DEADLINE_TICKS = 24;
var CUSTOMER_REPLY_TICKS = { min: 2, max: 30 };
var MAX_FREE_CLARIFICATIONS = 1;
var ATTEMPTS_BEFORE_ESCALATION = 2;
var DEFAULT_SPECIALTIES = {
  support: ["technical", "billing"],
  technician: ["technical", "outage"],
  "network-engineer": ["outage", "technical"],
  sales: ["sales", "billing"],
  security: ["abuse", "technical"]
};

// src/domain/business/tickets.ts
var RESPONSE_SLA = {
  urgent: 1,
  high: 4,
  normal: 12,
  low: 24
};
var SUBJECTS = {
  technical: [
    "Website l\xE4dt sehr langsam",
    "SSH-Zugang funktioniert nicht",
    "Speicherplatz voll",
    "Cronjob wird nicht ausgef\xFChrt",
    "PHP-Version aktualisieren",
    "Backup wiederherstellen"
  ],
  billing: [
    "Rechnung nicht nachvollziehbar",
    "Bitte um Zahlungsaufschub",
    "Tarifwechsel gew\xFCnscht",
    "Rechnungsanschrift \xE4ndern"
  ],
  abuse: ["Beschwerde \xFCber Spam von Ihrer IP", "Phishing-Seite auf Kundenserver gemeldet", "Portscans aus Ihrem Netz"],
  sales: ["Angebot f\xFCr gr\xF6\xDFeren Server", "Frage zu Colocation", "Rabatt bei Jahreszahlung?"],
  outage: ["Server nicht erreichbar", "Kompletter Ausfall seit einigen Minuten", "Hohe Paketverluste"]
};
var REPLIES = {
  technical: ["Wir haben die Konfiguration angepasst und den Dienst neu gestartet.", "Das Problem lie\xDF sich reproduzieren und ist behoben."],
  billing: ["Die Rechnung wurde korrigiert und neu versendet.", "Wir haben eine Ratenzahlung hinterlegt."],
  abuse: ["Der betroffene Account wurde gesperrt und der Kunde informiert.", "Wir haben die Quelle identifiziert und den Traffic gefiltert."],
  sales: ["Ein passendes Angebot ist unterwegs.", "Wir haben Ihnen einen individuellen Tarif erstellt."],
  outage: ["Die St\xF6rung ist behoben, alle Dienste laufen wieder.", "Ursache war ein Hardwaredefekt, das Ger\xE4t wurde ersetzt."]
};
var CLARIFICATIONS = {
  technical: [
    "K\xF6nnen Sie uns die genaue Fehlermeldung und den Zeitpunkt nennen?",
    "Tritt das Problem bei allen Domains auf oder nur bei einer bestimmten?"
  ],
  billing: ["Um welche Rechnungsnummer geht es genau?", "K\xF6nnen Sie uns die abweichende Position benennen?"],
  abuse: ["Bitte senden Sie uns die vollst\xE4ndigen Kopfzeilen der betroffenen Nachricht.", "Um welche IP-Adresse und welchen Zeitraum geht es?"],
  sales: ["Mit welchem Bedarf rechnen Sie in den n\xE4chsten Monaten?", "Welche Anforderungen sind Ihnen am wichtigsten?"],
  outage: ["Betrifft die St\xF6rung alle Ihre Dienste oder nur einen bestimmten?", "Von welchem Anschluss aus testen Sie?"]
};
var CUSTOMER_REPLIES = [
  "Anbei die angeforderten Angaben.",
  "Entschuldigen Sie die sp\xE4te R\xFCckmeldung \u2013 hier die Details.",
  "Ich habe das noch einmal gepr\xFCft, das Problem besteht weiterhin.",
  "Die gew\xFCnschten Informationen habe ich beigef\xFCgt."
];
var REOPEN_REASONS = [
  "Das Problem ist wieder aufgetreten.",
  "Leider hat das nicht geholfen, es ist unver\xE4ndert.",
  "Nach zwei Stunden war der Fehler zur\xFCck."
];
function createTicket(world, rng, input) {
  const subject = input.subject ?? rng.pick(SUBJECTS[input.category]) ?? "Anfrage";
  const ticket = {
    id: asId(makeId(rng, "tkt")),
    customerId: input.customerId,
    subject,
    category: input.category,
    priority: input.priority,
    state: "open",
    messages: [{ tick: world.meta.tick, author: "customer", body: input.body ?? `${subject}. Bitte um Pr\xFCfung.` }],
    openedAtTick: world.meta.tick,
    firstResponseTick: null,
    resolvedAtTick: null,
    assignedStaffId: null,
    ref: input.ref ?? null,
    satisfactionImpact: input.satisfactionImpact ?? 4,
    level: 1,
    attempts: 0,
    escalations: 0,
    waitingSinceTick: null,
    reopenCount: 0,
    // Nur Abuse hat eine Frist, die jemand von außen überwacht.
    dueAtTick: input.category === "abuse" ? world.meta.tick + ABUSE_DEADLINE_TICKS : null,
    breached: false
  };
  world.tickets[ticket.id] = ticket;
  if (input.customerId) world.customers[input.customerId]?.ticketIds.push(ticket.id);
  return ticket;
}
function supportThroughput(world, supportSpeedModifier = 1) {
  return supportCapacity(world, supportSpeedModifier).total;
}
function processTickets(world, rng, supportSpeedModifier = 1) {
  const capacity = supportCapacity(world, supportSpeedModifier);
  const priorityRank = { urgent: 0, high: 1, normal: 2, low: 3 };
  const clarifications = advanceWaitingTickets(world, rng);
  const breaches = enforceDeadlines(world);
  const queue = values(world.tickets).filter((t) => t.state === "open" || t.state === "in-progress").sort((a, b) => {
    const aDue = a.dueAtTick ?? Infinity;
    const bDue = b.dueAtTick ?? Infinity;
    if (aDue !== bDue) return aDue - bDue;
    return priorityRank[a.priority] - priorityRank[b.priority] || a.openedAtTick - b.openedAtTick;
  });
  const agents = values(world.staff).filter((s) => s.role === "support" && shiftCoverage(s.shift, capacity.hour) > 0);
  const budget = { ...capacity.byLevel };
  let resolved = 0;
  let escalated = 0;
  const spendTime = (level, amount) => {
    let remaining = amount;
    for (let l = level; l <= 3; l++) {
      const take = Math.min(budget[l], remaining);
      budget[l] -= take;
      remaining -= take;
      if (remaining <= 0) return true;
    }
    return remaining < amount;
  };
  const hasTimeFor = (level) => budget[level] > 0 || level < 3 && (budget[2] > 0 || budget[3] > 0);
  for (const ticket of queue) {
    if (budget[1] <= 0 && budget[2] <= 0 && budget[3] <= 0) break;
    if (!hasTimeFor(ticket.level)) continue;
    if (ticket.firstResponseTick === null) {
      const agent2 = pickAgent(rng, agents, ticket);
      ticket.firstResponseTick = world.meta.tick;
      ticket.state = "in-progress";
      ticket.assignedStaffId = agent2?.id ?? null;
      ticket.messages.push({
        tick: world.meta.tick,
        author: "staff",
        body: "Vielen Dank f\xFCr Ihre Meldung, wir k\xFCmmern uns darum."
      });
      spendTime(ticket.level, 0.4);
      continue;
    }
    if (ticket.category === "outage" && !underlyingIssueResolved(world, ticket)) continue;
    if (ticket.category === "outage") {
      closeTicket(world, ticket, "Die St\xF6rung ist behoben. Wir bitten die Unterbrechung zu entschuldigen.");
      resolved += 1;
      spendTime(ticket.level, 0.1);
      continue;
    }
    const agent = ticket.assignedStaffId ? world.staff[ticket.assignedStaffId] : void 0;
    const fit = agent ? fitFor(agent, ticket.category) : 0.45;
    const skill = agent?.skill ?? 3;
    const cost = 1 / Math.max(0.4, fit);
    const chance = clamp((0.5 + skill * 0.05) * fit + (ticket.level - 1) * 0.12, 0.2, 0.95);
    if (rng.chance(chance)) {
      closeTicket(world, ticket, rng.pick(REPLIES[ticket.category]) ?? "Das Anliegen ist erledigt.");
      resolved += 1;
    } else {
      ticket.attempts += 1;
      if (ticket.escalations < MAX_FREE_CLARIFICATIONS && rng.chance(0.35)) {
        askCustomer(world, rng, ticket);
      } else if (ticket.attempts >= ATTEMPTS_BEFORE_ESCALATION) {
        if (escalate(world, ticket, agents)) escalated += 1;
      }
    }
    spendTime(ticket.level, cost);
  }
  reopenUnsatisfactory(world, rng);
  decayUnanswered(world);
  const abandoned = abandonUnanswered(world);
  recoverSatisfaction(world);
  archiveOldTickets(world);
  return { resolved, escalated, clarifications, breaches, abandoned, coverage: capacity.coverage };
}
function reopenUnsatisfactory(world, rng) {
  for (const ticket of values(world.tickets)) {
    if (ticket.state !== "resolved" || ticket.resolvedAtTick === null) continue;
    const since = world.meta.tick - ticket.resolvedAtTick;
    if (since < 2 || since > SIM.TICKS_PER_DAY * 2) continue;
    if (ticket.reopenCount >= 2) continue;
    if (ticket.category === "outage" || ticket.category === "sales") continue;
    const agent = ticket.assignedStaffId ? world.staff[ticket.assignedStaffId] : void 0;
    const quality = agent ? (0.4 + agent.skill * 0.06) * fitFor(agent, ticket.category) : 0.3;
    if (!rng.chance((1 - quality) * 0.02)) continue;
    ticket.state = "open";
    ticket.resolvedAtTick = null;
    ticket.reopenCount += 1;
    ticket.attempts = 0;
    ticket.priority = ticket.priority === "low" ? "normal" : ticket.priority === "normal" ? "high" : ticket.priority;
    ticket.messages.push({
      tick: world.meta.tick,
      author: "customer",
      body: rng.pick(REOPEN_REASONS) ?? "Das Problem besteht weiterhin."
    });
    const customer = ticket.customerId ? world.customers[ticket.customerId] : void 0;
    if (customer) customer.satisfaction = clamp(customer.satisfaction - 3, 0, 100);
  }
}
function pickAgent(rng, agents, ticket) {
  const eligible = agents.filter((a) => canHandle(a, ticket));
  if (eligible.length === 0) return void 0;
  return rng.pickWeighted(eligible, (a) => fitFor(a, ticket.category) ** 2);
}
function closeTicket(world, ticket, body) {
  ticket.state = "resolved";
  ticket.resolvedAtTick = world.meta.tick;
  ticket.waitingSinceTick = null;
  ticket.messages.push({ tick: world.meta.tick, author: "staff", body });
  applySatisfaction(world, ticket);
}
function askCustomer(world, rng, ticket) {
  ticket.state = "waiting-customer";
  ticket.waitingSinceTick = world.meta.tick;
  ticket.escalations += 1;
  ticket.messages.push({
    tick: world.meta.tick,
    author: "staff",
    body: rng.pick(CLARIFICATIONS[ticket.category]) ?? "K\xF6nnen Sie uns weitere Angaben machen?"
  });
  const customer = ticket.customerId ? world.customers[ticket.customerId] : void 0;
  if (customer) customer.satisfaction = clamp(customer.satisfaction - 0.5, 0, 100);
}
function escalate(world, ticket, agents) {
  if (ticket.level >= 3) {
    ticket.attempts = 0;
    return false;
  }
  const next = ticket.level + 1;
  if (!agents.some((a) => a.level >= next)) {
    ticket.attempts = 0;
    return false;
  }
  ticket.level = next;
  ticket.attempts = 0;
  ticket.escalations += 1;
  ticket.assignedStaffId = null;
  ticket.messages.push({
    tick: world.meta.tick,
    author: "system",
    body: `An ${next}. Level weitergegeben.`
  });
  return true;
}
function advanceWaitingTickets(world, rng) {
  let replies = 0;
  for (const ticket of values(world.tickets)) {
    if (ticket.state !== "waiting-customer" || ticket.waitingSinceTick === null) continue;
    const waited = world.meta.tick - ticket.waitingSinceTick;
    if (waited < CUSTOMER_REPLY_TICKS.min) continue;
    const replyChance = 0.12 + waited / (CUSTOMER_REPLY_TICKS.max * 4);
    if (rng.chance(replyChance)) {
      ticket.state = "in-progress";
      ticket.waitingSinceTick = null;
      ticket.messages.push({
        tick: world.meta.tick,
        author: "customer",
        body: rng.pick(CUSTOMER_REPLIES) ?? "Anbei die Angaben."
      });
      replies += 1;
      continue;
    }
    if (waited > SIM.TICKS_PER_DAY * 7) {
      ticket.state = "closed";
      ticket.resolvedAtTick = world.meta.tick;
      ticket.waitingSinceTick = null;
      ticket.messages.push({
        tick: world.meta.tick,
        author: "system",
        body: "Ohne R\xFCckmeldung geschlossen."
      });
    }
  }
  return replies;
}
function enforceDeadlines(world) {
  const breached = [];
  for (const ticket of values(world.tickets)) {
    if (ticket.breached || ticket.dueAtTick === null) continue;
    if (ticket.state === "resolved" || ticket.state === "closed") continue;
    if (world.meta.tick < ticket.dueAtTick) continue;
    ticket.breached = true;
    ticket.priority = "urgent";
    ticket.messages.push({
      tick: world.meta.tick,
      author: "system",
      body: "Bearbeitungsfrist \xFCberschritten \u2013 der Beschwerdef\xFChrer hat den Upstream eingeschaltet."
    });
    world.company.reputation = clamp(world.company.reputation - 4, 0, 100);
    breached.push({ ticketId: ticket.id, subject: ticket.subject });
  }
  return breached;
}
function abuseDeadlines(world) {
  return values(world.tickets).filter((t) => t.dueAtTick !== null && t.state !== "resolved" && t.state !== "closed").map((ticket) => ({
    ticket,
    hoursLeft: (ticket.dueAtTick ?? 0) - world.meta.tick,
    breached: ticket.breached
  })).sort((a, b) => a.hoursLeft - b.hoursLeft);
}
var ABANDON_AFTER = SIM.TICKS_PER_MONTH * 2;
function abandonUnanswered(world) {
  let aufgegeben = 0;
  for (const ticket of values(world.tickets)) {
    if (ticket.state === "resolved" || ticket.state === "closed") continue;
    if (ticket.firstResponseTick !== null) continue;
    if (world.meta.tick - ticket.openedAtTick < ABANDON_AFTER) continue;
    const customer = ticket.customerId ? world.customers[ticket.customerId] : null;
    if (customer) {
      customer.abandonedTickets += 1;
      customer.ticketIds = customer.ticketIds.filter((id) => id !== ticket.id);
      customer.satisfaction = clamp(customer.satisfaction - 10, 0, 100);
    }
    delete world.tickets[ticket.id];
    aufgegeben += 1;
  }
  return aufgegeben;
}
function archiveOldTickets(world) {
  for (const ticket of values(world.tickets)) {
    if (ticket.state !== "resolved" && ticket.state !== "closed") continue;
    if (ticket.resolvedAtTick === null) continue;
    if (world.meta.tick - ticket.resolvedAtTick < SIM.TICKS_PER_MONTH) continue;
    if (ticket.customerId) {
      const customer = world.customers[ticket.customerId];
      if (customer) customer.ticketIds = customer.ticketIds.filter((id) => id !== ticket.id);
    }
    delete world.tickets[ticket.id];
  }
}
function underlyingIssueResolved(world, ticket) {
  if (!ticket.ref) return true;
  switch (ticket.ref.kind) {
    case "server": {
      const server = world.servers[ticket.ref.id];
      return !server || server.state === "online";
    }
    case "link": {
      const link = world.links[ticket.ref.id];
      return !link || link.state === "up";
    }
    case "router": {
      const router = world.routers[ticket.ref.id];
      return !router || router.state === "online";
    }
    default:
      return true;
  }
}
function hasHostedContract(world, customer) {
  return customer.contractIds.some((id) => {
    const contract = world.contracts[id];
    return contract?.state === "active" && !!(contract.serverId || contract.vpsId || contract.poolId || contract.rackId);
  });
}
function applySatisfaction(world, ticket) {
  if (!ticket.customerId) return;
  const customer = world.customers[ticket.customerId];
  if (!customer) return;
  const responseTime = (ticket.firstResponseTick ?? ticket.openedAtTick) - ticket.openedAtTick;
  const target = RESPONSE_SLA[ticket.priority];
  const bonus = responseTime <= target ? ticket.satisfactionImpact : ticket.satisfactionImpact * 0.15;
  customer.satisfaction = clamp(customer.satisfaction + bonus, 0, 100);
  customer.churnRisk = clamp(customer.churnRisk - 0.05, 0, 1);
}
var MAX_OVERDUE_FACTOR = 4;
function decayUnanswered(world) {
  const settings = DIFFICULTY[world.meta.difficulty];
  for (const ticket of values(world.tickets)) {
    if (ticket.state !== "open" && ticket.state !== "in-progress") continue;
    const age = world.meta.tick - ticket.openedAtTick;
    const target = RESPONSE_SLA[ticket.priority];
    if (age <= target) continue;
    if (!ticket.customerId) continue;
    const customer = world.customers[ticket.customerId];
    if (!customer) continue;
    const overdue = Math.min(MAX_OVERDUE_FACTOR, (age - target) / Math.max(1, target));
    customer.satisfaction = clamp(customer.satisfaction - 0.03 * overdue * settings.satisfactionDecay, 0, 100);
  }
}
function recoverSatisfaction(world) {
  for (const customer of values(world.customers)) {
    const hasOpenTicket = customer.ticketIds.some((id) => {
      const ticket = world.tickets[id];
      return ticket && (ticket.state === "open" || ticket.state === "in-progress");
    });
    if (hasOpenTicket) continue;
    const decke = Math.max(40, 100 - 20 * customer.abandonedTickets);
    if (customer.satisfaction >= decke) continue;
    customer.satisfaction = clamp(customer.satisfaction + 0.05, 0, decke);
  }
}
function generateIncidentTickets(world, rng, context) {
  const created = [];
  const affected = values(world.customers).filter((c) => c.contractIds.some((id) => world.contracts[id]?.state === "active"));
  if (affected.length === 0) return created;
  const hosted = affected.filter((c) => hasHostedContract(world, c));
  const openByCustomer = /* @__PURE__ */ new Map();
  for (const ticket of values(world.tickets)) {
    if (ticket.state !== "open" && ticket.state !== "in-progress") continue;
    if (!ticket.customerId) continue;
    let set = openByCustomer.get(ticket.customerId);
    if (!set) {
      set = /* @__PURE__ */ new Set();
      openByCustomer.set(ticket.customerId, set);
    }
    set.add(ticket.category);
  }
  const hasOpen = (customerId, category) => openByCustomer.get(customerId)?.has(category) ?? false;
  if (context.reachability < 0.9) {
    const share = (0.9 - context.reachability) * 0.35;
    for (const customer of hosted) {
      if (hasOpen(customer.id, "outage")) continue;
      if (!rng.chance(share)) continue;
      created.push(
        createTicket(world, rng, {
          customerId: customer.id,
          category: "outage",
          priority: context.reachability < 0.5 ? "urgent" : "high",
          satisfactionImpact: 8
        })
      );
    }
  }
  if (context.packetLoss > 1.5 || context.congested > 0) {
    for (const customer of affected) {
      if (hasOpen(customer.id, "technical")) continue;
      if (!rng.chance(6e-4 + context.packetLoss * 8e-4)) continue;
      created.push(
        createTicket(world, rng, {
          customerId: customer.id,
          subject: "Verbindungsabbr\xFCche und hohe Latenz",
          category: "technical",
          priority: "high",
          satisfactionImpact: 5
        })
      );
    }
  }
  const idle = affected.filter((c) => !openByCustomer.has(c.id));
  const routineRate = idle.length * 16e-5;
  const routineCount = Math.floor(routineRate) + (rng.chance(routineRate % 1) ? 1 : 0);
  for (let i = 0; i < routineCount; i++) {
    const category = rng.pickWeighted(
      ["technical", "billing", "sales", "abuse"],
      (c) => c === "technical" ? 6 : c === "billing" ? 3 : c === "sales" ? 2 : 1
    );
    const candidates = category === "billing" ? idle.filter((c) => c.invoiceIds.length > 0) : idle;
    const customer = rng.pick(candidates);
    if (!customer) continue;
    created.push(
      createTicket(world, rng, {
        customerId: customer.id,
        category: category ?? "technical",
        priority: rng.chance(0.15) ? "high" : rng.chance(0.5) ? "normal" : "low"
      })
    );
  }
  return created;
}
function bulkProcessTickets(world, ticketIds, input) {
  const result = { resolved: 0, replied: 0, skipped: [] };
  for (const id of ticketIds) {
    const ticket = world.tickets[id];
    if (!ticket) continue;
    if (ticket.state === "resolved" || ticket.state === "closed") continue;
    if (ticket.category === "outage" && !underlyingIssueResolved(world, ticket)) {
      result.skipped.push({ ticketId: id, reason: "Die Ursache der St\xF6rung besteht noch." });
      continue;
    }
    ticket.messages.push({ tick: world.meta.tick, author: "staff", body: input.body });
    if (ticket.firstResponseTick === null) ticket.firstResponseTick = world.meta.tick;
    if (!input.resolve) {
      ticket.state = "in-progress";
      result.replied += 1;
      continue;
    }
    ticket.state = "resolved";
    ticket.resolvedAtTick = world.meta.tick;
    ticket.waitingSinceTick = null;
    if (ticket.category === "outage") {
      applySatisfaction(world, ticket);
    } else {
      ticket.assignedStaffId = null;
      const customer = ticket.customerId ? world.customers[ticket.customerId] : void 0;
      if (customer) customer.satisfaction = clamp(customer.satisfaction - 1, 0, 100);
    }
    result.resolved += 1;
  }
  return result;
}
function closableOutageTickets(world) {
  return values(world.tickets).filter(
    (t) => (t.state === "open" || t.state === "in-progress") && t.category === "outage" && underlyingIssueResolved(world, t)
  );
}
function replyToTicket(world, ticketId, body, resolve) {
  const ticket = world.tickets[ticketId];
  if (!ticket) return false;
  ticket.messages.push({ tick: world.meta.tick, author: "staff", body });
  if (ticket.firstResponseTick === null) ticket.firstResponseTick = world.meta.tick;
  if (resolve) {
    ticket.state = "resolved";
    ticket.resolvedAtTick = world.meta.tick;
    applySatisfaction(world, ticket);
  } else {
    ticket.state = "in-progress";
  }
  return true;
}
function ticketStats(world) {
  const all = values(world.tickets);
  const open = all.filter((t) => t.state === "open" || t.state === "in-progress");
  const overdue = open.filter((t) => world.meta.tick - t.openedAtTick > RESPONSE_SLA[t.priority] && t.firstResponseTick === null);
  const responded = all.filter((t) => t.firstResponseTick !== null);
  const avg = responded.length ? responded.reduce((s, t) => s + (t.firstResponseTick - t.openedAtTick), 0) / responded.length : 0;
  const resolvedRecently = all.filter(
    (t) => t.resolvedAtTick !== null && world.meta.tick - t.resolvedAtTick <= SIM.TICKS_PER_DAY
  ).length;
  return {
    open: open.length,
    urgent: open.filter((t) => t.priority === "urgent").length,
    overdue: overdue.length,
    avgFirstResponseTicks: avg,
    resolvedLast24h: resolvedRecently,
    waitingCustomer: all.filter((t) => t.state === "waiting-customer").length,
    escalated: open.filter((t) => t.level > 1).length,
    breached: all.filter((t) => t.breached && t.state !== "resolved" && t.state !== "closed").length,
    reopened: all.filter((t) => t.reopenCount > 0).length,
    coverage: supportCapacity(world).coverage
  };
}
function ticketServices(world, ticket) {
  const contractIds = [];
  if (ticket.ref?.kind === "contract") {
    contractIds.push(ticket.ref.id);
  } else if (ticket.ref?.kind === "server") {
    const server = world.servers[ticket.ref.id];
    if (server) {
      const eigene = ticket.customerId ? server.contractIds.filter((id) => world.contracts[id]?.customerId === ticket.customerId) : server.contractIds;
      contractIds.push(...eigene);
    }
  } else if (ticket.customerId) {
    const customer = world.customers[ticket.customerId];
    contractIds.push(...customer?.contractIds ?? []);
  }
  const services = [];
  for (const contractId of contractIds) {
    const contract = world.contracts[contractId];
    if (!contract || contract.state === "cancelled") continue;
    const product = world.products[contract.productId];
    const server = contract.serverId ? world.servers[contract.serverId] : null;
    services.push({
      contractId,
      productName: product?.name ?? "Unbekanntes Produkt",
      productKind: product?.kind ?? "\u2013",
      serverId: server?.id ?? null,
      serverName: server?.name ?? null,
      datacenterCity: server ? world.datacenters[server.datacenterId]?.city ?? null : null
    });
  }
  return services;
}
var TICKET_CONTEXT_RESEARCH = "res-support-tooling";
function hasTicketContext(world) {
  return world.research[TICKET_CONTEXT_RESEARCH]?.completed === true;
}

// src/domain/business/sales-calls.ts
var CALLERS = [
  {
    key: "cocknet",
    name: "Cocknet Communications",
    pushiness: 2.4,
    fairness: 1.16,
    sells: ["transit", "ip-block", "colocation"],
    pitches: [
      "Guten Tag! Ich habe gesehen, Sie sind neu im Gesch\xE4ft \u2013 da habe ich genau das Richtige f\xFCr Sie.",
      "Ganz kurz nur: Wir r\xE4umen gerade Kapazit\xE4t frei und ich denke da sofort an Sie.",
      "Ich wei\xDF, Sie sind besch\xE4ftigt, deshalb komme ich direkt zum Punkt.",
      "Mein Kollege hat Sie vor zwei Wochen schon angeschrieben \u2013 ich hake nur kurz nach."
    ]
  },
  {
    key: "nordwerk",
    name: "Nordwerk Carrier Solutions",
    pushiness: 1,
    fairness: 0.94,
    sells: ["transit", "fiber"],
    pitches: [
      "Wir bauen gerade eine neue Strecke aus und suchen Ankerkunden.",
      "Sie zahlen bei Ihrem jetzigen Anbieter vermutlich zu viel. Darf ich Ihnen etwas rechnen?"
    ]
  },
  {
    key: "addrpool",
    name: "AddrPool Brokerage",
    pushiness: 1.3,
    fairness: 1.02,
    sells: ["ip-block"],
    pitches: [
      "Uns wurde ein Block angedient, der gut zu Ihrem Bestand passen w\xFCrde.",
      "IPv4 wird nicht billiger. Wer jetzt kauft, kauft am g\xFCnstigsten."
    ]
  },
  {
    key: "refurbo",
    name: "Refurbo Systems",
    pushiness: 1.1,
    fairness: 0.62,
    sells: ["hardware"],
    pitches: [
      "Wir l\xF6sen gerade ein Rechenzentrum auf \u2013 die Hardware ist zwei Jahre alt und gepr\xFCft.",
      "Neuware brauchen Sie daf\xFCr wirklich nicht. H\xF6ren Sie sich das mal an."
    ]
  },
  {
    key: "ixassist",
    name: "IX-Assist Peering",
    pushiness: 0.8,
    fairness: 0.9,
    sells: ["peering", "colocation"],
    pitches: [
      "Sie sind an keinem Knoten pr\xE4sent, oder? Da verschenken Sie Geld an Ihre Upstreams.",
      "Wir vermitteln Direktverbindungen zu Netzen, die sonst nicht mit Ihnen reden."
    ]
  }
];
function judgeOffer(ratio) {
  if (ratio <= 0.85) return "schnaeppchen";
  if (ratio <= 1.05) return "marktueblich";
  if (ratio <= 1.25) return "teuer";
  return "wucher";
}
var VERDICT_LABEL = {
  schnaeppchen: "deutlich unter Markt",
  marktueblich: "markt\xFCblich",
  teuer: "\xFCber Markt",
  wucher: "weit \xFCber Markt"
};
function updateSalesCalls(world, rng) {
  world.market.offers = world.market.offers.filter((o) => o.expiresAtTick > world.meta.tick);
  const customers = Object.keys(world.customers).length;
  const visibility = Math.min(1, world.company.reputation / 100 * 0.5 + Math.min(1, customers / 400) * 0.5);
  const rate = (6e-3 + visibility * 0.02) * (world.market.offers.length >= 4 ? 0.2 : 1);
  if (!rng.chance(rate)) return [];
  const caller = rng.pickWeighted(CALLERS, (c) => c.pushiness);
  if (!caller) return [];
  const kind = rng.pick(caller.sells);
  if (!kind) return [];
  const offer = buildOffer(world, rng, caller, kind);
  if (!offer) return [];
  world.market.offers.push(offer);
  return [offer];
}
function buildOffer(world, rng, caller, kind) {
  const pitch = rng.pick(caller.pitches) ?? "";
  const ratio = Math.max(0.55, caller.fairness + rng.normal(0, 0.12));
  const validTicks = Math.round(SIM.TICKS_PER_DAY * (2 + rng.next() * 5));
  const base = {
    id: makeId(rng, "off"),
    sellerName: caller.name,
    expiresAtTick: world.meta.tick + validTicks
  };
  switch (kind) {
    case "transit":
      return buildTransitOffer(world, rng, caller, base, pitch, ratio);
    case "ip-block":
      return buildIpOffer(world, rng, base, pitch, ratio);
    case "hardware":
      return buildHardwareOffer(world, rng, base, pitch, ratio);
    case "colocation":
      return buildColocationOffer(world, rng, base, pitch, ratio);
    case "peering":
      return buildPeeringOffer(world, rng, base, pitch, ratio);
    default:
      return null;
  }
}
function buildTransitOffer(world, rng, caller, base, pitch, ratio) {
  const provider = rng.pickWeighted(
    world.market.providers.filter((p) => p.transitPricePerMbps > 0),
    (p) => p.kind === "tier2" ? 2 : 1
  );
  if (!provider) return null;
  const capacityMbps = rng.pick([1e3, 1e4, 1e4, 25e3]) ?? 1e4;
  const committedMbps = Math.round(capacityMbps * (rng.next() < 0.5 ? 0.1 : 0.25));
  const pricePerMbps = Number((provider.transitPricePerMbps * ratio).toFixed(3));
  const monthlyPrice = Math.round(committedMbps * pricePerMbps);
  const termMonths = ratio > 1.05 ? rng.pick([24, 36]) ?? 24 : rng.pick([12, 12, 24]) ?? 12;
  return {
    ...base,
    kind: "transit",
    sellerAsn: provider.asn,
    title: `Transit ${formatCapacity(capacityMbps)} \xFCber ${provider.name}`,
    description: `${pitch} ${capacityMbps >= 1e4 ? "Ein" : "Ein kleiner"} Anschluss mit ${formatCapacity(capacityMbps)} Port, ${committedMbps} Mbit/s Commit zu ${pricePerMbps.toFixed(3)} \u20AC je Mbit/s, Mindestlaufzeit ${termMonths} Monate. Der \xFCbliche Satz von ${provider.name} liegt bei ${provider.transitPricePerMbps.toFixed(3)} \u20AC.`,
    monthlyPrice,
    setupPrice: ratio < 0.95 ? 0 : Math.round(500 + rng.next() * 1500),
    payload: {
      providerAsn: provider.asn,
      capacityMbps,
      committedMbps,
      pricePerMbps,
      termMonths,
      listPricePerMbps: provider.transitPricePerMbps,
      priceRatio: Number(ratio.toFixed(3)),
      verdict: judgeOffer(ratio),
      needsPort: true,
      caller: caller.key
    }
  };
}
function buildIpOffer(world, rng, base, pitch, ratio) {
  const length = rng.pick([24, 24, 23, 22]) ?? 24;
  const listPrice = ipv4BlockPrice(world, length);
  const price = Math.round(listPrice * ratio);
  return {
    ...base,
    kind: "ip-block",
    sellerAsn: 0,
    title: `IPv4-Block /${length} (${2 ** (32 - length)} Adressen)`,
    description: `${pitch} Ein sauberer /${length} ohne Vorbelastung, \xDCbertragung \xFCber den RIR. Verlangt werden ${price.toLocaleString("de-DE")} \u20AC; der Marktwert liegt bei etwa ${listPrice.toLocaleString("de-DE")} \u20AC.`,
    monthlyPrice: 0,
    setupPrice: price,
    payload: {
      family: "ipv4",
      length,
      listPrice,
      priceRatio: Number(ratio.toFixed(3)),
      verdict: judgeOffer(ratio)
    }
  };
}
function buildHardwareOffer(world, rng, base, pitch, ratio) {
  const model = rng.pick(SERVER_MODELS.filter((m) => m.requiresResearch === null)) ?? SERVER_MODELS[0];
  const quantity = rng.pick([2, 3, 4, 6]) ?? 2;
  const health = 0.62 + rng.next() * 0.2;
  const unitPrice = Math.round(model.price * ratio);
  return {
    ...base,
    kind: "hardware",
    sellerAsn: 0,
    title: `${quantity}\xD7 ${model.name} aus zweiter Hand`,
    description: `${pitch} ${quantity} St\xFCck ${model.name}, Zustand rund ${(health * 100).toFixed(0)} %, je ${unitPrice.toLocaleString("de-DE")} \u20AC statt ${model.price.toLocaleString("de-DE")} \u20AC Neupreis. Gew\xE4hrleistung gibt es keine \u2013 ein Ausfall kommt fr\xFCher als bei Neuware.`,
    monthlyPrice: model.maintenancePerMonth * quantity,
    setupPrice: unitPrice * quantity,
    payload: {
      modelKey: model.key,
      quantity,
      unitPrice,
      health: Number(health.toFixed(2)),
      listPrice: model.price,
      priceRatio: Number(ratio.toFixed(3)),
      verdict: judgeOffer(ratio),
      needsRack: true
    }
  };
}
function buildColocationOffer(world, rng, base, pitch, ratio) {
  const open = new Set(values(world.datacenters).map((d) => d.city));
  const location = rng.pick(LOCATIONS.filter((l) => !open.has(l.city)));
  if (!location) return null;
  const monthlyPrice = Math.round(location.monthlyRent * ratio);
  return {
    ...base,
    kind: "colocation",
    sellerAsn: 0,
    title: `Fl\xE4che in ${location.city}`,
    description: `${pitch} Ein Standort in ${location.city} (${location.country}) mit sofort verf\xFCgbarer Fl\xE4che. ${monthlyPrice.toLocaleString("de-DE")} \u20AC Grundmiete im Monat statt der \xFCblichen ${location.monthlyRent.toLocaleString("de-DE")} \u20AC. Strom kostet dort ${location.powerPricePerKwh.toFixed(2)} \u20AC/kWh.`,
    monthlyPrice,
    setupPrice: Math.round(location.setupCost * ratio),
    payload: {
      locationKey: location.key,
      city: location.city,
      listRent: location.monthlyRent,
      priceRatio: Number(ratio.toFixed(3)),
      verdict: judgeOffer(ratio)
    }
  };
}
function buildPeeringOffer(world, rng, base, pitch, ratio) {
  const candidates = world.market.providers.filter((p) => p.kind === "content" || p.kind === "eyeball");
  const provider = rng.pick(candidates);
  if (!provider) return null;
  const capacityMbps = rng.pick([1e4, 25e3]) ?? 1e4;
  const paid = provider.kind === "eyeball" && rng.chance(0.6);
  const monthlyPrice = paid ? Math.round(capacityMbps / 1e3 * 120 * ratio) : 0;
  return {
    ...base,
    kind: "peering",
    sellerAsn: provider.asn,
    title: `${paid ? "Bezahltes Peering" : "Direktverbindung"} zu ${provider.name}`,
    description: `${pitch} Eine Direktverbindung (PNI) mit ${formatCapacity(capacityMbps)} zu AS${provider.asn}. ` + (paid ? `${provider.name} verlangt daf\xFCr ${monthlyPrice.toLocaleString("de-DE")} \u20AC im Monat.` : "Kostenlos \u2013 beide Seiten sparen sich den Transit.") + ` Rund ${(provider.reach * 100).toFixed(0)} % des weltweiten Verkehrs entfallen auf dieses Netz.`,
    monthlyPrice,
    setupPrice: Math.round(1200 * ratio),
    payload: {
      peerAsn: provider.asn,
      capacityMbps,
      paid,
      priceRatio: Number(ratio.toFixed(3)),
      verdict: judgeOffer(ratio),
      needsPort: true
    }
  };
}
function formatCapacity(mbps) {
  return mbps >= 1e3 ? `${mbps / 1e3} Gbit/s` : `${mbps} Mbit/s`;
}
function declineOffer(world, offerId) {
  const before = world.market.offers.length;
  world.market.offers = world.market.offers.filter((o) => o.id !== offerId);
  return world.market.offers.length < before;
}
function describeOffer(offer) {
  const ratio = typeof offer.payload.priceRatio === "number" ? offer.payload.priceRatio : 1;
  const verdict = offer.payload.verdict ?? judgeOffer(ratio);
  return { verdict, verdictLabel: VERDICT_LABEL[verdict], ratio };
}

// src/domain/research/research.ts
var RESEARCH_TREE = [
  // --- Netzwerk ----------------------------------------------------------
  {
    key: "res-100g",
    name: "100G-Plattformen",
    description: "Qualifiziert 100-Gigabit-Optik und die zugeh\xF6rigen Router- und Switchplattformen.",
    category: "network",
    cost: 45e3,
    durationTicks: 24 * 30,
    requires: [],
    unlocksModels: ["rtr-core-l", "sw-spine-100g"],
    modifiers: { routingCapacity: 1.15 }
  },
  {
    key: "res-400g",
    name: "400G-Backbone",
    description: "Koh\xE4rente Optik und Chassis f\xFCr Terabit-Kapazit\xE4ten im Kernnetz.",
    category: "network",
    cost: 18e4,
    durationTicks: 24 * 75,
    requires: ["res-100g"],
    unlocksModels: ["rtr-core-xl"],
    modifiers: { routingCapacity: 1.4 }
  },
  {
    key: "res-traffic-engineering",
    name: "Traffic Engineering",
    description: "Automatische Lastverteilung \xFCber parallele Pfade senkt Spitzenlast und Transitkosten.",
    category: "network",
    cost: 32e3,
    durationTicks: 24 * 25,
    requires: [],
    unlocksModels: [],
    modifiers: { routingCapacity: 1.1 }
  },
  {
    key: "res-ddos-scrubbing",
    name: "Verteiltes Scrubbing",
    description: "Eigene Filterinfrastruktur an allen Standorten; gro\xDFe Volumenangriffe werden abgefangen.",
    category: "security",
    cost: 95e3,
    durationTicks: 24 * 45,
    requires: ["res-100g"],
    unlocksModels: ["fw-scrub-100g"],
    modifiers: { ddosMitigationGbps: 40 }
  },
  {
    key: "res-anycast",
    name: "Anycast-DNS",
    description: "Ein DNS-Prefix an allen Standorten \u2013 k\xFCrzere Antwortzeiten und Ausfallsicherheit.",
    category: "network",
    cost: 28e3,
    durationTicks: 24 * 20,
    requires: [],
    unlocksModels: [],
    modifiers: { failureRate: 0.92 }
  },
  // --- Rechenleistung ----------------------------------------------------
  {
    key: "res-nvme",
    name: "NVMe-Speicherplattform",
    description: "Direkt angebundene Flashspeicher l\xF6sen SATA-SSDs ab; deutlich h\xF6here IOPS pro Host.",
    category: "compute",
    cost: 38e3,
    durationTicks: 24 * 28,
    requires: [],
    unlocksModels: ["srv-nvme-1u", "chs-flash-1u"],
    modifiers: { computePerformance: 1.12 }
  },
  {
    key: "res-dense-compute",
    name: "Dual-Socket-Verdichtung",
    description: "H\xF6here Kerndichte pro H\xF6heneinheit senkt die Kosten je verkauftem vCPU.",
    category: "compute",
    cost: 52e3,
    durationTicks: 24 * 35,
    requires: [],
    // Die Forschung schaltet eine Klasse frei, nicht ein Gerät: zwei
    // Barebones, ein Fertigmodell und die Gen5-Prozessoren dazu.
    unlocksModels: ["srv-ent-2u", "srv-dual-2u", "chs-dual-2u", "chs-dual-1u", "dedi-power"],
    modifiers: { computePerformance: 1.2 }
  },
  {
    key: "res-ai-compute",
    name: "GPU-Beschleunigung",
    description: "Qualifiziert GPU-Plattformen f\xFCr Training und Inferenz \u2013 Voraussetzung f\xFCr das eigene KI-Compute-Gesch\xE4ft.",
    category: "compute",
    cost: 95e3,
    durationTicks: 24 * 42,
    requires: ["res-dense-compute"],
    unlocksModels: ["srv-gpu-1u"],
    modifiers: { computePerformance: 1.05 }
  },
  {
    key: "res-virtualization",
    name: "Optimierter Hypervisor",
    description: "Feineres Scheduling erlaubt h\xF6here \xDCberbuchung ohne sp\xFCrbare Einbu\xDFen.",
    category: "compute",
    cost: 24e3,
    durationTicks: 24 * 22,
    requires: [],
    unlocksModels: [],
    modifiers: { computePerformance: 1.15 }
  },
  // --- Effizienz ---------------------------------------------------------
  {
    key: "res-free-cooling",
    name: "Freie K\xFChlung",
    description: "Au\xDFenluft- und Verdunstungsk\xFChlung senken den Energiebedarf der Klimatisierung deutlich.",
    category: "efficiency",
    cost: 41e3,
    durationTicks: 24 * 30,
    requires: [],
    unlocksModels: [],
    modifiers: { coolingEfficiency: 1.35, powerUsage: 0.94 }
  },
  {
    key: "res-power-management",
    name: "Dynamisches Energiemanagement",
    description: "Lastabh\xE4ngige Taktung und Abschaltung ungenutzter Komponenten reduzieren die Grundlast.",
    category: "efficiency",
    cost: 29e3,
    durationTicks: 24 * 24,
    requires: [],
    unlocksModels: [],
    modifiers: { powerUsage: 0.88 }
  },
  {
    key: "res-heat-reuse",
    name: "Abw\xE4rmenutzung",
    description: "Auskopplung der Abw\xE4rme ins Fernw\xE4rmenetz senkt die effektiven Energiekosten weiter.",
    category: "efficiency",
    cost: 68e3,
    durationTicks: 24 * 50,
    requires: ["res-free-cooling"],
    unlocksModels: [],
    modifiers: { coolingEfficiency: 1.25, powerUsage: 0.93 }
  },
  // --- Automatisierung ---------------------------------------------------
  {
    key: "res-automation",
    name: "Provisionierungsautomatik",
    description: "Kundenauftr\xE4ge werden vollautomatisch ausgerollt; weniger Personal f\xFCr dieselbe Menge.",
    category: "automation",
    cost: 34e3,
    durationTicks: 24 * 26,
    requires: [],
    unlocksModels: [],
    modifiers: { staffEfficiency: 0.82 }
  },
  {
    key: "res-selfhealing",
    name: "Selbstheilende Systeme",
    description: "Automatische Erkennung und Umschaltung bei Defekten reduziert Ausf\xE4lle sp\xFCrbar.",
    category: "automation",
    cost: 72e3,
    durationTicks: 24 * 48,
    requires: ["res-automation"],
    unlocksModels: [],
    modifiers: { failureRate: 0.7, supportSpeed: 1.15 }
  },
  {
    key: "res-support-tooling",
    name: "Support-Werkzeuge",
    description: "Vorlagen, Wissensdatenbank und Diagnosetools beschleunigen die Ticketbearbeitung.",
    category: "automation",
    cost: 18e3,
    durationTicks: 24 * 18,
    requires: [],
    unlocksModels: [],
    modifiers: { supportSpeed: 1.4 }
  },
  // --- Finanzen ------------------------------------------------------------
  {
    key: "res-bonitaetspruefung",
    name: "Bonit\xE4tspr\xFCfung",
    description: "Geordnete Bilanzen und eine saubere Buchhaltung \xFCberzeugen die Bank: bessere Zinsen, mehr Rahmen, Zugang zum Investitionskredit.",
    category: "finance",
    cost: 8e3,
    durationTicks: 24 * 12,
    requires: [],
    unlocksModels: [],
    modifiers: { loanRateMultiplier: 0.93 },
    creditLimitBonus: 15e3
  },
  {
    key: "res-bankbeziehung",
    name: "Etablierte Bankbeziehung",
    description: "Wer \xFCber Jahre zuverl\xE4ssig tilgt, verhandelt nicht mehr bei null \u2013 die Hausbank kennt die Zahlen und rechnet gro\xDFz\xFCgiger.",
    category: "finance",
    cost: 35e3,
    durationTicks: 24 * 30,
    requires: ["res-bonitaetspruefung"],
    unlocksModels: [],
    modifiers: { loanRateMultiplier: 0.88 },
    creditLimitBonus: 4e4
  },
  {
    key: "res-hausbankstatus",
    name: "Hausbankstatus",
    description: "Die beste Stufe der Bankbeziehung: Zugang zum Hausbankdarlehen f\xFCr Gro\xDFvorhaben, zu den g\xFCnstigsten Konditionen im Spiel.",
    category: "finance",
    cost: 1e5,
    durationTicks: 24 * 60,
    requires: ["res-bankbeziehung"],
    unlocksModels: [],
    modifiers: { loanRateMultiplier: 0.82 },
    creditLimitBonus: 9e4
  }
];
function neutralModifiers() {
  return {
    powerUsage: 1,
    coolingEfficiency: 1,
    computePerformance: 1,
    routingCapacity: 1,
    staffEfficiency: 1,
    failureRate: 1,
    ddosMitigationGbps: 0,
    supportSpeed: 1,
    loanRateMultiplier: 1
  };
}
function buildResearchNodes() {
  const nodes = {};
  for (const template of RESEARCH_TREE) {
    const id = asId(template.key);
    nodes[id] = {
      id,
      name: template.name,
      description: template.description,
      category: template.category,
      cost: template.cost,
      durationTicks: template.durationTicks,
      requires: template.requires.map((r) => asId(r)),
      progressTicks: 0,
      completed: false,
      unlocksModels: template.unlocksModels,
      modifiers: template.modifiers,
      creditLimitBonus: template.creditLimitBonus ?? 0
    };
  }
  return nodes;
}
function isUnlocked(world, id) {
  const node = world.research[id];
  if (!node) return false;
  return node.requires.every((req) => world.research[req]?.completed);
}
function completedResearch(world) {
  return values(world.research).filter((n) => n.completed).map((n) => n.id);
}
function activeModifiers(world) {
  const result = neutralModifiers();
  for (const node of values(world.research)) {
    if (!node.completed) continue;
    for (const [key, value] of Object.entries(node.modifiers)) {
      if (value === void 0) continue;
      if (key === "ddosMitigationGbps") result[key] += value;
      else result[key] *= value;
    }
  }
  return result;
}
function unlockedModels(world) {
  return values(world.research).filter((n) => n.completed).flatMap((n) => n.unlocksModels);
}
function startResearch(world, id) {
  const node = world.research[id];
  if (!node) return { ok: false, error: "Forschungsprojekt nicht gefunden" };
  if (node.completed) return { ok: false, error: "Bereits abgeschlossen" };
  if (!isUnlocked(world, id)) return { ok: false, error: "Voraussetzungen nicht erf\xFCllt" };
  world.activeResearchId = id;
  return { ok: true };
}
function advanceResearch(world) {
  if (!world.activeResearchId) return null;
  const node = world.research[world.activeResearchId];
  if (!node || node.completed) {
    world.activeResearchId = null;
    return null;
  }
  node.progressTicks += 1;
  if (node.progressTicks >= node.durationTicks) {
    node.completed = true;
    world.activeResearchId = null;
    if (node.creditLimitBonus > 0) {
      world.company.creditLimit += node.creditLimitBonus;
    }
    return node;
  }
  return null;
}

// src/domain/economy/bank.ts
var ok8 = (message, loanId) => ({ ok: true, message, loanId });
var fail8 = (message) => ({ ok: false, message });
function effectiveLoanRate(world, product) {
  const multiplier = activeModifiers(world).loanRateMultiplier;
  return clamp(product.baseRate * multiplier, 0.01, product.baseRate);
}
function takeLoan(world, rng, productKey, amount) {
  const product = findLoanProduct(productKey);
  if (!product) return fail8("Bankprodukt nicht gefunden.");
  if (product.requiresResearch && !completedResearch(world).includes(product.requiresResearch)) {
    return fail8("Voraussetzung fehlt: Die Bank verlangt weitere Bonit\xE4tsnachweise.");
  }
  if (world.company.reputation < product.minReputation) {
    return fail8(`Der Ruf reicht nicht aus (mindestens ${product.minReputation}).`);
  }
  if (!Number.isFinite(amount) || amount < product.minAmount || amount > product.maxAmount) {
    return fail8(`Betrag muss zwischen ${product.minAmount.toLocaleString("de-DE")} \u20AC und ${product.maxAmount.toLocaleString("de-DE")} \u20AC liegen.`);
  }
  const rate = effectiveLoanRate(world, product);
  const id = asId(makeId(rng, "loan"));
  const loan = {
    id,
    productKey: product.key,
    name: product.name,
    principal: money(amount),
    balance: money(amount),
    interestRate: rate,
    termTicks: product.termTicks,
    remainingTicks: product.termTicks,
    principalPerTick: amount / product.termTicks,
    issuedAtTick: world.meta.tick,
    state: "active"
  };
  world.loans[id] = loan;
  world.company.cash = money(world.company.cash + amount);
  return ok8(
    `${product.name} \xFCber ${amount.toLocaleString("de-DE")} \u20AC aufgenommen, ${(rate * 100).toFixed(1)} % p. a., Laufzeit ${Math.round(product.termTicks / SIM.TICKS_PER_YEAR)} Jahre.`,
    id
  );
}
function advanceLoans(world) {
  const paidOff = [];
  for (const loan of Object.values(world.loans)) {
    if (loan.state !== "active") continue;
    const interest = loan.balance * loan.interestRate / SIM.TICKS_PER_YEAR;
    const principal = Math.min(loan.principalPerTick, loan.balance);
    post(world, { category: "cost-loan", amount: -(interest + principal), description: `Tilgung ${loan.name}` });
    loan.balance = money(loan.balance - principal);
    loan.remainingTicks = Math.max(0, loan.remainingTicks - 1);
    if (loan.balance <= 0.01 || loan.remainingTicks <= 0) {
      loan.balance = 0;
      loan.state = "paid";
      paidOff.push(loan);
    }
  }
  return paidOff;
}
function repayLoanEarly(world, loanId, amount) {
  const loan = world.loans[loanId];
  if (!loan) return fail8("Darlehen nicht gefunden.");
  if (loan.state !== "active") return fail8("Dieses Darlehen ist bereits getilgt.");
  const repay = Math.min(amount, loan.balance, world.company.cash);
  if (repay <= 0) return fail8("Sondertilgung nicht m\xF6glich.");
  loan.balance = money(loan.balance - repay);
  post(world, { category: "cost-loan", amount: -repay, description: `Sondertilgung ${loan.name}` });
  if (loan.balance <= 0.01) {
    loan.balance = 0;
    loan.remainingTicks = 0;
    loan.state = "paid";
  }
  return ok8(`${repay.toLocaleString("de-DE")} \u20AC Sondertilgung auf ${loan.name}.`);
}

// src/domain/events/events.ts
function onlineDevices(store) {
  return values(store).filter((d) => d.state === "online" || d.state === "degraded");
}
function activeCustomers(world) {
  return values(world.customers).filter((c) => c.contractIds.some((id) => world.contracts[id]?.state === "active"));
}
function outageRecipients(world) {
  return activeCustomers(world).filter((c) => hasHostedContract(world, c));
}
function attackableContracts(world) {
  const out = [];
  for (const contract of values(world.contracts)) {
    if (contract.state !== "active" || contract.ipv4.length === 0) continue;
    if (values(world.events).some((e) => !e.resolved && e.ddos?.contractId === contract.id)) continue;
    const datacenterId = contractDatacenterId(world, contract);
    if (datacenterId) out.push({ contract, datacenterId });
  }
  return out;
}
function decimal2(value) {
  return value.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}
var COOLING_FAILURE_FACTOR = 0.35;
function round1(value) {
  return Math.round(value * 10) / 10;
}
var EVENT_DEFINITIONS = [
  // --- Stromausfall -------------------------------------------------------
  {
    type: "power-outage",
    title: "Stromausfall",
    severity: "critical",
    baseChance: 9e-4,
    canTrigger: ({ world }) => values(world.datacenters).some((d) => d.utilityPower),
    trigger: ({ world, rng }) => {
      const dc = rng.pick(values(world.datacenters).filter((d) => d.utilityPower));
      if (!dc) return null;
      const feeds = dc.powerFeeds?.count ?? 1;
      if (feeds > 1 && !rng.chance(0.12)) {
        return {
          type: "power-outage",
          title: `Zuleitung in ${dc.city} ausgefallen`,
          description: `Eine der ${feeds} Netzeinspeisungen von ${dc.name} ist weggefallen. Die zweite Zuleitung tr\xE4gt die Last weiter \u2013 der Betrieb l\xE4uft ohne Unterbrechung.`,
          severity: "warning",
          ticksRemaining: rng.int(2, 8),
          targets: [{ kind: "datacenter", id: dc.id }],
          options: [{ key: "wait", label: "Zur Kenntnis nehmen", description: "Der Netzbetreiber repariert.", cost: 0, successChance: 1 }]
        };
      }
      dc.utilityPower = false;
      const cables = 4 + (dc.generator.installed ? 0 : 1) + (hasBackupPower(world, dc.id) ? 0 : 1);
      return {
        type: "power-outage",
        title: `Stromausfall in ${dc.city}`,
        description: `Die Netzeinspeisung von ${dc.name} ist ausgefallen. USV und Notstromaggregat \xFCbernehmen, solange Kapazit\xE4t und Treibstoff reichen.`,
        severity: "critical",
        ticksRemaining: rng.int(2, 8),
        targets: [{ kind: "datacenter", id: dc.id }],
        options: [
          { key: "fuel", label: "Treibstoff liefern lassen", description: "Express-Lieferung f\xFCllt den Generator auf.", cost: 4200, successChance: 0.95 },
          { key: "wait", label: "Abwarten", description: "Auf die Wiederherstellung durch den Netzbetreiber warten.", cost: 0, successChance: 1 }
        ],
        minigame: createMinigame(rng, "cabling", { cables })
      };
    },
    onEnd: ({ world }, event) => {
      for (const target of event.targets) {
        if (target.kind !== "datacenter") continue;
        const dc = world.datacenters[target.id];
        if (!dc) continue;
        dc.utilityPower = true;
        powerUpDatacenter(world, dc.id);
      }
    },
    onOption: ({ world }, event, key) => {
      if (key !== "fuel") return { ok: true, note: "Es wird abgewartet." };
      for (const target of event.targets) {
        const dc = world.datacenters[target.id];
        if (dc?.generator.installed) dc.generator.fuelPercent = 100;
      }
      return { ok: true, note: "Treibstoff wurde geliefert, der Generator l\xE4uft weiter." };
    }
  },
  // --- Hardwaredefekt -----------------------------------------------------
  {
    type: "hardware-failure",
    title: "Hardwaredefekt",
    severity: "error",
    baseChance: 4e-3,
    canTrigger: ({ world }) => onlineDevices(world.servers).length > 0,
    trigger: ({ world, rng }) => {
      const candidates = onlineDevices(world.servers);
      const server = rng.pickWeighted(candidates, (s) => (1 - s.health) * 4 + (s.temperatureC > SIM.TEMP_WARN_C ? 3 : 0.4));
      if (!server) return null;
      server.state = "failed";
      server.health = clamp(server.health - 0.3, 0, 1);
      return {
        type: "hardware-failure",
        title: `Hardwaredefekt: ${server.name}`,
        description: `${server.name} ist ausgefallen. Kunden auf diesem Host sind offline, bis das Ger\xE4t repariert oder ersetzt ist.`,
        severity: "error",
        ticksRemaining: 0,
        // bleibt bestehen, bis der Spieler repariert
        targets: [{ kind: "server", id: server.id }],
        options: [
          { key: "repair", label: "Reparieren", description: "Techniker tauschen die defekte Komponente.", cost: 450, successChance: 0.9 },
          { key: "replace", label: "Ersetzen", description: "Sofortiger Austausch aus dem Ersatzteillager.", cost: 2200, successChance: 1 }
        ]
      };
    },
    onOption: ({ world }, event, key) => {
      const target = event.targets[0];
      const server = target ? world.servers[target.id] : void 0;
      if (!server) return { ok: false, note: "Ger\xE4t nicht gefunden." };
      if (key === "replace") {
        server.health = 1;
        server.state = "booting";
        server.pendingTicks = SIM.BOOT_TICKS;
        return { ok: true, note: "Ger\xE4t wurde ersetzt." };
      }
      server.state = "maintenance";
      server.pendingTicks = SIM.REPAIR_TICKS_BASE;
      return { ok: true, note: "Reparatur l\xE4uft." };
    }
  },
  // --- Routerdefekt -------------------------------------------------------
  {
    type: "router-failure",
    title: "Routerausfall",
    severity: "critical",
    baseChance: 12e-4,
    canTrigger: ({ world }) => onlineDevices(world.routers).length > 0,
    trigger: ({ world, rng }) => {
      const router = rng.pickWeighted(onlineDevices(world.routers), (r) => (1 - r.health) * 5 + 0.5);
      if (!router) return null;
      router.state = "failed";
      return {
        type: "router-failure",
        title: `Routerausfall: ${router.name}`,
        description: `${router.name} antwortet nicht mehr. Alle BGP-Sessions dieses Routers brechen ab. Ohne redundanten Pfad ist der Standort vom Internet getrennt.`,
        severity: "critical",
        ticksRemaining: 0,
        targets: [{ kind: "router", id: router.id }],
        options: [
          { key: "repair", label: "Reparieren", description: "Vor-Ort-Einsatz eines Netzwerktechnikers.", cost: 900, successChance: 0.85 },
          { key: "replace", label: "Ersatzger\xE4t einbauen", description: "Sofortiger Tausch mit Konfigurations\xFCbernahme.", cost: 6500, successChance: 1 }
        ]
      };
    },
    onOption: ({ world }, event, key) => {
      const router = world.routers[event.targets[0]?.id];
      if (!router) return { ok: false, note: "Router nicht gefunden." };
      if (key === "replace") {
        router.health = 1;
        router.state = "booting";
        router.pendingTicks = SIM.BOOT_TICKS;
        return { ok: true, note: "Ersatzger\xE4t ist eingebaut, Konfiguration \xFCbernommen." };
      }
      router.state = "maintenance";
      router.pendingTicks = SIM.REPAIR_TICKS_BASE + 2;
      return { ok: true, note: "Techniker ist vor Ort." };
    }
  },
  // --- Glasfaserschaden ---------------------------------------------------
  {
    type: "fiber-cut",
    title: "Glasfaserschaden",
    severity: "error",
    baseChance: 16e-4,
    canTrigger: ({ world }) => values(world.links).some((l) => l.state === "up" && l.kind !== "internal"),
    trigger: ({ world, rng }) => {
      const candidates = values(world.links).filter((l) => l.state === "up" && l.kind !== "internal");
      const link = rng.pickWeighted(candidates, (l) => 1 - l.resilience + 0.15);
      if (!link) return null;
      link.state = "down";
      return {
        type: "fiber-cut",
        title: `Faserschaden: ${link.name}`,
        description: `Bei Bauarbeiten wurde die Trasse von ${link.name} besch\xE4digt. Die Strecke ist unterbrochen; BGP muss den Verkehr \xFCber verbleibende Pfade umleiten.`,
        severity: "error",
        ticksRemaining: rng.int(4, 24),
        targets: [{ kind: "link", id: link.id }],
        options: [
          { key: "expedite", label: "Notreparatur beauftragen", description: "Splei\xDFtrupp r\xFCckt sofort aus.", cost: 7800, successChance: 0.8 },
          { key: "wait", label: "Regul\xE4re Entst\xF6rung", description: "Der Carrier repariert im normalen Zeitfenster.", cost: 0, successChance: 1 }
        ]
      };
    },
    onEnd: ({ world }, event) => {
      const link = world.links[event.targets[0]?.id];
      if (link) link.state = "up";
    },
    onOption: ({ world, rng }, event, key) => {
      if (key !== "expedite") return { ok: true, note: "Regul\xE4re Entst\xF6rung l\xE4uft." };
      const link = world.links[event.targets[0]?.id];
      if (!link) return { ok: false, note: "Strecke nicht gefunden." };
      if (rng.chance(0.8)) {
        link.state = "up";
        event.ticksRemaining = 0;
        return { ok: true, note: "Notreparatur erfolgreich, die Strecke ist wieder aktiv." };
      }
      event.ticksRemaining = Math.max(1, Math.floor(event.ticksRemaining / 2));
      return { ok: true, note: "Der Splei\xDF dauert l\xE4nger als geplant, die Entst\xF6rzeit halbiert sich immerhin." };
    }
  },
  // --- DDoS ---------------------------------------------------------------
  {
    type: "ddos",
    title: "DDoS-Angriff",
    severity: "critical",
    baseChance: 22e-4,
    canTrigger: ({ world }) => activeCustomers(world).length > 3 && attackableContracts(world).length > 0,
    trigger: ({ world, rng, mitigationBonusGbps }) => {
      const target = rng.pick(attackableContracts(world));
      if (!target) return null;
      const { contract, datacenterId } = target;
      const customer = world.customers[contract.customerId];
      if (!customer) return null;
      const targetIp = contract.ipv4[0];
      const serverId = contract.vpsId ? world.vpsInstances[contract.vpsId]?.hostServerId ?? null : contract.serverId;
      const scale = 1 + Object.keys(world.customers).length / 40;
      const vector = rng.pickWeighted(
        ["udp-amplification", "syn-flood", "http-flood"],
        (v) => v === "udp-amplification" ? 5 : v === "syn-flood" ? 3 : 2
      );
      const peakGbps = vector === "udp-amplification" ? round1(rng.float(2, 25) * scale) : vector === "syn-flood" ? round1(rng.float(1, 10) * scale) : round1(rng.float(0.1, 0.8));
      const peakRps = vector === "http-flood" ? Math.round(rng.int(2e4, 25e4) * scale) : 0;
      const ddos = {
        vector,
        reflectorPort: vector === "udp-amplification" ? rng.pick(REFLECTOR_PORTS).port : null,
        targetIp,
        customerId: customer.id,
        contractId: contract.id,
        serverId,
        datacenterId,
        peakGbps,
        peakRps,
        externalScrub: false,
        scrubPricePerGbps: DDOS.SCRUB_PRICE_PER_GBPS,
        blackholeRouterIds: [],
        currentGbps: 0,
        filteredGbps: 0,
        residualGbps: 0,
        uplinkSaturation: 0,
        targetState: "ok",
        targetNote: "Messung l\xE4uft."
      };
      const site = world.datacenters[datacenterId];
      const server = serverId ? world.servers[serverId] : void 0;
      const mitigation = siteMitigationGbps(world, datacenterId, vector, mitigationBonusGbps);
      const contained = vector === "http-flood" ? !!server?.hardening?.httpRateLimit : mitigation >= peakGbps;
      const hardening = server ? hardeningOf(server) : null;
      const prepared = vector === "syn-flood" && hardening?.synCookies || vector === "http-flood" && hardening?.httpRateLimit || vector === "udp-amplification" && ddos.reflectorPort !== null && hardening?.udpDropPorts.includes(ddos.reflectorPort);
      const coverage = vector === "http-flood" ? 0 : clamp(mitigation / Math.max(0.1, peakGbps), 0, 1);
      const minigame = createMinigame(rng, "tower-defense", {
        vector: ["udp-amplification", "syn-flood", "http-flood"].indexOf(vector),
        budget: 170 + Math.round(coverage * 80) + (prepared ? 50 : 0),
        intensity: round1(
          clamp(vector === "http-flood" ? 0.8 + peakRps / 4e5 : 0.8 + peakGbps / (40 + mitigation), 0.8, 1.8)
        )
      });
      return {
        type: "ddos",
        title: `DDoS-Angriff auf ${targetIp}`,
        description: `Auf ${targetIp} (${customer.company ?? customer.name}${server ? `, ${server.name}` : ""}, ${site?.name ?? "unbekannter Standort"}) l\xE4uft ein Angriff mit bis zu ${decimal2(peakGbps)} Gbit/s. Die Filterkapazit\xE4t an diesem Standort betr\xE4gt ${decimal2(mitigation)} Gbit/s. ` + (server ? `Welche Art von Angriff es ist, zeigt die Konsole von ${server.name} (tcpdump, ss -s, Logs).` : "Ein Blackhole oder externes Scrubbing wirkt unabh\xE4ngig von der Angriffsart."),
        severity: contained ? "warning" : "critical",
        ticksRemaining: rng.int(3, 10),
        targets: [
          { kind: "customer", id: customer.id },
          ...serverId ? [{ kind: "server", id: serverId }] : [],
          { kind: "datacenter", id: datacenterId }
        ],
        options: [
          {
            key: "blackhole",
            label: `${targetIp} per Blackhole verwerfen`,
            description: "Hostroute mit der Community 65535:666 an die Upstreams: Der Angriff erreicht das Netz nicht mehr, das Ziel ist aber bis zum Ende des Angriffs offline.",
            cost: 0,
            successChance: 1
          },
          {
            key: "scrub",
            label: "Externes Scrubbing buchen",
            description: `Den Verkehr \xFCber einen Mitigation-Dienstleister umleiten. Einrichtung ${DDOS.SCRUB_SETUP_FEE.toLocaleString("de-DE")} \u20AC, danach ${DDOS.SCRUB_PRICE_PER_GBPS} \u20AC je Gbit/s und Stunde, bis der Angriff endet.`,
            cost: DDOS.SCRUB_SETUP_FEE,
            successChance: 0.9
          },
          { key: "endure", label: "Aussitzen", description: "Keine Ma\xDFnahme am Netzrand ergreifen.", cost: 0, successChance: 1 }
        ],
        ddos,
        minigame
      };
    },
    onEnd: ({ world }, event) => {
      if (event.ddos) {
        liftOwnBlackholes(world, event.ddos);
        event.ddos.externalScrub = false;
        return;
      }
      for (const link of values(world.links)) {
        if (link.kind === "transit" && link.state === "degraded") link.state = "up";
      }
    },
    onOption: ({ world, rng }, event, key) => {
      const attack = event.ddos;
      if (!attack) {
        for (const link of values(world.links)) {
          if (link.kind === "transit" && link.state === "degraded") link.state = "up";
        }
        event.ticksRemaining = 0;
        return { ok: true, note: "Der Angriff ist abgeflaut." };
      }
      if (key === "blackhole") {
        const routers = blackholeRouters(world, attack.datacenterId);
        if (routers.length === 0) {
          return {
            ok: false,
            note: "Kein Router kann das Blackhole an einen Upstream geben: Es braucht die aktivierte Blackhole-Community und eine aufgebaute Transit-Session."
          };
        }
        for (const router of routers) {
          setBlackhole(router, hostRoute(attack.targetIp), true);
          if (!attack.blackholeRouterIds.includes(router.id)) attack.blackholeRouterIds.push(router.id);
        }
        attack.externalScrub = false;
        return {
          ok: true,
          note: `${hostRoute(attack.targetIp)} wird \xFCber ${routers.map((r) => r.name).join(", ")} geblackholt. Das Ziel ist offline, bis der Angriff endet.`
        };
      }
      if (key === "scrub") {
        if (attack.externalScrub) return { ok: false, note: "Das externe Scrubbing l\xE4uft bereits." };
        if (!rng.chance(0.9)) return { ok: false, note: "Die Umleitung greift nicht schnell genug. Die Einrichtungsgeb\xFChr ist trotzdem f\xE4llig." };
        attack.externalScrub = true;
        liftOwnBlackholes(world, attack);
        return { ok: true, note: "Der Angriffsverkehr wird extern gefiltert. Abgerechnet wird je Stunde nach Volumen." };
      }
      return { ok: true, note: "Es wurde keine Ma\xDFnahme am Netzrand ergriffen." };
    }
  },
  // --- Einbruchsversuch ---------------------------------------------------
  {
    type: "intrusion",
    title: "Sicherheitsvorfall",
    severity: "error",
    baseChance: 11e-4,
    canTrigger: ({ world }) => onlineDevices(world.servers).length > 0,
    trigger: ({ world, rng }) => {
      const server = rng.pick(onlineDevices(world.servers));
      if (!server) return null;
      return {
        type: "intrusion",
        title: `Kompromittierter Server: ${server.name}`,
        description: `Auf ${server.name} wurde ein erfolgreicher Einbruch festgestellt. Der Host versendet Spam; Beschwerden von Upstreams sind zu erwarten, die IP-Reputation leidet.`,
        severity: "error",
        /*
         * Eine feste Laufzeit statt „bis die Ziele gesund sind“: Der Server ist
         * ja online – sonst endete der Vorfall nach einer Stunde von selbst,
         * bevor jemand reagieren konnte. Irgendwann zieht der Angreifer weiter.
         */
        ticksRemaining: rng.int(12, 36),
        targets: [{ kind: "server", id: server.id }],
        minigame: createMinigame(rng, "escape"),
        options: [
          { key: "isolate", label: "Host isolieren und neu aufsetzen", description: "Sofort vom Netz nehmen, Daten aus dem Backup zur\xFCckspielen.", cost: 1800, successChance: 0.95 },
          { key: "patch", label: "Nur patchen", description: "Sicherheitsl\xFCcke schlie\xDFen, System weiterlaufen lassen.", cost: 300, successChance: 0.5 }
        ]
      };
    },
    onTick: ({ world }) => {
      world.company.reputation = clamp(world.company.reputation - 0.08, 0, 100);
    },
    onEnd: (_ctx, event) => {
      event.resolutionNote ??= "Der Angreifer hat das System verlassen \u2013 Schaden am Ruf ist entstanden.";
    },
    onOption: ({ world, rng }, event, key) => {
      const server = world.servers[event.targets[0]?.id];
      if (!server) return { ok: false, note: "Server nicht gefunden." };
      if (key === "isolate") {
        server.state = "maintenance";
        server.pendingTicks = SIM.REPAIR_TICKS_BASE;
        event.ticksRemaining = 0;
        return { ok: true, note: "Der Host ist isoliert und wird neu aufgesetzt." };
      }
      if (rng.chance(0.5)) {
        event.ticksRemaining = 0;
        return { ok: true, note: "Der Patch hat gegriffen, keine weiteren Auff\xE4lligkeiten." };
      }
      world.company.reputation = clamp(world.company.reputation - 4, 0, 100);
      return { ok: false, note: "Der Angreifer war noch aktiv \u2013 der Vorfall setzt sich fort." };
    }
  },
  // --- Kundenwachstum -----------------------------------------------------
  {
    type: "growth-spike",
    title: "Nachfrageschub",
    severity: "info",
    baseChance: 25e-4,
    canTrigger: ({ world }) => world.company.reputation > 45,
    trigger: ({ world, rng }) => {
      world.market.demandIndex = clamp(world.market.demandIndex + rng.float(0.15, 0.4), 0.45, 1.9);
      return {
        type: "growth-spike",
        title: "Positive Erw\xE4hnung in der Fachpresse",
        description: "Ein Testbericht hebt das Preis-Leistungs-Verh\xE4ltnis hervor. Die Nachfrage steigt f\xFCr einige Zeit deutlich \u2013 jetzt zahlt sich freie Kapazit\xE4t aus.",
        severity: "info",
        ticksRemaining: rng.int(48, 160),
        targets: [],
        options: []
      };
    },
    onEnd: ({ world }) => {
      world.market.demandIndex = clamp(world.market.demandIndex - 0.2, 0.45, 1.9);
    }
  },
  // --- Wartungsfenster des Upstreams -------------------------------------
  {
    type: "upstream-maintenance",
    title: "Wartung beim Upstream",
    severity: "warning",
    baseChance: 18e-4,
    canTrigger: ({ world }) => values(world.links).some((l) => l.kind === "transit" && l.state === "up"),
    trigger: ({ world, rng }) => {
      const link = rng.pick(values(world.links).filter((l) => l.kind === "transit" && l.state === "up"));
      if (!link) return null;
      link.state = "down";
      return {
        type: "upstream-maintenance",
        title: `Wartungsfenster: ${link.name}`,
        description: `AS${link.remoteAsn ?? "?"} f\xFChrt Wartungsarbeiten durch. Die Session ist f\xFCr die Dauer des Fensters unterbrochen \u2013 ein zweiter Upstream w\xFCrde den Verkehr jetzt automatisch \xFCbernehmen.`,
        severity: "warning",
        ticksRemaining: rng.int(2, 6),
        targets: [{ kind: "link", id: link.id }],
        options: []
      };
    },
    onEnd: ({ world }, event) => {
      const link = world.links[event.targets[0]?.id];
      if (link) link.state = "up";
    }
  },
  // --- Kühlungsausfall ----------------------------------------------------
  {
    type: "cooling-failure",
    title: "K\xFChlungsausfall",
    severity: "error",
    baseChance: 13e-4,
    canTrigger: ({ world }) => Object.keys(world.datacenters).length > 0,
    trigger: ({ world, rng }) => {
      const dc = rng.pick(values(world.datacenters));
      if (!dc) return null;
      dc.coolingCapacityKw = round1(dc.coolingCapacityKw * COOLING_FAILURE_FACTOR);
      return {
        type: "cooling-failure",
        title: `K\xFChlungsst\xF6rung in ${dc.city}`,
        description: `Ein K\xE4ltekreis von ${dc.name} ist ausgefallen. Die Temperaturen steigen; bei anhaltender \xDCberhitzung drosseln Ger\xE4te oder fallen aus.`,
        severity: "error",
        ticksRemaining: rng.int(3, 12),
        targets: [{ kind: "datacenter", id: dc.id }],
        options: [
          { key: "service", label: "Notdienst rufen", description: "K\xE4ltetechniker r\xFCckt sofort an.", cost: 3600, successChance: 0.85 },
          { key: "shed", label: "Last reduzieren", description: "Nicht kritische Server abschalten, bis die K\xFChlung l\xE4uft.", cost: 0, successChance: 1 }
        ]
      };
    },
    /*
     * Die Kühlung wird ausschließlich hier zurückgesetzt – auch dann, wenn der
     * Notdienst erfolgreich war. Der setzt nur `ticksRemaining` auf 0, woraufhin
     * `resolveEventOption` dieses `onEnd` aufruft. Würde er zusätzlich selbst
     * teilen, liefe die Kapazität um den Faktor 1/0,35 nach oben davon.
     */
    onEnd: ({ world }, event) => {
      const dc = world.datacenters[event.targets[0]?.id];
      if (dc) dc.coolingCapacityKw = round1(dc.coolingCapacityKw / COOLING_FAILURE_FACTOR);
    },
    onOption: ({ world, rng }, event, key) => {
      const dc = world.datacenters[event.targets[0]?.id];
      if (!dc) return { ok: false, note: "Standort nicht gefunden." };
      if (key === "service" && rng.chance(0.85)) {
        event.ticksRemaining = 0;
        return { ok: true, note: "Die K\xFChlung l\xE4uft wieder." };
      }
      if (key === "shed") {
        const servers = values(world.servers).filter((s) => s.datacenterId === dc.id && s.state === "online");
        for (const server of servers.slice(0, Math.ceil(servers.length / 2))) server.state = "offline";
        return { ok: true, note: "Ein Teil der Server wurde abgeschaltet, um die W\xE4rmelast zu senken." };
      }
      return { ok: false, note: "Der Notdienst konnte den Fehler nicht sofort beheben." };
    }
  },
  // --- Kündigungswelle ----------------------------------------------------
  {
    type: "competitor-offer",
    title: "Aggressives Konkurrenzangebot",
    severity: "warning",
    baseChance: 15e-4,
    canTrigger: ({ world }) => activeCustomers(world).length > 5,
    trigger: ({ world, rng }) => {
      for (const customer of activeCustomers(world)) {
        if (rng.chance(0.35)) customer.churnRisk = clamp(customer.churnRisk + 0.12, 0, 1);
      }
      return {
        type: "competitor-offer",
        title: "Wettbewerber senkt die Preise",
        description: "Ein Mitbewerber wirbt aggressiv um Kunden. Das K\xFCndigungsrisiko steigt sp\xFCrbar \u2013 gute Zufriedenheitswerte und ein passender Preis wirken jetzt am besten.",
        severity: "warning",
        ticksRemaining: rng.int(72, 200),
        targets: [],
        options: [
          { key: "discount", label: "Bestandskunden Rabatt geben", description: "10 % Nachlass f\xFCr drei Monate auf alle laufenden Vertr\xE4ge.", cost: 0, successChance: 1 },
          { key: "ignore", label: "Preise halten", description: "Auf Qualit\xE4t statt Preis setzen.", cost: 0, successChance: 1 }
        ]
      };
    },
    onOption: ({ world }, _event, key) => {
      if (key !== "discount") return { ok: true, note: "Die Preise bleiben unver\xE4ndert." };
      for (const contract of values(world.contracts)) {
        if (contract.state !== "active") continue;
        contract.monthlyPrice = Math.round(contract.monthlyPrice * 0.9 * 100) / 100;
      }
      for (const customer of values(world.customers)) {
        customer.churnRisk = clamp(customer.churnRisk - 0.15, 0, 1);
        customer.satisfaction = clamp(customer.satisfaction + 5, 0, 100);
      }
      return { ok: true, note: "Alle laufenden Vertr\xE4ge wurden um 10 % reduziert." };
    }
  }
];
var DEFINITION_INDEX = new Map(EVENT_DEFINITIONS.map((d) => [d.type, d]));
function findEventDefinition(type) {
  return DEFINITION_INDEX.get(type);
}
function targetsHealthy(world, event) {
  if (event.targets.length === 0) return false;
  return event.targets.every((target) => {
    switch (target.kind) {
      case "server":
        return world.servers[target.id]?.state === "online";
      case "router":
        return world.routers[target.id]?.state === "online";
      case "switch":
        return world.switches[target.id]?.state === "online";
      case "firewall":
        return world.firewalls[target.id]?.state === "online";
      case "link":
        return world.links[target.id]?.state === "up";
      case "datacenter":
        return world.datacenters[target.id]?.utilityPower === true;
      default:
        return false;
    }
  });
}
function updateEvents(ctx) {
  const { world, rng } = ctx;
  const settings = DIFFICULTY[world.meta.difficulty];
  const triggered = [];
  const ended = [];
  expireMinigames(world);
  for (const event of values(world.events)) {
    if (event.resolved) continue;
    if (isFrozen(world, event)) continue;
    const definition = DEFINITION_INDEX.get(event.type);
    definition?.onTick?.(ctx, event);
    if (event.ticksRemaining === 0 && targetsHealthy(world, event)) {
      event.resolved = true;
      event.resolutionNote ??= "Ursache behoben.";
      ended.push(event);
      continue;
    }
    if (event.ticksRemaining > 0) {
      event.ticksRemaining -= 1;
      if (event.ticksRemaining === 0) {
        definition?.onEnd?.(ctx, event);
        event.resolved = true;
        ended.push(event);
      }
    }
  }
  const activeCount = values(world.events).filter((e) => !e.resolved).length;
  if (activeCount < 5) {
    for (const definition of EVENT_DEFINITIONS) {
      const chance = definition.baseChance * settings.eventFrequency;
      if (!rng.chance(chance)) continue;
      if (!definition.canTrigger(ctx)) continue;
      const payload = definition.trigger(ctx);
      if (!payload) continue;
      const event = {
        ...payload,
        id: asId(makeId(rng, "evt")),
        startedAtTick: world.meta.tick,
        resolved: false,
        resolutionNote: null
      };
      world.events[event.id] = event;
      triggered.push(event);
      if (event.severity === "critical" || event.severity === "error") {
        const affected = outageRecipients(world);
        for (const customer of affected.slice(0, Math.ceil(affected.length * 0.3))) {
          if (!rng.chance(0.4)) continue;
          createTicket(world, rng, {
            customerId: customer.id,
            category: "outage",
            priority: event.severity === "critical" ? "urgent" : "high",
            subject: event.title,
            body: `Wir bemerken eine St\xF6rung: ${event.title}. Bitte um Information.`,
            ref: event.targets[0] ?? null,
            satisfactionImpact: 7
          });
        }
      }
      break;
    }
  }
  for (const event of values(world.events)) {
    if (event.resolved && world.meta.tick - event.startedAtTick > SIM.TICKS_PER_MONTH) {
      delete world.events[event.id];
    }
  }
  return { triggered, ended };
}
function resolveEventOption(ctx, eventId, optionKey) {
  const { world } = ctx;
  const event = world.events[eventId];
  if (!event) return { ok: false, note: "Ereignis nicht gefunden." };
  if (event.resolved) return { ok: false, note: "Ereignis ist bereits abgeschlossen." };
  const option = event.options.find((o) => o.key === optionKey);
  if (!option) return { ok: false, note: "Unbekannte Option." };
  if (option.cost > 0) {
    if (world.company.cash < option.cost) return { ok: false, note: "Nicht gen\xFCgend Liquidit\xE4t f\xFCr diese Ma\xDFnahme." };
    post(world, { category: "cost-other", amount: -option.cost, description: `Ma\xDFnahme: ${option.label}` });
  }
  const definition = DEFINITION_INDEX.get(event.type);
  const result = definition?.onOption?.(ctx, event, optionKey) ?? { ok: true, note: option.label };
  event.resolutionNote = result.note;
  if (event.ticksRemaining === 0) {
    definition?.onEnd?.(ctx, event);
    event.resolved = true;
  }
  return result;
}

// src/domain/ai/advisor.ts
function alert(id, severity, title, message, suggestion, ref) {
  return { id, severity, title, message, suggestion, ref };
}
var ADVISOR_RULES = [
  // --- Ausfallsicherheit --------------------------------------------------
  {
    id: "single-upstream",
    area: "reliability",
    evaluate: (world) => {
      const transits = values(world.links).filter((l) => l.kind === "transit" && isLinkUsable(l));
      const peerings = values(world.links).filter((l) => l.kind.startsWith("peering") && isLinkUsable(l));
      if (transits.length === 0 && peerings.length === 0) {
        return [
          alert(
            "single-upstream",
            "critical",
            "Keine Au\xDFenanbindung",
            "Das Netz hat weder Transit noch Peering. Ohne Uplink ist kein Kunde erreichbar.",
            "Transit-Angebot im Markt buchen."
          )
        ];
      }
      if (transits.length === 1 && peerings.length === 0) {
        return [
          alert(
            "single-upstream",
            "warning",
            "Nur ein Upstream",
            `Der gesamte Verkehr l\xE4uft \xFCber ${transits[0].name}. Ein Ausfall oder ein Wartungsfenster trennt das Netz vollst\xE4ndig vom Internet.`,
            "Zweiten Transit von einem anderen AS buchen (Multihoming).",
            { kind: "link", id: transits[0].id }
          )
        ];
      }
      return [];
    }
  },
  {
    id: "split-backbone",
    area: "network",
    evaluate: (world) => {
      const topology = buildTopology(world);
      if (topology.routers.length < 2) return [];
      const components = connectedComponents(topology);
      if (components.length <= 1) return [];
      return [
        alert(
          "split-backbone",
          "error",
          "Backbone ist geteilt",
          `Das eigene Netz zerf\xE4llt in ${components.length} voneinander getrennte Bereiche. iBGP kann keine Routen austauschen, Standorte ohne eigenen Uplink sind offline.`,
          "Standorte mit einer Glasfaserstrecke verbinden."
        )
      ];
    }
  },
  {
    id: "single-router-per-dc",
    area: "reliability",
    evaluate: (world) => {
      const out = [];
      for (const dc of values(world.datacenters)) {
        const routers = values(world.routers).filter((r) => r.datacenterId === dc.id);
        const customers = values(world.contracts).filter((c) => {
          if (c.state !== "active") return false;
          if (c.serverId) return world.servers[c.serverId]?.datacenterId === dc.id;
          return false;
        }).length;
        if (routers.length === 1 && customers > 10) {
          out.push(
            alert(
              `single-router-${dc.id}`,
              "warning",
              `Nur ein Router in ${dc.city}`,
              `${customers} aktive Vertr\xE4ge h\xE4ngen an einem einzigen Router. F\xE4llt er aus, ist der Standort komplett offline.`,
              "Zweiten Router beschaffen und redundant anbinden.",
              { kind: "datacenter", id: dc.id }
            )
          );
        }
      }
      return out;
    }
  },
  {
    id: "no-generator",
    area: "reliability",
    evaluate: (world) => values(world.datacenters).filter((dc) => !dc.generator.installed).filter((dc) => values(world.racks).some((r) => r.datacenterId === dc.id)).map(
      (dc) => alert(
        `no-generator-${dc.id}`,
        "warning",
        `Kein Notstrom in ${dc.city}`,
        "Ohne Generator \xFCberbr\xFCcken nur die USV-Batterien. Ein l\xE4ngerer Netzausfall legt den Standort vollst\xE4ndig lahm.",
        "Notstromaggregat installieren.",
        { kind: "datacenter", id: dc.id }
      )
    )
  },
  // --- Kapazität ----------------------------------------------------------
  {
    id: "link-congestion",
    area: "capacity",
    evaluate: (world) => values(world.links).filter(isLinkUsable).map((link) => {
      const peak = Math.max(link.utilizationMbps.aToB, link.utilizationMbps.bToA);
      const usage2 = link.capacityMbps > 0 ? peak / link.capacityMbps : 0;
      if (usage2 < SIM.LINK_CONGESTION_WARN) return null;
      const severity = usage2 >= SIM.LINK_CONGESTION_CRITICAL ? "critical" : "warning";
      return alert(
        `congestion-${link.id}`,
        severity,
        `Strecke ausgelastet: ${link.name}`,
        `${(usage2 * 100).toFixed(0)} % der Kapazit\xE4t sind belegt. Ab etwa 90 % steigen Paketverlust und Latenz sp\xFCrbar.`,
        link.kind === "transit" ? "Kapazit\xE4t erh\xF6hen oder Verkehr \xFCber Peering verlagern." : "Strecke aufr\xFCsten oder parallele Verbindung bauen.",
        { kind: "link", id: link.id }
      );
    }).filter((a) => a !== null)
  },
  {
    id: "compute-capacity",
    area: "capacity",
    evaluate: (world) => {
      const out = [];
      for (const product of values(world.products)) {
        if (!product.active) continue;
        const slots = freeSlots(world, product.id);
        if (slots > 5 || slots === Number.MAX_SAFE_INTEGER) continue;
        out.push(
          alert(
            `capacity-${product.id}`,
            slots === 0 ? "error" : "warning",
            `Kapazit\xE4t ersch\xF6pft: ${product.name}`,
            slots === 0 ? `F\xFCr ${product.name} kann kein weiterer Auftrag angenommen werden. Jeder Interessent geht verloren.` : `Nur noch ${slots} freie Pl\xE4tze f\xFCr ${product.name}.`,
            "Passenden Server beschaffen und Rolle zuweisen.",
            { kind: "product", id: product.id }
          )
        );
      }
      return out;
    }
  },
  {
    id: "ipv4-exhaustion",
    area: "capacity",
    evaluate: (world) => {
      const summary = ipamSummary(world, "ipv4");
      if (summary.totalAddresses === 0) return [];
      const usage2 = summary.usedAddresses / summary.totalAddresses;
      if (usage2 < 0.85) return [];
      return [
        alert(
          "ipv4-exhaustion",
          usage2 > 0.97 ? "error" : "warning",
          "IPv4-Adressen werden knapp",
          `${summary.usedAddresses} von ${summary.totalAddresses} Adressen sind vergeben (${(usage2 * 100).toFixed(0)} %).`,
          "Weiteren IPv4-Block kaufen oder Produkte auf IPv6-only bzw. NAT umstellen."
        )
      ];
    }
  },
  {
    id: "rack-space",
    area: "capacity",
    evaluate: (world) => values(world.racks).map((rack) => {
      const usage2 = rackUsage(world, rack.id);
      if (usage2.total === 0 || usage2.used / usage2.total < 0.9) return null;
      return alert(
        `rack-${rack.id}`,
        "warning",
        `Rack fast voll: ${rack.name}`,
        `${usage2.used} von ${usage2.total} H\xF6heneinheiten belegt.`,
        "Weiteres Rack anmieten.",
        { kind: "rack", id: rack.id }
      );
    }).filter((a) => a !== null)
  },
  {
    id: "bgp-session-limit",
    area: "network",
    evaluate: (world) => values(world.routers).filter((router) => router.bgp.neighbors.filter((n) => n.enabled).length > router.maxBgpSessions).map(
      (router) => alert(
        `sessions-${router.id}`,
        "critical",
        `Zu viele BGP-Sessions: ${router.name}`,
        `${router.bgp.neighbors.filter((n) => n.enabled).length} aktivierte Nachbarn bei ${router.maxBgpSessions} unterst\xFCtzten Sessions. Die Control Plane kommt nicht mehr hoch \u2013 keine Session erreicht den Zustand "established", das Netz bleibt ohne Routen.`,
        "\xDCberz\xE4hlige Nachbarn deaktivieren oder einen Router mit gr\xF6\xDFerer Session-Kapazit\xE4t einsetzen.",
        { kind: "router", id: router.id }
      )
    )
  },
  {
    id: "fib-capacity",
    area: "network",
    evaluate: (world) => values(world.routers).filter((router) => {
      const fullTables = router.bgp.neighbors.filter((n) => n.relation === "transit" && n.enabled && !n.defaultOriginate);
      return fullTables.length > 0 && router.fibCapacity < 9e5;
    }).map(
      (router) => alert(
        `fib-${router.id}`,
        "error",
        `FIB zu klein: ${router.name}`,
        `Der Router nimmt eine volle Internet-Tabelle an, h\xE4lt aber nur ${router.fibCapacity.toLocaleString("de-DE")} Eintr\xE4ge. \xDCberz\xE4hlige Routen werden verworfen \u2013 Ziele sind zuf\xE4llig nicht erreichbar.`,
        "Beim Upstream nur eine Default-Route annehmen oder gr\xF6\xDFeren Router einsetzen.",
        { kind: "router", id: router.id }
      )
    )
  },
  // --- Kosten -------------------------------------------------------------
  {
    id: "transit-vs-peering",
    area: "cost",
    evaluate: (world) => {
      const traffic = world.derived.traffic;
      if (traffic.totalMbps < 100) return [];
      if (traffic.transitShare < 0.75) return [];
      const joinedIxps = values(world.ixps).filter((i) => i.joined).length;
      const transitCost = values(world.links).filter((l) => l.kind === "transit").reduce((s, l) => s + billable95th(l) * l.pricePerMbps, 0);
      return [
        alert(
          "transit-vs-peering",
          "info",
          "Hoher Transitanteil",
          `${(traffic.transitShare * 100).toFixed(0)} % des Verkehrs laufen \xFCber kostenpflichtigen Transit (rechnerisch etwa ${transitCost.toFixed(0)} \u20AC pro Monat allein aus dem Volumen).`,
          joinedIxps === 0 ? "Einem Internet Exchange beitreten \u2013 ein Gro\xDFteil des Verkehrs l\xE4sst sich dort kostenlos austauschen." : "Weitere Peerings am vorhandenen IXP aufbauen oder Local Preference f\xFCr Peers erh\xF6hen."
        )
      ];
    }
  },
  {
    id: "idle-hardware",
    area: "cost",
    evaluate: (world) => {
      const idle = values(world.servers).filter(
        (s) => s.contractIds.length === 0 && s.vpsIds.length === 0 && world.meta.tick - s.purchasedAtTick > SIM.TICKS_PER_MONTH
      );
      if (idle.length < 2) return [];
      return [
        alert(
          "idle-hardware",
          "info",
          "Ungenutzte Server",
          `${idle.length} Server laufen seit \xFCber einem Monat ohne Kunden und verursachen Strom- und Wartungskosten.`,
          "Rollen zuweisen, Produkte bewerben oder Hardware abschalten."
        )
      ];
    }
  },
  {
    id: "runway",
    area: "business",
    evaluate: (world) => {
      const runway = world.derived.finance.runwayMonths;
      if (!Number.isFinite(runway) || runway > 4) return [];
      return [
        alert(
          "runway",
          runway < 1.5 ? "critical" : "warning",
          "Liquidit\xE4t wird knapp",
          `Bei gleichbleibendem Verlust reicht das Guthaben noch etwa ${runway.toFixed(1)} Monate.`,
          "Kosten senken, Preise anpassen oder Investitionen verschieben."
        )
      ];
    }
  },
  // --- Betrieb ------------------------------------------------------------
  {
    id: "ticket-backlog",
    area: "business",
    evaluate: (world) => {
      const stats = ticketStats(world);
      if (stats.overdue < 3) return [];
      return [
        alert(
          "ticket-backlog",
          stats.overdue > 10 ? "error" : "warning",
          "Tickets \xFCberf\xE4llig",
          `${stats.overdue} Tickets haben die Reaktionszeit \xFCberschritten (${stats.open} offen insgesamt). Jede Stunde kostet Zufriedenheit.`,
          "Weiteren Supportmitarbeiter einstellen oder Support-Werkzeuge erforschen."
        )
      ];
    }
  },
  {
    id: "hot-devices",
    area: "reliability",
    evaluate: (world) => {
      const hot = [...values(world.servers), ...values(world.routers)].filter((d) => d.temperatureC > SIM.TEMP_WARN_C);
      if (hot.length === 0) return [];
      const hottest = hot.sort((a, b) => b.temperatureC - a.temperatureC)[0];
      return [
        alert(
          "hot-devices",
          hottest.temperatureC > SIM.TEMP_CRITICAL_C ? "critical" : "warning",
          "Ger\xE4te laufen zu hei\xDF",
          `${hot.length} Ger\xE4te \xFCber ${SIM.TEMP_WARN_C} \xB0C, Spitzenwert ${hottest.temperatureC.toFixed(0)} \xB0C bei ${hottest.name}. Hitze beschleunigt den Verschlei\xDF und f\xFChrt zu Ausf\xE4llen.`,
          "K\xFChlleistung erh\xF6hen, Racks entzerren oder freie K\xFChlung erforschen."
        )
      ];
    }
  },
  {
    id: "aging-hardware",
    area: "reliability",
    evaluate: (world) => {
      const worn = [...values(world.servers), ...values(world.routers), ...values(world.switches)].filter((d) => d.health < 0.4);
      if (worn.length === 0) return [];
      return [
        alert(
          "aging-hardware",
          "warning",
          "Hardware am Ende der Lebensdauer",
          `${worn.length} Ger\xE4te haben unter 40 % Restzustand. Die Ausfallwahrscheinlichkeit steigt stark an.`,
          "Betroffene Ger\xE4te warten oder ersetzen."
        )
      ];
    }
  },
  {
    id: "no-firewall",
    area: "security",
    evaluate: (world) => {
      if (Object.keys(world.firewalls).length > 0) return [];
      if (values(world.customers).length < 5) return [];
      return [
        alert(
          "no-firewall",
          "warning",
          "Keine Filterinfrastruktur",
          "Es ist keine Firewall im Netz. Volumetrische Angriffe treffen die Uplinks ungebremst.",
          "Scrubbing-Appliance beschaffen und am Netzrand platzieren."
        )
      ];
    }
  },
  {
    id: "missing-rdns",
    area: "network",
    evaluate: (world) => {
      const missing = values(world.prefixes).filter((p) => p.usage === "customer" && !p.rdnsDelegated);
      if (missing.length === 0) return [];
      return [
        alert(
          "missing-rdns",
          "info",
          "Reverse DNS fehlt",
          `${missing.length} Kundennetze haben keine delegierte Reverse-Zone. Mailserver dieser Kunden werden von vielen Empf\xE4ngern abgelehnt.`,
          "Reverse-Zonen anlegen und delegieren."
        )
      ];
    }
  },
  {
    id: "unannounced-prefix",
    area: "network",
    evaluate: (world) => {
      const unannounced = values(world.prefixes).filter(
        (p) => p.usage === "customer" && p.parentId === null && !p.announced && p.source !== "upstream"
      );
      if (unannounced.length === 0) return [];
      return [
        alert(
          "unannounced-prefix",
          "warning",
          "Prefix wird nicht angek\xFCndigt",
          `${unannounced.length} eigene Netze werden per BGP nicht angek\xFCndigt und sind damit aus dem Internet nicht erreichbar.`,
          "Prefix im BGP-Bereich zur Ank\xFCndigung freigeben."
        )
      ];
    }
  }
];
function analyze(world) {
  const severityRank = { critical: 0, error: 1, warning: 2, info: 3 };
  const alerts = [];
  for (const rule of ADVISOR_RULES) {
    try {
      alerts.push(...rule.evaluate(world));
    } catch {
    }
  }
  return alerts.sort((a, b) => severityRank[a.severity] - severityRank[b.severity]);
}
function ask(world, topic) {
  switch (topic) {
    case "routing": {
      const tables = Object.values(world.derived.routingTables);
      const totalRoutes = tables.reduce((s, t) => s + t.entries.length, 0);
      const details = tables.map(
        (t) => `${world.routers[t.routerId]?.name ?? t.routerId}: ${t.entries.length} beste Pfade aus ${t.totalPaths} Kandidaten`
      );
      const viaPeering = world.derived.traffic.peeringMbps;
      const viaTransit = world.derived.traffic.transitMbps;
      return {
        question: "Wie sieht mein Routing aus?",
        answer: `\xDCber alle Router sind ${totalRoutes} beste Pfade aktiv. ${viaPeering.toFixed(0)} Mbit/s flie\xDFen \xFCber Peering, ${viaTransit.toFixed(0)} Mbit/s \xFCber Transit. ` + (viaTransit > viaPeering ? "Der Transitanteil \xFCberwiegt \u2013 Peering w\xFCrde die Kosten senken." : "Der Peering-Anteil \xFCberwiegt, das ist wirtschaftlich gut."),
        details
      };
    }
    case "costs": {
      const finance = world.derived.finance;
      const sorted = Object.entries(finance.costBreakdown).sort((a, b) => b[1] - a[1]);
      return {
        question: "Wo liegen meine gr\xF6\xDFten Kosten?",
        answer: sorted.length === 0 ? "Es liegen noch keine Kostendaten vor." : `Gr\xF6\xDFter Posten ist "${sorted[0][0]}" mit rund ${sorted[0][1].toFixed(0)} \u20AC pro Monat. Gesamtkosten etwa ${finance.monthlyCost.toFixed(0)} \u20AC gegen\xFCber ${finance.monthlyRevenue.toFixed(0)} \u20AC Umsatz.`,
        details: sorted.map(([category, amount]) => `${category}: ${amount.toFixed(0)} \u20AC/Monat`)
      };
    }
    case "capacity": {
      const capacity = world.derived.capacity;
      const details = [
        `CPU: ${capacity.cpuCoresUsed.toFixed(0)} von ${capacity.cpuCoresTotal.toFixed(0)} Kernen`,
        `RAM: ${capacity.ramGbUsed.toFixed(0)} von ${capacity.ramGbTotal.toFixed(0)} GB`,
        `Speicher: ${capacity.diskGbUsed.toFixed(0)} von ${capacity.diskGbTotal.toFixed(0)} GB`,
        `Rackplatz: ${capacity.rackUnitsUsed} von ${capacity.rackUnitsTotal} HE`,
        `Strom: ${capacity.powerKwUsed.toFixed(1)} von ${capacity.powerKwTotal.toFixed(1)} kW`,
        `IPv4: ${capacity.ipv4Used} von ${capacity.ipv4Total} Adressen`
      ];
      const ramUsage = capacity.ramGbTotal > 0 ? capacity.ramGbUsed / capacity.ramGbTotal : 0;
      return {
        question: "Reicht meine Kapazit\xE4t?",
        answer: ramUsage > 0.85 ? "Der Arbeitsspeicher ist der Engpass \u2013 ohne zus\xE4tzliche Server lassen sich kaum noch Auftr\xE4ge annehmen." : "Die Kapazit\xE4t tr\xE4gt das aktuelle Wachstum. Beobachte vor allem RAM und IPv4.",
        details
      };
    }
    case "reliability": {
      const alerts = world.derived.alerts.filter((a) => a.severity === "critical" || a.severity === "error");
      return {
        question: "Wie stabil ist mein Netz?",
        answer: alerts.length === 0 ? `Keine kritischen Befunde. Verf\xFCgbarkeit im laufenden Monat: ${world.derived.quality.uptimePercent.toFixed(2)} %.` : `${alerts.length} kritische Befunde. Der wichtigste: ${alerts[0].title}.`,
        details: world.derived.alerts.map((a) => `[${a.severity}] ${a.title}: ${a.message}`)
      };
    }
  }
}

// src/domain/progress/objectives.ts
var de = (n) => Math.round(n).toLocaleString("de-DE");
function count(current, target, unit) {
  return { current, target, label: `${de(Math.min(current, target))} / ${de(target)} ${unit}` };
}
function below(value, limit, floor, label) {
  const reached = floor && value <= limit;
  return { current: reached ? 1 : 0, target: 1, label };
}
function done(reached, label) {
  return { current: reached ? 1 : 0, target: 1, label };
}
function transitAsns(world) {
  const asns = /* @__PURE__ */ new Set();
  for (const link of values(world.links)) {
    if (link.kind !== "transit" || !isLinkUsable(link)) continue;
    if (link.remoteAsn) asns.add(link.remoteAsn);
  }
  return asns;
}
function activePeerings(world) {
  return values(world.peerings).filter((p) => p.state === "active").length;
}
function onlineServers(world) {
  return values(world.servers).filter((s) => s.state === "online" || s.state === "degraded").length;
}
function servingServers(world) {
  return values(world.servers).filter(
    (s) => (s.state === "online" || s.state === "degraded") && s.os !== null && isServerConnected(world, s.id)
  ).length;
}
function supportStaff(world) {
  return values(world.staff).filter((s) => s.role === "support").length;
}
var CAMPAIGN = [
  {
    id: "first-customers",
    kind: "campaign",
    area: "growth",
    title: "Die ersten zehn Kunden",
    rationale: "Kunden kommen nicht von allein: Sie entstehen aus Preis, Ruf und dem Marktpotenzial deines Standorts. Wenn nichts passiert, steht dein Preis \xFCber dem Markt \u2013 oder es fehlt die Kapazit\xE4t, um die Auftr\xE4ge anzunehmen.",
    hint: { page: "products", text: "Der Preis entscheidet, wie schnell die ersten Interessenten kommen." },
    requires: [],
    reward: { reputation: 1 },
    measure: (w) => count(w.derived.customers.total, 10, "Kunden")
  },
  {
    id: "second-support",
    kind: "campaign",
    area: "operations",
    title: "Support aufbauen",
    rationale: "Eine Supportkraft tr\xE4gt grob tausend Kunden \u2013 aber nur in ihrer Schicht. Der Inhaber allein deckt keine zwei Schichten ab. Unbeantwortete Tickets senken die Zufriedenheit, das erzeugt K\xFCndigungen und dr\xFCckt den Ruf, und ein schlechter Ruf bremst die Neukundenrate. Diese Schleife dreht sich schneller, als man denkt.",
    hint: { page: "staff", text: "Einstellen, Schichtmodell und Fachgebiete festlegen." },
    requires: ["first-customers"],
    reward: { reputation: 2 },
    measure: (w) => count(supportStaff(w), 2, "Supportkr\xE4fte")
  },
  {
    id: "more-capacity",
    kind: "campaign",
    area: "growth",
    title: "Kapazit\xE4t schaffen",
    rationale: "Fehlt Rechenkapazit\xE4t, gehen Interessenten verloren \u2013 lautlos, denn ein abgelehnter Auftrag taucht in keiner Bilanz auf. Shared Hosting l\xE4sst sich \xFCberbuchen, VPS nicht: Dort ist RAM fest zugeteilt. Gez\xE4hlt wird hier, was l\xE4uft \u2013 ein Server in Reserve z\xE4hlt nicht mit. Betriebssystem und Kabel braucht er trotzdem, sonst nimmt er keine Kunden auf; darum k\xFCmmert sich das Ziel \u201ESechs Knoten, die ausliefern\u201C sp\xE4ter.",
    hint: { page: "servers", text: "Server kaufen und einschalten." },
    /*
     * Hinter dem Support, nicht daneben – und vor allem kein Torwächter mehr.
     *
     * Sechs laufende Server sind früh eine Beschäftigungstherapie: Die drei
     * aus der Startausstattung tragen ein Vielfaches der ersten Kunden, und
     * dieses Ziel verlangte trotzdem, drei weitere zu kaufen, bevor irgendetwas
     * anderes weiterging. Es blockierte "Hundert Kunden" und damit die halbe
     * Kampagne inklusive der Forschung. Jetzt läuft es neben dem Wachstum her:
     * offen, sichtbar, aber niemandes Vorbedingung.
     */
    requires: ["second-support"],
    reward: { reputation: 1 },
    measure: (w) => count(onlineServers(w), 6, "Server in Betrieb")
  },
  {
    id: "hundred-customers",
    kind: "campaign",
    area: "growth",
    title: "Hundert Kunden",
    rationale: "Ab hier tr\xE4gt sich der Betrieb nicht mehr nebenbei. Achte auf die Verschiebung zwischen Kosten und Erl\xF6sen: Hardware und Transit zahlst du sofort, die Rechnungen kommen monatlich mit Zahlungsziel. Wer schnell w\xE4chst, hat genau deshalb am wenigsten Geld.",
    hint: { page: "customers", text: "Wer kommt, wer geht \u2013 und woran es liegt." },
    requires: ["second-support"],
    reward: { reputation: 3 },
    measure: (w) => count(w.derived.customers.total, 100, "Kunden")
  },
  /**
   * Dieselbe Zahl, strenger gemessen – und deshalb erst hier.
   *
   * „Kapazität schaffen“ zählt Geräte, die laufen. Das ist für den dritten
   * Schritt der Kampagne genau richtig: Wer dort steht, hat Server gekauft und
   * eingeschaltet, mehr nicht. Die Regel, die im Betrieb wirklich gilt – ein
   * Knoten ohne Betriebssystem und ohne Weg zum Router bedient niemanden –
   * stand früher im Text des frühen Ziels, ohne dass sie gemessen wurde. Sie
   * gehört an die Stelle, an der beides längst dazugehört, und dort als Ziel
   * mit eigenem Namen statt als Kleingedrucktes.
   */
  {
    id: "serving-nodes",
    kind: "campaign",
    area: "growth",
    title: "Sechs Knoten, die ausliefern",
    rationale: "Ein laufender Server ist noch kein Knoten, der Kunden bedient. Es fehlt zweierlei: ein Betriebssystem \u2013 ohne das nimmt er keine Auftr\xE4ge an \u2013 und ein Weg nach drau\xDFen. Der geht \xFCber den Switch, und der Switch muss seinerseits an einem Router h\xE4ngen. Ein Switch verteilt nur; nach drau\xDFen verbindet er nicht.",
    hint: { page: "servers", text: "Betriebssystem installieren, an den Switch stecken \u2013 und den Switch an den Router." },
    // Der strenge Zwilling von "Kapazität schaffen" – er gehört unmittelbar
    // dahinter und nicht an die Kundenzahl.
    requires: ["more-capacity"],
    reward: { reputation: 2 },
    measure: (w) => count(servingServers(w), 6, "Knoten am Netz")
  },
  {
    id: "multihoming",
    kind: "campaign",
    area: "network",
    title: "Zweiter Upstream",
    rationale: "Mit einem einzigen Upstream trennt jedes Wartungsfenster dein gesamtes Netz vom Internet \u2013 und du kannst nichts dagegen tun au\xDFer warten. Ein zweiter Transit von einem *anderen* AS ist der erste Schritt zu einem Netz, das man ernst nehmen kann. Zwei Strecken zum selben Anbieter sind kein Multihoming.",
    hint: { page: "links", text: "Transit von einem zweiten AS buchen." },
    requires: ["hundred-customers"],
    reward: { reputation: 4 },
    measure: (w) => count(transitAsns(w).size, 2, "Upstream-AS")
  },
  {
    id: "backup-power",
    kind: "campaign",
    area: "operations",
    title: "Notstrom",
    rationale: "Die USV \xFCberbr\xFCckt Minuten, nicht Stunden. Ohne Generator endet jeder l\xE4ngere Netzausfall damit, dass dein Standort dunkel wird \u2013 mit allem, was daran h\xE4ngt: Ausfallzeit in jedem Vertrag, SLA-Gutschriften, K\xFCndigungen. Der Generator ist die billigste Versicherung im Spiel.",
    hint: { page: "datacenters", text: "Generator am Standort installieren." },
    requires: ["hundred-customers"],
    reward: { reputation: 2 },
    measure: (w) => done(values(w.datacenters).some((dc) => dc.generator.installed), "Generator installiert")
  },
  {
    id: "redundant-router",
    kind: "campaign",
    area: "network",
    title: "Zweiter Router",
    rationale: "Zwei Upstreams an einem Router sind eine halbe Redundanz: F\xE4llt das Ger\xE4t aus, ist beides weg. Ein zweiter Router im selben Standort verteilt das Risiko \u2013 und ohne Techniker im Haus bleibt ein Routerausfall endg\xFCltig.",
    hint: { page: "routers", text: "Zweiten Router kaufen und verkabeln." },
    requires: ["multihoming"],
    reward: { reputation: 3 },
    measure: (w) => count(values(w.routers).length, 2, "Router")
  },
  {
    id: "join-ixp",
    kind: "campaign",
    area: "network",
    title: "Einem Internetknoten beitreten",
    rationale: "Am IXP triffst du die Netze, mit denen du ohnehin Verkehr austauschst. Der Route-Server ist dabei die Abk\xFCrzung: eine einzige Sitzung, \xFCber die alle offenen Mitglieder erreichbar werden \u2013 statt mit jedem Netz einzeln zu verhandeln.",
    hint: { page: "ixp", text: "Knoten w\xE4hlen, Port buchen, Route-Server verbinden." },
    requires: ["multihoming"],
    reward: { reputation: 3 },
    measure: (w) => done(values(w.ixps).some((ixp) => ixp.joined), "IXP-Mitgliedschaft")
  },
  {
    id: "first-peering",
    kind: "campaign",
    area: "network",
    title: "Das erste Peering",
    rationale: "Peering-Verkehr kostet nichts und nimmt den k\xFCrzeren Weg. Aber ein Peering senkt deine Rechnung nur dann, wenn deine Routingpolitik den Verkehr auch dorthin lenkt \u2013 ein aufgebauter Peer, den keine Route benutzt, ist reine Zierde.",
    hint: { page: "ixp", text: "Peering-Anfragen stellen \u2013 am schnellsten \xFCber den Route-Server." },
    requires: ["join-ixp"],
    reward: { reputation: 4 },
    measure: (w) => count(activePeerings(w), 1, "aktive Peerings")
  },
  {
    id: "transit-share",
    kind: "campaign",
    area: "finance",
    title: "Transitanteil unter 50 %",
    rationale: "Transit wird nach dem 95. Perzentil abgerechnet \u2013 die Spitzen bestimmen die Rechnung, nicht der Schnitt. Jedes Prozent, das stattdessen \xFCber Peering l\xE4uft, ist dauerhaft gespartes Geld. Ab etwa 1 Gbit/s Gesamtverkehr wird diese Rechnung interessant.",
    hint: { page: "bgp", text: "Die Routingpolitik entscheidet, welcher Verkehr \xFCber Peering l\xE4uft." },
    requires: ["first-peering"],
    reward: { reputation: 4 },
    measure: (w) => {
      const total = w.derived.traffic.totalMbps;
      const share = w.derived.traffic.transitShare;
      return below(
        share,
        0.5,
        total >= 1e3,
        total < 1e3 ? `noch zu wenig Verkehr (${de(total)} / 1.000 Mbit/s)` : `Transitanteil ${(share * 100).toFixed(0)} %`
      );
    }
  },
  {
    id: "second-site",
    kind: "campaign",
    area: "growth",
    title: "Zweiter Standort",
    rationale: "Ein zweiter Standort erschlie\xDFt ein neues Kundenpotenzial und \xFCberlebt den Ausfall des ersten. Er will aber verbunden sein: Ohne Glasfaser dazwischen sind es zwei Netze, die sich zuf\xE4llig dieselbe AS-Nummer teilen.",
    hint: { page: "datacenters", text: "Standort er\xF6ffnen \u2013 und mit Glasfaser anbinden." },
    requires: ["redundant-router"],
    reward: { reputation: 5 },
    measure: (w) => count(values(w.datacenters).length, 2, "Standorte")
  },
  {
    id: "first-research",
    kind: "campaign",
    area: "operations",
    title: "Erste Forschung abschlie\xDFen",
    rationale: "Forschung ist der einzige Weg, die Grundrechnung zu ver\xE4ndern statt nur mehr davon zu kaufen: bessere K\xFChlung senkt jede Stromrechnung, ein optimierter Hypervisor bringt Kapazit\xE4t ohne neue Hardware.",
    hint: { page: "research", text: "Ein Projekt ausw\xE4hlen und starten." },
    /*
     * Früh, weil Forschung früh etwas ändert.
     *
     * Sie stand hinter dem hundertsten Kunden und war damit für die gesamte
     * Aufbauphase unsichtbar – ausgerechnet der Zweig, der die Grundrechnung
     * verbessert statt nur mehr davon zu kaufen. Das billigste Projekt kostet
     * 18.000 €; das ist früh eine Entscheidung und keine Formalie, und genau
     * so soll es sein.
     */
    requires: ["second-support"],
    reward: { reputation: 2 },
    measure: (w) => count(values(w.research).filter((r) => r.completed).length, 1, "Projekte")
  },
  {
    id: "profitable",
    kind: "campaign",
    area: "finance",
    title: "Schwarze Zahlen",
    rationale: "Ein Monatsgewinn bei nennenswerter Kundenzahl bedeutet, dass dein Preis die Kosten tr\xE4gt \u2013 Strom, Personal, Transit, Miete und Abschreibung zusammen. Bis dahin w\xE4chst du auf Kredit.",
    hint: { page: "finance", text: "Kosten nach Kategorie \u2013 hier sieht man, was dr\xFCckt." },
    requires: ["hundred-customers"],
    reward: { reputation: 4 },
    measure: (w) => done(w.derived.finance.monthlyProfit > 0 && w.derived.customers.total >= 250, "Monatsgewinn bei 250+ Kunden")
  },
  {
    id: "thousand-customers",
    kind: "campaign",
    area: "growth",
    title: "Tausend Kunden",
    rationale: "In dieser Gr\xF6\xDFenordnung entscheidet nicht mehr die Technik, sondern die Organisation: Schichtabdeckung im Support, Ersatzteile am Lager, ein zweiter Mensch, der den Router anfassen darf.",
    hint: { page: "customers", text: "In dieser Gr\xF6\xDFe entscheidet die Organisation, nicht die Technik." },
    requires: ["second-site", "profitable"],
    reward: { reputation: 6 },
    measure: (w) => count(w.derived.customers.total, 1e3, "Kunden")
  },
  {
    id: "debt-free",
    kind: "campaign",
    area: "finance",
    title: "Schuldenfrei",
    rationale: "Zinsen laufen st\xFCndlich, unabh\xE4ngig davon, wie das Gesch\xE4ft l\xE4uft. Ein Betrieb dieser Gr\xF6\xDFe ohne Schulden \xFCbersteht einen schlechten Monat, ohne etwas verkaufen zu m\xFCssen.",
    hint: { page: "finance", text: "Schulden gezielt tilgen." },
    requires: ["thousand-customers"],
    reward: { reputation: 5 },
    measure: (w) => done(w.company.debt <= 0 && w.derived.customers.total >= 1e3, "schuldenfrei bei 1.000+ Kunden")
  },
  {
    id: "ten-gbit",
    kind: "campaign",
    area: "network",
    title: "Zehn Gigabit",
    rationale: "Ab dieser Gr\xF6\xDFe wirst du f\xFCr andere Netze als Peering-Partner interessant \u2013 und deine Routingpolitik ist kein Detail mehr, sondern der gr\xF6\xDFte Posten auf deiner Kostenseite.",
    hint: { page: "monitoring", text: "Verkehr und Netzqualit\xE4t im Verlauf." },
    requires: ["transit-share"],
    reward: { reputation: 6 },
    measure: (w) => count(w.derived.traffic.totalMbps, 1e4, "Mbit/s")
  }
];
var ACHIEVEMENTS = [
  {
    id: "ach-sparfuchs",
    kind: "achievement",
    area: "finance",
    title: "Sparfuchs",
    rationale: "H\xF6chstens ein F\xFCnftel des Verkehrs l\xE4uft \xFCber bezahlten Transit \u2013 bei mindestens 5 Gbit/s.",
    requires: [],
    measure: (w) => {
      const total = w.derived.traffic.totalMbps;
      const share = w.derived.traffic.transitShare;
      return below(share, 0.2, total >= 5e3, `${(share * 100).toFixed(0)} % Transit bei ${de(total)} Mbit/s`);
    }
  },
  {
    id: "ach-peering-netzwerker",
    kind: "achievement",
    area: "network",
    title: "Netzwerker",
    rationale: "F\xFCnf aktive Peering-Beziehungen gleichzeitig.",
    requires: [],
    measure: (w) => count(activePeerings(w), 5, "Peerings")
  },
  {
    id: "ach-manrs",
    kind: "achievement",
    area: "network",
    title: "Saubere Papiere",
    rationale: "RPKI signiert und validierend, IRR gepflegt und filternd \u2013 vollst\xE4ndige MANRS-Konformit\xE4t.",
    requires: [],
    measure: (w) => {
      const h = w.company.hygiene;
      const n = [h.rpkiSigned, h.rpkiValidating, h.irrRegistered, h.irrFiltering].filter(Boolean).length;
      return count(n, 4, "Ma\xDFnahmen");
    }
  },
  {
    id: "ach-uptime",
    kind: "achievement",
    area: "operations",
    title: "Drei Neunen",
    rationale: "99,9 % Verf\xFCgbarkeit im laufenden Monat bei mindestens 200 Kunden.",
    requires: [],
    measure: (w) => done(
      w.derived.quality.uptimePercent >= 99.9 && w.derived.customers.total >= 200,
      `${w.derived.quality.uptimePercent.toFixed(2)} % bei ${de(w.derived.customers.total)} Kunden`
    )
  },
  {
    id: "ach-satisfaction",
    kind: "achievement",
    area: "operations",
    title: "Zufriedene Kundschaft",
    rationale: "Durchschnittliche Zufriedenheit \xFCber 90 bei mindestens 200 Kunden.",
    requires: [],
    measure: (w) => done(
      w.derived.customers.avgSatisfaction >= 90 && w.derived.customers.total >= 200,
      `Zufriedenheit ${w.derived.customers.avgSatisfaction.toFixed(0)} / 100`
    )
  },
  {
    id: "ach-inbox-zero",
    kind: "achievement",
    area: "operations",
    title: "Leerer Posteingang",
    rationale: "Kein einziger offener Vorgang bei mindestens 300 Kunden.",
    requires: [],
    measure: (w) => {
      const stats = ticketStats(w);
      return done(stats.open === 0 && w.derived.customers.total >= 300, `${de(stats.open)} offene Vorg\xE4nge`);
    }
  },
  {
    id: "ach-reputation",
    kind: "achievement",
    area: "growth",
    title: "Guter Name",
    rationale: "Ruf \xFCber 90 \u2013 der Markt kennt dich und mag dich.",
    requires: [],
    measure: (w) => count(w.company.reputation, 90, "Rufpunkte")
  },
  {
    id: "ach-landesweit",
    kind: "achievement",
    area: "growth",
    title: "Landesweit",
    rationale: "Vier Standorte gleichzeitig in Betrieb.",
    requires: [],
    measure: (w) => count(values(w.datacenters).length, 4, "Standorte")
  },
  {
    id: "ach-vollausbau",
    kind: "achievement",
    area: "operations",
    title: "Vollausbau",
    rationale: "Neun von zehn H\xF6heneinheiten belegt \u2013 bei mindestens drei Racks.",
    requires: [],
    measure: (w) => {
      const { rackUnitsTotal, rackUnitsUsed } = w.derived.capacity;
      const ratio = rackUnitsTotal > 0 ? rackUnitsUsed / rackUnitsTotal : 0;
      return done(
        values(w.racks).length >= 3 && ratio >= 0.9,
        `${de(rackUnitsUsed)} / ${de(rackUnitsTotal)} HE belegt`
      );
    }
  },
  {
    id: "ach-forscherdrang",
    kind: "achievement",
    area: "operations",
    title: "Forscherdrang",
    rationale: "Jedes Forschungsprojekt abgeschlossen.",
    requires: [],
    measure: (w) => {
      const all = values(w.research);
      return count(all.filter((r) => r.completed).length, Math.max(all.length, 1), "Projekte");
    }
  },
  {
    id: "ach-doppelt",
    kind: "achievement",
    area: "network",
    title: "Doppelt h\xE4lt besser",
    rationale: "Jeder Standort hat mindestens zwei Router, einen Generator und zwei Netzeinspeisungen.",
    requires: [],
    measure: (w) => {
      const dcs = values(w.datacenters);
      const safe = dcs.filter(
        (dc) => dc.generator.installed && dc.powerFeeds.count >= 2 && values(w.routers).filter((r) => r.datacenterId === dc.id).length >= 2
      ).length;
      return dcs.length === 0 ? count(0, 1, "Standorte") : count(safe, dcs.length, "Standorte abgesichert");
    }
  },
  {
    id: "ach-umsatzmillion",
    kind: "achievement",
    area: "finance",
    title: "Die erste Million",
    rationale: "Eine Million Euro Gesamtumsatz seit Gr\xFCndung.",
    requires: [],
    measure: (w) => count(w.company.lifetimeRevenue, 1e6, "\u20AC Umsatz")
  },
  {
    id: "ach-dickes-rohr",
    kind: "achievement",
    area: "network",
    title: "Dickes Rohr",
    rationale: "Vierzig Gigabit pro Sekunde durch das eigene Netz.",
    requires: [],
    measure: (w) => count(w.derived.traffic.totalMbps, 4e4, "Mbit/s")
  },
  {
    id: "ach-rundumdieuhr",
    kind: "achievement",
    area: "operations",
    title: "Rund um die Uhr",
    rationale: "Mindestens drei Supportkr\xE4fte im Schichtbetrieb \u2013 nachts erreichbar, nicht nur in Rufbereitschaft.",
    requires: [],
    measure: (w) => {
      const inShift = values(w.staff).filter((s) => s.role === "support" && s.shift === "shift").length;
      return count(inShift, 3, "im Schichtbetrieb");
    }
  }
];
var OBJECTIVES = [...CAMPAIGN, ...ACHIEVEMENTS];
var BY_ID = new Map(OBJECTIVES.map((o) => [o.id, o]));
function findObjective(id) {
  return BY_ID.get(id);
}
function isReached(progress) {
  return progress.current >= progress.target;
}
function isAvailable(objective, completed) {
  return objective.requires.every((id) => completed[id] !== void 0);
}
function evaluateObjectives(world) {
  const progress = world.progress;
  const fresh = [];
  for (let pass = 0; pass < CAMPAIGN.length + 1; pass++) {
    let changed = false;
    for (const objective of OBJECTIVES) {
      if (progress.completed[objective.id] !== void 0) continue;
      if (!isAvailable(objective, progress.completed)) continue;
      if (!isReached(objective.measure(world))) continue;
      progress.completed[objective.id] = world.meta.tick;
      fresh.push({ id: objective.id, title: objective.title, kind: objective.kind });
      if (objective.reward?.reputation) {
        world.company.reputation = clamp(world.company.reputation + objective.reward.reputation, 0, 100);
      }
      changed = true;
    }
    if (!changed) break;
  }
  progress.lastEvaluatedTick = world.meta.tick;
  return fresh;
}
function objectiveViews(world) {
  const completed = world.progress.completed;
  return OBJECTIVES.map((objective) => ({
    id: objective.id,
    kind: objective.kind,
    area: objective.area,
    title: objective.title,
    rationale: objective.rationale,
    hint: objective.hint ?? null,
    progress: objective.measure(world),
    completedAtTick: completed[objective.id] ?? null,
    available: isAvailable(objective, completed)
  }));
}
function currentObjective(world) {
  const completed = world.progress.completed;
  const candidates = CAMPAIGN.filter(
    (objective) => completed[objective.id] === void 0 && isAvailable(objective, completed)
  );
  if (candidates.length === 0) return null;
  let best = null;
  let bestRatio = -1;
  let bestProgress = null;
  for (const objective of candidates) {
    const progress = objective.measure(world);
    const ratio = progress.target > 0 ? progress.current / progress.target : 0;
    if (ratio > bestRatio) {
      best = objective;
      bestRatio = ratio;
      bestProgress = progress;
    }
  }
  if (!best || !bestProgress) return null;
  return {
    id: best.id,
    kind: best.kind,
    area: best.area,
    title: best.title,
    rationale: best.rationale,
    hint: best.hint ?? null,
    progress: bestProgress,
    completedAtTick: null,
    available: true
  };
}
function progressSummary(world) {
  const completed = world.progress.completed;
  return {
    campaignCompleted: CAMPAIGN.filter((o) => completed[o.id] !== void 0).length,
    campaignTotal: CAMPAIGN.length,
    achievementsCompleted: ACHIEVEMENTS.filter((o) => completed[o.id] !== void 0).length,
    achievementsTotal: ACHIEVEMENTS.length,
    current: currentObjective(world),
    completed
  };
}
function emptyProgress() {
  return { completed: {}, lastEvaluatedTick: -1 };
}
var AREA_UNLOCKS = {
  // Netz – der Teil, der Neulinge abschreckt.
  routers: "more-capacity",
  switches: "more-capacity",
  links: "hundred-customers",
  bgp: "multihoming",
  ixp: "multihoming",
  ipam: "join-ixp",
  services: "second-site",
  /*
   * Lastausgleich erscheint mit dem dreistelligen Kundenstamm.
   *
   * Früher wäre er eine Antwort auf eine Frage, die sich noch nicht stellt: Wer
   * zwölf Kunden hat, verliert bei einem Serverausfall zwölf Kunden für eine
   * Stunde. Ab hundert wird daraus eine SLA-Gutschrift und eine Kündigungswelle
   * – und die zweite Kopie ihr Geld wert.
   */
  loadbalancer: "hundred-customers",
  // Infrastruktur jenseits der Grundausstattung.
  parts: "more-capacity",
  vps: "more-capacity",
  dedicated: "hundred-customers",
  /*
   * Umzüge werden mit dem zweiten Knoten sichtbar – vorher gibt es kein Ziel,
   * auf das sich etwas verlegen ließe, und die Seite wäre leer. Die
   * Freischaltung wird gemeldet; das ist auffälliger als ein Eintrag, der von
   * Anfang an dasteht und nichts zeigt.
   */
  migrations: "more-capacity",
  // Auswertung, die vor den ersten Kunden nichts zeigt.
  monitoring: "first-customers",
  // Die Welt gibt es von Anfang an; sichtbar wird sie, sobald der Spieler
  // überhaupt etwas hat, das sie beeinflussen könnte.
  world: "first-customers",
  news: "first-customers",
  market: "hundred-customers",
  map: "multihoming",
  offers: "hundred-customers",
  // Der Forschungsbereich öffnet mit der zweiten Supportkraft, nicht mit dem
  // hundertsten Kunden: Wer forschen soll, muss den Baum sehen können, solange
  // die Entscheidungen darin noch etwas bewirken.
  research: "second-support",
  advisor: "second-support"
};
function isAreaUnlocked(world, page) {
  const required = AREA_UNLOCKS[page];
  if (!required) return true;
  return world.progress.completed[required] !== void 0;
}
function areasUnlockedBy(objectiveId) {
  return Object.entries(AREA_UNLOCKS).filter(([, required]) => required === objectiveId).map(([page]) => page);
}

// src/domain/analysis/attribution.ts
var CATEGORY_LABEL = {
  "revenue-hosting": "Hosting-Erl\xF6se",
  "revenue-domain": "Domain-Erl\xF6se",
  "revenue-transit": "Transit-Verkauf",
  "revenue-colocation": "Colocation-Erl\xF6se",
  "revenue-other": "Sonstige Erl\xF6se",
  "cost-power": "Strom",
  "cost-cooling": "K\xFChlung",
  "cost-rack": "Racks und Miete",
  "cost-hardware": "Hardware",
  "cost-staff": "Personal",
  "cost-transit": "IP-Transit",
  "cost-ip": "IP-Adressen",
  "cost-fiber": "Glasfaser",
  "cost-ixp": "IXP-Ports",
  "cost-domain": "Domains",
  "cost-research": "Forschung",
  "cost-penalty": "SLA-Gutschriften",
  "cost-loan": "Kreditraten",
  "cost-tax": "Umsatzsteuer",
  "cost-other": "Sonstiges"
};
var money2 = (n) => `${Math.round(n).toLocaleString("de-DE")} \u20AC`;
function explainCash(world, windowTicks = SIM.TICKS_PER_DAY) {
  const since = world.meta.tick - windowTicks;
  const byCategory = /* @__PURE__ */ new Map();
  let delta = 0;
  for (let i = world.ledger.length - 1; i >= 0; i--) {
    const entry = world.ledger[i];
    if (entry.tick <= since) break;
    delta += entry.amount;
    const current = byCategory.get(entry.category) ?? { sum: 0, count: 0 };
    current.sum += entry.amount;
    current.count += 1;
    byCategory.set(entry.category, current);
  }
  const contributions = [...byCategory.entries()].map(([category, { sum: sum3, count: count2 }]) => ({
    label: CATEGORY_LABEL[category] ?? category,
    value: sum3,
    unit: "eur",
    detail: count2 > 1 ? `${count2} Buchungen` : void 0
  })).sort((a, b) => Math.abs(b.value) - Math.abs(a.value));
  const largest = contributions.find((c) => c.value < 0);
  return {
    metric: "Liquidit\xE4t",
    delta,
    unit: "eur",
    windowTicks,
    contributions,
    summary: contributions.length === 0 ? "In diesem Zeitraum wurde nichts gebucht." : largest ? `Gr\xF6\xDFter Posten: ${largest.label} mit ${money2(Math.abs(largest.value))}.` : "Ausschlie\xDFlich Einnahmen."
  };
}
function explainChurn(world) {
  const reasons = world.derived.customers.churnReasons;
  const total = ChurnReasons.reduce((sum3, reason) => sum3 + reasons[reason], 0);
  const contributions = ChurnReasons.map((reason) => ({
    label: CHURN_REASON_LABEL[reason],
    value: reasons[reason],
    unit: "count"
  })).filter((c) => c.value > 0).sort((a, b) => b.value - a.value);
  const top2 = contributions[0];
  return {
    metric: "K\xFCndigungen",
    delta: -total,
    unit: "count",
    windowTicks: world.meta.tick % SIM.TICKS_PER_MONTH,
    contributions,
    summary: total === 0 ? "In diesem Monat hat noch niemand gek\xFCndigt." : `${top2.value} von ${total} K\xFCndigungen gehen auf ${top2.label} zur\xFCck.`
  };
}
function explainReputation(world) {
  const contributions = [];
  const contracts = values(world.contracts).filter((c) => c.state === "active");
  const tickets = ticketStats(world);
  const affected = contracts.filter((c) => contractUptimePercent(c) < 99.5);
  if (affected.length > 0) {
    const worst = affected.reduce((a, b) => contractUptimePercent(a) < contractUptimePercent(b) ? a : b);
    contributions.push({
      label: "Ausfallzeit bei Kunden",
      value: affected.length / Math.max(contracts.length, 1),
      unit: "share",
      detail: `${affected.length} Vertr\xE4ge unter 99,5 % \u2013 schlechtester bei ${contractUptimePercent(worst).toFixed(1)} %`
    });
  }
  if (tickets.overdue > 0) {
    contributions.push({
      label: "Vorg\xE4nge ohne Erstantwort",
      value: tickets.overdue / Math.max(tickets.open, 1),
      unit: "share",
      detail: `${tickets.overdue} von ${tickets.open} offenen Vorg\xE4ngen \xFCber der Reaktionszeit`
    });
  }
  if (tickets.breached > 0) {
    contributions.push({
      label: "Gerissene Abuse-Fristen",
      value: 1,
      unit: "share",
      detail: `${tickets.breached} Vorg\xE4nge \u2013 der Upstream wartet nicht ewig`
    });
  }
  const churned = world.derived.customers.churnedThisMonth;
  if (churned > 0) {
    contributions.push({
      label: "K\xFCndigungen im laufenden Monat",
      value: churned / Math.max(world.derived.customers.total + churned, 1),
      unit: "share",
      detail: `${churned} Kunden`
    });
  }
  const hygiene = world.company.hygiene;
  if (!hygiene.rpkiSigned || !hygiene.irrRegistered) {
    contributions.push({
      label: "Fehlende Netzhygiene",
      value: 0.15,
      unit: "share",
      detail: "Ohne RPKI-Signatur und IRR-Objekte peeren viele Netze nicht"
    });
  }
  contributions.sort((a, b) => b.value - a.value);
  return {
    metric: "Ruf",
    delta: world.company.reputation - world.derived.customers.avgSatisfaction,
    unit: "share",
    windowTicks: SIM.TICKS_PER_MONTH,
    contributions,
    summary: contributions.length === 0 ? "Nichts dr\xFCckt gerade auf den Ruf \u2013 er folgt der Zufriedenheit nach oben." : `Der Ruf folgt der Zufriedenheit (${Math.round(world.derived.customers.avgSatisfaction)} / 100) mit Verz\xF6gerung. St\xE4rkster Faktor: ${contributions[0].label}.`
  };
}
function explainPower(world) {
  const contributions = values(world.datacenters).map((dc) => {
    const devices = [
      ...values(world.servers).filter((s) => s.datacenterId === dc.id),
      ...values(world.routers).filter((r) => r.datacenterId === dc.id),
      ...values(world.switches).filter((s) => s.datacenterId === dc.id)
    ];
    const watt = devices.reduce((sum3, d) => sum3 + d.idleWatt, 0) * dc.pue;
    return {
      label: dc.name,
      value: watt / 1e3 * dc.powerPricePerKwh * 24 * 30,
      unit: "eur",
      detail: `${devices.length} Ger\xE4te \xB7 ${dc.powerPricePerKwh.toFixed(2)} \u20AC/kWh \xB7 PUE ${dc.pue.toFixed(2)}`,
      ref: { kind: "datacenter", id: dc.id }
    };
  }).filter((c) => c.value > 0).sort((a, b) => b.value - a.value);
  const total = contributions.reduce((sum3, c) => sum3 + c.value, 0);
  const worst = contributions[0];
  return {
    metric: "Stromkosten",
    delta: -total,
    unit: "eur",
    windowTicks: SIM.TICKS_PER_MONTH,
    contributions,
    summary: worst ? `${worst.label} tr\xE4gt ${Math.round(worst.value / total * 100)} % der Stromkosten. Ein niedrigerer PUE oder ein g\xFCnstigerer Standort wirkt hier am st\xE4rksten.` : "Noch kein Stromverbrauch."
  };
}
function explainTransit(world) {
  const contributions = values(world.links).filter((link) => link.kind === "transit").map((link) => {
    const samples = link.samples95th ?? [];
    const sorted = [...samples].sort((a, b) => a - b);
    const billable = sorted.length > 0 ? sorted[Math.floor(sorted.length * 0.95)] ?? 0 : 0;
    const over = Math.max(0, billable - link.committedMbps);
    return {
      label: link.name,
      value: link.monthlyCost + over * link.pricePerMbps,
      unit: "eur",
      detail: `95. Perzentil ${Math.round(billable)} Mbit/s` + (over > 0 ? ` \u2013 ${Math.round(over)} Mbit/s \xFCber dem Commit` : " \u2013 innerhalb des Commits"),
      ref: { kind: "link", id: link.id }
    };
  }).sort((a, b) => b.value - a.value);
  const total = contributions.reduce((sum3, c) => sum3 + c.value, 0);
  const share = world.derived.traffic.transitShare;
  return {
    metric: "Transitkosten",
    delta: -total,
    unit: "eur",
    windowTicks: SIM.TICKS_PER_MONTH,
    contributions,
    summary: contributions.length === 0 ? "Keine Transitstrecken gebucht." : `${Math.round(share * 100)} % des Verkehrs laufen \xFCber bezahlten Transit. Jedes Prozent, das stattdessen \xFCber Peering geht, senkt diese Rechnung dauerhaft.`
  };
}
function explainCapacity(world) {
  const c = world.derived.capacity;
  const ratio = (used, total) => total > 0 ? used / total : 0;
  const contributions = [
    { label: "Arbeitsspeicher", value: ratio(c.ramGbUsed, c.ramGbTotal), unit: "share", detail: `${Math.round(c.ramGbUsed)} von ${Math.round(c.ramGbTotal)} GB` },
    { label: "Rechenkerne", value: ratio(c.cpuCoresUsed, c.cpuCoresTotal), unit: "share", detail: `${Math.round(c.cpuCoresUsed)} von ${Math.round(c.cpuCoresTotal)}` },
    { label: "Speicherplatz", value: ratio(c.diskGbUsed, c.diskGbTotal), unit: "share", detail: `${Math.round(c.diskGbUsed)} von ${Math.round(c.diskGbTotal)} GB` },
    { label: "H\xF6heneinheiten", value: ratio(c.rackUnitsUsed, c.rackUnitsTotal), unit: "share", detail: `${c.rackUnitsUsed} von ${c.rackUnitsTotal} HE` },
    { label: "Anschlussleistung", value: ratio(c.powerKwUsed, c.powerKwTotal), unit: "share", detail: `${c.powerKwUsed.toFixed(1)} von ${c.powerKwTotal.toFixed(1)} kW` },
    { label: "IPv4-Adressen", value: ratio(c.ipv4Used, c.ipv4Total), unit: "share", detail: `${c.ipv4Used} von ${c.ipv4Total}` }
  ].sort((a, b) => b.value - a.value);
  const tightest = contributions[0];
  return {
    metric: "Auslastung",
    delta: tightest?.value ?? 0,
    unit: "share",
    windowTicks: 0,
    contributions,
    summary: tightest && tightest.value > 0.85 ? `${tightest.label} ist die knappste Ressource (${Math.round(tightest.value * 100)} %) \u2013 hier gehen als N\xE4chstes Auftr\xE4ge verloren.` : tightest ? `Reichlich Luft; am knappsten ist ${tightest.label} mit ${Math.round(tightest.value * 100)} %.` : "Noch keine Kapazit\xE4t vorhanden."
  };
}
var EXPLAINABLE = ["cash", "churn", "reputation", "power", "transit", "capacity"];
function explain(world, metric, windowTicks) {
  switch (metric) {
    case "cash":
      return explainCash(world, windowTicks);
    case "churn":
      return explainChurn(world);
    case "reputation":
      return explainReputation(world);
    case "power":
      return explainPower(world);
    case "transit":
      return explainTransit(world);
    case "capacity":
      return explainCapacity(world);
  }
}

// src/domain/history/records.ts
var MAX_MONTHS = 600;
var MAX_CHRONICLE = 200;
function emptyHistory() {
  return { months: [], chronicle: [] };
}
function yearMonthOf(tick2) {
  const months = Math.floor(tick2 / SIM.TICKS_PER_MONTH);
  return { year: Math.floor(months / 12) + 1, month: months % 12 + 1 };
}
function calendarYear(year) {
  return new Date(SIM.EPOCH).getUTCFullYear() + year - 1;
}
function closeMonth(world, research = []) {
  const { year, month } = yearMonthOf(Math.max(0, world.meta.tick - 1));
  const derived = world.derived;
  const tickets = ticketStats(world);
  let worstDowntimeTicks = 0;
  for (const contract of values(world.contracts)) {
    if (contract.downtimeTicks > worstDowntimeTicks) worstDowntimeTicks = contract.downtimeTicks;
  }
  const record = {
    tick: world.meta.tick,
    year,
    month,
    customers: derived.customers.total,
    acquired: derived.customers.acquiredThisMonth,
    churned: derived.customers.churnedThisMonth,
    churnByReason: { ...derived.customers.churnReasons },
    revenue: Math.round(derived.finance.monthlyRevenue),
    cost: Math.round(derived.finance.monthlyCost),
    profit: Math.round(derived.finance.monthlyProfit),
    cash: Math.round(world.company.cash),
    debt: Math.round(world.company.debt),
    companyValue: companyValue(world).total,
    reputation: Math.round(world.company.reputation * 10) / 10,
    satisfaction: Math.round(derived.customers.avgSatisfaction * 10) / 10,
    uptimePercent: Math.round(derived.quality.uptimePercent * 100) / 100,
    trafficMbps: Math.round(derived.traffic.totalMbps),
    transitBillableMbps: Math.round(
      values(world.links).filter((link) => link.kind === "transit").reduce((sum3, link) => sum3 + billable95th(link), 0)
    ),
    transitShare: Math.round(derived.traffic.transitShare * 1e3) / 1e3,
    datacenters: Object.keys(world.datacenters).length,
    servers: Object.keys(world.servers).length,
    staff: Object.keys(world.staff).length,
    racks: Object.keys(world.racks).length,
    ticketsOpen: tickets.open,
    ticketsBreached: tickets.breached,
    worstDowntimeTicks,
    research
  };
  world.history.months.push(record);
  if (world.history.months.length > MAX_MONTHS) {
    world.history.months.splice(0, world.history.months.length - MAX_MONTHS);
  }
  return record;
}
function chronicle(world, kind, text) {
  world.history.chronicle.push({ tick: world.meta.tick, kind, text });
  if (world.history.chronicle.length <= MAX_CHRONICLE) return;
  const stoerung = world.history.chronicle.findIndex((e) => e.kind === "stoerung");
  const fallback = world.history.chronicle.findIndex((e) => e.kind !== "gruendung");
  const removable = stoerung >= 0 ? stoerung : fallback;
  if (removable >= 0) world.history.chronicle.splice(removable, 1);
}
function monthsOfYear(world, year) {
  return world.history.months.filter((m) => m.year === year);
}
function availableYears(world) {
  return [...new Set(world.history.months.map((m) => m.year))].sort((a, b) => a - b);
}
function records(world) {
  const months = world.history.months;
  if (months.length === 0) return [];
  const best = (key, label, unit, pick, hint, lowest = false) => {
    const winner = months.reduce((a, b) => lowest ? pick(a) <= pick(b) ? a : b : pick(a) >= pick(b) ? a : b);
    return { key, label, value: pick(winner), unit, tick: winner.tick, hint };
  };
  const entries = [
    best("customers", "Meiste Kunden", "count", (m) => m.customers, "Bestand am Monatsende"),
    best("acquired", "St\xE4rkster Zuwachs", "count", (m) => m.acquired, "Neukunden in einem Monat"),
    best("profit", "Bester Monatsgewinn", "eur", (m) => m.profit, "Erl\xF6se minus Kosten"),
    best("revenue", "H\xF6chster Monatsumsatz", "eur", (m) => m.revenue, "Erl\xF6se eines Monats"),
    best("value", "H\xF6chster Unternehmenswert", "eur", (m) => m.companyValue, "Anlagen, Adressen, Kundenstamm, Kasse minus Schulden"),
    best("traffic", "H\xF6chster Verkehr", "mbps", (m) => m.trafficMbps, "95. Perzentil eines Monats"),
    best("reputation", "Bester Ruf", "count", (m) => m.reputation, "Ruf am Monatsende"),
    best("uptime", "Beste Verf\xFCgbarkeit", "percent", (m) => m.uptimePercent, "\xFCber alle Vertr\xE4ge")
  ];
  const withTraffic = months.filter((m) => m.trafficMbps >= 100);
  if (withTraffic.length > 0) {
    const winner = withTraffic.reduce((a, b) => a.transitShare <= b.transitShare ? a : b);
    entries.push({
      key: "transit-share",
      label: "Niedrigster Transitanteil",
      value: Math.round(winner.transitShare * 100),
      unit: "percent",
      tick: winner.tick,
      hint: "bei mindestens 100 Mbit/s Verkehr"
    });
  }
  return entries;
}
function historyTotals(world) {
  const totals = {
    months: world.history.months.length,
    revenue: 0,
    profit: 0,
    acquired: 0,
    churned: 0,
    churnByReason: emptyChurnReasons()
  };
  for (const month of world.history.months) {
    totals.revenue += month.revenue;
    totals.profit += month.profit;
    totals.acquired += month.acquired;
    totals.churned += month.churned;
    for (const reason of Object.keys(month.churnByReason)) {
      totals.churnByReason[reason] += month.churnByReason[reason];
    }
  }
  return totals;
}

// src/domain/history/report.ts
var money3 = (n) => `${Math.round(n).toLocaleString("de-DE")} \u20AC`;
var pct = (n) => `${Math.round(n * 100)} %`;
var sum2 = (months, pick) => months.reduce((s, m) => s + pick(m), 0);
var last = (months, pick) => months.length > 0 ? pick(months[months.length - 1]) : 0;
var HIGHLIGHT_RULES = [
  {
    // Der stärkste Einzeleffekt im Spiel: Ein IXP-Beitritt oder eine geänderte
    // Routingpolitik schlägt sich binnen Wochen in der Transitrechnung nieder.
    id: "transit-drop",
    evaluate: (year) => {
      const withTraffic = year.filter((m) => m.trafficMbps >= 100);
      if (withTraffic.length < 3) return null;
      const first = withTraffic[0];
      const final = withTraffic[withTraffic.length - 1];
      const drop = first.transitShare - final.transitShare;
      if (drop < 0.12) return null;
      return `Der Transitanteil fiel von ${pct(first.transitShare)} auf ${pct(final.transitShare)}. Jedes Prozent, das \xFCber Peering statt \xFCber Transit l\xE4uft, senkt die Rechnung dauerhaft.`;
    }
  },
  {
    id: "growth-without-support",
    evaluate: (year) => {
      if (year.length < 6) return null;
      const first = year[0];
      const final = year[year.length - 1];
      const customerGrowth = first.customers > 0 ? final.customers / first.customers : 0;
      if (customerGrowth < 1.4) return null;
      if (final.staff > first.staff) return null;
      return `Die Kundenzahl wuchs um ${pct(customerGrowth - 1)}, die Belegschaft blieb bei ${final.staff}. Das geht eine Weile gut \u2013 bis die Erstantwortzeiten steigen und die K\xFCndigungen nachziehen.`;
    }
  },
  {
    id: "churn-dominant",
    evaluate: (year) => {
      const totals = {};
      let total = 0;
      for (const month of year) {
        for (const [reason2, count3] of Object.entries(month.churnByReason)) {
          totals[reason2] = (totals[reason2] ?? 0) + count3;
          total += count3;
        }
      }
      if (total < 20) return null;
      const [reason, count2] = Object.entries(totals).sort((a, b) => b[1] - a[1])[0];
      if (count2 / total < 0.45) return null;
      return `${count2} von ${total} K\xFCndigungen gingen auf ${CHURN_REASON_LABEL[reason]} zur\xFCck.`;
    }
  },
  {
    id: "turned-profitable",
    evaluate: (year, previous) => {
      if (!previous || previous.length === 0) return null;
      const before = sum2(previous, (m) => m.profit);
      const now = sum2(year, (m) => m.profit);
      if (before >= 0 || now <= 0) return null;
      return `Das erste Jahr mit Gewinn: ${money3(now)} nach ${money3(before)} im Vorjahr.`;
    }
  },
  {
    id: "worst-outage",
    evaluate: (year) => {
      const worst = year.reduce((a, b) => a.worstDowntimeTicks >= b.worstDowntimeTicks ? a : b);
      if (worst.worstDowntimeTicks < 6) return null;
      return `Die l\xE4ngste Ausfallzeit traf einen Vertrag \xFCber ${worst.worstDowntimeTicks} Stunden. Ausfallzeit wirkt doppelt: SLA-Gutschriften sofort, K\xFCndigungen mit Verz\xF6gerung.`;
    }
  },
  {
    id: "value-growth",
    evaluate: (year, previous) => {
      if (!previous || previous.length === 0) return null;
      const before = last(previous, (m) => m.companyValue);
      const now = last(year, (m) => m.companyValue);
      if (before <= 0) return null;
      const factor = now / before;
      if (factor < 1.5 && factor > 0.7) return null;
      return factor >= 1.5 ? `Der Unternehmenswert stieg auf das ${factor.toFixed(1)}-fache \u2013 auf ${money3(now)}.` : `Der Unternehmenswert fiel auf ${money3(now)}. Ein wachsender Kundenstamm allein tr\xE4gt ihn nicht, wenn die Zufriedenheit sinkt.`;
    }
  },
  {
    id: "debt",
    evaluate: (year, previous) => {
      const now = last(year, (m) => m.debt);
      const before = previous ? last(previous, (m) => m.debt) : 0;
      if (now === 0 && before > 0) return "Erstmals schuldenfrei.";
      if (now > before * 1.5 && now > 2e4) {
        return `Die Schulden stiegen auf ${money3(now)}. Zinsen laufen st\xFCndlich, unabh\xE4ngig vom Gesch\xE4ft.`;
      }
      return null;
    }
  }
];
function buildAnnualReport(world, year) {
  const months = monthsOfYear(world, year);
  if (months.length === 0) return null;
  const previous = year > 1 ? monthsOfYear(world, year - 1) : null;
  const hasPrevious = previous !== null && previous.length > 0;
  const change = (pick) => {
    if (!hasPrevious) return null;
    const before = pick(previous);
    if (before === 0) return null;
    return pick(months) / before;
  };
  const figures = [
    { label: "Umsatz", value: sum2(months, (m) => m.revenue), unit: "eur", change: change((ms) => sum2(ms, (m) => m.revenue)) },
    { label: "Gewinn", value: sum2(months, (m) => m.profit), unit: "eur", change: change((ms) => sum2(ms, (m) => m.profit)) },
    { label: "Kunden", value: last(months, (m) => m.customers), unit: "count", change: change((ms) => last(ms, (m) => m.customers)) },
    { label: "Neukunden", value: sum2(months, (m) => m.acquired), unit: "count", change: change((ms) => sum2(ms, (m) => m.acquired)) },
    { label: "K\xFCndigungen", value: sum2(months, (m) => m.churned), unit: "count", change: change((ms) => sum2(ms, (m) => m.churned)) },
    { label: "Verkehr", value: last(months, (m) => m.trafficMbps), unit: "mbps", change: change((ms) => last(ms, (m) => m.trafficMbps)) },
    { label: "Transitanteil", value: last(months, (m) => m.transitShare) * 100, unit: "percent", change: null },
    { label: "Unternehmenswert", value: last(months, (m) => m.companyValue), unit: "eur", change: change((ms) => last(ms, (m) => m.companyValue)) },
    { label: "Ruf", value: last(months, (m) => m.reputation), unit: "count", change: null },
    { label: "Verf\xFCgbarkeit", value: last(months, (m) => m.uptimePercent), unit: "percent", change: null }
  ];
  const churnTotals = {};
  for (const month of months) {
    for (const [reason, count2] of Object.entries(month.churnByReason)) {
      churnTotals[reason] = (churnTotals[reason] ?? 0) + count2;
    }
  }
  const highlights = HIGHLIGHT_RULES.map((rule) => rule.evaluate(months, hasPrevious ? previous : null)).filter(
    (text) => text !== null
  );
  return {
    year,
    calendarYear: calendarYear(year),
    figures,
    churn: Object.entries(churnTotals).filter(([, count2]) => count2 > 0).map(([reason, count2]) => ({ reason, label: CHURN_REASON_LABEL[reason], count: count2 })).sort((a, b) => b.count - a.count),
    research: months.flatMap((m) => m.research),
    highlights,
    worstDowntimeTicks: months.reduce((max, m) => Math.max(max, m.worstDowntimeTicks), 0),
    newDatacenters: Math.max(0, last(months, (m) => m.datacenters) - (months[0]?.datacenters ?? 0))
  };
}

// src/domain/world/trends.ts
var FLOOR = 0.35;
var CEILING = 2.2;
var BASE_DRIFT = {
  "shared-hosting": -0.022,
  vps: 0.03,
  dedicated: -8e-3,
  colocation: 6e-3,
  storage: 0.028,
  domain: -0.018,
  ssl: -4e-3,
  backup: 0.02,
  mail: 0.01,
  "transit-sale": 0.012,
  // Drei neue Segmente, jung und wachsend – deutlich stärkere Drift als das
  // etablierte Geschäft, GPU-Compute am stärksten (KI-Boom, siehe Technikwelle).
  "game-server": 0.02,
  container: 0.035,
  "gpu-compute": 0.06
};
var TECH_WAVES = [
  {
    key: "nvme-massenware",
    headline: "NVMe wird zur Massenware",
    body: "Die Preise f\xFCr NVMe-Laufwerke fallen deutlich. Speicherlastige Angebote werden f\xFCr Anbieter erstmals ausk\xF6mmlich.",
    window: [1, 5],
    duration: [12, 24],
    demand: { storage: 1.5, backup: 1.3, vps: 1.15 },
    prices: { hardware: 0.9 }
  },
  {
    key: "container-hosting",
    headline: "Container-Hosting setzt sich durch",
    body: "Entwickler bevorzugen zunehmend eigene virtuelle Server gegen\xFCber geteilten Webspaces \u2013 und verlagern Workloads direkt in verwaltete Container.",
    window: [2, 7],
    duration: [18, 30],
    demand: { vps: 1.45, "shared-hosting": 0.72, dedicated: 1.1, container: 1.6 }
  },
  {
    key: "400g-standard",
    headline: "400G wird Standard im Backbone",
    body: "Optik und Ports f\xFCr 400 Gbit/s fallen im Preis. Kapazit\xE4t im Kernnetz wird deutlich g\xFCnstiger.",
    window: [3, 9],
    duration: [12, 24],
    demand: { "transit-sale": 1.35, colocation: 1.15 },
    prices: { glasfaser: 0.78, transit: 0.85 }
  },
  {
    key: "ipv6-pflicht",
    headline: "IPv6 wird in Ausschreibungen zur Pflicht",
    body: "\xD6ffentliche Auftraggeber verlangen durchg\xE4ngige IPv6-Unterst\xFCtzung. Der Druck auf den IPv4-Markt l\xE4sst nach.",
    window: [4, 12],
    duration: [18, 36],
    demand: { colocation: 1.1, "transit-sale": 1.1 },
    prices: { ipv4: 0.72 }
  },
  {
    key: "ipv4-knappheit",
    headline: "IPv4-Reserven endg\xFCltig ersch\xF6pft",
    body: "Die Vergabestellen melden das Ende jeder Reserve. Adressen wechseln nur noch \xFCber den Transfermarkt den Besitzer.",
    window: [1, 6],
    duration: [24, 48],
    demand: {},
    prices: { ipv4: 1.9 }
  },
  {
    key: "datenschutz-novelle",
    headline: "Neue Datenschutzvorgaben treten in Kraft",
    body: "Versch\xE4rfte Anforderungen an Auftragsverarbeitung und Standortwahl. Wer im Inland betreibt, gewinnt.",
    window: [2, 10],
    duration: [24, 40],
    demand: { colocation: 1.3, dedicated: 1.2, mail: 1.25, backup: 1.2 },
    prices: { miete: 1.1 }
  },
  {
    key: "stromsparende-cpus",
    headline: "Neue CPU-Generation senkt den Verbrauch deutlich",
    body: "Leistung je Watt steigt sprunghaft. Der Austausch alter Knoten rechnet sich schneller als geplant.",
    window: [3, 10],
    duration: [12, 20],
    demand: { vps: 1.15, dedicated: 1.15 },
    prices: { hardware: 1.12, strom: 0.94 }
  },
  {
    key: "managed-welle",
    headline: "Nachfrage nach betreuten Diensten w\xE4chst",
    body: "Kleinere Unternehmen wollen Technik nicht mehr selbst betreiben und fragen betreute Angebote nach.",
    window: [3, 12],
    duration: [18, 36],
    demand: { mail: 1.4, backup: 1.35, "shared-hosting": 1.15, ssl: 1.2 }
  },
  {
    key: "ddos-welle",
    headline: "Angriffsvolumen erreicht neue Rekorde",
    body: "Botnetze aus schlecht gesicherten Ger\xE4ten treiben die Spitzenlast von Angriffen. Schutz wird zum Verkaufsargument.",
    window: [2, 12],
    duration: [8, 16],
    demand: { dedicated: 1.15, colocation: 1.2 },
    prices: { transit: 1.12 }
  },
  {
    key: "domainmarkt-saettigung",
    headline: "Domainmarkt gilt als ges\xE4ttigt",
    body: "Registrare unterbieten sich. Das Domaingesch\xE4ft tr\xE4gt kaum noch zum Ergebnis bei.",
    window: [4, 14],
    duration: [24, 48],
    demand: { domain: 0.55, ssl: 0.8 }
  },
  {
    key: "ki-boom",
    headline: "Trainingskapazit\xE4t f\xFCr KI-Modelle wird knapp",
    body: "Unternehmen suchen h\xE4nderingend GPU-Kapazit\xE4t f\xFCr Training und Inferenz \u2013 wer welche anbietet, bestimmt selbst den Preis.",
    window: [3, 10],
    duration: [20, 36],
    demand: { "gpu-compute": 2, dedicated: 1.08 }
  }
];
function emptyTrends() {
  const demand = {};
  for (const kind of ProductKinds) demand[kind] = 1;
  return { demand, active: [], seen: [] };
}
var ADJUST_PER_MONTH2 = 0.14;
function findWave(key) {
  return TECH_WAVES.find((wave) => wave.key === key);
}
function updateTrends(world, rng) {
  const state = world.market.trends;
  const report = { started: [], ended: [] };
  const year = Math.floor(world.meta.tick / SIM.TICKS_PER_YEAR) + 1;
  for (const active of [...state.active]) {
    if (world.meta.tick < active.endsAtTick) continue;
    state.active = state.active.filter((a) => a.key !== active.key);
    const wave = findWave(active.key);
    if (wave) report.ended.push(wave);
  }
  if (state.active.length < 2) {
    const candidates = TECH_WAVES.filter(
      (wave) => !state.seen.includes(wave.key) && year >= wave.window[0] && year <= wave.window[1]
    );
    if (candidates.length > 0 && rng.chance(1 / 24)) {
      const wave = candidates[Math.floor(rng.float(0, 1) * candidates.length)];
      const [minMonths, maxMonths] = wave.duration;
      const months = minMonths + Math.floor(rng.float(0, 1) * (maxMonths - minMonths + 1));
      state.active.push({
        key: wave.key,
        startedAtTick: world.meta.tick,
        endsAtTick: world.meta.tick + months * SIM.TICKS_PER_MONTH
      });
      state.seen.push(wave.key);
      report.started.push(wave);
    }
  }
  const yearsElapsed = world.meta.tick / SIM.TICKS_PER_YEAR;
  for (const kind of ProductKinds) {
    let target = 1 + BASE_DRIFT[kind] * yearsElapsed;
    for (const active of state.active) {
      const wave = findWave(active.key);
      const factor = wave?.demand[kind];
      if (factor !== void 0) target *= factor;
    }
    target = clamp(target, FLOOR, CEILING);
    state.demand[kind] = clamp(state.demand[kind] + (target - state.demand[kind]) * ADJUST_PER_MONTH2, FLOOR, CEILING);
  }
  return report;
}
function waveTargetFor(world, key) {
  let factor = 1;
  for (const active of world.market.trends.active) {
    const wave = findWave(active.key);
    const value = wave?.prices?.[key];
    if (value !== void 0) factor *= value;
  }
  return factor;
}
function trendArrow(value) {
  if (value >= 1.25) return "\u2191";
  if (value >= 1.07) return "\u2197";
  if (value <= 0.75) return "\u2193";
  if (value <= 0.93) return "\u2198";
  return "\u2192";
}

// src/domain/world/news.ts
var NewsCategories = ["wirtschaft", "technik", "branche", "region", "recht"];
var NEWS_CATEGORY_LABEL = {
  wirtschaft: "Wirtschaft",
  technik: "Technik",
  branche: "Branche",
  region: "Region",
  recht: "Recht"
};
var MAX_NEWS = 150;
function snapshotWorld(world) {
  const indices = {};
  for (const key of IndexKeys) indices[key] = world.economy.indices[key].value;
  const competitorStates = {};
  for (const firm of world.competitors.firms) competitorStates[firm.id] = firm.state;
  return {
    regime: world.economy.regime.key,
    indices,
    demand: { ...world.market.trends.demand },
    activeWaves: world.market.trends.active.map((a) => a.key),
    activeRegionTrends: world.regions.active.map((a) => a.key),
    competitorStates
  };
}
function emptyNews() {
  return { items: [], snapshot: null };
}
var item = (world, category, headline, body, relevance = "hinweis") => ({ tick: world.meta.tick, category, headline, body, relevance });
var INDEX_THRESHOLDS = [
  { at: 1.5, direction: "up", word: "deutlich \xFCber dem langj\xE4hrigen Mittel" },
  { at: 1.25, direction: "up", word: "sp\xFCrbar \xFCber dem Mittel" },
  { at: 0.8, direction: "down", word: "sp\xFCrbar unter dem Mittel" },
  { at: 0.65, direction: "down", word: "auf einem mehrj\xE4hrigen Tief" }
];
var NEWS_RULES = [
  {
    /**
     * Die Ankündigung – die wichtigste Meldung im Spiel.
     *
     * Sie steht zuerst in der Liste, weil sie beim Regimewechsel erscheint und
     * damit vor allen Folgemeldungen, die sich auf denselben Wechsel beziehen.
     */
    id: "regimewechsel",
    evaluate: (world, previous) => {
      if (world.economy.regime.key === previous.regime) return [];
      const regime = REGIMES[world.economy.regime.key];
      const months = Math.round((world.economy.regime.endsAtTick - world.meta.tick) / SIM.TICKS_PER_MONTH);
      return [
        item(
          world,
          "wirtschaft",
          regime.key === "normal" ? "Die Lage beruhigt sich" : `${regime.label} zeichnet sich ab`,
          `${regime.description} Analysten rechnen mit einer Phase von etwa ${months} Monaten. Die Preise ziehen erfahrungsgem\xE4\xDF erst \xFCber mehrere Wochen nach.`,
          regime.key === "normal" ? "hinweis" : "wichtig"
        )
      ];
    }
  },
  {
    id: "index-schwelle",
    evaluate: (world, previous) => {
      const news = [];
      for (const key of IndexKeys) {
        if (key === "konjunktur") continue;
        const now = world.economy.indices[key].value;
        const before = previous.indices[key] ?? 1;
        for (const threshold of INDEX_THRESHOLDS) {
          const crossed = threshold.direction === "up" ? before < threshold.at && now >= threshold.at : before > threshold.at && now <= threshold.at;
          if (!crossed) continue;
          const percent = Math.round(Math.abs(now - 1) * 100);
          news.push(
            item(
              world,
              key === "ipv4" || key === "transit" || key === "glasfaser" ? "technik" : "wirtschaft",
              `${INDEX_LABEL[key]} ${threshold.direction === "up" ? "ziehen an" : "geben nach"}`,
              `Der Marktindex liegt ${threshold.word} \u2013 rund ${percent} % ${threshold.direction === "up" ? "\xFCber" : "unter"} dem Normalwert.`,
              threshold.at >= 1.5 ? "wichtig" : "hinweis"
            )
          );
          break;
        }
      }
      return news;
    }
  },
  {
    id: "technikwelle",
    evaluate: (world, previous) => {
      const news = [];
      for (const active of world.market.trends.active) {
        if (previous.activeWaves.includes(active.key)) continue;
        const wave = findWave(active.key);
        if (wave) news.push(item(world, "technik", wave.headline, wave.body, "wichtig"));
      }
      return news;
    }
  },
  {
    id: "regionaltrend",
    evaluate: (world, previous) => {
      const news = [];
      for (const active of world.regions.active) {
        if (previous.activeRegionTrends.includes(active.key)) continue;
        const trend = findRegionTrend(active.key);
        if (trend) news.push(item(world, "region", trend.headline, trend.body, "wichtig"));
      }
      return news;
    }
  },
  {
    id: "wettbewerber-ausscheiden",
    evaluate: (world, previous) => {
      const news = [];
      for (const firm of world.competitors.firms) {
        const before = previous.competitorStates[firm.id];
        if (!before || before === firm.state || firm.state === "aktiv") continue;
        news.push(
          firm.state === "insolvent" ? item(
            world,
            "branche",
            `${firm.name} meldet Insolvenz an`,
            "Der Anbieter konnte sich am Markt nicht behaupten. Kunden suchen einen neuen Anbieter \u2013 f\xFCr die verbleibenden H\xE4user bedeutet das kurzfristig zus\xE4tzliche Nachfrage.",
            "wichtig"
          ) : item(
            world,
            "branche",
            `${firm.name} wird \xFCbernommen`,
            "Ein Wettbewerber \xFCbernimmt das Gesch\xE4ft. Erfahrungsgem\xE4\xDF wechselt ein Teil der Kunden bei solchen \xDCbernahmen den Anbieter."
          )
        );
      }
      return news;
    }
  },
  {
    id: "nachfrageverschiebung",
    evaluate: (world, previous) => {
      const news = [];
      for (const [kind, value] of Object.entries(world.market.trends.demand)) {
        const before = previous.demand[kind] ?? 1;
        for (const mark of [1.3, 0.7]) {
          const crossed = mark > 1 ? before < mark && value >= mark : before > mark && value <= mark;
          if (!crossed) continue;
          news.push(
            item(
              world,
              "branche",
              mark > 1 ? `Nachfrage nach ${PRODUCT_LABEL[kind] ?? kind} zieht stark an` : `${PRODUCT_LABEL[kind] ?? kind} verliert an Bedeutung`,
              mark > 1 ? "Marktbeobachter melden anhaltend hohe Nachfrage in diesem Segment." : "Das Segment verliert seit L\xE4ngerem Anteile. Anbieter richten ihr Sortiment neu aus."
            )
          );
          break;
        }
      }
      return news;
    }
  }
];
var PRODUCT_LABEL = {
  "shared-hosting": "Shared Hosting",
  vps: "VPS",
  dedicated: "Dedicated Servern",
  colocation: "Colocation",
  storage: "Storage",
  domain: "Domains",
  ssl: "SSL-Zertifikaten",
  backup: "Backup",
  mail: "Mail-Diensten",
  "transit-sale": "Transitverkauf"
};
function collectNews(world) {
  const previous = world.news.snapshot ?? snapshotWorld(world);
  const fresh = [];
  for (const rule of NEWS_RULES) {
    fresh.push(...rule.evaluate(world, previous));
  }
  if (fresh.length > 0) {
    world.news.items.push(...fresh);
    if (world.news.items.length > MAX_NEWS) {
      world.news.items.splice(0, world.news.items.length - MAX_NEWS);
    }
  }
  world.news.snapshot = snapshotWorld(world);
  return fresh;
}

// src/engine/bootstrap.ts
function tickToDate(tick2) {
  const epoch = new Date(SIM.EPOCH).getTime();
  return new Date(epoch + tick2 * SIM.MINUTES_PER_TICK * 6e4).toISOString();
}
function buildDestinations(providers) {
  const destinations = [];
  let block = 0;
  for (const provider of providers) {
    const count2 = provider.kind === "content" ? 6 : provider.kind === "eyeball" ? 5 : 3;
    for (let i = 0; i < count2; i++) {
      const city = provider.cities[i % provider.cities.length] ?? "Frankfurt";
      const location = LOCATIONS.find((l) => l.city === city) ?? LOCATIONS[0];
      destinations.push({
        prefix: `${100 + Math.floor(block / 250)}.${block % 250}.0.0/16`,
        ownerAsn: provider.asn,
        // Reichweite je Ziel; wird gleich normiert.
        trafficShare: provider.reach / count2,
        city,
        position: location.position
      });
      block += 1;
    }
  }
  const total = destinations.reduce((s, d) => s + d.trafficShare, 0);
  for (const destination of destinations) destination.trafficShare /= total;
  return destinations;
}
function buildProducts(rng) {
  const products = {};
  for (const template of PRODUCT_TEMPLATES) {
    const id = asId(template.key);
    products[id] = {
      id,
      kind: template.kind,
      name: template.name,
      monthlyPrice: template.referencePrice,
      setupPrice: template.setupPrice,
      resources: { ...template.resources },
      slaUptimePercent: template.slaUptimePercent,
      // Zu Beginn wird nur ein kleines Sortiment angeboten.
      active: ["shared-starter", "shared-business", "vps-s", "domain-de", "ssl-dv"].includes(template.key),
      attractiveness: 1
    };
  }
  void rng;
  return products;
}
function buildRouterPorts(count2, speedMbps) {
  return Array.from({ length: count2 }, (_, index) => ({
    index,
    speedMbps,
    linkId: null,
    description: "",
    ipv4: null,
    ipv6: null,
    vrfId: null,
    enabled: true
  }));
}
function buildSwitchPorts(count2, speedMbps, uplinks, uplinkSpeed) {
  const ports = Array.from({ length: count2 }, (_, index) => ({
    index,
    speedMbps,
    mode: "access",
    vlanId: 100,
    allowedVlans: [],
    linkId: null,
    connectedDevice: null,
    enabled: true,
    description: ""
  }));
  for (let i = 0; i < uplinks; i++) {
    ports.push({
      index: count2 + i,
      speedMbps: uplinkSpeed,
      mode: "trunk",
      vlanId: 1,
      allowedVlans: [1, 100, 200],
      linkId: null,
      connectedDevice: null,
      enabled: true,
      description: `Uplink ${i + 1}`
    });
  }
  return ports;
}
function createWorld(options) {
  const seed = options.seed ?? Math.floor(Math.random() * 4294967295);
  const rng = new Rng(seed);
  const settings = DIFFICULTY[options.difficulty];
  const locationKey = options.startLocation ?? "loc-fra";
  const location = findLocation(locationKey) ?? LOCATIONS[0];
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const ixpIdByKey = /* @__PURE__ */ new Map();
  const ixps = {};
  for (const template of IXP_TEMPLATES) {
    const id = asId(template.key);
    ixpIdByKey.set(template.key, id);
    ixps[id] = {
      id,
      name: template.name,
      city: template.city,
      position: template.position,
      portFeePerGbps: template.portFeePerGbps,
      setupFee: template.setupFee,
      memberCount: template.memberCount,
      trafficCoverage: template.trafficCoverage,
      joined: false,
      joinedAtTick: null,
      portCapacityMbps: 0,
      routerId: null,
      routeServer: { ...template.routeServer, connected: false }
    };
  }
  const providers = PROVIDER_TEMPLATES.map((template) => ({
    asn: template.asn,
    name: template.name,
    kind: template.kind,
    transitPricePerMbps: template.transitPricePerMbps,
    reach: template.reach,
    peeringWillingness: template.peeringWillingness,
    ixpIds: template.ixpKeys.map((k) => ixpIdByKey.get(k)).filter(Boolean),
    cities: template.cities,
    playerId: null,
    peeringPolicy: template.peeringPolicy,
    maxRatio: template.maxRatio,
    requiresRpki: template.requiresRpki,
    minTrafficMbps: template.minTrafficMbps,
    atRouteServer: template.atRouteServer
  }));
  const world = {
    meta: {
      id: makeId(rng, "wld"),
      name: options.name,
      seed,
      difficulty: options.difficulty,
      tick: 0,
      date: tickToDate(0),
      speed: SIM.DEFAULT_SPEED,
      paused: false,
      createdAt: now,
      updatedAt: now,
      version: WORLD_VERSION
    },
    company: {
      name: options.companyName,
      // Eine eigene ASN aus dem Dokumentationsbereich – im Spiel bereits zugeteilt.
      asn: 64600,
      cash: settings.startingCash,
      creditLimit: settings.creditLimit,
      debt: 0,
      reputation: 50,
      rirMember: true,
      foundedAtTick: 0,
      lifetimeRevenue: 0,
      lifetimeCost: 0,
      hygiene: emptyHygiene()
    },
    datacenters: {},
    racks: {},
    servers: {},
    routers: {},
    switches: {},
    firewalls: {},
    loadBalancers: {},
    upsUnits: {},
    vpsInstances: {},
    migrations: {},
    transports: {},
    negotiations: {},
    partOrders: {},
    deliveries: {},
    inventory: {},
    links: {},
    ixps,
    peerings: {},
    sessions: {},
    prefixes: {},
    vlans: {},
    vrfs: {},
    dnsZones: {},
    products: buildProducts(rng),
    customers: {},
    contracts: {},
    invoices: {},
    domains: {},
    tickets: {},
    staff: {},
    research: buildResearchNodes(),
    activeResearchId: null,
    loans: {},
    events: {},
    ledger: [],
    logs: [],
    market: {
      providers,
      offers: [],
      destinations: buildDestinations(providers),
      demandIndex: 1,
      trends: emptyTrends()
    },
    economy: emptyEconomy(),
    regions: emptyRegions(),
    competitors: emptyCompetitors(),
    news: emptyNews(),
    monitoring: {
      window: SIM.METRIC_WINDOW,
      series: {},
      probes: []
    },
    derived: emptyDerived(),
    progress: emptyProgress(),
    history: emptyHistory(),
    rngState: rng.getState()
  };
  const dcId = asId(makeId(rng, "dc"));
  world.datacenters[dcId] = {
    id: dcId,
    name: `${options.companyName} ${location.city}`,
    city: location.city,
    country: location.country,
    position: location.position,
    // Zu Beginn nur ein kleiner gemieteter Bereich, nicht der ganze Standort.
    rackCapacity: 6,
    powerCapacityKw: 45,
    coolingCapacityKw: 40,
    pue: location.pue,
    powerPricePerKwh: location.powerPricePerKwh,
    monthlyRent: Math.round(location.monthlyRent * 0.25),
    generator: { installed: false, runtimeHours: 0, fuelPercent: 0 },
    // Ein Standort startet mit einer Zuleitung; Redundanz muss beschafft werden.
    powerFeeds: { count: 1, monthlyCost: 0 },
    carriers: location.carriers,
    ambientTempC: location.ambientTempC,
    utilityPower: true,
    builtAtTick: 0,
    /*
     * Der Gründungsvertrag – und bewusst kein guter.
     *
     * Er wurde nicht verhandelt, sondern unterschrieben, weil man irgendwo
     * anfangen musste: zwei Jahre Bindung zum Listenpreis. Damit gibt es von
     * der ersten Stunde an etwas zu verbessern, und der Spieler lernt die
     * Mechanik dort kennen, wo sie ihn nichts kostet.
     */
    contract: {
      providerName: providerFor(location.key),
      termMonths: 24,
      committedKw: 45,
      prepaidMonths: 0,
      monthlyRent: Math.round(location.monthlyRent * 0.25),
      noticeMonths: COLOCATION.NOTICE_MONTHS.long,
      exitPenaltyShare: COLOCATION.EXIT_PENALTY_SHARE.long,
      signedAtTick: 0,
      termEndsAtTick: 24 * SIM.TICKS_PER_MONTH,
      listRent: Math.round(location.monthlyRent * 0.25),
      notice: null
    }
  };
  const rackModel = findRackModel("rack-half");
  const rackId = asId(makeId(rng, "rck"));
  world.racks[rackId] = {
    id: rackId,
    datacenterId: dcId,
    name: "Rack A01",
    units: rackModel.units,
    powerBudgetKw: rackModel.powerBudgetKw,
    monthlyCost: rackModel.monthlyCost,
    upsIds: []
  };
  const routerModel = findRouterModel("rtr-edge-s");
  const routerId = asId(makeId(rng, "rtr"));
  const switchModel = findSwitchModel("sw-access-1g");
  const switchId = asId(makeId(rng, "swt"));
  world.switches[switchId] = {
    id: switchId,
    name: "sw-a01-01",
    rackId,
    datacenterId: dcId,
    rackUnit: 20,
    heightUnits: switchModel.heightUnits,
    state: "online",
    model: switchModel.key,
    purchasePrice: switchModel.price,
    purchasedAtTick: 0,
    health: 1,
    temperatureC: 24,
    pendingTicks: 0,
    standby: false,
    ports: buildSwitchPorts(switchModel.portCount, switchModel.portSpeedMbps, switchModel.uplinkCount, switchModel.uplinkSpeedMbps),
    switchingCapacityMbps: switchModel.switchingCapacityMbps,
    macTableSize: switchModel.macTableSize,
    idleWatt: switchModel.idleWatt,
    maxWatt: switchModel.maxWatt,
    layer3: switchModel.layer3
  };
  world.routers[routerId] = {
    id: routerId,
    name: "rtr-fra-01",
    rackId,
    datacenterId: dcId,
    rackUnit: 21,
    heightUnits: routerModel.heightUnits,
    state: "online",
    model: routerModel.key,
    purchasePrice: routerModel.price,
    purchasedAtTick: 0,
    health: 1,
    temperatureC: 26,
    pendingTicks: 0,
    standby: false,
    ports: buildRouterPorts(routerModel.portCount, routerModel.portSpeedMbps),
    forwardingCapacityMbps: routerModel.forwardingCapacityMbps,
    fibCapacity: routerModel.fibCapacity,
    maxBgpSessions: routerModel.maxBgpSessions,
    cpuLoad: 0.1,
    idleWatt: routerModel.idleWatt,
    maxWatt: routerModel.maxWatt,
    bgp: {
      localAsn: world.company.asn,
      routerId: "10.255.255.1",
      neighbors: [],
      originatedPrefixes: [],
      routeMaps: [],
      prefixLists: [],
      blackholeEnabled: true,
      dampening: false
    },
    staticRoutes: [],
    acls: [],
    nat: []
  };
  const uplinkPort = world.switches[switchId].ports.find((p) => p.mode === "trunk");
  if (uplinkPort) {
    uplinkPort.connectedDevice = { kind: "router", id: routerId };
    uplinkPort.description = "rtr-fra-01";
  }
  const upsModel = findUpsModel("ups-3kw");
  const upsId = asId(makeId(rng, "ups"));
  world.upsUnits[upsId] = {
    id: upsId,
    name: "usv-a01",
    rackId,
    datacenterId: dcId,
    rackUnit: 1,
    heightUnits: upsModel.heightUnits,
    state: "online",
    model: upsModel.key,
    purchasePrice: upsModel.price,
    purchasedAtTick: 0,
    health: 1,
    temperatureC: 24,
    pendingTicks: 0,
    standby: false,
    capacityKwh: upsModel.capacityKwh,
    outputKw: upsModel.outputKw,
    charge: 1,
    idleWatt: upsModel.idleWatt,
    maxWatt: upsModel.maxWatt
  };
  world.racks[rackId].upsIds.push(upsId);
  const serverModel = findServerModel("srv-eco-1");
  const roles = ["shared-hosting", "shared-hosting", "vps-host"];
  roles.forEach((role, index) => {
    const id = asId(makeId(rng, "srv"));
    const server = {
      id,
      name: `srv-fra-${String(index + 1).padStart(2, "0")}`,
      rackId,
      datacenterId: dcId,
      rackUnit: 3 + index,
      heightUnits: serverModel.heightUnits,
      state: "online",
      model: serverModel.key,
      purchasePrice: serverModel.price,
      purchasedAtTick: 0,
      health: 1,
      temperatureC: 32,
      pendingTicks: 0,
      standby: false,
      parts: factoryParts(serverModel.key, 0),
      maintenance: null,
      retirement: null,
      cpuModel: serverModel.cpuModel,
      cpuCores: serverModel.cpuCores,
      cpuGhz: serverModel.cpuGhz,
      cpuIpc: serverModel.cpuIpc,
      ramGb: serverModel.ramGb,
      ssdGb: serverModel.ssdGb,
      hddGb: serverModel.hddGb,
      idleWatt: serverModel.idleWatt,
      maxWatt: serverModel.maxWatt,
      os: "linux-debian",
      role,
      uplink: { switchId, portIndex: index },
      managementIp: `10.0.1.${10 + index}`,
      vpsIds: [],
      contractIds: []
    };
    world.servers[id] = server;
    world.switches[switchId].ports[index].connectedDevice = { kind: "server", id };
    world.switches[switchId].ports[index].description = server.name;
  });
  const v4 = createPrefix(world, rng, { cidr: "203.0.113.0/24", source: "rir", usage: "customer" });
  v4.announced = true;
  const v6 = createPrefix(world, rng, { cidr: "2001:db8:1000::/32", source: "rir", usage: "customer" });
  v6.announced = true;
  createPrefix(world, rng, { cidr: "10.0.0.0/16", source: "rfc1918", usage: "unassigned", monthlyCost: 0 });
  const infra = createPrefix(world, rng, { cidr: "10.0.1.0/24", source: "rfc1918", usage: "infrastructure", monthlyCost: 0 });
  infra.assignedTo = { kind: "datacenter", id: dcId };
  world.routers[routerId].bgp.originatedPrefixes = ["203.0.113.0/24", "2001:db8:1000::/32"];
  world.routers[routerId].acls = [defaultEdgeAcl(["203.0.113.0/24"])];
  const upstream = providers.find((p) => p.asn === 64503);
  const neighborId = asId(makeId(rng, "peer"));
  const linkId = asId(makeId(rng, "lnk"));
  const transitLink = {
    id: linkId,
    kind: "transit",
    name: `Transit ${upstream.name} 1G`,
    state: "up",
    a: { kind: "internal", routerId, portIndex: 0, label: "rtr-fra-01 Port 0", datacenterId: dcId },
    b: { kind: "external", routerId: null, portIndex: null, label: `${upstream.name} (AS${upstream.asn})`, datacenterId: null },
    capacityMbps: 1e3,
    latencyMs: 0.4,
    baseLossPercent: 0,
    monthlyCost: 220,
    setupCost: 0,
    pricePerMbps: upstream.transitPricePerMbps,
    committedMbps: 100,
    resilience: 0.8,
    utilizationMbps: { aToB: 0, bToA: 0 },
    samples95th: [],
    buildTicksRemaining: 0,
    standby: false,
    ixpId: null,
    remoteAsn: upstream.asn
  };
  world.links[linkId] = transitLink;
  world.routers[routerId].ports[0].linkId = linkId;
  world.routers[routerId].ports[0].description = `Transit ${upstream.name}`;
  world.routers[routerId].ports[0].ipv4 = "198.51.100.2";
  const neighbor = {
    id: neighborId,
    address: "198.51.100.1",
    remoteAsn: upstream.asn,
    description: `${upstream.name} Transit`,
    relation: "transit",
    linkId,
    enabled: true,
    routeMapIn: null,
    routeMapOut: null,
    maxPrefix: 1e6,
    // Der Einstiegsrouter hält keine volle Tabelle – deshalb nur eine Default-Route.
    defaultOriginate: true,
    prependOut: 0,
    localPrefIn: 100,
    medOut: null
  };
  world.routers[routerId].bgp.neighbors.push(neighbor);
  const hire = (name, role, skill, options2 = {}) => {
    const id = asId(makeId(rng, "stf"));
    world.staff[id] = {
      id,
      name,
      role,
      skill,
      // Der Inhaber zahlt sich am Anfang nichts – so fängt jeder Kleinbetrieb an.
      monthlySalary: options2.owner ? 0 : ECONOMY.SALARY_BASE + skill * ECONOMY.SALARY_PER_SKILL,
      datacenterId: dcId,
      hiredAtTick: 0,
      workload: 0,
      level: options2.owner ? 2 : 1,
      // Der Inhaber kennt sein eigenes Geschäft in der Breite.
      specialties: options2.owner ? ["technical", "billing", "outage", "sales"] : DEFAULT_SPECIALTIES[role] ?? [],
      // Wer den Laden besitzt, geht auch nachts ans Telefon.
      shift: options2.owner ? "oncall" : "day",
      isOwner: options2.owner
    };
  };
  hire(options.companyName ? `${options.companyName} (Inhaber)` : "Inhaber", "support", 6, { owner: true });
  hire("Miriam Kessler", "technician", 5);
  world.logs.push({
    id: asId(makeId(rng, "log")),
    tick: 0,
    category: "system",
    severity: "info",
    message: `${options.companyName} wurde gegr\xFCndet. AS${world.company.asn}, Standort ${location.city}, Startkapital ${settings.startingCash.toLocaleString("de-DE")} \u20AC.`
  });
  recomputeAggregates(world);
  chronicle(
    world,
    "gruendung",
    `${options.companyName} gegr\xFCndet \u2013 AS${world.company.asn}, Standort ${location.city}.`
  );
  world.rngState = rng.getState();
  return world;
}
function emptyDerived() {
  return {
    routingTables: {},
    internetReachability: 0,
    traffic: { totalMbps: 0, transitMbps: 0, peeringMbps: 0, internalMbps: 0, transitShare: 0 },
    quality: { avgLatencyMs: 0, packetLossPercent: 0, uptimePercent: 100 },
    capacity: {
      cpuCoresTotal: 0,
      cpuCoresUsed: 0,
      ramGbTotal: 0,
      ramGbUsed: 0,
      diskGbTotal: 0,
      diskGbUsed: 0,
      rackUnitsTotal: 0,
      rackUnitsUsed: 0,
      powerKwTotal: 0,
      powerKwUsed: 0,
      ipv4Total: 0,
      ipv4Used: 0
    },
    finance: {
      monthlyRevenue: 0,
      monthlyCost: 0,
      monthlyProfit: 0,
      revenueBreakdown: {},
      costBreakdown: {},
      runwayMonths: Infinity,
      companyValue: 0
    },
    customers: { total: 0, avgSatisfaction: 0, churnedThisMonth: 0, acquiredThisMonth: 0, churnReasons: emptyChurnReasons() },
    migrations: 0,
    transports: 0,
    alerts: [],
    diagnostics: []
  };
}

// src/domain/minigames/cabling.ts
var WIRE_COLORS = {
  SW: { code: "SW", label: "Schwarz", hex: "#1f2937" },
  BR: { code: "BR", label: "Braun", hex: "#8b4513" },
  RT: { code: "RT", label: "Rot", hex: "#dc2626" },
  OR: { code: "OR", label: "Orange", hex: "#f97316" },
  GE: { code: "GE", label: "Gelb", hex: "#facc15" },
  GN: { code: "GN", label: "Gr\xFCn", hex: "#16a34a" },
  BL: { code: "BL", label: "Blau", hex: "#2563eb" },
  VI: { code: "VI", label: "Violett", hex: "#7c3aed" },
  GR: { code: "GR", label: "Grau", hex: "#9ca3af" },
  WS: { code: "WS", label: "Wei\xDF", hex: "#f5f5f4" },
  RS: { code: "RS", label: "Rosa", hex: "#f472b6" }
};
var BASES = ["SW", "BR", "RT", "OR", "BL", "VI", "GR", "WS", "RS"];
var STRIPES = ["WS", "SW", "RT", "BL"];
var CABLING = {
  BASE_SECONDS: 60,
  SECONDS_PER_WIRE: 12,
  /** Abzug für einen Fehlgriff (nur Anzeige – der Server misst die Gesamtzeit). */
  PENALTY_SECONDS: 4
};
function wireCode(base, stripe) {
  return stripe ? `${base}/${stripe}` : base;
}
function buildCabling(seed, count2) {
  const rng = new Rng(seed);
  const n = Math.max(3, Math.min(8, Math.round(count2)));
  const wires = [{ base: "GN", stripe: "GE", code: "GN/GE", earth: true }];
  const used = /* @__PURE__ */ new Set(["GN/GE"]);
  let guard = 0;
  while (wires.length < n && guard++ < 200) {
    const twin = wires.length > 1 && rng.chance(0.45) ? rng.pick(wires.filter((w) => !w.earth)) : void 0;
    const base = twin ? twin.base : rng.pick(BASES);
    const stripe = twin ? twin.stripe ? null : rng.pick(STRIPES.filter((s) => s !== base)) : rng.chance(0.3) ? rng.pick(STRIPES.filter((s) => s !== base)) : null;
    const code = wireCode(base, stripe);
    if (used.has(code)) continue;
    used.add(code);
    wires.push({ base, stripe, code, earth: false });
  }
  rng.shuffle(wires);
  const terminals = rng.shuffle(wires.map((_, i) => i));
  return { wires, terminals, seconds: CABLING.BASE_SECONDS + CABLING.SECONDS_PER_WIRE * wires.length };
}
function checkCabling2(puzzle, submission) {
  const { mapping, order } = submission;
  if (!Array.isArray(mapping) || mapping.length !== puzzle.wires.length) return "Nicht alle Adern sind angeklemmt.";
  if (!Array.isArray(order) || order.length !== puzzle.wires.length || new Set(order).size !== order.length) {
    return "Die Reihenfolge der Anschl\xFCsse ist unvollst\xE4ndig.";
  }
  const earth = puzzle.wires.findIndex((w) => w.earth);
  if (order[0] !== earth) return "Der Schutzleiter wurde nicht zuerst angeklemmt \u2013 das Geh\xE4use stand unter Spannung.";
  for (let wire = 0; wire < puzzle.wires.length; wire++) {
    const terminal = mapping[wire];
    if (puzzle.terminals[terminal] !== wire) {
      return `${puzzle.wires[wire].code} steckt auf der falschen Klemme \u2013 Kurzschluss.`;
    }
  }
  return null;
}

// src/domain/minigames/escape.ts
var ESCAPE = {
  SECONDS: 300,
  /** Abzug je falscher Antwort. */
  PENALTY_SECONDS: 20
};
var MALWARE = [
  { name: "[kworker/1:2H]", path: "[kworker/1:2H]", note: "Kernel-Thread unter www-data?" },
  { name: "kdevtmpfsi", path: "/tmp/kdevtmpfsi", note: "bekannter Krypto-Miner" },
  { name: "sshd", path: "/dev/shm/.x/sshd", note: "sshd aus /dev/shm" },
  { name: "php-fpm", path: "/var/tmp/.font-unix/php-fpm", note: "php-fpm aus /var/tmp" }
];
var BACKDOOR_PORTS = [4444, 31337, 6667, 48211, 1337, 5555, 8443, 2222];
var ACCOUNTS = ["deploy", "backup", "jenkins", "gitlab-runner", "ftpuser", "monitor"];
var NOISE_USERS = ["root", "admin", "test", "oracle", "ubuntu", "postgres", "user"];
function ip2(rng) {
  const first = rng.pick([45, 61, 80, 91, 103, 112, 141, 178, 185, 193, 212]);
  return `${first}.${rng.int(1, 254)}.${rng.int(0, 255)}.${rng.int(1, 254)}`;
}
function pad(value, width) {
  return String(value).padEnd(width);
}
function time(minute, second) {
  const h = 3 + Math.floor(minute / 60);
  return `Oct  9 ${String(h).padStart(2, "0")}:${String(minute % 60).padStart(2, "0")}:${String(second).padStart(2, "0")}`;
}
function buildEscape(seed, hostname) {
  const rng = new Rng(seed);
  const host = hostname.replace(/[^a-zA-Z0-9-]/g, "").toLowerCase() || "web01";
  const malware = rng.pick(MALWARE);
  const usedPids = /* @__PURE__ */ new Set();
  const pid = (min, max) => {
    let value = rng.int(min, max);
    while (usedPids.has(value)) value += 1;
    usedPids.add(value);
    return value;
  };
  const procs = [
    { user: "root", pid: 1, cpu: "0.0", mem: "0.3", cmd: "/sbin/init" },
    { user: "root", pid: pid(300, 420), cpu: "0.0", mem: "0.2", cmd: "/lib/systemd/systemd-journald" },
    { user: "root", pid: pid(600, 700), cpu: "0.0", mem: "0.1", cmd: "/usr/sbin/cron -f" },
    { user: "syslog", pid: pid(700, 760), cpu: "0.0", mem: "0.1", cmd: "/usr/sbin/rsyslogd -n" },
    { user: "root", pid: pid(800, 900), cpu: "0.0", mem: "0.2", cmd: "sshd: /usr/sbin/sshd -D" },
    { user: "mysql", pid: pid(900, 1100), cpu: "1.2", mem: "9.8", cmd: "/usr/sbin/mysqld" },
    { user: "root", pid: pid(1100, 1200), cpu: "0.0", mem: "0.4", cmd: "nginx: master process /usr/sbin/nginx" },
    { user: "www-data", pid: pid(1200, 1300), cpu: "0.3", mem: "0.6", cmd: "nginx: worker process" },
    { user: "www-data", pid: pid(1200, 1300), cpu: "0.2", mem: "0.6", cmd: "nginx: worker process" },
    { user: "root", pid: pid(1300, 1400), cpu: "0.0", mem: "1.1", cmd: "php-fpm: master process (/etc/php/8.3/fpm/php-fpm.conf)" },
    { user: "www-data", pid: pid(1400, 1500), cpu: "0.4", mem: "2.3", cmd: "php-fpm: pool www" },
    { user: "root", pid: pid(1500, 1600), cpu: "0.0", mem: "0.3", cmd: "/usr/bin/node_exporter" }
  ];
  const badPid = pid(2e4, 31e3);
  procs.push({ user: "www-data", pid: badPid, cpu: `${rng.int(88, 99)}.${rng.int(0, 9)}`, mem: "0.4", cmd: malware.path });
  procs.sort((a, b) => a.pid - b.pid);
  const ps = [
    "USER         PID %CPU %MEM COMMAND",
    ...procs.map((p) => `${pad(p.user, 12)} ${String(p.pid).padStart(5)} ${p.cpu.padStart(4)} ${p.mem.padStart(4)} ${p.cmd}`)
  ];
  const backdoorPort = rng.pick(BACKDOOR_PORTS);
  const pidOf = (cmd) => procs.find((p) => p.cmd.startsWith(cmd)).pid;
  const listeners = [
    { local: "0.0.0.0:22", proc: `"sshd",pid=${pidOf("sshd")}` },
    { local: "0.0.0.0:80", proc: `"nginx",pid=${pidOf("nginx: master")}` },
    { local: "0.0.0.0:443", proc: `"nginx",pid=${pidOf("nginx: master")}` },
    { local: "127.0.0.1:3306", proc: `"mysqld",pid=${pidOf("/usr/sbin/mysqld")}` },
    { local: "127.0.0.1:9000", proc: `"php-fpm",pid=${pidOf("php-fpm: master")}` },
    { local: "0.0.0.0:9100", proc: `"node_exporter",pid=${pidOf("/usr/bin/node_exporter")}` },
    { local: `0.0.0.0:${backdoorPort}`, proc: `"${malware.name}",pid=${badPid}` }
  ];
  rng.shuffle(listeners);
  const ss = [
    "State   Recv-Q  Send-Q  Local Address:Port   Process",
    ...listeners.map((l) => `LISTEN  0       128     ${pad(l.local, 20)} users:((${l.proc},fd=3))`)
  ];
  const attackerIp = ip2(rng);
  const account = rng.pick(ACCOUNTS);
  const auth = [];
  let minute = rng.int(0, 20);
  const noise = () => {
    const from = ip2(rng);
    const user = rng.pick(NOISE_USERS);
    auth.push(`${time(minute, rng.int(0, 59))} ${host} sshd[${rng.int(2e3, 9e3)}]: Failed password for ${user === "root" ? "" : "invalid user "}${user} from ${from} port ${rng.int(3e4, 65e3)} ssh2`);
    minute += rng.int(0, 3);
  };
  for (let i = 0; i < 5; i++) noise();
  auth.push(`${time(minute, rng.int(0, 59))} ${host} sshd[${rng.int(2e3, 9e3)}]: Accepted publickey for admin from 10.10.20.1 port ${rng.int(3e4, 65e3)} ssh2: ED25519 SHA256:q7N2\u2026`);
  minute += 2;
  for (let i = 0; i < 3; i++) noise();
  const tries = rng.int(3, 5);
  for (let i = 0; i < tries; i++) {
    auth.push(`${time(minute, rng.int(0, 59))} ${host} sshd[${rng.int(2e3, 9e3)}]: Failed password for ${account} from ${attackerIp} port ${rng.int(3e4, 65e3)} ssh2`);
    if (rng.chance(0.5)) noise();
  }
  minute += 1;
  auth.push(`${time(minute, rng.int(0, 59))} ${host} sshd[${rng.int(2e3, 9e3)}]: Accepted password for ${account} from ${attackerIp} port ${rng.int(3e4, 65e3)} ssh2`);
  auth.push(`${time(minute, rng.int(0, 59))} ${host} sudo:   ${account} : TTY=pts/1 ; PWD=/home/${account} ; USER=root ; COMMAND=/bin/su www-data -s /bin/sh`);
  for (let i = 0; i < 3; i++) noise();
  const crontab = [`*/5 * * * * ${malware.path.startsWith("[") ? "/var/tmp/.k/run" : malware.path} >/dev/null 2>&1 || true`];
  const help = [
    "Eingeschr\xE4nkte Shell \u2013 verf\xFCgbare Befehle:",
    "  ps aux                  laufende Prozesse",
    "  ss -tlnp                offene Ports mit Prozess",
    "  cat <datei>             Datei anzeigen",
    "  grep <muster> <datei>   Zeilen mit Muster",
    "  crontab -l -u www-data  geplante Aufgaben",
    "  ls                      Dateien in der Zelle",
    "  whoami, clear, help"
  ];
  const pickOthers = (pool, answer) => {
    const others = rng.shuffle([...new Set(pool)].filter((v) => v !== answer)).slice(0, 3);
    return rng.shuffle([answer, ...others]);
  };
  const otherIps = auth.map((l) => / from ([0-9.]+) port/.exec(l)?.[1]).filter((v) => !!v && v !== "10.10.20.1");
  const choices = [
    pickOthers(
      procs.filter((p) => p.pid !== 1).map((p) => String(p.pid)),
      String(badPid)
    ),
    pickOthers(["22", "80", "443", "3306", "9000", "9100"], String(backdoorPort)),
    pickOthers(otherIps, attackerIp),
    pickOthers([...NOISE_USERS, "admin", "www-data"], account)
  ];
  return {
    hostname: host,
    seconds: ESCAPE.SECONDS,
    locks: [
      {
        question: "PID des Schadprozesses",
        hint: "ps aux \u2013 was frisst die CPU und l\xE4uft von dort, wo nichts laufen sollte?",
        explain: "Die Prozessliste zeigt alle laufenden Programme. Ein Programm frisst fast die ganze CPU (Spalte %CPU) und l\xE4uft aus einem Temp-Ordner. Seine Nummer in der Spalte PID \xF6ffnet das Schloss.",
        command: "ps aux",
        choices: choices[0]
      },
      {
        question: "Port der Hintert\xFCr",
        hint: "ss -tlnp \u2013 welcher Port geh\xF6rt zu dieser PID?",
        explain: "Die Liste zeigt, welches Programm auf welchem Port lauscht. Such die PID aus Schloss 1 (pid=\u2026). Die Zahl hinter dem Doppelpunkt in derselben Zeile ist der Port.",
        command: "ss -tlnp",
        choices: choices[1]
      },
      {
        question: "IP-Adresse des Angreifers",
        hint: "cat /var/log/auth.log \u2013 wer kam nach mehreren Fehlversuchen herein?",
        explain: "Das Anmeldeprotokoll: \u201EFailed password\u201C hei\xDFt falsches Passwort, \u201EAccepted password\u201C hei\xDFt drin. Wer es erst mehrmals vergeblich versucht hat und dann reinkam, ist der Angreifer \u2013 seine Adresse steht hinter \u201Efrom\u201C.",
        command: "cat /var/log/auth.log",
        choices: choices[2]
      },
      {
        question: "Konto, \xFCber das er kam",
        hint: "Dieselbe Zeile in auth.log: \u201EAccepted password for \u2026\u201C",
        explain: "Gleiche Zeile wie bei Schloss 3: Der Name direkt hinter \u201EAccepted password for\u201C ist das Konto, das der Angreifer geknackt hat. (admin kam per Schl\xFCssel aus dem eigenen Netz \u2013 das bist du.)",
        command: "grep Accepted /var/log/auth.log",
        choices: choices[3]
      }
    ],
    commands: {
      "ps aux": ps,
      "ss -tlnp": ss,
      "crontab -l -u www-data": crontab,
      "crontab -l": ["no crontab for admin"],
      whoami: ["admin (chroot: /srv/zelle)"],
      ls: ["NOTIZ.txt  var/"],
      help
    },
    files: {
      "/var/log/auth.log": auth,
      "NOTIZ.txt": [
        "Wer das liest, sitzt fest. Die T\xFCr hat vier Schl\xF6sser.",
        "Jedes will eine Spur vom System. Tipp: help"
      ]
    },
    answers: [String(badPid), String(backdoorPort), attackerIp, account]
  };
}
function escapeAnswerMatches(expected, given) {
  return expected.trim().toLowerCase() === String(given ?? "").trim().toLowerCase();
}
function runEscapeCommand(puzzle, line) {
  const input = line.trim().replace(/\s+/g, " ");
  if (!input) return { output: [] };
  if (input === "clear") return { output: [], clear: true };
  if (puzzle.commands[input]) return { output: puzzle.commands[input] };
  if (input === "ps" || input === "ps -ef" || input === "ps aux | less") return { output: puzzle.commands["ps aux"] };
  if (input === "ss" || input === "netstat -tlnp" || input === "ss -tulpn" || input === "ss -lntp") {
    return { output: puzzle.commands["ss -tlnp"] };
  }
  const [cmd, ...args] = input.split(" ");
  const resolve = (name) => {
    if (!name) return void 0;
    const key = Object.keys(puzzle.files).find((f) => f === name || f.replace(/^\//, "") === name.replace(/^\//, "") || f.endsWith(`/${name}`));
    return key ? puzzle.files[key] : void 0;
  };
  if (cmd === "cat" || cmd === "less" || cmd === "tail" || cmd === "head") {
    const file = resolve(args[args.length - 1]);
    return file ? { output: file } : { output: [`${cmd}: ${args[args.length - 1] ?? ""}: Datei oder Verzeichnis nicht gefunden`] };
  }
  if (cmd === "grep") {
    const pattern = (args[0] ?? "").replace(/^["']|["']$/g, "");
    const file = resolve(args[1]);
    if (!pattern || !file) return { output: ["Aufruf: grep <muster> <datei>"] };
    return { output: file.filter((l) => l.toLowerCase().includes(pattern.toLowerCase())) };
  }
  if (cmd === "ls") return { output: puzzle.commands.ls };
  if (cmd === "cd" || cmd === "sudo" || cmd === "su" || cmd === "exit") {
    return { output: [`${cmd}: In dieser Zelle nicht erlaubt. Die T\xFCr \xF6ffnet sich nur mit den vier Spuren.`] };
  }
  return { output: [`${cmd}: Befehl nicht gefunden \u2013 \u201Ehelp\u201C zeigt, was hier geht.`] };
}

// src/domain/minigames/towerdefense.ts
var TOWERS = {
  filter: {
    kind: "filter",
    label: "UDP-Filter",
    description: "Verwirft reflektierte UDP-Pakete. Schnell, aber blind f\xFCr alles andere.",
    cost: 30,
    range: 2.5,
    damage: 1,
    cooldown: 3,
    targets: ["udp"]
  },
  proxy: {
    kind: "proxy",
    label: "SYN-Proxy",
    description: "Beantwortet SYNs stellvertretend und l\xE4sst nur echte Verbindungen durch.",
    cost: 40,
    range: 2,
    damage: 2,
    cooldown: 5,
    targets: ["syn"]
  },
  waf: {
    kind: "waf",
    label: "Rate-Limit",
    description: "Begrenzt Anfragen je Quelle. Das Einzige, was gegen Layer 7 hilft.",
    cost: 45,
    range: 2.6,
    damage: 3,
    cooldown: 8,
    targets: ["http"]
  },
  scrubber: {
    kind: "scrubber",
    label: "Scrubbing-Appliance",
    description: "Filtert jede Angriffsart, kostet aber das Doppelte.",
    cost: 85,
    range: 1.8,
    damage: 2,
    cooldown: 6,
    targets: ["udp", "syn", "http"]
  }
};
var PACKETS = {
  udp: { kind: "udp", label: "UDP", hp: 2, speed: 0.1, color: "#f97316" },
  syn: { kind: "syn", label: "SYN", hp: 4, speed: 0.08, color: "#a855f7" },
  http: { kind: "http", label: "HTTP", hp: 7, speed: 0.055, color: "#ef4444" }
};
var TD = {
  WIDTH: 14,
  HEIGHT: 8,
  /** Schritte je Sekunde beim Abspielen. */
  STEPS_PER_SECOND: 10,
  SPAWN_INTERVAL: 6,
  KILL_REWARD: 5,
  WAVES: 3,
  /** Höchstens so viele Schritte je Welle – Schutz gegen Endlosschleifen. */
  MAX_WAVE_STEPS: 4e3,
  /** Bis zu diesem Durchlassanteil gilt der Angriff als abgewehrt. */
  WIN_LEAK_SHARE: 0.2,
  SECONDS: 360
};
var VECTOR_PACKET = {
  "udp-amplification": "udp",
  "syn-flood": "syn",
  "http-flood": "http"
};
function buildTowerDefense(seed, params) {
  const rng = new Rng(seed);
  const { WIDTH, HEIGHT } = TD;
  const path = [];
  let y = rng.int(1, HEIGHT - 2);
  let x = 0;
  while (x < WIDTH) {
    const run = Math.min(WIDTH - x, rng.int(2, 4));
    for (let i = 0; i < run; i++) path.push({ x: x + i, y });
    x += run;
    if (x >= WIDTH - 1) {
      while (x < WIDTH) path.push({ x: x++, y });
      break;
    }
    let target = rng.int(1, HEIGHT - 2);
    if (target === y) target = y <= HEIGHT / 2 ? y + 2 : y - 2;
    const dir = target > y ? 1 : -1;
    while (y !== target) {
      y += dir;
      path.push({ x: x - 1, y });
    }
  }
  const main = VECTOR_PACKET[params.vector];
  const others = ["udp", "syn", "http"].filter((k) => k !== main);
  const sizes = [10, 15, 22];
  const waves = sizes.map((size, wave) => {
    const list = [];
    for (let i = 0; i < size; i++) {
      const roll = rng.next();
      const mainShare = wave === 0 ? 0.85 : 0.7;
      list.push(roll < mainShare ? main : rng.pick(others));
    }
    return list;
  });
  return {
    width: WIDTH,
    height: HEIGHT,
    path,
    waves,
    budget: Math.round(params.budget),
    intensity: Math.max(0.5, Math.min(2.5, params.intensity))
  };
}
function createTdState(game) {
  return {
    wave: 0,
    running: false,
    step: 0,
    budget: game.budget,
    towers: [],
    packets: [],
    queue: [],
    spawnIn: 0,
    nextId: 1,
    leaked: 0,
    blocked: 0,
    total: game.waves.reduce((sum3, w) => sum3 + w.length, 0),
    shots: []
  };
}
function placementProblem(game, state, placement) {
  const spec = TOWERS[placement.kind];
  if (!spec) return "Unbekannter Filter.";
  const { x, y } = placement;
  if (!Number.isInteger(x) || !Number.isInteger(y) || x < 0 || y < 0 || x >= game.width || y >= game.height) {
    return "Au\xDFerhalb des Spielfelds.";
  }
  if (game.path.some((c) => c.x === x && c.y === y)) return "Auf der Leitung selbst ist kein Platz.";
  if (state.towers.some((t) => t.x === x && t.y === y)) return "Das Feld ist belegt.";
  if (spec.cost > state.budget) return "Das Budget reicht nicht.";
  return null;
}
function placeTower(game, state, placement) {
  const problem = placementProblem(game, state, placement);
  if (problem) return problem;
  state.budget -= TOWERS[placement.kind].cost;
  state.towers.push({ x: placement.x, y: placement.y, kind: placement.kind, cooldown: 0 });
  return null;
}
function startWave(game, state) {
  if (state.running || state.wave >= game.waves.length) return;
  state.queue = [...game.waves[state.wave]];
  state.spawnIn = 0;
  state.running = true;
}
function packetPoint(game, pos) {
  const last2 = game.path.length - 1;
  const i = Math.max(0, Math.min(last2, Math.floor(pos)));
  const j = Math.min(last2, i + 1);
  const f = Math.max(0, Math.min(1, pos - i));
  const a = game.path[i];
  const b = game.path[j];
  return { x: a.x + (b.x - a.x) * f, y: a.y + (b.y - a.y) * f };
}
function stepTd(game, state) {
  if (!state.running) return false;
  state.step += 1;
  state.shots = [];
  if (state.queue.length > 0) {
    if (state.spawnIn <= 0) {
      const kind = state.queue.shift();
      const hp = Math.round(PACKETS[kind].hp * game.intensity * (1 + state.wave * 0.15));
      state.packets.push({ id: state.nextId++, kind, hp, maxHp: hp, pos: 0 });
      state.spawnIn = TD.SPAWN_INTERVAL;
    } else {
      state.spawnIn -= 1;
    }
  }
  const end = game.path.length - 1;
  for (const packet of state.packets) packet.pos += PACKETS[packet.kind].speed;
  const arrived = state.packets.filter((p) => p.pos >= end);
  state.leaked += arrived.length;
  state.packets = state.packets.filter((p) => p.pos < end);
  for (const tower of state.towers) {
    if (tower.cooldown > 0) {
      tower.cooldown -= 1;
      continue;
    }
    const spec = TOWERS[tower.kind];
    let best = null;
    for (const packet of state.packets) {
      if (packet.hp <= 0 || !spec.targets.includes(packet.kind)) continue;
      const p = packetPoint(game, packet.pos);
      const dx = p.x - tower.x;
      const dy = p.y - tower.y;
      if (dx * dx + dy * dy > spec.range * spec.range) continue;
      if (!best || packet.pos > best.pos) best = packet;
    }
    if (!best) continue;
    best.hp -= spec.damage;
    tower.cooldown = spec.cooldown;
    state.shots.push({ from: { x: tower.x, y: tower.y }, to: packetPoint(game, best.pos), kind: tower.kind });
  }
  const killed = state.packets.filter((p) => p.hp <= 0).length;
  state.blocked += killed;
  state.budget += killed * TD.KILL_REWARD;
  state.packets = state.packets.filter((p) => p.hp > 0);
  if (state.queue.length === 0 && state.packets.length === 0) {
    state.running = false;
    state.wave += 1;
    for (const tower of state.towers) tower.cooldown = 0;
    return false;
  }
  return true;
}
function runWave(game, state) {
  startWave(game, state);
  for (let i = 0; i < TD.MAX_WAVE_STEPS && stepTd(game, state); i++) ;
  if (state.running) {
    state.leaked += state.packets.length + state.queue.length;
    state.packets = [];
    state.queue = [];
    state.running = false;
    state.wave += 1;
  }
}
function replayTowerDefense(game, submission) {
  if (!Array.isArray(submission.placements) || submission.placements.length !== game.waves.length) {
    return { ok: false, error: "Es fehlen Wellen." };
  }
  const state = createTdState(game);
  for (let wave = 0; wave < game.waves.length; wave++) {
    const placements = submission.placements[wave];
    if (!Array.isArray(placements)) return { ok: false, error: "Ung\xFCltige Platzierung." };
    for (const placement of placements) {
      const problem = placeTower(game, state, placement);
      if (problem) return { ok: false, error: `Welle ${wave + 1}: ${problem}` };
    }
    runWave(game, state);
  }
  return { ok: true, leaked: state.leaked, total: state.total };
}

// src/domain/minigames/play.ts
var TD_VECTORS = ["udp-amplification", "syn-flood", "http-flood"];
function round12(value) {
  return Math.round(value * 10) / 10;
}
function hostnameOf(ctx, event) {
  const serverId = event.targets.find((t) => t.kind === "server")?.id;
  return serverId && ctx.world.servers[serverId]?.name || "web01";
}
function secondsOf(ctx, event) {
  const game = event.minigame;
  if (game.kind === "cabling") return buildCabling(game.seed, game.params.cables ?? 5).seconds;
  if (game.kind === "tower-defense") return TD.SECONDS;
  return buildEscape(game.seed, hostnameOf(ctx, event)).seconds;
}
function viewOf(ctx, event) {
  const game = event.minigame;
  if (game.kind === "cabling") return buildCabling(game.seed, game.params.cables ?? 5);
  if (game.kind === "tower-defense") {
    return buildTowerDefense(game.seed, {
      vector: TD_VECTORS[game.params.vector ?? 0] ?? "udp-amplification",
      budget: game.params.budget ?? 150,
      intensity: game.params.intensity ?? 1
    });
  }
  const { answers: _answers, ...puzzle } = buildEscape(game.seed, hostnameOf(ctx, event));
  return puzzle;
}
function finish(ctx, event, note) {
  findEventDefinition(event.type)?.onEnd?.(ctx, event);
  event.resolved = true;
  event.ticksRemaining = 0;
  event.resolutionNote = note;
}
function playMinigame(ctx, eventId, input, nowMs) {
  const { world } = ctx;
  const event = world.events[eventId];
  if (!event) return { ok: false, note: "Ereignis nicht gefunden." };
  const game = event.minigame;
  if (!game) return { ok: false, note: "Zu diesem Ereignis gibt es kein Minispiel." };
  if (input.action === "view") {
    return { ok: true, silent: true, note: "", data: { minigame: game, puzzle: viewOf(ctx, event), nowMs } };
  }
  if (event.resolved) return { ok: false, note: "Das Ereignis ist bereits vorbei." };
  if (input.action === "start") {
    if (game.state === "running") return { ok: true, silent: true, note: "Das Minispiel l\xE4uft bereits." };
    if (game.state !== "ready") return { ok: false, note: "Dieses Minispiel ist bereits gespielt." };
    game.state = "running";
    game.startedAtMs = nowMs;
    game.deadlineMs = nowMs + secondsOf(ctx, event) * 1e3;
    game.startedAtTick = world.meta.tick;
    return { ok: true, note: `${event.title}: Selbst eingegriffen \u2013 das Ereignis ist angehalten, solange das Minispiel l\xE4uft.` };
  }
  if (game.state !== "running") return { ok: false, note: "Das Minispiel l\xE4uft nicht." };
  if (input.action === "abort") {
    game.state = "lost";
    game.resultNote = "Abgebrochen \u2013 das Ereignis l\xE4uft normal weiter.";
    return { ok: true, note: `${event.title}: Minispiel abgebrochen.` };
  }
  if (game.deadlineMs !== null && nowMs > game.deadlineMs + MINIGAME.GRACE_MS) {
    game.state = "lost";
    game.resultNote = "Die Zeit ist abgelaufen \u2013 das Ereignis l\xE4uft normal weiter.";
    return { ok: false, note: game.resultNote };
  }
  const payload = input.payload ?? {};
  if (game.kind === "cabling") {
    const puzzle2 = buildCabling(game.seed, game.params.cables ?? 5);
    const error = checkCabling2(puzzle2, payload);
    if (error) {
      game.state = "lost";
      game.mistakes += 1;
      game.resultNote = `${error} Die Notumschaltung ist ausgel\xF6st; jetzt bleibt nur Abwarten oder Treibstoff.`;
      return { ok: false, note: game.resultNote };
    }
    game.state = "won";
    game.resultNote = "Die mobile Netzersatzanlage speist ein \u2013 der Standort l\xE4uft wieder auf stabilem Strom.";
    finish(ctx, event, game.resultNote);
    return { ok: true, note: `${event.title}: ${game.resultNote}` };
  }
  if (game.kind === "tower-defense") {
    const tdGame = viewOf(ctx, event);
    const replay = replayTowerDefense(tdGame, payload);
    if (!replay.ok) return { ok: false, note: `Die Abgabe passt nicht zum Spielfeld: ${replay.error}` };
    const leakShare = replay.total > 0 ? replay.leaked / replay.total : 0;
    const blockedPct = Math.round((1 - leakShare) * 100);
    const attack = event.ddos;
    if (leakShare <= TD.WIN_LEAK_SHARE || !attack) {
      game.state = "won";
      game.resultNote = `${blockedPct} % des Angriffs abgefangen \u2013 der Angreifer gibt auf.`;
      finish(ctx, event, game.resultNote);
      world.company.reputation = clamp(world.company.reputation + 0.5, 0, 100);
      return { ok: true, note: `${event.title}: ${game.resultNote}` };
    }
    attack.peakGbps = round12(Math.max(0.1, attack.peakGbps * leakShare));
    attack.peakRps = Math.round(attack.peakRps * leakShare);
    game.state = "lost";
    game.resultNote = `${blockedPct} % abgefangen. Der Angriff l\xE4uft mit h\xF6chstens ${attack.peakGbps.toLocaleString("de-DE")} Gbit/s weiter.`;
    return { ok: true, note: `${event.title}: ${game.resultNote}` };
  }
  const puzzle = buildEscape(game.seed, hostnameOf(ctx, event));
  const lock = Number(payload.lock);
  if (!Number.isInteger(lock) || lock < 0 || lock >= puzzle.answers.length) return { ok: false, note: "Unbekanntes Schloss." };
  if (game.solved.includes(lock)) return { ok: true, silent: true, note: "Dieses Schloss ist schon offen." };
  if (!escapeAnswerMatches(puzzle.answers[lock], String(payload.answer ?? ""))) {
    game.mistakes += 1;
    if (game.deadlineMs !== null) game.deadlineMs -= ESCAPE.PENALTY_SECONDS * 1e3;
    return {
      ok: false,
      silent: true,
      note: `Falsch \u2013 das Schloss klemmt. ${ESCAPE.PENALTY_SECONDS} Sekunden Abzug. Hinweis: ${puzzle.locks[lock].hint}`,
      data: { deadlineMs: game.deadlineMs }
    };
  }
  game.solved.push(lock);
  if (game.solved.length < puzzle.answers.length) {
    return { ok: true, silent: true, note: `Schloss ${lock + 1} ist offen.`, data: { solved: game.solved } };
  }
  game.state = "won";
  game.resultNote = "Ausgebrochen: Schadprozess beendet, Hintert\xFCr geschlossen, Konto gesperrt \u2013 ohne Neuinstallation.";
  finish(ctx, event, game.resultNote);
  world.company.reputation = clamp(world.company.reputation + 1, 0, 100);
  return { ok: true, note: `${event.title}: ${game.resultNote}`, data: { solved: game.solved } };
}

// src/domain/dc/delivery.ts
function blockedRanges(world, rackId, excludeDeliveryId) {
  const ranges = [...occupiedRanges(world, rackId)];
  for (const delivery of values(world.deliveries)) {
    if (delivery.id === excludeDeliveryId || !delivery.install || delivery.install.rackId !== rackId) continue;
    ranges.push({ start: delivery.install.rackUnit, end: delivery.install.rackUnit + delivery.heightUnits });
  }
  return ranges.sort((a, b) => a.start - b.start);
}
function checkSlot(world, delivery, rackId, rackUnit) {
  const rack = world.racks[rackId];
  if (!rack) return { ok: false, reason: "Rack nicht gefunden." };
  if (rackUnit < 0 || rackUnit + delivery.heightUnits > rack.units) {
    return { ok: false, reason: `Die H\xF6heneinheiten ${rackUnit + 1}\u2013${rackUnit + delivery.heightUnits} liegen nicht im Rack.` };
  }
  const end = rackUnit + delivery.heightUnits;
  const clash = blockedRanges(world, rackId, delivery.id).find((range) => range.start < end && rackUnit < range.end);
  if (clash) return { ok: false, reason: `Die H\xF6heneinheiten ${rackUnit + 1}\u2013${end} sind bereits belegt.` };
  const reservedWatt = values(world.deliveries).filter((d) => d.id !== delivery.id && d.install?.rackId === rackId).reduce((sum3, d) => sum3 + d.maxWatt, 0);
  const budgetKw = rack.powerBudgetKw;
  if (rackPowerKw(world, rackId) + (reservedWatt + delivery.maxWatt) / 1e3 > budgetKw) {
    return { ok: false, reason: `Das Strombudget des Racks (${budgetKw} kW) w\xFCrde \xFCberschritten.` };
  }
  return { ok: true };
}
function findFreeSlot(world, delivery, rackId) {
  const rack = world.racks[rackId];
  if (!rack) return null;
  let cursor = 0;
  for (const range of blockedRanges(world, rackId, delivery.id)) {
    if (range.start - cursor >= delivery.heightUnits) {
      if (checkSlot(world, delivery, rackId, cursor).ok) return cursor;
    }
    cursor = Math.max(cursor, range.end);
  }
  if (rack.units - cursor >= delivery.heightUnits && checkSlot(world, delivery, rackId, cursor).ok) return cursor;
  return null;
}
function dueInstallations(world) {
  return values(world.deliveries).filter((d) => d.install !== null && d.install.doneTick <= world.meta.tick);
}
function startInstallation(world, deliveryId, rackId, rackUnit) {
  const delivery = world.deliveries[deliveryId];
  if (!delivery) return { ok: false, message: "Lieferung nicht gefunden." };
  if (delivery.install) return { ok: false, message: `${delivery.label} wird bereits eingebaut.` };
  const rack = world.racks[rackId];
  if (!rack) return { ok: false, message: "Rack nicht gefunden." };
  if (rack.datacenterId !== delivery.datacenterId) {
    return { ok: false, message: "Das Ger\xE4t liegt im Lager eines anderen Standorts. Einbau nur im selben Rechenzentrum." };
  }
  const slot = rackUnit ?? findFreeSlot(world, delivery, rackId);
  if (slot === null) {
    return { ok: false, message: `In ${rack.name} fehlen frei ${delivery.heightUnits} H\xF6heneinheiten oder genug Strombudget f\xFCr dieses Ger\xE4t.` };
  }
  const check = checkSlot(world, delivery, rackId, slot);
  if (!check.ok) return { ok: false, message: check.reason };
  delivery.install = { rackId, rackUnit: slot, doneTick: world.meta.tick + DELIVERY.INSTALL_TICKS };
  return {
    ok: true,
    message: `${delivery.label} wird in ${rack.name} an Platz ${slot + 1} eingebaut \u2013 fertig in ${DELIVERY.INSTALL_TICKS} Stunden.`
  };
}
function cancelInstallation(world, deliveryId) {
  const delivery = world.deliveries[deliveryId];
  if (!delivery) return { ok: false, message: "Lieferung nicht gefunden." };
  if (!delivery.install) return { ok: false, message: `${delivery.label} wird gerade nicht eingebaut.` };
  delivery.install = null;
  return { ok: true, message: `Einbau von ${delivery.label} abgebrochen. Das Ger\xE4t liegt wieder im Lager.` };
}

// src/engine/commands.ts
var STANDBY_LOCAL_PREF = 50;
var ok9 = (message, createdId) => ({ ok: true, message, createdId });
var fail9 = (message) => ({ ok: false, message });
function deviceStore(world, kind) {
  switch (kind) {
    case "server":
      return world.servers;
    case "router":
      return world.routers;
    case "switch":
      return world.switches;
    case "firewall":
      return world.firewalls;
    case "loadbalancer":
      return world.loadBalancers;
    case "ups":
      return world.upsUnits;
    default:
      return null;
  }
}
function freePort(world, routerId) {
  const router = world.routers[routerId];
  if (!router) return -1;
  const port = router.ports.find((p) => p.linkId === null);
  return port?.index ?? -1;
}
function execute(world, command) {
  const rng = new Rng(world.rngState);
  let result;
  try {
    result = dispatch2(world, command, rng);
  } catch (error) {
    result = fail9(error.message);
  }
  world.rngState = rng.getState();
  if (result.ok && !result.silent) {
    log(world, rng, categoryOf(command), "info", result.message);
  }
  world.meta.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
  return result;
}
function orderDelivery(world, rng, input) {
  if (!spend(world, input.price, "cost-hardware", `Kauf ${input.label}`)) {
    return fail9(`Nicht gen\xFCgend Kapital (${input.price.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
  }
  const id = asId(makeId(rng, "dlv"));
  world.deliveries[id] = {
    id,
    kind: input.kind,
    datacenterId: input.rack.datacenterId,
    label: input.label,
    order: input.order,
    price: input.price,
    heightUnits: input.heightUnits,
    maxWatt: input.maxWatt,
    orderedAtTick: world.meta.tick,
    install: null
  };
  const city = world.datacenters[input.rack.datacenterId].city;
  return ok9(`${input.label} gekauft und ins Lager nach ${city} geliefert. Zum Einbau ins Rechenzentrum fahren.`, id);
}
function placeDelivery(world, rng, delivery, rackId, rackUnit) {
  return dispatch2(world, { ...delivery.order, rackId }, rng, { rackId, rackUnit, price: delivery.price });
}
function completeInstallations(world, rng) {
  for (const delivery of dueInstallations(world)) {
    const { rackId, rackUnit } = delivery.install;
    delivery.install = null;
    const check = checkSlot(world, delivery, rackId, rackUnit);
    if (!check.ok) {
      log(world, rng, "hardware", "warning", `Einbau von ${delivery.label} abgebrochen: ${check.reason}`);
      continue;
    }
    const result = placeDelivery(world, rng, delivery, rackId, rackUnit);
    if (!result.ok) {
      log(world, rng, "hardware", "warning", `Einbau von ${delivery.label} fehlgeschlagen: ${result.message}`);
      continue;
    }
    delete world.deliveries[delivery.id];
    log(world, rng, "hardware", "info", `${delivery.label} ist im Rack eingebaut und einsatzbereit.`);
  }
}
function categoryOf(command) {
  const prefix = command.type.split("/")[0];
  switch (prefix) {
    case "bgp":
      return "bgp";
    case "link":
    case "ixp":
    case "ipam":
    case "dns":
    case "vlan":
    case "vrf":
    case "switch":
    case "router":
    case "firewall":
    case "cable":
      return "network";
    case "hw":
    case "server":
    case "vps":
    case "rack":
    case "dc":
      return "hardware";
    case "product":
    case "contract":
    case "customer":
    case "ticket":
    case "staff":
      return "customer";
    case "finance":
    case "bank":
      return "billing";
    case "research":
      return "research";
    default:
      return "system";
  }
}
function acceptOffer(world, rng, offer, choice) {
  const p = offer.payload;
  switch (offer.kind) {
    case "transit": {
      if (!choice.routerId) return fail9("F\xFCr den Anschluss fehlt der Router. Bitte Router und Port w\xE4hlen.");
      const router = world.routers[choice.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const portIndex = choice.portIndex ?? freePort(world, router.id);
      if (portIndex < 0) return fail9(`${router.name} hat keinen freien Port.`);
      const bought = dispatch2(
        world,
        {
          type: "link/buyTransit",
          routerId: router.id,
          portIndex,
          providerAsn: p.providerAsn,
          capacityMbps: p.capacityMbps,
          committedMbps: p.committedMbps
        },
        rng
      );
      if (!bought.ok || !bought.createdId) return bought;
      const link = world.links[bought.createdId];
      if (link) {
        link.pricePerMbps = p.pricePerMbps;
        link.monthlyCost = offer.monthlyPrice;
        link.name = `${link.name} (${offer.sellerName})`;
      }
      return ok9(
        `Angebot von ${offer.sellerName} angenommen: ${offer.title}. ${p.pricePerMbps.toFixed(3)} \u20AC je Mbit/s, ${p.termMonths} Monate Laufzeit.`,
        bought.createdId
      );
    }
    case "ip-block": {
      if (!spend(world, offer.setupPrice, "cost-ip", `${offer.title} von ${offer.sellerName}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${offer.setupPrice.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      const existing = values(world.prefixes).filter((x) => x.family === "ipv4" && x.source !== "rfc1918").length;
      const length = p.length;
      const prefix = createPrefix(world, rng, {
        cidr: `198.18.${existing * 4 % 250}.0/${length}`,
        source: "purchased",
        usage: "customer"
      });
      return ok9(`${offer.title} von ${offer.sellerName} erworben: ${cidrOf(prefix)}.`, prefix.id);
    }
    case "hardware": {
      if (!choice.rackId) return fail9("F\xFCr die Server fehlt das Rack.");
      const rack = world.racks[choice.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const quantity = p.quantity;
      const total = p.unitPrice * quantity;
      const model = findServerModel(p.modelKey);
      if (!model) return fail9("Servermodell unbekannt.");
      for (let i = 0; i < quantity; i++) {
        const check = canInstall(world, rack.id, model.heightUnits, model.maxWatt);
        if (!check.ok) return fail9(`Nur ${i} von ${quantity} Ger\xE4ten passen in ${rack.name}: ${check.reason}`);
      }
      if (!spend(world, total, "cost-hardware", `${offer.title} von ${offer.sellerName}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${total.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      const health = p.health;
      const created = [];
      for (let i = 0; i < quantity; i++) {
        const id = asId(makeId(rng, "srv"));
        const count2 = Object.keys(world.servers).length + 1;
        world.servers[id] = {
          id,
          name: `srv-${world.datacenters[rack.datacenterId].city.slice(0, 3).toLowerCase()}-${String(count2).padStart(2, "0")}`,
          rackId: rack.id,
          datacenterId: rack.datacenterId,
          rackUnit: nextRackSlot(world, rack.id, model.heightUnits),
          heightUnits: model.heightUnits,
          state: "offline",
          model: model.key,
          purchasePrice: p.unitPrice,
          // Gebrauchte Geräte sind nicht neu – das schlägt sich in Alter und
          // Zustand nieder und damit in der Ausfallwahrscheinlichkeit.
          purchasedAtTick: world.meta.tick - Math.round(model.lifespanTicks * (1 - health) * 0.5),
          health,
          temperatureC: 24,
          pendingTicks: 0,
          standby: false,
          parts: factoryParts(model.key, world.meta.tick),
          maintenance: null,
          retirement: null,
          cpuModel: model.cpuModel,
          cpuCores: model.cpuCores,
          cpuGhz: model.cpuGhz,
          cpuIpc: model.cpuIpc,
          ramGb: model.ramGb,
          ssdGb: model.ssdGb,
          hddGb: model.hddGb,
          gpuCount: model.gpuCount,
          idleWatt: model.idleWatt,
          maxWatt: model.maxWatt,
          os: null,
          role: "unassigned",
          uplink: null,
          managementIp: null,
          vpsIds: [],
          contractIds: []
        };
        for (const part of world.servers[id].parts) part.health = health;
        created.push(id);
      }
      return ok9(
        `${quantity}\xD7 ${model.name} von ${offer.sellerName} gekauft (${total.toLocaleString("de-DE")} \u20AC). Rolle festlegen, Betriebssystem installieren und verkabeln, dann sind sie einsatzbereit.`,
        created[0]
      );
    }
    case "colocation": {
      const opened = dispatch2(world, { type: "dc/open", locationKey: p.locationKey }, rng);
      if (!opened.ok || !opened.createdId) return opened;
      const dc = world.datacenters[opened.createdId];
      if (dc) dc.monthlyRent = offer.monthlyPrice;
      return ok9(
        `Standort ${p.city} \xFCber ${offer.sellerName} er\xF6ffnet (${offer.monthlyPrice.toLocaleString("de-DE")} \u20AC statt ${p.listRent.toLocaleString("de-DE")} \u20AC Miete).`,
        opened.createdId
      );
    }
    case "peering": {
      if (!choice.routerId) return fail9("F\xFCr die Direktverbindung fehlt der Router.");
      const router = world.routers[choice.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const portIndex = choice.portIndex ?? freePort(world, router.id);
      if (portIndex < 0) return fail9(`${router.name} hat keinen freien Port.`);
      const port = router.ports[portIndex];
      if (!port || port.linkId) return fail9("Der gew\xE4hlte Port ist belegt.");
      const capacityMbps = p.capacityMbps;
      if (port.speedMbps < capacityMbps) {
        return fail9(`Port ${portIndex} liefert nur ${port.speedMbps} Mbit/s, gebraucht werden ${capacityMbps}.`);
      }
      if (!spend(world, offer.setupPrice, "cost-transit", `Aufbau ${offer.title}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${offer.setupPrice.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      const provider = world.market.providers.find((x) => x.asn === p.peerAsn);
      const linkId = asId(makeId(rng, "lnk"));
      world.links[linkId] = {
        id: linkId,
        kind: "peering-private",
        name: `PNI ${provider?.name ?? `AS${p.peerAsn}`}`,
        state: "up",
        a: {
          kind: "internal",
          routerId: router.id,
          portIndex: port.index,
          label: `${router.name} Port ${port.index}`,
          datacenterId: router.datacenterId
        },
        b: { kind: "external", routerId: null, portIndex: null, label: provider?.name ?? `AS${p.peerAsn}`, datacenterId: null },
        capacityMbps,
        latencyMs: 0.3,
        baseLossPercent: 0,
        monthlyCost: offer.monthlyPrice,
        setupCost: offer.setupPrice,
        pricePerMbps: 0,
        committedMbps: 0,
        resilience: 0.95,
        utilizationMbps: { aToB: 0, bToA: 0 },
        samples95th: [],
        buildTicksRemaining: 0,
        standby: false,
        ixpId: null,
        remoteAsn: p.peerAsn
      };
      port.linkId = linkId;
      port.description = `PNI ${provider?.name ?? ""}`.trim();
      router.bgp.neighbors.push({
        id: asId(makeId(rng, "peer")),
        address: `192.0.2.${p.peerAsn % 200 + 10}`,
        remoteAsn: p.peerAsn,
        description: `${provider?.name ?? `AS${p.peerAsn}`} (PNI)`,
        relation: "peer",
        linkId,
        enabled: true,
        routeMapIn: null,
        routeMapOut: null,
        maxPrefix: 25e4,
        defaultOriginate: false,
        prependOut: 0,
        localPrefIn: 200,
        medOut: null
      });
      return ok9(
        `Direktverbindung zu ${provider?.name ?? `AS${p.peerAsn}`} aufgebaut (${capacityMbps} Mbit/s${offer.monthlyPrice > 0 ? `, ${offer.monthlyPrice.toLocaleString("de-DE")} \u20AC/Monat` : ", kostenlos"}).`,
        linkId
      );
    }
    default:
      return fail9("Diese Angebotsart l\xE4sst sich noch nicht direkt annehmen.");
  }
}
function dispatch2(world, command, rng, placement) {
  switch (command.type) {
    // --- Simulation --------------------------------------------------------
    case "sim/setSpeed":
      world.meta.speed = clamp(Math.round(command.speed), 0, SIM.MAX_SPEED);
      return ok9(`Simulationsgeschwindigkeit auf ${world.meta.speed}\xD7 gesetzt.`);
    case "sim/setPaused":
      world.meta.paused = command.paused;
      return ok9(command.paused ? "Simulation angehalten." : "Simulation fortgesetzt.");
    // --- Standorte ---------------------------------------------------------
    case "dc/open": {
      const location = findLocation(command.locationKey);
      if (!location) return fail9("Standort unbekannt.");
      if (values(world.datacenters).some((d) => d.city === location.city)) {
        return fail9(`In ${location.city} existiert bereits ein Standort.`);
      }
      if (!spend(world, location.setupCost, "cost-other", `Standorter\xF6ffnung ${location.city}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${location.setupCost.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      const committedKw = baseCommittedKw(location);
      const footprint = footprintFor(location, committedKw);
      const rent = listRent(location, committedKw);
      const id = asId(makeId(rng, "dc"));
      world.datacenters[id] = {
        id,
        name: `${world.company.name} ${location.city}`,
        city: location.city,
        country: location.country,
        position: location.position,
        rackCapacity: footprint.rackCapacity,
        powerCapacityKw: footprint.powerCapacityKw,
        coolingCapacityKw: footprint.coolingCapacityKw,
        pue: location.pue,
        powerPricePerKwh: location.powerPricePerKwh,
        monthlyRent: rent,
        generator: { installed: false, runtimeHours: 0, fuelPercent: 0 },
        // Ein Standort startet mit einer Zuleitung; Redundanz muss beschafft werden.
        powerFeeds: { count: 1, monthlyCost: 0 },
        carriers: location.carriers,
        ambientTempC: location.ambientTempC,
        utilityPower: true,
        builtAtTick: world.meta.tick,
        /*
         * Wer sofort eröffnet, unterschreibt den Standardvertrag: zwölf Monate
         * zum Listenpreis. Das ist der Preis der Eile – verhandeln kostet Zeit,
         * spart aber bis zu einem Drittel der Miete.
         */
        contract: {
          providerName: providerFor(location.key),
          termMonths: 12,
          committedKw,
          prepaidMonths: 0,
          monthlyRent: rent,
          noticeMonths: COLOCATION.NOTICE_MONTHS.short,
          exitPenaltyShare: COLOCATION.EXIT_PENALTY_SHARE.short,
          signedAtTick: world.meta.tick,
          termEndsAtTick: world.meta.tick + 12 * SIM.TICKS_PER_MONTH,
          listRent: rent,
          notice: null
        }
      };
      chronicle(world, "ausbau", `Neuer Standort: ${location.city}.`);
      return ok9(`Standort ${location.city} er\xF6ffnet.`, id);
    }
    case "dc/installGenerator": {
      const dc = world.datacenters[command.datacenterId];
      if (!dc) return fail9("Standort nicht gefunden.");
      if (dc.generator.installed) return fail9("Es ist bereits ein Generator installiert.");
      const cost = Math.round(dc.powerCapacityKw * 420);
      if (!spend(world, cost, "cost-hardware", `Notstromaggregat ${dc.city}`)) return fail9(`Nicht gen\xFCgend Kapital (${cost} \u20AC ben\xF6tigt).`);
      dc.generator = { installed: true, runtimeHours: 48, fuelPercent: 100 };
      return ok9(`Notstromaggregat in ${dc.city} installiert (48 h Laufzeit).`);
    }
    case "dc/expandPower": {
      const dc = world.datacenters[command.datacenterId];
      if (!dc) return fail9("Standort nicht gefunden.");
      const cost = command.additionalKw * 900;
      if (!spend(world, cost, "cost-other", `Netzanschluss ${dc.city} erweitern`)) return fail9(`Nicht gen\xFCgend Kapital (${cost} \u20AC ben\xF6tigt).`);
      dc.powerCapacityKw += command.additionalKw;
      dc.monthlyRent += command.additionalKw * 22;
      return ok9(`Anschlussleistung in ${dc.city} auf ${dc.powerCapacityKw} kW erh\xF6ht.`);
    }
    case "dc/expandCooling": {
      const dc = world.datacenters[command.datacenterId];
      if (!dc) return fail9("Standort nicht gefunden.");
      const cost = command.additionalKw * 1100;
      if (!spend(world, cost, "cost-hardware", `K\xFChlung ${dc.city} erweitern`)) return fail9(`Nicht gen\xFCgend Kapital (${cost} \u20AC ben\xF6tigt).`);
      dc.coolingCapacityKw += command.additionalKw;
      dc.monthlyRent += command.additionalKw * 15;
      return ok9(`K\xFChlleistung in ${dc.city} auf ${dc.coolingCapacityKw} kW erh\xF6ht.`);
    }
    /*
     * Zweite Netzeinspeisung.
     *
     * Der eigentliche Schutz gegen Stromausfälle – wirksamer als jede USV, weil
     * er den Ausfall gar nicht erst durchschlagen lässt. USV und Generator
     * überbrücken Minuten bis Stunden; eine zweite Zuleitung aus einem anderen
     * Umspannwerk überbrückt den ganzen Ausfall.
     */
    case "dc/addPowerFeed": {
      const dc = world.datacenters[command.datacenterId];
      if (!dc) return fail9("Standort nicht gefunden.");
      const feeds = dc.powerFeeds?.count ?? 1;
      if (feeds >= 2) return fail9(`${dc.name} hat bereits eine redundante Einspeisung.`);
      const setup = Math.round(dc.powerCapacityKw * 55);
      const monthly = Math.round(dc.powerCapacityKw * 1.8);
      if (!spend(world, setup, "cost-power", `Zweite Netzeinspeisung ${dc.name}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${setup.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      dc.powerFeeds = { count: 2, monthlyCost: monthly };
      return ok9(
        `${dc.name}: zweite Netzeinspeisung aus einem anderen Umspannwerk geschaltet (${setup.toLocaleString("de-DE")} \u20AC einmalig, ${monthly.toLocaleString("de-DE")} \u20AC/Monat). Ein Ausfall einer Zuleitung schl\xE4gt jetzt nicht mehr durch.`
      );
    }
    /*
     * Eine bestehende Strecke zur Reserve erklären – oder zurück.
     *
     * Über die Local Preference: Reserverouten verlieren gegen die Hauptstrecke,
     * tragen aber sofort, wenn diese wegfällt. Kein Umschalten von Hand nötig,
     * genau dafür gibt es BGP.
     */
    case "link/setStandby": {
      const link = world.links[command.linkId];
      if (!link) return fail9("Strecke nicht gefunden.");
      if (link.kind !== "transit") return fail9("Nur Transitstrecken lassen sich als Reserve f\xFChren.");
      if (link.standby === command.standby) {
        return fail9(command.standby ? "Die Strecke ist bereits Reserve." : "Die Strecke ist bereits im Regelbetrieb.");
      }
      link.standby = command.standby;
      for (const router of values(world.routers)) {
        for (const neighbor of router.bgp.neighbors) {
          if (neighbor.linkId !== link.id) continue;
          neighbor.localPrefIn = command.standby ? STANDBY_LOCAL_PREF : 100;
        }
      }
      return ok9(
        command.standby ? `${link.name} ist jetzt Reserve. Verkehr l\xE4uft nur dar\xFCber, wenn die Hauptstrecken ausfallen.` : `${link.name} tr\xE4gt wieder im Regelbetrieb mit.`
      );
    }
    /*
     * --- Standortverträge ---------------------------------------------------
     *
     * Der Vertrag ist die zweite Hälfte von `dc/open`: Dort wird ein Standort zu
     * Listenkonditionen eröffnet, hier wird über ihn gesprochen. Beide Wege
     * führen zum selben Ergebnis – nur kostet der eine Zeit und der andere Geld.
     */
    case "coloc/negotiate": {
      const result = startNegotiation(world, rng, {
        locationKey: command.locationKey,
        termMonths: command.termMonths,
        committedKw: command.committedKw,
        prepaidMonths: command.prepaidMonths,
        datacenterId: command.datacenterId ?? null
      });
      return result.ok ? ok9(result.message, result.negotiationId) : fail9(result.message);
    }
    case "coloc/counter": {
      const result = counterNegotiation(world, rng, {
        negotiationId: command.negotiationId,
        demandedRent: command.demandedRent,
        terms: command.terms
      });
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "coloc/accept": {
      const result = acceptNegotiation(
        world,
        rng,
        command.negotiationId,
        (amount, description) => spend(world, amount, "cost-other", description)
      );
      if (!result.ok) return fail9(result.message);
      const negotiation = world.negotiations[command.negotiationId];
      if (negotiation && !negotiation.datacenterId) chronicle(world, "ausbau", `Neuer Standort: ${negotiation.city}.`);
      return ok9(result.message, result.datacenterId);
    }
    case "coloc/abort": {
      const result = abortNegotiation(world, command.negotiationId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "coloc/giveNotice": {
      const result = giveNotice(
        world,
        command.datacenterId,
        command.mode,
        (amount, description) => spend(world, amount, "cost-other", description)
      );
      if (!result.ok) return fail9(result.message);
      chronicle(world, "ausbau", `Standort ${world.datacenters[command.datacenterId]?.city} gek\xFCndigt.`);
      return ok9(result.message);
    }
    case "coloc/withdrawNotice": {
      const result = withdrawNotice(world, command.datacenterId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    // --- Hardware umsetzen ----------------------------------------------------
    case "dc/installDelivery": {
      const result = startInstallation(world, command.deliveryId, command.rackId, command.rackUnit);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "dc/cancelInstall": {
      const result = cancelInstallation(world, command.deliveryId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "dc/relocateDevice": {
      const result = startTransport(
        world,
        rng,
        { kind: command.kind, id: command.id, targetRackId: command.targetRackId },
        (amount, description) => spend(world, amount, "cost-other", description)
      );
      return result.ok ? ok9(result.message, result.transportId) : fail9(result.message);
    }
    case "dc/moveDevice": {
      const result = moveDeviceWithinSite(world, {
        kind: command.kind,
        id: command.id,
        targetRackId: command.targetRackId,
        force: command.force
      });
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "dc/reorderDevice": {
      const result = reorderDeviceInRack(world, command.kind, command.id, command.direction);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "dc/relocateSite": {
      const result = relocateSite(
        world,
        rng,
        { fromDatacenterId: command.fromDatacenterId, toDatacenterId: command.toDatacenterId },
        (amount, description) => spend(world, amount, "cost-other", description)
      );
      if (!result.ok) return fail9(result.message);
      chronicle(
        world,
        "ausbau",
        `Umzug von ${world.datacenters[command.fromDatacenterId]?.city} nach ${world.datacenters[command.toDatacenterId]?.city} begonnen.`
      );
      return ok9(result.message);
    }
    case "dc/cancelTransport": {
      const result = cancelTransport(world, command.transportId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "rack/rent": {
      const dc = world.datacenters[command.datacenterId];
      if (!dc) return fail9("Standort nicht gefunden.");
      if (freeRackSlots(world, command.datacenterId) <= 0) return fail9("Keine freien Rackpl\xE4tze am Standort.");
      const model = findRackModel(command.modelKey);
      if (!model) return fail9("Rackmodell unbekannt.");
      if (!spend(world, model.setupCost, "cost-rack", `Rack ${model.name} in ${dc.city}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${model.setupCost} \u20AC ben\xF6tigt).`);
      }
      const id = asId(makeId(rng, "rck"));
      const count2 = values(world.racks).filter((r) => r.datacenterId === command.datacenterId).length;
      world.racks[id] = {
        id,
        datacenterId: command.datacenterId,
        name: command.name ?? `Rack A${String(count2 + 1).padStart(2, "0")}`,
        units: model.units,
        powerBudgetKw: model.powerBudgetKw,
        monthlyCost: model.monthlyCost,
        upsIds: []
      };
      return ok9(`${model.name} in ${dc.city} angemietet.`, id);
    }
    case "rack/release": {
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const belegung = [
        ...values(world.servers),
        ...values(world.routers),
        ...values(world.switches),
        ...values(world.firewalls),
        ...values(world.loadBalancers),
        ...values(world.upsUnits)
      ].filter((d) => d.rackId === rack.id).map((d) => d.name);
      if (belegung.length > 0) {
        return fail9(
          `${rack.name} ist noch best\xFCckt (${belegung.slice(0, 3).join(", ")}${belegung.length > 3 ? ", \u2026" : ""}). Erst umbauen, verkaufen oder verlagern.`
        );
      }
      delete world.racks[command.rackId];
      return ok9(`${rack.name} zur\xFCckgegeben. Die Monatsmiete entf\xE4llt ab sofort.`);
    }
    // --- Hardware ----------------------------------------------------------
    /*
     * Selbst zusammengestellter Server.
     *
     * Fast derselbe Ablauf wie `hw/buyServer`, mit zwei Unterschieden: Der
     * Preis ergibt sich aus Gehäuse plus Bauteilen statt aus einem Katalogpreis,
     * und die Bestückung kommt aus der Konfiguration statt aus dem Werk. Alles
     * danach – Rolle, Betriebssystem, Verkabelung, Aufrüsten – ist identisch,
     * weil ein selbst gebauter Server im Zustand ein ganz normaler Server ist.
     */
    case "hw/buildServer": {
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const configuration = configureServer({ chassisKey: command.chassisKey, parts: command.parts });
      if (!configuration.ok) return fail9(configuration.problems.join(" "));
      const chassis = findChassis(command.chassisKey);
      const research = completedResearch(world);
      if (chassis.requiresResearch && !research.includes(chassis.requiresResearch)) {
        return fail9(`${chassis.name} ist noch nicht freigeschaltet \u2013 daf\xFCr fehlt die Forschung.`);
      }
      for (const line of configuration.lines) {
        if (line.part.requiresResearch && !research.includes(line.part.requiresResearch)) {
          return fail9(`${line.part.name} ist noch nicht freigeschaltet \u2013 daf\xFCr fehlt die Forschung.`);
        }
      }
      const price = placement?.price ?? worldPrice(world, "hardware", configuration.totalPrice);
      if (!placement) {
        return orderDelivery(world, rng, {
          kind: "server",
          rack,
          label: chassis.name,
          order: { type: "hw/buildServer", chassisKey: command.chassisKey, parts: command.parts, role: command.role, name: command.name },
          price,
          heightUnits: configuration.heightUnits,
          maxWatt: configuration.specs.maxWatt
        });
      }
      const id = asId(makeId(rng, "srv"));
      const count2 = Object.keys(world.servers).length + 1;
      const parts = [];
      const nextSlot = { cpu: 0, ram: 0, drive: 0, nic: 0, gpu: 0 };
      for (const line of configuration.lines) {
        for (let i = 0; i < line.quantity; i++) {
          parts.push({
            kind: line.part.kind,
            modelKey: line.part.key,
            slot: nextSlot[line.part.kind]++,
            installedAtTick: world.meta.tick,
            health: 1
          });
        }
      }
      world.servers[id] = {
        id,
        name: command.name ?? `srv-${world.datacenters[rack.datacenterId].city.slice(0, 3).toLowerCase()}-${String(count2).padStart(2, "0")}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: placement.rackUnit,
        heightUnits: configuration.heightUnits,
        state: "offline",
        model: chassis.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: 0,
        standby: false,
        parts,
        maintenance: null,
        retirement: null,
        cpuModel: configuration.specs.cpuModel,
        cpuCores: configuration.specs.cpuCores,
        cpuGhz: configuration.specs.cpuGhz,
        cpuIpc: configuration.specs.cpuIpc,
        ramGb: configuration.specs.ramGb,
        ssdGb: configuration.specs.ssdGb,
        hddGb: configuration.specs.hddGb,
        gpuCount: configuration.specs.gpuCount,
        idleWatt: configuration.specs.idleWatt,
        maxWatt: configuration.specs.maxWatt,
        os: null,
        role: command.role,
        uplink: null,
        managementIp: null,
        vpsIds: [],
        contractIds: []
      };
      return ok9(
        `${chassis.name} zusammengebaut: ${configuration.specs.cpuCores} Kerne, ${configuration.specs.ramGb} GB RAM, ${configuration.specs.ssdGb + configuration.specs.hddGb} GB Speicher f\xFCr ${price.toLocaleString("de-DE")} \u20AC. Betriebssystem installieren, dann ist der Server einsatzbereit.`,
        id
      );
    }
    case "hw/buyServer": {
      const model = findServerModel(command.modelKey);
      if (!model) return fail9("Servermodell unbekannt.");
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const price = placement?.price ?? worldPrice(world, "hardware", model.price);
      if (!placement) {
        return orderDelivery(world, rng, {
          kind: "server",
          rack,
          label: model.name,
          order: { type: "hw/buyServer", modelKey: command.modelKey, role: command.role, name: command.name },
          price,
          heightUnits: model.heightUnits,
          maxWatt: model.maxWatt
        });
      }
      const id = asId(makeId(rng, "srv"));
      const count2 = Object.keys(world.servers).length + 1;
      world.servers[id] = {
        id,
        name: command.name ?? `srv-${world.datacenters[rack.datacenterId].city.slice(0, 3).toLowerCase()}-${String(count2).padStart(2, "0")}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: placement.rackUnit,
        heightUnits: model.heightUnits,
        state: "offline",
        model: model.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: 0,
        standby: false,
        parts: factoryParts(model.key, world.meta.tick),
        maintenance: null,
        retirement: null,
        cpuModel: model.cpuModel,
        cpuCores: model.cpuCores,
        cpuGhz: model.cpuGhz,
        cpuIpc: model.cpuIpc,
        ramGb: model.ramGb,
        ssdGb: model.ssdGb,
        hddGb: model.hddGb,
        gpuCount: model.gpuCount,
        idleWatt: model.idleWatt,
        maxWatt: model.maxWatt,
        os: null,
        role: command.role,
        uplink: null,
        managementIp: null,
        vpsIds: [],
        contractIds: []
      };
      return ok9(`${model.name} gekauft. Betriebssystem installieren, dann ist der Server einsatzbereit.`, id);
    }
    case "hw/buyRouter": {
      const model = findRouterModel(command.modelKey);
      if (!model) return fail9("Routermodell unbekannt.");
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const price = placement?.price ?? worldPrice(world, "hardware", model.price);
      if (!placement) {
        return orderDelivery(world, rng, {
          kind: "router",
          rack,
          label: model.name,
          order: { type: "hw/buyRouter", modelKey: command.modelKey, name: command.name },
          price,
          heightUnits: model.heightUnits,
          maxWatt: model.maxWatt
        });
      }
      const id = asId(makeId(rng, "rtr"));
      const city = world.datacenters[rack.datacenterId].city.slice(0, 3).toLowerCase();
      const count2 = values(world.routers).filter((r) => r.datacenterId === rack.datacenterId).length + 1;
      world.routers[id] = {
        id,
        name: command.name ?? `rtr-${city}-${String(count2).padStart(2, "0")}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: placement.rackUnit,
        heightUnits: model.heightUnits,
        state: "booting",
        model: model.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: SIM.BOOT_TICKS,
        standby: false,
        ports: Array.from({ length: model.portCount }, (_, index) => ({
          index,
          speedMbps: model.portSpeedMbps,
          linkId: null,
          description: "",
          ipv4: null,
          ipv6: null,
          vrfId: null,
          enabled: true
        })),
        forwardingCapacityMbps: model.forwardingCapacityMbps,
        fibCapacity: model.fibCapacity,
        maxBgpSessions: model.maxBgpSessions,
        cpuLoad: 0.1,
        idleWatt: model.idleWatt,
        maxWatt: model.maxWatt,
        bgp: {
          localAsn: world.company.asn,
          routerId: nextRouterId(world),
          neighbors: [],
          originatedPrefixes: [],
          routeMaps: [],
          prefixLists: [],
          blackholeEnabled: true,
          dampening: false
        },
        staticRoutes: [],
        acls: [],
        nat: []
      };
      return ok9(`${model.name} gekauft und im Rack installiert.`, id);
    }
    case "hw/buySwitch": {
      const model = findSwitchModel(command.modelKey);
      if (!model) return fail9("Switchmodell unbekannt.");
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const price = placement?.price ?? worldPrice(world, "hardware", model.price);
      if (!placement) {
        return orderDelivery(world, rng, {
          kind: "switch",
          rack,
          label: model.name,
          order: { type: "hw/buySwitch", modelKey: command.modelKey, name: command.name },
          price,
          heightUnits: model.heightUnits,
          maxWatt: model.maxWatt
        });
      }
      const id = asId(makeId(rng, "swt"));
      const count2 = Object.keys(world.switches).length + 1;
      world.switches[id] = {
        id,
        name: command.name ?? `sw-${String(count2).padStart(2, "0")}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: placement.rackUnit,
        heightUnits: model.heightUnits,
        state: "booting",
        model: model.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: SIM.BOOT_TICKS,
        standby: false,
        ports: [
          ...Array.from({ length: model.portCount }, (_, index) => ({
            index,
            speedMbps: model.portSpeedMbps,
            mode: "access",
            vlanId: 100,
            allowedVlans: [],
            linkId: null,
            connectedDevice: null,
            enabled: true,
            description: ""
          })),
          ...Array.from({ length: model.uplinkCount }, (_, i) => ({
            index: model.portCount + i,
            speedMbps: model.uplinkSpeedMbps,
            mode: "trunk",
            vlanId: 1,
            allowedVlans: [1, 100, 200],
            linkId: null,
            connectedDevice: null,
            enabled: true,
            description: `Uplink ${i + 1}`
          }))
        ],
        switchingCapacityMbps: model.switchingCapacityMbps,
        macTableSize: model.macTableSize,
        idleWatt: model.idleWatt,
        maxWatt: model.maxWatt,
        layer3: model.layer3
      };
      return ok9(`${model.name} gekauft.`, id);
    }
    case "hw/buyFirewall": {
      const model = findFirewallModel(command.modelKey);
      if (!model) return fail9("Firewallmodell unbekannt.");
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const price = placement?.price ?? worldPrice(world, "hardware", model.price);
      if (!placement) {
        return orderDelivery(world, rng, {
          kind: "firewall",
          rack,
          label: model.name,
          order: { type: "hw/buyFirewall", modelKey: command.modelKey, name: command.name },
          price,
          heightUnits: model.heightUnits,
          maxWatt: model.maxWatt
        });
      }
      const id = asId(makeId(rng, "fwl"));
      world.firewalls[id] = {
        id,
        name: command.name ?? `fw-${Object.keys(world.firewalls).length + 1}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: placement.rackUnit,
        heightUnits: model.heightUnits,
        state: "booting",
        model: model.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: SIM.BOOT_TICKS,
        standby: false,
        throughputMbps: model.throughputMbps,
        sessionCapacity: model.sessionCapacity,
        currentSessions: 0,
        rules: defaultFirewallRules(),
        scrubbingGbps: model.scrubbingGbps,
        idleWatt: model.idleWatt,
        maxWatt: model.maxWatt
      };
      return ok9(`${model.name} gekauft (${model.scrubbingGbps} Gbit/s Scrubbing).`, id);
    }
    /*
     * Ein Loadbalancer kommt ohne Pool auf die Welt.
     *
     * Er ist zunächst genau das: ein Gerät im Rack, das Strom zieht. Erst der
     * Pool und seine Mitglieder machen ihn zu etwas – und diese Schritte will
     * der Betreiber bewusst gehen, statt eine Voreinstellung vorzufinden, die
     * er nicht bestellt hat.
     */
    case "hw/buyLoadBalancer": {
      const model = findLoadBalancerModel(command.modelKey);
      if (!model) return fail9("Loadbalancer-Modell unbekannt.");
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const price = placement?.price ?? worldPrice(world, "hardware", model.price);
      if (!placement) {
        return orderDelivery(world, rng, {
          kind: "loadbalancer",
          rack,
          label: model.name,
          order: { type: "hw/buyLoadBalancer", modelKey: command.modelKey, name: command.name },
          price,
          heightUnits: model.heightUnits,
          maxWatt: model.maxWatt
        });
      }
      const id = asId(makeId(rng, "lb"));
      world.loadBalancers[id] = {
        id,
        name: command.name ?? `lb-${Object.keys(world.loadBalancers).length + 1}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: placement.rackUnit,
        heightUnits: model.heightUnits,
        state: "booting",
        model: model.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: SIM.BOOT_TICKS,
        standby: false,
        throughputMbps: model.throughputMbps,
        connectionCapacity: model.connectionCapacity,
        tlsHandshakesPerSecond: model.tlsHandshakesPerSecond,
        idleWatt: model.idleWatt,
        maxWatt: model.maxWatt,
        pools: [],
        peerId: null,
        haRole: "active",
        load: 0
      };
      return ok9(
        `${model.name} gekauft. Noch verkabeln, dann einen Pool anlegen \u2013 allein tut er nichts.`,
        id
      );
    }
    case "hw/buyUps": {
      const model = findUpsModel(command.modelKey);
      if (!model) return fail9("USV-Modell unbekannt.");
      if (model.central) {
        if (!command.datacenterId) return fail9("F\xFCr die zentrale USV fehlt der Standort.");
        const dc = world.datacenters[command.datacenterId];
        if (!dc) return fail9("Standort nicht gefunden.");
        const price2 = worldPrice(world, "hardware", model.price);
        if (!spend(world, price2, "cost-hardware", `Kauf ${model.name}`)) return fail9(`Nicht gen\xFCgend Kapital (${price2} \u20AC ben\xF6tigt).`);
        const id2 = asId(makeId(rng, "ups"));
        world.upsUnits[id2] = {
          id: id2,
          name: command.name ?? `usv-zentral-${Object.keys(world.upsUnits).length + 1}`,
          rackId: null,
          datacenterId: dc.id,
          rackUnit: 0,
          heightUnits: 0,
          state: "online",
          model: model.key,
          purchasePrice: price2,
          purchasedAtTick: world.meta.tick,
          health: 1,
          temperatureC: dc.ambientTempC,
          pendingTicks: 0,
          standby: false,
          capacityKwh: model.capacityKwh,
          outputKw: model.outputKw,
          charge: 1,
          idleWatt: model.idleWatt,
          maxWatt: model.maxWatt
        };
        return ok9(`${model.name} als Zuleitung f\xFCr ${dc.city} installiert.`, id2);
      }
      if (!command.rackId) return fail9("F\xFCr die USV fehlt das Rack.");
      const rack = world.racks[command.rackId];
      if (!rack) return fail9("Rack nicht gefunden.");
      const check = canInstall(world, command.rackId, model.heightUnits, model.maxWatt);
      if (!check.ok) return fail9(check.reason);
      const price = worldPrice(world, "hardware", model.price);
      if (!spend(world, price, "cost-hardware", `Kauf ${model.name}`)) return fail9(`Nicht gen\xFCgend Kapital (${price} \u20AC ben\xF6tigt).`);
      const id = asId(makeId(rng, "ups"));
      world.upsUnits[id] = {
        id,
        name: command.name ?? `usv-${Object.keys(world.upsUnits).length + 1}`,
        rackId: rack.id,
        datacenterId: rack.datacenterId,
        rackUnit: nextRackSlot(world, rack.id, model.heightUnits),
        heightUnits: model.heightUnits,
        state: "online",
        model: model.key,
        purchasePrice: price,
        purchasedAtTick: world.meta.tick,
        health: 1,
        temperatureC: 24,
        pendingTicks: 0,
        standby: false,
        capacityKwh: model.capacityKwh,
        outputKw: model.outputKw,
        charge: 1,
        idleWatt: model.idleWatt,
        maxWatt: model.maxWatt
      };
      rack.upsIds.push(id);
      return ok9(`${model.name} installiert.`, id);
    }
    /*
     * Verkauf eines Geräts.
     *
     * `harvestParts` behält die verbauten Bauteile im eigenen Ersatzteillager,
     * statt sie mitzuverkaufen – die richtige Wahl, solange gleichartige Server
     * im Bestand sind. Der Rückbau löst außerdem alle Verweise auf das Gerät,
     * damit kein Switch-Port ins Leere zeigt.
     */
    case "hw/sell":
      return decommissionDevice(
        world,
        command.kind,
        command.id,
        { harvestParts: command.harvestParts },
        (amount, description) => post(world, { category: "revenue-other", amount, description })
      );
    /*
     * Ein Gerät abschalten und wieder starten.
     *
     * Das Abschalten setzt zusätzlich `standby`: Von da an ist das Gerät nicht
     * „aus, warum auch immer“, sondern ausdrücklich Reserve. Ohne diese
     * Unterscheidung fährt die Rückkehr des Netzstroms es wieder mit hoch, und
     * die Störungsdiagnose meldet dauerhaft einen Zustand, den jemand
     * absichtlich hergestellt hat.
     */
    case "hw/power": {
      const store = deviceStore(world, command.kind);
      const device = store?.[command.id];
      if (!device) return fail9("Ger\xE4t nicht gefunden.");
      if (command.on) {
        if (device.state === "failed") return fail9("Defektes Ger\xE4t muss zuerst repariert werden.");
        device.standby = false;
        if (device.state === "online" || device.state === "booting") return ok9(`${device.name} l\xE4uft bereits.`);
        device.state = "booting";
        device.pendingTicks = SIM.BOOT_TICKS;
        return ok9(`${device.name} wird gestartet.`);
      }
      if (device.state === "maintenance") return fail9(`An ${device.name} l\xE4uft gerade eine Wartung.`);
      if (command.kind === "server" && !command.force) {
        const server = world.servers[command.id];
        const busy = server.contractIds.filter((id) => world.contracts[id] && world.contracts[id].state !== "cancelled").length + server.vpsIds.filter((id) => world.vpsInstances[id]).length;
        if (busy > 0) {
          return fail9(
            `Auf ${server.name} liegen ${busy} Dienste \u2013 abgeschaltet w\xE4ren sie offline und die Verf\xFCgbarkeit dahin. Erst r\xE4umen, oder das Abschalten ausdr\xFCcklich best\xE4tigen.`
          );
        }
      }
      device.state = "offline";
      device.pendingTicks = 0;
      device.standby = true;
      return ok9(
        `${device.name} ausgeschaltet und als Reserve vorgemerkt. Das Ger\xE4t zieht keinen Strom mehr, kostet aber weiter Wartung \u2013 und bleibt auch nach einem Stromausfall aus.`
      );
    }
    case "hw/reboot": {
      const store = deviceStore(world, command.kind);
      const device = store?.[command.id];
      if (!device) return fail9("Ger\xE4t nicht gefunden.");
      const result = rebootDevice(device);
      return result.ok ? ok9(`${device.name} wird neu gestartet.`) : fail9(result.error);
    }
    case "hw/repair": {
      const store = deviceStore(world, command.kind);
      const device = store?.[command.id];
      if (!device) return fail9("Ger\xE4t nicht gefunden.");
      const cost = Math.round(device.purchasePrice * 0.12);
      if (!spend(world, cost, "cost-hardware", `Reparatur ${device.name}`)) return fail9(`Nicht gen\xFCgend Kapital (${cost} \u20AC ben\xF6tigt).`);
      const result = startRepair(world, device);
      return ok9(`Reparatur von ${device.name} gestartet (${result.ticks} h).`);
    }
    // --- Bauteile, Lager, Wartungsfenster ------------------------------------
    case "hw/orderParts":
      return orderParts(world, rng, command, (amount, description) => spend(world, amount, "cost-hardware", description));
    case "hw/cancelPartOrder":
      return cancelPartOrder(
        world,
        command.orderId,
        (amount, description) => post(world, { category: "cost-hardware", amount, description })
      );
    case "hw/sellParts":
      return sellParts(world, command, (amount, description) => post(world, { category: "revenue-other", amount, description }));
    case "server/planUpgrade":
      return planUpgrade(world, {
        serverId: command.serverId,
        install: command.install,
        remove: command.remove,
        acceptDowntime: command.acceptDowntime
      });
    case "server/cancelUpgrade":
      return cancelUpgrade(world, command.serverId);
    case "vps/migrate": {
      const result = startVpsMigration(
        world,
        rng,
        { vpsId: command.vpsId, targetServerId: command.targetServerId },
        activeModifiers(world).computePerformance
      );
      return result.ok ? ok9(result.message, result.migrationId) : fail9(result.message);
    }
    case "migration/cancel":
      return cancelMigration(world, command.migrationId);
    /*
     * Server räumen.
     *
     * Der häufigste Fall im Betrieb, und bisher der am schlechtesten
     * unterstützte: "Diese Kiste muss raus." Anders als bei der Konsolidierung
     * ist kein Ziel vorgegeben – jede Last sucht sich den passendsten freien
     * Knoten.
     */
    case "server/evacuate": {
      const result = evacuateServer(world, rng, {
        serverId: command.serverId,
        targetServerId: command.targetServerId,
        retireAfterwards: command.retireAfterwards,
        performanceModifier: activeModifiers(world).computePerformance
      });
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    /*
     * Konsolidierung.
     *
     * Der Erlös aus den abgegebenen Servern wird hier nicht gebucht: Zum
     * Zeitpunkt des Befehls ist noch kein Server verkauft, sondern nur der
     * Umzug angestoßen. Gebucht wird im Tick, wenn der jeweilige Knoten
     * tatsächlich leer ist – siehe `advanceRetirements`.
     */
    case "server/consolidate": {
      const result = consolidate(world, rng, {
        targetServerId: command.targetServerId,
        sourceServerIds: command.sourceServerIds,
        retireDrained: command.retireDrained,
        harvestParts: command.harvestParts,
        performanceModifier: activeModifiers(world).computePerformance
      });
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "server/retire": {
      const result = retireServer(world, command.serverId, { harvestParts: command.harvestParts, reason: "manual" });
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "server/cancelRetirement": {
      const result = cancelRetirement(world, command.serverId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "vps/resize":
      return resizeVps(world, command, (serverId) => serverCapacity(world, serverId));
    /*
     * Tarifwechsel eines bestehenden Vertrags.
     *
     * Der Kunde bleibt, die Leistung ändert sich. Bei VPS heißt das, die Instanz
     * auf die neue Größe zu bringen; passt sie auf dem aktuellen Host nicht
     * mehr, muss vorher migriert oder aufgerüstet werden. Genau so laufen
     * Upgrade-Anfragen aus dem Vertrieb in der Praxis.
     */
    case "contract/changeProduct": {
      const contract = world.contracts[command.contractId];
      if (!contract) return fail9("Vertrag nicht gefunden.");
      if (contract.state !== "active") return fail9("Nur aktive Vertr\xE4ge lassen sich umstellen.");
      const product = world.products[command.productId];
      if (!product) return fail9("Produkt nicht gefunden.");
      if (!product.active) return fail9(`${product.name} wird derzeit nicht verkauft.`);
      const current = world.products[contract.productId];
      if (product.id === contract.productId) return fail9("Der Vertrag l\xE4uft bereits auf diesem Produkt.");
      if (current && product.kind !== current.kind) {
        return fail9(`Ein Wechsel von ${current.name} auf ${product.name} ist kein Tarifwechsel \u2013 daf\xFCr einen neuen Vertrag anlegen.`);
      }
      if (contract.vpsId) {
        const resized = resizeVps(
          world,
          {
            vpsId: contract.vpsId,
            vcpu: product.resources.cpuCores,
            ramGb: product.resources.ramGb,
            diskGb: product.resources.ssdGb
          },
          (serverId) => serverCapacity(world, serverId)
        );
        if (!resized.ok) return fail9(`Tarifwechsel nicht m\xF6glich: ${resized.message}`);
      }
      const oldPrice = contract.monthlyPrice;
      contract.productId = product.id;
      contract.monthlyPrice = product.monthlyPrice;
      const customer = world.customers[contract.customerId];
      if (customer && product.monthlyPrice > oldPrice) {
        customer.satisfaction = clamp(customer.satisfaction + 2, 0, 100);
      }
      return ok9(
        `${customer?.company ?? customer?.name ?? "Kunde"} wechselt auf ${product.name} (${oldPrice.toFixed(2)} \u20AC \u2192 ${product.monthlyPrice.toFixed(2)} \u20AC/Monat).`
      );
    }
    case "server/installOs": {
      const result = installOs(world, command.serverId, command.os);
      return result.ok ? ok9(`Betriebssystem ${command.os} wird auf ${world.servers[command.serverId].name} installiert.`) : fail9(result.error);
    }
    case "server/setRole": {
      const server = world.servers[command.serverId];
      if (!server) return fail9("Server nicht gefunden.");
      if (server.contractIds.length > 0 || server.vpsIds.length > 0) return fail9("Rolle l\xE4sst sich nur bei leerem Server \xE4ndern.");
      server.role = command.role;
      return ok9(`${server.name} \xFCbernimmt die Rolle "${command.role}".`);
    }
    case "server/rename": {
      const server = world.servers[command.serverId];
      if (!server) return fail9("Server nicht gefunden.");
      server.name = command.name;
      return ok9(`Server umbenannt in ${command.name}.`);
    }
    // --- Netzverbindungen ---------------------------------------------------
    case "link/buyTransit": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const provider = world.market.providers.find((p) => p.asn === command.providerAsn);
      if (!provider) return fail9("Anbieter unbekannt.");
      if (provider.transitPricePerMbps <= 0) return fail9(`${provider.name} verkauft keinen Transit.`);
      const dc = world.datacenters[router.datacenterId];
      if (!provider.cities.includes(dc.city)) return fail9(`${provider.name} ist in ${dc.city} nicht pr\xE4sent.`);
      const port = router.ports[command.portIndex];
      if (!port) return fail9("Port existiert nicht.");
      if (port.linkId) return fail9("Port ist bereits belegt.");
      if (port.speedMbps < command.capacityMbps) return fail9(`Port liefert nur ${port.speedMbps} Mbit/s.`);
      const setupCost = 900;
      const monthlyCost = command.committedMbps * provider.transitPricePerMbps + 150;
      if (!spend(world, setupCost, "cost-transit", `Transitanschluss ${provider.name}`)) return fail9("Nicht gen\xFCgend Kapital f\xFCr die Einrichtung.");
      const linkId = asId(makeId(rng, "lnk"));
      const link = {
        id: linkId,
        kind: "transit",
        name: `Transit ${provider.name} ${command.capacityMbps >= 1e3 ? `${command.capacityMbps / 1e3}G` : `${command.capacityMbps}M`}`,
        state: "up",
        a: { kind: "internal", routerId: router.id, portIndex: port.index, label: `${router.name} Port ${port.index}`, datacenterId: router.datacenterId },
        b: { kind: "external", routerId: null, portIndex: null, label: `${provider.name} (AS${provider.asn})`, datacenterId: null },
        capacityMbps: command.capacityMbps,
        latencyMs: 0.4,
        baseLossPercent: 0,
        monthlyCost,
        setupCost,
        pricePerMbps: provider.transitPricePerMbps,
        committedMbps: command.committedMbps,
        resilience: 0.8,
        utilizationMbps: { aToB: 0, bToA: 0 },
        samples95th: [],
        buildTicksRemaining: 0,
        standby: command.standby ?? false,
        ixpId: null,
        remoteAsn: provider.asn
      };
      world.links[linkId] = link;
      port.linkId = linkId;
      port.description = `Transit ${provider.name}`;
      const peerId = asId(makeId(rng, "peer"));
      router.bgp.neighbors.push({
        id: peerId,
        address: `198.51.${100 + router.bgp.neighbors.length % 50}.1`,
        remoteAsn: provider.asn,
        description: `${provider.name} Transit`,
        relation: "transit",
        linkId,
        enabled: true,
        routeMapIn: null,
        routeMapOut: null,
        maxPrefix: 12e5,
        // Kleine Router bekommen automatisch nur eine Default-Route.
        defaultOriginate: router.fibCapacity < 9e5,
        prependOut: 0,
        localPrefIn: command.standby ? STANDBY_LOCAL_PREF : 100,
        medOut: null
      });
      return ok9(
        (command.standby ? `Reserve-Transit von ${provider.name} gebucht` : `Transit von ${provider.name} gebucht`) + ` (${command.capacityMbps} Mbit/s, ${command.committedMbps} Mbit/s Commit, \u2248 ${monthlyCost.toFixed(0)} \u20AC/Monat).` + (command.standby ? " Er tr\xE4gt erst, wenn die Hauptstrecken ausfallen \u2013 bis dahin zahlst du nur den Commit." : ""),
        linkId
      );
    }
    case "link/buildFiber": {
      const from = world.routers[command.fromRouterId];
      const to = world.routers[command.toRouterId];
      if (!from || !to) return fail9("Router nicht gefunden.");
      if (from.id === to.id) return fail9("Quelle und Ziel sind identisch.");
      const portA = from.ports[command.fromPort];
      const portB = to.ports[command.toPort];
      if (!portA || !portB) return fail9("Port existiert nicht.");
      if (portA.linkId || portB.linkId) return fail9("Mindestens ein Port ist bereits belegt.");
      const dcA = world.datacenters[from.datacenterId];
      const dcB = world.datacenters[to.datacenterId];
      const km = distanceKm(dcA.position, dcB.position);
      const latency = fiberLatencyMs(dcA.position, dcB.position);
      const setupCost = command.owned ? Math.round(km * 4200) : 2500;
      const monthlyCost = command.owned ? Math.round(km * 6) : Math.round(km * 1.8 + command.capacityMbps / 1e3 * 180);
      const buildTicks = command.owned ? Math.round(km * 1.6) : 24;
      if (!spend(world, setupCost, "cost-fiber", `Glasfaser ${dcA.city} \u2013 ${dcB.city}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${setupCost.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      const linkId = asId(makeId(rng, "lnk"));
      world.links[linkId] = {
        id: linkId,
        kind: command.owned ? "fiber-owned" : "fiber-leased",
        name: `${dcA.city} \u2013 ${dcB.city}`,
        state: buildTicks > 0 ? "planned" : "up",
        a: { kind: "internal", routerId: from.id, portIndex: portA.index, label: `${from.name} Port ${portA.index}`, datacenterId: from.datacenterId },
        b: { kind: "internal", routerId: to.id, portIndex: portB.index, label: `${to.name} Port ${portB.index}`, datacenterId: to.datacenterId },
        capacityMbps: command.capacityMbps,
        latencyMs: latency,
        baseLossPercent: 0,
        monthlyCost,
        setupCost,
        pricePerMbps: 0,
        committedMbps: 0,
        resilience: command.owned ? 0.75 : 0.85,
        utilizationMbps: { aToB: 0, bToA: 0 },
        samples95th: [],
        buildTicksRemaining: buildTicks,
        standby: false,
        ixpId: null,
        remoteAsn: null
      };
      portA.linkId = linkId;
      portB.linkId = linkId;
      portA.description = `Backbone \u2192 ${dcB.city}`;
      portB.description = `Backbone \u2192 ${dcA.city}`;
      const addIbgp = (local, remote) => {
        if (local.bgp.neighbors.some((n) => n.relation === "ibgp" && n.address === remote.bgp.routerId)) return;
        local.bgp.neighbors.push({
          id: asId(makeId(rng, "peer")),
          address: remote.bgp.routerId,
          remoteAsn: world.company.asn,
          description: `iBGP ${remote.name}`,
          relation: "ibgp",
          linkId: null,
          enabled: true,
          routeMapIn: null,
          routeMapOut: null,
          maxPrefix: 2e6,
          defaultOriginate: false,
          prependOut: 0,
          localPrefIn: 100,
          medOut: null
        });
      };
      addIbgp(from, to);
      addIbgp(to, from);
      return ok9(
        `Strecke ${dcA.city} \u2013 ${dcB.city} beauftragt (${km.toFixed(0)} km, ${latency.toFixed(2)} ms, Bauzeit ${buildTicks} h, ${monthlyCost} \u20AC/Monat).`,
        linkId
      );
    }
    case "link/upgrade": {
      const link = world.links[command.linkId];
      if (!link) return fail9("Strecke nicht gefunden.");
      if (command.capacityMbps <= link.capacityMbps) return fail9("Neue Kapazit\xE4t muss gr\xF6\xDFer sein.");
      for (const side of ["a", "b"]) {
        const endpoint = link[side];
        if (endpoint.kind !== "internal" || !endpoint.routerId || endpoint.portIndex === null) continue;
        const router = world.routers[endpoint.routerId];
        const port = router?.ports[endpoint.portIndex];
        if (!router || !port || port.speedMbps >= command.capacityMbps) continue;
        return fail9(
          `${router.name} Port ${endpoint.portIndex} tr\xE4gt nur ${formatMbps(port.speedMbps)}. Erst auf einen Port mit mindestens ${formatMbps(command.capacityMbps)} umstecken, dann aufr\xFCsten.`
        );
      }
      const factor = command.capacityMbps / link.capacityMbps;
      const cost = Math.round(link.monthlyCost * factor * 2);
      if (!spend(world, cost, "cost-fiber", `Aufr\xFCstung ${link.name}`)) return fail9(`Nicht gen\xFCgend Kapital (${cost} \u20AC ben\xF6tigt).`);
      link.capacityMbps = command.capacityMbps;
      link.monthlyCost = Math.round(link.monthlyCost * Math.sqrt(factor));
      return ok9(`${link.name} auf ${command.capacityMbps} Mbit/s aufger\xFCstet.`);
    }
    case "link/cancel": {
      const link = world.links[command.linkId];
      if (!link) return fail9("Strecke nicht gefunden.");
      for (const router of values(world.routers)) {
        for (const port of router.ports) if (port.linkId === command.linkId) {
          port.linkId = null;
          port.description = "";
        }
        router.bgp.neighbors = router.bgp.neighbors.filter((n) => n.linkId !== command.linkId);
      }
      delete world.links[command.linkId];
      return ok9(`${link.name} gek\xFCndigt.`);
    }
    // --- IXP ---------------------------------------------------------------
    case "ixp/join": {
      const ixp = world.ixps[command.ixpId];
      if (!ixp) return fail9("IXP nicht gefunden.");
      if (ixp.joined) return fail9("Bereits Mitglied.");
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const dc = world.datacenters[router.datacenterId];
      if (dc.city !== ixp.city) return fail9(`${ixp.name} liegt in ${ixp.city}; der Router steht in ${dc.city}.`);
      const port = router.ports[command.portIndex];
      if (!port) return fail9("Port existiert nicht.");
      if (port.linkId) return fail9("Port ist bereits belegt.");
      if (!spend(world, ixp.setupFee, "cost-ixp", `IXP-Beitritt ${ixp.name}`)) return fail9(`Nicht gen\xFCgend Kapital (${ixp.setupFee} \u20AC ben\xF6tigt).`);
      ixp.joined = true;
      ixp.joinedAtTick = world.meta.tick;
      ixp.portCapacityMbps = command.portCapacityMbps;
      ixp.routerId = router.id;
      const linkId = asId(makeId(rng, "lnk"));
      world.links[linkId] = {
        id: linkId,
        kind: "peering-ix",
        name: `${ixp.name} Port`,
        state: "up",
        a: { kind: "internal", routerId: router.id, portIndex: port.index, label: `${router.name} Port ${port.index}`, datacenterId: router.datacenterId },
        b: { kind: "external", routerId: null, portIndex: null, label: ixp.name, datacenterId: null },
        capacityMbps: command.portCapacityMbps,
        latencyMs: 0.2,
        baseLossPercent: 0,
        monthlyCost: Math.round(command.portCapacityMbps / 1e3 * ixp.portFeePerGbps),
        setupCost: ixp.setupFee,
        pricePerMbps: 0,
        committedMbps: 0,
        resilience: 0.9,
        utilizationMbps: { aToB: 0, bToA: 0 },
        samples95th: [],
        buildTicksRemaining: 0,
        standby: false,
        ixpId: ixp.id,
        remoteAsn: null
      };
      port.linkId = linkId;
      port.description = ixp.name;
      return ok9(
        `${ixp.name} beigetreten (${command.portCapacityMbps} Mbit/s Port). Jetzt Peering-Sessions mit den ${ixp.memberCount} Mitgliedern anfragen.`,
        linkId
      );
    }
    case "ixp/leave": {
      const ixp = world.ixps[command.ixpId];
      if (!ixp) return fail9("IXP nicht gefunden.");
      if (!ixp.joined) return fail9("Keine Mitgliedschaft vorhanden.");
      for (const link of values(world.links)) {
        if (link.ixpId !== ixp.id) continue;
        for (const router of values(world.routers)) {
          for (const port of router.ports) if (port.linkId === link.id) {
            port.linkId = null;
            port.description = "";
          }
          router.bgp.neighbors = router.bgp.neighbors.filter((n) => n.linkId !== link.id);
        }
        delete world.links[link.id];
      }
      ixp.joined = false;
      ixp.routerId = null;
      ixp.portCapacityMbps = 0;
      return ok9(`Mitgliedschaft bei ${ixp.name} beendet.`);
    }
    /*
     * Portkapazität am Knoten anpassen.
     *
     * Ein IXP-Port läuft genauso voll wie eine Transitleitung – nur merkt man
     * es später, weil Peering-Verkehr nicht auf der Rechnung auftaucht. Wer
     * nicht nachlegt, hat Paketverlust ausgerechnet auf dem Weg, der ihn nichts
     * kostet.
     */
    case "ixp/upgradePort": {
      const ixp = world.ixps[command.ixpId];
      if (!ixp?.joined) return fail9("Keine Mitgliedschaft an diesem Knoten.");
      if (command.capacityMbps <= ixp.portCapacityMbps) return fail9("Der neue Port muss gr\xF6\xDFer sein als der bisherige.");
      const link = values(world.links).find((l) => l.ixpId === ixp.id);
      const router = ixp.routerId ? world.routers[ixp.routerId] : null;
      const port = router && link ? router.ports.find((p) => p.linkId === link.id) : null;
      if (port && port.speedMbps < command.capacityMbps) {
        return fail9(`Der Router-Port liefert nur ${port.speedMbps} Mbit/s. Erst auf einen schnelleren Port umstecken.`);
      }
      const setup = Math.round((command.capacityMbps - ixp.portCapacityMbps) / 1e3 * ixp.portFeePerGbps * 2);
      if (!spend(world, setup, "cost-ixp", `Portausbau ${ixp.name}`)) {
        return fail9(`Nicht gen\xFCgend Kapital (${setup.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      ixp.portCapacityMbps = command.capacityMbps;
      if (link) {
        link.capacityMbps = command.capacityMbps;
        link.monthlyCost = Math.round(command.capacityMbps / 1e3 * ixp.portFeePerGbps);
      }
      return ok9(`${ixp.name}: Port auf ${(command.capacityMbps / 1e3).toFixed(0)} Gbit/s ausgebaut.`);
    }
    case "ixp/connectRouteServer":
      return connectRouteServer(world, rng, command.ixpId);
    // --- Peering als Beziehung ------------------------------------------------
    case "peering/request":
      return requestPeering(world, rng, { peerAsn: command.peerAsn, via: command.via });
    case "peering/terminate":
      return terminatePeering(world, command.relationId);
    /*
     * Routing-Hygiene.
     *
     * RPKI, IRR und MANRS sind hier keine Kosmetik: Ohne sie lehnen ernsthafte
     * Netze das Peering ab, Knoten lassen einen nicht an den Route-Server, und
     * fremde Hijacks treffen ungebremst durch.
     */
    case "net/enableHygiene": {
      const costs = HYGIENE_COSTS[command.measure];
      if (world.company.hygiene[command.measure]) return fail9("Diese Ma\xDFnahme l\xE4uft bereits.");
      if (!spend(world, costs.setup, "cost-other", HYGIENE_LABEL[command.measure])) {
        return fail9(`Nicht gen\xFCgend Kapital (${costs.setup.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      }
      return enableHygiene(world, command.measure);
    }
    // --- BGP ----------------------------------------------------------------
    case "bgp/addNeighbor": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      if (router.bgp.neighbors.length >= router.maxBgpSessions) {
        return fail9(`${router.name} unterst\xFCtzt nur ${router.maxBgpSessions} Sessions.`);
      }
      const id = asId(makeId(rng, "peer"));
      const neighbor = {
        id,
        address: command.neighbor.address ?? "0.0.0.0",
        remoteAsn: command.neighbor.remoteAsn,
        description: command.neighbor.description ?? `AS${command.neighbor.remoteAsn}`,
        relation: command.neighbor.relation,
        linkId: command.neighbor.linkId ?? null,
        enabled: command.neighbor.enabled ?? true,
        routeMapIn: command.neighbor.routeMapIn ?? null,
        routeMapOut: command.neighbor.routeMapOut ?? null,
        maxPrefix: command.neighbor.maxPrefix ?? 5e5,
        defaultOriginate: command.neighbor.defaultOriginate ?? false,
        prependOut: command.neighbor.prependOut ?? 0,
        localPrefIn: command.neighbor.localPrefIn ?? (command.neighbor.relation === "peer" ? 200 : 100),
        medOut: command.neighbor.medOut ?? null
      };
      router.bgp.neighbors.push(neighbor);
      return ok9(`BGP-Nachbar AS${neighbor.remoteAsn} auf ${router.name} angelegt.`, id);
    }
    case "bgp/updateNeighbor": {
      const router = world.routers[command.routerId];
      const neighbor = router?.bgp.neighbors.find((n) => n.id === command.peerId);
      if (!neighbor) return fail9("Nachbar nicht gefunden.");
      Object.assign(neighbor, command.patch, { id: neighbor.id });
      return ok9(`Nachbar AS${neighbor.remoteAsn} aktualisiert.`);
    }
    case "bgp/removeNeighbor": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const before = router.bgp.neighbors.length;
      router.bgp.neighbors = router.bgp.neighbors.filter((n) => n.id !== command.peerId);
      if (router.bgp.neighbors.length === before) return fail9("Nachbar nicht gefunden.");
      delete world.sessions[asId(`ses_${command.routerId}_${command.peerId}`)];
      return ok9("BGP-Nachbar entfernt.");
    }
    case "bgp/announce": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const prefix = values(world.prefixes).find((p) => cidrOf(p) === command.prefix);
      if (prefix) {
        const check = canAnnounce(world, prefix.id);
        if (!check.ok) return fail9(check.reason);
        prefix.announced = true;
      }
      if (!announcePrefix(router, command.prefix)) return fail9("Prefix wird bereits angek\xFCndigt.");
      return ok9(`${command.prefix} wird von ${router.name} angek\xFCndigt.`);
    }
    case "bgp/withdraw": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      if (!withdrawPrefix(router, command.prefix)) return fail9("Prefix wird von diesem Router nicht angek\xFCndigt.");
      const stillAnnounced = values(world.routers).some((r) => r.bgp.originatedPrefixes.includes(command.prefix));
      const prefix = values(world.prefixes).find((p) => cidrOf(p) === command.prefix);
      if (prefix && !stillAnnounced) prefix.announced = false;
      return ok9(`${command.prefix} zur\xFCckgezogen. Ziele in diesem Netz sind nicht mehr erreichbar.`);
    }
    case "bgp/blackhole": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      try {
        parsePrefix(command.prefix);
      } catch {
        return fail9("Ung\xFCltiges Prefix.");
      }
      setBlackhole(router, command.prefix, command.enable);
      if (!command.enable) return ok9(`Blackhole f\xFCr ${command.prefix} aufgehoben.`);
      const problem = blackholeProblem(world, router, command.prefix);
      return ok9(
        problem ? `Blackhole f\xFCr ${command.prefix} eingetragen, wirkt aber nicht: ${problem}` : `Blackhole f\xFCr ${command.prefix} gesetzt \u2013 der Verkehr wird bereits bei den Upstreams verworfen.`
      );
    }
    case "bgp/setRouteMap": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const index = router.bgp.routeMaps.findIndex((m) => m.name === command.routeMap.name);
      if (index >= 0) router.bgp.routeMaps[index] = command.routeMap;
      else router.bgp.routeMaps.push(command.routeMap);
      return ok9(`Route-Map "${command.routeMap.name}" gespeichert (${command.routeMap.clauses.length} Klauseln).`);
    }
    case "bgp/deleteRouteMap": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      router.bgp.routeMaps = router.bgp.routeMaps.filter((m) => m.name !== command.name);
      for (const neighbor of router.bgp.neighbors) {
        if (neighbor.routeMapIn === command.name) neighbor.routeMapIn = null;
        if (neighbor.routeMapOut === command.name) neighbor.routeMapOut = null;
      }
      return ok9(`Route-Map "${command.name}" gel\xF6scht.`);
    }
    case "bgp/clearSession": {
      const session = world.sessions[asId(`ses_${command.routerId}_${command.peerId}`)];
      if (!session) return fail9("Session nicht gefunden.");
      session.state = "idle";
      session.ticksInState = 0;
      session.uptimeTicks = 0;
      session.prefixesReceived = 0;
      session.prefixesSent = 0;
      return ok9("Session zur\xFCckgesetzt \u2013 sie baut sich neu auf.");
    }
    // --- IPAM und Dienste ----------------------------------------------------
    case "ipam/buyBlock": {
      if (!world.company.rirMember) return fail9("Ohne RIR-Mitgliedschaft k\xF6nnen keine Adressen bezogen werden.");
      if (command.family === "ipv4") {
        if (command.length > 24 || command.length < 20) return fail9("Handelbar sind Bl\xF6cke zwischen /20 und /24.");
        const price2 = ipv4BlockPrice(world, command.length);
        if (!spend(world, price2, "cost-ip", `Kauf IPv4-Block /${command.length}`)) {
          return fail9(`Nicht gen\xFCgend Kapital (${price2.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
        }
        const existing2 = values(world.prefixes).filter((p) => p.family === "ipv4" && p.source !== "rfc1918").length;
        const cidr = `198.18.${existing2 * 4 % 250}.0/${command.length}`;
        const prefix2 = createPrefix(world, rng, { cidr, source: "purchased", usage: "customer" });
        return ok9(`IPv4-Block ${cidrOf(prefix2)} erworben (${price2.toLocaleString("de-DE")} \u20AC).`, prefix2.id);
      }
      const price = 2500;
      if (!spend(world, price, "cost-ip", "Zuteilung IPv6-Block")) return fail9(`Nicht gen\xFCgend Kapital (${price} \u20AC ben\xF6tigt).`);
      const existing = values(world.prefixes).filter((p) => p.family === "ipv6").length;
      const prefix = createPrefix(world, rng, { cidr: `2001:db8:${(4096 + existing).toString(16)}::/32`, source: "rir", usage: "customer" });
      return ok9(`IPv6-Block ${cidrOf(prefix)} zugeteilt.`, prefix.id);
    }
    /*
     * Abgabe eines Blocks auf dem Transfermarkt.
     *
     * IPv4 ist knapp und teuer – ein ungenutzter Block ist totes Kapital, das
     * jeden Monat Geld kostet. Wer schrumpft oder auf IPv6 umstellt, macht ihn
     * hier wieder zu Geld.
     */
    case "ipam/sellBlock": {
      const result = sellPrefix(
        world,
        command.prefixId,
        (amount, description) => post(world, { category: "revenue-other", amount, description })
      );
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    /*
     * Ein eingehendes Angebot annehmen.
     *
     * Die Konditionen des Angebots gelten, nicht die Listenpreise – darin liegt
     * ja der Sinn. Alles Weitere läuft über dieselben Wege wie ein regulärer
     * Kauf, damit ein per Anruf gebuchter Transit sich anschließend genauso
     * verhält wie ein selbst bestellter.
     */
    case "market/acceptOffer": {
      const offer = world.market.offers.find((o) => o.id === command.offerId);
      if (!offer) return fail9("Das Angebot gibt es nicht mehr.");
      if (offer.expiresAtTick <= world.meta.tick) {
        declineOffer(world, offer.id);
        return fail9("Das Angebot ist abgelaufen.");
      }
      const result = acceptOffer(world, rng, offer, {
        routerId: command.routerId,
        portIndex: command.portIndex,
        rackId: command.rackId
      });
      if (result.ok) declineOffer(world, offer.id);
      return result;
    }
    case "market/declineOffer": {
      const offer = world.market.offers.find((o) => o.id === command.offerId);
      if (!offer) return fail9("Das Angebot gibt es nicht mehr.");
      declineOffer(world, offer.id);
      return ok9(`Angebot von ${offer.sellerName} abgelehnt.`);
    }
    /*
     * Ankündigung eines Blocks zurückziehen.
     *
     * Der erste Schritt, bevor ein Block abgegeben werden kann – und ein
     * Eingriff mit Folgen: Wer noch Kunden darin hat, nimmt sie damit vom Netz.
     * Die Rückmeldung sagt deshalb, wie viele es sind.
     */
    case "ipam/withdrawBlock": {
      const result = withdrawPrefixEverywhere(world, command.prefixId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    /*
     * Unterteilung rückgängig machen.
     *
     * Ohne diesen Weg wäre das Unterteilen eine Einbahnstraße: Ein einmal
     * zerlegter Block ließe sich nie wieder als Ganzes abgeben.
     */
    case "ipam/mergeSubnets": {
      const result = mergeSubnets(world, command.prefixId);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    case "ipam/split": {
      const created = splitPrefix(world, rng, command.prefixId, command.newLength);
      return ok9(`${created.length} Subnetze /${command.newLength} angelegt.`);
    }
    case "ipam/setUsage": {
      const prefix = world.prefixes[command.prefixId];
      if (!prefix) return fail9("Prefix nicht gefunden.");
      prefix.usage = command.usage;
      return ok9(`${cidrOf(prefix)} als "${command.usage}" markiert.`);
    }
    case "ipam/createReverseZone": {
      const zone = createReverseZone(world, command.prefixId, command.serverIds);
      return ok9(`Reverse-Zone ${zone.name} angelegt und delegiert.`);
    }
    case "dns/createZone": {
      if (world.dnsZones[command.name]) return fail9("Zone existiert bereits.");
      if (command.serverIds.length === 0) return fail9("Mindestens ein Nameserver erforderlich.");
      createZone(world, command.name, command.serverIds);
      return ok9(`Zone ${command.name} angelegt.`);
    }
    case "dns/setPtr":
      return setReverseRecord(world, command.address, command.hostname) ? ok9(`PTR f\xFCr ${command.address} auf ${command.hostname} gesetzt.`) : fail9("Keine passende Reverse-Zone vorhanden.");
    case "vlan/create": {
      const vlan = createVlan(world, rng, { tag: command.tag, name: command.name, datacenterId: command.datacenterId });
      return ok9(`VLAN ${vlan.tag} (${vlan.name}) angelegt.`, vlan.id);
    }
    case "vlan/assignPrefix":
      assignPrefixToVlan(world, command.vlanId, command.prefixId);
      return ok9("Prefix dem VLAN zugewiesen.");
    case "vlan/enableDhcp": {
      const pool = createDhcpPool(world, command.vlanId, command.prefixId);
      return ok9(`DHCP aktiviert (${pool.rangeStart} \u2013 ${pool.rangeEnd}, Gateway ${pool.gateway}).`);
    }
    case "vrf/create": {
      const vrf = createVrf(world, rng, { name: command.name, rd: command.rd });
      return ok9(`VRF ${vrf.name} (RD ${vrf.rd}) angelegt.`, vrf.id);
    }
    case "switch/setPort": {
      const sw = world.switches[command.switchId];
      if (!sw) return fail9("Switch nicht gefunden.");
      const port = sw.ports[command.portIndex];
      if (!port) return fail9("Port existiert nicht.");
      port.mode = command.mode;
      port.vlanId = command.vlanId;
      if (command.allowedVlans) port.allowedVlans = command.allowedVlans;
      const attached = port.connectedDevice ? ` (${port.description || port.connectedDevice.kind})` : "";
      return ok9(`${sw.name} Port ${command.portIndex}${attached} auf ${command.mode} / VLAN ${command.vlanId} gesetzt.`);
    }
    /*
     * Port administrativ abschalten.
     *
     * Das übliche erste Mittel bei einem Problem am Zugang: den Port dicht
     * machen, statt das Gerät auszubauen. Ein abgeschalteter Port trennt das
     * dahinterliegende Blech vom Netz – mit allen Folgen für die Kunden darauf.
     */
    case "switch/setPortEnabled": {
      const sw = world.switches[command.switchId];
      if (!sw) return fail9("Switch nicht gefunden.");
      const port = sw.ports[command.portIndex];
      if (!port) return fail9("Port existiert nicht.");
      port.enabled = command.enabled;
      const behind = port.description || port.connectedDevice?.kind || "nichts";
      return ok9(
        `${sw.name} Port ${command.portIndex} ${command.enabled ? "aktiviert" : "abgeschaltet"} (dahinter: ${behind}).`
      );
    }
    // --- Verkabelung ----------------------------------------------------------
    case "cable/connect":
      return connectToSwitch(world, command);
    case "cable/disconnect":
      return disconnectFromSwitch(world, command);
    case "cable/repatch":
      return repatchDevice(world, command);
    case "link/movePort":
      return moveLinkToPort(world, command);
    case "contract/migrate": {
      const result = startContractMigration(
        world,
        rng,
        { contractId: command.contractId, targetServerId: command.targetServerId },
        activeModifiers(world).computePerformance
      );
      return result.ok ? ok9(result.message, result.migrationId) : fail9(result.message);
    }
    case "firewall/setRules": {
      const firewall = world.firewalls[command.firewallId];
      if (!firewall) return fail9("Firewall nicht gefunden.");
      firewall.rules = command.rules;
      return ok9(`${command.rules.length} Firewallregeln \xFCbernommen.`);
    }
    // --- Lastausgleich --------------------------------------------------------
    case "lb/createPool": {
      const result = createPool(world, rng, command);
      return result.ok ? ok9(result.message, result.createdId) : fail9(result.message);
    }
    case "lb/deletePool":
      return deletePool(world, command.poolId);
    case "lb/updatePool":
      return updatePool(world, command.poolId, command.patch);
    case "lb/addMember":
      return addPoolMember(world, command, activeModifiers(world).computePerformance);
    case "lb/removeMember":
      return removePoolMember(world, command);
    case "lb/setDrain":
      return setMemberDrain(world, command);
    case "lb/setWeight":
      return setMemberWeight(world, command);
    case "lb/attachContract":
      return attachContractToPool(world, command, activeModifiers(world).computePerformance);
    case "lb/detachContract":
      return detachContractFromPool(world, command, activeModifiers(world).computePerformance);
    case "lb/pair":
      return pairLoadBalancers(world, command.loadBalancerId, command.peerId);
    case "lb/unpair":
      return unpairLoadBalancer(world, command.loadBalancerId);
    case "router/addStaticRoute": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      parsePrefix(command.prefix);
      router.staticRoutes.push({
        prefix: command.prefix,
        nextHop: command.nextHop,
        distance: command.distance ?? 1,
        vrfId: null,
        description: ""
      });
      return ok9(`Statische Route ${command.prefix} via ${command.nextHop} eingetragen.`);
    }
    case "router/removeStaticRoute": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      router.staticRoutes = router.staticRoutes.filter((r) => r.prefix !== command.prefix);
      return ok9(`Statische Route ${command.prefix} entfernt.`);
    }
    /*
     * Router-Port administrativ schalten.
     *
     * Das Gegenstück zum Switch-Port: Wer eine zickende Übergabe hat, macht sie
     * zu, statt den Vertrag zu kündigen. Ein abgeschalteter Port trägt keinen
     * Verkehr, die BGP-Sitzung darüber fällt.
     */
    case "router/setPort": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      const port = router.ports[command.portIndex];
      if (!port) return fail9(`Port ${command.portIndex} gibt es an ${router.name} nicht.`);
      if (command.description !== void 0) port.description = command.description;
      if (command.enabled === void 0) return ok9(`${router.name} Port ${port.index}: Beschreibung gesetzt.`);
      port.enabled = command.enabled;
      const link = port.linkId ? world.links[port.linkId] : null;
      return ok9(
        `${router.name} Port ${port.index} ${command.enabled ? "aktiviert" : "abgeschaltet"}` + (link ? ` (${link.name}).` : ".")
      );
    }
    case "router/addNat": {
      const router = world.routers[command.routerId];
      if (!router) return fail9("Router nicht gefunden.");
      router.nat.push({ kind: "source", insidePrefix: command.insidePrefix, outsideAddress: command.outsideAddress, description: "" });
      return ok9(`NAT f\xFCr ${command.insidePrefix} auf ${command.outsideAddress} eingerichtet.`);
    }
    // --- Geschäft --------------------------------------------------------------
    case "product/setPrice": {
      const product = world.products[command.productId];
      if (!product) return fail9("Produkt nicht gefunden.");
      if (command.monthlyPrice < 0) return fail9("Preis darf nicht negativ sein.");
      product.monthlyPrice = Math.round(command.monthlyPrice * 100) / 100;
      return ok9(`${product.name} kostet jetzt ${product.monthlyPrice.toFixed(2)} \u20AC pro Monat.`);
    }
    case "product/setActive": {
      const product = world.products[command.productId];
      if (!product) return fail9("Produkt nicht gefunden.");
      product.active = command.active;
      return ok9(`${product.name} ${command.active ? "wird verkauft" : "aus dem Angebot genommen"}.`);
    }
    case "contract/terminate":
      return terminateContract(world, command.contractId) ? ok9("Vertrag gek\xFCndigt.") : fail9("Vertrag nicht gefunden.");
    case "contract/suspend":
      return suspendContract(world, command.contractId) ? ok9("Vertrag ausgesetzt.") : fail9("Vertrag nicht gefunden oder nicht aktiv.");
    case "contract/resume":
      return resumeContract(world, command.contractId) ? ok9("Vertrag reaktiviert.") : fail9("Vertrag nicht gefunden oder nicht ausgesetzt.");
    case "customer/credit": {
      const customer = world.customers[command.customerId];
      if (!customer) return fail9("Kunde nicht gefunden.");
      customer.balance += command.amount;
      customer.satisfaction = clamp(customer.satisfaction + Math.min(10, command.amount / 5), 0, 100);
      post(world, { category: "cost-penalty", amount: -command.amount, description: `Gutschrift: ${command.reason}` });
      return ok9(`${command.amount.toFixed(2)} \u20AC gutgeschrieben (${command.reason}).`);
    }
    case "admin/editCustomer": {
      const customer = world.customers[command.customerId];
      if (!customer) return fail9("Kunde nicht gefunden.");
      const changed = [];
      const p = command.patch;
      if (p.name !== void 0) {
        customer.name = p.name;
        changed.push("Name");
      }
      if (p.company !== void 0) {
        customer.company = p.company;
        changed.push("Firma");
      }
      if (p.email !== void 0) {
        customer.email = p.email;
        changed.push("E-Mail");
      }
      if (p.segment !== void 0) {
        customer.segment = p.segment;
        changed.push("Segment");
      }
      if (p.satisfaction !== void 0) {
        customer.satisfaction = clamp(p.satisfaction, 0, 100);
        changed.push("Zufriedenheit");
      }
      if (p.balance !== void 0) {
        customer.balance = p.balance;
        changed.push("Guthaben");
      }
      if (p.churnRisk !== void 0) {
        customer.churnRisk = clamp(p.churnRisk, 0, 1);
        changed.push("K\xFCndigungsrisiko");
      }
      if (p.reliability !== void 0) {
        customer.reliability = clamp(p.reliability, 0, 1);
        changed.push("Zahlungsmoral");
      }
      if (p.notes !== void 0) {
        customer.notes = p.notes;
        changed.push("Notiz");
      }
      if (changed.length === 0) return fail9("Keine \xC4nderung angegeben.");
      return ok9(`Verwaltung (${command.actorEmail}) hat Kunde "${customer.name}" bearbeitet: ${changed.join(", ")}.`);
    }
    case "admin/editCompany": {
      const changed = [];
      const p = command.patch;
      if (p.name !== void 0) {
        world.company.name = p.name;
        changed.push("Name");
      }
      if (p.cash !== void 0) {
        world.company.cash = p.cash;
        changed.push("Kasse");
      }
      if (p.debt !== void 0) {
        world.company.debt = clamp(p.debt, 0, Number.MAX_SAFE_INTEGER);
        changed.push("Schulden");
      }
      if (p.reputation !== void 0) {
        world.company.reputation = clamp(p.reputation, 0, 100);
        changed.push("Ruf");
      }
      if (p.creditLimit !== void 0) {
        world.company.creditLimit = clamp(p.creditLimit, 0, Number.MAX_SAFE_INTEGER);
        changed.push("Kreditlinie");
      }
      if (changed.length === 0) return fail9("Keine \xC4nderung angegeben.");
      return ok9(`Verwaltung (${command.actorEmail}) hat das Unternehmen bearbeitet: ${changed.join(", ")}.`);
    }
    case "admin/triggerEvent": {
      const definition = findEventDefinition(command.eventType);
      if (!definition) return fail9(`Unbekannter Ereignistyp \u201E${command.eventType}\u201C.`);
      const ctx = { world, rng, mitigationBonusGbps: activeModifiers(world).ddosMitigationGbps };
      if (!definition.canTrigger(ctx)) return fail9(`\u201E${definition.title}\u201C kann in dieser Partie gerade nicht eintreten.`);
      const payload = definition.trigger(ctx);
      if (!payload) return fail9("Das Ereignis fand kein Ziel.");
      const id = asId(makeId(rng, "evt"));
      world.events[id] = { ...payload, id, startedAtTick: world.meta.tick, resolved: false, resolutionNote: null };
      return ok9(`Verwaltung (${command.actorEmail}) hat ausgel\xF6st: ${payload.title}.`, id);
    }
    case "ticket/reply":
      return replyToTicket(world, command.ticketId, command.body, command.resolve) ? ok9(command.resolve ? "Ticket beantwortet und geschlossen." : "Antwort gesendet.") : fail9("Ticket nicht gefunden.");
    case "ticket/setPriority": {
      const ticket = world.tickets[command.ticketId];
      if (!ticket) return fail9("Ticket nicht gefunden.");
      ticket.priority = command.priority;
      return ok9(`Priorit\xE4t auf "${command.priority}" gesetzt.`);
    }
    case "ticket/assign": {
      const ticket = world.tickets[command.ticketId];
      if (!ticket) return fail9("Ticket nicht gefunden.");
      ticket.assignedStaffId = command.staffId;
      return ok9(command.staffId ? `Ticket zugewiesen an ${world.staff[command.staffId]?.name ?? command.staffId}.` : "Zuweisung aufgehoben.");
    }
    /*
     * Einstellung.
     *
     * Stufe, Fachgebiet und Arbeitszeitmodell bestimmen zusammen mit dem Können
     * das Gehalt. Ein 3rd-Level-Kollege im Schichtbetrieb kostet ein Vielfaches
     * eines Tages-1st-Levels – und genau darum geht es: Rund-um-die-Uhr-Support
     * ist möglich, aber er muss verdient sein.
     */
    /*
     * Sammelbearbeitung.
     *
     * Gedacht für den Fall nach einem Ausfall, wenn hunderte gleichlautende
     * Meldungen offen sind. Wer damit reguläre Anfragen pauschal zumacht,
     * bekommt sie erfahrungsgemäß zurück – die Rückmeldung sagt das auch.
     */
    case "ticket/bulk": {
      if (command.ticketIds.length === 0) return fail9("Es wurde kein Vorgang ausgew\xE4hlt.");
      const result = bulkProcessTickets(world, command.ticketIds, { body: command.body, resolve: command.resolve });
      const parts = [];
      if (result.resolved > 0) parts.push(`${result.resolved} geschlossen`);
      if (result.replied > 0) parts.push(`${result.replied} beantwortet`);
      if (result.skipped.length > 0) parts.push(`${result.skipped.length} \xFCbersprungen (Ursache besteht noch)`);
      if (parts.length === 0) return fail9("Keiner der gew\xE4hlten Vorg\xE4nge war offen.");
      return ok9(parts.join(", ") + ".");
    }
    case "staff/hire": {
      const skill = clamp(Math.round(command.skill), 1, 10);
      const level = command.level ?? 1;
      const shift = command.shift ?? "day";
      const specialties = command.specialties ?? DEFAULT_SPECIALTIES[command.role] ?? [];
      const base = ECONOMY.SALARY_BASE + skill * ECONOMY.SALARY_PER_SKILL;
      const salary = Math.round(base * (1 + (level - 1) * 0.35) * SHIFT_SALARY_FACTOR[shift]);
      const signing = salary;
      if (!spend(world, signing, "cost-staff", "Einstellung")) return fail9(`Nicht gen\xFCgend Kapital (${signing} \u20AC ben\xF6tigt).`);
      const id = asId(makeId(rng, "stf"));
      const names = ["Jana Vogt", "Marek Sobota", "Lena Fischer", "\xD6mer Demir", "Sofia Rossi", "Tim Berger", "Nora Haas", "Ilias Papadopoulos"];
      world.staff[id] = {
        id,
        name: rng.pick(names) ?? "Neue Kollegin",
        role: command.role,
        skill,
        monthlySalary: salary,
        datacenterId: command.datacenterId,
        hiredAtTick: world.meta.tick,
        workload: 0,
        level,
        specialties,
        shift
      };
      return ok9(
        `${world.staff[id].name} als ${command.role} eingestellt (${level}. Level, ${SHIFT_LABEL[shift]}, ${salary.toLocaleString("de-DE")} \u20AC/Monat).`,
        id
      );
    }
    case "staff/setShift": {
      const staff = world.staff[command.staffId];
      if (!staff) return fail9("Mitarbeiter nicht gefunden.");
      if (staff.shift === command.shift) return fail9(`${staff.name} arbeitet bereits in diesem Modell.`);
      const base = staff.monthlySalary / SHIFT_SALARY_FACTOR[staff.shift];
      staff.shift = command.shift;
      staff.monthlySalary = Math.round(base * SHIFT_SALARY_FACTOR[command.shift]);
      return ok9(
        `${staff.name} arbeitet jetzt in ${SHIFT_LABEL[command.shift]} (${staff.monthlySalary.toLocaleString("de-DE")} \u20AC/Monat).`
      );
    }
    case "staff/setSpecialties": {
      const staff = world.staff[command.staffId];
      if (!staff) return fail9("Mitarbeiter nicht gefunden.");
      staff.specialties = command.specialties;
      return ok9(
        command.specialties.length > 0 ? `${staff.name} betreut jetzt: ${command.specialties.join(", ")}.` : `${staff.name} hat kein festes Fachgebiet mehr \u2013 das kostet Tempo bei jedem Vorgang.`
      );
    }
    /*
     * Vorgang von Hand weiterreichen.
     *
     * Der Automatismus eskaliert erst nach einem gescheiterten Versuch. Wer
     * erkennt, dass ein Fall von vornherein ins 3rd Level gehört, spart damit
     * einen Durchlauf.
     */
    case "ticket/escalate": {
      const ticket = world.tickets[command.ticketId];
      if (!ticket) return fail9("Ticket nicht gefunden.");
      if (ticket.state === "resolved" || ticket.state === "closed") return fail9("Der Vorgang ist abgeschlossen.");
      if (command.level <= ticket.level) return fail9(`Der Vorgang liegt bereits auf Stufe ${ticket.level}.`);
      if (!values(world.staff).some((s) => s.role === "support" && s.level >= command.level)) {
        return fail9(`Es gibt niemanden auf ${command.level}. Level. Erst jemanden einstellen.`);
      }
      ticket.level = command.level;
      ticket.escalations += 1;
      ticket.assignedStaffId = null;
      ticket.messages.push({ tick: world.meta.tick, author: "system", body: `An ${command.level}. Level weitergegeben.` });
      return ok9(`Vorgang an ${command.level}. Level weitergegeben.`);
    }
    /** Rückfrage an den Kunden: Der Vorgang wartet, bis eine Antwort kommt. */
    case "ticket/askCustomer": {
      const ticket = world.tickets[command.ticketId];
      if (!ticket) return fail9("Ticket nicht gefunden.");
      if (ticket.state === "waiting-customer") return fail9("Es l\xE4uft bereits eine R\xFCckfrage.");
      if (ticket.state === "resolved" || ticket.state === "closed") return fail9("Der Vorgang ist abgeschlossen.");
      ticket.state = "waiting-customer";
      ticket.waitingSinceTick = world.meta.tick;
      if (ticket.firstResponseTick === null) ticket.firstResponseTick = world.meta.tick;
      ticket.messages.push({ tick: world.meta.tick, author: "staff", body: command.body });
      return ok9("R\xFCckfrage gesendet, der Vorgang wartet auf Antwort.");
    }
    case "staff/fire": {
      const staff = world.staff[command.staffId];
      if (!staff) return fail9("Mitarbeiter nicht gefunden.");
      if (staff.isOwner) return fail9("Der Inhaber l\xE4sst sich nicht entlassen.");
      spend(world, staff.monthlySalary * 2, "cost-staff", `Abfindung ${staff.name}`);
      delete world.staff[command.staffId];
      return ok9(`${staff.name} wurde entlassen.`);
    }
    // --- Sonstiges ---------------------------------------------------------------
    case "research/start": {
      const node = world.research[command.researchId];
      if (!node) return fail9("Forschungsprojekt nicht gefunden.");
      if (!canAfford(world, node.cost)) return fail9(`Nicht gen\xFCgend Kapital (${node.cost.toLocaleString("de-DE")} \u20AC ben\xF6tigt).`);
      const result = startResearch(world, command.researchId);
      if (!result.ok) return fail9(result.error);
      return ok9(`Forschung "${node.name}" gestartet (${Math.round(node.durationTicks / 24)} Tage).`);
    }
    case "server/console": {
      const server = world.servers[command.serverId];
      if (!server) return fail9("Server nicht gefunden.");
      const result = runConsole(world, command.serverId, String(command.line ?? ""));
      let output = result.output;
      if (result.delegate) {
        const delegated = dispatch2(world, result.delegate, rng);
        output = [...output, delegated.message];
        if (delegated.ok) return { ...delegated, output };
        return { ok: true, silent: true, message: delegated.message, output };
      }
      if (result.change) return { ok: true, message: result.change, output };
      return { ok: true, silent: true, message: "", output, clear: result.clear, close: result.close };
    }
    case "event/resolve": {
      const result = resolveEventOption(
        { world, rng, mitigationBonusGbps: activeModifiers(world).ddosMitigationGbps },
        command.eventId,
        command.optionKey
      );
      return result.ok ? ok9(result.note) : fail9(result.note);
    }
    case "event/minigame": {
      const { type: _type, eventId, nowMs, ...action } = command;
      const result = playMinigame(
        { world, rng, mitigationBonusGbps: activeModifiers(world).ddosMitigationGbps },
        eventId,
        action,
        Number.isFinite(nowMs) ? Number(nowMs) : world.meta.clockMs ?? 0
      );
      return { ok: result.ok, message: result.note, silent: result.silent, data: result.data };
    }
    case "finance/repayDebt":
      return repayDebt(world, command.amount) ? ok9(`${command.amount.toFixed(2)} \u20AC getilgt.`) : fail9("Tilgung nicht m\xF6glich.");
    case "bank/takeLoan": {
      const result = takeLoan(world, rng, command.productKey, command.amount);
      return result.ok ? ok9(result.message, result.loanId) : fail9(result.message);
    }
    case "bank/repayLoan": {
      const result = repayLoanEarly(world, command.loanId, command.amount);
      return result.ok ? ok9(result.message) : fail9(result.message);
    }
    default: {
      const exhaustive = command;
      return fail9(`Unbekanntes Kommando: ${JSON.stringify(exhaustive)}`);
    }
  }
}
function catalog(completedResearch2) {
  const available = (items) => items.filter((i) => i.requiresResearch === null || completedResearch2.includes(i.requiresResearch));
  return {
    servers: available(SERVER_MODELS),
    // Leere Gehäuse für den Konfigurator – dieselbe Struktur wie Fertiggeräte,
    // nur ohne Bestückung.
    chassis: available(SERVER_CHASSIS),
    routers: available(ROUTER_MODELS),
    switches: available(SWITCH_MODELS),
    firewalls: available(FIREWALL_MODELS),
    loadbalancers: available(LOADBALANCER_MODELS),
    ups: available(UPS_MODELS),
    loanProducts: available(LOAN_PRODUCTS),
    racks: RACK_MODELS,
    locations: LOCATIONS,
    // Bauteile für den nachträglichen Ausbau bestehender Server.
    parts: {
      cpu: available(CPU_PARTS),
      ram: available(RAM_PARTS),
      drive: available(DRIVE_PARTS),
      nic: available(NIC_PARTS),
      gpu: available(GPU_PARTS)
    }
  };
}

// src/engine/prune.ts
var RETENTION = {
  /** Gekündigte Verträge: drei Monate. */
  cancelledContracts: SIM.TICKS_PER_MONTH * 3,
  /**
   * Bezahlte und stornierte Rechnungen: zwei Monate.
   *
   * Die frühere Frist von sechs Monaten war fachlich nachvollziehbar und
   * praktisch die teuerste Zahl im ganzen Zustand: Bei tausend Kunden trägt
   * eine Welt damit sechstausend abgeschlossene Rechnungen mit sich herum,
   * jede mit ihren Positionen. Sie werden nirgends mehr gelesen – die
   * Monatsabschlüsse in `history` sind die Auswertung, und die überleben das
   * Aufräumen ohnehin.
   */
  settledInvoices: SIM.TICKS_PER_MONTH * 2,
  /**
   * Höchstzahl abgeschlossener Rechnungen je Kunde.
   *
   * Die Frist allein genügt nicht: Ein Kunde mit dreißig Verträgen bekommt
   * jeden Monat eine Rechnung, ein Großkunde über Jahre also Hunderte. Diese
   * Grenze deckelt, was die Frist noch durchlässt – die ältesten fallen
   * zuerst.
   */
  settledInvoicesPerCustomer: 3,
  /** Kunden ohne Vertrag und ohne offene Forderung: ein Monat. */
  departedCustomers: SIM.TICKS_PER_MONTH
};
function prune(world) {
  const now = world.meta.tick;
  const report = { contracts: 0, invoices: 0, customers: 0, migrations: 0, transports: 0, negotiations: 0 };
  report.migrations = pruneMigrations(world);
  report.transports = pruneTransports(world);
  report.negotiations = pruneNegotiations(world);
  for (const contract of values(world.contracts)) {
    if (contract.state !== "cancelled") continue;
    if (contract.endsAtTick === null || now - contract.endsAtTick < RETENTION.cancelledContracts) continue;
    const customer = world.customers[contract.customerId];
    if (customer) customer.contractIds = customer.contractIds.filter((id) => id !== contract.id);
    delete world.contracts[contract.id];
    report.contracts += 1;
  }
  const drop = (invoice) => {
    const customer = world.customers[invoice.customerId];
    if (customer) customer.invoiceIds = customer.invoiceIds.filter((id) => id !== invoice.id);
    delete world.invoices[invoice.id];
    report.invoices += 1;
  };
  for (const invoice of values(world.invoices)) {
    if (invoice.state !== "paid" && invoice.state !== "cancelled") continue;
    const settledAt = invoice.paidAtTick ?? invoice.issuedAtTick;
    if (now - settledAt < RETENTION.settledInvoices) continue;
    drop(invoice);
  }
  for (const customer of values(world.customers)) {
    const settled = customer.invoiceIds.map((id) => world.invoices[id]).filter((invoice) => !!invoice && (invoice.state === "paid" || invoice.state === "cancelled")).sort((a, b) => (b.paidAtTick ?? b.issuedAtTick) - (a.paidAtTick ?? a.issuedAtTick));
    for (const invoice of settled.slice(RETENTION.settledInvoicesPerCustomer)) drop(invoice);
  }
  for (const customer of values(world.customers)) {
    if (customer.contractIds.length > 0) continue;
    const hasOpenInvoice = customer.invoiceIds.some((id) => {
      const invoice = world.invoices[id];
      return invoice && (invoice.state === "open" || invoice.state === "overdue");
    });
    if (hasOpenInvoice) continue;
    const hasOpenTicket = customer.ticketIds.some((id) => {
      const ticket = world.tickets[id];
      return ticket && (ticket.state === "open" || ticket.state === "in-progress");
    });
    if (hasOpenTicket) continue;
    if (now - customer.joinedAtTick < RETENTION.departedCustomers) continue;
    for (const ticketId of customer.ticketIds) delete world.tickets[ticketId];
    for (const invoiceId of customer.invoiceIds) delete world.invoices[invoiceId];
    for (const domainId of customer.domainIds) delete world.domains[domainId];
    delete world.customers[customer.id];
    report.customers += 1;
  }
  return report;
}

// src/engine/simulation.ts
var researchThisMonth = [];
function log(world, rng, category, severity, message, ref) {
  world.logs.push({
    id: asId(makeId(rng, "log")),
    tick: world.meta.tick,
    category,
    severity,
    message,
    ref
  });
  if (world.logs.length > SIM.MAX_LOGS) {
    world.logs.splice(0, world.logs.length - SIM.MAX_LOGS);
  }
}
function tick(world) {
  const rng = new Rng(world.rngState);
  const logsBefore = world.logs.length;
  const report = {
    tick: world.meta.tick + 1,
    date: "",
    logs: [],
    newCustomers: 0,
    lostCustomers: 0,
    rejectedOrders: [],
    triggeredEvents: [],
    invoicesIssued: 0,
    paymentsReceived: 0,
    completedObjectives: [],
    news: []
  };
  world.meta.tick += 1;
  world.meta.date = tickToDate(world.meta.tick);
  const modifiers = activeModifiers(world);
  if (world.meta.tick % SIM.TICKS_PER_DAY === 0) {
    const economy = updateEconomy(world, rng);
    if (economy.regimeChanged) {
      chronicle(world, "ausbau", `Weltlage: ${REGIMES[economy.regimeChanged.to].label}.`);
    }
  }
  if (world.meta.tick % SIM.TICKS_PER_MONTH === 0) {
    updateTrends(world, rng);
    updateRegions(world, rng);
    for (const event of updateCompetitors(world, rng)) {
      if (event.freedShare && event.freedShare > 0) {
        world.market.demandIndex = Math.min(1.9, world.market.demandIndex + event.freedShare * 2.5);
      }
      if (event.kind === "insolvenz" || event.kind === "fusion") {
        chronicle(world, "ausbau", event.text);
      }
    }
  }
  if (world.meta.tick % SIM.TICKS_PER_DAY === 0) {
    report.news = collectNews(world);
  }
  for (const message of advancePartOrders(world)) {
    log(world, rng, "hardware", "info", message);
  }
  const maintenance = advanceMaintenance(world);
  for (const message of maintenance.messages) {
    log(world, rng, "hardware", "info", message);
  }
  for (const contractId of maintenance.satisfactionHits) {
    const customerId = world.contracts[contractId]?.customerId;
    const customer = customerId ? world.customers[customerId] : void 0;
    if (customer) customer.satisfaction = clamp(customer.satisfaction - UPGRADE.MAINTENANCE_SATISFACTION_COST, 0, 100);
  }
  const migrations = advanceMigrations(world);
  for (const message of migrations.messages) {
    log(world, rng, "hardware", message.severity, message.text);
  }
  for (const serverId of migrations.drainedServerIds) {
    log(world, rng, "hardware", "info", `${world.servers[serverId]?.name ?? "Ein Server"} ist leergelaufen und l\xE4sst sich jetzt abgeben.`, {
      kind: "server",
      id: serverId
    });
  }
  const retirements = advanceRetirements(world, (amount, description) => post(world, { category: "revenue-other", amount, description }));
  for (const message of retirements.messages) {
    log(world, rng, "hardware", "info", message);
  }
  if (retirements.soldServerIds.length > 0) {
    chronicle(
      world,
      "ausbau",
      retirements.soldServerIds.length === 1 ? "Ein ausgemusterter Server wurde abgegeben." : `${retirements.soldServerIds.length} ausgemusterte Server wurden abgegeben.`
    );
  }
  completeInstallations(world, rng);
  const transports = advanceTransports(world, rng);
  for (const message of transports.messages) {
    log(world, rng, "hardware", message.severity, message.text);
  }
  for (const datacenterId of transports.clearedSites) {
    log(world, rng, "hardware", "info", `${world.datacenters[datacenterId]?.name ?? "Ein Standort"} ist leer \u2013 der Vertrag l\xE4sst sich jetzt beenden.`, {
      kind: "datacenter",
      id: datacenterId
    });
  }
  const colocation = advanceColocation(
    world,
    (amount, description) => post(world, { category: amount >= 0 ? "revenue-other" : "cost-other", amount, description })
  );
  for (const message of colocation.messages) {
    log(world, rng, "event", message.severity, message.text, message.datacenterId ? { kind: "datacenter", id: message.datacenterId } : void 0);
  }
  for (const closure of colocation.closed) {
    chronicle(world, "ausbau", `Standort ${closure.city} aufgegeben.`);
  }
  for (const message of advancePendingOperations(world)) {
    log(world, rng, "hardware", "info", message);
  }
  for (const warning of agePartsAndReport(world, rng).warnings) {
    log(world, rng, "hardware", "warning", warning.text, { kind: "server", id: warning.serverId });
  }
  const repairs = autoRepair(world);
  for (const message of repairs.started) {
    log(world, rng, "hardware", "info", message);
  }
  if (repairs.costs > 0) {
    post(world, { category: "cost-hardware", amount: -repairs.costs, description: "Ersatzteile f\xFCr Reparaturen" });
  }
  updateVpsLoad(world, rng);
  let powerCostPerTick = 0;
  let coolingCostPerTick = 0;
  let powerKwUsed = 0;
  let powerKwTotal = 0;
  for (const datacenterId of Object.keys(world.datacenters)) {
    const facility = updateFacility(world, datacenterId, {
      power: modifiers.powerUsage,
      cooling: modifiers.coolingEfficiency
    });
    powerCostPerTick += facility.itCostPerTick;
    coolingCostPerTick += facility.coolingCostPerTick;
    powerKwUsed += facility.totalKw;
    powerKwTotal += facility.capacityKw;
    if (facility.coolingDeficitKw > 0.5 && world.meta.tick % 6 === 0) {
      log(
        world,
        rng,
        "hardware",
        "warning",
        `${world.datacenters[datacenterId].name}: K\xFChlleistung reicht nicht (${facility.coolingDeficitKw.toFixed(1)} kW \xDCberschuss).`,
        { kind: "datacenter", id: datacenterId }
      );
    }
    if (facility.totalKw > facility.capacityKw) {
      log(
        world,
        rng,
        "hardware",
        "error",
        `${world.datacenters[datacenterId].name}: Anschlussleistung \xFCberschritten (${facility.totalKw.toFixed(1)} von ${facility.capacityKw} kW).`,
        { kind: "datacenter", id: datacenterId }
      );
    }
  }
  for (const done2 of advanceLinkBuilds(world)) {
    log(world, rng, "network", "info", done2.text, { kind: "link", id: done2.linkId });
  }
  const sessionResult = stepSessions(world);
  for (const message of sessionResult.messages) {
    log(world, rng, "bgp", message.severity, message.text);
  }
  const peering = advancePeerings(world, rng);
  for (const decision of peering.decided) {
    log(
      world,
      rng,
      "bgp",
      decision.accepted ? "info" : "warning",
      `Peering-Anfrage an ${decision.name}: ${decision.accepted ? "angenommen" : "abgelehnt"}. ${decision.note}`
    );
  }
  for (const end of peering.terminated) {
    log(world, rng, "bgp", "warning", `Peering mit ${end.name} beendet: ${end.reason}`);
  }
  const bgp = runBgp(world);
  world.derived.routingTables = bgp.routingTables;
  world.derived.internetReachability = bgp.reachability;
  for (const message of bgp.messages) {
    log(world, rng, "bgp", message.severity, message.text);
  }
  for (const leak of bgp.leaks) {
    const router = world.routers[leak.routerId];
    const neighbor = router?.bgp.neighbors.find((n) => n.id === leak.peerId);
    log(
      world,
      rng,
      "bgp",
      "error",
      `Route Leak erkannt: ${leak.prefixCount} fremde Prefixe werden an AS${leak.toAsn} exportiert (Beispielpfad ${leak.sampleAsPath.join(" ")}). AS${leak.toAsn} hat die Session gefiltert.`,
      { kind: "router", id: leak.routerId }
    );
    if (neighbor) neighbor.enabled = false;
    world.company.reputation = clamp(world.company.reputation - 3, 0, 100);
  }
  for (const router of values(world.routers)) {
    const fibUsage = bgp.fibUsage[router.id] ?? 0;
    const load = clamp(fibUsage / Math.max(1, router.fibCapacity), 0, 1) * 0.6 + bgp.iterations * 0.05;
    router.cpuLoad = clamp(router.cpuLoad * 0.6 + load * 0.4, 0.05, 1);
  }
  const attackInbound = prepareAttacks(world, modifiers.ddosMitigationGbps);
  const traffic = simulateTraffic(world, bgp.routingTables, rng, attackInbound);
  settleAttacks(world);
  world.derived.traffic = {
    totalMbps: traffic.totalMbps,
    transitMbps: traffic.transitMbps,
    peeringMbps: traffic.peeringMbps,
    internalMbps: traffic.internalMbps,
    transitShare: traffic.totalMbps > 0 ? traffic.transitMbps / traffic.totalMbps : 0
  };
  world.derived.quality.avgLatencyMs = traffic.avgLatencyMs;
  world.derived.quality.packetLossPercent = traffic.packetLossPercent;
  for (const linkId of traffic.congestedLinks) {
    if (world.meta.tick % 4 !== 0) break;
    const link = world.links[linkId];
    if (!link) continue;
    log(world, rng, "network", "warning", `${link.name} ist \xFCberlastet \u2013 Paketverlust steigt.`, { kind: "link", id: linkId });
  }
  const balancing = updateLoadBalancers(world, rng);
  for (const message of balancing.messages) {
    log(world, rng, "network", message.severity, message.text, message.ref);
  }
  updateContractMetrics(world, bgp.reachability, 1);
  updateDemandIndex(world, rng);
  refreshAttractiveness(world);
  for (const offer of updateSalesCalls(world, rng)) {
    log(
      world,
      rng,
      "customer",
      "info",
      `Anruf von ${offer.sellerName}: ${offer.title}. Angebot gilt ${Math.round((offer.expiresAtTick - world.meta.tick) / SIM.TICKS_PER_DAY)} Tage.`
    );
  }
  for (const lead of generateLeads(world, rng)) {
    const result = provisionContract(world, rng, {
      customer: lead.customer,
      productId: lead.productId,
      performanceModifier: modifiers.computePerformance
    });
    if (result.ok) {
      report.newCustomers += 1;
      world.derived.customers.acquiredThisMonth += 1;
      log(
        world,
        rng,
        "customer",
        "info",
        `Neuer Kunde: ${lead.customer.company ?? lead.customer.name} bucht ${world.products[lead.productId]?.name}.`,
        { kind: "customer", id: lead.customer.id }
      );
    } else {
      report.rejectedOrders.push({ product: world.products[lead.productId]?.name ?? lead.productId, reason: result.error ?? "unbekannt" });
      if (world.meta.tick % 8 === 0) {
        log(world, rng, "customer", "warning", `Auftrag abgelehnt (${world.products[lead.productId]?.name}): ${result.error}`);
      }
    }
  }
  for (const customerId of updateChurn(world, rng)) {
    const customer = world.customers[customerId];
    if (!customer) continue;
    log(world, rng, "customer", "warning", `${customer.company ?? customer.name} hat gek\xFCndigt (Zufriedenheit ${customer.satisfaction.toFixed(0)}).`, {
      kind: "customer",
      id: customerId
    });
    removeCustomer(world, customerId);
    report.lostCustomers += 1;
    world.derived.customers.churnedThisMonth += 1;
  }
  generateIncidentTickets(world, rng, {
    reachability: bgp.reachability,
    packetLoss: traffic.packetLossPercent,
    congested: traffic.congestedLinks.length
  });
  const support = processTickets(world, rng, modifiers.supportSpeed);
  for (const breach of support.breaches) {
    log(
      world,
      rng,
      "security",
      "error",
      `Abuse-Frist \xFCberschritten: "${breach.subject}". Der Beschwerdef\xFChrer hat den Upstream eingeschaltet, der Ruf leidet.`,
      { kind: "ticket", id: breach.ticketId }
    );
  }
  if (support.abandoned > 0) {
    log(
      world,
      rng,
      "customer",
      "warning",
      support.abandoned === 1 ? "Ein Kunde hat seine Anfrage aufgegeben \u2013 nach zwei Monaten ohne Antwort. Er bleibt nachtragend." : `${support.abandoned} Kunden haben ihre Anfragen aufgegeben \u2013 nach zwei Monaten ohne Antwort. Sie bleiben nachtragend.`
    );
  }
  const eventResult = updateEvents({ world, rng, mitigationBonusGbps: modifiers.ddosMitigationGbps });
  for (const event of eventResult.triggered) {
    report.triggeredEvents.push(event.title);
    log(world, rng, "event", event.severity, `${event.title}: ${event.description}`, event.targets[0]);
  }
  for (const event of eventResult.ended) {
    log(world, rng, "event", "info", `Abgeschlossen: ${event.title}`);
  }
  const finished = advanceResearch(world);
  if (finished) {
    log(world, rng, "research", "info", `Forschung abgeschlossen: ${finished.name}.`);
    researchThisMonth.push(finished.name);
    chronicle(world, "forschung", `Forschung abgeschlossen: ${finished.name}.`);
  }
  chargeOperatingCosts(world, powerCostPerTick, coolingCostPerTick, { staff: modifiers.staffEfficiency });
  chargeInterest(world, modifiers.loanRateMultiplier);
  for (const paid of advanceLoans(world)) {
    log(world, rng, "billing", "info", `${paid.name} vollst\xE4ndig getilgt.`);
  }
  if (isBillingTick(world.meta.tick)) {
    const invoices = issueMonthlyInvoices(world, rng);
    report.invoicesIssued = invoices.length;
    log(world, rng, "billing", "info", `${invoices.length} Rechnungen f\xFCr den abgelaufenen Monat erstellt.`);
    const closed = closeMonth(world, researchThisMonth);
    report.closedMonth = closed;
    if (closed.month === 12) {
      report.closedYear = closed.year;
      chronicle(world, "meilenstein", `Gesch\xE4ftsjahr ${calendarYear(closed.year)} abgeschlossen.`);
    }
    world.derived.customers.acquiredThisMonth = 0;
    world.derived.customers.churnedThisMonth = 0;
    world.derived.customers.churnReasons = emptyChurnReasons();
    researchThisMonth.length = 0;
  }
  const payments = processPayments(world, rng);
  report.paymentsReceived = payments.paid;
  for (const invoiceId of payments.overdue) {
    const invoice = world.invoices[invoiceId];
    if (!invoice) continue;
    log(world, rng, "billing", "warning", `Rechnung ${invoice.number} ist \xFCberf\xE4llig (${invoice.gross.toFixed(2)} \u20AC).`, {
      kind: "invoice",
      id: invoiceId
    });
  }
  if (world.company.cash < 0 && world.company.debt >= world.company.creditLimit) {
    world.meta.paused = true;
    log(world, rng, "system", "critical", "Zahlungsunf\xE4higkeit: Die Kreditlinie ist ausgesch\xF6pft. Die Simulation wurde angehalten.");
  }
  if (world.meta.tick % SIM.TICKS_PER_DAY === 0) {
    prune(world);
  }
  updateReputation(world);
  recomputeDerived(world, { powerKwUsed, powerKwTotal, modifiers });
  updateMonitoring(world, bgp.reachability, traffic);
  for (const objective of evaluateObjectives(world)) {
    report.completedObjectives.push(objective);
    if (objective.kind === "campaign") chronicle(world, "meilenstein", objective.title);
    log(
      world,
      rng,
      "event",
      "info",
      objective.kind === "campaign" ? `Ziel erreicht: ${objective.title}.` : `Erfolg freigeschaltet: ${objective.title}.`
    );
  }
  world.derived.alerts = analyze(world);
  if (world.meta.tick % 3 === 0 || world.derived.diagnostics.length > 0) {
    world.derived.diagnostics = diagnose(world);
  }
  world.meta.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
  world.rngState = rng.getState();
  report.date = world.meta.date;
  report.logs = world.logs.slice(logsBefore);
  return report;
}
function recomputeDerived(world, context) {
  const compute = totalCapacity(world, context.modifiers.computePerformance);
  let rackUnitsTotal = 0;
  let rackUnitsUsed = 0;
  for (const rack of values(world.racks)) {
    const usage2 = rackUsage(world, rack.id);
    rackUnitsTotal += usage2.total;
    rackUnitsUsed += usage2.used;
  }
  const v4 = ipamSummary(world, "ipv4");
  world.derived.migrations = runningMigrations(world).length;
  world.derived.transports = runningTransports(world).length;
  world.derived.capacity = {
    ...compute,
    rackUnitsTotal,
    rackUnitsUsed,
    powerKwTotal: context.powerKwTotal,
    powerKwUsed: context.powerKwUsed,
    ipv4Total: v4.totalAddresses,
    ipv4Used: v4.usedAddresses
  };
  world.derived.finance = { ...summarizeFinance(world), companyValue: 0 };
  const customers = values(world.customers).filter((c) => c.contractIds.some((id) => world.contracts[id]?.state === "active"));
  world.derived.customers = {
    ...world.derived.customers,
    total: customers.length,
    avgSatisfaction: customers.length > 0 ? customers.reduce((s, c) => s + c.satisfaction, 0) / customers.length : 0
  };
  world.derived.finance.companyValue = companyValue(world).total;
  const contracts = values(world.contracts).filter((c) => c.state === "active");
  const totalTicks = contracts.reduce((s, c) => s + c.uptimeTicks + c.downtimeTicks, 0);
  const upTicks = contracts.reduce((s, c) => s + c.uptimeTicks, 0);
  world.derived.quality.uptimePercent = totalTicks > 0 ? upTicks / totalTicks * 100 : 100;
}
function updateMonitoring(world, reachability, traffic) {
  const window = world.monitoring.window;
  const push = (key, label, value) => {
    const series = world.monitoring.series[key] ??= { label, points: [] };
    pushWindow(series.points, Number.isFinite(value) ? Number(value.toFixed(3)) : 0, window);
  };
  push("traffic", "Gesamtverkehr (Mbit/s)", traffic.totalMbps);
  push("transit", "Transit (Mbit/s)", world.derived.traffic.transitMbps);
  push("peering", "Peering (Mbit/s)", world.derived.traffic.peeringMbps);
  push("latency", "Latenz (ms)", traffic.avgLatencyMs);
  push("loss", "Paketverlust (%)", traffic.packetLossPercent);
  push("reachability", "Erreichbarkeit (%)", reachability * 100);
  push("cash", "Liquidit\xE4t (\u20AC)", world.company.cash);
  push("customers", "Aktive Kunden", world.derived.customers.total);
  push("satisfaction", "Zufriedenheit", world.derived.customers.avgSatisfaction);
  push("power", "Leistungsaufnahme (kW)", world.derived.capacity.powerKwUsed);
  const servers = values(world.servers);
  const avgTemp = servers.length > 0 ? servers.reduce((s, d) => s + d.temperatureC, 0) / servers.length : 0;
  push("temperature", "\xD8 Servertemperatur (\xB0C)", avgTemp);
  const cpuUsed = world.derived.capacity.cpuCoresTotal > 0 ? world.derived.capacity.cpuCoresUsed / world.derived.capacity.cpuCoresTotal * 100 : 0;
  push("cpu", "CPU-Auslastung (%)", cpuUsed);
  const ramUsed = world.derived.capacity.ramGbTotal > 0 ? world.derived.capacity.ramGbUsed / world.derived.capacity.ramGbTotal * 100 : 0;
  push("ram", "RAM-Auslastung (%)", ramUsed);
  if (world.meta.tick % 3 === 0) {
    const probes = world.market.destinations.slice(0, 6).map((destination) => {
      const result = probeDestination(world, world.derived.routingTables, destination);
      const provider = world.market.providers.find((p) => p.asn === destination.ownerAsn);
      return {
        target: destination.prefix,
        description: `${provider?.name ?? `AS${destination.ownerAsn}`} (${destination.city})`,
        latencyMs: Number(result.latencyMs.toFixed(2)),
        lossPercent: Number(result.lossPercent.toFixed(2)),
        reachable: result.reachable
      };
    });
    world.monitoring.probes = probes;
  }
}
function tickMany(world, count2) {
  const reports = [];
  for (let i = 0; i < count2; i++) {
    if (world.meta.paused) break;
    reports.push(tick(world));
  }
  return reports;
}

// src/engine/snapshot.ts
function summarize(world) {
  return {
    worldId: world.meta.id,
    name: world.meta.name,
    companyName: world.company.name,
    tick: world.meta.tick,
    date: world.meta.date,
    cash: world.company.cash,
    customers: Object.keys(world.customers).length,
    difficulty: world.meta.difficulty
  };
}
function createSnapshot(world) {
  return {
    format: "hosting-sim-save",
    version: WORLD_VERSION,
    savedAt: (/* @__PURE__ */ new Date()).toISOString(),
    summary: summarize(world),
    world
  };
}
function exportSave(world) {
  return JSON.stringify(createSnapshot(world), null, 2);
}
var SaveError = class extends Error {
};
function importSave(raw) {
  const snapshot = typeof raw === "string" ? JSON.parse(raw) : raw;
  if (snapshot?.format !== "hosting-sim-save") {
    throw new SaveError("Die Datei ist kein g\xFCltiger Spielstand.");
  }
  if (typeof snapshot.version !== "number") {
    throw new SaveError("Dem Spielstand fehlt die Versionsangabe.");
  }
  if (snapshot.version > WORLD_VERSION) {
    throw new SaveError(
      `Der Spielstand stammt aus einer neueren Version (${snapshot.version} > ${WORLD_VERSION}). Bitte die Anwendung aktualisieren.`
    );
  }
  const world = migrate(snapshot.world, snapshot.version);
  validate(world);
  return world;
}
var MIGRATIONS = {
  /**
   * 1 -> 2: Server bestehen aus einzelnen Bauteilen.
   *
   * Alte Spielstände kennen nur die Summenwerte am Server. Die Bestückung wird
   * aus dem Modell rekonstruiert – das ist die Konfiguration, mit der der Server
   * gekauft wurde, und damit die einzige, die sich sinnvoll herleiten lässt.
   * Ein Server, dessen Modell nicht mehr im Katalog steht, behält seine Werte
   * und bleibt ohne Bauteile: Er läuft weiter, lässt sich aber nicht aufrüsten.
   */
  1: (world) => {
    for (const server of Object.values(world.servers)) {
      server.parts ??= factoryParts(server.model, server.purchasedAtTick);
      server.maintenance ??= null;
    }
    for (const vps of Object.values(world.vpsInstances)) {
      const legacy = vps;
      legacy.migration ??= null;
    }
    world.partOrders ??= {};
    world.inventory ??= {};
    return world;
  },
  /**
   * 2 -> 3: Supportstufen, Fachgebiete, Arbeitszeitmodelle und Ticketfristen.
   *
   * Bestandspersonal landet auf dem 1st Level in Bürozeiten mit den
   * Fachgebieten seiner Rolle – das entspricht dem Verhalten vorher, nur jetzt
   * ausdrücklich. Laufende Abuse-Vorgänge bekommen ihre Frist ab jetzt
   * gerechnet, nicht rückwirkend: Sonst wären sie beim ersten Tick nach dem
   * Laden allesamt gerissen.
   */
  2: (world) => {
    for (const staff of Object.values(world.staff)) {
      staff.level ??= 1;
      staff.shift ??= "day";
      staff.specialties ??= DEFAULT_SPECIALTIES[staff.role] ?? [];
    }
    for (const ticket of Object.values(world.tickets)) {
      ticket.level ??= 1;
      ticket.attempts ??= 0;
      ticket.escalations ??= 0;
      ticket.waitingSinceTick ??= null;
      ticket.reopenCount ??= 0;
      ticket.breached ??= false;
      if (ticket.dueAtTick === void 0) {
        ticket.dueAtTick = ticket.category === "abuse" && ticket.state !== "resolved" && ticket.state !== "closed" ? world.meta.tick + ABUSE_DEADLINE_TICKS : null;
      }
    }
    return world;
  },
  /**
   * 3 -> 4: Peering wird zur Beziehung.
   *
   * Bestehende Peering-Sitzungen aus alten Spielständen werden als aktive
   * Beziehungen nachgetragen – sonst stünden BGP-Nachbarn ohne zugehöriges
   * Peering da und würden beim nächsten Prüflauf stillschweigend gekündigt.
   */
  3: (world) => {
    world.peerings ??= {};
    for (const dc of Object.values(world.datacenters)) dc.powerFeeds ??= { count: 1, monthlyCost: 0 };
    for (const link of Object.values(world.links)) link.standby ??= false;
    world.company.hygiene ??= emptyHygiene();
    for (const ixp of Object.values(world.ixps)) {
      ixp.routeServer ??= { available: true, connected: false, requiresRpki: false };
    }
    for (const provider of world.market.providers) {
      provider.peeringPolicy ??= provider.kind === "tier1" ? "restrictive" : provider.kind === "content" ? "open" : "selective";
      provider.maxRatio ??= provider.kind === "eyeball" ? 8 : provider.kind === "content" ? 12 : 2.5;
      provider.requiresRpki ??= provider.kind !== "eyeball";
      provider.minTrafficMbps ??= provider.kind === "tier1" ? 1e5 : provider.kind === "content" ? 100 : 1e3;
      provider.atRouteServer ??= provider.kind !== "tier1";
    }
    let counter = 0;
    for (const router of Object.values(world.routers)) {
      for (const neighbor of router.bgp.neighbors) {
        if (neighbor.relation !== "peer") continue;
        if (Object.values(world.peerings).some((p) => p.peerAsn === neighbor.remoteAsn)) continue;
        const link = neighbor.linkId ? world.links[neighbor.linkId] : null;
        const via = link?.ixpId ? { kind: "ix", ixpId: link.ixpId } : neighbor.linkId ? { kind: "pni", linkId: neighbor.linkId } : null;
        if (!via) continue;
        const id = `peer-rel-migrated-${counter++}`;
        world.peerings[id] = {
          id,
          peerAsn: neighbor.remoteAsn,
          via,
          state: "active",
          requestedAtTick: world.meta.tick,
          decidesAtTick: null,
          establishedAtTick: world.meta.tick,
          note: "Aus einem \xE4lteren Spielstand \xFCbernommen.",
          ratio: 0,
          monthlyCost: 0,
          trafficMbps: 0
        };
      }
    }
    return world;
  },
  /**
   * 4 -> 5: Redundanz bei Strom und Transit.
   *
   * Bestandsstandorte haben eine Zuleitung, Bestandsstrecken laufen im
   * Regelbetrieb – das entspricht dem bisherigen Verhalten.
   */
  4: (world) => {
    for (const dc of Object.values(world.datacenters)) {
      dc.powerFeeds ??= { count: 1, monthlyCost: 0 };
    }
    for (const link of Object.values(world.links)) {
      link.standby ??= false;
    }
    return world;
  },
  /**
   * 5 -> 6: Ziele und Erfolge.
   *
   * Bestandsstände starten mit leerem Fortschritt. Sie bekommen ihre bereits
   * erreichten Meilensteine nicht geschenkt, sondern beim ersten Tick nach dem
   * Laden zugesprochen: `lastEvaluatedTick: -1` erzwingt eine Auswertung
   * außerhalb des Tagesrasters, und die Fixpunktschleife in
   * `evaluateObjectives` arbeitet die gesamte Kette in einem Durchgang ab. Ein
   * ausgebautes Netz bekommt also sofort alles, was es verdient hat – nicht ein
   * Ziel pro Spieltag nachgereicht.
   */
  5: (world) => {
    world.progress ??= { completed: {}, lastEvaluatedTick: -1 };
    return world;
  },
  /**
   * 6 -> 7: Firmengedächtnis, Kündigungsgründe, Unternehmenswert.
   *
   * Die Historie beginnt beim Laden leer und nicht rückwirkend gefüllt. Das ist
   * unvermeidlich: Die Zahlen vergangener Monate sind zu diesem Zeitpunkt
   * längst gelöscht – Ringpuffer über zehn Tage, Rechnungen nach sechs Monaten.
   * Sie zu erfinden wäre schlimmer als sie zu vermissen, denn ein Jahresbericht
   * mit geschätzten Zahlen ist kein Jahresbericht.
   *
   * Ein Bestandsstand fängt also ab dem Ladezeitpunkt an, Geschichte zu
   * schreiben. Der Gründungseintrag wird nachgetragen, damit die Chronik nicht
   * mitten im Nichts beginnt.
   */
  6: (world) => {
    world.history ??= { months: [], chronicle: [] };
    if (world.history.chronicle.length === 0) {
      world.history.chronicle.push({
        tick: world.company.foundedAtTick ?? 0,
        kind: "gruendung",
        text: `${world.company.name} gegr\xFCndet \u2013 AS${world.company.asn}.`
      });
    }
    world.derived.customers.churnReasons ??= { ausfall: 0, support: 0, preis: 0, zahlung: 0 };
    world.derived.finance.companyValue ??= 0;
    return world;
  },
  /**
   * 7 -> 8: Die Welt außerhalb des Unternehmens.
   *
   * Alles startet im Ruhezustand: Regime `normal`, alle Indizes und
   * Regionalfaktoren bei 1,0, Wettbewerber bei mittlerer Gesundheit. Ein
   * Bestandsspielstand merkt beim Laden nichts – die Preise sind exakt die von
   * vorher, und die Welt beginnt sich erst ab dem Ladezeitpunkt zu bewegen.
   *
   * Das ist bewusst so: Einem laufenden Unternehmen rückwirkend eine
   * Energiekrise unterzuschieben, die es nie erlebt hat, wäre genau die Sorte
   * Willkür, die diese Welt vermeiden soll.
   */
  7: (world) => {
    world.market.trends ??= emptyTrends();
    world.economy ??= emptyEconomy();
    world.regions ??= emptyRegions();
    world.competitors ??= emptyCompetitors();
    world.news ??= emptyNews();
    recomputeAggregates(world);
    return world;
  },
  /**
   * 8 -> 9: Serverkonsolidierung und Außerbetriebnahme.
   *
   * Bestandsstände kennen keine vorgemerkten Server – jeder Knoten ist im
   * Bestand, bis der Spieler etwas anderes beschließt. Rückwirkend eine
   * Ausmusterung zu erfinden, wäre falsch: Ein Server, der seit einem Jahr
   * leer läuft, war eine Entscheidung und kein Versehen.
   */
  8: (world) => {
    for (const server of Object.values(world.servers)) {
      server.retirement ??= null;
    }
    return world;
  },
  /**
   * 9 -> 10: Aufgegebene Vorgänge.
   *
   * Der Zähler beginnt bei null, obwohl in einem Bestandsstand durchaus
   * monatealte unbeantwortete Tickets liegen können. Sie rückwirkend als
   * "aufgegeben" zu buchen, würde beim ersten Laden einen Schwung Kunden
   * gleichzeitig verärgern – eine Strafe für etwas, das die Regel zum
   * Zeitpunkt des Versäumnisses noch nicht kannte. Die Tickets selbst bleiben
   * liegen und laufen ab dem nächsten Tick ganz normal in die Frist.
   */
  9: (world) => {
    for (const customer of Object.values(world.customers)) {
      customer.abandonedTickets ??= 0;
    }
    return world;
  },
  /**
   * 10 -> 11: Verlagerungen als Aufträge, dazu Lastausgleich.
   *
   * Zwei Dinge passieren hier. Erstens bekommt die Welt zwei neue Speicher, die
   * leer beginnen – Loadbalancer hat ein Bestandsstand nun einmal keine, und
   * ihm rückwirkend welche hinzustellen wäre kein Migrieren, sondern Schenken.
   *
   * Zweitens ziehen laufende Live-Migrationen aus dem Feld an der Instanz in
   * den Auftragsspeicher um. Sie werden dabei *neu eingereiht* statt mit ihrem
   * alten Restfortschritt übernommen: Der alte Fortschritt war in Ticks
   * gemessen, der neue in übertragenen Gigabyte, und zwischen beiden gibt es
   * keine ehrliche Umrechnung. Die Reservierung auf dem Zielknoten steht
   * bereits – es geht also nichts verloren, es dauert nur noch einmal.
   */
  10: (world) => {
    world.loadBalancers ??= {};
    world.migrations ??= {};
    for (const contract of Object.values(world.contracts)) {
      contract.poolId ??= null;
    }
    let counter = 0;
    for (const vps of Object.values(world.vpsInstances)) {
      const legacy = vps.migration;
      if (legacy?.targetServerId && world.servers[legacy.targetServerId]) {
        const id = `mig_uebernommen_${counter++}`;
        world.migrations[id] = {
          id,
          subject: { kind: "vps", id: vps.id },
          sourceServerId: vps.hostServerId,
          targetServerId: legacy.targetServerId,
          phase: "queued",
          startedAtTick: world.meta.tick,
          diskGbTotal: vps.diskGb,
          diskGbSent: 0,
          ramGbTotal: vps.ramGb,
          ramGbOutstanding: vps.ramGb,
          passes: 0,
          rateMbps: 0,
          freezeSeconds: 0,
          reason: "manual",
          note: "Aus einem \xE4lteren Spielstand \xFCbernommen und neu eingereiht."
        };
      }
      delete vps.migration;
    }
    return world;
  },
  /**
   * 11 -> 12: Standorte sind Mietverhältnisse.
   *
   * Bestandsstandorte bekommen einen unbefristeten Vertrag zur bisherigen
   * Miete. Ihnen rückwirkend eine Laufzeit anzudichten, wäre die schlechteste
   * aller Möglichkeiten: Der Spieler hätte sich an etwas gebunden, das es beim
   * Unterschreiben nicht gab, und stünde beim ersten Kündigungsversuch vor
   * einer Rechnung, die er nie akzeptiert hat. Unbefristet heißt: einen Monat
   * Frist, keine Ausstiegszahlung – und die Möglichkeit, ab sofort zu
   * verhandeln.
   *
   * Der Betrag bleibt unverändert. Auch die Listenmiete wird auf den
   * bestehenden Wert gesetzt, damit beim Laden keine Preisanpassung passiert,
   * die niemand veranlasst hat.
   */
  11: (world) => {
    world.transports ??= {};
    world.negotiations ??= {};
    world.derived.transports ??= 0;
    for (const dc of Object.values(world.datacenters)) {
      const legacy = dc;
      if (legacy.contract) continue;
      dc.contract = {
        providerName: providerFor(LOCATIONS.find((l) => l.city === dc.city)?.key ?? dc.city),
        termMonths: 0,
        committedKw: dc.powerCapacityKw,
        prepaidMonths: 0,
        monthlyRent: dc.monthlyRent,
        noticeMonths: COLOCATION.NOTICE_MONTHS.none,
        exitPenaltyShare: COLOCATION.EXIT_PENALTY_SHARE.none,
        signedAtTick: dc.builtAtTick,
        termEndsAtTick: dc.builtAtTick,
        listRent: dc.monthlyRent,
        notice: null
      };
    }
    return world;
  },
  /**
   * 12 -> 13: Reserve statt bloß „aus“.
   *
   * Bestandsgeräte gelten als *nicht* in Reserve – auch die gerade
   * ausgeschalteten. Das ist die vorsichtige Richtung: Ein Gerät, das der
   * Spieler früher abgeschaltet hat, fährt nach dem nächsten Stromausfall
   * wieder mit hoch, so wie er es bisher kannte. Es rückwirkend zur Reserve zu
   * erklären hieße, eine Absicht zu unterstellen, die niemand geäußert hat –
   * und ein Gerät stumm ausgelassen zu lassen, das jemand vermisst.
   */
  12: (world) => {
    const mark = (device) => {
      device.standby ??= false;
    };
    Object.values(world.servers).forEach(mark);
    Object.values(world.routers).forEach(mark);
    Object.values(world.switches).forEach(mark);
    Object.values(world.firewalls).forEach(mark);
    Object.values(world.loadBalancers).forEach(mark);
    Object.values(world.upsUnits).forEach(mark);
    return world;
  },
  /**
   * 13 -> 14: Ein Switch braucht einen Uplink zum Router.
   *
   * Bis hierher war der Switch die letzte Station: Ein Server galt als
   * angebunden, sobald sein Switch lief. Jetzt zählt die ganze Kette – und
   * damit stünde jeder alte Spielstand schlagartig ohne Netz da, obwohl der
   * Spieler nichts falsch gemacht hat. Er hatte diese Regel ja nie.
   *
   * Deshalb wird nachträglich gesteckt, was der Aufbau immer gemeint hat: Jeder
   * Switch ohne Weg zu einem Router bekommt den Router seines Standorts auf
   * einen freien Port – bevorzugt einen Trunk, so wie man es auch im Rack
   * machen würde. Findet sich weder Router noch freier Port, bleibt der Switch
   * unverkabelt; dann meldet ihn die Störungsdiagnose, und das ist die
   * ehrlichere Antwort als eine erfundene Verbindung.
   */
  13: (world) => {
    for (const sw of Object.values(world.switches)) {
      const schonVerbunden = sw.ports.some((port2) => port2.connectedDevice && port2.connectedDevice.kind !== "server");
      if (schonVerbunden) continue;
      const router = Object.values(world.routers).find((r) => r.datacenterId === sw.datacenterId);
      if (!router) continue;
      const frei = sw.ports.filter((port2) => !port2.connectedDevice && !port2.linkId);
      const port = frei.find((p) => p.mode === "trunk") ?? frei[0];
      if (!port) continue;
      port.connectedDevice = { kind: "router", id: router.id };
      port.description = router.name;
    }
    return world;
  },
  /**
   * 14 -> 15: Bankensystem.
   *
   * Bestandsstände kennen den Darlehensspeicher nicht – er beginnt leer, kein
   * Spieler hatte vorher die Möglichkeit, ein Darlehen aufzunehmen. Der neue
   * Forschungszweig „Finanzen“ existiert in `RESEARCH_TREE`, aber nicht im
   * gespeicherten `world.research`, weil dieses nur bei Weltgründung aus dem
   * Baum erzeugt wird. Fehlende Knoten werden hier nachgetragen statt neu
   * gebaut, damit bereits abgeschlossene Forschung unangetastet bleibt.
   */
  /**
   * 15 -> 16: Gekaufte Geräte liegen zuerst im Lager (`deliveries`). Bestehende
   * Geräte bleiben unverändert eingebaut; es gibt keine offenen Lieferungen,
   * die nachträglich umzuwandeln wären.
   */
  15: (world) => {
    world.deliveries ??= {};
    return world;
  },
  14: (world) => {
    world.loans ??= {};
    for (const node of Object.values(world.research)) {
      node.creditLimitBonus ??= 0;
    }
    for (const [id, node] of Object.entries(buildResearchNodes())) {
      world.research[asId(id)] ??= node;
    }
    return world;
  }
};
function migrate(world, fromVersion) {
  let current = world;
  for (let version = fromVersion; version < WORLD_VERSION; version++) {
    const step = MIGRATIONS[version];
    if (step) current = step(current);
  }
  current.meta.version = WORLD_VERSION;
  return current;
}
function validate(world) {
  const required = [
    "meta",
    "company",
    "datacenters",
    "racks",
    "servers",
    "routers",
    "switches",
    "links",
    "prefixes",
    "products",
    "customers",
    "contracts"
  ];
  for (const key of required) {
    if (world[key] === void 0 || world[key] === null) {
      throw new SaveError(`Der Spielstand ist unvollst\xE4ndig: "${String(key)}" fehlt.`);
    }
  }
  world.derived ??= emptyDerived();
  world.derived.diagnostics ??= [];
  world.progress ??= emptyProgress();
  world.progress.completed ??= {};
  world.history ??= emptyHistory();
  world.history.months ??= [];
  world.history.chronicle ??= [];
  world.market.trends ??= emptyTrends();
  world.economy ??= emptyEconomy();
  world.regions ??= emptyRegions();
  world.competitors ??= emptyCompetitors();
  world.news ??= emptyNews();
  world.derived.customers.churnReasons ??= emptyChurnReasons();
  world.monitoring ??= { window: 240, series: {}, probes: [] };
  world.logs ??= [];
  world.ledger ??= [];
  world.events ??= {};
  world.sessions ??= {};
  world.vlans ??= {};
  world.vrfs ??= {};
  world.dnsZones ??= {};
  world.domains ??= {};
  world.tickets ??= {};
  world.staff ??= {};
  world.invoices ??= {};
  world.firewalls ??= {};
  world.loadBalancers ??= {};
  world.upsUnits ??= {};
  world.vpsInstances ??= {};
  world.migrations ??= {};
  world.transports ??= {};
  world.negotiations ??= {};
  world.partOrders ??= {};
  world.deliveries ??= {};
  world.inventory ??= {};
  world.ixps ??= {};
  world.peerings ??= {};
  for (const dc of Object.values(world.datacenters)) dc.powerFeeds ??= { count: 1, monthlyCost: 0 };
  for (const link of Object.values(world.links)) link.standby ??= false;
  world.research ??= {};
  world.loans ??= {};
  world.market ??= { providers: [], offers: [], destinations: [], demandIndex: 1, trends: emptyTrends() };
  world.market.destinations ??= [];
  world.market.offers ??= [];
  for (const contract of Object.values(world.contracts)) {
    contract.poolId ??= null;
    if (contract.serverId && !world.servers[contract.serverId]) contract.serverId = null;
    if (contract.vpsId && !world.vpsInstances[contract.vpsId]) contract.vpsId = null;
    if (contract.rackId && !world.racks[contract.rackId]) contract.rackId = null;
    if (contract.poolId && !Object.values(world.loadBalancers).some((lb) => lb.pools.some((p) => p.id === contract.poolId))) {
      contract.poolId = null;
    }
  }
  for (const job of Object.values(world.migrations)) {
    if (!world.servers[job.targetServerId] && job.phase !== "done") job.phase = "failed";
  }
  for (const store of [world.servers, world.routers, world.switches, world.firewalls, world.loadBalancers, world.upsUnits]) {
    for (const device of Object.values(store)) device.standby ??= false;
  }
  for (const job of Object.values(world.transports)) {
    if (!world.racks[job.targetRackId] && job.phase !== "done") job.phase = "failed";
  }
  for (const customer of Object.values(world.customers)) {
    customer.contractIds = customer.contractIds.filter((id) => world.contracts[id]);
    customer.invoiceIds = customer.invoiceIds.filter((id) => world.invoices[id]);
    customer.ticketIds = customer.ticketIds.filter((id) => world.tickets[id]);
  }
  for (const router of Object.values(world.routers)) {
    for (const port of router.ports) {
      if (port.linkId && !world.links[port.linkId]) port.linkId = null;
    }
    router.bgp.neighbors = router.bgp.neighbors.filter((n) => n.relation === "ibgp" || !n.linkId || world.links[n.linkId]);
  }
}
function toClientView(world, options = {}) {
  const logLimit = options.logLimit ?? 200;
  const ledgerLimit = options.ledgerLimit ?? 200;
  return {
    ...world,
    logs: world.logs.slice(-logLimit),
    ledger: world.ledger.slice(-ledgerLimit)
  };
}
export {
  ABUSE_DEADLINE_TICKS,
  ACHIEVEMENTS,
  ADMIN_DISTANCE,
  ADVISOR_RULES,
  ALGORITHM_LABEL,
  ARCHETYPE_LABEL,
  AREA_UNLOCKS,
  ATTEMPTS_BEFORE_ESCALATION,
  AddressFamilies,
  BASE_DRIFT,
  BalanceAlgorithms,
  BgpOrigins,
  BgpSessionStates,
  CABLING,
  CALLERS,
  CAMPAIGN,
  CHURN_REASON_LABEL,
  COLOCATION,
  COMMUNITIES,
  COMPETITOR_TEMPLATES,
  CONSOLE_MAX_LINE,
  CPU_PARTS,
  CUSTOMER_REPLY_TICKS,
  ChurnReasons,
  CompetitorArchetypes,
  CompetitorStrategies,
  ContractStates,
  CpuSockets,
  CustomerSegments,
  DDOS,
  DEFAULT_SPECIALTIES,
  DIFFICULTY,
  DRIVE_PARTS,
  DeviceKinds,
  DeviceStates,
  Difficulties,
  DimmStandards,
  DriveFormFactors,
  ECONOMY,
  ESCAPE,
  EVENT_DEFINITIONS,
  EXPLAINABLE,
  FIREWALL_MODELS,
  FULL_TABLE_SIZE,
  GPU_PARTS,
  HYGIENE_COSTS,
  HYGIENE_DESCRIPTION,
  HYGIENE_LABEL,
  INDEX_LABEL,
  IXP_TEMPLATES,
  IndexKeys,
  InvoiceStates,
  KM_PER_UNIT,
  LOADBALANCER_MODELS,
  LOADBALANCING,
  LOAN_PRODUCTS,
  LOCATIONS,
  LinkKinds,
  LinkStates,
  LogCategories,
  MAX_CHRONICLE,
  MAX_FREE_CLARIFICATIONS,
  MAX_MONTHS,
  MAX_NEWS,
  MIGRATION,
  MINIGAME,
  MINIGAME_LABEL,
  MigrationPhases,
  NEWS_CATEGORY_LABEL,
  NEWS_RULES,
  NIC_PARTS,
  NewsCategories,
  OBJECTIVES,
  OVERCOMMIT,
  OperatingSystems,
  PACKETS,
  PART_KIND_LABEL,
  PART_MODELS,
  PHYSICS,
  POLICY_LABEL,
  PRODUCT_TEMPLATES,
  PROVIDER_TEMPLATES,
  PartKinds,
  PeerRelations,
  ProductKinds,
  RACK_MODELS,
  RAM_PARTS,
  REFLECTOR_PORTS,
  REGIMES,
  REGION_TRENDS,
  RELOCATION,
  RESEARCH_TREE,
  RESPONSE_SLA,
  RETENTION,
  ROUTER_MODELS,
  RegimeKeys,
  Rng,
  SERVER_CHASSIS,
  SERVER_MODELS,
  SHIFT_LABEL,
  SHIFT_SALARY_FACTOR,
  SIM,
  SLOT_LABEL,
  STRATEGY_LABEL,
  STRATEGY_TABLE,
  SWITCH_MODELS,
  SaveError,
  ServerRoles,
  Severities,
  StaffRoles,
  TD,
  TECH_WAVES,
  TICKET_CONTEXT_RESEARCH,
  TLD_COSTS,
  TOWERS,
  TicketCategories,
  TicketPriorities,
  TicketStates,
  UPGRADE,
  UPS_MODELS,
  UserRoles,
  VECTOR_LABEL,
  VERDICT_LABEL,
  WIRE_COLORS,
  WORLD_VERSION,
  abortNegotiation,
  abuseDeadlines,
  acceptNegotiation,
  activeAttacks,
  activeBillableLinks,
  activeModifiers,
  activeTransfers,
  addPoolMember,
  addRecord,
  advanceColocation,
  advanceLinkBuilds,
  advanceLoans,
  advanceMaintenance,
  advanceMigrations,
  advancePartOrders,
  advancePeerings,
  advancePendingOperations,
  advanceResearch,
  advanceRetirements,
  advanceTransports,
  affectedContracts,
  agePartsAndReport,
  allShortestPaths,
  allocateAddresses,
  analyze,
  announcePrefix,
  applyRouteMap,
  areasUnlockedBy,
  asId,
  ask,
  assessPeering,
  assignPrefixToVlan,
  assignedAddressCount,
  attachContractToPool,
  attackOnServer,
  autoRepair,
  availableLocations,
  availableModels,
  availableParts,
  availableYears,
  average,
  balancerPathUp,
  baseCommittedKw,
  billable95th,
  blackholeProblem,
  buildAnnualReport,
  buildCabling,
  buildDestinations,
  buildResearchNodes,
  buildTopology,
  buildTowerDefense,
  bulkProcessTickets,
  calendarYear,
  canAfford,
  canAnnounce,
  canHandle,
  canInstall,
  canSellPrefix,
  cancelMigration,
  cancelPartOrder,
  cancelRetirement,
  cancelTransport,
  cancelUpgrade,
  catalog,
  chargeInterest,
  chargeOperatingCosts,
  checkCabling2 as checkCabling,
  checkMovable,
  checkTransportable,
  childPrefixes,
  chronicle,
  cidrOf,
  clamp,
  closableOutageTickets,
  closeDatacenter,
  closeMonth,
  collectNews,
  companyValue,
  comparePaths,
  competitorPriceLevel,
  completedResearch,
  computeAdvertisedRoutes,
  computeAttractiveness,
  configureServer,
  connectRouteServer,
  connectToSwitch,
  connectedComponents,
  consolidate,
  consolidationSuggestions,
  contractAvailability,
  contractUptimePercent,
  counterNegotiation,
  createCustomer,
  createDhcpPool,
  createPool,
  createPrefix,
  createReverseZone,
  createSnapshot,
  createTdState,
  createTicket,
  createVlan,
  createVps,
  createVrf,
  createWorld,
  createZone,
  currentObjective,
  currentRegime,
  declineOffer,
  decommissionDevice,
  deepClone,
  defaultEdgeAcl,
  defaultFirewallRules,
  defaultPrefixCost,
  deletePool,
  deriveServerSpecs,
  describeOffer,
  describeParts,
  describeSite,
  describeVia,
  destroyVps,
  detachContractFromPool,
  detectRouteLeak,
  devicePowerWatt,
  diagnose,
  disconnectFromSwitch,
  distanceKm,
  diurnalFactor,
  dropContractFromPools,
  dropMigrationsFor,
  dropServerFromPools,
  effectiveBlackholes,
  effectiveLoanRate,
  effectivePowerPrice,
  emptyChurnReasons,
  emptyCompetitors,
  emptyDerived,
  emptyEconomy,
  emptyHistory,
  emptyHygiene,
  emptyNews,
  emptyProgress,
  emptyRegions,
  emptyTrends,
  enableHygiene,
  estimateMigration,
  estimateTransport,
  evacuateServer,
  evaluateAcl,
  evaluateObjectives,
  execute,
  explain,
  explainCapacity,
  explainCash,
  explainChurn,
  explainPower,
  explainReputation,
  explainTransit,
  exportSave,
  factoryParts,
  fiberLatencyMs,
  findChassis,
  findEventDefinition,
  findFirewallModel,
  findFreePrefix,
  findHost,
  findLoadBalancerModel,
  findLoanProduct,
  findLocation,
  findModel,
  findObjective,
  findPart,
  findPartOfKind,
  findPool,
  findProductTemplate,
  findRackModel,
  findRegionTrend,
  findRouterModel,
  findServerModel,
  findSwitchModel,
  findUpsModel,
  findWave,
  fitFor,
  fits,
  footprintFor,
  formatBytes,
  formatMbps,
  freeRackSlots,
  freeShareOf,
  freeSlots,
  freeSwitchPorts,
  gbPerTick,
  generateExternalRoutes,
  generateIncidentTickets,
  generateLeads,
  giveNotice,
  groupBy,
  hasAsLoop,
  hasBackupPower,
  hasExternalConnectivity,
  hasHostedContract,
  hasTicketContext,
  historyTotals,
  hostFailureReason,
  hourOfDay,
  importSave,
  installOs,
  interDcFreeMbps,
  ip_exports as ip,
  ipamSummary,
  ipv4BlockPrice,
  isAreaUnlocked,
  isBillingTick,
  isBlockedByCommunity,
  isCompatible,
  isCompetitorTick,
  isContractUp,
  isFrozen,
  isLinkLive,
  isLinkPortEnabled,
  isLinkUsable,
  isServerConnected,
  isUnderNotice,
  isUnlocked,
  isValleyFreeExport,
  issueMonthlyInvoices,
  ixpPortLoad,
  judgeOffer,
  lerp,
  listRent,
  locationSetupCost,
  log,
  makeId,
  marketPressure,
  marketReach,
  matchAsPath,
  matchCommunity,
  matchPrefixList,
  maxCommittedKw,
  mergeSubnets,
  migrate,
  migrationOf,
  migrationRateMbps,
  migrationTargets,
  mitigationCapacityGbps,
  money,
  monthsOfYear,
  moveDeviceWithinSite,
  moveLinkToPort,
  natOversubscription,
  neutralModifiers,
  nextFreeSlot,
  nextRackSlot,
  nextRouterId,
  objectiveViews,
  occupiedRanges,
  orderParts,
  outageRecipients,
  overcommitOfRole,
  packetPoint,
  paidPeeringMonthlyCost,
  pairLoadBalancers,
  partsValue,
  peeringOverview,
  percentile,
  placeTower,
  placementProblem,
  planConsolidation,
  planEvacuation,
  planSiteRelocation,
  planUpgrade,
  plannedRateMbps,
  platformOf,
  playerShare,
  poolAvailabilityOf,
  poolCandidates,
  poolDatacenterId,
  poolTrafficMbps,
  poolsAt,
  poolsOfServer,
  post,
  powerDownDatacenter,
  powerUpDatacenter,
  prefixUtilization,
  prefixesOfFamily,
  prependsFromCommunity,
  previewUpgrade,
  primaryIssue,
  probeDestination,
  processPayments,
  processTickets,
  progressSummary,
  providerFor,
  provisionContract,
  prune,
  pruneMigrations,
  pruneNegotiations,
  pruneTransports,
  quoteColocation,
  quoteDecommission,
  quoteNotice,
  quoteOrder,
  rackPowerKw,
  rackSetupCost,
  rackUsage,
  rebootDevice,
  recomputeAggregates,
  recomputeDerived,
  recomputeManrs,
  recomputeServerSpecs,
  records,
  recoverSatisfaction,
  refreshAttractiveness,
  regionFactors,
  regionFactorsOfCity,
  relationLabel,
  releaseAddresses,
  releaseLease,
  relocateSite,
  removeCustomer,
  removePoolMember,
  reorderDeviceInRack,
  repatchDevice,
  repayDebt,
  repayLoanEarly,
  replacementCandidates,
  replayTowerDefense,
  replyToTicket,
  requestLease,
  requestPeering,
  requiredRole,
  residualValue,
  resizeVps,
  resolveCommunity,
  resolveEventOption,
  resumeContract,
  retireServer,
  retirementBlockers,
  runBgp,
  runConsole,
  runEscapeCommand,
  runWave,
  runningMigrations,
  runningTransports,
  selectBestPath,
  sellParts,
  sellPrefix,
  sellablePrefixes,
  serverCapacity,
  serverLoad,
  serverLoadRows,
  serverNicMbps,
  serverUplinkMbps,
  serverUtilization,
  serverUtilizations,
  servingMembers,
  sessionsOfRouter,
  setBlackhole,
  setMemberDrain,
  setMemberWeight,
  setReverseRecord,
  shiftCoverage,
  shortestPaths,
  simulateTraffic,
  siteDistanceKm,
  siteMitigationGbps,
  slotUsage,
  smooth,
  snapshotWorld,
  spend,
  splitPrefix,
  startContractMigration,
  startNegotiation,
  startRepair,
  startResearch,
  startTransport,
  startVpsMigration,
  startWave,
  stepSessions,
  stepTd,
  stockAt,
  stockOf,
  suggestConfiguration,
  sum,
  summarize,
  summarizeFinance,
  supportCapacity,
  supportThroughput,
  surcharge,
  suspendContract,
  switchHasUplink,
  switchesWithFreePorts,
  switchesWithoutUplink,
  takeLoan,
  terminateContract,
  terminatePeering,
  terminationReason,
  tick,
  tickMany,
  tickToDate,
  ticketServices,
  ticketStats,
  toClientView,
  totalCapacity,
  trafficByDatacenter,
  transferMarketValue,
  transferPath,
  translate,
  transportOf,
  trendArrow,
  unlockedModels,
  unpairLoadBalancer,
  updateChurn,
  updateCompetitors,
  updateContractMetrics,
  updateDemandIndex,
  updateEconomy,
  updateEvents,
  updateFacility,
  updateLoadBalancers,
  updatePool,
  updateRegions,
  updateReputation,
  updateSalesCalls,
  updateTrends,
  updateVpsLoad,
  validate,
  validateSwitchVlans,
  values,
  waveTargetFor,
  withdrawNotice,
  withdrawPrefix,
  withdrawPrefixEverywhere,
  worldPrice,
  worldRate,
  yearMonthOf,
  zoneResolvable
};
//# sourceMappingURL=index.mjs.map